import { gql } from '@apollo/client'
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql'
export type Maybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } &
  { [P in K]-?: NonNullable<T[P]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  DateTime: any
  /** Formatted full-name of a US state. */
  USStateName: any
  URL: any
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any
  TickerSymbol: any
  BigDecimal: any
  Date: any
  /** A field representing a standard email address. https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address */
  Email: any
  StringKey: any
  /** The last four numbers of a card. */
  CardNumberMasked: any
  /** An Email */
  EmailAddress: any
  /** Represents NULL values */
  Void: any
  /** A routing number for a bank */
  RoutingNumber: any
  /** An account number for a corepro account */
  AccountNumber: any
  /** Floats that will have a value greater than 0. */
  PositiveFloat: any
  /** Four digit PIN. */
  BankCardPin: any
  /** The `Upload` scalar type represents a file upload. */
  Upload: any
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: any
  /** Non zero, positive float */
  Amount: any
  UUID: any
  /** The Long scalar type represents a signed 64-bit numeric non-fractional value */
  Long: any
  /** The Short scalar type represents a signed 16-bit numeric non-fractional value */
  Short: any
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: any
}

export type AboutSection = {
  __typename?: 'AboutSection'
  image?: Maybe<Image>
  title: Scalars['String']
}

/** Describes the employer switch based on the switch type. */
export type AbstractSwitch = AcornsPdfSwitch | OnlineSwitch | SubmittableSwitch

export type AcceptanceDocument = {
  __typename?: 'AcceptanceDocument'
  id: Scalars['ID']
  /** The name of the document */
  name: Scalars['String']
  /** The type of document (arbitrary right now) */
  type: Scalars['String']
  /** The version of the document */
  version: Scalars['String']
  /** The URL to the document text */
  url: Scalars['URL']
  /** The name of the summary */
  summaryName?: Maybe<Scalars['String']>
  /** The URL to the summary text */
  summaryUrl?: Maybe<Scalars['URL']>
  /**
   * Indicates wether the app should force the user to scroll to
   * the bottom before accepting
   */
  mustScrollToBottom?: Maybe<Scalars['Boolean']>
  /**
   * A string indicating a specific app feature that the acceptance
   * of the document is required for using
   */
  requiredFor?: Maybe<Scalars['String']>
}

export enum AcceptanceDocumentType {
  /** Required agreement when user is signed up through a referral program or code */
  ReferralDisclosure = 'referralDisclosure',
}

/** Bundle of acceptance date, signature, and document type */
export type AcceptDocumentInput = {
  /** The date the document was signed by the user */
  acceptedDate: Scalars['Date']
  /** Name to apply to the accepted document */
  signature: Scalars['String']
  /** Type of document the given signature is accepting */
  documentType: AcceptanceDocumentType
  /** The version of the document the user is accepting */
  documentVersion: Scalars['String']
}

/** What happens when a user accepts a document */
export type AcceptDocumentResponse = AcceptedDocument | DocumentNotFound | UserNotFound

/** A document that a user has accepted */
export type AcceptedDocument = {
  __typename?: 'AcceptedDocument'
  acceptedDate: Scalars['Date']
  documentType: AcceptanceDocumentType
  documentUrl: Scalars['String']
  documentVersion: Scalars['String']
  signature: Scalars['String']
}

export type AcceptUploadedDocumentInput = {
  documentRequestId: Scalars['ID']
  reviewerId: Scalars['ID']
}

/** Individual accounts opened by a user at Acorns */
export type Account = TimestampsInterface & {
  __typename?: 'Account'
  /** Type of account */
  accountType: AccountType
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for account creator */
  creatorId: Scalars['ID']
  /** Internal ID for account */
  id: Scalars['ID']
  /** Status of account */
  status: AccountStatus
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export type AccountAchievement = {
  __typename?: 'AccountAchievement'
  achievement: AchievementItem
  completed: Scalars['Boolean']
  dateCompleted: Scalars['DateTime']
}

/** The account provided is already closed */
export type AccountAlreadyClosedException = {
  __typename?: 'AccountAlreadyClosedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Investment account is already closed */
export type AccountClosedException = {
  __typename?: 'AccountClosedException'
  /** message */
  errorMessage?: Maybe<Scalars['String']>
}

/** When investment account id doesn't match with user */
export type AccountNotFoundException = {
  __typename?: 'AccountNotFoundException'
  /** message */
  errorMessage?: Maybe<Scalars['String']>
}

export type AccountPoints = {
  __typename?: 'AccountPoints'
  /**
   * detailed explanation about how points are earned
   * @deprecated Use detailsKey field instead
   */
  details: Scalars['String']
  /** key that maps to a detailed explanation about how points are earned */
  detailsKey: Scalars['StringKey']
  earned: Scalars['Int']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /**
   * summarized explanation about how points are earned
   * @deprecated Use summaryKey field instead
   */
  summary?: Maybe<Scalars['String']>
  /** key that maps to a summarized explanation about how points are earned */
  summaryKey?: Maybe<Scalars['StringKey']>
}

export type AccountPointsRule = {
  __typename?: 'AccountPointsRule'
  /**
   * detailed explanation about how points are earned
   * @deprecated Use detailsKey field instead
   */
  details: Scalars['String']
  /** key that maps to a detailed explanation about how points are earned */
  detailsKey: Scalars['StringKey']
  milestoneID: Scalars['ID']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /**
   * summarized explanation about how points are earned
   * @deprecated Use summaryKey field instead
   */
  summary?: Maybe<Scalars['String']>
  /** key that maps to a summarized explanation about how points are earned */
  summaryKey?: Maybe<Scalars['StringKey']>
}

export type AccountRequirement = {
  __typename?: 'AccountRequirement'
  actionable: Scalars['Boolean']
  description?: Maybe<Scalars['String']>
  status: AccountRequirementStatus
  type: AccountRequirementType
}

export type AccountRequirements = {
  __typename?: 'AccountRequirements'
  close: Array<AccountRequirement>
}

export enum AccountRequirementStatus {
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Completed = 'COMPLETED',
}

export enum AccountRequirementType {
  FundingSource = 'FUNDING_SOURCE',
  VerifiedFundingSource = 'VERIFIED_FUNDING_SOURCE',
  NoTransferringInvestments = 'NO_TRANSFERRING_INVESTMENTS',
  NoTransferringDividends = 'NO_TRANSFERRING_DIVIDENDS',
  Liquidated = 'LIQUIDATED',
  NoPendingInvestments = 'NO_PENDING_INVESTMENTS',
  RecurringDepositsDisabled = 'RECURRING_DEPOSITS_DISABLED',
  SelfDirectedPortfolioClosed = 'SELF_DIRECTED_PORTFOLIO_CLOSED',
}

/** reflects the user's account setup progress */
export type AccountSetupMilestones = {
  __typename?: 'AccountSetupMilestones'
  /** optional copy to provide more info */
  descriptionKey?: Maybe<Scalars['StringKey']>
  /** account setup completion progress */
  groupProgress: DiscreteMilestoneProgress
  /** list of milestones to show in account set up widget */
  milestones: Array<Milestone>
}

export enum AccountStatus {
  /** Account is in process of being opened or verified */
  Pending = 'pending',
  /** Open account ready for use */
  Open = 'open',
  /** Account closure is in progress */
  Inactive = 'inactive',
  /** Account has been closed */
  Closed = 'closed',
}

export type AccountStrengthResult = {
  __typename?: 'AccountStrengthResult'
  achievements?: Maybe<Array<Maybe<AccountAchievement>>>
  percentage: Scalars['Float']
}

export enum AccountType {
  /** Core basic investment account */
  Basic = 'basic',
  /** Later ROTH IRA account */
  RothIra = 'rothIra',
  /** Later traditional IRA account */
  TraditionalIra = 'traditionalIra',
  /** Later SEP IRA account */
  SepIra = 'sepIra',
  /** Spend LSB checking account */
  Checking = 'checking',
  /** Uniform Gift to Minors Act */
  Ugma = 'ugma',
  /** Uniform Transfers to Minors Act */
  Utma = 'utma',
}

/** Account values over the reporting period */
export type AccountValue = {
  __typename?: 'AccountValue'
  /** The dollar amount of the account's balance */
  amount?: Maybe<Scalars['Float']>
  /** The time of the associated account value */
  timestamp?: Maybe<Scalars['DateTime']>
}

export enum AchievementItem {
  RoundupAccountLinked = 'roundupAccountLinked',
  AutomaticRoundupsOn = 'automaticRoundupsOn',
  MultipleRoundupAccountsLinked = 'multipleRoundupAccountsLinked',
  AccountValueGte10 = 'accountValueGte10',
  AccountValueGte100 = 'accountValueGte100',
  FundingSourceLinked = 'fundingSourceLinked',
  AutomaticInvestmentOn = 'automaticInvestmentOn',
  RegistrationComplete = 'registrationComplete',
}

export enum AcornsPartnerStatus {
  Inactive = 'INACTIVE',
  InProgress = 'IN_PROGRESS',
  Active = 'ACTIVE',
}

/** Acorns PDF Switches are performed by emailing and printing a PDF. */
export type AcornsPdfSwitch = SwitchInterface & {
  __typename?: 'AcornsPdfSwitch'
  source: SwitchSource
  type: SwitchType
}

export type ActionCard = {
  __typename?: 'ActionCard'
  userCardDigest?: Maybe<Scalars['ID']>
  style: ActionCardStyle
  type: Scalars['String']
  eyebrow?: Maybe<Scalars['String']>
  headline?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  body?: Maybe<Scalars['String']>
  icon?: Maybe<Scalars['String']>
  imageUrl?: Maybe<Scalars['URL']>
  image?: Maybe<Scalars['JSON']>
  heroImageUrl?: Maybe<Scalars['URL']>
  ctaDetails?: Maybe<ActionCardButton>
  widget?: Maybe<Scalars['JSON']>
  ownerName?: Maybe<Scalars['String']>
}

export type ActionCardButton = {
  __typename?: 'ActionCardButton'
  type: Scalars['String']
  id?: Maybe<Scalars['String']>
  title: Scalars['String']
  videoUrl?: Maybe<Scalars['URL']>
  video?: Maybe<Scalars['URL']>
  image?: Maybe<Scalars['URL']>
}

export type ActionCardsInput = {
  feedContext?: Maybe<ActionFeedContext>
}

export enum ActionCardStyle {
  Alert = 'alert',
  AnnouncingLater = 'announcingLater',
  Basic = 'basic',
  BasicVideo = 'basicVideo',
  FoundMoney = 'foundMoney',
  Grow = 'grow',
  Snackable = 'snackable',
  Widget = 'widget',
}

export enum ActionFeedContext {
  A3Core = 'a3Core',
  A3Later = 'a3Later',
  A3Present = 'a3Present',
  A3Spend = 'a3Spend',
  A4Early = 'a4Early',
  A4EarlyDetails = 'a4EarlyDetails',
  A4Home = 'a4Home',
  A4HomeBottomNav = 'a4HomeBottomNav',
  A4Invest = 'a4Invest',
  A4Later = 'a4Later',
  A4Spend = 'a4Spend',
  A4Savings = 'a4Savings',
  A4BankingHub = 'a4BankingHub',
  A4CheckingHub = 'a4CheckingHub',
  A4CheckingEngagementWizard = 'a4CheckingEngagementWizard',
  A4InvestHub = 'a4InvestHub',
  Later = 'later',
}

export type ActionFeedCta = {
  __typename?: 'ActionFeedCta'
  hideCardIfUnknown?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['ID']>
  image?: Maybe<Scalars['String']>
  title: Scalars['String']
  type?: Maybe<ActionFeedCtaType>
  video?: Maybe<Scalars['String']>
  videoUrl?: Maybe<Scalars['String']>
}

export enum ActionFeedCtaType {
  /** link */
  Link = 'link',
  /** grow article link */
  GrowArticle = 'grow_article',
  /** link to view a video */
  Video = 'video',
  /** insights sequence wizard */
  Wizard = 'wizard',
  /** insights sequence offer */
  Offer = 'offer',
  /** insights sequence spell */
  Spell = 'spell',
  /** triggers an email download */
  Email = 'email',
  /** customer feedback survey */
  Survey = 'survey',
}

/** input for an action feed event */
export type ActionFeedEvent = {
  /** event action type */
  action: ActionFeedEventAction
  /** CARD | TIP */
  eventType: ActionFeedEventType
  /** card type */
  eventKey: Scalars['ID']
  /** body of event */
  body?: Maybe<Scalars['String']>
  /** card digest id */
  userCardDigest?: Maybe<Scalars['String']>
  /** cta id */
  ctaId?: Maybe<Scalars['ID']>
  /** investment account id */
  accountId?: Maybe<Scalars['ID']>
}

export enum ActionFeedEventAction {
  /** Card Impression */
  Impression = 'impression',
  /** CTA Tapped */
  Tapped = 'tapped',
  /** Dismissed */
  Dismissed = 'dismissed',
  /** Completed */
  Completed = 'completed',
}

/** Response to recording a feed event */
export type ActionFeedEventResponse = {
  __typename?: 'ActionFeedEventResponse'
  success: Scalars['Boolean']
}

export enum ActionFeedEventType {
  /** Card Event - impression, tapped, dismissed */
  Card = 'CARD',
  /** Tip Event - completed, dismissed */
  Tip = 'TIP',
}

export enum ActionType {
  Choose = 'CHOOSE',
  Continue = 'CONTINUE',
  Direct = 'DIRECT',
  Link = 'LINK',
  Manual = 'MANUAL',
  MoreInfo = 'MORE_INFO',
  Skip = 'SKIP',
  Switch = 'SWITCH',
  /** Represents when a user switches funnels mid-way through a funnel */
  Update = 'UPDATE',
}

export type ActivateBankCardInput = {
  cardNumberMasked: Scalars['CardNumberMasked']
}

export type ActivateBankCardPayload = {
  __typename?: 'ActivateBankCardPayload'
  bankCard?: Maybe<BankCard>
}

export type Activity = {
  __typename?: 'Activity'
  id: Scalars['ID']
  type: ActivityType
  createdAt: Scalars['DateTime']
  pending?: Maybe<Scalars['Boolean']>
  meta: Scalars['JSON']
}

export enum ActivitySummaryProduct {
  /** Core investment product */
  Invest = 'INVEST',
  /** Later investment product */
  Later = 'LATER',
  /** Early investment product */
  Early = 'EARLY',
}

export type ActivitySummaryResponse = {
  __typename?: 'ActivitySummaryResponse'
  activitySummaryItems?: Maybe<Array<SummaryItem>>
  numberOfDays?: Maybe<Scalars['Int']>
  total?: Maybe<CurrencyAmount>
}

export enum ActivityType {
  Seeding = 'seeding',
  OneTimeInvestment = 'oneTimeInvestment',
  RecurringInvestment = 'recurringInvestment',
  Withdrawal = 'withdrawal',
  Dividend = 'dividend',
  ReferralReward = 'referralReward',
  FoundMoney = 'foundMoney',
  Fee = 'fee',
  Rebalance = 'rebalance',
  RoundUp = 'roundUp',
  BonusRoundup = 'bonusRoundup',
  EmployeeContribution = 'employeeContribution',
  GiftCard = 'giftCard',
  Credit = 'credit',
  PartnerReward = 'partnerReward',
  AchFee = 'achFee',
  DirectFee = 'directFee',
}

export type AddActionToMilestoneAchievementActionRuleInput = {
  /** the action to add to the list of side-effects the milestone can trigger when it is completed */
  actionToAdd: MilestoneAchievementActionType
  milestoneID: Scalars['ID']
}

export type AddActionToMilestoneAchievementActionRuleResult =
  | MilestoneAchievementActionRule
  | RecordAlreadyExistsError
  | RecordDoesNotExistError

export type AddActionToMilestoneGroupAchievementActionRuleInput = {
  /** the action to add to the list of side-effects the milestone group can trigger when it is completed */
  actionToAdd: MilestoneAchievementActionType
  milestoneGroupID: Scalars['ID']
}

export type AddActionToMilestoneGroupAchievementActionRuleResult =
  | MilestoneGroupAchievementActionRule
  | RecordDoesNotExistError

export type AddDocumentUrlsInput = {
  documents: Array<DocumentInput>
  documentRequestId: Scalars['ID']
}

export type AddMilestonesToMilestoneGroupDefinitionInput = {
  milestoneGroupID: Scalars['ID']
  /** the milestoneIDs to add to the group */
  milestoneIDsToAdd: Array<Scalars['ID']>
}

export type AddMilestonesToMilestoneHubDefinitionInput = {
  milestoneHubId: Scalars['ID']
  /** the list of milestone ids to add to the milestone hub definition */
  milestonesToAdd: Array<Scalars['ID']>
}

export type AddMilestonesToMilestoneHubDefinitionResult =
  | RecordDoesNotExistError
  | MilestoneHubDefinition

export type AddMilestoneToMilestoneGroupDefinitionResult =
  | MilestoneGroupDefinition
  | RecordDoesNotExistError

/** Miscellaneous attributes and information about a user's address */
export type Address = TimestampsInterface & {
  __typename?: 'Address'
  /** Type of address */
  addressType: AddressType
  /** City */
  city: Scalars['String']
  /** Country */
  country: Scalars['String']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for address */
  id: Scalars['ID']
  /** State */
  state: Scalars['String']
  /** First street address */
  street1: Scalars['String']
  /** Second street address */
  street2?: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
  /** Address has been verified */
  verified: Scalars['Boolean']
  /** Zip code */
  zipCode: Scalars['String']
}

export type AddressDeliverabilityAdditionalInfo = {
  __typename?: 'AddressDeliverabilityAdditionalInfo'
  isPoBox?: Maybe<Scalars['Boolean']>
  isBusiness?: Maybe<Scalars['Boolean']>
  isPrivateMailbox?: Maybe<Scalars['Boolean']>
  isVacant?: Maybe<Scalars['Boolean']>
}

/**
 * The Address is verified as deliverable but requires corrections to one or more input fields.
 * Note: Clients can determine what fields are different by diffing their input with the corrected field.
 */
export type AddressDeliverabilityCorrectedAddress = {
  __typename?: 'AddressDeliverabilityCorrectedAddress'
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  street1?: Maybe<Scalars['String']>
  street2?: Maybe<Scalars['String']>
  zipCode?: Maybe<Scalars['String']>
  additionalInfo?: Maybe<AddressDeliverabilityAdditionalInfo>
}

/** Changeable attributes for addresses */
export type AddressDeliverabilityInput = {
  street1: Scalars['String']
  street2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  /** 5 digit zip code */
  zipCode?: Maybe<Scalars['String']>
}

export type AddressDeliverabilityResult =
  | AddressDeliverabilityVerified
  | AddressDeliverabilityVerificationError
  | AddressDeliverabilityCorrectedAddress
  | AddressDeliverabilityUnavailableError

/** The Verification was unavailable. Clients should determine how to handle this case according to product requirements */
export type AddressDeliverabilityUnavailableError = {
  __typename?: 'AddressDeliverabilityUnavailableError'
  requestId?: Maybe<Scalars['String']>
}

/** The Verification rejected the address as undeliverable. */
export type AddressDeliverabilityVerificationError = {
  __typename?: 'AddressDeliverabilityVerificationError'
  requestId?: Maybe<Scalars['String']>
  failureReason?: Maybe<AddressDeliverabilityVerificationErrorFailureReason>
}

export enum AddressDeliverabilityVerificationErrorFailureReason {
  /** The input address is missing or was not found */
  AddressNotFound = 'addressNotFound',
  /** The input state code is missing or invalid */
  InvalidState = 'invalidState',
  /** The input city is missing or invalid */
  InvalidCity = 'invalidCity',
  /** The input postal code is missing or invalid */
  InvalidZipCode = 'invalidZipCode',
  /** The input address contains an invalid ste, apt, or box number */
  InvalidAddressSecondaryNumber = 'invalidAddressSecondaryNumber',
  /** The input address is missing ste, apt, or box number */
  MissingAddressSecondaryNumber = 'missingAddressSecondaryNumber',
  /** The input address has an invalid house number */
  InvalidAddressPrimaryNumber = 'invalidAddressPrimaryNumber',
  /** The input address is missing a house number */
  MissingAddressPrimaryNumber = 'missingAddressPrimaryNumber',
  /** The input matched multiple addresses, needs more info */
  AmbiguousAddress = 'ambiguousAddress',
  /** The input address is missing PO, RR, or HC box number */
  MissingPoBoxNumber = 'missingPoBoxNumber',
  /** The input address' PO, RR, or HC box number invalid */
  InvalidPoBoxNumber = 'invalidPoBoxNumber',
  /** The input address matched to CMRA but PMB designator not present (PMB 123 or # 123) */
  MissingPmbNumber = 'missingPmbNumber',
  /** The input address matched to a physical address that does not receive delivery from the USPS */
  AddressNotDeliverable = 'addressNotDeliverable',
  /** An unknown or unmapped error occurred */
  Unknown = 'unknown',
}

/** The Address is verified as deliverable with no corrections issued on any input fields. */
export type AddressDeliverabilityVerified = {
  __typename?: 'AddressDeliverabilityVerified'
  requestId?: Maybe<Scalars['String']>
  additionalInfo?: Maybe<AddressDeliverabilityAdditionalInfo>
}

/** Address Document Requested Alert. */
export type AddressDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'AddressDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Changeable attributes for addresses */
export type AddressInput = {
  /** Street 1 */
  street1?: Maybe<Scalars['String']>
  /** Street 2 */
  street2?: Maybe<Scalars['String']>
  /** City */
  city?: Maybe<Scalars['String']>
  /** State */
  state?: Maybe<Scalars['String']>
  /** Country */
  country?: Maybe<Scalars['String']>
  /** Zip code */
  zipCode?: Maybe<Scalars['String']>
}

export enum AddressType {
  /** A residential address */
  Residential = 'residential',
  /** A mailing address */
  Mailing = 'mailing',
  /** A billing address */
  Billing = 'billing',
}

export type AddSearchTermToLearnSearchHistoryInput = {
  term: Scalars['String']
}

export type AddSearchTermToLearnSearchHistoryResult = LearnSearchTermSavedResult

/** Input to add a security to a portfolio */
export type AddSecurityToPortfolioInput = {
  /** The market exchange symbol of the ETF to add to the portfolio */
  symbol: Scalars['String']
  /** Investment account ID */
  investmentAccountId: Scalars['ID']
}

/** Result from adding a security to a portfolio */
export type AddSecurityToPortfolioResult =
  | InvestmentAccountNotFoundException
  | InvestmentAccountNotSupportedException
  | Portfolio
  | PortfolioNotFoundException
  | PortfolioNotSupportedException
  | SecurityNotSupportedException

/** Input for creating a Self Directed Portfolio */
export type AddSelfDirectedPortfolioInput = {
  /** ID of the existing investment account for this portfolio to be associated with */
  investmentAccountId: Scalars['ID']
}

/** Result from opening a Self Directed Portfolio */
export type AddSelfDirectedPortfolioResult =
  | CustomerAgreementRequiredException
  | InvalidInvestmentAccountException
  | InvalidSubscriptionTierException
  | InvestmentAccount
  | PortfolioNotFoundException

/** An existing Acorns user that has referred friends to Acorns */
export type Advocate = {
  __typename?: 'Advocate'
  /** UUID of the existing Acorns user */
  userId?: Maybe<Scalars['ID']>
  /** The referral code associated with the advocate */
  referralCodes?: Maybe<Array<Scalars['String']>>
  /** A list of people that have used the advocate's share link */
  friends?: Maybe<Array<Friend>>
  /** An object with referral metrics for the advocate */
  referralHistory?: Maybe<ReferralHistory>
  /** The content that supports and drives the user experience */
  experienceContent?: Maybe<ExperienceContent>
}

/** List of referral codes and friends that were referred by an existing Acorns user */
export type AdvocateFriendsStatuses = {
  __typename?: 'AdvocateFriendsStatuses'
  /** User ID of the advocate */
  userId: Scalars['ID']
  /** The referral codes associated with the advocate */
  referralCodes?: Maybe<Array<Scalars['String']>>
  /** A list of people that have used the advocate's share link */
  friends?: Maybe<Array<Friend>>
}

export type Alert = {
  type: Scalars['String']
  userId: Scalars['ID']
}

/** Response from beneficiary alert hub alerts query */
export type AlertHubBeneficiaryAlert =
  | MissingSsnBeneficiaryAlertItem
  | UnverifiedBeneficiarySsnAlertItem

export type AlertMessage = Message & {
  __typename?: 'AlertMessage'
  body: MessageTextAsset
  createdAt: Scalars['DateTime']
  deepLink?: Maybe<Scalars['URL']>
  icon?: Maybe<MessageVisualAsset>
  id: Scalars['ID']
  isDismissed: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isRead: Scalars['Boolean']
  messageCategory: MessageCategory
  messageType: MessageType
  readAt?: Maybe<Scalars['DateTime']>
  title: MessageTextAsset
  trackingId?: Maybe<Scalars['ID']>
  updatedAt: Scalars['DateTime']
}

export type AllBankAccountsInput = {
  /** Deprecated. Use types instead. types takes precedence over type if both are non-null */
  type?: Maybe<BankAccountType>
  types?: Maybe<Array<BankAccountType>>
}

export type AllBankCardsFilter = {
  showNonActive?: Maybe<Scalars['Boolean']>
}

export type AllBankDocumentsInput = {
  isActive?: Maybe<Scalars['Boolean']>
}

/** The result of the allCheckPayments query */
export type AllCheckPaymentsResult = CheckPaymentConnection | AuthorizationError

export type AllPastCoreItemsSchemaFilter = {
  /** Only return pending items */
  pending?: Maybe<Scalars['Boolean']>
}

export type AllPastEarlyItemsSchemaFilter = {
  /** Only return pending items */
  pending?: Maybe<Scalars['Boolean']>
}

export type AllPastLaterItemsSchemaFilter = {
  /** Only return pending items */
  pending?: Maybe<Scalars['Boolean']>
}

export type AllPastSpendItemsSchemaFilter = {
  /** Only return pending items */
  pending?: Maybe<Scalars['Boolean']>
}

export type AllSupportArticlesFilterInput = {
  promoted?: Maybe<Scalars['Boolean']>
}

export type AllTransferableToInput = {
  /** ID of TransferableAccounts that money can be taken from */
  from: Scalars['ID']
}

/** Possible answer for an onboarding question */
export type Answer = {
  __typename?: 'Answer'
  /** Internal answer ID */
  id: Scalars['ID']
  /** Answer text */
  title: Scalars['String']
  /** type of this answer */
  type: AnswerType
}

export type AnswerLearnQuizQuestionInput = {
  questionId: Scalars['ID']
  quizId: Scalars['ID']
  /** A list of one or more answers (if multiple choice question) */
  selectedAnswers: Array<LearnAnswerInput>
}

export type AnswerLearnQuizQuestionResult = LearnQuizAnswerResult | RecordDoesNotExistError

export enum AnswerType {
  /** yes/true */
  Yes = 'yes',
  /** no/false */
  No = 'no',
  /** informational */
  Next = 'next',
  /** skip this question */
  Skip = 'skip',
  /** defined value */
  Value = 'value',
}

export type ApplyPromotionInput = {
  promotionId: Scalars['ID']
  subscriptionId: Scalars['ID']
}

export type ApplyPromotionResult =
  | PromotionConsumedError
  | PromotionExpiredError
  | PromotionNotFoundError
  | SubscriberIneligibleError
  | TierSubscription

export type Article = {
  __typename?: 'Article'
  body: Scalars['String']
  cta?: Maybe<Cta>
  eyebrow: Scalars['String']
  id: Scalars['ID']
  image?: Maybe<Image>
  title: Scalars['String']
}

/** Options to assign a subaccount to a given role */
export type AssignLinkedSubaccountInput = {
  /** Role to give the linked subaccount */
  role: LinkedSubaccountRoleEnum
}

/** Response returned if the link session is asynchronous. */
export type AsyncLinkSessionResult = {
  __typename?: 'AsyncLinkSessionResult'
  /** The asynchronous process was kicked off successfully? */
  success: Scalars['Boolean']
}

export type AuthAlert = {
  userId: Scalars['ID']
  type: Scalars['String']
}

export type AuthChallenge = {
  id: Scalars['ID']
  alternateAuthenticators: Array<AuthenticatorInfo>
}

export type AuthChallengeAnswerAttemptsExhaustedException = {
  __typename?: 'AuthChallengeAnswerAttemptsExhaustedException'
  message?: Maybe<Scalars['String']>
}

export type AuthChallengeAnswerIncorrectException = {
  __typename?: 'AuthChallengeAnswerIncorrectException'
  message?: Maybe<Scalars['String']>
}

/** exceptions */
export type AuthChallengeExpiredException = {
  __typename?: 'AuthChallengeExpiredException'
  message?: Maybe<Scalars['String']>
}

export type AuthenticateForFeeNegotiationChallengeInput = {
  /** A MFA authorization code, answer to a security question. */
  tfaInput: Scalars['String']
  linkedAccountId: Scalars['ID']
}

export type AuthenticateForFeeNegotiationChallengeMethodInput = {
  /** The email, phone number, or question a user has chosen to complete TFA. */
  tfaOption: Scalars['String']
  linkedAccountId: Scalars['ID']
  tfaType: TfaType
  restart: Scalars['Boolean']
}

export type AuthenticateForFeeNegotiationInput = {
  /** The username for the bank connection. */
  userName: Scalars['String']
  /** The password for the bank connection. */
  password: Scalars['String']
  /** The ID of the bank connection. */
  linkedAccountId: Scalars['ID']
  /** The name of the bank connection. */
  bankName: BankName
  /**
   * If True, the system will ignore the user_name/password provided in this
   * request and login with the credentials previously provided for this connection.
   */
  reconnect: Scalars['Boolean']
}

export type AuthenticateForFeeNegotiationResult =
  | AuthenticateForFeeNegotiationStatus
  | LinkedAccountNotFound
  | NegotiationServiceConnectionFailure

export type AuthenticateForFeeNegotiationStatus = {
  __typename?: 'AuthenticateForFeeNegotiationStatus'
  /** The authorization status of the provided credentials. */
  credentialStatus: CredentialStatus
  tfaOptions?: Maybe<TfaOptions>
  /** The two factor authentication status.  */
  tfaStatus: TfaStatus
  tfaType: TfaType
  tfaMethod?: Maybe<Scalars['String']>
  /** The current stage of authentication. */
  operationStage: OperationStage
  operationError?: Maybe<AutomationError>
}

export type AuthenticateInput = {
  email: Scalars['EmailAddress']
  password: Scalars['String']
  udid: Scalars['String']
  rememberMe?: Maybe<Scalars['Boolean']>
}

export type AuthenticateNegotiationStatusResult =
  | AuthenticateForFeeNegotiationStatus
  | LinkedAccountNotFound

/** auth results */
export type AuthenticateResult =
  | SmsAuthChallenge
  | EmailAuthChallenge
  | AuthSession
  | AuthenticatorUnavailableException
  | InvalidCredentialsException
  | UserSuspendedException
  | DeviceBlockedException
  | UserLockedException
  | LoginRateLimitedException
  | PhoneNumberOptedOutException
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeExpiredException
  | AuthenticatorTypeAlreadyRegisteredException

export type AuthenticationAlreadyUpgradedException = {
  __typename?: 'AuthenticationAlreadyUpgradedException'
  userId: Scalars['ID']
}

export type Authenticator = {
  id: Scalars['ID']
  name: Scalars['String']
  lastUsedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
}

export type AuthenticatorAlreadyDefaultException = {
  __typename?: 'AuthenticatorAlreadyDefaultException'
  message?: Maybe<Scalars['String']>
}

export type AuthenticatorInfo = {
  __typename?: 'AuthenticatorInfo'
  id: Scalars['ID']
  type: AuthType
}

export type AuthenticatorNotFoundException = {
  __typename?: 'AuthenticatorNotFoundException'
  message?: Maybe<Scalars['String']>
}

export type AuthenticatorTypeAlreadyRegisteredException = {
  __typename?: 'AuthenticatorTypeAlreadyRegisteredException'
  message?: Maybe<Scalars['String']>
}

export type AuthenticatorUnavailableException = {
  __typename?: 'AuthenticatorUnavailableException'
  message?: Maybe<Scalars['String']>
}

export type AuthorizationError = {
  __typename?: 'AuthorizationError'
  requestId: Scalars['ID']
}

/** types */
export type AuthProfile = {
  __typename?: 'AuthProfile'
  userId: Scalars['ID']
  email?: Maybe<Scalars['EmailAddress']>
  emailVerifiedAt?: Maybe<Scalars['DateTime']>
  phoneNumber?: Maybe<Scalars['String']>
  phoneNumberVerifiedAt?: Maybe<Scalars['DateTime']>
  requireLoginChallenge?: Maybe<Scalars['Boolean']>
  /** the Authenticator that will be used for challenges by default. */
  defaultAuthenticator?: Maybe<Authenticator>
  loginAccess?: Maybe<LoginAccess>
}

export type AuthProfileAlreadyExistsException = {
  __typename?: 'AuthProfileAlreadyExistsException'
  message?: Maybe<Scalars['String']>
}

export type AuthProfileNotFoundException = {
  __typename?: 'AuthProfileNotFoundException'
  userId: Scalars['ID']
}

export type AuthSession = {
  __typename?: 'AuthSession'
  id: Scalars['ID']
  token: Scalars['ID']
  refreshToken?: Maybe<Scalars['ID']>
  identityId: Scalars['ID']
  /** @deprecated No longer used */
  redirectUrl?: Maybe<Scalars['URL']>
}

export type AuthTokenNotFoundException = {
  __typename?: 'AuthTokenNotFoundException'
  userId: Scalars['ID']
}

export enum AuthType {
  Phone = 'PHONE',
  Email = 'EMAIL',
}

export type AutomationError = {
  __typename?: 'AutomationError'
  /** A description of the error. */
  error?: Maybe<Scalars['String']>
  /** The error code. */
  errorCode?: Maybe<AutomationErrorCode>
}

export enum AutomationErrorCode {
  TfaInv = 'TFA_INV',
  TfaSelInv = 'TFA_SEL_INV',
  /** The username and/or password are invalid. */
  LogInv = 'LOG_INV',
  /** Login was blocked. */
  LogBlk = 'LOG_BLK',
  /** Unexptected error in authorizing this bank connection. */
  LogEx = 'LOG_EX',
  /** Invalid TFA method. */
  SttRes = 'STT_RES',
  /** Unexpected error in completing TFA. */
  CttEx = 'CTT_EX',
  /** Unexpected error in selecting a tfa method. */
  SttEx = 'STT_EX',
  /** TFA is required for a Wells Fargo connection. Unable to proceeed. */
  WfTfa = 'WF_TFA',
}

export type BackendJobBatch = {
  __typename?: 'BackendJobBatch'
  id: Scalars['ID']
  type: BackendJobBatchType
  name: Scalars['String']
  status: BackendJobBatchStatus
  totalJobs?: Maybe<Scalars['Int']>
  processedJobs?: Maybe<Scalars['Int']>
  failedJobs?: Maybe<Scalars['Int']>
  pendingJobs?: Maybe<Scalars['Int']>
  successPercentage?: Maybe<Scalars['Float']>
  pendingPercentage?: Maybe<Scalars['Float']>
  createdAt: Scalars['DateTime']
}

export type BackendJobBatchAutomatedOrdersFilterInput = {
  timeframe: BackendJobBatchTimeframe
  jobBatchType?: Maybe<BackendJobBatchType>
}

export type BackendJobBatchMoneyMovementFilterInput = {
  timeframe: BackendJobBatchTimeframe
  jobBatchType?: Maybe<BackendJobBatchType>
}

export type BackendJobBatchOrdersFilterInput = {
  timeframe: BackendJobBatchTimeframe
  jobBatchType?: Maybe<BackendJobBatchType>
}

export type BackendJobBatchProfitStarsFilterInput = {
  timeframe: BackendJobBatchTimeframe
}

export enum BackendJobBatchStatus {
  Completed = 'COMPLETED',
  Restarted = 'RESTARTED',
  Started = 'STARTED',
  InProgress = 'IN_PROGRESS',
  Failed = 'FAILED',
}

export type BackendJobBatchSummary = {
  __typename?: 'BackendJobBatchSummary'
  id: Scalars['ID']
  name: Scalars['String']
  totalInvestmentCount?: Maybe<Scalars['Int']>
  customerCount?: Maybe<Scalars['Int']>
  totalInvestmentAmount?: Maybe<Scalars['Float']>
  totalHoldingsAmount?: Maybe<Scalars['Float']>
  createdAt: Scalars['DateTime']
}

export type BackendJobBatchSummaryFilterInput = {
  timeframe: BackendJobBatchTimeframe
  jobBatchType: BackendJobBatchType
}

export enum BackendJobBatchTimeframe {
  Today = 'TODAY',
  Yesterday = 'YESTERDAY',
  LastSeven = 'LAST_SEVEN',
  LastThirty = 'LAST_THIRTY',
  Month = 'MONTH',
  Year = 'YEAR',
}

export enum BackendJobBatchType {
  AutomatedBuyOrderConfirm = 'AUTOMATED_BUY_ORDER_CONFIRM',
  AutomatedBuyOrderLock = 'AUTOMATED_BUY_ORDER_LOCK',
  AutomatedSellFeeOrderConfirm = 'AUTOMATED_SELL_FEE_ORDER_CONFIRM',
  AutomatedSellFeeOrderLock = 'AUTOMATED_SELL_FEE_ORDER_LOCK',
  ChargebackOrderLock = 'CHARGEBACK_ORDER_LOCK',
  ProfitStarsDeposits = 'PROFIT_STARS_DEPOSITS',
  BuyOrderLock = 'BUY_ORDER_LOCK',
  BuyOrderConfirm = 'BUY_ORDER_CONFIRM',
  RebalanceSellOrderLock = 'REBALANCE_SELL_ORDER_LOCK',
  RebalanceSellOrderConfirm = 'REBALANCE_SELL_ORDER_CONFIRM',
  RebalanceBuyOrderLock = 'REBALANCE_BUY_ORDER_LOCK',
  RebalanceBuyOrderConfirm = 'REBALANCE_BUY_ORDER_CONFIRM',
  SellFeeOrderLock = 'SELL_FEE_ORDER_LOCK',
  SellFeeOrderConfirm = 'SELL_FEE_ORDER_CONFIRM',
  TransferApproval = 'TRANSFER_APPROVAL',
}

export type BackgroundImage = {
  __typename?: 'BackgroundImage'
  horizontalFocalPoint?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['URL']>
  verticalFocalPoint?: Maybe<Scalars['String']>
}

export enum BadgeCategory {
  NewCustomer = 'NEW_CUSTOMER',
  Travel = 'TRAVEL',
}

export type BankAccount = {
  __typename?: 'BankAccount'
  id: Scalars['ID']
  balance: CurrencyAmount
  /** @deprecated Use balance */
  currentBalance: CurrencyAmount
  /**
   * Balance available for immediate withdrawal.
   *
   * Settling a transaction for a DDA account will typically credit the
   * availableBalance immediately. However, savings or FBO accounts may have
   * a "deposit hold time" or a "new customer hold time", meaning there could be
   * a length of time between when the transaction is settled and the corresponding
   * funds are made available for withdrawal.
   */
  availableBalance: CurrencyAmount
  /**
   * Balance of pending deposit transactions. When a pending deposit transaction
   * settles, it will debit this balance. Deposit transactions which settle
   * immediately will never affect this balance.
   */
  pendingBalance: CurrencyAmount
  number: Scalars['String']
  routingNumber: Scalars['String']
  type: BankAccountType
  referenceId: Scalars['ID']
  accountHolderReferenceId: Scalars['ID']
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
  closedAt?: Maybe<Scalars['DateTime']>
  isEligible: Scalars['Boolean']
  status: BankAccountStatus
  isLocked: Scalars['Boolean']
  lockReason?: Maybe<BankAccountLockReason>
  /**
   * True if an account closure has been initiated but
   * was unsuccessful in automatically closing.
   */
  isPendingClosure?: Maybe<Scalars['Boolean']>
  /**
   * The current status of the account and requirements
   * needed to be met to close the account
   */
  requirements: BankAccountRequirements
  /** The name of the account */
  accountName: Scalars['String']
  /** Information related to the goals of the bank account */
  goals: BankAccountGoals
  /** The bank that this account is associated with */
  bankType: BankType
}

export enum BankAccountClosureReason {
  /** Not seeing the value */
  NotSeeingTheValue = 'NOT_SEEING_THE_VALUE',
  /** No longer use */
  NoLongerUse = 'NO_LONGER_USE',
  /** Going to a competitor */
  GoingToACompetitor = 'GOING_TO_A_COMPETITOR',
  /** Missing features I expect with a checking account */
  MissingFeaturesExpectedWithCheckingAccount = 'MISSING_FEATURES_EXPECTED_WITH_CHECKING_ACCOUNT',
  /** Had a bad experience */
  HadABadExperience = 'HAD_A_BAD_EXPERIENCE',
  /** Other */
  Other = 'OTHER',
}

export type BankAccountDisclosure = {
  __typename?: 'BankAccountDisclosure'
  id: Scalars['ID']
  name: Scalars['String']
  type: Scalars['String']
  version: Scalars['String']
  url: Scalars['String']
  summaryName?: Maybe<Scalars['String']>
  summaryUrl?: Maybe<Scalars['String']>
  mustScrollToBottom?: Maybe<Scalars['Boolean']>
  requiredFor?: Maybe<Scalars['String']>
}

export type BankAccountDisclosureFilter = {
  bankType: BankType
  paymentProcessor: BankCardPaymentProcessor
}

export type BankAccountGoal = {
  __typename?: 'BankAccountGoal'
  type: BankAccountGoalType
  amount: CurrencyAmount
  name: Scalars['String']
}

export type BankAccountGoalInput = {
  amount: PositiveCurrencyAmountInput
  type: BankAccountGoalType
}

export type BankAccountGoals = {
  __typename?: 'BankAccountGoals'
  currentGoal?: Maybe<BankAccountGoal>
}

export enum BankAccountGoalType {
  EmergencySavings = 'EMERGENCY_SAVINGS',
}

export enum BankAccountLockReason {
  Unknown = 'Unknown',
  Fraud = 'Fraud',
  Administrative = 'Administrative',
  Temporary = 'Temporary',
  Frozen = 'Frozen',
}

export type BankAccountNotFoundError = {
  __typename?: 'BankAccountNotFoundError'
  message: Scalars['String']
}

/**
 * Defines a list of requirements that must be met before a bank account
 * can be closed
 */
export type BankAccountRequirement = {
  __typename?: 'BankAccountRequirement'
  actionable: Scalars['Boolean']
  description?: Maybe<Scalars['String']>
  status: BankAccountRequirementStatus
  type: BankAccountRequirementType
}

export type BankAccountRequirements = {
  __typename?: 'BankAccountRequirements'
  close: Array<BankAccountRequirement>
}

export enum BankAccountRequirementStatus {
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Completed = 'COMPLETED',
}

export enum BankAccountRequirementType {
  FundingSource = 'FUNDING_SOURCE',
  VerifiedFundingSource = 'VERIFIED_FUNDING_SOURCE',
  NoPendingTransfers = 'NO_PENDING_TRANSFERS',
}

export enum BankAccountStatus {
  Open = 'open',
  Closed = 'closed',
  Locked = 'locked',
}

export enum BankAccountType {
  Spend = 'spend',
  Save = 'save',
}

export type BankCard = {
  __typename?: 'BankCard'
  id: Scalars['ID']
  cardNumberMasked?: Maybe<Scalars['CardNumberMasked']>
  createdAt: Scalars['DateTime']
  activatedAt?: Maybe<Scalars['DateTime']>
  expireMonth: Scalars['Int']
  expireYear: Scalars['Int']
  tier: BankCardTier
  type: BankCardType
  referenceId: Scalars['ID']
  lockReason?: Maybe<BankCardLockReason>
  lockTypeCode: BankCardLockTypeCode
  status: BankCardStatus
  paymentProcessor: BankCardPaymentProcessor
  bankType: BankType
  userActivatedAt?: Maybe<Scalars['DateTime']>
}

export enum BankCardLockReason {
  Unknown = 'unknown',
  Fraud = 'fraud',
  Damage = 'damage',
  Lost = 'lost',
  Temporary = 'temporary',
  Stolen = 'stolen',
  Admin = 'admin',
  PinRetriesExceeded = 'pinRetriesExceeded',
}

export enum BankCardLockTypeCode {
  Unlocked = 'unlocked',
  Customer = 'customer',
  System = 'system',
}

export type BankCardOrder = {
  __typename?: 'BankCardOrder'
  cardOrderStatus: BankCardOrderStatus
  addressVerification?: Maybe<BankCardOrderAddressVerification>
  identityVerification?: Maybe<BankCardOrderIdentityVerification>
  prefundVerification?: Maybe<BankCardOrderPrefundVerification>
  fundingSourceVerification?: Maybe<BankCardOrderFundingSourceVerification>
  failureReason?: Maybe<BankCardOrderFailureReason>
  bankType?: Maybe<BankType>
  bankCardTier?: Maybe<BankCardTier>
  kycStatus?: Maybe<KycStatus>
  fundingInitiated?: Maybe<Scalars['Boolean']>
  requestVersion?: Maybe<RequestVersions>
}

export type BankCardOrderAddressVerification = {
  __typename?: 'BankCardOrderAddressVerification'
  status: BankCardOrderVerificationStatus
  actionRequired?: Maybe<BankCardOrderAddressVerificationActions>
}

export enum BankCardOrderAddressVerificationActions {
  UploadDocuments = 'uploadDocuments',
}

export enum BankCardOrderFailureReason {
  Expired = 'EXPIRED',
  AddressFailure = 'ADDRESS_FAILURE',
  IdentityFailure = 'IDENTITY_FAILURE',
  PrefundFailure = 'PREFUND_FAILURE',
  FundingSourceFailure = 'FUNDING_SOURCE_FAILURE',
}

export type BankCardOrderFundingSourceVerification = {
  __typename?: 'BankCardOrderFundingSourceVerification'
  status: BankCardOrderVerificationStatus
  actionRequired?: Maybe<BankCardOrderFundingSourceVerificationActions>
  pendingReason?: Maybe<BankCardOrderFundingSourceVerificationPendingReason>
}

export enum BankCardOrderFundingSourceVerificationActions {
  SubmitRdVs = 'submitRDVs',
  UploadDocuments = 'uploadDocuments',
  LinkFundingSource = 'linkFundingSource',
  HandleFrozenFundingSource = 'handleFrozenFundingSource',
}

export enum BankCardOrderFundingSourceVerificationPendingReason {
  RdvsPending = 'rdvsPending',
  RdvsInitiated = 'rdvsInitiated',
  DocumentsUnderReview = 'documentsUnderReview',
}

export type BankCardOrderIdentityVerification = {
  __typename?: 'BankCardOrderIdentityVerification'
  status: BankCardOrderVerificationStatus
  actionRequired?: Maybe<BankCardOrderIdentityVerificationActions>
  documentUploadUrl?: Maybe<Scalars['String']>
}

export enum BankCardOrderIdentityVerificationActions {
  UploadDocuments = 'uploadDocuments',
}

export type BankCardOrderPrefundVerification = {
  __typename?: 'BankCardOrderPrefundVerification'
  status: BankCardOrderVerificationStatus
  actionRequired?: Maybe<BankCardOrderPrefundVerificationActions>
}

export enum BankCardOrderPrefundVerificationActions {
  CreateBankTransfer = 'createBankTransfer',
}

export enum BankCardOrderStatus {
  NotOrdered = 'notOrdered',
  Pending = 'pending',
  ActionRequired = 'actionRequired',
  Accepted = 'accepted',
  Success = 'success',
  Failure = 'failure',
}

export enum BankCardOrderVerificationStatus {
  Pending = 'pending',
  ActionRequired = 'actionRequired',
  ActionRequiredDueToFailure = 'actionRequiredDueToFailure',
  Success = 'success',
  Failure = 'failure',
}

export enum BankCardPaymentProcessor {
  Dps = 'DPS',
  Shazam = 'SHAZAM',
}

export enum BankCardPermanentLockReason {
  Fraud = 'fraud',
  Lost = 'lost',
  Stolen = 'stolen',
}

export type BankCardPrefundTransfer = {
  /** Amount (either $0 or between $25, $500) to transfer after bank account is created. */
  amount: PositiveCurrencyAmountInput
}

export type BankCardReissue = {
  __typename?: 'BankCardReissue'
  bankCardRequest?: Maybe<BankCardRequest>
  reissueBankCardEligibility: ReissueBankCardEligibility
  bankType: BankType
}

export type BankCardRequest = {
  __typename?: 'BankCardRequest'
  /** tag for new bank card */
  id: Scalars['ID']
  userId: Scalars['ID']
  requestedDate: Scalars['Date']
  status: BankCardRequestStatus
  /** Reason for requesting a new bank card */
  reason: BankCardRequestReason
  isReissue: Scalars['Boolean']
  /** Date associated with reason (Date lost, date stolen, etc) */
  reasonDate?: Maybe<Scalars['Date']>
  /** Additional information pertaining to the request */
  reasonComment?: Maybe<Scalars['String']>
  /** Issued date for new bank card */
  issuedDate?: Maybe<Scalars['Date']>
  /** True when new bank card has been activated */
  isActivated: Scalars['Boolean']
  previousBankCardId?: Maybe<Scalars['ID']>
  /** The mailing address used to ship the reissued card */
  mailingAddress?: Maybe<BankCardRequestMailingAddress>
}

export type BankCardRequestMailingAddress = {
  __typename?: 'BankCardRequestMailingAddress'
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2?: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type BankCardRequestMailingAddressInput = {
  city: Scalars['String']
  country: Scalars['String']
  street1: Scalars['String']
  street2?: Maybe<Scalars['String']>
  state: Scalars['String']
  zipCode: Scalars['String']
}

export enum BankCardRequestReason {
  NewAccount = 'NEW_ACCOUNT',
  Damaged = 'DAMAGED',
  Lost = 'LOST',
  Stolen = 'STOLEN',
  DeliveryIssue = 'DELIVERY_ISSUE',
  Other = 'OTHER',
}

export enum BankCardRequestStatus {
  Requested = 'REQUESTED',
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Issued = 'ISSUED',
}

export enum BankCardStatus {
  Initiated = 'initiated',
  Pending = 'pending',
  PendingVerification = 'pendingVerification',
  Verified = 'verified',
  Denied = 'denied',
  Expired = 'expired',
  Archived = 'archived',
  Reissued = 'reissued',
  Hotlisted = 'hotlisted',
}

export enum BankCardTemporaryLockReason {
  Unknown = 'unknown',
  Fraud = 'fraud',
  Damage = 'damage',
  Temporary = 'temporary',
}

export enum BankCardTier {
  Oak = 'oak',
  RoyalOak = 'royalOak',
  MightyOak = 'mightyOak',
}

export enum BankCardType {
  Debit = 'debit',
  Credit = 'credit',
}

export type BankConnection = {
  __typename?: 'BankConnection'
  /** The name of the bank associated with this connection. */
  bank: Scalars['String']
  /** The ID of the associated bank connection. */
  linkedAccountId: Scalars['ID']
  /** The date last submission was made on the connection */
  lastSubmissionDate?: Maybe<Scalars['DateTime']>
  /** The date next submission can be made on the connection */
  nextSubmissionDate?: Maybe<Scalars['DateTime']>
  /** True if this connection is eligible for authentication, False if not. */
  eligible?: Maybe<Scalars['Boolean']>
  /** Status based on the Eligibility */
  accountStatus?: Maybe<BankConnectionStatus>
  /** Institution name of the given connection */
  institutionName: Scalars['String']
  /** The total amount of fees which are currently negotiable. */
  totalNegotiableFees?: Maybe<MonetaryAmount>
  /** Provides the type of Negotiation for the Connection.(Auto, MailIn)  */
  negotiationType?: Maybe<Scalars['String']>
  /** The logo url for the institution associated with the account. */
  logoUrl: Scalars['URL']
}

export enum BankConnectionStatus {
  Eligible = 'ELIGIBLE',
  Lowertier = 'LOWERTIER',
  Pending = 'PENDING',
  IneligibleThreshold = 'INELIGIBLE_THRESHOLD',
  IneligibleCooldown = 'INELIGIBLE_COOLDOWN',
  IneligibleNotsupported = 'INELIGIBLE_NOTSUPPORTED',
}

export type BankDocument = {
  __typename?: 'BankDocument'
  url: Scalars['String']
  name: Scalars['String']
  type: Scalars['String']
}

/** Bank Document Requested Alert. */
export type BankDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'BankDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type BankFee = {
  __typename?: 'BankFee'
  amount: MonetaryAmount
  /** The name of the transaction. */
  name: Scalars['String']
  type: BankFeeType
  category: TransactionCategory
  linkedSubAccountId: Scalars['ID']
  linkedAccountId: Scalars['ID']
  transactionDate: Scalars['DateTime']
  status: FeeStatus
  submissionKey?: Maybe<Scalars['String']>
  accountName: Scalars['String']
  /** The last 4 digits of the account associated with this transaction. */
  digit: Scalars['String']
  /** The bank name, digit, and date of the fee. */
  subtitle?: Maybe<Scalars['String']>
  /** Return bank fee type string */
  title: Scalars['String']
}

export type BankFeeConnection = {
  __typename?: 'BankFeeConnection'
  /** The name of the bank associated with this connection. */
  bank: BankName
  /** The ID of the associated bank connection. */
  linkedAccountId: Scalars['ID']
  /** Whether the negotiation service is authenticated with this connection. */
  status: ConnectionStatus
  /** The fee type string. Ex: 'Overdraft fees' */
  feeSynopsis?: Maybe<Scalars['String']>
  latestSubmission?: Maybe<Submission>
  submissions?: Maybe<Array<Submission>>
  /** True if this connection is eligible for authentication, False if not. */
  eligible: Scalars['Boolean']
  /** Institution name of the given connection */
  institutionName: Scalars['String']
  /** The total amount of fees which are currently negotiable. */
  totalNegotiableFees: MonetaryAmount
  /** True if this connection is eligible for mail-in negotiations, False if not. */
  mailInEligibility: Scalars['Boolean']
  /** The logo url for the institution associated with the account. */
  logoUrl: Scalars['URL']
}

export type BankFeeConnectionAlert = {
  __typename?: 'BankFeeConnectionAlert'
  /** The name of the bank connection. */
  bankName: BankName
  status: SubmissionStatus
  /** The ID of the bank connection. */
  linkedAccountId: Scalars['ID']
  /** The ID of the Negotiation. */
  negotiationId: Scalars['ID']
}

export type BankFeeNegotiationAlert = {
  __typename?: 'BankFeeNegotiationAlert'
  alertData?: Maybe<Array<BankFeeConnectionAlert>>
  /** Type of bank fee negotiation alert. */
  type: BankFeeNegotiationAlertType
  /** UserID */
  userId: Scalars['ID']
}

export enum BankFeeNegotiationAlertType {
  NegotiationError = 'NEGOTIATION_ERROR',
  MailInStatusCheck = 'MAIL_IN_STATUS_CHECK',
}

export enum BankFeeNegotiationGqlStatus {
  Submitted = 'SUBMITTED',
  SubmittedSent = 'SUBMITTED_SENT',
  ActionrequiredReportRefund = 'ACTIONREQUIRED_REPORT_REFUND',
  ActionrequiredScheduleCall = 'ACTIONREQUIRED_SCHEDULE_CALL',
  ActionrequiredConnectionError = 'ACTIONREQUIRED_CONNECTION_ERROR',
  CallScheduled = 'CALL_SCHEDULED',
  ResolvedNoRefund = 'RESOLVED_NO_REFUND',
  ResolvedRefund = 'RESOLVED_REFUND',
}

export type BankFeeNegotiationResults = {
  __typename?: 'BankFeeNegotiationResults'
  /** The total amount of fees refunded by Benefits Hub. */
  totalRefundedFees: MonetaryAmount
}

export enum BankFeeNegotiationStatus {
  Submitted = 'SUBMITTED',
  AutoConnectionError = 'AUTO_CONNECTION_ERROR',
  AutoInProgress = 'AUTO_IN_PROGRESS',
  AutoError = 'AUTO_ERROR',
  MailInPending = 'MAIL_IN_PENDING',
  MailInError = 'MAIL_IN_ERROR',
  MailInSent = 'MAIL_IN_SENT',
  MailInEscalated = 'MAIL_IN_ESCALATED',
  MailInScheduleCall = 'MAIL_IN_SCHEDULE_CALL',
  ResolvedRefund = 'RESOLVED_REFUND',
  ResolvedNoRefund = 'RESOLVED_NO_REFUND',
  CallScheduled = 'CALL_SCHEDULED',
}

export type BankFeeSummary = {
  __typename?: 'BankFeeSummary'
  /** The total amount of fees which are currently negotiable. */
  totalNegotiableFees: MonetaryAmount
  /** The total amount of fees refunded by Harvest. */
  totalReimbursedFees: MonetaryAmount
  /** The total amount of fees Harvest has attempted to negotiate. */
  totalNegotiatedFees: MonetaryAmount
  /** Signifies whether a user is eligible for the WTDN card in the Action Feed. */
  eligible: Scalars['Boolean']
  /** The total number of cups of coffee a user could purchase with the amount they have paid in fees. */
  coffeeCount: Scalars['Int']
  /** The total number of fees this user has paid by status. */
  feesFound: FeeStatusSummary
  linkedAccounts: Array<BankFeeConnection>
  lastSync?: Maybe<Scalars['DateTime']>
}

export enum BankFeeType {
  OverdraftFee = 'OVERDRAFT_FEE',
  ForeignTransactionFee = 'FOREIGN_TRANSACTION_FEE',
  LateFee = 'LATE_FEE',
  WireTransferFee = 'WIRE_TRANSFER_FEE',
  AccountMaintenanceFee = 'ACCOUNT_MAINTENANCE_FEE',
  MonthlyServiceFee = 'MONTHLY_SERVICE_FEE',
  MinimumBalanceFee = 'MINIMUM_BALANCE_FEE',
  AtmFee = 'ATM_FEE',
  CreditCardInterestCharge = 'CREDIT_CARD_INTEREST_CHARGE',
  NsfFee = 'NSF_FEE',
  CashAdvance = 'CASH_ADVANCE',
  BalanceInquiryFee = 'BALANCE_INQUIRY_FEE',
  ExcessFee = 'EXCESS_FEE',
  CheckFee = 'CHECK_FEE',
  StopPaymentFee = 'STOP_PAYMENT_FEE',
  EarlyClosureFee = 'EARLY_CLOSURE_FEE',
  DormantFee = 'DORMANT_FEE',
  PaperStatementFee = 'PAPER_STATEMENT_FEE',
  ClosedAccountProcessingFee = 'CLOSED_ACCOUNT_PROCESSING_FEE',
  ExternalTransferFee = 'EXTERNAL_TRANSFER_FEE',
  CardSetupFee = 'CARD_SETUP_FEE',
}

export type BankMetadata = {
  __typename?: 'BankMetadata'
  totals?: Maybe<BankMetadataTotals>
}

export type BankMetadataTotals = {
  __typename?: 'BankMetadataTotals'
  oak: Scalars['Int']
  royalOak: Scalars['Int']
}

export enum BankName {
  Chase = 'CHASE',
  WellsFargo = 'WELLS_FARGO',
  TestBank = 'TEST_BANK',
  NotApplicable = 'NOT_APPLICABLE',
}

export type BankStatement = {
  __typename?: 'BankStatement'
  type: BankStatementType
  createdAt: Scalars['DateTime']
  year: Scalars['String']
  month: Scalars['String']
  url: Scalars['String']
}

export enum BankStatementType {
  Monthly = 'monthly',
  Tax = 'tax',
}

export type BankTransaction = {
  __typename?: 'BankTransaction'
  id: Scalars['ID']
  /** The amount of funds the transaction represents. */
  amount: CurrencyAmount
  /** The exact date and time the transaction was created */
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
  /** The exact date and time the transaction was settled. */
  settledAt?: Maybe<Scalars['DateTime']>
  /** The exact date and time the funds associated with the transaction became available. */
  availableAt?: Maybe<Scalars['DateTime']>
  /** The exact date and time the transaction was voided. */
  voidedAt?: Maybe<Scalars['DateTime']>
  /** The status of the transaction */
  status: BankTransactionStatus
  /** The program-wide unique identifier generated for each transfer */
  tag?: Maybe<Scalars['String']>
  /**
   * The card that created the transaction. Will be null if this transaction is
   * not tied to a card
   */
  bankCard?: Maybe<BankCard>
  /**
   * Represents a client-specified description of the transaction.
   * If transaction was received from a NACHA file (typeCode is UNKWTH, UNKDEP, UNKRSV),
   * this property contains the description verbatim from the NACHA file. By law, this
   * description must be displayed to the end user. If transaction was received
   * from an ISO-8583 interface (i.e. debit card transaction), this property contains
   * description verbatim from DataElement 43 (Card Acceptor Name/Location) of
   * ISO-8583 interface plus details of any fees or surchages that may have been
   * incurred. By law, this description must be displayed to the end user
   * Otherwise, the transaction was received from a call to CorePro API or it was
   * line item in the Bulk Transfer File. This property contains the description
   * verbatim passed by the client code
   */
  description: Scalars['String']
  /**
   * Shorter version of description. Depending on type, may contain full description.
   * Ex. Purchase transactions contain merchant name without address.
   */
  summary: Scalars['String']
  typeCode: Scalars['String']
  type: BankTransactionType
  nachaCode: Scalars['String']
}

export type BankTransactionConnection = {
  __typename?: 'BankTransactionConnection'
  edges: Array<Maybe<BankTransactionEdge>>
  pageInfo: PageInfo
}

export type BankTransactionEdge = {
  __typename?: 'BankTransactionEdge'
  node?: Maybe<BankTransaction>
  cursor: Scalars['ID']
}

export enum BankTransactionStatus {
  /** Transaction has been created but not yet put into a NACHA file */
  Initiated = 'initiated',
  /** Transaction has been created and put into a NACHA file */
  Pending = 'pending',
  /** Transaction has been posted to the account */
  Settled = 'settled',
  /** Transaction has been voided */
  Voided = 'voided',
}

export enum BankTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
}

export enum BankType {
  Lsb = 'LSB',
  Nbkc = 'NBKC',
}

/** Acorns base Portfolio interface */
export type BasePortfolio = {
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation
  cashOwed: MonetaryAmount
  currentAllocationPercentage: Scalars['Float']
  currentBalance: MonetaryAmount
  currentBalanceWithPending: MonetaryAmount
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel?: Maybe<PortfolioCustomizationLevel>
  /** Description of the portfolio */
  description: Scalars['String']
  /** ID of the Portfolio */
  id: Scalars['ID']
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']
  pendingBalance: MonetaryAmount
  /**
   * Securities currently owned by the Portfolio's InvestmentAccount (will be null
   * if not selected in the context of an InvestmentAccount).
   */
  portfolioSecurities?: Maybe<Array<PortfolioSecurity>>
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations?: Maybe<Array<PortfolioSecurityAllocation>>
  yearToDateReturn?: Maybe<MarketReturn>
}

/** Returned result for a batchAddTierSubscriptions mutation */
export type BatchAddTierSubscriptions = {
  __typename?: 'BatchAddTierSubscriptions'
  addedIds: Array<Scalars['ID']>
  unaddedIds: Array<Scalars['ID']>
}

export type BatchAddTierSubscriptionsInput = {
  allowInactiveTier?: Maybe<Scalars['Boolean']>
  createdBy?: Maybe<TierSubscriptionCreatedBy>
  migrationId?: Maybe<Scalars['ID']>
  tierId: Scalars['ID']
  tierPriceId: Scalars['ID']
  userIds: Array<Scalars['ID']>
}

export type BatchAddTierSubscriptionsResult =
  | BatchAddTierSubscriptions
  | InvalidTier
  | InvalidTierPrice

/** A person who doesn't have an Acorns account, but may someday inherit one or funds from one. */
export type Beneficiary = TimestampsInterface & {
  __typename?: 'Beneficiary'
  /** List of addresses associated with beneficiary */
  addresses?: Maybe<Array<Maybe<Address>>>
  /** URL for the Beneficiary's avatar image */
  avatarUrl?: Maybe<Scalars['String']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for user who this beneficiary belongs to */
  custodianId: Scalars['ID']
  /** Beneficiaries nickname for their custodian. */
  custodianNickname?: Maybe<Scalars['String']>
  /** Beneficiary's date of birth: */
  dateOfBirth: Scalars['String']
  /** Timestamp when the Beneficiary was deactivated */
  deactivatedAt?: Maybe<Scalars['DateTime']>
  /** Beneficiaries email id */
  email?: Maybe<Scalars['Email']>
  /** First name of beneficiary */
  firstName: Scalars['String']
  /** Internal ID for beneficiary */
  id: Scalars['ID']
  /** Last name of beneficiary */
  lastName: Scalars['String']
  /** List of phone numbers associated with the beneficiary */
  phoneNumbers?: Maybe<Array<Maybe<Phone>>>
  /** True if the beneficiary has an ssn false if not */
  ssnPresent: Scalars['Boolean']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  investmentAccount?: Maybe<InvestmentAccount>
}

/** Cannot open early account because the beneficiary account already exsists */
export type BeneficiaryAccountExistsException = {
  __typename?: 'BeneficiaryAccountExistsException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** A person with the supplied date of birth is too old to open a UTMA/UGMA account */
export type BeneficiaryExceedsAgeLimitException = {
  __typename?: 'BeneficiaryExceedsAgeLimitException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Changeable attributes for beneficiaries */
export type BeneficiaryInfoInput = {
  /** Beneficiary Phone number */
  phoneNumber?: Maybe<Scalars['String']>
  /** Beneficiary Email */
  email?: Maybe<Scalars['Email']>
  /** Mailing Address */
  mailingAddress?: Maybe<AddressInput>
  /** Beneficiaries nickname for their custodian. */
  custodianNickname?: Maybe<Scalars['String']>
}

/** Changeable attributes for beneficiaries */
export type BeneficiaryInput = {
  /** Beneficiary First Name */
  firstName: Scalars['String']
  /** Beneficiary Last Name */
  lastName: Scalars['String']
  /** Date of Birth */
  dateOfBirth: Scalars['String']
}

/** Beneficiary does not exist */
export type BeneficiaryNotFoundException = {
  __typename?: 'BeneficiaryNotFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type BeneficiaryRequestedLaterAlert = Alert & {
  __typename?: 'BeneficiaryRequestedLaterAlert'
  type: Scalars['String']
  userId: Scalars['ID']
}

export enum BeneficiaryType {
  Individual = 'individual',
  Entity = 'entity',
}

export enum BenefitsPartner {
  Avibra = 'AVIBRA',
  TrustAndWill = 'TRUST_AND_WILL',
}

export enum BenefitsProduct {
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsInsuranceBasic = 'BENEFITS_INSURANCE_BASIC',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD',
}

export type BigCurrencyAmount = {
  __typename?: 'BigCurrencyAmount'
  currency: Currency
  value: Scalars['BigDecimal']
}

/** Attributes related to the billing cycle */
export type BillingCycle = TimestampsInterface & {
  __typename?: 'BillingCycle'
  active: Scalars['Boolean']
  amount?: Maybe<Scalars['Float']>
  amountCollected?: Maybe<Scalars['Float']>
  amountOwed?: Maybe<Scalars['Float']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  credits: Array<Maybe<Credit>>
  endDate: Scalars['String']
  extension: Scalars['String']
  fees: Array<Maybe<Fee>>
  id: Scalars['ID']
  invoiceDate: Scalars['String']
  startDate: Scalars['String']
  state: BillingCycleState
  tierSubscriptionId?: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
  tierSubscription?: Maybe<TierSubscription>
}

/** Attributes related to the billing cycle */
export type BillingCycleCreditsArgs = {
  discount_ids?: Maybe<Array<Maybe<Scalars['ID']>>>
}

/** Attributes related to the billing cycle */
export type BillingCycleFeesArgs = {
  execution_methods?: Maybe<Array<Maybe<FeeExecutionMethod>>>
}

export enum BillingCycleState {
  /** Unpaid billing cycle */
  Unpaid = 'UNPAID',
  /** Assessed billing cycle */
  Assessed = 'ASSESSED',
  /** Billing cycle execution started */
  Executed = 'EXECUTED',
  /** Paid billing cycle */
  Paid = 'PAID',
  /** Failed billing cycle */
  Failed = 'FAILED',
  /** Initiate refund billing cycle */
  PendingRefund = 'PENDING_REFUND',
  /** Refunded billing cycle */
  Refunded = 'REFUNDED',
  /** Refund failed billing cycle */
  RefundFailed = 'REFUND_FAILED',
}

export enum BillingFrequency {
  Monthly = 'MONTHLY',
  Never = 'NEVER',
}

/** Billing Profile not found */
export type BillingProfileNotFoundException = {
  __typename?: 'BillingProfileNotFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type BillNegotiation = {
  __typename?: 'BillNegotiation'
  /** The date the submission was created Ex: 'Tue, 29 Dec 2020 04:16:41 GMT' */
  created: Scalars['DateTime']
  /** The date the mail was sent. Ex: 'Tue, 29 Dec 2020 04:16:41 GMT' */
  sendDate?: Maybe<Scalars['DateTime']>
  /** Name of the utility bill company */
  serviceName: Scalars['String']
  /** Name of the customer's plan with the company */
  logoUrl: Scalars['URL']
  /** Status of the utility bill negotiation */
  negotiationStatus: MailInNegotiationStatus
}

export type BillNegotiationSubmitResult = {
  __typename?: 'BillNegotiationSubmitResult'
  message: Scalars['String']
}

export type BlockDeviceInput = {
  deviceId: Scalars['ID']
}

/** blockDevice results */
export type BlockDeviceResult = Device | DeviceNotFoundException

export type BlockedEmailDomainException = {
  __typename?: 'BlockedEmailDomainException'
  message?: Maybe<Scalars['String']>
}

export type BriefInsuranceSection = {
  __typename?: 'BriefInsuranceSection'
  cta: Cta
  image: Image
  insuranceType: Scalars['String']
  recommendType: Scalars['String']
  title: Scalars['String']
}

/** Grouping of Products */
export type Bundle = {
  __typename?: 'Bundle'
  /** Image asset path in CDN */
  iconPath: Scalars['String']
  /** Name of bundle */
  name: Scalars['String']
  /** Associated products to display for grouping */
  products: Array<PresentableProduct>
}

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE',
}

/** The result of the cancelCheckPayment mutation */
export type CancelCheckPaymentResult =
  | CheckPayment
  | ResourceNotFoundError
  | UnableToCancelCheckError
  | AuthorizationError

/** Input to cancel existing account closure request */
export type CancelInvestmentAccountClosureRequestInput = {
  /** The ID of the investment account */
  investmentAccountId: Scalars['ID']
}

/** Cancel investment account request mutation response */
export type CancelInvestmentAccountClosureRequestResult =
  | AccountClosedException
  | AccountNotFoundException
  | ClosureRequestDoesNotExistException
  | InvestmentAccount

/** Input to cancel a pending investment */
export type CancelInvestmentInput = {
  /** DEPRECATED: The ID of the investment account */
  investmentAccountId?: Maybe<Scalars['ID']>
  /** The ID of the pending investment associated with the investment account id */
  investmentId: Scalars['ID']
}

/** ID of canceled investment */
export type CancelInvestmentPayload = {
  __typename?: 'CancelInvestmentPayload'
  id: Scalars['ID']
}

/** Cancel investment mutation response */
export type CancelInvestmentResult =
  | CancelInvestmentPayload
  | InvestmentNotFoundException
  | InvestmentUncancellableException

export type CancelRecurringTransferResult = RecurringTransfer | VersionMismatchException

export type CancelRequestedDocumentInput = {
  documentRequestId: Scalars['ID']
  reviewerId: Scalars['ID']
}

export type CancelTransferPayload = {
  __typename?: 'CancelTransferPayload'
  transactionId: Scalars['ID']
}

/** Card delivery status */
export type CardDeliveryStatus = {
  __typename?: 'CardDeliveryStatus'
  /** When the card tracking record was created */
  createdAt: Scalars['String']
  /** Current Tracking Status Description */
  description?: Maybe<Scalars['String']>
  /** USPS Tracking Number */
  picNumber?: Maybe<Scalars['String']>
  /** Reference ID */
  referenceId: Scalars['String']
  /** Status enum */
  status: PackageStatus
  /** When the card tracking record was updated */
  updatedAt: Scalars['String']
}

export type CarouselOffer = {
  __typename?: 'CarouselOffer'
  campaignId: Scalars['ID']
  cta: Cta
  fastQuote: Scalars['Boolean']
  logo: Image
  offerId: Scalars['ID']
  ownerId: Scalars['ID']
  tip?: Maybe<Scalars['String']>
  title: Scalars['String']
}

export enum CarouselType {
  Standard = 'STANDARD',
  Banner = 'BANNER',
}

export type ChallengeAnswerInput = {
  challengeId: Scalars['ID']
  challengeAnswer: Scalars['String']
}

/** enums */
export enum ChallengeDeliveryType {
  Sms = 'SMS',
}

export type ChallengePointsEarned = {
  __typename?: 'ChallengePointsEarned'
  challengeID: Scalars['ID']
  /** legal copy about how points are earned */
  details: Scalars['String']
  /** how many points earned out of how many possible */
  earningProgress: DiscreteMilestoneProgress
  /** summarized information about how points are earned */
  summary?: Maybe<Scalars['String']>
}

/** Input to change the amount of an outside contribution */
export type ChangeOutsideContributionAmountInput = {
  /** Stripe payment intent id */
  paymentIntentId: Scalars['ID']
  /** investment amount for the outside contribution */
  investmentAmount: Scalars['String']
}

/** Change outside contribution amount response */
export type ChangeOutsideContributionAmountResult =
  | ContributionAmountAboveThresholdError
  | ContributionAmountBelowThresholdError
  | OutsideContributionCheckoutCart

export type ChangePasswordInput = {
  oldPassword: Scalars['String']
  newPassword: Scalars['String']
  securityAnswer?: Maybe<SecurityAnswer>
}

/** changePasswordResult */
export type ChangePasswordResult =
  | ChangePasswordSuccess
  | IncorrectOldPasswordException
  | InvalidPasswordException
  | IncorrectSecurityAnswerException

export type ChangePasswordSuccess = {
  __typename?: 'ChangePasswordSuccess'
  userId: Scalars['ID']
}

export type ChangeSecuritySymbolInput = {
  priorSymbol: Scalars['TickerSymbol']
  newSymbol: Scalars['TickerSymbol']
}

export type ChangeSecuritySymbolResult =
  | Fund
  | Stock
  | InvalidSecurityForSymbolChangeError
  | InvalidSymbolForSymbolChangeError

/** Represents the check to be uploaded. */
export type CheckImage = {
  type: ImageType
  /** Image based-64 encoded. */
  image: Scalars['String']
}

export enum CheckoutCartStatus {
  /** Initial state, before a payment method is attached */
  RequiresPaymentMethod = 'REQUIRES_PAYMENT_METHOD',
  /** Payment intent needs confirming */
  RequiresConfirmation = 'REQUIRES_CONFIRMATION',
  /** Payment intent needs further action by frontend */
  RequiresAction = 'REQUIRES_ACTION',
  /** State a payment intent is in after actions are handled */
  Processing = 'PROCESSING',
  /** Payment intent needs capturing */
  RequiresCapture = 'REQUIRES_CAPTURE',
  /** Terminal state, canceled payment intent */
  Canceled = 'CANCELED',
  /** Terminal state, succeeded payment intent */
  Succeeded = 'SUCCEEDED',
}

export type CheckPayment = {
  __typename?: 'CheckPayment'
  fromAccountId: Scalars['String']
  recipientName: Scalars['String']
  recipientAddress: CheckPaymentAddress
  createdAt: Scalars['DateTime']
  memo?: Maybe<Scalars['String']>
  estimatedArrivalAt: Scalars['DateTime']
  status: CheckPaymentStatus
  checkNumber?: Maybe<Scalars['String']>
  trackingNumber?: Maybe<Scalars['String']>
  amount: CurrencyAmount
  failedAt?: Maybe<Scalars['DateTime']>
  failureReason?: Maybe<CheckPaymentFailureReason>
  canceledAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
}

export type CheckPaymentAddress = {
  __typename?: 'CheckPaymentAddress'
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2?: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type CheckPaymentAddressInput = {
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2?: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type CheckPaymentConnection = {
  __typename?: 'CheckPaymentConnection'
  edges: Array<CheckPaymentEdge>
  pageInfo: PageInfo
}

export type CheckPaymentEdge = {
  __typename?: 'CheckPaymentEdge'
  node: CheckPayment
  cursor: Scalars['ID']
}

export enum CheckPaymentFailureReason {
  InsufficientFunds = 'insufficientFunds',
}

export type CheckPaymentRecipient = {
  __typename?: 'CheckPaymentRecipient'
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  businessName?: Maybe<Scalars['String']>
}

export type CheckPaymentRecipientAddressType = {
  __typename?: 'CheckPaymentRecipientAddressType'
  recipient: CheckPaymentRecipient
  recipientAddress: CheckPaymentAddress
}

export type CheckPaymentRecipientInput = {
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  businessName?: Maybe<Scalars['String']>
}

export enum CheckPaymentStatus {
  Canceled = 'canceled',
  Failed = 'failed',
  Shipped = 'shipped',
  Pending = 'pending',
}

export enum Circumstance {
  Financial = 'FINANCIAL',
  Work = 'WORK',
  Family = 'FAMILY',
  Personal = 'PERSONAL',
}

/** Represents the client info passed into startCheckDeposit */
export type ClientInfo = {
  /** iphone, android, or web */
  platform: Scalars['String']
  /** Operating System, e.g. iOS, Android, Windows, Mac OS */
  os: Scalars['String']
  /** Operating System version, e.g. 8.0.10211, KITKAT, LOLLIPOP etc. */
  osVersion: Scalars['String']
  /** App version */
  appVersion: Scalars['String']
  /** Make of the device, e.g. Samsung, Apple, LG, etc */
  manufacturer: Scalars['String']
  /** Device model, e.g. iPhone 7, AsusPad 2 etc. */
  model: Scalars['String']
}

export type CloseAccountReason = {
  __typename?: 'CloseAccountReason'
  key: Scalars['String']
  label: Scalars['String']
}

export type CloseBankAccountInput = {
  accountId: Scalars['ID']
  bankAccountClosureReason?: Maybe<BankAccountClosureReason>
  feedback?: Maybe<Scalars['String']>
}

export type CloseBankAccountResult = BankAccount | BankAccountNotFoundError

/** Investment account closure request */
export type CloseInvestmentAccountInput = {
  /** The ID of the investment account to be closed */
  investmentAccountId: Scalars['ID']
  /** List of closure reason keys */
  accountClosureReasons?: Maybe<Array<Scalars['String']>>
  /** Any closure reason comments the user may have */
  comments?: Maybe<Scalars['String']>
}

/** Investment Account Closure Response */
export type CloseInvestmentAccountResult =
  | AccountNotFoundException
  | InvestmentAccount
  | InvestmentAccountAlreadyClosed
  | InvestmentAccountClosureInProgress
  | NonBasicAccountOpenException

/** Close User Account Response */
export type CloseUserAccountResult = OpenAccountsException | UserNotFoundException | User_V2

/** No account closure request exists for the given investment account */
export type ClosureRequestDoesNotExistException = {
  __typename?: 'ClosureRequestDoesNotExistException'
  /** message */
  errorMessage?: Maybe<Scalars['String']>
}

/** An account closure request already exists for this account */
export type ClosureRequestExistsException = {
  __typename?: 'ClosureRequestExistsException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type CohortEligibility = {
  __typename?: 'CohortEligibility'
  /** key referencing if the user is eligible or not */
  eligible: Scalars['Boolean']
  /** key referencing the cohort eligibility scope */
  type: CohortEligibilityScope
}

export enum CohortEligibilityScope {
  /** Mobile Remote Deposit Checks Feature Cohort */
  Mrdc = 'MRDC',
  /** Send Check Cohort */
  SendCheck = 'SEND_CHECK',
  /** Personalized Found Money on Present Cohort */
  PersonalizedFoundMoneyOnPresent = 'PERSONALIZED_FOUND_MONEY_ON_PRESENT',
  /** Earn Incentive New User Cohort */
  EarnIncentive = 'EARN_INCENTIVE',
  /** Passions Cohort */
  PassionsExperience = 'PASSIONS_EXPERIENCE',
}

/** Collapsed view which only shows the recommended amount */
export type CollapsedLifeRecommendation = {
  __typename?: 'CollapsedLifeRecommendation'
  cta: Cta
  recommendedCoverage: Scalars['Int']
  title: Scalars['String']
}

/** Performance values aggregated across all investment accounts within a user's Acorns account */
export type CombinedPerformance = {
  __typename?: 'CombinedPerformance'
  /** Combined investment account values based on previous market day's closing prices */
  accountValues?: Maybe<Array<Maybe<AccountValue>>>
  /** Value of bond holdings across all investment accounts */
  bondValue?: Maybe<MonetaryAmount>
  /** Value of crypto holdings across all investment accounts */
  cryptoValue?: Maybe<MonetaryAmount>
  /** Value of all investment accounts based on most current available prices */
  currentBalance?: Maybe<MonetaryAmount>
  /** The dollar change in combined account value from market movement over the reporting period */
  marketChange?: Maybe<MonetaryAmount>
  /** The percentage change in combined account value from market movement over the reporting period */
  marketChangePercent?: Maybe<Scalars['Float']>
  /** The percentage change in combined account value from market movement over the reporting period (excluding fees) */
  marketChangePercentWithoutFees?: Maybe<Scalars['Float']>
  /** The dollar change in combined account value from market movement over the reporting period (excluding fees) */
  marketChangeWithoutFees?: Maybe<MonetaryAmount>
  /** The total dollar amount of contributions minus withdrawals */
  netInvestments?: Maybe<MonetaryAmount>
  /** Value of stock holdings across all investment accounts */
  stockValue?: Maybe<MonetaryAmount>
  /** The total dollar amount invested over the reporting period */
  totalInvested?: Maybe<MonetaryAmount>
  /** The total dollar amount invested over the reporting period (including pending investments) */
  totalInvestedWithPending?: Maybe<MonetaryAmount>
}

export type CompleteCheckDepositInput = {
  amount: CurrencyAmountInput
  /** The session to complete. */
  sessionToken: Scalars['String']
}

/** Response from completing a deposit. */
export type CompleteCheckDepositPayload = {
  __typename?: 'CompleteCheckDepositPayload'
  /** The session that was completed. */
  sessionToken: Scalars['String']
}

export type CompletedQuiz = {
  __typename?: 'CompletedQuiz'
  communityAvgPercents: Scalars['Int']
  correctQuestions: Scalars['Int']
  totalQuestions: Scalars['Int']
  userScorePercents: Scalars['Int']
}

export type CondensedSocialCopies = {
  __typename?: 'CondensedSocialCopies'
  sms?: Maybe<Scalars['String']>
  twitter?: Maybe<Scalars['String']>
  all?: Maybe<Scalars['String']>
}

export type ConfigureSettingsInput = {
  employerHidden?: Maybe<Scalars['Boolean']>
  employerName: Scalars['String']
  splitPercent: Scalars['String']
  splitType: DistributionType
}

export type ConfigureSplitDepositDirectDepositIntentGenericError = {
  __typename?: 'ConfigureSplitDepositDirectDepositIntentGenericError'
  requestId: Scalars['String']
}

export type ConfigureSplitDepositDirectDepositIntentPayload = {
  __typename?: 'ConfigureSplitDepositDirectDepositIntentPayload'
  intent: SplitDepositDirectDepositIntentSetting
}

export type ConfigureSplitDepositDirectDepositIntentSettingInput = {
  allocations: Array<SplitDepositAllocationInput>
  estimatedPaycheckAmount: CurrencyAmountInput
  id?: Maybe<Scalars['ID']>
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
}

export type ConfigureSplitDepositDirectDepositIntentSettingResult =
  | ConfigureSplitDepositDirectDepositIntentPayload
  | ConfigureSplitDepositDirectDepositIntentGenericError

export type ConfigureSplitDepositDirectDepositSettingGenericError = {
  __typename?: 'ConfigureSplitDepositDirectDepositSettingGenericError'
  requestId: Scalars['String']
}

export type ConfigureSplitDepositDirectDepositSettingInput = {
  allocations: Array<SplitDepositAllocationInput>
  directDepositIntentSettingId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
}

export type ConfigureSplitDepositDirectDepositSettingPayload = {
  __typename?: 'ConfigureSplitDepositDirectDepositSettingPayload'
  setting: SplitDepositDirectDepositSetting
}

export type ConfigureSplitDepositDirectDepositSettingResult =
  | ConfigureSplitDepositDirectDepositSettingPayload
  | ConfigureSplitDepositDirectDepositSettingGenericError

export type ConnectAchAccountInput = {
  routing: Scalars['RoutingNumber']
  account: Scalars['AccountNumber']
}

export type ConnectAchAccountResult = InstitutionNotSupportedError | ConnectAchAccountSucceeded

export type ConnectAchAccountSucceeded = {
  __typename?: 'ConnectACHAccountSucceeded'
  message: Scalars['String']
}

export enum ConnectionStatus {
  /** This connection is currently authorized with Harvest's negotiation service. */
  Authorized = 'AUTHORIZED',
  /**
   * This connection is NOT currently authorized with Harvest's negotiation
   * service. Please make a AuthenticateForFeeNegotiation mutation to begin the
   * authorization process.
   */
  Unauthorized = 'UNAUTHORIZED',
  /** Please make a AuthenticateForFeeNegotiation mutation with reconnect=true to complete the TFA process for this connection. */
  TfaRequired = 'TFA_REQUIRED',
}

export type ContactCategory = {
  __typename?: 'ContactCategory'
  id: Scalars['ID']
  value: Scalars['String']
  label: Scalars['String']
  subcategories?: Maybe<Array<ContactSubcategory>>
}

export type ContactFaq = {
  __typename?: 'ContactFaq'
  answer: Scalars['String']
  href: Scalars['String']
  id: Scalars['ID']
  question: Scalars['String']
}

export type ContactFormAlert = {
  __typename?: 'ContactFormAlert'
  message?: Maybe<Scalars['String']>
}

export type ContactInfoInput = {
  address1?: Maybe<Scalars['String']>
  address2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  zip?: Maybe<Scalars['String']>
}

export type ContactSubcategory = {
  __typename?: 'ContactSubcategory'
  id: Scalars['ID']
  value: Scalars['String']
  label: Scalars['String']
  faqs: Array<ContactFaq>
  chatEnabled: Scalars['Boolean']
  emailEnabled: Scalars['Boolean']
  phoneEnabled: Scalars['Boolean']
  message?: Maybe<SubcategoryMessage>
}

export type ContentPreviewConnection = LearnConnection & {
  __typename?: 'ContentPreviewConnection'
  edges: Array<ContentPreviewEdge>
  pageInfo: LearnPageInfo
}

export type ContentPreviewEdge = LearnEdge & {
  __typename?: 'ContentPreviewEdge'
  cursor: Scalars['ID']
  node: LearnContentPreview
}

export type ContributionAbility = {
  __typename?: 'ContributionAbility'
  /**  flag indicating if the user can contribute to this tax year */
  canContribute?: Maybe<Scalars['Boolean']>
  /**  maximum legally allowed amount for contributions */
  planLimit?: Maybe<Scalars['Int']>
  /**  available contribution amount */
  remaining?: Maybe<Scalars['Float']>
  /**  tax year of aggregated contributions */
  taxYear: Scalars['Int']
  /**  total current contributions in tax year */
  yearToDate?: Maybe<Scalars['Float']>
}

export type ContributionAbilityByYear = {
  __typename?: 'ContributionAbilityByYear'
  contributionAbilities?: Maybe<Array<ContributionAbility>>
}

/** Contribution cannot be created because an additional action needs to be taken first */
export type ContributionActionRequiredError = {
  __typename?: 'ContributionActionRequiredError'
  /** The payment_intent_id that the contribution was attempted to be made for */
  paymentIntentId: Scalars['ID']
  /** The url that the frontend needs to redirect the user to for 3DS. Only available for REDIRECT_TO_URL action */
  redirectUrl?: Maybe<Scalars['String']>
  /** The action that needs to be taken in order to create transaction */
  requiredAction: ContributionRequiredAction
}

/** Contribution amount must be below the maximum threshold */
export type ContributionAmountAboveThresholdError = {
  __typename?: 'ContributionAmountAboveThresholdError'
  maximumThresholdAmount: Scalars['String']
}

/** Contribution amount must be above the minimum threshold */
export type ContributionAmountBelowThresholdError = {
  __typename?: 'ContributionAmountBelowThresholdError'
  minimumThresholdAmount: Scalars['String']
}

/** Contribution cannot be created because the card was declined */
export type ContributionCardDeclinedError = {
  __typename?: 'ContributionCardDeclinedError'
  /** The payment_intent_id that the contribution was attempted to be made for */
  paymentIntentId: Scalars['ID']
}

export type ContributionHistoryItem = {
  __typename?: 'ContributionHistoryItem'
  year: Scalars['Int']
}

/** Invalid owner email. */
export type ContributionInvalidOwnerEmailError = {
  __typename?: 'ContributionInvalidOwnerEmailError'
  /** The invalid email provided. */
  providedEmail: Scalars['String']
}

export enum ContributionRequiredAction {
  /** Stripe is expecting the app to redirect the user (not part of our flow and should not happen) */
  RedirectToUrl = 'REDIRECT_TO_URL',
  /** The frontend is responsible for sending this payment intent to Stripe for 3DS verification */
  UseStripeSdk = 'USE_STRIPE_SDK',
}

export enum ContributionState {
  /** Initial state, pending contribution */
  Pending = 'PENDING',
  /** Terminal state, successful contribution */
  Success = 'SUCCESS',
  /** Terminal state, failed contribution */
  Failed = 'FAILED',
}

/** A Core account already exists for this user */
export type CoreAccountAlreadyExistsException = {
  __typename?: 'CoreAccountAlreadyExistsException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Custodian's Core account must be open in order to open an Early Account */
export type CoreAccountClosedException = {
  __typename?: 'CoreAccountClosedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Pulls from funding source */
export type CoreAchSubscriptionFeeItem = PastItem & {
  __typename?: 'CoreACHSubscriptionFeeItem'
  /** Past Item ID */
  id: Scalars['ID']
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** The title of the item */
  title: Scalars['String']
  /** The current state of the item */
  status: PastItemStatus
  /**
   * The amount paid for the subscription. Note that this is intentionally positive
   * because it does not represent removing balance from the account.
   */
  amount: CurrencyAmount
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The corresponding product of the item */
  productType: ProductType
}

/** Legacy type we need to account for Credit (Found Money Credits + Employee Contribution) */
export type CoreAdjustmentItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreAdjustmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount?: Maybe<CurrencyAmount>
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type CoreCashForwardItem = PastItem & {
  __typename?: 'CoreCashForwardItem'
  /** Past Item ID */
  id: Scalars['ID']
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** The title of the item */
  title: Scalars['String']
  /** The current state of the item */
  status: PastItemStatus
  amount: CurrencyAmount
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The corresponding product of the item */
  productType: ProductType
  /** Format: 2017-02 */
  relatedMonth: Scalars['String']
}

/** You owe us money */
export type CoreCollectionItem = PastItem & {
  __typename?: 'CoreCollectionItem'
  /** Past Item ID */
  id: Scalars['ID']
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** The title of the item */
  title: Scalars['String']
  /** The current state of the item */
  status: PastItemStatus
  /** The amount owed. */
  amount: CurrencyAmount
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The corresponding product of the item */
  productType: ProductType
}

export type CoreDividendsItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreDividendsItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    etfCategory: Scalars['String']
    etfTicker: Scalars['String']
  }

export type CoreEmployeeCreditItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreEmployeeCreditItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    employerName: Scalars['String']
  }

/** Sell shares for the fee. This happens for Paypal users or if users never accepted the new EFT */
export type CoreFeeInvestmentItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreFeeInvestmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type CoreFoundMoneyRewardItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreFoundMoneyRewardItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    merchantName?: Maybe<Scalars['String']>
    partnerLogoUrl?: Maybe<Scalars['URL']>
  }

export type CoreGiftCardCreditRedemptionItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreGiftCardCreditRedemptionItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

/** Holding transfer transfered in from Age of Transfer beneficiary investment account */
export type CoreHoldingsTransferInItem = PastItem & {
  __typename?: 'CoreHoldingsTransferInItem'
  /** Past Item ID */
  id: Scalars['ID']
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** The title of the item */
  title: Scalars['String']
  /** The current state of the item */
  status: PastItemStatus
  amount: CurrencyAmount
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The corresponding product of the item */
  productType: ProductType
}

/** An investment in to the Core account */
export type CoreInvestmentItem = PastItem &
  PastCoreCombinedItem &
  PastCoreTradedItem &
  PastUserTransferItem & {
    __typename?: 'CoreInvestmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    isCombinedInvestment: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate?: Maybe<Scalars['DateTime']>
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring?: Maybe<Scalars['Boolean']>
  }

export type CoreLocalFoundMoneyItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreLocalFoundMoneyItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    merchantName?: Maybe<Scalars['String']>
    partnerLogoUrl?: Maybe<Scalars['URL']>
  }

export type CorePartnerRewardItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CorePartnerRewardItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    merchantName?: Maybe<Scalars['String']>
    partnerLogoUrl?: Maybe<Scalars['URL']>
  }

export type CoreRebalanceItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreRebalanceItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount?: Maybe<CurrencyAmount>
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type CoreReferralRewardItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreReferralRewardItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

/** Instant and regular round ups */
export type CoreRoundUpsItem = PastItem &
  PastCoreCombinedItem &
  PastCoreTradedItem &
  PastUserTransferItem & {
    __typename?: 'CoreRoundUpsItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    /** The investment amount after being multiplied. */
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    isCombinedInvestment: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate?: Maybe<Scalars['DateTime']>
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring?: Maybe<Scalars['Boolean']>
    type: RoundUpType
    /** The investment amount prior to being multiplied */
    initialAmount: CurrencyAmount
    multiplier: Scalars['Int']
    merchantName?: Maybe<Scalars['String']>
    /**
     * The amount of the transaction that caused this round up. TransactionAmount
     * will be null if this is a combined round up investment.
     */
    transactionAmount?: Maybe<CurrencyAmount>
  }

export type CoreWithdrawalItem = PastItem &
  PastCoreTradedItem &
  PastUserTransferItem & {
    __typename?: 'CoreWithdrawalItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate?: Maybe<Scalars['DateTime']>
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring?: Maybe<Scalars['Boolean']>
  }

export type Course = {
  __typename?: 'Course'
  authors: Array<LearnAuthor>
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  id: Scalars['ID']
  lessons: Array<Lesson>
  metadata: LearnMetadata
  summary?: Maybe<Scalars['String']>
  tags: Array<LearnTag>
  theme: CourseTheme
  tier: LearnTier
  title: Scalars['String']
  topics: Array<LearnTopic>
}

export type CoursePreview = {
  __typename?: 'CoursePreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  courseTheme: CourseTheme
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  numberOfLessons: Scalars['Int']
  primaryTopicName: Scalars['String']
  progress?: Maybe<LearnProgress>
  relatedQuizProgress?: Maybe<LearnProgress>
  tierName: Scalars['String']
  title: Scalars['String']
}

export type CoursePreviewLocked = {
  __typename?: 'CoursePreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  numberOfLessons: Scalars['Int']
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  title: Scalars['String']
}

export type CourseTheme = LearnThemeLiteral

export type CoverageAsk = {
  __typename?: 'CoverageAsk'
  body: Scalars['String']
  image: Image
  noCta: Cta
  title: Scalars['String']
  yesCta: Cta
}

export type CoverageCalculator = {
  __typename?: 'CoverageCalculator'
  body: Scalars['String']
  cta: Cta
  headline: Scalars['String']
  image: Image
  recommendedCoverage?: Maybe<Scalars['Int']>
  title: Scalars['String']
}

export type CoverageGrow = {
  __typename?: 'CoverageGrow'
  body: Scalars['String']
  cta: Cta
  image: Image
  title: Scalars['String']
}

export type CoverageKnown = {
  __typename?: 'CoverageKnown'
  body: Scalars['String']
  cta: Cta
  educationSection: EducationSection
  image: Image
  subtitle: Scalars['String']
  title: Scalars['String']
}

/** A user response for coverage */
export type CoverageResponse = {
  /** Insurance type */
  insuranceType: InsuranceType
  /** Coverage provider id */
  providerId?: Maybe<Scalars['ID']>
  /** Coverage provider name */
  provider?: Maybe<Scalars['String']>
  /** Covered? */
  covered: Scalars['Boolean']
}

export type CoverageShop = {
  __typename?: 'CoverageShop'
  body: Scalars['String']
  id: Scalars['ID']
  legalDisclaimer: Disclaimer
  modals: Array<Modal>
  partnerDisclaimer: Disclaimer
  title: Scalars['String']
  widgets: Array<CoverageShopWidget>
}

export type CoverageShopWidget = FeaturedOffers | InsuranceCarousel | PartnerChoices

export type CoverageUnknown = {
  __typename?: 'CoverageUnknown'
  body?: Maybe<Scalars['String']>
  cta: Cta
  educationSection: EducationSection
  icon: Image
  image: Image
  subtitle: Scalars['String']
  title: Scalars['String']
}

export type CreateAccountPointsRuleInput = {
  /** detailed explanation about how points are earned */
  details: Scalars['String']
  milestoneID: Scalars['ID']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /** summarized explanation about how points are earned */
  summary?: Maybe<Scalars['String']>
}

export type CreateAccountPointsRuleResult =
  | RecordAlreadyExistsError
  | RecordDoesNotExistError
  | AccountPointsRule

export type CreateAuthProfileInput = {
  email?: Maybe<Scalars['EmailAddress']>
  phoneNumber?: Maybe<Scalars['PhoneNumber']>
}

/** authProfile results */
export type CreateAuthProfileResult = AuthProfile | AuthProfileAlreadyExistsException

export type CreateBankAccountInput = {
  type: BankAccountType
  tag?: Maybe<Scalars['String']>
  accountName?: Maybe<Scalars['String']>
  isDocumentsAccepted: Scalars['Boolean']
}

export type CreateBankAccountPayload = {
  __typename?: 'CreateBankAccountPayload'
  bankAccount?: Maybe<BankAccount>
}

/** Response to a beneficiary creation attempt */
export type CreateBeneficiaryResult =
  | Beneficiary
  | BeneficiaryExceedsAgeLimitException
  | InternalErrorException
  | InvalidDateOfBirthException
  | InvalidFirstNameException
  | InvalidLastNameException

export type CreateCustomSupportTicketInput = {
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>
  ticketFormId?: Maybe<Scalars['String']>
  category?: Maybe<Scalars['String']>
  dateOfBirth: Scalars['String']
  description: Scalars['String']
  email: Scalars['String']
  phoneNumber: Scalars['String']
  customFields?: Maybe<Array<Maybe<Scalars['String']>>>
  subject: Scalars['String']
}

/** Pinwheel Token Return Results */
export type CreateDirectDepositLinkInfoFailure = {
  __typename?: 'CreateDirectDepositLinkInfoFailure'
  failureMessage: Scalars['String']
}

/** Mutation attributes for retrieving a Pinwheel link token */
export type CreateDirectDepositLinkInfoInput = {
  /** User ID */
  userId: Scalars['ID']
  /** Account ID */
  accountId: Scalars['ID']
  /** Required Job */
  requiredJobs: Array<PinwheelLinkTokenRequiredJobs>
  /** Vendor */
  vendor?: Maybe<DirectDepositVendor>
}

/** Pinwheel Token Return Results */
export type CreateDirectDepositLinkInfoPayload = {
  __typename?: 'CreateDirectDepositLinkInfoPayload'
  results: CreatePinwheelLinkToken
  vendor: Scalars['String']
}

/** Describes the create direct deposit info return type. */
export type CreateDirectDepositLinkInfoSwitch =
  | CreateDirectDepositLinkInfoFailure
  | CreateDirectDepositLinkInfoPayload

export type CreateDocumentUpload = {
  __typename?: 'CreateDocumentUpload'
  expiresAt: Scalars['DateTime']
  createdAt: Scalars['DateTime']
  uploadUrl: Scalars['URL']
  requestedDocumentId: Scalars['ID']
}

export type CreateDocumentUploadInput = {
  documentType: DocumentType
  contentType: Scalars['String']
}

export type CreateInvestmentAccountResponse = {
  __typename?: 'CreateInvestmentAccountResponse'
  id: Scalars['ID']
  userUuid: Scalars['ID']
  iraType: InvestmentAccountTypes
}

export type CreateJobAlertResult = JobAlert

export type CreateMilestoneAccountLevelDefinitionInput = {
  /** what is the background image when active */
  activeBackgroundUrl: Scalars['String']
  /** what is the foreground image when active */
  activeForegroundUrl: Scalars['String']
  /** level id, e.g. 3 */
  id: Scalars['Int']
  /** what is the background image when inactive */
  inactiveBackgroundUrl: Scalars['String']
  /** max points for the level. If min and max are the same value, there is no higher level */
  max: Scalars['Int']
  /** minimum points needed for the level */
  min: Scalars['Int']
}

export type CreateMilestoneAccountLevelDefinitionResult =
  | MilestoneAccountLevelDefinition
  | RecordAlreadyExistsError

export type CreateMilestoneAchievementActionRuleInput = {
  /** list of side-effects the milestone can trigger when it is completed */
  actions: Array<MilestoneAchievementActionType>
  milestoneID: Scalars['ID']
}

export type CreateMilestoneAchievementActionRuleResult =
  | MilestoneAchievementActionRule
  | RecordAlreadyExistsError
  | RecordDoesNotExistError

export type CreateMilestoneChallengeDefinitionInput = {
  /** additional information about this challenge */
  details?: Maybe<Scalars['String']>
  /** what time the challenge becomes inactive */
  endsAt: Scalars['DateTime']
  id: Scalars['ID']
  logo?: Maybe<ImageInput>
  /** the list of milestones this challenge is dependent on */
  milestonesIds: Array<Scalars['ID']>
  /** descriptive identifier */
  name?: Maybe<Scalars['String']>
  /** what time the challenge becomes active */
  startsAt: Scalars['DateTime']
}

export type CreateMilestoneChallengeDefinitionResult =
  | MilestoneChallengeDefinition
  | RecordAlreadyExistsError
  | RecordDoesNotExistError

export type CreateMilestoneChallengePointsRuleInput = {
  challengeID: Scalars['ID']
  /** legal copy about how points are earned */
  earningDetails: Scalars['String']
  /** summarized information about how points are earned */
  earningSummary?: Maybe<Scalars['String']>
  /** specifies the max points that can be earned if the milestone is completed more than once */
  maxPointsAllowed: Scalars['Int']
  milestoneID: Scalars['ID']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
}

export type CreateMilestoneChallengePointsRuleResult =
  | MilestoneChallengePointsRule
  | RecordAlreadyExistsError
  | RecordDoesNotExistError

export type CreateMilestoneDefinitionInput = {
  /** the DateTime value argument */
  arg1DateTime?: Maybe<Scalars['DateTime']>
  /** the integer value argument */
  arg1Int?: Maybe<Scalars['Int']>
  /** an optional logo used for inactive milestone states (e.g. LOCKED, NOT_STARTED) */
  inactiveLogo?: Maybe<ImageInput>
  /** denotes if this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean']
  /** default logo */
  logo: ImageInput
  /** descriptive identifier */
  name: Scalars['String']
  /** the rule that determines how this milestone changes status */
  ruleId: Scalars['ID']
  /** the milestone category */
  theme: MilestoneTheme
}

export type CreateMilestoneDefinitionResult =
  | MilestoneDefinition
  | RecordAlreadyExistsError
  | RecordDoesNotExistError

export type CreateMilestoneGroupAchievementActionRuleInput = {
  /** list of side-effects the milestone group can trigger when it is completed */
  actions: Array<MilestoneAchievementActionType>
  /** ID of the milestone group this new rule is for */
  milestoneGroupID: Scalars['ID']
}

export type CreateMilestoneGroupAchievementActionRuleResult =
  | MilestoneGroupAchievementActionRule
  | RecordAlreadyExistsError
  | RecordDoesNotExistError

export type CreateMilestoneGroupDefinitionInput = {
  /** Identifier for the new milestone group */
  milestoneGroupID: Scalars['ID']
  /** IDs of the milestone definitions that comprise this group */
  milestoneIDs: Array<Scalars['ID']>
}

export type CreateMilestoneGroupDefinitionResult =
  | MilestoneGroupDefinition
  | RecordAlreadyExistsError
  | RecordDoesNotExistError

export type CreateMilestoneHubDefinitionInput = {
  id: Scalars['ID']
  /** milestone ids to be associated with milestone hub */
  milestoneIds: Array<Scalars['ID']>
}

export type CreateMilestoneHubDefinitionResult =
  | RecordAlreadyExistsError
  | RecordDoesNotExistError
  | MilestoneHubDefinition

export type CreateMilestoneRuleInput = {
  /** denotes if an argument input needs to be provided for the creation of a MilestoneDefinition */
  argInput: MilestoneRuleArgInput
  id: Scalars['ID']
  /** the rule name */
  name: Scalars['String']
  /** eligible milestones themes */
  themes: Array<MilestoneTheme>
}

export type CreateMilestoneRuleResult = MilestoneRule | RecordAlreadyExistsError

export type CreateOfferInput = {
  availableTo: OfferAvailability
  expiresAt?: Maybe<Scalars['DateTime']>
  offerType: OfferType
  price: OfferPriceInput
}

export type CreateOfferResult = Offer

/** Input to create a new outside contribution checkout cart */
export type CreateOutsideContributionCheckoutCartInput = {
  /** Outside contribution code */
  code: Scalars['String']
  /** investment amount for the outside contribution */
  investmentAmount: Scalars['String']
}

/** Create Outside Contribution checkout cart response */
export type CreateOutsideContributionCheckoutCartResult =
  | ContributionAmountAboveThresholdError
  | ContributionAmountBelowThresholdError
  | OutsideContributionCheckoutCart

/** Input to create a new outside contribution */
export type CreateOutsideContributionInput = {
  /** The note from the outside contributor */
  note?: Maybe<Scalars['String']>
  /** The name from the note of the contributor */
  noteAuthor?: Maybe<Scalars['String']>
  /** Stripe payment_intent_id */
  paymentIntentId: Scalars['ID']
  /** Stripe payment_method_id */
  paymentMethodId: Scalars['ID']
  /** The last 4 digits of the debit card number */
  cardNumberLast4: Scalars['String']
  /** The outside contributor email address */
  contributorEmail: Scalars['String']
  /** The provider of the debit card ie visa, mastercard etc */
  cardProvider: Scalars['String']
  /** The first name of the outside contributor */
  contributorFirstName: Scalars['String']
  /** The last name of the outside contributor */
  contributorLastName: Scalars['String']
}

/** Create Outside Contribution mutation response */
export type CreateOutsideContributionResult =
  | ContributionActionRequiredError
  | ContributionCardDeclinedError
  | ContributionInvalidOwnerEmailError
  | OutsideContribution

export type CreatePinwheelLinkToken = {
  __typename?: 'CreatePinwheelLinkToken'
  /** Pinwheel Token expiration date/time */
  expires: Scalars['DateTime']
  /** UUID of the link token */
  id: Scalars['String']
  /** Pinwheel token Environment */
  mode: Scalars['String']
  /** Short lived token that is used to initialize Pinwheel Link */
  token: Scalars['String']
}

/** Attributes for a linked account created through Plaid Link */
export type CreatePlaidLinkedAccountInput = {
  /** Plaid link session id */
  linkSessionId: Scalars['String']
  /** Plaid's Financial Institution ID */
  externalInstitutionId?: Maybe<Scalars['String']>
  /** Should the related round up account be disabled */
  disableRoundUps?: Maybe<Scalars['Boolean']>
}

/** Input for creating a prospect user */
export type CreateProspectUserInput = {
  /** Email address of the prospect user */
  email: Scalars['String']
  /** Prospect Type */
  type: ProspectType
}

/** Create Prospect User Response */
export type CreateProspectUserResult =
  | GrowProspect
  | InternalErrorException
  | LaterWaitlistProspect
  | OutsideContributionProspect
  | User_V2

export type CreateSavingsAccountInput = {
  currentGoal?: Maybe<BankAccountGoalInput>
  type: SavingsAccountType
  isReopen?: Maybe<Scalars['Boolean']>
}

export type CreateSavingsAccountPayload = {
  __typename?: 'CreateSavingsAccountPayload'
  bankAccountId: Scalars['ID']
}

export type CreateSavingsAccountResult =
  | CreateSavingsAccountPayload
  | CreateSavingsAccountVerificationError

export type CreateSavingsAccountVerificationError = {
  __typename?: 'CreateSavingsAccountVerificationError'
  notEligibleReasons: Array<SavingsAccountEligibilityRequirement>
}

export type CreateSecurityQuestionInput = {
  id?: Maybe<Scalars['ID']>
  text: Scalars['String']
  order: Scalars['String']
}

export type CreateSubscriptionMigrationInput = {
  description: Scalars['String']
  effectiveAt: Scalars['DateTime']
  fromTierId: Scalars['ID']
  toTierId: Scalars['ID']
}

export type CreateSubscriptionMigrationResult = SubscriptionMigration

export type CreateSupportTicketInput = {
  category?: Maybe<Scalars['String']>
  dob: Scalars['String']
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  message: Scalars['String']
  phone: Scalars['String']
  recaptchaToken?: Maybe<Scalars['String']>
  subcategory?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
}

export type CreateSuspendedUserSupportTicketInput = {
  message: Scalars['String']
  subject: Scalars['String']
  tags?: Maybe<Array<Scalars['String']>>
}

/** Input for creating an upload url for direct to s3 upload */
export type CreateUploadUrlInput = {
  /** the user_id of the user uploading a document */
  userId: Scalars['String']
  /** the file_name upload document */
  fileName: Scalars['String']
  /** the document type of the upload document */
  documentType: DocumentType
}

/** CreateUploadUrlResult */
export type CreateUploadUrlResult = UploadUrl

export type CreateUserInput = {
  acceptanceDocumentVersionUuids: Array<Maybe<Scalars['String']>>
  authorizationAccessToken?: Maybe<Scalars['String']>
  authorizationExpiresAt?: Maybe<Scalars['DateTime']>
  authorizationProvider?: Maybe<Scalars['String']>
  authorizationRefreshToken?: Maybe<Scalars['String']>
  authorizationUid?: Maybe<Scalars['String']>
  captchaToken?: Maybe<Scalars['String']>
  clientCredentialsToken?: Maybe<Scalars['String']>
  codeGroup?: Maybe<Scalars['String']>
  email: Scalars['String']
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  invitationCode?: Maybe<Scalars['String']>
  password: Scalars['String']
  sourceAttributes?: Maybe<Scalars['JSON']>
  sourceId?: Maybe<Scalars['String']>
  udid: Scalars['String']
  usResident?: Maybe<Scalars['Boolean']>
  withBasicAccount?: Maybe<Scalars['Boolean']>
}

export type Credentials = {
  __typename?: 'Credentials'
  userId: Scalars['ID']
  email: Scalars['EmailAddress']
}

export enum CredentialStatus {
  /** The provided credentials were valid. */
  Valid = 'VALID',
  /** The provided credentials were invalid. */
  Invalid = 'INVALID',
  /** Waiting for a AuthenticateForFeeNegotiation mutation to begin the authorization process. */
  Pending = 'PENDING',
}

/** Credit information */
export type Credit = TimestampsInterface & {
  __typename?: 'Credit'
  amount: Scalars['Float']
  assessedAt?: Maybe<Scalars['String']>
  billingCycle: BillingCycle
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  discountId: Scalars['ID']
  id: Scalars['ID']
  state: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export type Cta = {
  __typename?: 'Cta'
  id: Scalars['ID']
  image?: Maybe<Image>
  title?: Maybe<Scalars['String']>
  type: CtaType
}

export type CtaDetails = {
  __typename?: 'CtaDetails'
  android?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  ios?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  web?: Maybe<Scalars['String']>
  buttonUrl?: Maybe<Scalars['String']>
  userMetadata?: Maybe<Scalars['String']>
  /** indicates whether clients should display and handle offer as an in-app experience */
  internallyRouted?: Maybe<Scalars['Boolean']>
}

export enum CtaType {
  Link = 'link',
  ProtectLink = 'protect_link',
  GrowArticle = 'grow_article',
  Video = 'video',
  Disclaimer = 'disclaimer',
  Action = 'action',
}

export enum Currency {
  Usd = 'USD',
}

export type CurrencyAmount = {
  __typename?: 'CurrencyAmount'
  currency: Currency
  value: Scalars['Float']
}

export type CurrencyAmountInput = {
  currency: Currency
  value: Scalars['Float']
}

export type CurrencyMilestoneProgress = {
  __typename?: 'CurrencyMilestoneProgress'
  /** the type of currency */
  currency: Currency
  /** the current value */
  currentAmount: Scalars['Float']
  /** the value needed for completion */
  targetAmount: Scalars['Float']
}

/** A bank statement showing ownership of the current funding source has not been provided */
export type CurrentBankStatementNotProvided = {
  __typename?: 'CurrentBankStatementNotProvided'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

export type CustodianAddressInput = {
  line1: Scalars['String']
  line2?: Maybe<Scalars['String']>
  city: Scalars['String']
  state: StateCode
  zipCode: Scalars['String']
  country: Scalars['String']
}

export type CustodianCompany = {
  __typename?: 'CustodianCompany'
  companyId: Scalars['String']
  name: Scalars['String']
}

/** Required acceptance documents for portfolio missing */
export type CustomerAgreementRequiredException = {
  __typename?: 'CustomerAgreementRequiredException'
  /** message */
  message?: Maybe<Scalars['String']>
  /** message */
  requiredAcceptanceDocumentTypes: Array<Scalars['String']>
}

export enum CustomerPeriod {
  Week = 'WEEK',
  Month = 'MONTH',
  Year = 'YEAR',
}

export type CustomFieldOption = {
  __typename?: 'CustomFieldOption'
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['String']>
  raw_name?: Maybe<Scalars['String']>
  default?: Maybe<Scalars['Boolean']>
  label?: Maybe<Scalars['String']>
}

export enum DayOfWeek {
  Sun = 'SUN',
  Mon = 'MON',
  Tue = 'TUE',
  Wed = 'WED',
  Thu = 'THU',
  Fri = 'FRI',
  Sat = 'SAT',
}

/** Response to a beneficiary ssn update */
export type DeactivateBeneficiaryResult =
  | Beneficiary
  | BeneficiaryNotFoundException
  | InternalErrorException

export type DeactivateSecurityFailed = {
  __typename?: 'DeactivateSecurityFailed'
  description: Scalars['String']
}

export type DeactivateSecurityInput = {
  symbol: Scalars['TickerSymbol']
}

export type DeactivateSecurityResult = Fund | Stock | DeactivateSecurityFailed

export type DeactivateTierSubscriptionInput = {
  feedback?: Maybe<Scalars['String']>
  subscriptionDeactivationReason: TierSubscriptionDeactivationReason
  userId: Scalars['ID']
}

export type DeactivateTierSubscriptionResult = TierSubscription | TierSubscriptionAlreadyDeactivated

export enum DealType {
  TapAndGet = 'TAP_AND_GET',
  SimplySpend = 'SIMPLY_SPEND',
  UniquePricePoint = 'UNIQUE_PRICE_POINT',
  VerifiedReferral = 'VERIFIED_REFERRAL',
  PartnerLink = 'PARTNER_LINK',
}

export type DeleteExpiredBankCardOrderCardTierNotFoundError = {
  __typename?: 'DeleteExpiredBankCardOrderCardTierNotFoundError'
  failureMessage: Scalars['String']
}

export type DeleteExpiredBankCardOrderNotExpiredError = {
  __typename?: 'DeleteExpiredBankCardOrderNotExpiredError'
  expiresAt: Scalars['DateTime']
}

export type DeleteExpiredBankCardOrderNotFoundError = {
  __typename?: 'DeleteExpiredBankCardOrderNotFoundError'
  userId: Scalars['ID']
}

export type DeleteExpiredBankCardOrderResult =
  | BankCardOrder
  | DeleteExpiredBankCardOrderNotFoundError
  | DeleteExpiredBankCardOrderNotExpiredError
  | DeleteExpiredBankCardOrderCardTierNotFoundError

export enum DepositField {
  AccountNumber = 'accountNumber',
  AccountHolderName = 'accountHolderName',
  InstitutionName = 'institutionName',
  CheckNumber = 'checkNumber',
  PayeeName = 'payeeName',
  CourtesyAmount = 'courtesyAmount',
  LegalAmount = 'legalAmount',
  FrontSignature = 'frontSignature',
  AuxOnUs = 'auxOnUs',
  Epc = 'epc',
  Routing = 'routing',
  OnUs = 'onUs',
  EncodedAmount = 'encodedAmount',
  Codeline = 'codeline',
  FractionCode = 'fractionCode',
  CheckDate = 'checkDate',
  BackEndorsement = 'backEndorsement',
  BackImage = 'backImage',
  FrontImage = 'frontImage',
  CustomerSuppliedAmount = 'customerSuppliedAmount',
  InstrumentType = 'instrumentType',
}

/** Represents a risk that could prevent the deposit from completing */
export type DepositRiskFactor = {
  __typename?: 'DepositRiskFactor'
  fields: Array<DepositField>
  /** Description of risk */
  description: Scalars['String']
  /**
   * Risk Statuses:
   *     fixable: fixable = true
   *     confirmable: confirmable = true
   *     hard_reject: fixable = false, confirmable = false, severity level reject
   */
  status: RiskStatus
}

export type DeregisterAuthenticatorInput = {
  id: Scalars['ID']
}

export type DeregisterAuthenticatorResult =
  | PhoneAuthenticator
  | EmailAuthenticator
  | AuthenticatorNotFoundException

export type DesignLibraryIcon = {
  __typename?: 'DesignLibraryIcon'
  /** icon type corresponding to a Design Library icon */
  icon: IconType
}

export type Destination = {
  __typename?: 'Destination'
  /** deep link to milestone action destination */
  deepLink: Scalars['URL']
  /** key that maps to client-defined destination label */
  labelKey: Scalars['StringKey']
}

export type Device = {
  __typename?: 'Device'
  id: Scalars['ID']
  lastLoginAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  userId: Scalars['ID']
  updatedAt: Scalars['DateTime']
  hasActiveSession?: Maybe<Scalars['Boolean']>
  isBlocked: Scalars['Boolean']
  firstLoginAt?: Maybe<Scalars['DateTime']>
  appVersion?: Maybe<Scalars['String']>
  userAgent?: Maybe<Scalars['String']>
  blockTrigger?: Maybe<Scalars['String']>
}

export type DeviceBlockedException = {
  __typename?: 'DeviceBlockedException'
  message?: Maybe<Scalars['String']>
}

export type DeviceNotFoundException = {
  __typename?: 'DeviceNotFoundException'
  message?: Maybe<Scalars['String']>
}

export enum DirectDepositDistribution {
  /** Entire Paycheck */
  FullAmount = 'FULL_AMOUNT',
  /** Amount of Paycheck */
  FixedAmount = 'FIXED_AMOUNT',
  /** Percentage of Paycheck */
  PercentageAmount = 'PERCENTAGE_AMOUNT',
}

/** Describes a user state for all its direct deposit switches. */
export type DirectDepositState = {
  __typename?: 'DirectDepositState'
  /** Creation Date */
  createdAt?: Maybe<Scalars['DateTime']>
  /** Switch Method */
  switchMethod: SwitchMethod
  /** Switch State */
  switchState: SwitchState
  /** Last Updated Date */
  updatedAt?: Maybe<Scalars['DateTime']>
}

/** Direct Deposit User State */
export type DirectDepositStatePayload = {
  __typename?: 'DirectDepositStatePayload'
  /** Direct Deposit State */
  state?: Maybe<DirectDepositState>
}

export enum DirectDepositVendor {
  Pinwheel = 'Pinwheel',
}

/** legal disclaimer */
export type Disclaimer = {
  __typename?: 'Disclaimer'
  /** body text */
  body: Scalars['String']
  /** call to action */
  cta?: Maybe<Cta>
  /** disclaimer image */
  image?: Maybe<Image>
  /** title text */
  title?: Maybe<Scalars['String']>
}

export type DiscreteMilestoneProgress = {
  __typename?: 'DiscreteMilestoneProgress'
  /** the current value */
  currentInt: Scalars['Int']
  /** the value needed for completion */
  targetInt: Scalars['Int']
}

export type DismissMessageInput = {
  messageId: Scalars['ID']
}

export type DistributionAmounts = {
  __typename?: 'DistributionAmounts'
  investment: Scalars['String']
  retirement: Scalars['String']
  savings: Scalars['String']
}

export enum DistributionType {
  LongTerm = 'LONG_TERM',
  LongWeighted = 'LONG_WEIGHTED',
  Balanced = 'BALANCED',
  MediumWeighted = 'MEDIUM_WEIGHTED',
  MediumTerm = 'MEDIUM_TERM',
}

export type Dividend = {
  __typename?: 'Dividend'
  symbol: Scalars['TickerSymbol']
  /** The Dividend Execution Date (Ex Date) - This date will typically be one business day prior to the Record Date. */
  executionDate?: Maybe<Scalars['Date']>
  /** Dividend Payment Date - This is the date that the stock dividend will be paid. */
  payableDate?: Maybe<Scalars['Date']>
  /** Dividend Record Date - To receive a "cash" dividend you must own the stock on the Record Date. */
  recordDate?: Maybe<Scalars['Date']>
  /** Dividend amount per share */
  amountPerShare?: Maybe<Scalars['BigDecimal']>
  /** Dividend payout frequency */
  frequency: DividendFrequency
}

export enum DividendFrequency {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Irregularly = 'IRREGULARLY',
  Unspecified = 'UNSPECIFIED',
  OtherRegular = 'OTHER_REGULAR',
}

export type DividendsBySymbolInput = {
  symbol: Scalars['TickerSymbol']
  /** Filter to select dividends with executionDate on or after the executionStartDate */
  executionStartDate?: Maybe<Scalars['Date']>
  /** Filter to select dividends with executionDate before or on the executionEndDate */
  executionEndDate?: Maybe<Scalars['Date']>
}

export type Document = {
  __typename?: 'Document'
  uploadedAt: Scalars['DateTime']
  url: Scalars['URL']
}

export type DocumentInput = {
  uploadedAt: Scalars['DateTime']
  url: Scalars['URL']
}

/** No document for the given document_type and version */
export type DocumentNotFound = {
  __typename?: 'DocumentNotFound'
  /** The type of document to sign */
  documentType: AcceptanceDocumentType
  /** The version of the document to sign */
  documentVersion: Scalars['String']
}

export enum DocumentQueryType {
  Address = 'address',
  All = 'all',
  BeneficiarySsn = 'beneficiarySsn',
  CurrentBankStatement = 'currentBankStatement',
  SpendFundingSource = 'spendFundingSource',
  TraditionalFundingSource = 'traditionalFundingSource',
  PaypalFundingSource = 'paypalFundingSource',
  EarlyQuarantinePromotion = 'earlyQuarantinePromotion',
  FutureBankStatement = 'futureBankStatement',
  Id = 'id',
  Miscellaneous = 'miscellaneous',
  SpendAddress = 'spendAddress',
  SpendId = 'spendId',
  Ssn = 'ssn',
  W9 = 'w9',
  MilitaryId = 'militaryId',
  BulkSuspendCsv = 'bulkSuspendCsv',
}

export type DocumentRequest = {
  __typename?: 'DocumentRequest'
  acceptedAt?: Maybe<Scalars['DateTime']>
  canceledAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  documents?: Maybe<Array<Document>>
  documentType: DocumentType
  externalId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  parentRequest?: Maybe<DocumentRequest>
  parentRequestId?: Maybe<Scalars['ID']>
  rejectedAt?: Maybe<Scalars['DateTime']>
  rejectedNote?: Maybe<Scalars['String']>
  rejectedReason?: Maybe<RejectedReason>
  requestedFileCount?: Maybe<Scalars['Int']>
  requesterId?: Maybe<Scalars['ID']>
  /** Idempotency key for ensuring that duplicate requests are not made or to store additional data */
  requestKey?: Maybe<Scalars['String']>
  reviewerId?: Maybe<Scalars['String']>
  status: DocumentStatus
  userId: Scalars['ID']
}

export type DocumentRequestEdge = {
  __typename?: 'DocumentRequestEdge'
  node?: Maybe<DocumentRequest>
}

export type DocumentRequestInput = {
  documentRequestId: Scalars['ID']
}

export type DocumentRequestsConnection = {
  __typename?: 'DocumentRequestsConnection'
  edges?: Maybe<Array<DocumentRequestEdge>>
  pageInfo: DocumentRequestsPageInfo
}

export type DocumentRequestsInput = {
  pageInput?: Maybe<DocumentRequestsPageInput>
  status?: Maybe<DocumentStatus>
  type: DocumentQueryType
  /** Deprecated: use `status` field */
  uploaded?: Maybe<Scalars['Boolean']>
}

export type DocumentRequestsPageInfo = {
  __typename?: 'DocumentRequestsPageInfo'
  hasNext: Scalars['Boolean']
  cursor?: Maybe<Scalars['String']>
}

export type DocumentRequestsPageInput = {
  ascending?: Maybe<Scalars['Boolean']>
  limit?: Maybe<Scalars['Int']>
  cursor?: Maybe<Scalars['String']>
}

export enum DocumentStatus {
  Accepted = 'accepted',
  Canceled = 'canceled',
  Rejected = 'rejected',
  Requested = 'requested',
  Uploaded = 'uploaded',
}

export enum DocumentType {
  Address = 'address',
  BeneficiarySsn = 'beneficiarySsn',
  CurrentBankStatement = 'currentBankStatement',
  SpendFundingSource = 'spendFundingSource',
  TraditionalFundingSource = 'traditionalFundingSource',
  PaypalFundingSource = 'paypalFundingSource',
  EarlyQuarantinePromotion = 'earlyQuarantinePromotion',
  FutureBankStatement = 'futureBankStatement',
  Id = 'id',
  Miscellaneous = 'miscellaneous',
  SpendAddress = 'spendAddress',
  SpendId = 'spendId',
  Ssn = 'ssn',
  W9 = 'w9',
  MilitaryId = 'militaryId',
  BulkSuspendCsv = 'bulkSuspendCsv',
}

/** Uploads from backend */
export type DocumentUploads = {
  __typename?: 'DocumentUploads'
  uploadDocuments: Array<LegacyUploadDocument>
}

export type DuplicateActionError = {
  __typename?: 'DuplicateActionError'
  requestId: Scalars['ID']
}

/** State Laws Regarding UGMA/UTMA account types and termination ages */
export type EarlyAccountStateRegulation = {
  __typename?: 'EarlyAccountStateRegulation'
  /** Whether UGMA/UTMA account is offered in the given state */
  accountType: EarlyInvestmentAccountType
  /** Default age of termination for the given state */
  defaultAge: Scalars['Int']
  /** Maximum age of termination for the given state */
  maxAge?: Maybe<Scalars['Int']>
  /** Minimum age of termination for the given state */
  minAge?: Maybe<Scalars['Int']>
  /** Full State/Territory name */
  state: Scalars['String']
  /** State/Territory abbreviation */
  stateCode: Scalars['String']
}

/** Result for Early Account state regulations */
export type EarlyAccountStateRegulationResult =
  | EarlyAccountStateRegulation
  | InternalErrorException
  | InvalidStateException
  | UserNotFoundException

/** DEPRECATED - Use InvestmentAccountTransferability instead */
export type EarlyAccountTransferInfo = {
  __typename?: 'EarlyAccountTransferInfo'
  /** The beneficiary investment account's state of residence */
  stateCode: Scalars['String']
  /** The beneficiary investment account's age of transfer */
  terminationAge: Scalars['Int']
  /** The beneficiary investment account's date of transfer */
  terminationDate: Scalars['Date']
}

export type EarlyDividendsItem = PastItem &
  PastCoreTradedItem &
  PastEarlyItem & {
    __typename?: 'EarlyDividendsItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    beneficiaryAccountId: Scalars['String']
    etfCategory: Scalars['String']
    etfTicker: Scalars['String']
  }

/** Sell shares for the fee. */
export type EarlyFeeInvestmentItem = PastItem &
  PastCoreTradedItem &
  PastEarlyItem & {
    __typename?: 'EarlyFeeInvestmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    beneficiaryAccountId: Scalars['String']
  }

/** A gift investment line item for the Early account */
export type EarlyGiftItem = PastItem &
  PastCoreTradedItem &
  PastAnnotatedItem &
  PastEarlyItem & {
    __typename?: 'EarlyGiftItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    /** Annotation on the item */
    note?: Maybe<Scalars['String']>
    /** Author of the note */
    noteAuthor?: Maybe<Scalars['String']>
    beneficiaryAccountId: Scalars['String']
  }

export enum EarlyInvestmentAccountType {
  /** Uniform Gift to Minors Act Custodial Investment Account */
  Ugma = 'UGMA',
  /** Uniform Transfer to Minors Act Custodial Investment Account */
  Utma = 'UTMA',
}

/** A generic money movement line item for the Early account */
export type EarlyInvestmentItem = PastItem &
  PastCoreTradedItem &
  PastUserTransferItem &
  PastEarlyItem & {
    __typename?: 'EarlyInvestmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount?: Maybe<CurrencyAmount>
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate?: Maybe<Scalars['DateTime']>
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring?: Maybe<Scalars['Boolean']>
    beneficiaryAccountId: Scalars['String']
  }

export type EarlyWithdrawalItem = PastItem &
  PastCoreTradedItem &
  PastUserTransferItem &
  PastEarlyItem & {
    __typename?: 'EarlyWithdrawalItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate?: Maybe<Scalars['DateTime']>
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring?: Maybe<Scalars['Boolean']>
    beneficiaryAccountId: Scalars['String']
  }

export type EarnCtaRecord = {
  __typename?: 'EarnCTARecord'
  userId: Scalars['ID']
  partnerName?: Maybe<Scalars['String']>
  ctaDates?: Maybe<Array<Maybe<Scalars['Date']>>>
  devicePlatform?: Maybe<Scalars['String']>
}

export type EarnOffer = {
  __typename?: 'EarnOffer'
  /** The list of applicable categories for affiliates */
  affiliateCategoryList?: Maybe<Array<Scalars['String']>>
  /** Whether affiliateCategoryList is inclusionary or exclusionary  */
  affiliateCategoryType?: Maybe<Scalars['String']>
  /** For use with colorBackgroundLogoImageUrl */
  backgroundColorHex: Scalars['String']
  /** Non-logo background image */
  backgroundImageUrl: Scalars['URL']
  /** Offer's Badge Category */
  badgeCategory?: Maybe<BadgeCategory>
  /** Long description of what is needed to qualify for offer */
  campaignDescription: Scalars['String']
  campaignId: Scalars['ID']
  campaignOfferId: Scalars['ID']
  /** Transparent logo used with backgroundColorHex overlaid on background */
  colorBackgroundLogoImageUrl: Scalars['URL']
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  colorImageUrl: Scalars['URL']
  ctaDetails: EarnOfferCtaDetails
  /** Offer's Deal Type */
  dealType?: Maybe<DealType>
  /** Desktop Background/featured image url */
  desktopBackgroundImageUrl?: Maybe<Scalars['URL']>
  /** Offer Details Information */
  details: Array<Scalars['String']>
  /** List of device platforms the campaign offer is eligible for */
  devicePlatforms: Array<Scalars['String']>
  /** The main campaign text used image overlay text */
  displayBody?: Maybe<Scalars['String']>
  /** The ending date of a campaign */
  displayEndDate?: Maybe<Scalars['String']>
  /** The main campaign name used on tiles and on details */
  displayName: Scalars['String']
  /** The starting date of a campaign */
  displayStartDate?: Maybe<Scalars['String']>
  /** Summary of qualification, e.g. "For new customers only" */
  displaySubtitle?: Maybe<Scalars['String']>
  /** Display Title for the amount invested, e.g. "Earn 2%" or "Earn $10" */
  displayTitle: Scalars['String']
  /** Offer Exclusion Information */
  exclusions: Array<Scalars['String']>
  /** Denotes the favorite order rank by most recently added */
  favoriteRank: Scalars['Int']
  /** Used for the banner on the categories page */
  featuredCategoryOffer: Scalars['Boolean']
  /** Used for the banner on the categories page */
  featuredCategoryOfferRank: Scalars['Int']
  /** Amount invested, e.g. "2%" or "$10" */
  incentiveSummary: Scalars['String']
  /** Denotes a favorite offer for the current user */
  isFavorite: Scalars['Boolean']
  /** Offer's Keyphrase Categories Names */
  keyphraseCategoryNames?: Maybe<Array<Scalars['String']>>
  /** External merchantId associated with owner */
  merchantId?: Maybe<Scalars['String']>
  /** Description of the brand */
  ownerDescription: Scalars['String']
  ownerId: Scalars['ID']
  /** Used for the banner on web */
  promoted: Scalars['Boolean']
  /** Used for the banner on web */
  promotionRank: Scalars['Int']
  /** Identifying slug on the owner level */
  slug: Scalars['String']
  termsAndConditionsUrl: Scalars['String']
  /** The ending time for a campaign */
  visibilityEndTime?: Maybe<Scalars['String']>
  /** The starting time for a campaign */
  visibilityStartTime?: Maybe<Scalars['String']>
  /** Manages how we launch offers on mobile */
  webviewEnabled: Scalars['Boolean']
}

export type EarnOfferCtaDetails = {
  __typename?: 'EarnOfferCtaDetails'
  android?: Maybe<Scalars['String']>
  buttonUrl?: Maybe<Scalars['String']>
  chromeExt?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  internallyRouted: Scalars['Boolean']
  ios?: Maybe<Scalars['String']>
  notificationTitle: Scalars['String']
  notificationUrl: Scalars['URL']
  repeatTitle: Scalars['String']
  title: Scalars['String']
  type: Scalars['String']
  userMetadata?: Maybe<Scalars['String']>
  web?: Maybe<Scalars['String']>
}

export type EarnOfferQueryPage = {
  __typename?: 'EarnOfferQueryPage'
  earnOffers: Array<EarnOffer>
  pageInfo: EarnPageInfo
}

export type EarnPageInfo = {
  __typename?: 'EarnPageInfo'
  /**
   * This value is passed back as the 'cursor' parameter to continue pagination.
   * An empty string indicates there are no more pages to fetch.
   */
  endCursor: Scalars['String']
}

export type EditSecurityQuestionInput = {
  id: Scalars['ID']
  text?: Maybe<Scalars['String']>
  isDeleted?: Maybe<Scalars['Boolean']>
  order?: Maybe<Scalars['String']>
}

export type EditSecurityQuestionResult = SecurityQuestion | InvalidSecurityQuestionException

export type Education = {
  __typename?: 'Education'
  articles: Array<Article>
}

export type EducationSection = {
  __typename?: 'EducationSection'
  body: Scalars['String']
  title: Scalars['String']
}

export type EducationTip = {
  __typename?: 'EducationTip'
  /** key that maps to client-defined education tip details */
  detailsKey: Scalars['StringKey']
  /** key that maps to client-defined education tip summary */
  summaryKey: Scalars['StringKey']
}

export type Eligibility = {
  __typename?: 'Eligibility'
  eligible: Scalars['Boolean']
}

export enum EligibilityScope {
  Spend = 'spend',
  RoundUps = 'roundUps',
  Mrdc = 'mrdc',
  FundSpendInActivation = 'fundSpendInActivation',
  SendCheck = 'sendCheck',
  PersonalizedFoundMoneyOnPresent = 'personalizedFoundMoneyOnPresent',
  SpendRecurringTransfers = 'spendRecurringTransfers',
}

export type EmailAddressValidation = {
  __typename?: 'EmailAddressValidation'
  /** The email that is being validated */
  email: Scalars['EmailAddress']
  /**
   * Soft check indicating wether or not a DNS MX record exists for the address
   * domain (does not validate that an email can actually be delivered to the email server).
   */
  deliverable: Scalars['Boolean']
  /** Wether or not credentials are associated with the address or not. */
  credentialsExist: Scalars['Boolean']
  /** Indicates wether the address may have common spelling mistakes. */
  possibleTypo: Scalars['Boolean']
  /** Suggestion for corrected address if there was a typo detected. */
  suggestion?: Maybe<Scalars['EmailAddress']>
}

export type EmailAuthChallenge = AuthChallenge & {
  __typename?: 'EmailAuthChallenge'
  id: Scalars['ID']
  maskedEmail: Scalars['String']
  alternateAuthenticators: Array<AuthenticatorInfo>
}

export type EmailAuthenticator = Authenticator & {
  __typename?: 'EmailAuthenticator'
  id: Scalars['ID']
  name: Scalars['String']
  lastUsedAt?: Maybe<Scalars['DateTime']>
  email: Scalars['EmailAddress']
  deviceId: Scalars['ID']
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
}

export type EmailTakenException = {
  __typename?: 'EmailTakenException'
  message?: Maybe<Scalars['String']>
}

export enum Employees {
  /** User has no employees under their company */
  None = 'none',
  /** User has full or part time employees under their company */
  FullOrPart = 'fullOrPart',
}

/** Employer */
export type Employer = {
  __typename?: 'Employer'
  /**
   * Clickswitch Target ID
   * @deprecated Use SwitchInterface.vendorTargetId instead
   */
  clickSwitchTargetId?: Maybe<Scalars['ID']>
  /** DUNS Name */
  dunsName?: Maybe<Scalars['String']>
  /** Duns Number */
  dunsNumber?: Maybe<Scalars['ID']>
  /** Employer Name */
  employerName: Scalars['String']
  /** Employer ID */
  id: Scalars['ID']
  /** Employer Logo URL */
  logoUrl?: Maybe<Scalars['String']>
  /** Switch Type specific information. */
  switch: AbstractSwitch
  /** Switch Type */
  switchType: SwitchType
  /**
   * Employer URL
   * @deprecated Use OnlineSwitch.url instead
   */
  url?: Maybe<Scalars['String']>
}

export type EmploymentInput = {
  employer?: Maybe<Scalars['String']>
  occupation?: Maybe<Scalars['String']>
  suitability?: Maybe<Array<Maybe<SuitabilityInput>>>
}

export enum EmploymentStatus {
  /** User is a full time employee or contractor */
  FullTime = 'fullTime',
  /** User owns their own business or is self employed */
  SelfEmployed = 'selfEmployed',
  /** User is a part time employee or contractor */
  PartTime = 'partTime',
  /** User is enrolled full time in school */
  Student = 'student',
  /** User currently is not employed */
  Unemployed = 'unemployed',
  /** User is retired and does not work */
  Retired = 'retired',
}

/** Configuration for investment account quarterly recaps. */
export type EnableQuarterlyRecapsInput = {
  /** The unique identifier of the investment account for which to configure quarterly recaps. */
  investmentAccountId: Scalars['ID']
  /** Wether or not to enable quarterly recaps. */
  enabled: Scalars['Boolean']
}

/** Result of configuring investment account recaps. */
export type EnableQuarterlyRecapsResult =
  | InvalidSubscriptionTierException
  | InvestmentAccount
  | InvestmentAccountNotFoundException
  | InvestmentAccountNotSupportedException

export type EstimatedCheckPaymentDates = {
  __typename?: 'EstimatedCheckPaymentDates'
  estimatedTransferAtText: Scalars['String']
  estimatedShippingAt: Scalars['DateTime']
  estimatedArrivalAt: Scalars['DateTime']
}

/** Input to get estimated dates for a transfer */
export type EstimatedTransferDatesInput = {
  /** Type of account to move money from */
  fromAccountType: TransferableAccountTypeEnum
  /** Type of account to move money into */
  toAccountType: TransferableAccountTypeEnum
  /** UTC datetime when the transfer was/will be created. If omitted, the current datetime will be used */
  transferCreatedAt?: Maybe<Scalars['DateTime']>
}

/** Estimated dates for a transfer */
export type EstimatedTransferDatesPayload = {
  __typename?: 'EstimatedTransferDatesPayload'
  /** Estimated UTC datetime when the transfer will be completed by */
  estimatedTransferCompletedAt: Scalars['DateTime']
}

/** DEPRECATED - Use Security type instead */
export type Etf = {
  __typename?: 'ETF'
  /** Indicates the amount of every dollar that will go towards buying a share of the ETF */
  amount?: Maybe<Scalars['Int']>
  /** ETF high price over trailing 12 month period */
  annualHigh?: Maybe<Scalars['Float']>
  /** ETF low price over trailing 12 month period */
  annualLow?: Maybe<Scalars['Float']>
  /** Indicates the current per/share price */
  currentPrice?: Maybe<Scalars['Float']>
  /** The Acorns-designated display name of the ETF */
  displayName: Scalars['String']
  /** Indicates the individual stocks that make up the ETF */
  holdings?: Maybe<Array<Holding>>
  /** Indicates the investment category for the ETF */
  investmentCategories: InvestmentCategory
  /** Indicates the last market day's close per/share price */
  lastClosePrice?: Maybe<Scalars['Float']>
  /** The Acorns-designated name of the ETF */
  name: Scalars['String']
  /** Indicates the total worth of the ETF as a whole */
  netAssets?: Maybe<Scalars['String']>
  /** Indicates the day's open per/share price */
  openPrice?: Maybe<Scalars['Float']>
  /** Indicates the number of shares the user owns */
  ownedShares?: Maybe<Scalars['Float']>
  /** Indicates the percent of every dollar that will go towards buying a share of the ETF */
  percent?: Maybe<Scalars['Float']>
  /** Get price values of the ETF over a time range */
  performance: EtfPerformance
  /** Indicates the position of the ETF */
  position?: Maybe<Scalars['Int']>
  /** Indicates the per/share price range over the current week */
  priceRangeOverWeek?: Maybe<Scalars['String']>
  /** Indicates whether or not the ETF can be removed from a managed Portfolio by direction of an account holder. */
  removable?: Maybe<Scalars['Boolean']>
  /** The market exchange symbol of the ETF */
  symbol: Scalars['String']
  /** Indicates the total number of shares in the market */
  volume?: Maybe<Scalars['Int']>
  /** Indicates the year-to-date return of the ETF */
  ytdReturn?: Maybe<Scalars['Float']>
  /** Indicates the year-to-date return percentage of the ETF */
  ytdReturnPercentage?: Maybe<Scalars['Float']>
}

/** DEPRECATED - Use Security type instead */
export type EtfPerformanceArgs = {
  timescale: EtfTimescale
  timespan: Scalars['Int']
  points?: Maybe<Scalars['Int']>
}

/** Amount and Percentage of ETF Gain */
export type EtfGain = {
  __typename?: 'ETFGain'
  amount: Scalars['Float']
  percentage: Scalars['Float']
}

/** Gain and Prices of ETF */
export type EtfPerformance = {
  __typename?: 'ETFPerformance'
  gain?: Maybe<EtfGain>
  prices?: Maybe<Array<EtfPrice>>
}

/** Price of ETF */
export type EtfPrice = {
  __typename?: 'ETFPrice'
  amount: Scalars['Float']
  timestamp: Scalars['DateTime']
}

export enum EtfTimescale {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
}

/** Evaluates check deposit session to determine if it is submittable. */
export type EvaluateCheckDepositInput = {
  amount: CurrencyAmountInput
  /** The session to evaluate. */
  sessionToken: Scalars['String']
}

/** Evaluates if a check can be submitted. */
export type EvaluateCheckDepositPayload = {
  __typename?: 'EvaluateCheckDepositPayload'
  /** Recognized amount from check image. */
  ocrAmount: CurrencyAmount
  riskFactors: Array<DepositRiskFactor>
}

export type ExistingEmailVerifiedException = {
  __typename?: 'ExistingEmailVerifiedException'
  message?: Maybe<Scalars['String']>
}

export type ExistingPhoneVerifiedException = {
  __typename?: 'ExistingPhoneVerifiedException'
  message?: Maybe<Scalars['String']>
}

/** A reopen request for this investment account already exists and is pending review */
export type ExistingRequestPendingReview = {
  __typename?: 'ExistingRequestPendingReview'
  /** Reopen request for investment account */
  reopenRequest: InvestmentAccountReopenRequest
}

/** A reopen request for this investment account already exists and is pending user action */
export type ExistingRequestPendingUserAction = {
  __typename?: 'ExistingRequestPendingUserAction'
  /** Reopen request for investment account */
  reopenRequest: InvestmentAccountReopenRequest
}

/** Expanded view that includes the recommended coverage breakdown */
export type ExpandedLifeRecommendation = {
  __typename?: 'ExpandedLifeRecommendation'
  coverageBreakdown: LifeCoverageBreakdown
  cta: Cta
  title: Scalars['String']
}

/** The content that supports and drives the user experience */
export type ExperienceContent = {
  __typename?: 'ExperienceContent'
  /** JSON Content for rendering the referrer experience */
  rawContent: Scalars['String']
  /** Campaign ID for the referrer's active campaign */
  campaignId: Scalars['ID']
}

export type ExploreCarousel = {
  __typename?: 'ExploreCarousel'
  title: Scalars['String']
  widgets: Array<InsuranceSection>
}

export type ExtensionCampaign = {
  __typename?: 'ExtensionCampaign'
  id: Scalars['ID']
  name: Scalars['String']
  displayTitle?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  backgroundImage?: Maybe<ExtensionCampaignBackgroundImage>
  backgroundImageUrl?: Maybe<Scalars['URL']>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaTitle?: Maybe<Scalars['String']>
  ctaDetails: ExtensionCampaignCtaDetails
  stores?: Maybe<Array<Maybe<ExtensionCampaignStore>>>
  rank?: Maybe<Scalars['Int']>
  termsAndConditionsUrl?: Maybe<Scalars['String']>
  incentiveSummary?: Maybe<Scalars['String']>
  displayEndDate?: Maybe<Scalars['DateTime']>
}

export type ExtensionCampaignBackgroundImage = {
  __typename?: 'ExtensionCampaignBackgroundImage'
  url?: Maybe<Scalars['String']>
  horizontalFocalPoint?: Maybe<Scalars['String']>
  verticalFocalPoint?: Maybe<Scalars['String']>
}

export type ExtensionCampaignCtaDetails = {
  __typename?: 'ExtensionCampaignCtaDetails'
  type?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  repeatTitle?: Maybe<Scalars['String']>
  notificationTitle?: Maybe<Scalars['String']>
  chromeExt?: Maybe<Scalars['URL']>
  userAttribution?: Maybe<Scalars['String']>
  notificationUrl?: Maybe<Scalars['URL']>
}

export type ExtensionCampaignStore = {
  __typename?: 'ExtensionCampaignStore'
  id?: Maybe<Scalars['ID']>
  domain: Scalars['URL']
  enabled: Scalars['Boolean']
  checkoutMatchType: Scalars['String']
  checkoutMatchRegex: Scalars['String']
  checkoutTotalAmountSelector?: Maybe<Scalars['String']>
  conversionMatchType: Scalars['String']
  conversionMatchRegex: Scalars['String']
  conversionTotalAmountSelector?: Maybe<Scalars['String']>
}

export type ExtensionOwner = {
  __typename?: 'ExtensionOwner'
  id: Scalars['ID']
  name: Scalars['String']
  slug: Scalars['String']
  imageUrl?: Maybe<Scalars['URL']>
  description?: Maybe<Scalars['String']>
  monochromeImageUrl?: Maybe<Scalars['URL']>
  colorBackgroundLogoImageUrl?: Maybe<Scalars['URL']>
  greyLogoImageUrl?: Maybe<Scalars['URL']>
  twitterHandle?: Maybe<Scalars['String']>
  campaigns?: Maybe<Array<Maybe<ExtensionCampaign>>>
}

export type ExtensionRewardsSummary = {
  __typename?: 'ExtensionRewardsSummary'
  totalRewardsDollarValue: RewardSummary
  totalPendingRewardsDollarValue: RewardSummary
  totalFulfilledRewardsDollarValue: RewardSummary
}

export type ExtensionTransaction = {
  __typename?: 'ExtensionTransaction'
  id: Scalars['ID']
  campaignId?: Maybe<Scalars['ID']>
  salesAmount?: Maybe<Scalars['Float']>
  status?: Maybe<Scalars['String']>
  createdAt: Scalars['String']
  activatedAt?: Maybe<Scalars['String']>
  convertedAt?: Maybe<Scalars['String']>
  confirmedAt?: Maybe<Scalars['String']>
  lockedAt?: Maybe<Scalars['String']>
  userUuid?: Maybe<Scalars['ID']>
}

export enum ExternalSource {
  Plaid = 'plaid',
  Spend = 'spend',
  Paypal = 'paypal',
  Manual = 'manual',
  DirectBank = 'direct_bank',
}

export type FavoritePartnerOfferGroup = {
  __typename?: 'FavoritePartnerOfferGroup'
  /** list of offers in the favorite group */
  offers: Array<PartnerOfferGroupItem>
}

/** Used to customize favorite offer group contents */
export type FavoritePartnerOfferInput = {
  ids: Array<Scalars['String']>
}

export type FeaturedLearnContentPreview = LearnArticlePreview | LearnMediaPreview

export type FeaturedMilestones = {
  __typename?: 'FeaturedMilestones'
  /** list of featured milestones to show on widget */
  milestones: Array<Milestone>
}

export type FeaturedMilestonesV2 = AccountSetupMilestones | FeaturedMilestones

export type FeaturedOffer = {
  __typename?: 'FeaturedOffer'
  campaignId: Scalars['ID']
  cta: Cta
  fastQuote: Scalars['Boolean']
  image?: Maybe<Image>
  logo: Image
  offerId: Scalars['ID']
  ownerId: Scalars['ID']
  subtitle?: Maybe<Scalars['String']>
  tip?: Maybe<Scalars['String']>
  title: Scalars['String']
}

export type FeaturedOffers = {
  __typename?: 'FeaturedOffers'
  body?: Maybe<Scalars['String']>
  offers: Array<FeaturedOffer>
  title: Scalars['String']
}

/** Fee information */
export type Fee = TimestampsInterface & {
  __typename?: 'Fee'
  accountId?: Maybe<Scalars['ID']>
  amount: Scalars['Float']
  assessedAt?: Maybe<Scalars['String']>
  balance?: Maybe<Scalars['Float']>
  billingCycle: BillingCycle
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  discount?: Maybe<Scalars['Float']>
  discountedAmount?: Maybe<Scalars['Float']>
  feeCategoryId: Scalars['String']
  feeExecutions: Array<Maybe<FeeExecution>>
  feeType: FeeType
  id: Scalars['ID']
  state: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId?: Maybe<Scalars['ID']>
}

export enum FeedContext {
  /** a3 core */
  A3Core = 'a3_core',
  /** a3 present */
  A3Present = 'a3_present',
  /** a3 spend */
  A3Spend = 'a3_spend',
  /** a3 later */
  A3Later = 'a3_later',
  /** a3 present_later */
  A3PresentLater = 'a3_present_later',
  /** a3 present_spend */
  A3PresentSpend = 'a3_present_spend',
  /** a4 invest */
  A4Invest = 'a4_invest',
  /** a4 home/present */
  A4Home = 'a4_home',
  /** a4 home bottom nav */
  A4HomeBottomNav = 'a4_home_bottom_nav',
  /** a4 spend */
  A4Spend = 'a4_spend',
  /** a4 later */
  A4Later = 'a4_later',
  /** a4 early */
  A4Early = 'a4_early',
  /** a4 early details */
  A4EarlyDetails = 'a4_early_details',
  /** a4 savings */
  A4Savings = 'a4_savings',
  /** a4 checking hub */
  A4CheckingHub = 'a4_checking_hub',
  /** a4 banking hub */
  A4BankingHub = 'a4_banking_hub',
  /** invest hub */
  A4InvestHub = 'a4_invest_hub',
  /** a4 checking engagement wizard */
  A4CheckingEngagementWizard = 'a4_checking_engagement_wizard',
}

/** Fee execution information */
export type FeeExecution = TimestampsInterface & {
  __typename?: 'FeeExecution'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  executionMethod: Scalars['String']
  externalId?: Maybe<Scalars['ID']>
  fundingAccountId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  reason?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export enum FeeExecutionMethod {
  /** Executed fee by direct ACH */
  Direct = 'DIRECT',
  /** Executed fee by selling shares */
  LiquidateSecurities = 'LIQUIDATE_SECURITIES',
  /** Waived fee execution */
  Waive = 'WAIVE',
  /** Skipped fee execution */
  Skip = 'SKIP',
  /** Executed by direct ACH from Spend funding source */
  SpendDirect = 'SPEND_DIRECT',
  /** Pre-emptively failed execution due to a known failure reason */
  PreemptiveFailure = 'PREEMPTIVE_FAILURE',
}

export type FeeNegotiation = {
  __typename?: 'FeeNegotiation'
  /** The ID of the associated bank connection. */
  connection: BankConnection
  /** The date the negotiation submission was created. Ex: 'Tue, 29 Dec 2020 04:16:41 GMT' */
  created: Scalars['DateTime']
  /** A uinique identifier for this submission: 'Chase Bank_1609215401.1132371'  */
  id: Scalars['ID']
  /** The internal status for this negotaition submission. */
  internalStatus?: Maybe<BankFeeNegotiationStatus>
  /** The gql status for this negotaition submission. */
  status?: Maybe<BankFeeNegotiationGqlStatus>
  /** The date this submission was last edited. Ex: 'Fri, 22 Jan 2021 03:25:33 GMT' */
  updated: Scalars['DateTime']
  /** The fee type string. Ex: 'Overdraft fees' */
  feeSynopsis?: Maybe<Scalars['String']>
  /** The total amount of fees which are being negotiated */
  negotiatedAmount?: Maybe<MonetaryAmount>
  /** The total amount of fees which has been refunded */
  refundAmount?: Maybe<MonetaryAmount>
}

export type FeeNegotiationOutput = {
  __typename?: 'FeeNegotiationOutput'
  negotiations?: Maybe<Array<FeeNegotiation>>
  summary?: Maybe<BankFeeNegotiationResults>
}

export enum FeeStatus {
  Negotiable = 'NEGOTIABLE',
  Processing = 'PROCESSING',
  Negotiated = 'NEGOTIATED',
  Unnegotiable = 'UNNEGOTIABLE',
}

export enum FeeStatusFilter {
  Negotiable = 'NEGOTIABLE',
  Processing = 'PROCESSING',
  Negotiated = 'NEGOTIATED',
  Unnegotiable = 'UNNEGOTIABLE',
}

export type FeeStatusSummary = {
  __typename?: 'FeeStatusSummary'
  total: Scalars['Int']
  negotiable: Scalars['Int']
  processing: Scalars['Int']
  negotiated: Scalars['Int']
  unnegotiable: Scalars['Int']
}

export enum FeeType {
  /** ADVISORY fee */
  Advisory = 'ADVISORY',
  /** SUBSCRIPTION fee */
  Subscription = 'SUBSCRIPTION',
}

export type File = {
  __typename?: 'File'
  documentRequestId: Scalars['ID']
  encoding: Scalars['String']
  filename: Scalars['String']
  mimetype: Scalars['String']
  url: Scalars['URL']
}

/** The file does not exist */
export type FileDoesNotExistError = {
  __typename?: 'FileDoesNotExistError'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The upload uuid */
  uploadUuid?: Maybe<Scalars['ID']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** The file does not exist in s3 */
export type FileDoesNotExistInS3 = {
  __typename?: 'FileDoesNotExistInS3'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

export type FileOrException = File | FileSizeError | UploadFailedError

export type FileSizeError = {
  __typename?: 'FileSizeError'
  message: Scalars['String']
}

/** The file uploaded exceeds the max allowed byte size */
export type FileTooLarge = {
  __typename?: 'FileTooLarge'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

export enum FilingType {
  /** User files taxes living with spouse part of the year */
  SeparatePartYear = 'separatePartYear',
  /** User files taxes living apart from spouse all year */
  SeparateWholeYear = 'separateWholeYear',
  /** User files taxes with their spouse */
  Joint = 'joint',
}

/** Miscellaneous attributes about a Financial Institution */
export type FinancialInstitution = TimestampsInterface & {
  __typename?: 'FinancialInstitution'
  /** Is this Financial Institution blacklisted within Acorns */
  blacklisted: Scalars['Boolean']
  /** Inorganic ordering for Financial Institutions */
  boost: Scalars['Int']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Is this Financial Institution removed from Plaid's list */
  deleted: Scalars['Boolean']
  /** Is this Financial Institution a Direct Bank type */
  directBank: Scalars['Boolean']
  /** Plaid Financial Institution ID */
  externalId: Scalars['String']
  /** Does this Financial Institution have multi-factor authentication? */
  hasMfa: Scalars['Boolean']
  /** Internal Acorns UUID representing Financial Institution */
  id: Scalars['ID']
  /** The link provider type of the financial institution */
  linkProviderType?: Maybe<LinkProviderType>
  /** Location of logo for a Financial Institution */
  logoUrl: Scalars['String']
  /** Name of Financial Institution */
  name: Scalars['String']
  /** URL for signing in with Direct Bank Integration */
  oauthUrl?: Maybe<Scalars['String']>
  /** Plaid products this Financial Institution supports */
  products: Array<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** URL of the Financial Institution */
  url?: Maybe<Scalars['String']>
}

/** An individual edge within the paginated list of FinancialInstitutionType */
export type FinancialInstitutionTypeEdge = {
  __typename?: 'FinancialInstitutionTypeEdge'
  /** The unique key used for pagination */
  cursor: Scalars['ID']
  /** The FinancialInstitutionType record in the edge */
  node: FinancialInstitution
}

/** Relay style pagination information for FinancialInstitutionType */
export type FinancialInstitutionTypePagination = {
  __typename?: 'FinancialInstitutionTypePagination'
  edges: Array<FinancialInstitutionTypeEdge>
  pageInfo: PageInfo
}

export type FinishSetup = {
  __typename?: 'FinishSetup'
  eyebrow: Scalars['String']
  tips: Array<SetUpTip>
}

/** Details for footer */
export type Footer = {
  __typename?: 'Footer'
  image?: Maybe<Image>
  title?: Maybe<Scalars['String']>
}

export type FormattedMonetaryAmount = {
  __typename?: 'FormattedMonetaryAmount'
  currency: Currency
  value: Scalars['String']
}

export enum FormType {
  Form1099 = 'form1099',
  Form1099R = 'form1099R',
  Form1099R1 = 'form1099R1',
  Form1099R2 = 'form1099R2',
  Form1099R4 = 'form1099R4',
  Form1099R7 = 'form1099R7',
  Form1099R8 = 'form1099R8',
  Form1099Rj = 'form1099RJ',
  Form1099Rq = 'form1099RQ',
  Form1099Rt = 'form1099RT',
  Form5498 = 'form5498',
  Form1099Misc = 'form1099MISC',
  Form1099Bdiv = 'form1099BDIV',
}

export type FoundMoneyCampaign = {
  __typename?: 'FoundMoneyCampaign'
  id: Scalars['ID']
  name: Scalars['String']
  ownerName: Scalars['String']
  backgroundImageUrl?: Maybe<Scalars['URL']>
  ownerImageUrl?: Maybe<Scalars['URL']>
  offers: Array<FoundMoneyOffer>
}

export type FoundMoneyCampaignOfferV2 = {
  __typename?: 'FoundMoneyCampaignOfferV2'
  id: Scalars['ID']
  incentiveSummary: Scalars['String']
}

export type FoundMoneyCampaignV2 = {
  __typename?: 'FoundMoneyCampaignV2'
  id: Scalars['ID']
  cohortSlug: Scalars['String']
  imageUrl: Scalars['URL']
  backgroundImageUrl: Scalars['URL']
  backgroundColorHex: Scalars['String']
  colorBackgroundLogoImageUrl?: Maybe<Scalars['URL']>
  colorImageUrl: Scalars['URL']
  ownerId: Scalars['ID']
  displayName: Scalars['String']
  offers: Array<FoundMoneyCampaignOfferV2>
}

export type FoundMoneyOffer = {
  __typename?: 'FoundMoneyOffer'
  active?: Maybe<Scalars['Boolean']>
  backgroundColorHex?: Maybe<Scalars['String']>
  backgroundImage?: Maybe<BackgroundImage>
  backgroundImageUrl?: Maybe<Scalars['URL']>
  colorBackgroundLogoImageUrl?: Maybe<Scalars['URL']>
  campaignId?: Maybe<Scalars['ID']>
  ctaDetails?: Maybe<CtaDetails>
  ctaTitle?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  dealType?: Maybe<DealType>
  devicePlatforms?: Maybe<Array<Maybe<Scalars['String']>>>
  displayEndDate?: Maybe<Scalars['String']>
  displayStartDate?: Maybe<Scalars['String']>
  displayTitle?: Maybe<Scalars['String']>
  displaySubtitle?: Maybe<Scalars['String']>
  id: Scalars['ID']
  owner?: Maybe<Owner>
  promoted?: Maybe<Scalars['Boolean']>
  promotionRank?: Maybe<Scalars['Int']>
  rank?: Maybe<Scalars['Int']>
  redemptionAction?: Maybe<Scalars['String']>
  /** @deprecated use condensedSocialCopies field instead. */
  socialCopies?: Maybe<Array<Maybe<SocialCopies>>>
  condensedSocialCopies?: Maybe<CondensedSocialCopies>
  termsAndConditionsUrl?: Maybe<Scalars['URL']>
  webviewEnabled?: Maybe<Scalars['Boolean']>
}

export type FoundMoneyOfferCategory = {
  __typename?: 'FoundMoneyOfferCategory'
  featuredOffer?: Maybe<FoundMoneyOffer>
  iconUrl?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  offers?: Maybe<Array<Maybe<FoundMoneyOffer>>>
}

export type FoundMoneyReward = {
  __typename?: 'FoundMoneyReward'
  id: Scalars['ID']
  campaignOwnerName?: Maybe<Scalars['String']>
  /** @deprecated Field is deprecated, use colorBackgroundLogoImageUrl instead */
  campaignOwnerImageUrl?: Maybe<Scalars['URL']>
  colorBackgroundLogoImageUrl?: Maybe<Scalars['URL']>
  categoryIcon?: Maybe<Scalars['String']>
  dollarValue?: Maybe<MonetaryAmount>
  status?: Maybe<Scalars['String']>
  daysFulfilledWithin?: Maybe<Scalars['Int']>
  originationDate?: Maybe<Scalars['String']>
  originationType?: Maybe<Scalars['String']>
  fulfillmentDate?: Maybe<Scalars['String']>
  isFoundMoneyPlus?: Maybe<Scalars['Boolean']>
}

export type FoundMoneySummary = {
  __typename?: 'FoundMoneySummary'
  totalRewardsDollarValue?: Maybe<MonetaryAmount>
  totalPendingRewardsDollarValue?: Maybe<MonetaryAmount>
  totalFulfilledRewardsDollarValue?: Maybe<MonetaryAmount>
}

/** A user who was referred by an existing Acorns User */
export type Friend = {
  __typename?: 'Friend'
  userId?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  email: Scalars['String']
  /**
   * If the Friend object resolved via the Advocate query, advocateUserId
   * corresponds to the argument passed in at the root level.
   * If Friend object resolved via the Friend query, advocateUserId is the
   * first advocate that is returned by Extole.
   */
  advocateUserId?: Maybe<Scalars['ID']>
  /** A list of all campaigns that the friend is participating in */
  campaigns?: Maybe<Array<ReferralCampaign>>
  /** Status based on activity of friend */
  status?: Maybe<FriendStatus>
  friendExperienceContent?: Maybe<FriendExperienceContent>
}

/** The content that supports user experience */
export type FriendExperienceContent = {
  __typename?: 'FriendExperienceContent'
  /** The first name of the referred user's advocate */
  advocateFirstName?: Maybe<Scalars['String']>
  /** The last name of the referred user's advocate */
  advocateLastName?: Maybe<Scalars['String']>
  /** The baseline advocate incentive they will earn if friend converts */
  advocateMinimumIncentive?: Maybe<Scalars['String']>
}

/** Status of friend */
export enum FriendStatus {
  /** Advocate sent invite but user has not completed any steps */
  Sent = 'SENT',
  /** Friend has registered */
  Pending = 'PENDING',
  /** Friend has finished required steps to qualify for reward */
  Complete = 'COMPLETE',
  /** Reward has been given to Friend/Advocate */
  Fulfilled = 'FULFILLED',
  /** Friend did not complete required steps in allotted time frame */
  Expired = 'EXPIRED',
}

/** A summary of information around a referred user */
export type FriendSummary = {
  __typename?: 'FriendSummary'
  /** First name of the referred user */
  name?: Maybe<Scalars['String']>
  /** High level status indicating referred user reward status */
  status?: Maybe<FriendStatus>
  /** Campaign identifier that the referred user signed up under */
  campaignId: Scalars['ID']
  userId: Scalars['ID']
}

export type Fund = Security & {
  __typename?: 'Fund'
  id: Scalars['ID']
  symbol: Scalars['TickerSymbol']
  type: SecurityType
  week52High: BigCurrencyAmount
  week52Low: BigCurrencyAmount
  currentPrice: BigCurrencyAmount
  lastClosePrice: BigCurrencyAmount
  openPrice: BigCurrencyAmount
  shortName: Scalars['String']
  longName: Scalars['String']
  displayName: Scalars['String']
  volume: Scalars['BigDecimal']
  marketCap: Scalars['BigDecimal']
  profile: SecurityProfile
  /** @deprecated Use `Security.profile` instead. */
  securityProfile: SecurityProfile
  headlines: Array<SecurityHeadline>
  /** @deprecated Use `Security.headlines` instead. */
  securityHeadlines: Array<SecurityHeadline>
  topHoldings: Array<TopHolding>
  lastUpdatedAt: Scalars['DateTime']
  earliestPriceDate: Scalars['Date']
  numberOfHoldings: Scalars['Int']
}

export type FundingSource = {
  __typename?: 'FundingSource'
  type: Scalars['String']
  fundingType: Scalars['String']
  name: Scalars['String']
  last4?: Maybe<Scalars['String']>
  verificationStatus?: Maybe<Scalars['Int']>
  verified?: Maybe<Scalars['Boolean']>
  icon?: Maybe<Scalars['URL']>
  alert?: Maybe<Scalars['JSON']>
  rdvSettledAt?: Maybe<Scalars['DateTime']>
  rdvTriggeredAt?: Maybe<Scalars['DateTime']>
}

/** A Funding Source for the acorns user */
export type FundingSourceAccount = TimestampsInterface & {
  __typename?: 'FundingSourceAccount'
  accountName: Scalars['String']
  alert?: Maybe<Scalars['JSON']>
  balance?: Maybe<Scalars['Float']>
  bankRoutingNumber?: Maybe<Scalars['String']>
  canCancel: Scalars['Boolean']
  canTriggerRdv: Scalars['Boolean']
  /** Indicates whether the user is allowed to verify RDV */
  canVerifyRdv?: Maybe<Scalars['Boolean']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  deleted: Scalars['Boolean']
  frozen: Scalars['Boolean']
  /** The type of the funding source. */
  fundType: FundingSourceType
  /** The bank icon of the funding source */
  icon?: Maybe<Scalars['String']>
  id: Scalars['Int']
  institutionName: Scalars['String']
  insufficientFunds?: Maybe<Scalars['Boolean']>
  last4?: Maybe<Scalars['String']>
  linked: Scalars['Boolean']
  linkedSubaccountId?: Maybe<Scalars['ID']>
  /** The logo url from Linked Accounts Service */
  logoUrl?: Maybe<Scalars['String']>
  name: Scalars['String']
  rdvSettledAt?: Maybe<Scalars['DateTime']>
  rdvTriggeredAt?: Maybe<Scalars['DateTime']>
  /** The role of the funding source. */
  role?: Maybe<FundingSourceRoleEnum>
  /** The status of the funding source. */
  status: FundingSourceStatus
  transfersApproved: Scalars['Boolean']
  /** Deprecated - use fundType instead. */
  type: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  uuid?: Maybe<Scalars['ID']>
  verificationStatus: Scalars['Int']
  verified?: Maybe<Scalars['Boolean']>
}

/** Funding Source with account and routing already exists for user */
export type FundingSourceAlreadyExists = {
  __typename?: 'FundingSourceAlreadyExists'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** Account credentials linked by too many users */
export type FundingSourceCredentialsExceedLinkLimit = {
  __typename?: 'FundingSourceCredentialsExceedLinkLimit'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

export type FundingSourceInfo = {
  __typename?: 'FundingSourceInfo'
  type?: Maybe<FundingSourceType>
  name: Scalars['String']
  verificationStatus?: Maybe<Scalars['Int']>
  verified?: Maybe<Scalars['Boolean']>
  icon?: Maybe<Scalars['URL']>
  alert?: Maybe<Scalars['JSON']>
  rdvSettledAt?: Maybe<Scalars['DateTime']>
  rdvTriggeredAt?: Maybe<Scalars['DateTime']>
  accountNumberLastFour?: Maybe<Scalars['String']>
  balance?: Maybe<Scalars['Float']>
  /** @deprecated Will move in the future */
  canChange: Scalars['Boolean']
  /** @deprecated Will move in the future */
  changeRequiresApproval: Scalars['Boolean']
  linkedSubaccountId?: Maybe<Scalars['ID']>
}

/** The user needs to verify their RDVs to close their early account */
export type FundingSourceRequiresRdvException = {
  __typename?: 'FundingSourceRequiresRdvException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export enum FundingSourceRoleEnum {
  /** The subaccount is the primary funding source of the user */
  PrimaryFunding = 'primaryFunding',
  /** The subaccount is the secondary funding source of the user */
  SecondaryFunding = 'secondaryFunding',
}

export enum FundingSourceStatus {
  /** Funding Source is waiting on RDV triggers. */
  Pending = 'pending',
  /** RDVs have been sent and are awaiting settlement. */
  RdvsInitiated = 'rdvsInitiated',
  /** RDVs have settled in the user's funding source. User must verify amounts. */
  RdvsSettled = 'rdvsSettled',
  /** RDV verification attempts exhausted. */
  Frozen = 'frozen',
  /** Documents have been requested to verify the funding source. */
  DocsRequired = 'docsRequired',
  /** Awaiting admin approval. No user action is required. */
  Unapproved = 'unapproved',
  /** Funding Source is verified. No user action is required. */
  Success = 'success',
}

export enum FundingSourceStatusEnum {
  /** Funding Source is waiting on RDV triggers. */
  Pending = 'pending',
  /** RDVs have been sent and are awaiting settlement. */
  RdvsInitiated = 'rdvsInitiated',
  /** RDVs have settled in the user's funding source. User must verify amounts. */
  RdvsSettled = 'rdvsSettled',
  /** RDV verification attempts exhausted. */
  Frozen = 'frozen',
  /** Documents have been requested to verify the funding source. */
  DocsRequired = 'docsRequired',
  /** Awaiting admin approval. No user action is required. */
  Unapproved = 'unapproved',
  /** Funding Source is verified. No user action is required. */
  Success = 'success',
}

export enum FundingSourceType {
  Ach = 'ach',
  Paypal = 'paypal',
  Spend = 'spend',
}

export enum FundsAvailability {
  /** User wants easy access to cash in an emergency */
  Emergency = 'emergency',
  /** User is planning to save and not withdraw until retirement */
  Retirement = 'retirement',
}

export enum Funnel {
  /** Core funnel */
  Core = 'core',
  /** Later funnel */
  Later = 'later',
  /** Spend funnel */
  Spend = 'spend',
  /** Early funnel */
  Early = 'early',
  /** Tiered registration funnel */
  TieredReg = 'tiered_reg',
  /** Simple registration funnel */
  SimpleReg = 'simple_reg',
  /** Direct to mobile funnel */
  DirectToMobile = 'direct_to_mobile',
}

export type FunnelMetadata = {
  __typename?: 'FunnelMetadata'
  name: FunnelName
  version: Scalars['String']
}

export enum FunnelName {
  Default = 'DEFAULT',
  MightyOakCard = 'MIGHTY_OAK_CARD',
  Referrals = 'REFERRALS',
}

/** Attributes for generating a linked account session. */
export type GenerateLinkSessionInput = {
  /** Acorns Financial Institution ID */
  institutionId: Scalars['ID']
  /** The URL to redirect the client to after customer has finished linking account. */
  redirectUrl?: Maybe<Scalars['URL']>
  /** Flag indicating a web view client default is true */
  isWebview?: Maybe<Scalars['Boolean']>
  /** ISO 639-1 code representing the language. default is 'EN' */
  language?: Maybe<LinkSessionLanguage>
  /** Linked Account ID for Linked Account to relink */
  linkedAccountId?: Maybe<Scalars['ID']>
}

/** Returns Base 64 encoded string of PDF for Front-end */
export type GenerateUpdatedPdfPayload = {
  __typename?: 'GenerateUpdatedPdfPayload'
  /** Base 64 Encoded String of PDF */
  pdf: Scalars['String']
}

/** Object representing a grow prospect */
export type GrowProspect = Prospect & {
  __typename?: 'GrowProspect'
  email: Scalars['String']
  id: Scalars['ID']
}

/** text over background image */
export type Header = {
  __typename?: 'Header'
  image: Image
  title: Scalars['String']
}

export type HelpFormContent = {
  __typename?: 'HelpFormContent'
  body?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export enum HelpFormType {
  Contact = 'CONTACT',
  EarnMissingCredit = 'EARN_MISSING_CREDIT',
  SpendDispute = 'SPEND_DISPUTE',
}

export type HideMessageByExternalIdInput = {
  externalMessageId: Scalars['ID']
}

export type HideMessageInput = {
  messageId: Scalars['ID']
}

/** The Individual Security on the ETF */
export type Holding = {
  __typename?: 'Holding'
  /** Indicates the amount of every dollar that will go towards buying a share of the stock */
  amount: Scalars['Float']
  /** The name of the stock */
  name: Scalars['String']
  /** Indicates the percent of every dollar that will go towards buying a share of the stock */
  percent: Scalars['Float']
  /** The Symbol of the stock */
  symbol: Scalars['String']
}

export type HomeIcon = {
  __typename?: 'HomeIcon'
  body: Scalars['String']
  cta: Cta
  icon: Image
  title?: Maybe<Scalars['String']>
}

export type HomeIcons = {
  __typename?: 'HomeIcons'
  icons: Array<HomeIcon>
}

export enum IconType {
  IconAddGoal = 'ICON_ADD_GOAL',
  IconAlert = 'ICON_ALERT',
  IconAlertGrey = 'ICON_ALERT_GREY',
  IconAlertPending = 'ICON_ALERT_PENDING',
  IconAlertRed = 'ICON_ALERT_RED',
  IconAlertYellow = 'ICON_ALERT_YELLOW',
  IconArticle = 'ICON_ARTICLE',
  IconBabyKids = 'ICON_BABY_KIDS',
  IconCard = 'ICON_CARD',
  IconCategoryBaby = 'ICON_CATEGORY_BABY',
  IconCategoryBeauty = 'ICON_CATEGORY_BEAUTY',
  IconCategoryCar = 'ICON_CATEGORY_CAR',
  IconCategoryClothing = 'ICON_CATEGORY_CLOTHING',
  IconCategoryCollege = 'ICON_CATEGORY_COLLEGE',
  IconCategoryEntertainment = 'ICON_CATEGORY_ENTERTAINMENT',
  IconCategoryFlowers = 'ICON_CATEGORY_FLOWERS',
  IconCategoryFood = 'ICON_CATEGORY_FOOD',
  IconCategoryFootball = 'ICON_CATEGORY_FOOTBALL',
  IconCategoryHealth = 'ICON_CATEGORY_HEALTH',
  IconCategoryHome = 'ICON_CATEGORY_HOME',
  IconCategoryPet = 'ICON_CATEGORY_PET',
  IconCategoryPhone = 'ICON_CATEGORY_PHONE',
  IconCategoryShoe = 'ICON_CATEGORY_SHOE',
  IconCheckHub = 'ICON_CHECK_HUB',
  IconCheckIn = 'ICON_CHECK_IN',
  IconCircleCheck = 'ICON_CIRCLE_CHECK',
  IconCircleClock = 'ICON_CIRCLE_CLOCK',
  IconCircleInfo = 'ICON_CIRCLE_INFO',
  IconCirclePause = 'ICON_CIRCLE_PAUSE',
  IconCircleX = 'ICON_CIRCLE_X',
  IconClose = 'ICON_CLOSE',
  IconClothing = 'ICON_CLOTHING',
  IconDepositCheck = 'ICON_DEPOSIT_CHECK',
  IconDirectDeposit = 'ICON_DIRECT_DEPOSIT',
  IconDisclosureRight = 'ICON_DISCLOSURE_RIGHT',
  IconDropPin = 'ICON_DROP_PIN',
  IconEarnJobs = 'ICON_EARN_JOBS',
  IconElectronics = 'ICON_ELECTRONICS',
  IconEntertainment = 'ICON_ENTERTAINMENT',
  IconFastQuote = 'ICON_FAST_QUOTE',
  IconFavorites = 'ICON_FAVORITES',
  IconFinancialWellness = 'ICON_FINANCIAL_WELLNESS',
  IconFlowersGifts = 'ICON_FLOWERS_GIFTS',
  IconFoodGourmet = 'ICON_FOOD_GOURMET',
  IconHealthBeauty = 'ICON_HEALTH_BEAUTY',
  IconHealthWellness = 'ICON_HEALTH_WELLNESS',
  IconHomeDecor = 'ICON_HOME_DECOR',
  IconInstant = 'ICON_INSTANT',
  IconInterstitialAchievements = 'ICON_INTERSTITIAL_ACHIEVEMENTS',
  IconInterstitialAdd = 'ICON_INTERSTITIAL_ADD',
  IconInterstitialApy = 'ICON_INTERSTITIAL_APY',
  IconInterstitialAutoRefill = 'ICON_INTERSTITIAL_AUTO_REFILL',
  IconInterstitialBank = 'ICON_INTERSTITIAL_BANK',
  IconInterstitialCalculator = 'ICON_INTERSTITIAL_CALCULATOR',
  IconInterstitialCalendar = 'ICON_INTERSTITIAL_CALENDAR',
  IconInterstitialCheck = 'ICON_INTERSTITIAL_CHECK',
  IconInterstitialCheckActive = 'ICON_INTERSTITIAL_CHECK_ACTIVE',
  IconInterstitialConfident = 'ICON_INTERSTITIAL_CONFIDENT',
  IconInterstitialCreditCard = 'ICON_INTERSTITIAL_CREDIT_CARD',
  IconInterstitialDeposit = 'ICON_INTERSTITIAL_DEPOSIT',
  IconInterstitialDocuments = 'ICON_INTERSTITIAL_DOCUMENTS',
  IconInterstitialDollar = 'ICON_INTERSTITIAL_DOLLAR',
  IconInterstitialDollarSign = 'ICON_INTERSTITIAL_DOLLAR_SIGN',
  IconInterstitialEarnJobs = 'ICON_INTERSTITIAL_EARN_JOBS',
  IconInterstitialEntries = 'ICON_INTERSTITIAL_ENTRIES',
  IconInterstitialFastQuote = 'ICON_INTERSTITIAL_FAST_QUOTE',
  IconInterstitialFeelingGood = 'ICON_INTERSTITIAL_FEELING_GOOD',
  IconInterstitialGettingStarted1 = 'ICON_INTERSTITIAL_GETTING_STARTED1',
  IconInterstitialGettingStarted2 = 'ICON_INTERSTITIAL_GETTING_STARTED2',
  IconInterstitialHealthAdd = 'ICON_INTERSTITIAL_HEALTH_ADD',
  IconInterstitialLearn = 'ICON_INTERSTITIAL_LEARN',
  IconInterstitialNextDay = 'ICON_INTERSTITIAL_NEXT_DAY',
  IconInterstitialNumber = 'ICON_INTERSTITIAL_NUMBER',
  IconInterstitialOffers = 'ICON_INTERSTITIAL_OFFERS',
  IconInterstitialPie = 'ICON_INTERSTITIAL_PIE',
  IconInterstitialPin = 'ICON_INTERSTITIAL_PIN',
  IconInterstitialProfile = 'ICON_INTERSTITIAL_PROFILE',
  IconInterstitialRecurring = 'ICON_INTERSTITIAL_RECURRING',
  IconInterstitialRenters = 'ICON_INTERSTITIAL_RENTERS',
  IconInterstitialRoundUp = 'ICON_INTERSTITIAL_ROUND_UP',
  IconInterstitialRoundUps = 'ICON_INTERSTITIAL_ROUND_UPS',
  IconInterstitialRoundUpBill = 'ICON_INTERSTITIAL_ROUND_UP_BILL',
  IconInterstitialSave = 'ICON_INTERSTITIAL_SAVE',
  IconInterstitialSendCheck = 'ICON_INTERSTITIAL_SEND_CHECK',
  IconInterstitialShipping = 'ICON_INTERSTITIAL_SHIPPING',
  IconInterstitialSideHustles = 'ICON_INTERSTITIAL_SIDE_HUSTLES',
  IconInterstitialSimplySpend = 'ICON_INTERSTITIAL_SIMPLY_SPEND',
  IconInterstitialSmartDeposit = 'ICON_INTERSTITIAL_SMART_DEPOSIT',
  IconInterstitialSmartDepositActive = 'ICON_INTERSTITIAL_SMART_DEPOSIT_ACTIVE',
  IconInterstitialTimer = 'ICON_INTERSTITIAL_TIMER',
  IconInterstitialTree = 'ICON_INTERSTITIAL_TREE',
  IconInterstitialTwoFactorAuth = 'ICON_INTERSTITIAL_TWO_FACTOR_AUTH',
  IconInterstitialWallet = 'ICON_INTERSTITIAL_WALLET',
  IconLearningCenter = 'ICON_LEARNING_CENTER',
  IconLocalOffers = 'ICON_LOCAL_OFFERS',
  IconLocation = 'ICON_LOCATION',
  IconLock = 'ICON_LOCK',
  IconLockSolid = 'ICON_LOCK_SOLID',
  IconMiniArrowLrgDown = 'ICON_MINI_ARROW_LRG_DOWN',
  IconMiniArrowLrgUp = 'ICON_MINI_ARROW_LRG_UP',
  IconMiniArrowSmDown = 'ICON_MINI_ARROW_SM_DOWN',
  IconMiniArrowSmUp = 'ICON_MINI_ARROW_SM_UP',
  IconMiniCheckmark = 'ICON_MINI_CHECKMARK',
  IconMiniIndicatorTriangle = 'ICON_MINI_INDICATOR_TRIANGLE',
  IconMiniLightningBolt = 'ICON_MINI_LIGHTNING_BOLT',
  IconMinus = 'ICON_MINUS',
  IconNew = 'ICON_NEW',
  IconOneTime = 'ICON_ONE_TIME',
  IconPets = 'ICON_PETS',
  IconPlane = 'ICON_PLANE',
  IconPlus = 'ICON_PLUS',
  IconProductBanking = 'ICON_PRODUCT_BANKING',
  IconProductColorAchievements = 'ICON_PRODUCT_COLOR_ACHIEVEMENTS',
  IconProductColorEarly = 'ICON_PRODUCT_COLOR_EARLY',
  IconProductColorEarn = 'ICON_PRODUCT_COLOR_EARN',
  IconProductColorGrow = 'ICON_PRODUCT_COLOR_GROW',
  IconProductColorInvest = 'ICON_PRODUCT_COLOR_INVEST',
  IconProductColorInvite = 'ICON_PRODUCT_COLOR_INVITE',
  IconProductColorLater = 'ICON_PRODUCT_COLOR_LATER',
  IconProductColorLocalFoundMoney = 'ICON_PRODUCT_COLOR_LOCAL_FOUND_MONEY',
  IconProductColorProtect = 'ICON_PRODUCT_COLOR_PROTECT',
  IconProductColorSave = 'ICON_PRODUCT_COLOR_SAVE',
  IconProductColorSpend = 'ICON_PRODUCT_COLOR_SPEND',
  IconProductEarly = 'ICON_PRODUCT_EARLY',
  IconProductEarn = 'ICON_PRODUCT_EARN',
  IconProductEmergency = 'ICON_PRODUCT_EMERGENCY',
  IconProductGrow = 'ICON_PRODUCT_GROW',
  IconProductInvest = 'ICON_PRODUCT_INVEST',
  IconProductLater = 'ICON_PRODUCT_LATER',
  IconProductProtect = 'ICON_PRODUCT_PROTECT',
  IconProductSave = 'ICON_PRODUCT_SAVE',
  IconProductSpend = 'ICON_PRODUCT_SPEND',
  IconProtected = 'ICON_PROTECTED',
  IconRoundUps = 'ICON_ROUND_UPS',
  IconScooter = 'ICON_SCOOTER',
  IconSearch = 'ICON_SEARCH',
  IconSendCheck = 'ICON_SEND_CHECK',
  IconSendMoneyInstant = 'ICON_SEND_MONEY_INSTANT',
  IconShare = 'ICON_SHARE',
  IconShoesAccessories = 'ICON_SHOES_ACCESSORIES',
  IconSideHustles = 'ICON_SIDE_HUSTLES',
  IconSimplySpend = 'ICON_SIMPLY_SPEND',
  IconSportsOutdoors = 'ICON_SPORTS_OUTDOORS',
  IconTimer = 'ICON_TIMER',
  IconTransactionAcorns = 'ICON_TRANSACTION_ACORNS',
  IconTransactionAtm = 'ICON_TRANSACTION_ATM',
  IconTransactionBankFee = 'ICON_TRANSACTION_BANK_FEE',
  IconTransactionCheck = 'ICON_TRANSACTION_CHECK',
  IconTransactionCheckDeposit = 'ICON_TRANSACTION_CHECK_DEPOSIT',
  IconTransactionDirectDeposit = 'ICON_TRANSACTION_DIRECT_DEPOSIT',
  IconTransactionDistribution = 'ICON_TRANSACTION_DISTRIBUTION',
  IconTransactionDividend = 'ICON_TRANSACTION_DIVIDEND',
  IconTransactionEarnReward = 'ICON_TRANSACTION_EARN_REWARD',
  IconTransactionGift = 'ICON_TRANSACTION_GIFT',
  IconTransactionHamburger = 'ICON_TRANSACTION_HAMBURGER',
  IconTransactionId = 'ICON_TRANSACTION_ID',
  IconTransactionInstantRoundUp = 'ICON_TRANSACTION_INSTANT_ROUND_UP',
  IconTransactionOneTime = 'ICON_TRANSACTION_ONE_TIME',
  IconTransactionOriginalTransaction = 'ICON_TRANSACTION_ORIGINAL_TRANSACTION',
  IconTransactionRebalance = 'ICON_TRANSACTION_REBALANCE',
  IconTransactionRecurringDeposit = 'ICON_TRANSACTION_RECURRING_DEPOSIT',
  IconTransactionRoundUp = 'ICON_TRANSACTION_ROUND_UP',
  IconTransactionSpendCard = 'ICON_TRANSACTION_SPEND_CARD',
  IconTransactionStatus = 'ICON_TRANSACTION_STATUS',
  IconTransactionTransferIn = 'ICON_TRANSACTION_TRANSFER_IN',
  IconTransactionTransferInOut = 'ICON_TRANSACTION_TRANSFER_IN_OUT',
  IconTransactionTransferOut = 'ICON_TRANSACTION_TRANSFER_OUT',
  IconTransactionType = 'ICON_TRANSACTION_TYPE',
  IconTravelTransportation = 'ICON_TRAVEL_TRANSPORTATION',
  IconTrustedPartners = 'ICON_TRUSTED_PARTNERS',
  IconUtilityAccessibility = 'ICON_UTILITY_ACCESSIBILITY',
  IconUtilityAccountDetails = 'ICON_UTILITY_ACCOUNT_DETAILS',
  IconUtilityAchievement = 'ICON_UTILITY_ACHIEVEMENT',
  IconUtilityAdd = 'ICON_UTILITY_ADD',
  IconUtilityAi = 'ICON_UTILITY_AI',
  IconUtilityAlert = 'ICON_UTILITY_ALERT',
  IconUtilityArrowLeft = 'ICON_UTILITY_ARROW_LEFT',
  IconUtilityArrowRight = 'ICON_UTILITY_ARROW_RIGHT',
  IconUtilityArExperience = 'ICON_UTILITY_AR_EXPERIENCE',
  IconUtilityBackupCodes = 'ICON_UTILITY_BACKUP_CODES',
  IconUtilityBag = 'ICON_UTILITY_BAG',
  IconUtilityBank = 'ICON_UTILITY_BANK',
  IconUtilityBankAdd = 'ICON_UTILITY_BANK_ADD',
  IconUtilityBankFees = 'ICON_UTILITY_BANK_FEES',
  IconUtilityBeneficiaries = 'ICON_UTILITY_BENEFICIARIES',
  IconUtilityBinoculars = 'ICON_UTILITY_BINOCULARS',
  IconUtilityBirthday = 'ICON_UTILITY_BIRTHDAY',
  IconUtilityBonds = 'ICON_UTILITY_BONDS',
  IconUtilityBook = 'ICON_UTILITY_BOOK',
  IconUtilityBookmark = 'ICON_UTILITY_BOOKMARK',
  IconUtilityBox = 'ICON_UTILITY_BOX',
  IconUtilityCalendar = 'ICON_UTILITY_CALENDAR',
  IconUtilityCamera = 'ICON_UTILITY_CAMERA',
  IconUtilityCancel = 'ICON_UTILITY_CANCEL',
  IconUtilityCar = 'ICON_UTILITY_CAR',
  IconUtilityCheckmark = 'ICON_UTILITY_CHECKMARK',
  IconUtilityClose = 'ICON_UTILITY_CLOSE',
  IconUtilityCoin = 'ICON_UTILITY_COIN',
  IconUtilityCollapseMenu = 'ICON_UTILITY_COLLAPSE_MENU',
  IconUtilityCompanyBuilding = 'ICON_UTILITY_COMPANY_BUILDING',
  IconUtilityController = 'ICON_UTILITY_CONTROLLER',
  IconUtilityCopy = 'ICON_UTILITY_COPY',
  IconUtilityCredit = 'ICON_UTILITY_CREDIT',
  IconUtilityCrypto = 'ICON_UTILITY_CRYPTO',
  IconUtilityCurrentLocation = 'ICON_UTILITY_CURRENT_LOCATION',
  IconUtilityCyberSecurity = 'ICON_UTILITY_CYBER_SECURITY',
  IconUtilityDelete = 'ICON_UTILITY_DELETE',
  IconUtilityDocuments = 'ICON_UTILITY_DOCUMENTS',
  IconUtilityDocumentDownload = 'ICON_UTILITY_DOCUMENT_DOWNLOAD',
  IconUtilityDocumentUpload = 'ICON_UTILITY_DOCUMENT_UPLOAD',
  IconUtilityDots = 'ICON_UTILITY_DOTS',
  IconUtilityDown = 'ICON_UTILITY_DOWN',
  IconUtilityEarnJobs = 'ICON_UTILITY_EARN_JOBS',
  IconUtilityEdit = 'ICON_UTILITY_EDIT',
  IconUtilityEntries = 'ICON_UTILITY_ENTRIES',
  IconUtilityEth = 'ICON_UTILITY_ETH',
  IconUtilityExpand = 'ICON_UTILITY_EXPAND',
  IconUtilityExpandMenu = 'ICON_UTILITY_EXPAND_MENU',
  IconUtilityFace = 'ICON_UTILITY_FACE',
  IconUtilityFaceId = 'ICON_UTILITY_FACE_ID',
  IconUtilityFastQuote = 'ICON_UTILITY_FAST_QUOTE',
  IconUtilityFilter = 'ICON_UTILITY_FILTER',
  IconUtilityFlame = 'ICON_UTILITY_FLAME',
  IconUtilityFlashOff = 'ICON_UTILITY_FLASH_OFF',
  IconUtilityFlashOn = 'ICON_UTILITY_FLASH_ON',
  IconUtilityGift = 'ICON_UTILITY_GIFT',
  IconUtilityGoal = 'ICON_UTILITY_GOAL',
  IconUtilityGovernment = 'ICON_UTILITY_GOVERNMENT',
  IconUtilityGradCap = 'ICON_UTILITY_GRAD_CAP',
  IconUtilityHamburgerMenu = 'ICON_UTILITY_HAMBURGER_MENU',
  IconUtilityHealth = 'ICON_UTILITY_HEALTH',
  IconUtilityHeart = 'ICON_UTILITY_HEART',
  IconUtilityHeartAdd = 'ICON_UTILITY_HEART_ADD',
  IconUtilityHelp = 'ICON_UTILITY_HELP',
  IconUtilityHide = 'ICON_UTILITY_HIDE',
  IconUtilityHistory = 'ICON_UTILITY_HISTORY',
  IconUtilityHome = 'ICON_UTILITY_HOME',
  IconUtilityInfo = 'ICON_UTILITY_INFO',
  IconUtilityInvestorProfile = 'ICON_UTILITY_INVESTOR_PROFILE',
  IconUtilityInvite = 'ICON_UTILITY_INVITE',
  IconUtilityJobAlerts = 'ICON_UTILITY_JOB_ALERTS',
  IconUtilityKeypad = 'ICON_UTILITY_KEYPAD',
  IconUtilityLaptop = 'ICON_UTILITY_LAPTOP',
  IconUtilityLeaf = 'ICON_UTILITY_LEAF',
  IconUtilityLibrary = 'ICON_UTILITY_LIBRARY',
  IconUtilityLightbulb = 'ICON_UTILITY_LIGHTBULB',
  IconUtilityLocalOffers = 'ICON_UTILITY_LOCAL_OFFERS',
  IconUtilityLoginActivity = 'ICON_UTILITY_LOGIN_ACTIVITY',
  IconUtilityLogOut = 'ICON_UTILITY_LOG_OUT',
  IconUtilityMail = 'ICON_UTILITY_MAIL',
  IconUtilityManualLinking = 'ICON_UTILITY_MANUAL_LINKING',
  IconUtilityMedia = 'ICON_UTILITY_MEDIA',
  IconUtilityMenu = 'ICON_UTILITY_MENU',
  IconUtilityMobilePhone = 'ICON_UTILITY_MOBILE_PHONE',
  IconUtilityMorning = 'ICON_UTILITY_MORNING',
  IconUtilityNew = 'ICON_UTILITY_NEW',
  IconUtilityNight = 'ICON_UTILITY_NIGHT',
  IconUtilityNotifications = 'ICON_UTILITY_NOTIFICATIONS',
  IconUtilityOneTime = 'ICON_UTILITY_ONE_TIME',
  IconUtilityPassword = 'ICON_UTILITY_PASSWORD',
  IconUtilityPause = 'ICON_UTILITY_PAUSE',
  IconUtilityPet = 'ICON_UTILITY_PET',
  IconUtilityPhone = 'ICON_UTILITY_PHONE',
  IconUtilityPin = 'ICON_UTILITY_PIN',
  IconUtilityPlane = 'ICON_UTILITY_PLANE',
  IconUtilityPointer = 'ICON_UTILITY_POINTER',
  IconUtilityPotential = 'ICON_UTILITY_POTENTIAL',
  IconUtilityPreferences = 'ICON_UTILITY_PREFERENCES',
  IconUtilityProfile = 'ICON_UTILITY_PROFILE',
  IconUtilityQr = 'ICON_UTILITY_QR',
  IconUtilityQuestionMark = 'ICON_UTILITY_QUESTION_MARK',
  IconUtilityQuickWithdraw = 'ICON_UTILITY_QUICK_WITHDRAW',
  IconUtilityReload = 'ICON_UTILITY_RELOAD',
  IconUtilityRenters = 'ICON_UTILITY_RENTERS',
  IconUtilityRocket = 'ICON_UTILITY_ROCKET',
  IconUtilityRoundUpsRealTime = 'ICON_UTILITY_ROUND_UPS_REAL_TIME',
  IconUtilityScales = 'ICON_UTILITY_SCALES',
  IconUtilityScience = 'ICON_UTILITY_SCIENCE',
  IconUtilityScooter = 'ICON_UTILITY_SCOOTER',
  IconUtilitySearch = 'ICON_UTILITY_SEARCH',
  IconUtilitySettings = 'ICON_UTILITY_SETTINGS',
  IconUtilityShareAndroid = 'ICON_UTILITY_SHARE_ANDROID',
  IconUtilityShareIos = 'ICON_UTILITY_SHARE_IOS',
  IconUtilityShareLink = 'ICON_UTILITY_SHARE_LINK',
  IconUtilityShieldCheck = 'ICON_UTILITY_SHIELD_CHECK',
  IconUtilityShipping = 'ICON_UTILITY_SHIPPING',
  IconUtilityShow = 'ICON_UTILITY_SHOW',
  IconUtilitySilverware = 'ICON_UTILITY_SILVERWARE',
  IconUtilitySingleCoin = 'ICON_UTILITY_SINGLE_COIN',
  IconUtilitySmartDepositShine = 'ICON_UTILITY_SMART_DEPOSIT_SHINE',
  IconUtilitySort = 'ICON_UTILITY_SORT',
  IconUtilitySpace = 'ICON_UTILITY_SPACE',
  IconUtilitySpendCardDispute = 'ICON_UTILITY_SPEND_CARD_DISPUTE',
  IconUtilitySpendCardLocked = 'ICON_UTILITY_SPEND_CARD_LOCKED',
  IconUtilityStackedCoins = 'ICON_UTILITY_STACKED_COINS',
  IconUtilityStar = 'ICON_UTILITY_STAR',
  IconUtilityStocks = 'ICON_UTILITY_STOCKS',
  IconUtilitySubscription = 'ICON_UTILITY_SUBSCRIPTION',
  IconUtilitySun = 'ICON_UTILITY_SUN',
  IconUtilityTax = 'ICON_UTILITY_TAX',
  IconUtilityTextMessage = 'ICON_UTILITY_TEXT_MESSAGE',
  IconUtilityTimer = 'ICON_UTILITY_TIMER',
  IconUtilityTouchId = 'ICON_UTILITY_TOUCH_ID',
  IconUtilityTrash = 'ICON_UTILITY_TRASH',
  IconUtilityTree = 'ICON_UTILITY_TREE',
  IconUtilityTwoFactorAuth = 'ICON_UTILITY_TWO_FACTOR_AUTH',
  IconUtilityUp = 'ICON_UTILITY_UP',
  IconUtilityWand = 'ICON_UTILITY_WAND',
  IconUtilityWithdraw = 'ICON_UTILITY_WITHDRAW',
  IconWithdraw = 'ICON_WITHDRAW',
}

/** Identity Document Requested Alert. */
export type IdentityDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'IdentityDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type Image = {
  __typename?: 'Image'
  url: Scalars['String']
}

export type ImageInput = {
  url: Scalars['String']
}

export enum ImageType {
  Front = 'front',
  Back = 'back',
}

/**
 * An abstract representation of some reward a subscriber will be afforded
 * upon subscription to some Offer.
 */
export type Incentive = {
  /**
   * Arbitrary human-readable identifier that can be used by clients
   * to localize related copy.
   */
  copyKey?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  /** Description of what the incentive provides the subscriber. */
  description: Scalars['String']
  id: Scalars['ID']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type IncorrectOldPasswordException = {
  __typename?: 'IncorrectOldPasswordException'
  message?: Maybe<Scalars['String']>
}

export type IncorrectSecurityAnswerException = {
  __typename?: 'IncorrectSecurityAnswerException'
  message?: Maybe<Scalars['String']>
}

export type IncorrectSsnException = {
  __typename?: 'IncorrectSsnException'
  message?: Maybe<Scalars['String']>
}

export type IneligibilityLander = {
  __typename?: 'IneligibilityLander'
  alternatePartners?: Maybe<InsuranceCarousel>
  body: Scalars['String']
  cta: Cta
  disclaimer?: Maybe<Disclaimer>
  id: Scalars['ID']
  logo: Image
  title: Scalars['String']
}

export type InitiateEmailChallengeInput = {
  email: Scalars['EmailAddress']
}

export type InitiateEmailChallengeResult = EmailAuthChallenge | ExistingEmailVerifiedException

/** inputs */
export type InitiateSmsChallengeInput = {
  phoneNumber: Scalars['PhoneNumber']
}

/** challenge results */
export type InitiateSmsChallengeResult = SmsAuthChallenge | InvalidPhoneNumberException

export type InitiateTransferInput = {
  /** UUID of account to move money from */
  fromAccountId: Scalars['ID']
  /** UUID of account to move money into */
  toAccountId: Scalars['ID']
  /** Amount of currency to transfer */
  amount: CurrencyAmountInput
  /** Idempotency key for customer request */
  nonce?: Maybe<Scalars['ID']>
}

export type InitiateTransferPayload = {
  __typename?: 'InitiateTransferPayload'
  transfer?: Maybe<Transfer>
}

export type InstitutionNotSupportedError = {
  __typename?: 'InstitutionNotSupportedError'
  message: Scalars['String']
}

/** Insufficient Funds user alert. */
export type InsufficientFundsUserAlert = UserAlertsItem & {
  __typename?: 'InsufficientFundsUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type InsuranceCarousel = {
  __typename?: 'InsuranceCarousel'
  body?: Maybe<Scalars['String']>
  insuranceType: InsuranceType
  offers: Array<CarouselOffer>
  title: Scalars['String']
}

export type InsuranceHome = {
  __typename?: 'InsuranceHome'
  body: Scalars['String']
  disclaimerBody: Scalars['String']
  disclaimerCta: Cta
  image: Image
  insuranceType: InsuranceType
  modals: Array<Modal>
  subtitle: Scalars['String']
  title: Scalars['String']
  widgets: Array<InsuranceHomeWidget>
}

export type InsuranceHomeWidget =
  | CoverageAsk
  | CoverageCalculator
  | CoverageGrow
  | CoverageKnown
  | CoverageUnknown
  | InsuranceCarousel

export type InsuranceSection = {
  __typename?: 'InsuranceSection'
  body: Scalars['String']
  cta: Cta
  image: Image
  insuranceType: Scalars['String']
  recommendType: Scalars['String']
  title: Scalars['String']
}

export enum InsuranceType {
  /** Auto Insurance */
  Auto = 'auto',
  /** Life Insurance */
  Life = 'life',
  /** Renters Insurance */
  Renters = 'renters',
  /** Homeowners Insurance */
  Home = 'home',
  /** Pet Insurance */
  Pet = 'pet',
}

/** Internal Error */
export type InternalErrorException = {
  __typename?: 'InternalErrorException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type InternalShareTransferFailed = {
  __typename?: 'InternalShareTransferFailed'
  description: Scalars['String']
}

export type InternalShareTransferInput = {
  symbol: Scalars['TickerSymbol']
  shareQuantity: Scalars['BigDecimal']
}

/** The account number is invalid */
export type InvalidAccountNumber = {
  __typename?: 'InvalidAccountNumber'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** The supplied account token is invalid */
export type InvalidAccountToken = {
  __typename?: 'InvalidAccountToken'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** Investment Account must be a Custodial account */
export type InvalidAccountTypeException = {
  __typename?: 'InvalidAccountTypeException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Risk Level cannot be changed on Later and Early accounts */
export type InvalidActionOnAccount = {
  __typename?: 'InvalidActionOnAccount'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type InvalidAddressError = {
  __typename?: 'InvalidAddressError'
  /** Error details. Not for user display. */
  errorMessage?: Maybe<Scalars['String']>
  requestId: Scalars['ID']
}

/** Invalid Address */
export type InvalidAddressException = {
  __typename?: 'InvalidAddressException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Allocations exceed max threshold for non managed portfolios */
export type InvalidAllocationPercentError = {
  __typename?: 'InvalidAllocationPercentError'
  /** Maximum allocation percent for the given portfolio Type */
  maxAllocationPercent: Scalars['Int']
}

/** Occurs when exactly one conversion ID (email, phone, etc) was not provided */
export type InvalidConversionIdentifierException = {
  __typename?: 'InvalidConversionIdentifierException'
  message: Scalars['String']
}

export type InvalidCredentialsException = {
  __typename?: 'InvalidCredentialsException'
  message?: Maybe<Scalars['String']>
}

/** Date of birth does not meet validity criteria */
export type InvalidDateOfBirthException = {
  __typename?: 'InvalidDateOfBirthException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Invalid email id */
export type InvalidEmailException = {
  __typename?: 'InvalidEmailException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** The file uploaded does not have an allowed file extension */
export type InvalidFile = {
  __typename?: 'InvalidFile'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** First Name does not meet validity criteria */
export type InvalidFirstNameException = {
  __typename?: 'InvalidFirstNameException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Invalid Investment Account */
export type InvalidInvestmentAccountException = {
  __typename?: 'InvalidInvestmentAccountException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Last Name does not meet validity criteria */
export type InvalidLastNameException = {
  __typename?: 'InvalidLastNameException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type InvalidLaterInput = LaterTypedException & {
  __typename?: 'InvalidLaterInput'
  id: Scalars['ID']
  message: Scalars['String']
}

/** This account is not supported */
export type InvalidManualLink = {
  __typename?: 'InvalidManualLink'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

export type InvalidOptionException = {
  __typename?: 'InvalidOptionException'
  message: Scalars['String']
}

export type InvalidPasswordException = {
  __typename?: 'InvalidPasswordException'
  message?: Maybe<Scalars['String']>
}

export type InvalidPasswordResetException = {
  __typename?: 'InvalidPasswordResetException'
  errors: Array<PasswordResetErrors>
}

export type InvalidPasswordResetTokenException = {
  __typename?: 'InvalidPasswordResetTokenException'
  invalidToken: Scalars['String']
}

/** Invalid Phone Number */
export type InvalidPhoneException = {
  __typename?: 'InvalidPhoneException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type InvalidPhoneNumberException = {
  __typename?: 'InvalidPhoneNumberException'
  message?: Maybe<Scalars['String']>
}

export type InvalidPinException = {
  __typename?: 'InvalidPinException'
  message?: Maybe<Scalars['String']>
}

/** Portfolio ID must be valid */
export type InvalidPortfolioIdException = {
  __typename?: 'InvalidPortfolioIdException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** The routing number provided is unsupported or invalid */
export type InvalidRoutingNumber = {
  __typename?: 'InvalidRoutingNumber'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** The provided security is not valid for allocation */
export type InvalidSecurityError = {
  __typename?: 'InvalidSecurityError'
  /** ID of the invalid security */
  securityId: Scalars['ID']
}

/** Invalid Security For Allocation */
export type InvalidSecurityForAllocationError = {
  __typename?: 'InvalidSecurityForAllocationError'
  reason: InvalidSecurityForAllocationReasonEnum
  /** ID of the invalid security */
  securityId: Scalars['ID']
}

export enum InvalidSecurityForAllocationReasonEnum {
  SecurityDeactivated = 'SECURITY_DEACTIVATED',
}

export type InvalidSecurityForSymbolChangeError = {
  __typename?: 'InvalidSecurityForSymbolChangeError'
  error_reason: Scalars['String']
}

export type InvalidSecurityQuestionException = {
  __typename?: 'InvalidSecurityQuestionException'
  message?: Maybe<Scalars['String']>
}

/** Occurs when attribution does not match standardized attributes */
export type InvalidSourceAttributesException = {
  __typename?: 'InvalidSourceAttributesException'
  incorrectAttributes: Array<Scalars['String']>
}

export type InvalidSsnError = {
  __typename?: 'InvalidSSNError'
  message: Scalars['String']
}

/** SSN does not meet validity criteria */
export type InvalidSsnException = {
  __typename?: 'InvalidSsnException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Custodian is not able to open an account based on their residential address */
export type InvalidStateException = {
  __typename?: 'InvalidStateException'
  /** message */
  message?: Maybe<Scalars['String']>
  /** Custodian's State */
  state?: Maybe<Scalars['String']>
}

/** User is not in the correct subscription tier for the requested investment account */
export type InvalidSubscriptionTierException = {
  __typename?: 'InvalidSubscriptionTierException'
  /** User current subscription tier */
  currentUserTierKey?: Maybe<Scalars['String']>
}

export type InvalidSymbolForSymbolChangeError = {
  __typename?: 'InvalidSymbolForSymbolChangeError'
  error_reason: Scalars['String']
}

/** The given termination age is not valid for the custodian's state */
export type InvalidTerminationAgeException = {
  __typename?: 'InvalidTerminationAgeException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type InvalidTier = {
  __typename?: 'InvalidTier'
  message: Scalars['String']
  validTiers: Array<Tier>
}

export type InvalidTierForMigrationError = {
  __typename?: 'InvalidTierForMigrationError'
  message: Scalars['String']
}

export type InvalidTierPrice = {
  __typename?: 'InvalidTierPrice'
  message: Scalars['String']
  validTierPrices: Array<TierPrice>
}

export type InvalidTierPriceCombination = {
  __typename?: 'InvalidTierPriceCombination'
  message: Scalars['String']
  tier: Tier
}

/** Returned if there is no available tier based on the provided tierPriceId */
export type InvalidTierPriceId = {
  __typename?: 'InvalidTierPriceId'
  message: Scalars['String']
}

export type Investment = {
  __typename?: 'Investment'
  allocations?: Maybe<Array<InvestmentAllocation>>
  /**
   * Non-negative dollar amount invested as either a credit or debit. Debit amounts
   * are not guaranteed to match the original requested amount due to market fluctuation.
   * @deprecated Use the more explicit requestedAmount and transferredAmount fields.
   */
  amount: Scalars['Float']
  createdAt: Scalars['DateTime']
  /** @deprecated Legacy field do not use will always be null. */
  description?: Maybe<Scalars['String']>
  /** @deprecated Legacy field do not use will always be null. */
  details?: Maybe<Scalars['JSON']>
  executionDate?: Maybe<Scalars['DateTime']>
  /** Unique identifier of the Investment. */
  id: Scalars['ID']
  pending?: Maybe<Scalars['Boolean']>
  receivedAt?: Maybe<Scalars['DateTime']>
  requestedAmount: MonetaryAmount
  reversible: Scalars['Boolean']
  /** @deprecated Legacy field do not use will always be null. */
  shares?: Maybe<Scalars['Int']>
  /** @deprecated Legacy field do not use will cause operations to fail. */
  status: InvestmentStatus
  /** URLs that can be used to download documentation of the trade */
  tradeConfirmationUrls?: Maybe<Array<Scalars['URL']>>
  transferredAmount?: Maybe<MonetaryAmount>
  type: Scalars['String']
  /** @deprecated Legacy field do not use will always be null. */
  typeHelp?: Maybe<Scalars['String']>
}

/** Investment Account Object */
export type InvestmentAccount = TimestampsInterface & {
  __typename?: 'InvestmentAccount'
  /** Internal ID of the beneficiary */
  beneficiaryId?: Maybe<Scalars['ID']>
  cashBalance: MonetaryAmount
  cashOwed: MonetaryAmount
  closedAt?: Maybe<Scalars['DateTime']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  currentBalance?: Maybe<MonetaryAmount>
  currentBalanceWithPending: MonetaryAmount
  /** Whether or not the user has made their first investment on this account. */
  hasInvested: Scalars['Boolean']
  /** Internal UUID of the Investment Account */
  id: Scalars['ID']
  investmentAccountType: InvestmentAccountType
  /** Name of the Investment Account */
  name: Scalars['String']
  /** The net investments in this investment account. */
  netInvestments: MonetaryAmount
  pendingBalance: MonetaryAmount
  pendingWithdrawals: Array<Withdrawal>
  performance?: Maybe<Performance>
  portfolio?: Maybe<Portfolio>
  portfolios?: Maybe<Array<BasePortfolio>>
  product: InvestmentProduct
  /** Recap of the investment account's activity and statistics over the last quarter. */
  quarterlyRecap?: Maybe<InvestmentAccountRecap>
  /** Whether or not quarterly recap generation is enabled for this investment account. */
  quarterlyRecapsEnabled: Scalars['Boolean']
  recommendedPortfolio?: Maybe<Portfolio>
  recurringInvestmentSettings?: Maybe<RecurringInvestmentSettings>
  /** The current status of the account */
  requirements: AccountRequirements
  /** The all-time returns in this investment account. */
  returnsAllTime: MonetaryAmount
  status: InvestmentAccountStatus
  summary: InvestmentAccountSummary
  /** The total account value in this investment account. */
  totalAccountValue: MonetaryAmount
  /** The total amount that is invested in bonds in this investment account. */
  totalBonds: MonetaryAmount
  /** The total amount that is invested in crypto in this investment account. */
  totalCrypto: MonetaryAmount
  /** The total amount that is invested in equities in this investment account. */
  totalEquities: MonetaryAmount
  transferability?: Maybe<InvestmentAccountTransferability>
  type: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** UUID for the user */
  userId: Scalars['ID']
  /** @deprecated Use id instead. */
  uuid: Scalars['ID']
  yearToDateReturn?: Maybe<MarketReturn>
  beneficiary?: Maybe<Beneficiary>
}

/** Investment Account Object */
export type InvestmentAccountPerformanceArgs = {
  days: Scalars['Int']
}

/** Investment Account Object */
export type InvestmentAccountSummaryArgs = {
  startPeriod: Scalars['Date']
  endPeriod: Scalars['Date']
}

export type InvestmentAccountAlreadyClosed = {
  __typename?: 'InvestmentAccountAlreadyClosed'
  /** Date and Time of account closure if account is already closed */
  accountClosedAt: Scalars['DateTime']
}

export type InvestmentAccountClosureInProgress = {
  __typename?: 'InvestmentAccountClosureInProgress'
  /** Message displayed to customer when closure is already in progress */
  clientMessage: Scalars['String']
}

export enum InvestmentAccountClosureReason {
  /** Not seeing the value */
  NotSeeingTheValue = 'NOT_SEEING_THE_VALUE',
  /** Can't afford at this time */
  CantAffordAtThisTime = 'CANT_AFFORD_AT_THIS_TIME',
  /** Going to a competitor */
  GoingToACompetitor = 'GOING_TO_A_COMPETITOR',
  /** No longer use */
  NoLongerUse = 'NO_LONGER_USE',
  /** Using funds for another purpose */
  UsingFundsForAnotherPurpose = 'USING_FUNDS_FOR_ANOTHER_PURPOSE',
  /** Had a bad experience */
  HadABadExperience = 'HAD_A_BAD_EXPERIENCE',
  /** Other */
  Other = 'OTHER',
  /** Switching to another savings plan */
  SwitchingToAnotherSavingsPlan = 'SWITCHING_TO_ANOTHER_SAVINGS_PLAN',
  /** Using funds for the good of the child */
  WithdrawalForChild = 'WITHDRAWAL_FOR_CHILD',
  /** Change age of transfer */
  ChangeAgeOfTransfer = 'CHANGE_AGE_OF_TRANSFER',
  /** Rolling over to another ira */
  RollingOverToAnotherIra = 'ROLLING_OVER_TO_ANOTHER_IRA',
}

/** Generic Error */
export type InvestmentAccountCreationException = {
  __typename?: 'InvestmentAccountCreationException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Investment account must transfer funds before closure */
export type InvestmentAccountNeedsTransferException = {
  __typename?: 'InvestmentAccountNeedsTransferException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** The investment account is still open. */
export type InvestmentAccountNotClosedException = {
  __typename?: 'InvestmentAccountNotClosedException'
  /** Type of investment account */
  accountType?: Maybe<InvestmentAccountType>
}

/** Investment Account Not Found */
export type InvestmentAccountNotFoundException = {
  __typename?: 'InvestmentAccountNotFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Investment Account Not Supported */
export type InvestmentAccountNotSupportedException = {
  __typename?: 'InvestmentAccountNotSupportedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Outside contribution made to an investment account. */
export type InvestmentAccountOutsideContribution = {
  __typename?: 'InvestmentAccountOutsideContribution'
  /** Monetary amount of the contribution. */
  amount: MonetaryAmount
  /** Name of the contributor */
  contributorName: Scalars['String']
  /** Note from the contributor. */
  note?: Maybe<Scalars['String']>
}

/** Aggregation of investment account activity and stats over a period of time. */
export type InvestmentAccountRecap = {
  __typename?: 'InvestmentAccountRecap'
  /** Contributions to the investment account made by non-owners. */
  contributionsByOthers?: Maybe<Array<InvestmentAccountOutsideContribution>>
  /** Creation date of the investment account recap. */
  createdAt: Scalars['Date']
  /** Start date of the investment account recap. */
  endsAt: Scalars['Date']
  /** Unique identifier of the investment account recap. */
  id: Scalars['ID']
  /** Investment account for which the recap was generated for. */
  investmentAccount: InvestmentAccount
  /** Unique identifier of the investment account for which the investment account recap was generated for. */
  investmentAccountId: Scalars['ID']
  /** Latest value of the investment account over the timeframe of the recap. */
  latestAccountValue?: Maybe<MonetaryAmount>
  /** Market value of the investment account over the timeframe. */
  performance?: Maybe<Performance>
  /** Whether or not the recap has public access enabled. */
  public: Scalars['Boolean']
  /** Web URL that the recap is publicly available at. */
  publicUrl?: Maybe<Scalars['URL']>
  /** Start date of the investment account recap. */
  startsAt: Scalars['Date']
  /** Total amount contributed to the investment account over the timeframe. */
  totalContributions?: Maybe<MonetaryAmount>
  /**
   * Total amount contributed to the investment account by non-owners over the
   * timeframe. Only applies to UGMA and UTMA type investment accounts.
   */
  totalContributionsByOthers?: Maybe<MonetaryAmount>
  /** Date of last update made to the investment account recap. */
  updatedAt: Scalars['Date']
  /** Record of whether or not the recap has been viewed by the investment account owner. */
  viewed: Scalars['Boolean']
}

/** Investment Account Recap Not Found */
export type InvestmentAccountRecapNotFoundException = {
  __typename?: 'InvestmentAccountRecapNotFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export enum InvestmentAccountReopenCheck {
  /** Backup withholding check */
  BackupWithholdingCheck = 'BACKUP_WITHHOLDING_CHECK',
  /** Underage check */
  UnderageCheck = 'UNDERAGE_CHECK',
  /** Account locked check */
  AccountLockedCheck = 'ACCOUNT_LOCKED_CHECK',
  /** Account suspended check */
  AccountSuspendedCheck = 'ACCOUNT_SUSPENDED_CHECK',
  /** Investment collections check */
  InvestmentCollectionsCheck = 'INVESTMENT_COLLECTIONS_CHECK',
  /** Spend collections check */
  SpendCollectionsCheck = 'SPEND_COLLECTIONS_CHECK',
}

/** An investment account reopen request */
export type InvestmentAccountReopenRequest = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequest'
  /** A list of actions performed on this account reopen request */
  adminActions: Array<InvestmentAccountReopenRequestAction>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The ID of the reopen request */
  id: Scalars['Int']
  /** The investment account for which this reopen request was made */
  investmentAccount: InvestmentAccount
  /** The UUID of the investment account for which this request was made */
  investmentAccountId: Scalars['ID']
  /** A list of update notes for this investment account reopen request */
  notes: Array<InvestmentAccountReopenRequestNote>
  /** A list of reopen checks for this investment account reopen request */
  reopenChecks: Array<UserInvestmentAccountReopenCheck>
  /** The state of the investment account reopen request */
  state: InvestmentAccountReopenRequestState
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** The owner of the investment account associated with the reopen_request */
  user: User_V2
  /** The ID of the user to whom the investment account the request was made for belongs */
  userId: Scalars['Int']
}

/** An admin action performed on an investment account reopen request */
export type InvestmentAccountReopenRequestAction = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequestAction'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The starting state of the reopen request */
  fromState: Scalars['String']
  /** The UUID of the reopen request admin action */
  id: Scalars['ID']
  /** The investment account for the corresponding reopen request */
  investmentAccount: InvestmentAccount
  /** A note associated with this action */
  note?: Maybe<InvestmentAccountReopenRequestNote>
  /** The associated reopen request */
  reopenRequest: InvestmentAccountReopenRequest
  /** The end state of the reopen request */
  toState: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** A note sent to the user regarding an investment account reopen request */
export type InvestmentAccountReopenRequestNote = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequestNote'
  /** The action associated with this note */
  adminAction: InvestmentAccountReopenRequestAction
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** A boolean indicating if an email has been sent for this note */
  emailSent: Scalars['Boolean']
  /** The UUID of the reopen request note */
  id: Scalars['ID']
  /** The note text */
  note: Scalars['String']
  /** The associated reopen request */
  reopenRequest: InvestmentAccountReopenRequest
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export enum InvestmentAccountReopenRequestState {
  /** Indicates that the request has been made but not yet processed */
  Requested = 'REQUESTED',
  /** Indicates that the request must be reviewed by invest ops */
  PendingReview = 'PENDING_REVIEW',
  /** Indicates that the request is pending user action */
  PendingUserAction = 'PENDING_USER_ACTION',
  /** Indicates that the request has been approved */
  Approved = 'APPROVED',
  /** Indicates that the request has been rejected */
  Rejected = 'REJECTED',
}

/** Filter for InvestmentAccountsByUserId query */
export type InvestmentAccountsByUserIdFilter = {
  /** Investment Account Product Name */
  product?: Maybe<InvestmentProduct>
  /** Optionally filter by account status */
  accountStatus?: Maybe<InvestmentAccountStatus>
}

export enum InvestmentAccountStatus {
  /** Investment account is open */
  Open = 'OPEN',
  /** Account has started account closure process */
  PendingClosure = 'PENDING_CLOSURE',
  /** Account has started account reopen process */
  PendingReopen = 'PENDING_REOPEN',
  /** Investment account is closed */
  Closed = 'CLOSED',
  /** Investment account has reached transfer age */
  LockedForTransfer = 'LOCKED_FOR_TRANSFER',
}

/** Investment account summary data */
export type InvestmentAccountSummary = {
  __typename?: 'InvestmentAccountSummary'
  /** The date of the user's first investment into this account */
  firstInvestmentDate?: Maybe<Scalars['DateTime']>
  /** The date of the user's most recent one-time investment into this account */
  mostRecentOneTimeInvestmentDate?: Maybe<Scalars['DateTime']>
  /** The total credits credited to this account. */
  totalCredits: Scalars['Float']
  /** The total dividends invested in this account. */
  totalDividends: Scalars['Float']
  /** The total found money rewards allocated to this account */
  totalFoundMoneyRewards: Scalars['Float']
  /** The total amount invested into this account. */
  totalInvested: Scalars['Float']
  /** The total one time investments made in this account. */
  totalOneTime: Scalars['Float']
  /** The total outside contributions to this account. */
  totalOutsideContributions: Scalars['Float']
  /** The total plan investments invested with this account. */
  totalPlan: Scalars['Float']
  /** The recurring investment total invested in this account. */
  totalRecurring: Scalars['Float']
  /** The total referral rewards to this account. */
  totalReferralRewards: Scalars['Float']
  /** The total round ups contributed to this account. */
  totalRoundUps: Scalars['Float']
  /** The total real time round ups contributed to this account. */
  totalRtru: Scalars['Float']
}

/** Transfer information for the given investment account */
export type InvestmentAccountTransferability = {
  __typename?: 'InvestmentAccountTransferability'
  /** The beneficiary investment account's age of transfer */
  transferAge: Scalars['Int']
  /** The beneficiary investment account's date of transfer */
  transferDate: Scalars['Date']
  /** The beneficiary investment account's age of transfer reached */
  transferReached: Scalars['Boolean']
  /** The beneficiary investment account's state of residence */
  transferStateCode: UsStateCodes
}

export enum InvestmentAccountType {
  /** Basic investment account */
  BasicInvestment = 'BASIC_INVESTMENT',
  /** Roth IRA investment account */
  RothIra = 'ROTH_IRA',
  /** Traditional IRA investment account */
  TraditionalIra = 'TRADITIONAL_IRA',
  /** Simplified Employee Pension investment account */
  SimplifiedEmployeePension = 'SIMPLIFIED_EMPLOYEE_PENSION',
  /** Uniform Gift to Minors Act Custodial Investment Account */
  Ugma = 'UGMA',
  /** Uniform Transfer to Minors Act Custodial Investment Account */
  Utma = 'UTMA',
  AcornsInvestingAccount = 'acornsInvestingAccount',
  TraditionalIra = 'traditionalIRA',
  RothIra = 'rothIRA',
  SimplifiedEmployeePension = 'simplifiedEmployeePension',
}

export enum InvestmentAccountTypes {
  RothIra = 'RothIRA',
  SimplifiedEmployeePension = 'SimplifiedEmployeePension',
  TraditionalIra = 'TraditionalIRA',
}

/** Amount of an asset that was bought or sold for a specific Investment. */
export type InvestmentAllocation = {
  __typename?: 'InvestmentAllocation'
  /** Dollar amount sold or bought of the associated security. */
  amount: Scalars['Float']
  /** Price that the shares of the associated security were bought or sold at. */
  price: MonetaryAmount
  /** Indicates whether the shares were allocated to a self-directed Portfolio. */
  selfDirected: Scalars['Boolean']
  /** Shares sold or bought of the associated security. */
  shares: Scalars['Float']
  /** Indicates the state of the holding allocated to the portfolio. */
  status: InvestmentAllocationStatus
  /** Trading symbol of the associated security. */
  symbol: Scalars['String']
  /** Indicates the type of holding allocated to the portfolio. */
  type: InvestmentAllocationType
}

export enum InvestmentAllocationStatus {
  /** Shares that have been bought or sold but are not yet settled to the account. */
  Pending = 'PENDING',
  /** Shares that have settled in the account. */
  Settled = 'SETTLED',
  /** Shares that have been returned due to a declined funding transfer. */
  Chargeback = 'CHARGEBACK',
}

export enum InvestmentAllocationType {
  Buy = 'BUY',
  Sell = 'SELL',
}

export type InvestmentCategory = {
  __typename?: 'InvestmentCategory'
  bond: Scalars['Float']
  crypto: Scalars['Float']
  equity: Scalars['Float']
  realEstate: Scalars['Float']
}

export enum InvestmentFrequency {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly',
}

/** When investment id and investment account id do not match */
export type InvestmentNotFoundException = {
  __typename?: 'InvestmentNotFoundException'
  /** ID */
  id?: Maybe<Scalars['ID']>
}

export enum InvestmentProduct {
  /** Invest investment product */
  Invest = 'INVEST',
  /** Later investment product */
  Later = 'LATER',
  /** Early investment product */
  Early = 'EARLY',
}

/** Investments Paused user alert. */
export type InvestmentsPausedUserAlert = UserAlertsItem & {
  __typename?: 'InvestmentsPausedUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export enum InvestmentStatus {
  All = 'all',
  Finished = 'finished',
  Unfinished = 'unfinished',
}

export enum InvestmentTypes {
  Credit = 'credit',
  Debit = 'debit',
}

/** Investment cannot be cancelled */
export type InvestmentUncancellableException = {
  __typename?: 'InvestmentUncancellableException'
  /** ID */
  id?: Maybe<Scalars['ID']>
}

export type InvestorQuestionsInput = {
  employedAffiliatedWithBrokerDealer?: Maybe<Scalars['Boolean']>
  shareholderOrDirector?: Maybe<Scalars['Boolean']>
  subjectToBackupWithholding?: Maybe<Scalars['Boolean']>
}

/** Job alert display info */
export type JobAlert = {
  __typename?: 'JobAlert'
  id: Scalars['ID']
  /** desired job description */
  keyPhrase: Scalars['String']
  /** desired job location */
  location: Scalars['String']
}

/** Specifies the alert criteria */
export type JobAlertCriteriaInput = {
  filters: Array<JobSearchFilterInput>
  location: JobLocationInput
}

export type JobLocation = {
  __typename?: 'JobLocation'
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['String']>
}

export type JobLocationInput = {
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  /** flexible text field to input location as a single string (e.g. "New York, NY 10010" */
  value?: Maybe<Scalars['String']>
}

export type JobOffer = {
  __typename?: 'JobOffer'
  /** Company logo or generic default */
  companyLogo: Image
  /** Hiring company */
  companyName: Scalars['String']
  id: Scalars['ID']
  /** Relevant job industry */
  industryName?: Maybe<Scalars['String']>
  /** Job role */
  jobName: Scalars['String']
  /** Job location */
  location: OfferLocation
  /** Salary details */
  salary?: Maybe<JobOfferSalary>
  /** List of tags to display */
  tags: Array<Scalars['String']>
  /** Redirect URL for job posting */
  url: Scalars['URL']
}

export type JobOfferSalary = {
  __typename?: 'JobOfferSalary'
  interval: SalaryInterval
  maxValue: Scalars['Float']
  minValue: Scalars['Float']
}

export type Jobs_Article = {
  __typename?: 'jobs_Article'
  body: Scalars['String']
  cta?: Maybe<Cta>
  eyebrow: Scalars['String']
  id: Scalars['ID']
  image?: Maybe<Image>
  title: Scalars['String']
}

export type Jobs_Education = {
  __typename?: 'jobs_Education'
  articles: Array<Jobs_Article>
  id: Scalars['ID']
  title: Scalars['String']
}

export type Jobs_Offer = {
  __typename?: 'jobs_Offer'
  /** Company logo or generic default */
  companyLogo: Image
  /** Hiring company */
  companyName: Scalars['String']
  id: Scalars['ID']
  /** Relevant job industry */
  industryName?: Maybe<Scalars['String']>
  /** Job role */
  jobName: Scalars['String']
  /** Job location */
  location: JobLocation
  /** Salary details */
  salary?: Maybe<Jobs_OfferSalary>
  /** List of tags to display */
  tags: Array<Scalars['String']>
  /** Redirect URL for job posting */
  url: Scalars['URL']
}

/** Specifies a Job Offer Connection */
export type Jobs_OfferConnection = {
  __typename?: 'jobs_OfferConnection'
  edges: Array<Jobs_OfferEdge>
  pageInfo: PageInfo
}

/** Specifies a Job Offer Edge */
export type Jobs_OfferEdge = {
  __typename?: 'jobs_OfferEdge'
  cursor: Scalars['ID']
  node: Jobs_Offer
}

export type Jobs_OfferSalary = {
  __typename?: 'jobs_OfferSalary'
  interval: SalaryInterval
  maxValue: Scalars['Float']
  minValue: Scalars['Float']
}

/** Specifies the search criteria */
export type JobSearchCriteria = {
  __typename?: 'JobSearchCriteria'
  filters: Array<JobSearchFilter>
  location: JobLocation
  /** Specifies the search radius in miles */
  searchRadius?: Maybe<Scalars['Int']>
}

/** Specifies the search criteria */
export type JobSearchCriteriaInput = {
  filters: Array<JobSearchFilterInput>
  location: JobLocationInput
  searchRadius?: Maybe<Scalars['Int']>
}

/** Specifies which values to filter jobs by */
export type JobSearchFilter = {
  __typename?: 'JobSearchFilter'
  key: JobSearchFilterKey
  value: Scalars['String']
}

/** Specifies which values to filter jobs by */
export type JobSearchFilterInput = {
  key: JobSearchFilterKey
  value: Scalars['String']
}

/** Supported types of search criteria */
export enum JobSearchFilterKey {
  /** finds jobs that have metadata matching this phrase */
  KeyPhrase = 'KEY_PHRASE',
  /** finds jobs with exact match for company name */
  Company = 'COMPANY',
}

/** Display wrapper for featured job searches */
export type JobSearchOffer = {
  __typename?: 'JobSearchOffer'
  /** Background/featured image */
  backgroundImage: Image
  /** Display body for the offer */
  body?: Maybe<Scalars['String']>
  /** Desktop Background/featured image */
  desktopBackgroundImage: Image
  id: Scalars['ID']
  /** Company/partner logo */
  logo?: Maybe<Image>
  /** List of filters used when searching for jobs */
  searchFilters: Array<JobSearchFilter>
  /** Display subtitle for the offer */
  subtitle?: Maybe<Scalars['String']>
  /** Display title for the offer */
  title: Scalars['String']
}

export type JobSearchPage = {
  __typename?: 'JobSearchPage'
  recentSearches: Array<JobSearchCriteria>
}

export enum KycStatus {
  Pending = 'pending',
  ActionRequired = 'actionRequired',
  Accepted = 'accepted',
  Failure = 'failure',
}

export type LadderLinkResponse = {
  __typename?: 'LadderLinkResponse'
  id: Scalars['ID']
  url: Scalars['String']
  urlExpires: Scalars['Int']
}

export type LadderQuote = {
  __typename?: 'LadderQuote'
  coverage?: Maybe<Scalars['Int']>
  term?: Maybe<Scalars['Int']>
  monthlyPremium?: Maybe<Scalars['Float']>
}

export type LadderQuoteStatus = {
  __typename?: 'LadderQuoteStatus'
  valid?: Maybe<Scalars['Boolean']>
  complete?: Maybe<Scalars['Boolean']>
  eligible?: Maybe<Scalars['Boolean']>
}

export type LadderResponse = {
  __typename?: 'LadderResponse'
  id: Scalars['String']
  quoteStatus?: Maybe<LadderQuoteStatus>
  quotes: Array<Maybe<LadderQuote>>
}

export type LaterAccount = {
  __typename?: 'LaterAccount'
  accountId: Scalars['ID']
  accountNumber?: Maybe<Scalars['String']>
  name: Scalars['String']
  code: LaterAccountCodes
  portfolioId: Scalars['ID']
  portfolioName: Scalars['String']
  amount: Scalars['Float']
  performance?: Maybe<LaterPortfolioPerformance>
  recurringSettings?: Maybe<RecurringInvestmentSettings>
  contributionLimit: Scalars['Float']
  status?: Maybe<LaterAccountStatus>
}

export type LaterAccountAlreadyVerified = LaterTypedException & {
  __typename?: 'LaterAccountAlreadyVerified'
  id: Scalars['ID']
  message: Scalars['String']
}

export enum LaterAccountCodes {
  Sep = 'SEP',
  Roth = 'ROTH',
  Traditional = 'TRADITIONAL',
}

export type LaterAccountIneligibleForVerification = LaterTypedException & {
  __typename?: 'LaterAccountIneligibleForVerification'
  id: Scalars['ID']
  message: Scalars['String']
}

export type LaterAccountInfo = {
  __typename?: 'LaterAccountInfo'
  investmentAccountId: Scalars['ID']
  plan: InvestmentAccountTypes
  status: LaterAccountStatus
  userId: Scalars['ID']
}

export type LaterAccountInfoOrError =
  | LaterAccountAlreadyVerified
  | LaterAccountIneligibleForVerification
  | LaterAccountInfo
  | LaterAccountNotFound

export type LaterAccountNotFound = LaterTypedException & {
  __typename?: 'LaterAccountNotFound'
  id: Scalars['ID']
  message: Scalars['String']
}

export enum LaterAccountStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  FailedToCreate = 'FAILED_TO_CREATE',
  Hidden = 'HIDDEN',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
}

export type LaterBeneficiary = {
  type?: Maybe<BeneficiaryType>
  accountId: Scalars['String']
  percentageShare?: Maybe<Scalars['Float']>
  beneficiaryId?: Maybe<Scalars['ID']>
}

export type LaterContributionAbilityResult = ContributionAbilityByYear

export type LaterContributionLimitMet = {
  __typename?: 'LaterContributionLimitMet'
  year: Scalars['Int']
}

export type LaterDeposit = LaterHistoryItem & {
  __typename?: 'LaterDeposit'
  name: Scalars['String']
  type?: Maybe<LaterHistoryItemType>
  depositId: Scalars['ID']
  depositType?: Maybe<LaterDepositType>
  taxYear: Scalars['Int']
  amount: Scalars['Float']
  status: Scalars['String']
  date: Scalars['DateTime']
  reversible?: Maybe<Scalars['Boolean']>
  tradeConfirmUrl?: Maybe<Scalars['String']>
  pending?: Maybe<Scalars['Boolean']>
}

export enum LaterDepositType {
  Contribution = 'Contribution',
  EmployerContribution = 'EmployerContribution',
  EmployeeContribution = 'EmployeeContribution',
  SpousalContribution = 'SpousalContribution',
  PostponedContribution = 'PostponedContribution',
  RepaymentContribution = 'RepaymentContribution',
  Dividend = 'Dividend',
  Fees = 'Fees',
  Interest = 'Interest',
  NonQualified = 'NonQualified',
  Payment = 'Payment',
  Payoff = 'Payoff',
  Payout = 'Payout',
  Rent = 'Rent',
  Rollover = 'Rollover',
  Royalty = 'Royalty',
  Settlement = 'Settlement',
  Other = 'Other',
  Unspecified = 'Unspecified',
}

export type LaterDividendsItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'LaterDividendsItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    etfCategory: Scalars['String']
    etfTicker: Scalars['String']
  }

export type LaterEntityBeneficiary = LaterBeneficiary & {
  __typename?: 'LaterEntityBeneficiary'
  beneficiaryId?: Maybe<Scalars['ID']>
  name: Scalars['String']
  type?: Maybe<BeneficiaryType>
  accountId: Scalars['String']
  percentageShare?: Maybe<Scalars['Float']>
}

/** Sell shares for the fee. This happens for Paypal users or if users never accepted the new EFT */
export type LaterFeeInvestmentItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'LaterFeeInvestmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type LaterFullContributionSuccess = {
  __typename?: 'LaterFullContributionSuccess'
  year: Scalars['Int']
}

export type LaterHistoryItem = {
  type?: Maybe<LaterHistoryItemType>
  taxYear: Scalars['Int']
  status: Scalars['String']
  amount: Scalars['Float']
  date: Scalars['DateTime']
  reversible?: Maybe<Scalars['Boolean']>
  tradeConfirmUrl?: Maybe<Scalars['String']>
  pending?: Maybe<Scalars['Boolean']>
}

export enum LaterHistoryItemType {
  Withdrawal = 'withdrawal',
  Rollover = 'rollover',
  Transfer = 'transfer',
  Deposit = 'deposit',
}

export type LaterIndividualBeneficiary = LaterBeneficiary & {
  __typename?: 'LaterIndividualBeneficiary'
  beneficiaryId?: Maybe<Scalars['ID']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  birthDate: Scalars['DateTime']
  relationship: Scalars['String']
  percentageShare?: Maybe<Scalars['Float']>
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  zip?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  type?: Maybe<BeneficiaryType>
  accountId: Scalars['String']
}

export type LaterIndividualBeneficiaryResponse = {
  __typename?: 'LaterIndividualBeneficiaryResponse'
  accountId: Scalars['ID']
  beneficiaryId: Scalars['ID']
  firstName: Scalars['String']
  lastName: Scalars['String']
  percentageShare?: Maybe<Scalars['Float']>
  birthDate?: Maybe<Scalars['DateTime']>
  relationship: Scalars['String']
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  zip?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
}

/** A generic money movement line item for the Later account */
export type LaterInvestmentItem = PastItem &
  PastCoreTradedItem &
  PastUserTransferItem & {
    __typename?: 'LaterInvestmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount?: Maybe<CurrencyAmount>
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** The percentage that the user elected for withholding */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate?: Maybe<Scalars['DateTime']>
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring?: Maybe<Scalars['Boolean']>
  }

export type LaterPartialContributionSuccess = {
  __typename?: 'LaterPartialContributionSuccess'
  acceptedAmount: CurrencyAmount
  year: Scalars['Int']
}

export type LaterPortfolioPerformance = {
  __typename?: 'LaterPortfolioPerformance'
  periodMarketChange: Scalars['Float']
  periodMarketChangePercent: Scalars['Float']
  periodMarketChangeWithoutFees: Scalars['Float']
  periodMarketChangePercentWithoutFees: Scalars['Float']
}

export type LaterProgramAccountContributionInput = {
  amount: CurrencyAmountInput
  fundingTransferCreated?: Maybe<Scalars['Boolean']>
  nonce: Scalars['ID']
  programAccountType: ProgramAccountType
  year?: Maybe<Scalars['Int']>
}

export type LaterProgramAccountContributionResult =
  | LaterContributionLimitMet
  | LaterFullContributionSuccess
  | LaterPartialContributionSuccess

export type LaterRebalanceItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'LaterRebalanceItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount?: Maybe<CurrencyAmount>
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type LaterTotalLiquidationInput = {
  federalTaxes: Scalars['Float']
  stateTaxes: Scalars['Float']
  withdrawalType?: Maybe<LaterWithdrawalType>
  taxYear: Scalars['Int']
  earlyDistributionTaxExceptionReason?: Maybe<Scalars['String']>
  reason?: Maybe<LaterWithdrawalReason>
}

export type LaterTypedException = {
  id: Scalars['ID']
  message: Scalars['String']
}

/** Object representing an outside contribution prospect */
export type LaterWaitlistProspect = Prospect & {
  __typename?: 'LaterWaitlistProspect'
  email: Scalars['String']
  id: Scalars['ID']
}

export type LaterWithdrawal = LaterHistoryItem & {
  __typename?: 'LaterWithdrawal'
  name: Scalars['String']
  withdrawalId: Scalars['ID']
  type?: Maybe<LaterHistoryItemType>
  withdrawalType?: Maybe<LaterWithdrawalType>
  taxYear: Scalars['Int']
  federalTaxes?: Maybe<Scalars['Float']>
  stateTaxes?: Maybe<Scalars['Float']>
  earlyDistributionTaxExceptionReason?: Maybe<Scalars['String']>
  amount: Scalars['Float']
  status: Scalars['String']
  date: Scalars['DateTime']
  reversible?: Maybe<Scalars['Boolean']>
  tradeConfirmUrl?: Maybe<Scalars['String']>
  pending?: Maybe<Scalars['Boolean']>
}

export type LaterWithdrawalItem = PastItem &
  PastCoreTradedItem &
  PastUserTransferItem & {
    __typename?: 'LaterWithdrawalItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate?: Maybe<Scalars['DateTime']>
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring?: Maybe<Scalars['Boolean']>
    federalWithholdings?: Maybe<LaterWithholdingValues>
    stateWithholdings?: Maybe<LaterWithholdingValues>
  }

/**  Reason for withdrawing from a later account */
export enum LaterWithdrawalReason {
  DirectTransfer = 'direct_transfer',
  EarlyWithdrawal = 'early_withdrawal',
  OverContribution = 'over_contribution',
  Retirement = 'retirement',
  Rollover = 'rollover',
}

/**
 * Reason for withdrawing from a later account
 * Deprecated - this can be derived from the LaterWithdrawalReason below
 */
export enum LaterWithdrawalType {
  EarlyDistribution = 'EarlyDistribution',
  IneligibleContribution = 'IneligibleContribution',
  NormalDistribution = 'NormalDistribution',
}

/** Tuple of fields related to withholdings elected at either the state or federal level */
export type LaterWithholdingValues = {
  __typename?: 'LaterWithholdingValues'
  amount: CurrencyAmount
  /** The percentage that the user elected for withholding */
  percentage: Scalars['Float']
}

export type LearnAnswer = {
  __typename?: 'LearnAnswer'
  id: Scalars['ID']
  isCorrect: Scalars['Boolean']
  value: Scalars['String']
}

export type LearnAnswerInput = {
  id: Scalars['ID']
  value: Scalars['String']
}

export type LearnArticle = {
  __typename?: 'LearnArticle'
  authors: Array<LearnAuthor>
  body: Scalars['String']
  contentImage?: Maybe<LearnVisualAsset>
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  id: Scalars['ID']
  metadata: LearnMetadata
  publishedAt?: Maybe<Scalars['String']>
  summary: Scalars['String']
  tags: Array<LearnTag>
  tier: LearnTier
  title: Scalars['String']
  topics: Array<LearnTopic>
}

export type LearnArticlePreview = {
  __typename?: 'LearnArticlePreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  primaryTopicName: Scalars['String']
  progress?: Maybe<LearnProgress>
  tierName: Scalars['String']
  title: Scalars['String']
  views: Scalars['Int']
}

export type LearnArticlePreviewLocked = {
  __typename?: 'LearnArticlePreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  title: Scalars['String']
  views: Scalars['Int']
}

export enum LearnAspectRatioType {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
}

export type LearnAuthor = {
  __typename?: 'LearnAuthor'
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  photo?: Maybe<LearnVisualAsset>
}

export type LearnConnection = {
  edges: Array<LearnEdge>
  pageInfo: LearnPageInfo
}

export type LearnContentCategory = LearnTier | LearnTopic

export type LearnContentCommunityStats = LearnContentStats

export type LearnContentDuration = Milliseconds

export type LearnContentElapsedMillisecondsUpdatedResult = {
  __typename?: 'LearnContentElapsedMillisecondsUpdatedResult'
  contentId: Scalars['ID']
  elapsedTime: Milliseconds
}

export type LearnContentFilterByTierIdInput = {
  contentType?: Maybe<LearnSearchContentType>
  durationMillisecondsEnd?: Maybe<MillisecondsInput>
  durationMillisecondsStart?: Maybe<MillisecondsInput>
  tierId: Scalars['ID']
  topicId?: Maybe<Scalars['ID']>
  viewStatus?: Maybe<LearnContentViewStatus>
}

export type LearnContentFilterByTopicIdInput = {
  contentType?: Maybe<LearnSearchContentType>
  durationMillisecondsEnd?: Maybe<MillisecondsInput>
  durationMillisecondsStart?: Maybe<MillisecondsInput>
  tierId?: Maybe<Scalars['ID']>
  topicId: Scalars['ID']
  viewStatus?: Maybe<LearnContentViewStatus>
}

export type LearnContentFilterInput = {
  contentType?: Maybe<LearnSearchContentType>
  durationMillisecondsEnd?: Maybe<MillisecondsInput>
  durationMillisecondsStart?: Maybe<MillisecondsInput>
  tierId?: Maybe<Scalars['ID']>
  topicId?: Maybe<Scalars['ID']>
  viewStatus?: Maybe<LearnContentViewStatus>
}

export type LearnContentInteractionState = LearnInteractionState

export type LearnContentPageInput = {
  after?: Maybe<Scalars['ID']>
  limit: Scalars['Int']
}

export type LearnContentPreview =
  | CoursePreview
  | CoursePreviewLocked
  | LearnArticlePreview
  | LearnArticlePreviewLocked
  | LearnMediaPreview
  | LearnMediaPreviewLocked
  | LearnPollPreview
  | LearnPollPreviewLocked
  | LessonPreview
  | LessonPreviewLocked
  | QuizPreview
  | QuizPreviewLocked

export enum LearnContentSortType {
  Trending = 'TRENDING',
  MostViewed = 'MOST_VIEWED',
  Duration = 'DURATION',
  MostRecent = 'MOST_RECENT',
}

export type LearnContentStats = {
  __typename?: 'LearnContentStats'
  communityAvg?: Maybe<Scalars['Int']>
  views?: Maybe<Scalars['Int']>
}

export enum LearnContentType {
  MediaArticle = 'MEDIA_ARTICLE',
  Course = 'COURSE',
  Article = 'ARTICLE',
  Lesson = 'LESSON',
  Quiz = 'QUIZ',
  Poll = 'POLL',
}

export enum LearnContentViewStatus {
  Viewed = 'VIEWED',
  Unviewed = 'UNVIEWED',
}

export type LearnCoursePreview = CoursePreview | CoursePreviewLocked

export type LearnEdge = {
  cursor: Scalars['ID']
}

export type LearnInsight = {
  __typename?: 'LearnInsight'
  cuePointMillis: Milliseconds
  description: Scalars['String']
  id: Scalars['ID']
  title: Scalars['String']
}

export type LearnInteractionState = {
  __typename?: 'LearnInteractionState'
  elapsedTime?: Maybe<LearnContentDuration>
  isFavorites: Scalars['Boolean']
  isHelpful?: Maybe<Scalars['Boolean']>
  progress?: Maybe<LearnProgress>
}

export type LearnMedia = LearnMediaArticle

export type LearnMediaArticle = {
  __typename?: 'LearnMediaArticle'
  audioTheme?: Maybe<LearnMediaTheme>
  authors: Array<LearnAuthor>
  featuredImage?: Maybe<LearnVisualAsset>
  id: Scalars['ID']
  insights: Array<LearnInsight>
  media: LearnMediaReference
  metadata: LearnMetadata
  polls: Array<LearnPoll>
  preEventDescription?: Maybe<Scalars['String']>
  startsAt?: Maybe<Scalars['String']>
  tags: Array<LearnTag>
  tier: LearnTier
  title: Scalars['String']
  topics: Array<LearnTopic>
}

export type LearnMediaPreview = {
  __typename?: 'LearnMediaPreview'
  audioTheme?: Maybe<LearnMediaTheme>
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  mediaType?: Maybe<LearnMediaType>
  primaryTopicName: Scalars['String']
  progress?: Maybe<LearnProgress>
  startsAt?: Maybe<Scalars['String']>
  tierName: Scalars['String']
  title: Scalars['String']
  views: Scalars['Int']
}

export type LearnMediaPreviewLocked = {
  __typename?: 'LearnMediaPreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  mediaType?: Maybe<LearnMediaType>
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  title: Scalars['String']
  views: Scalars['Int']
}

export type LearnMediaReference = {
  __typename?: 'LearnMediaReference'
  aspectRatio: LearnAspectRatioType
  duration: LearnContentDuration
  id: Scalars['ID']
  reference: Scalars['String']
  theme?: Maybe<LearnMediaTheme>
  transcript?: Maybe<Scalars['String']>
  type: LearnMediaType
}

export type LearnMediaTheme = LearnThemeLiteral

export enum LearnMediaType {
  Audio = 'AUDIO',
  Video = 'VIDEO',
  LiveVideo = 'LIVE_VIDEO',
}

export type LearnMetadata = {
  __typename?: 'LearnMetadata'
  contentStats?: Maybe<LearnContentCommunityStats>
  interactionState?: Maybe<LearnContentInteractionState>
}

export type LearnNextStepAction = {
  __typename?: 'LearnNextStepAction'
  ctaLabel?: Maybe<Scalars['String']>
  id: Scalars['ID']
  illustration?: Maybe<Image>
  title: Scalars['String']
  url: Scalars['String']
}

export type LearnPageInfo = {
  __typename?: 'LearnPageInfo'
  count: Scalars['Int']
  cursor?: Maybe<Scalars['ID']>
  hasNextPage: Scalars['Boolean']
}

export type LearnPoll = {
  __typename?: 'LearnPoll'
  cuePointMillis?: Maybe<Milliseconds>
  id: Scalars['ID']
  options?: Maybe<Array<Scalars['String']>>
  pollType: LearnPollType
  question: Scalars['String']
  title: Scalars['String']
}

export type LearnPollOption = {
  __typename?: 'LearnPollOption'
  count: Scalars['Int']
  option: Scalars['String']
}

export type LearnPollPreview = {
  __typename?: 'LearnPollPreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  options?: Maybe<Array<LearnPollOption>>
  pollType: LearnPollType
  question: Scalars['String']
  title: Scalars['String']
}

export type LearnPollPreviewLocked = {
  __typename?: 'LearnPollPreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  productRequired: Scalars['String']
  title: Scalars['String']
}

export type LearnPollResponse = {
  __typename?: 'LearnPollResponse'
  isSuccess: Scalars['Boolean']
  selectedOption: Scalars['String']
  stats?: Maybe<Array<LearnPollOption>>
}

export enum LearnPollType {
  Emoji = 'EMOJI',
  Option = 'OPTION',
  YesNo = 'YES_NO',
}

export type LearnProgress = {
  __typename?: 'LearnProgress'
  currentValue: Scalars['Int']
  unitType: LearnProgressUnit
}

export type LearnProgressInput = {
  currentValue: Scalars['Int']
  unitType: LearnProgressUnit
}

export enum LearnProgressUnit {
  Seconds = 'SECONDS',
  Percents = 'PERCENTS',
  Stages = 'STAGES',
}

export type LearnProgressUpdatedResult = {
  __typename?: 'LearnProgressUpdatedResult'
  contentId: Scalars['ID']
  progress: LearnProgress
}

export type LearnQuestion = {
  __typename?: 'LearnQuestion'
  answers: Array<LearnAnswer>
  id: Scalars['ID']
  incrementStep?: Maybe<Scalars['Int']>
  insight?: Maybe<LearnQuestionInsight>
  questionBody: Scalars['String']
  questionType: LearnQuestionType
  rangeEnd?: Maybe<Scalars['Int']>
  rangeLabel?: Maybe<Scalars['String']>
  rangeStart?: Maybe<Scalars['Int']>
  rangeType?: Maybe<LearnRangeType>
  statement?: Maybe<Scalars['String']>
  statementHighLight?: Maybe<Scalars['String']>
  unitType?: Maybe<Scalars['String']>
}

export type LearnQuestionInsight = {
  __typename?: 'LearnQuestionInsight'
  featuredImage?: Maybe<Image>
  id: Scalars['ID']
  insightText: Scalars['String']
  media?: Maybe<LearnMediaReference>
  mediaType?: Maybe<LearnMediaType>
  title: Scalars['String']
}

export enum LearnQuestionType {
  FillInTheBlank = 'FILL_IN_THE_BLANK',
  MultiSelect = 'MULTI_SELECT',
  NumericRange = 'NUMERIC_RANGE',
  SingleSelect = 'SINGLE_SELECT',
  TwoOptions = 'TWO_OPTIONS',
}

export type LearnQuizAnswerResult = {
  __typename?: 'LearnQuizAnswerResult'
  isCorrect: Scalars['Boolean']
  questionId: Scalars['ID']
  quizId: Scalars['ID']
}

export enum LearnRangeType {
  Dial = 'DIAL',
  Slider = 'SLIDER',
}

export enum LearnSearchContentType {
  Video = 'VIDEO',
  Audio = 'AUDIO',
  Article = 'ARTICLE',
  Course = 'COURSE',
}

export type LearnSearchTermSavedResult = {
  __typename?: 'LearnSearchTermSavedResult'
  term: Scalars['String']
}

export type LearnTag = {
  __typename?: 'LearnTag'
  id: Scalars['ID']
  name: Scalars['String']
}

export type LearnThemeLiteral = {
  __typename?: 'LearnThemeLiteral'
  value: Scalars['String']
}

export type LearnTier = {
  __typename?: 'LearnTier'
  icon: LearnVisualAsset
  id: Scalars['ID']
  name: Scalars['String']
}

export type LearnTopic = {
  __typename?: 'LearnTopic'
  icon: LearnVisualAsset
  id: Scalars['ID']
  name: Scalars['String']
}

export type LearnVisualAsset = Image

/** An upload from backend */
export type LegacyUploadDocument = {
  __typename?: 'LegacyUploadDocument'
  documentType: DocumentType
  id: Scalars['ID']
  userId: Scalars['ID']
}

/** Input for creating a legacy document upload */
export type LegacyUploadDocumentInput = {
  /** the type of document being uploaded */
  documentType: DocumentType
  /** the multipart document upload file */
  upload: Scalars['Upload']
}

/** LegacyUploadDocumentResult */
export type LegacyUploadDocumentResult =
  | FileDoesNotExistInS3
  | FileTooLarge
  | InvalidFile
  | LegacyUploadDocument
  | UploadDoesNotExist

export type Lesson = {
  __typename?: 'Lesson'
  authors: Array<LearnAuthor>
  featuredImage: Image
  id: Scalars['ID']
  insights: Array<LearnInsight>
  media: LearnMediaReference
  metadata: LearnMetadata
  polls: Array<LearnPoll>
  title: Scalars['String']
}

export type LessonPreview = {
  __typename?: 'LessonPreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  parentContentId: Scalars['ID']
  title: Scalars['String']
}

export type LessonPreviewLocked = {
  __typename?: 'LessonPreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  parentContentId: Scalars['ID']
  productRequired: Scalars['String']
  title: Scalars['String']
}

/** A user's insurance calculation response */
export type LifeCalculatorInput = {
  /** annual income (after taxes) */
  netIncome: LifeCalculatorUserResponse
  /** total savings */
  savings?: Maybe<LifeCalculatorUserResponse>
  /** mortgage balance (if any) */
  mortgage?: Maybe<LifeCalculatorUserResponse>
  /** number of children */
  numberOfChildren?: Maybe<LifeCalculatorUserResponse>
  /** total debt (excluding mortgage) */
  debt?: Maybe<LifeCalculatorUserResponse>
  /** number of years to pay beneficiaries */
  payoutYears: LifeCalculatorUserResponse
  /** age in years (use 0 for infant) */
  youngestChildAge?: Maybe<LifeCalculatorUserResponse>
}

/** Insurance onboarding question */
export type LifeCalculatorQuestion = {
  __typename?: 'LifeCalculatorQuestion'
  /** order within corresponding row */
  column: Scalars['Int']
  /** Internal question ID */
  id: Scalars['ID']
  /** maximum number of digits allowed */
  maxDigits?: Maybe<Scalars['Int']>
  /** maximum input value allowed */
  maxValue?: Maybe<Scalars['Int']>
  /** minimum input value allowed */
  minValue?: Maybe<Scalars['Int']>
  /** question name identifier */
  name: Scalars['String']
  /** question placeholder text */
  placeholder: Scalars['String']
  /** corresponding survey row */
  row: Scalars['Int']
  /** question tooltip */
  tip?: Maybe<Tip>
  /** question title text */
  title: Scalars['String']
  /** life calculator question type */
  type: LifeCalculatorQuestionType
  /** previously given answer (if available) */
  value?: Maybe<Scalars['Int']>
}

export enum LifeCalculatorQuestionType {
  /** numerical keyboard input for discrete quantities */
  IntegerInput = 'integer_input',
  /** numerical keyboard input for monetary amounts */
  CurrencyInput = 'currency_input',
  /** dropdown number picker */
  NumberPicker = 'number_picker',
}

/** Content for the life calculator form */
export type LifeCalculatorSurvey = {
  __typename?: 'LifeCalculatorSurvey'
  body: Scalars['String']
  cta: Cta
  id: Scalars['ID']
  modals: Array<Modal>
  questions: Array<LifeCalculatorQuestion>
  tip: Tip
  title: Scalars['String']
  tutorialTitle: Scalars['String']
}

/** A user's response to a life insurance calculator question */
export type LifeCalculatorUserResponse = {
  /** Internal question ID */
  id: Scalars['ID']
  /** user response */
  value: Scalars['Int']
}

/** Breakdown for recommended life insurance coverage */
export type LifeCoverageBreakdown = {
  __typename?: 'LifeCoverageBreakdown'
  /** total debt including mortgage */
  debt: LifeCoverageBreakdownCategory
  /** estimated college costs for all children */
  education: LifeCoverageBreakdownCategory
  /** total income being replaced */
  expenses: LifeCoverageBreakdownCategory
  /** matching coverage level offered by provider */
  nearestCoverage: LifeCoverageBreakdownCategory
  /** total savings to offset from money needed */
  savings: LifeCoverageBreakdownCategory
  /** total costs for insurance to cover */
  totalNeeds: LifeCoverageBreakdownCategory
}

/** Recommended life coverage breakdown category */
export type LifeCoverageBreakdownCategory = {
  __typename?: 'LifeCoverageBreakdownCategory'
  tip?: Maybe<Scalars['String']>
  title: Scalars['String']
  value: Scalars['Int']
}

/** A user's life quote  apply input */
export type LifeQuoteApplyInput = {
  /** Provider name */
  providerName: ProviderName
  /** coverage amount */
  coverageAmount: Scalars['Int']
  /** policy term length */
  termLength: Scalars['Int']
}

/** A user's life quote input */
export type LifeQuoteInput = {
  /** Provider name */
  providerName: ProviderName
  /** date of birth */
  dateOfBirth: Scalars['String']
  /** family health history */
  familyHistory: Scalars['Boolean']
  /** gender  */
  gender: Scalars['String']
  /** height in inches */
  heightInches: Scalars['Int']
  /** income */
  householdIncome: Scalars['Int']
  /** smoker */
  smoker: Scalars['Boolean']
  /** weight in pounds */
  weightPounds: Scalars['Int']
  /** zip code */
  zipCode: Scalars['String']
  /** User's metadata */
  userMetadata: QuoteUserMetadata
}

/** Quote Insurance question */
export type LifeQuoteQuestion = {
  __typename?: 'LifeQuoteQuestion'
  /** Possible answers to be selected for the related question */
  answers?: Maybe<Array<QuestionAnswer>>
  /** Internal question ID */
  id: Scalars['ID']
  /** max height amount in feet for question is type 'height_picker' */
  maxValue?: Maybe<Scalars['String']>
  /** minimum height amount in feet for question is type 'height_picker' */
  minValue?: Maybe<Scalars['String']>
  /** question name identifier */
  name: Scalars['String']
  /** question placeholder text */
  placeholder: Scalars['String']
  /** question placeholder text */
  required: Scalars['String']
  /** question tooltip */
  tip?: Maybe<Tip>
  /** question title text */
  title: Scalars['String']
  /** life quote question type */
  type: LifeQuoteQuestionType
  /** question value text */
  value?: Maybe<Scalars['String']>
}

export enum LifeQuoteQuestionType {
  /** date calendar selection */
  Date = 'date',
  /** single choice selection */
  SingleChoice = 'single_choice',
  /** height number picker */
  HeightPicker = 'height_picker',
  /** numerical keyboard input for monetary amounts */
  CurrencyInput = 'currency_input',
  /** weight number picker */
  WeightPicker = 'weight_picker',
  /** numerical keyboard input for discrete quantities */
  IntegerInput = 'integer_input',
  /** boolean selection of yes/no */
  Boolean = 'boolean',
  /** lower to upper bound amounts */
  Scale = 'scale',
}

/** Return type for LifeQuoteResponse mutation */
export type LifeQuoteResponse = {
  __typename?: 'LifeQuoteResponse'
  success: Scalars['Boolean']
}

/** One possible return type for the protectLifeQuotePremiums query */
export type LifeQuoteResultSliders = {
  __typename?: 'LifeQuoteResultSliders'
  cta: Cta
  footer: Footer
  header: Header
  id: Scalars['ID']
  modals: Array<Modal>
  navBody: Scalars['String']
  navTitle: Scalars['String']
  partnerBody: Scalars['String']
  partnerTitle: Scalars['String']
  partnerUrl: Scalars['String']
  premiums?: Maybe<Array<Premium>>
  requestedCoverage?: Maybe<Scalars['Int']>
  sliders: Array<QuoteSlider>
}

/** Life Quote Step */
export type LifeQuoteStep = {
  __typename?: 'LifeQuoteStep'
  body?: Maybe<Scalars['String']>
  cta?: Maybe<Cta>
  footer?: Maybe<Footer>
  navBody?: Maybe<Scalars['String']>
  navTitle?: Maybe<Scalars['String']>
  questions: Array<LifeQuoteQuestion>
  tip?: Maybe<Tip>
  title?: Maybe<Scalars['String']>
}

/** Content for the life quote survey */
export type LifeQuoteSurvey = {
  __typename?: 'LifeQuoteSurvey'
  id: Scalars['ID']
  modals: Array<Modal>
  steps: Array<LifeQuoteStep>
}

/** Miscellaneous attributes about a Linked Account */
export type LinkedAccount = TimestampsInterface & {
  __typename?: 'LinkedAccount'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Error code attached to operation done on account */
  errorCode?: Maybe<Scalars['String']>
  /** Plaid account ID */
  externalId?: Maybe<Scalars['ID']>
  /** Source of linked account (plaid or spend) */
  externalSource: LinkedAccountExternalSourceEnum
  financialInstitution?: Maybe<FinancialInstitution>
  /** ID of the financial institution this linked account is for */
  financialInstitutionId?: Maybe<Scalars['ID']>
  /** Linked Account ID */
  id: Scalars['ID']
  /** Name of the associated institution this linked account is for */
  institutionName?: Maybe<Scalars['String']>
  /** Is the account linked? */
  linked: Scalars['Boolean']
  linkedSubaccounts: Array<LinkedSubaccount>
  /** The logo url for the institution associated with the account */
  logoUrl: Scalars['String']
  /** This field should only be fetched for initializing a Plaid Link session */
  publicToken?: Maybe<Scalars['String']>
  /** Status indicating potential user action required */
  status: LinkedAccountStatusEnum
  /** DateTime of when Transactions were last synced for financial institution */
  transactionsLastSyncedAt?: Maybe<Scalars['DateTime']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Correlated User UUID */
  userId: Scalars['ID']
}

/** A Linked Account Alert. */
export type LinkedAccountAlert = UserAlertsItem & {
  __typename?: 'LinkedAccountAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Response from linked account alert query */
export type LinkedAccountAlertsResponse = LinkedAccountAlert | RelinkLinkedAccountAlert

export enum LinkedAccountExternalSourceEnum {
  /** The link was created through Plaid and represents an external financial institution */
  Plaid = 'plaid',
  /** The link was created directly between the corresponding bank's API and Acorns */
  DirectBank = 'direct_bank',
  /** This account has an internal Acorns spend account associated with it */
  Spend = 'spend',
  /** The user linked by manually entering an account & routing number */
  Manual = 'manual',
  /** PayPal direct connection was used to link this account */
  Paypal = 'paypal',
}

export enum LinkedAccountLinkingErrorsEnum {
  /** Error with incorrect institution security questions */
  InvalidMfa = 'INVALID_MFA',
  /** Online banking credentials have been updated */
  InvalidUpdatedUsername = 'INVALID_UPDATED_USERNAME',
  /** Online banking account is locked */
  ItemLocked = 'ITEM_LOCKED',
  /** Error with institution security settings */
  ItemNotSupported = 'ITEM_NOT_SUPPORTED',
  /** Online banking account is not fully set up */
  UserSetupRequired = 'USER_SETUP_REQUIRED',
  /** Error with institution security questions */
  MfaNotSupported = 'MFA_NOT_SUPPORTED',
  /** Online banking system is down */
  InstitutionDown = 'INSTITUTION_DOWN',
  /** Online banking system is unresponsive */
  InstitutionNotResponding = 'INSTITUTION_NOT_RESPONDING',
  /** Online banking system is unresponsive */
  InstitutionNotAvailable = 'INSTITUTION_NOT_AVAILABLE',
  /** Online banking system is not supported anymore */
  InstitutionNoLongerSupported = 'INSTITUTION_NO_LONGER_SUPPORTED',
  /** Server error */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
}

export type LinkedAccountNotFound = {
  __typename?: 'LinkedAccountNotFound'
  message: Scalars['String']
}

export enum LinkedAccountStatusEnum {
  /** The linked account is working and requires no action */
  Success = 'success',
  /** The user must relink and update their linked account to continue functioning */
  Relink = 'relink',
  /** The user must take action with their financial institution to fix the issue */
  ExternalAction = 'externalAction',
  /** The linked account or financial institution is no longer supported and can be unlinked */
  Unsupported = 'unsupported',
}

/** An individual account between an individual user and financial institution */
export type LinkedSubaccount = TimestampsInterface & {
  __typename?: 'LinkedSubaccount'
  /** Last 4 Digits of Account Number */
  accountNumberLastFour?: Maybe<Scalars['String']>
  /** Roles this linked account can be assigned to */
  allowedRoles: Array<LinkedSubaccountRoleEnum>
  /** Balance available (via Plaid/Spend) */
  balanceAvailable?: Maybe<Scalars['Float']>
  /** Current balance of subaccount (via Plaid/Spend) */
  balanceCurrent?: Maybe<Scalars['Float']>
  /** Spending limit of balance */
  balanceLimit?: Maybe<Scalars['Float']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Plaid ID for linked subaccount */
  externalId?: Maybe<Scalars['String']>
  /** External source of subaccount (plaid, spend, paypal, manual) */
  externalSource?: Maybe<Scalars['String']>
  /** Internal ID for linked subaccount */
  id: Scalars['ID']
  /** Subaccount Linked? */
  linked: Scalars['Boolean']
  linkedAccount: LinkedAccount
  /** Internal ID for the corresponding linked account */
  linkedAccountId: Scalars['ID']
  /** Name of linked subaccount (Department) */
  name: Scalars['String']
  /** Official name (verbose) */
  officialName?: Maybe<Scalars['String']>
  paymentEngines: Array<LinkedSubaccountPaymentEngineEnum>
  /** The role of the linked subaccount */
  role?: Maybe<LinkedSubaccountRoleEnum>
  /** Financial institution routing number. */
  routingNumber?: Maybe<Scalars['String']>
  /** The status of the linked subaccount */
  status?: Maybe<FundingSourceStatusEnum>
  /** Subtype (ie checking) */
  subaccountSubtype: Scalars['String']
  /** Type (depository, credit) */
  subaccountType: Scalars['String']
  /** Transactions count */
  transactionsLastSyncedCount: Scalars['Int']
  /** RDVs and docs have been verified and approved for this account */
  transfersApproved?: Maybe<Scalars['Boolean']>
  /** Is the account at risk or does it have insufficient funds? */
  transfersAtRisk?: Maybe<Scalars['Boolean']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /**
   * Subaccount Verified?
   * @deprecated This will be removed in favor of "transfersApproved"
   */
  verified?: Maybe<Scalars['Boolean']>
}

export enum LinkedSubaccountPaymentEngineEnum {
  /** The linked subaccount is linked in ProfitStars */
  ProfitStars = 'profitStars',
}

export enum LinkedSubaccountRoleEnum {
  /** The subaccount is the primary funding source of the user */
  PrimaryFunding = 'primaryFunding',
  /** The subaccount is the secondary funding source of the user */
  SecondaryFunding = 'secondaryFunding',
}

/** Input for creating a manual, ACH funding source */
export type LinkManualFundingSourceInput = {
  /** the account number of the funding source being linked */
  accountNumber: Scalars['String']
  /** the routing number of the funding source being linked */
  routingNumber: Scalars['RoutingNumber']
}

/** LinkManualFundingSourceResult */
export type LinkManualFundingSourceResult =
  | CurrentBankStatementNotProvided
  | FundingSourceAccount
  | FundingSourceAlreadyExists
  | FundingSourceCredentialsExceedLinkLimit
  | InvalidAccountNumber
  | InvalidManualLink
  | InvalidRoutingNumber
  | PreviousFundingSourcePending
  | RdvVerificationRequired

export enum LinkProviderType {
  /** Spend provider type. */
  Spend = 'SPEND',
  /** Plaid provider type */
  Plaid = 'PLAID',
  /** Direct bank provider type. */
  DirectBank = 'DIRECT_BANK',
}

/** Attributes for a linked account created through Plaid Link */
export type LinkSessionInput = {
  /** The Authorization Code returned from the Authorization Server */
  authorizationCode: Scalars['String']
  /** Vendor session correlation id */
  linkSessionId?: Maybe<Scalars['String']>
  /** Financial Institution ID */
  financialInstitutionId: Scalars['String']
  /** Linked Account ID */
  linkedAccountId?: Maybe<Scalars['String']>
  /** Flag to determine if round-ups should be disabled */
  disableRoundUps?: Maybe<Scalars['Boolean']>
}

export enum LinkSessionLanguage {
  /** English */
  En = 'EN',
  /** Spanish */
  Es = 'ES',
  /** French */
  Fr = 'FR',
  /** Dutch */
  Nl = 'NL',
}

/** Returns a Link Token or Link URL for use with Account Linking. */
export type LinkSessionResult =
  | RawLinkSession
  | UnrecoverableLinkedAccountError
  | WebviewLinkSession

/** Liquidation of holdings is currently unavailable. */
export type LiquidationUnavailableError = {
  __typename?: 'LiquidationUnavailableError'
  /** Reason for liquidation being unavailable. */
  reason: LiquidationUnavailableReason
}

export enum LiquidationUnavailableReason {
  /** No funding source exists for the investment account. */
  FundingSourceRequired = 'FUNDING_SOURCE_REQUIRED',
  /** The associated funding source requires RDV. */
  FundingSourceRdvRequired = 'FUNDING_SOURCE_RDV_REQUIRED',
  /** The funding source is frozen. */
  FundingSourceFrozen = 'FUNDING_SOURCE_FROZEN',
}

export type LobThumbNails = {
  __typename?: 'LOBThumbNails'
  /** Small Thumbnail of the Letter */
  small?: Maybe<Scalars['URL']>
  /** Medium Thumbnail of the Letter */
  medium?: Maybe<Scalars['URL']>
  /** Large Thumbnail of the Letter */
  large?: Maybe<Scalars['URL']>
}

export type LockBankCardInput = {
  lockReason: BankCardTemporaryLockReason
}

export type LockBankCardPayload = {
  __typename?: 'LockBankCardPayload'
  bankCard?: Maybe<BankCard>
}

export type LoginAccess = {
  __typename?: 'LoginAccess'
  loginAllowed: Scalars['Boolean']
  loginRevokedAt?: Maybe<Scalars['DateTime']>
  loginRevokedReason?: Maybe<Scalars['String']>
}

export type LoginRateLimitedException = {
  __typename?: 'LoginRateLimitedException'
  message?: Maybe<Scalars['String']>
}

export type LogoutDeviceInput = {
  deviceId: Scalars['ID']
}

export type LogoutDeviceResult =
  | LogoutDeviceSuccess
  | RefreshTokenNotFoundException
  | DeviceNotFoundException

export type LogoutDeviceSuccess = {
  __typename?: 'LogoutDeviceSuccess'
  Device: Device
}

export type LogoutResult =
  | LogoutSuccess
  | RefreshTokenNotFoundException
  | AuthTokenNotFoundException

export type LogoutSuccess = {
  __typename?: 'LogoutSuccess'
  userId: Scalars['ID']
}

export type MailInDocument = {
  __typename?: 'MailInDocument'
  /** Type of mail-in document. */
  mailType: MailInDocumentType
  /** The name of recipient. */
  recipientName: Scalars['String']
  /** The date the document was sent. */
  sendDate: Scalars['DateTime']
  /** The LOB document ID. */
  letterId: Scalars['String']
  /** A temporary Hyperlink to the pdf document. */
  letterUrl?: Maybe<Scalars['URL']>
  /** Status of the mail-in document. */
  status: MailInNegotiationStatus
  letterThumbnails?: Maybe<Array<Maybe<LobThumbNails>>>
  /** The date the document is expected to be delivered. */
  expectedDeliveryDate?: Maybe<Scalars['DateTime']>
}

export enum MailInDocumentType {
  FeeNegotiation = 'FEE_NEGOTIATION',
  BillNegotiation = 'BILL_NEGOTIATION',
}

export enum MailInNegotiationStatus {
  MailInPending = 'MAIL_IN_PENDING',
  MailInSent = 'MAIL_IN_SENT',
  MailInError = 'MAIL_IN_ERROR',
}

export type MakeInvestmentInput = {
  /** The amount of the investment */
  amount: Scalars['Float']
  /**
   * The type of the investment:
   * - `credit` if transferring from the funding source -> investment account
   * - `debit` if transferring from the investment account -> funding source
   */
  type: InvestmentTypes
  /**
   * ID of the investment account
   * If omitted, the user's basic investment account is used
   */
  investmentAccountId?: Maybe<Scalars['ID']>
  /**
   * ID of the funding source to fund the investment
   * If omitted, the user's primary funding source is used
   */
  fundingSourceId?: Maybe<Scalars['ID']>
}

export type MakeInvestmentPayload = {
  __typename?: 'MakeInvestmentPayload'
  id: Scalars['ID']
}

export type MalformedRecurringTransferException = {
  __typename?: 'MalformedRecurringTransferException'
  pathExceptions: Array<RecurringTransferPathException>
}

export enum MaritalStatus {
  /** User has never been married */
  Single = 'single',
  /** User is married currently */
  Married = 'married',
  /** User is no longer married due to legal separation */
  Divorced = 'divorced',
  /** User is no longer married due to death of spouse */
  Widowed = 'widowed',
}

export enum MaritalStatusType {
  Single = 'single',
  Married = 'married',
  Divorced = 'divorced',
  Widowed = 'widowed',
}

export type MarkAllAsReadResult = MarkAllAsReadSuccess | UpdateMessageFailed

export type MarkAllAsReadSuccess = {
  __typename?: 'MarkAllAsReadSuccess'
  markedAsReadCount: Scalars['Int']
}

export type Market = {
  __typename?: 'Market'
  isOpen: Scalars['Boolean']
}

export type MarketReturn = {
  __typename?: 'MarketReturn'
  marketValue: MonetaryAmount
  percent: Scalars['Float']
}

export type MarkLearnContentAsHelpfulInput = {
  contentId: Scalars['ID']
}

export type MarkLearnContentAsHelpfulResult =
  | UpdateLearnContentHelpfulnessResult
  | RecordDoesNotExistError

export type MarkLearnContentAsViewedInput = {
  contentId: Scalars['ID']
}

export type MarkLearnContentAsViewedResult = ViewedLearnContentResult | RecordDoesNotExistError

/** Cannot open early account because the custodian is already at max */
export type MaxAccountsCreatedException = {
  __typename?: 'MaxAccountsCreatedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type Message = {
  body: MessageTextAsset
  deepLink?: Maybe<Scalars['URL']>
  icon?: Maybe<MessageVisualAsset>
  id: Scalars['ID']
  title: MessageTextAsset
  trackingId?: Maybe<Scalars['ID']>
}

export enum MessageCategory {
  Account = 'ACCOUNT',
  Banking = 'BANKING',
  BenefitsHub = 'BENEFITS_HUB',
  Milestone = 'MILESTONE',
}

/** Specifies a Message Connection */
export type MessageConnection = {
  __typename?: 'MessageConnection'
  edges: Array<MessageEdge>
  pageInfo: MessagePageInfo
}

/** Specifies a Message Edge */
export type MessageEdge = {
  __typename?: 'MessageEdge'
  cursor: Scalars['ID']
  node: Message
}

/** Specifies Page Information */
export type MessagePageInfo = {
  __typename?: 'MessagePageInfo'
  endCursor?: Maybe<Scalars['ID']>
  hasNextPage: Scalars['Boolean']
}

export type MessagePageInput = {
  after?: Maybe<Scalars['ID']>
  first?: Maybe<Scalars['Int']>
}

export enum MessageStatus {
  Read = 'READ',
  Dismissed = 'DISMISSED',
}

/** A pair of a status and a desired boolean for it. */
export type MessageStatusFilterInput = {
  key: MessageStatus
  value: Scalars['Boolean']
}

export type MessageTextAsset = StringKeyAsset

export enum MessageType {
  Notification = 'NOTIFICATION',
  Alert = 'ALERT',
}

export type MessageVisualAsset = DesignLibraryIcon | Image

export type MfaMissingAuthAlert = AuthAlert & {
  __typename?: 'MfaMissingAuthAlert'
  userId: Scalars['ID']
  type: Scalars['String']
}

/** The mighty oak card waiver for a user */
export type MightyOakCardWaiver = {
  __typename?: 'MightyOakCardWaiver'
  mightyOakCardWaiverPeriodEndDate: Scalars['String']
  userId: Scalars['ID']
}

/** Mighty Oak Waiver expired */
export type MightyOakCardWaiverExpiredException = {
  __typename?: 'MightyOakCardWaiverExpiredException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Mighty Oak Waiver not found */
export type MightyOakCardWaiverNotFoundException = {
  __typename?: 'MightyOakCardWaiverNotFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** result from attempting to create a provisional waiver for a user */
export type MightyOakWaiverResult =
  | BillingProfileNotFoundException
  | MightyOakCardWaiver
  | MightyOakCardWaiverExpiredException
  | MightyOakCardWaiverNotFoundException

export type Milestone = {
  __typename?: 'Milestone'
  /** key that maps to client-defined milestone description */
  descriptionKey: Scalars['StringKey']
  /** optional destination label and deep link for milestone action */
  destination?: Maybe<Destination>
  /**
   * key that maps to client-defined milestone details
   * @deprecated leverage accountPoints.detailsKey
   */
  detailsKey?: Maybe<Scalars['StringKey']>
  /** milestone education tip content */
  educationTip: EducationTip
  /** the first time the user completed the milestone */
  firstCompletedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** @deprecated No longer needed since the logo will be dynamically set based on milestone status. Use 'logo' instead */
  inactiveLogo?: Maybe<Image>
  /** the most recent time the user completed the milestone */
  lastCompletedAt?: Maybe<Scalars['DateTime']>
  /** logo that matches the milestone status */
  logo: Image
  /** @deprecated Do not use anymore. This field has been replaced by nameKey. */
  name: Scalars['String']
  /** key that maps to descriptive identifier */
  nameKey: Scalars['StringKey']
  /** information the user's progress towards completion */
  progress: MilestoneProgress
  /** key that maps to simplified descriptive identifier */
  simpleNameKey: Scalars['StringKey']
  /** the user-specific status */
  status: MilestoneStatus
  /** the milestone category */
  theme: MilestoneTheme
  /** how many times the user completed this milestone */
  timesCompleted: Scalars['Int']
  /** how many account points the user has earned for this milestone so far */
  accountPoints: AccountPoints
  /** how many challenge points the user has earned for completing this milestone. The specific challenge is indicated by the ID */
  challengePoints?: Maybe<ChallengePointsEarned>
  /** whether or not this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean']
  /** milestone rule enum which can be used for grouping and fetch string mappings */
  rule: MilestoneRuleType
}

export type MilestoneChallengePointsArgs = {
  challengeId: Scalars['ID']
}

export type MilestoneAccountLevelDefinition = {
  __typename?: 'MilestoneAccountLevelDefinition'
  /** image to display as the background when the level is active */
  activeBackground: Image
  /** image to display as the foreground when the level is active */
  activeForeground: Image
  /** level id, e.g. 3 */
  id: Scalars['Int']
  /** image to display as the background when the level is inactive */
  inactiveBackground: Image
  /** max points for the level. If min and max are the same value, there is no higher level */
  max: Scalars['Int']
  /** minimum points needed for the level */
  min: Scalars['Int']
}

export type MilestoneAchievementActionRule = {
  __typename?: 'MilestoneAchievementActionRule'
  actions: Array<MilestoneAchievementActionType>
  milestoneID: Scalars['ID']
}

export enum MilestoneAchievementActionType {
  NativeNotification = 'NATIVE_NOTIFICATION',
  ChallengePoints = 'CHALLENGE_POINTS',
  AnalyticsEvent = 'ANALYTICS_EVENT',
}

export type MilestoneByThemeFilterInput = {
  /** No longer in use. Will be ignored if provided. */
  challengeId?: Maybe<Scalars['ID']>
  rule?: Maybe<MilestoneRuleType>
}

export type MilestoneChallenge = {
  __typename?: 'MilestoneChallenge'
  /** Static date label for when the challenge becomes inactive (NOTE: is relative to PST) */
  closingAt: Scalars['String']
  /** additional information about this challenge */
  details?: Maybe<Scalars['String']>
  /** Internal UTC timestamp. For display, use 'closingAt'instead */
  endsAt: Scalars['DateTime']
  /** optional deeplink to challenge FAQ */
  faqDeepLink?: Maybe<Scalars['URL']>
  id: Scalars['ID']
  /** optional logo for the challenge */
  logo?: Maybe<Image>
  /** number of milestones the user has completed for the challenge */
  milestonesCompleted: DiscreteMilestoneProgress
  /** descriptive identifier */
  name: Scalars['String']
  /** number of points the user has earned for the challenge. May be null if not applicable to the current challenge */
  pointsEarned?: Maybe<DiscreteMilestoneProgress>
  /** optional deeplink to official challenge rules */
  rulesDeepLink?: Maybe<Scalars['URL']>
  /** list of user milestones, grouped and ordered */
  groupedMilestones: Array<MilestoneGroup>
}

export type MilestoneChallengeDefinition = {
  __typename?: 'MilestoneChallengeDefinition'
  /** additional information about this challenge */
  details?: Maybe<Scalars['String']>
  /** what time the challenge becomes inactive */
  endsAt: Scalars['DateTime']
  id: Scalars['ID']
  /** optional logo for the challenge */
  logo?: Maybe<Image>
  /** the list of milestones this challenge is dependent on */
  milestones: Array<MilestoneDefinition>
  /** descriptive identifier */
  name: Scalars['String']
  /** what time the challenge becomes active */
  startsAt: Scalars['DateTime']
}

export type MilestoneChallengePointsRule = {
  __typename?: 'MilestoneChallengePointsRule'
  challengeID: Scalars['ID']
  /** legal copy about how points are earned */
  details: Scalars['String']
  /** specifies the max points that can be earned if the milestone is completed more than once */
  maxPointsAllowed: Scalars['Int']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /** summarized information about how points are earned */
  summary?: Maybe<Scalars['String']>
}

export type MilestoneDefinition = {
  __typename?: 'MilestoneDefinition'
  /** optional datetime arg required for some milestone rules (e.g. ACTIVE_CUSTOMER) */
  arg1DateTime?: Maybe<Scalars['DateTime']>
  /** optional integer arg required for some milestone rules (e.g. BALANCED_REACHED) */
  arg1Int?: Maybe<Scalars['Int']>
  id: Scalars['ID']
  /** optional logo used for inactive milestone states (e.g. LOCKED, NOT_STARTED) */
  inactiveLogo?: Maybe<Image>
  /** whether or not this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean']
  /** default logo */
  logo: Image
  /** list of MilestoneGroupID for groups to which this milestone belongs */
  milestoneGroups: Array<Scalars['ID']>
  /** descriptive identifier */
  name: Scalars['String']
  /** the rule that determines how this milestone changes status */
  rule: MilestoneRule
  /** the milestone category */
  theme: MilestoneTheme
  accountPointsRule?: Maybe<AccountPointsRule>
  challengePointsRule?: Maybe<MilestoneChallengePointsRule>
}

export type MilestoneDefinitionChallengePointsRuleArgs = {
  challengeId: Scalars['ID']
}

export type MilestoneEligibility = {
  __typename?: 'MilestoneEligibility'
  eligible: Scalars['Boolean']
  scope: MilestoneEligibilityScope
}

export enum MilestoneEligibilityScope {
  AccountSetupExp = 'ACCOUNT_SETUP_EXP',
  AccountSetupComplete = 'ACCOUNT_SETUP_COMPLETE',
}

export type MilestoneGroup = MilestoneRuleGroup | MilestoneThemeGroup

export type MilestoneGroupAchievementActionRule = {
  __typename?: 'MilestoneGroupAchievementActionRule'
  actions: Array<MilestoneAchievementActionType>
  milestoneGroupID: Scalars['ID']
}

export type MilestoneGroupDefinition = {
  __typename?: 'MilestoneGroupDefinition'
  id: Scalars['ID']
  milestoneIDs: Array<Scalars['ID']>
}

export type MilestoneHub = {
  __typename?: 'MilestoneHub'
  /** static list of min and max values for each account level */
  levelDefinitions: Array<MilestoneAccountLevelDefinition>
  userAccount: MilestoneHubAccount
  /** list of user milestones, grouped and ordered */
  groupedMilestones: Array<MilestoneGroup>
}

export type MilestoneHubAccount = {
  __typename?: 'MilestoneHubAccount'
  /**
   * shows progress of points earned vs points needed to move to the next level.
   * NOTE: the currentInt can exceed the targetInt if the user is at the highest level
   */
  accountPointsProgress: DiscreteMilestoneProgress
  /** current level achieved */
  currentLevel: Scalars['Int']
  /** shows progress of milestones completed vs milestones available */
  milestoneProgress: DiscreteMilestoneProgress
}

export type MilestoneHubDefinition = {
  __typename?: 'MilestoneHubDefinition'
  id: Scalars['ID']
  milestoneIds: Array<Scalars['ID']>
}

export type MilestoneProgress = CurrencyMilestoneProgress | DiscreteMilestoneProgress

/** defines how a milestone is completed */
export type MilestoneRule = {
  __typename?: 'MilestoneRule'
  /** denotes if an argument input needs to be provided for the creation of a MilestoneDefinition */
  argInput: MilestoneRuleArgInput
  id: Scalars['ID']
  /** the rule name */
  name: Scalars['String']
  /** the milestone supported themes */
  themes: Array<MilestoneTheme>
}

export enum MilestoneRuleArgInput {
  Int = 'INT',
  Datetime = 'DATETIME',
  None = 'NONE',
}

export type MilestoneRuleGroup = {
  __typename?: 'MilestoneRuleGroup'
  contents: Array<MilestoneRuleGroupContent>
  descriptionKey: Scalars['StringKey']
  groupCompletion: DiscreteMilestoneProgress
  logo: Image
  nameKey: Scalars['StringKey']
  rule: MilestoneRuleType
}

export type MilestoneRuleGroupContent = Milestone

export enum MilestoneRuleType {
  CompleteRegistration = 'COMPLETE_REGISTRATION',
  CreateAcornsAccount = 'CREATE_ACORNS_ACCOUNT',
  Verified = 'VERIFIED',
  FundingSourceLinked = 'FUNDING_SOURCE_LINKED',
  ActiveCustomer = 'ACTIVE_CUSTOMER',
  Signup = 'SIGNUP',
  CardActivation = 'CARD_ACTIVATION',
  FirstInvestment = 'FIRST_INVESTMENT',
  SmartDepositCompleted = 'SMART_DEPOSIT_COMPLETED',
  RewardCreated = 'REWARD_CREATED',
  RecurringInvestmentMonthly = 'RECURRING_INVESTMENT_MONTHLY',
  BalanceReached = 'BALANCE_REACHED',
  RealtimeRoundup = 'REALTIME_ROUNDUP',
  Roundup = 'ROUNDUP',
}

export enum MilestoneStatus {
  Locked = 'LOCKED',
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Completed = 'COMPLETED',
}

export enum MilestoneTheme {
  AccountSetup = 'ACCOUNT_SETUP',
  Invest = 'INVEST',
  Spend = 'SPEND',
  Later = 'LATER',
  Early = 'EARLY',
  Earn = 'EARN',
  Acorns = 'ACORNS',
}

export type MilestoneThemeGroup = {
  __typename?: 'MilestoneThemeGroup'
  contents: Array<MilestoneThemeGroupContent>
  descriptionKey: Scalars['StringKey']
  destination?: Maybe<Destination>
  groupCompletion: DiscreteMilestoneProgress
  groupPointsProgress?: Maybe<DiscreteMilestoneProgress>
  isLocked: Scalars['Boolean']
  logo: Image
  nameKey: Scalars['StringKey']
  theme: MilestoneTheme
}

export type MilestoneThemeGroupContent = MilestoneRuleGroup | Milestone

export type Milliseconds = {
  __typename?: 'Milliseconds'
  value: Scalars['Int']
}

export type MillisecondsInput = {
  value: Scalars['Int']
}

/** Miscellaneous document requested. */
export type MiscDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'MiscDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Cannot open early account because the beneficiary does not have an SSN */
export type MissingBeneficiarySsnException = {
  __typename?: 'MissingBeneficiarySsnException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** The user needs to attach a funding source to close their early account */
export type MissingFundingSourceException = {
  __typename?: 'MissingFundingSourceException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type MissingRequiredAgreementsException = {
  __typename?: 'MissingRequiredAgreementsException'
  message?: Maybe<Scalars['String']>
}

/** The given beneficiary does not have an associated SSN. */
export type MissingSsnBeneficiaryAlert = Alert & {
  __typename?: 'MissingSsnBeneficiaryAlert'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /**
   * Internal ID of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  beneficiaryId: Scalars['ID']
  /**
   * First name of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  firstName: Scalars['String']
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String']
  userId: Scalars['ID']
}

/** The given beneficiary does not have an associated SSN. */
export type MissingSsnBeneficiaryAlertItem = UserAlertsItem & {
  __typename?: 'MissingSsnBeneficiaryAlertItem'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** modal */
export type Modal = {
  __typename?: 'Modal'
  body: Scalars['String']
  /** offer campaign id */
  campaignId?: Maybe<Scalars['ID']>
  /** list of actions */
  cta: Array<Cta>
  logo?: Maybe<Image>
  title: Scalars['String']
  /** modal type */
  type: ModalType
}

export enum ModalType {
  /** about */
  About = 'about',
  /** clear input fields */
  Clear = 'clear',
  /** error notification */
  Error = 'error',
  /** privacy notice */
  HeadsUp = 'heads_up',
  /** highlights a specific provider */
  Quote = 'quote',
}

export type MonetaryAmount = {
  __typename?: 'MonetaryAmount'
  currency: Currency
  value: Scalars['Float']
}

/** A monetrary reward that will be provided to a subscriber in some fashion. */
export type MonetaryIncentive = Incentive & {
  __typename?: 'MonetaryIncentive'
  /** Amount of the monetary reward. */
  amount: CurrencyAmount
  copyKey?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  id: Scalars['ID']
  /** Is the monetary reward recurring. */
  recurring: Scalars['Boolean']
  /** Total amount of the reward if recurring. */
  totalAmount: CurrencyAmount
  /**
   * Arbitrary string denoting to fulfillment processes how monetary
   * reward should be provided to a subscriber.
   *
   * Ex. "INVESTMENT"
   */
  type: Scalars['String']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type MonthlyTotal = {
  __typename?: 'MonthlyTotal'
  isPredicted: Scalars['Boolean']
  totalAmount: FormattedMonetaryAmount
  yearMonth: Scalars['String']
}

export type Mutation = {
  __typename?: 'Mutation'
  destroySession?: Maybe<Scalars['Void']>
  changePIN?: Maybe<Scalars['Void']>
  resetPassword?: Maybe<Scalars['Void']>
  resetPIN?: Maybe<Scalars['Void']>
  updateNotification?: Maybe<Scalars['Void']>
  agreeToAcceptanceDocument?: Maybe<Scalars['Void']>
  setPortfolio: User
  requestAccountClosure?: Maybe<Scalars['Void']>
  /** @deprecated Use Mutation.suspendUserDeposits or Mutation.unsuspendUserDeposits instead */
  suspendDeposits?: Maybe<Scalars['Void']>
  linkACHAccount?: Maybe<Scalars['Void']>
  connectACHAccount: ConnectAchAccountResult
  submitRDVs: Scalars['Boolean']
  redeemGiftcard?: Maybe<Scalars['Void']>
  sessionRefresh?: Maybe<Session>
  /** @deprecated Implicit cookie auth no longer supported. */
  refreshCookie?: Maybe<Scalars['Void']>
  createExtensionTransaction?: Maybe<TransactionResult>
  updateExtensionTransaction?: Maybe<TransactionResult>
  makeInvestment: MakeInvestmentPayload
  /** @deprecated Use scheduleRecurringTransfer instead. */
  updateRecurringInvestment: RecurringInvestmentPayload
  /** @deprecated Use cancelRecurringTransfer instead. */
  stopRecurringInvestment: RecurringInvestmentPayload
  createLadderQuote?: Maybe<LadderResponse>
  updateLadderQuote?: Maybe<LadderResponse>
  connectLadderCustomer?: Maybe<LadderLinkResponse>
  /** @deprecated Never implemented. */
  createRollover?: Maybe<PdfFormLinks>
  /** @deprecated Never implemented. */
  createTransfer?: Maybe<PdfFormLinks>
  /** @deprecated Never implemented. */
  submitSignature?: Maybe<PdfFormLinks>
  createInvestmentAccount?: Maybe<CreateInvestmentAccountResponse>
  createIRAWithProfile?: Maybe<CreateInvestmentAccountResponse>
  createLaterContribution?: Maybe<Scalars['Void']>
  laterTotalLiquidation?: Maybe<Scalars['Void']>
  laterCreateIndividualBeneficiary?: Maybe<LaterIndividualBeneficiaryResponse>
  updateContactInfo?: Maybe<User>
  updateEmail?: Maybe<User>
  updateEmployment?: Maybe<User>
  updateInvestorQuestions?: Maybe<User>
  updatePersonalInfo?: Maybe<User>
  updateUserInfo?: Maybe<UpdateUserInfoResult>
  updateSecurityQuestion?: Maybe<User>
  completeRegistration?: Maybe<User>
  /** Create a beneficiary */
  createBeneficiary: CreateBeneficiaryResult
  /** Deactivates the specified account and returns the newley deactived account. */
  deactivateAccount?: Maybe<Account>
  /** Deactivate a beneficiary that is no longer used */
  deactivateBeneficiary: DeactivateBeneficiaryResult
  /** Update a beneficiary's SSN/TIN */
  setBeneficiarySsn: SetBeneficiarySsnResult
  /** Update a single address for a user */
  updateAddress?: Maybe<Address>
  /** Update a beneficiary's basic info */
  updateBeneficiaryInfo: UpdateBeneficiaryInfoResult
  /** Update a single profile for a user */
  updateProfile?: Maybe<Profile>
  /** Update a certificate or card signature for a user */
  updateSignature?: Maybe<Signature>
  activateBankCard?: Maybe<ActivateBankCardPayload>
  createBankAccount?: Maybe<CreateBankAccountPayload>
  lockBankCard?: Maybe<LockBankCardPayload>
  orderBankCard?: Maybe<OrderBankCardResult>
  unlockBankCard?: Maybe<UnlockBankCardPayload>
  updateBankCardPin?: Maybe<UpdateBankCardPinPayload>
  reportBankCardLostStolen?: Maybe<ReportBankCardLostStolenPayload>
  deleteExpiredBankCardOrder?: Maybe<DeleteExpiredBankCardOrderResult>
  closeBankAccount: CloseBankAccountResult
  reissueBankCard?: Maybe<ReissueBankCardResult>
  submitSpendTransactionsDispute: SpendTransactionsDisputeResult
  createSavingsAccount: CreateSavingsAccountResult
  updateBankAccountGoal: UpdateBankAccountGoalResult
  /** Assign a linked subaccount to a role (i.e. funding source) */
  assignLinkedSubaccount?: Maybe<LinkedSubaccount>
  /** Create a linked account */
  createPlaidLinkedAccount?: Maybe<LinkedAccount>
  /** Generate a Link Token and return either the Link Token of Link URL for use with Account Linking. */
  generateLinkSession: LinkSessionResult
  /** Save a linked account */
  registerLinkSession?: Maybe<RegisterLinkSessionResult>
  /** Updates a plaid account with a new linking error code. Returns the updated linked account. */
  setLinkingError?: Maybe<LinkedAccount>
  /** Unlink account and all attached subaccounts */
  unlinkLinkedAccount?: Maybe<LinkedAccount>
  /** Updates a plaid account with a new link session id. To be used after re-authenticating a linked account */
  updateLinkedAccount?: Maybe<LinkedAccount>
  /** Update a single round up profile for a user */
  roundUpProfile?: Maybe<RoundUpProfile>
  /** Set the manual flag to true on a round up */
  setManualRoundUps: Array<RoundUp>
  /** Update a single Round Up Account for a given ID */
  updateRoundUpAccount?: Maybe<RoundUpAccount>
  initiateTransfer?: Maybe<InitiateTransferPayload>
  cancelTransfer?: Maybe<CancelTransferPayload>
  startCheckDeposit?: Maybe<StartCheckDepositPayload>
  uploadCheck?: Maybe<UploadCheckPayload>
  completeCheckDeposit?: Maybe<CompleteCheckDepositPayload>
  /** @deprecated Replaced with createSupportTicketOrException mutation. */
  createSupportTicket?: Maybe<SupportTicket>
  createSupportTicketOrException?: Maybe<SupportTicketResponse>
  createAuthenticatedSupportTicket?: Maybe<SupportTicket>
  createSupportTicketWithCustomFields?: Maybe<SupportTicketWithCustomFieldsResponse>
  createSuspendedUserSupportTicket?: Maybe<SupportTicketWithCustomFieldsResponse>
  /** Get Pinwheel Link Token */
  createDirectDepositLinkInfo: CreateDirectDepositLinkInfoSwitch
  /** Add a direct deposit employer */
  startAcornsPdfSwitch?: Maybe<Scalars['Boolean']>
  /** Persists a user intention of perform an online switch. */
  startOnlineSwitch: StartOnlineSwitchPayload
  /** Submits a direct deposit switch via ClickSwitch */
  startSubmittableSwitch?: Maybe<StartSubmittableSwitchPayload>
  /** Update a user's suitability */
  updateSuitability?: Maybe<Suitability_UpdateSuitabilityResult>
  cancelCheckPayment?: Maybe<CancelCheckPaymentResult>
  sendCheckPayment?: Maybe<SendCheckPaymentResult>
  /** Accept an acceptance document with a signature and date */
  acceptDocument: AcceptDocumentResponse
  /** Adds a security to a portfolio */
  addSecurityToPortfolio: AddSecurityToPortfolioResult
  /** Add a Self Directed Portfolio */
  addSelfDirectedPortfolio: AddSelfDirectedPortfolioResult
  /** Cancel pending investment */
  cancelInvestment: CancelInvestmentResult
  /** Cancel an existing account closure request */
  cancelInvestmentAccountClosureRequest: CancelInvestmentAccountClosureRequestResult
  /** Start the account closure process for the specified investment account */
  closeInvestmentAccount: CloseInvestmentAccountResult
  /** Close an open Acorns user account */
  closeUserAccount: CloseUserAccountResult
  /** Create a Prospect User */
  createProspectUser: CreateProspectUserResult
  /** Create a presigned post for direct to s3 file upload */
  createUploadUrl: CreateUploadUrlResult
  /** Enable quarterly investment account recaps for an investment account. */
  enableQuarterlyRecaps: EnableQuarterlyRecapsResult
  /** Legacy document upload */
  legacyUploadDocument: LegacyUploadDocumentResult
  /** Link a funding source via account and routing number */
  linkManualFundingSource: LinkManualFundingSourceResult
  /** Open a Core InvestmentAccount */
  openCoreInvestmentAccount: OpenCoreInvestmentAccountResult
  /** Create an Acorns Early Account */
  openEarlyAccount: OpenEarlyAccountResult
  /** Link a funding source via partner account token */
  partnerLinkManualFundingSource: PartnerLinkFundingSourceResult
  /** Record view_at timestamp on investment account recap. */
  recordInvestmentAccountRecapView: RecordInvestmentAccountRecapViewResult
  /** Regenerate public token for an investment account recap. */
  regenerateInvestmentAccountRecapPublicToken: RegenerateInvestmentAccountRecapPublicTokenResult
  /** Removes a security from a portfolio */
  removeSecurityFromPortfolio: RemoveSecurityFromPortfolioResult
  /** Start the process for removing a self directed portfolio from an investment account */
  removeSelfDirectedPortfolio: RemoveSelfDirectedPortfolioResult
  /** Reopen a closed Acorns user account */
  reopenUserAccount: ReopenUserAccountResult
  /** Attempts to close a single or multiple Early investment accounts */
  requestEarlyAccountClosure: Array<RequestEarlyAccountClosureResult>
  /** Attempts to reopen an investment account. */
  requestInvestmentAccountReopen: RequestInvestmentAccountReopenResult
  /** Save upload url after direct s3 upload and create upload record */
  saveUploadUrl: LegacyUploadDocumentResult
  /** Set a given investment account recap's public access. */
  setInvestmentAccountRecapPublicAccess: SetInvestmentAccountRecapPublicAccessResult
  /** Suspend user deposits */
  suspendUserDeposits: Scalars['Void']
  /** Unauthenticated mutation for creating a presigned post for direct to s3 file upload */
  unauthenticatedCreateUploadUrl: CreateUploadUrlResult
  /** Unauthenticated mutation for saving upload url after direct s3 upload and create upload record */
  unauthenticatedSaveUploadUrl: UnauthenticatedSaveUploadUrlResult
  /** Unsuspend user deposits */
  unsuspendUserDeposits: Scalars['Void']
  /** Updates Account Portfolio */
  updateAccountPortfolio: UpdateAccountPortfolioResponse
  /** Update the securities and target allocation percentages of the portfolio */
  updatePortfolioSecurities: UpdatePortfolioSecuritiesResult
  /** Updates a registration record */
  updateRegistration: Result
  /** Validate a user suspended upload token */
  validateUserSuspendedUploadToken: ValidateUserSuspendedUploadTokenResult
  initiateLaterProgramAccountContribution?: Maybe<LaterProgramAccountContributionResult>
  /**
   * Make a withdrawal from a later account
   * One of either earlyDistributionTaxExceptionReason or reason is required; reason is newer/preferred
   * withdrawalType is no longer supported, since it can be derived
   */
  laterWithdrawal?: Maybe<Scalars['Void']>
  /**  Returns the tax withholding amounts for state and federal */
  taxWithholdingAmounts?: Maybe<TaxWithholdingAmounts>
  /**  Verify and create a later account */
  verifyLaterAccountOrError: LaterAccountInfoOrError
  scheduleRecurringTransfer?: Maybe<ScheduleRecurringTransferResult>
  cancelRecurringTransfer?: Maybe<CancelRecurringTransferResult>
  /** Apply a life quote for a given user/provider name */
  protectApplyLifeQuote?: Maybe<LifeQuoteResponse>
  /** Create a life quote for a given user/provider name */
  protectCreateLifeQuote?: Maybe<LifeQuoteResponse>
  /** Update user coverage for a given user/insurance type */
  protectUpdateCoverage?: Maybe<UpdateCoverageResponse>
  /** Update user calculation response for a given user/insurance type */
  protectUpdateRecommendedLifeCoverage?: Maybe<UpdateRecommendedCoverageResponse>
  /** Update all onboarding responses for a given user */
  protectUpdateResponses?: Maybe<ProtectHome>
  /** Record an action feed event */
  feedEvent?: Maybe<ActionFeedEventResponse>
  addFavoritePartnerOffers: FavoritePartnerOfferGroup
  removeFavoritePartnerOffers: FavoritePartnerOfferGroup
  setFavoritePartnerOffers: FavoritePartnerOfferGroup
  createJobAlert?: Maybe<CreateJobAlertResult>
  removeJobAlert?: Maybe<RemoveJobAlertResult>
  addMilestonesToGroup: AddMilestoneToMilestoneGroupDefinitionResult
  createMilestoneGroupDefinition: CreateMilestoneGroupDefinitionResult
  removeMilestonesFromGroup: RemoveMilestoneFromMilestoneGroupDefinitionResult
  addActionToMilestoneGroupAchievementActionRule: AddActionToMilestoneGroupAchievementActionRuleResult
  createMilestoneGroupAchievementActionRule: CreateMilestoneGroupAchievementActionRuleResult
  removeActionFromMilestoneGroupAchievementActionRule: RemoveActionFromMilestoneGroupAchievementActionRuleResult
  /** @deprecated Do not use this anymore. Milestone Hub Definitions can now only be updated by revising the milestoneHubDefinitions.json file */
  addMilestonesToMilestoneHubDefinition: AddMilestonesToMilestoneHubDefinitionResult
  /** @deprecated Do not use this anymore. Milestone Hub Definitions can now only be created by updating the milestoneHubDefinitions.json file */
  createMilestoneHubDefinition: CreateMilestoneHubDefinitionResult
  /** @deprecated Do not use this anymore. Milestone Hub Definitions can now only be updated by revising the milestoneHubDefinitions.json file */
  removeMilestonesFromMilestoneHubDefinition: RemoveMilestonesFromMilestoneHubDefinitionResult
  dismissMessage: UpdateMessageResult
  hideMessageByExternalId: UpdateMessageResult
  markAllAsRead: MarkAllAsReadResult
  readMessage: UpdateMessageResult
  /** Marks content with given ID as helpful and returns ID and helpful flag or error if it does not exist */
  markLearnContentAsHelpful: MarkLearnContentAsHelpfulResult
  /** Removes content with given ID from helpful section and returns ID and helpful flag or error if it does not exist */
  unmarkLearnContentAsHelpful: UnmarkLearnContentAsHelpfulResult
  /** Saves content as viewed and returns id and date when it is viewed or error if content does not exist */
  markLearnContentAsViewed: MarkLearnContentAsViewedResult
  /**
   * Updates progress for related content and returns id and progress for that
   * content or error if related content does not exist
   */
  updateLearnContentProgress: UpdateLearnProgressResult
  answerLearnQuizQuestion: AnswerLearnQuizQuestionResult
  /** Updates elapsed time, the time the user spent in the quiz. */
  updateElapsedTimeForLearnQuiz: UpdateElapsedTimeForLearnQuizResult
  /** Saves poll respond and returns stats for related poll or error if poll does not exists */
  respondToLearnPoll: RespondToLearnPollResult
  /** Saves new search term and returns that term when it is saved */
  addSearchTermToLearnSearchHistory: AddSearchTermToLearnSearchHistoryResult
  uploadDocuments: Array<FileOrException>
  uploadUnsolicitedDocuments: Array<FileOrException>
  createDocumentUpload: CreateDocumentUpload
  /** Initiate registration of a PhoneAuthenticator. */
  initiateSMSChallenge: InitiateSmsChallengeResult
  /** Initiate registration of an EmailAuthenticator. */
  initiateEmailChallenge: InitiateEmailChallengeResult
  /** Re-initiate registration of an Authenticator. */
  reinitiateChallenge: ReinitiateSmsChallengeResult
  /** Register a PhoneAuthenticator. */
  registerPhoneAuthenticator: RegisterPhoneAuthenticatorResult
  /** Register an EmailAuthenticator. */
  registerEmailAuthenticator: RegisterEmailAuthenticatorResult
  /** Request an AuthSession for the provided credentials. */
  authenticate: AuthenticateResult
  setDefaultAuthenticator: SetDefaultAuthenticatorResult
  /** token refresh */
  refreshAuthToken: RefreshAuthTokenResult
  /** credentials registration */
  registerCredentials: RegisterCredentialsResult
  /** user creation */
  createUser?: Maybe<Session>
  /** password reset request */
  passwordResetRequest?: Maybe<Scalars['Void']>
  /** verifyDevice */
  verifyDevice: VerifyDeviceResult
  /** blockDevice */
  blockDevice: BlockDeviceResult
  /** unblockDevice */
  unblockDevice: UnblockDeviceResult
  /** setAuthenticationPIN */
  setAuthenticationPIN: SetAuthenticationPinResult
  /** verifyPasswords */
  verifyPasswords: VerifyPasswordsResult
  /** updateCredentials */
  updateCredentials: UpdateCredentialsResult
  /** Updates a users security question and answer */
  updateSecurityQuestionAndAnswer: UpdateSecurityQuestionAndAnswerResult
  /** Resets a password if the password reset token exists (legacy Backend flow) */
  resetPasswordByToken: ResetPasswordByTokenResult
  /** Resets a password if the password reset token exists (updated flow through web app) */
  resetPasswordWithToken: ResetPasswordWithTokenResult
  /** Changes a users password if password change criteria is met */
  changePassword?: Maybe<Scalars['Void']>
  /**
   * changePasswordAuth
   * this mutation is future looking and not in use for now
   * to be used when/if clients update their change password flows to use typed errors
   */
  changePasswordAuth: ChangePasswordResult
  /** Upgrade to JWT authentication */
  upgradeAuthentication: UpgradeAuthenticationResult
  logout: LogoutResult
  /**
   * Apply a promotion to an existing subscription. May entitle a subscriber to
   * promotional pricing for their subscription and/or additional incentives.
   */
  applyPromotion: ApplyPromotionResult
  /** Deactivate a user's subscription */
  deactivateTierSubscription: DeactivateTierSubscriptionResult
  /** Request to be waived from being migrated to a new Subscription. */
  requestSubscriptionMigrationWaiver: RequestSubscriptionMigrationWaiverResult
  /** Eventually will replace the current 'subscribeUserToTier' mutation */
  subscribeToTier: SubscribeToTierResult
  /**
   * Attempt to subscribe a user to a specific Tier + TierPrice
   * Reliant on some synchronous calls to service (for statuses)
   */
  subscribeUserToTier: SubscribeUserToTierResult
  /**
   * Subscribes a user to the cheapest default tier based on their current open accounts
   * @deprecated Will be removed soon in-favor-of the more generic Mutation.subscribeUserToTier.
   */
  subscribeUserToTierByOpenAccounts: TierSubscription
  /**
   * Subscribes a user to the cheapest default tier available with provided productKey
   * @deprecated Will be removed soon in-favor-of the more generic Mutation.subscribeUserToTier.
   */
  subscribeUserToTierByProductKey: TierSubscription
  /** Unsubscribes a user to from their current tier */
  unsubscribeUserFromTier: UnsubscribeUserFromTierResult
  splitDepositSettings: SplitDepositSettingsMutation
  splitDeposit: SplitDepositMutation
  configureSplitDepositDirectDepositIntentSetting?: Maybe<
    ConfigureSplitDepositDirectDepositIntentSettingResult
  >
  configureSplitDepositDirectDepositSetting?: Maybe<ConfigureSplitDepositDirectDepositSettingResult>
  /** Change the amount of an outside contribution payment intent */
  changeOutsideContributionAmount: ChangeOutsideContributionAmountResult
  /** Create a new Outside Contribution */
  createOutsideContribution: CreateOutsideContributionResult
  /** Generate outside contribution payment token */
  createOutsideContributionCheckoutCart: CreateOutsideContributionCheckoutCartResult
  authenticateForFeeNegotiation: AuthenticateForFeeNegotiationResult
  authenticateForFeeNegotiationChallengeMethod: AuthenticateNegotiationStatusResult
  authenticateForFeeNegotiationChallenge: AuthenticateNegotiationStatusResult
  submitBankFeeNegotiation: SubmitBankFeeNegotiationResult
  syncBankFeeTransactions: SyncBankFeeTransactionsResult
  submitForBillNegotiation: BillNegotiationSubmitResult
  submitUserReportedBankFeeRefund: SubmitUserReportedBankFeeRefundResult
  setNegotiationStatus: SetNegotiationStatusResult
  setUserPartnerStatus: UserPartnerStatusResponse
  /** Registers a prospect user with associated source attributes */
  registerProspect: RegisterProspectResult
  /** Updates source attribution data for a user */
  updateAttribution: UpdateAttributionResult
  stub?: Maybe<Scalars['String']>
}

export type MutationChangePinArgs = {
  oldPIN: Scalars['String']
  newPIN: Scalars['String']
  questionId: Scalars['String']
  answer: Scalars['String']
}

export type MutationResetPasswordArgs = {
  email: Scalars['String']
}

export type MutationResetPinArgs = {
  email: Scalars['String']
}

export type MutationUpdateNotificationArgs = {
  channel: Scalars['String']
  category?: Maybe<Scalars['String']>
  subcategory?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  active: Scalars['Boolean']
  uuid?: Maybe<Scalars['ID']>
}

export type MutationAgreeToAcceptanceDocumentArgs = {
  id: Scalars['ID']
}

export type MutationSetPortfolioArgs = {
  input: SetPortfolioInput
}

export type MutationRequestAccountClosureArgs = {
  input: RequestAccountClosureInput
}

export type MutationSuspendDepositsArgs = {
  suspended: Scalars['Boolean']
}

export type MutationLinkAchAccountArgs = {
  routing: Scalars['String']
  account: Scalars['String']
}

export type MutationConnectAchAccountArgs = {
  input: ConnectAchAccountInput
}

export type MutationSubmitRdVsArgs = {
  deposits: Array<Maybe<Scalars['Float']>>
}

export type MutationRedeemGiftcardArgs = {
  pin: Scalars['String']
}

export type MutationSessionRefreshArgs = {
  pin: Scalars['String']
  longSession?: Maybe<Scalars['Boolean']>
}

export type MutationCreateExtensionTransactionArgs = {
  campaignId: Scalars['String']
  salesAmount?: Maybe<Scalars['Float']>
}

export type MutationUpdateExtensionTransactionArgs = {
  id: Scalars['String']
  status: Scalars['String']
}

export type MutationMakeInvestmentArgs = {
  input: MakeInvestmentInput
}

export type MutationUpdateRecurringInvestmentArgs = {
  input: RecurringInvestmentInput
}

export type MutationStopRecurringInvestmentArgs = {
  investmentAccountId?: Maybe<Scalars['String']>
}

export type MutationCreateLadderQuoteArgs = {
  firstName: Scalars['String']
  lastName: Scalars['String']
  age: Scalars['Int']
  email: Scalars['String']
  phone: Scalars['String']
  address: Scalars['String']
  city: Scalars['String']
  state: StateCode
  zip: Scalars['String']
}

export type MutationUpdateLadderQuoteArgs = {
  quoteId: Scalars['ID']
  coverage: Scalars['Int']
}

export type MutationConnectLadderCustomerArgs = {
  quoteId: Scalars['ID']
}

export type MutationCreateRolloverArgs = {
  custodianName: Scalars['String']
  custodianId?: Maybe<Scalars['ID']>
  custodianAddress?: Maybe<CustodianAddressInput>
  custodianPhone?: Maybe<Scalars['String']>
  accountBalance: Scalars['Float']
}

export type MutationCreateTransferArgs = {
  custodianName: Scalars['String']
  custodianId?: Maybe<Scalars['ID']>
  custodianAddress?: Maybe<CustodianAddressInput>
  custodianPhone?: Maybe<Scalars['String']>
  accountBalance: Scalars['Float']
}

export type MutationSubmitSignatureArgs = {
  signature: Scalars['String']
  statement?: Maybe<Scalars['String']>
}

export type MutationCreateInvestmentAccountArgs = {
  iraType?: Maybe<InvestmentAccountTypes>
}

export type MutationCreateIraWithProfileArgs = {
  iraType?: Maybe<InvestmentAccountTypes>
  profileAttributes: Array<Maybe<ProfileAttribute>>
}

export type MutationCreateLaterContributionArgs = {
  accountId: Scalars['ID']
  amount: Scalars['Float']
  year?: Maybe<Scalars['Int']>
}

export type MutationLaterTotalLiquidationArgs = {
  investmentAccountId: Scalars['ID']
  input?: Maybe<LaterTotalLiquidationInput>
}

export type MutationLaterCreateIndividualBeneficiaryArgs = {
  accountId: Scalars['ID']
  firstName: Scalars['String']
  lastName: Scalars['String']
  percentageShare?: Maybe<Scalars['Float']>
  birthDate: Scalars['DateTime']
  ssn?: Maybe<Scalars['String']>
  relationship?: Maybe<Scalars['String']>
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  zip?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
}

export type MutationUpdateContactInfoArgs = {
  input: ContactInfoInput
}

export type MutationUpdateEmailArgs = {
  email: Scalars['String']
}

export type MutationUpdateEmploymentArgs = {
  input: EmploymentInput
}

export type MutationUpdateInvestorQuestionsArgs = {
  input: InvestorQuestionsInput
}

export type MutationUpdatePersonalInfoArgs = {
  input: PersonalInfoInput
}

export type MutationUpdateUserInfoArgs = {
  input: PersonalInfoInput
}

export type MutationUpdateSecurityQuestionArgs = {
  input: SecurityQuestionInput
}

export type MutationCreateBeneficiaryArgs = {
  input: BeneficiaryInput
}

export type MutationDeactivateAccountArgs = {
  accountId: Scalars['ID']
}

export type MutationDeactivateBeneficiaryArgs = {
  id: Scalars['ID']
}

export type MutationSetBeneficiarySsnArgs = {
  id: Scalars['ID']
  ssn: Scalars['String']
}

export type MutationUpdateAddressArgs = {
  addressType: AddressType
  input: AddressInput
  ownerId?: Maybe<Scalars['ID']>
}

export type MutationUpdateBeneficiaryInfoArgs = {
  id: Scalars['ID']
  input: BeneficiaryInfoInput
}

export type MutationUpdateProfileArgs = {
  input: ProfileInput
}

export type MutationUpdateSignatureArgs = {
  signatureType: SignatureType
  svgFile: Scalars['String']
}

export type MutationActivateBankCardArgs = {
  input: ActivateBankCardInput
}

export type MutationCreateBankAccountArgs = {
  input: CreateBankAccountInput
}

export type MutationLockBankCardArgs = {
  input: LockBankCardInput
}

export type MutationOrderBankCardArgs = {
  input: OrderBankCardInput
}

export type MutationUpdateBankCardPinArgs = {
  input: UpdateBankCardPinInput
}

export type MutationReportBankCardLostStolenArgs = {
  input: ReportBankCardLostStolenInput
}

export type MutationCloseBankAccountArgs = {
  input: CloseBankAccountInput
}

export type MutationReissueBankCardArgs = {
  input: ReissueBankCardInput
}

export type MutationSubmitSpendTransactionsDisputeArgs = {
  input: SubmitSpendTransactionsDisputeInput
}

export type MutationCreateSavingsAccountArgs = {
  input: CreateSavingsAccountInput
}

export type MutationUpdateBankAccountGoalArgs = {
  input: UpdateBankAccountGoalInput
}

export type MutationAssignLinkedSubaccountArgs = {
  linkedSubaccountId: Scalars['ID']
  input: AssignLinkedSubaccountInput
}

export type MutationCreatePlaidLinkedAccountArgs = {
  publicToken: Scalars['String']
  input: CreatePlaidLinkedAccountInput
}

export type MutationGenerateLinkSessionArgs = {
  userId?: Maybe<Scalars['ID']>
  input: GenerateLinkSessionInput
}

export type MutationRegisterLinkSessionArgs = {
  input: LinkSessionInput
}

export type MutationSetLinkingErrorArgs = {
  linkedAccountId: Scalars['ID']
  linkingErrorCode: SetLinkingErrorInput
}

export type MutationUnlinkLinkedAccountArgs = {
  linkedAccountId: Scalars['ID']
}

export type MutationUpdateLinkedAccountArgs = {
  linkedAccountId: Scalars['ID']
  input: UpdateLinkedAccountInput
}

export type MutationRoundUpProfileArgs = {
  input: RoundUpProfileInput
}

export type MutationSetManualRoundUpsArgs = {
  roundUpIds: Array<Scalars['ID']>
}

export type MutationUpdateRoundUpAccountArgs = {
  enabled: Scalars['Boolean']
  linkedSubaccountId: Scalars['ID']
}

export type MutationInitiateTransferArgs = {
  input: InitiateTransferInput
}

export type MutationCancelTransferArgs = {
  id: Scalars['ID']
  accountId: Scalars['ID']
}

export type MutationStartCheckDepositArgs = {
  input: StartCheckDepositInput
}

export type MutationUploadCheckArgs = {
  input: UploadCheckInput
}

export type MutationCompleteCheckDepositArgs = {
  input: CompleteCheckDepositInput
}

export type MutationCreateSupportTicketArgs = {
  input: CreateSupportTicketInput
}

export type MutationCreateSupportTicketOrExceptionArgs = {
  input: CreateSupportTicketInput
}

export type MutationCreateAuthenticatedSupportTicketArgs = {
  input: CreateSupportTicketInput
}

export type MutationCreateSupportTicketWithCustomFieldsArgs = {
  input: CreateCustomSupportTicketInput
}

export type MutationCreateSuspendedUserSupportTicketArgs = {
  input: CreateSuspendedUserSupportTicketInput
}

export type MutationCreateDirectDepositLinkInfoArgs = {
  input: CreateDirectDepositLinkInfoInput
}

export type MutationStartAcornsPdfSwitchArgs = {
  input: StartAcornsPdfSwitchInput
}

export type MutationStartOnlineSwitchArgs = {
  input: StartOnlineSwitchInput
}

export type MutationStartSubmittableSwitchArgs = {
  input: StartSubmittableSwitchInput
}

export type MutationUpdateSuitabilityArgs = {
  suitabilityInput: Array<Suitability_SuitabilityInput>
}

export type MutationCancelCheckPaymentArgs = {
  id: Scalars['ID']
}

export type MutationSendCheckPaymentArgs = {
  input: SendCheckPaymentInput
}

export type MutationAcceptDocumentArgs = {
  input: AcceptDocumentInput
}

export type MutationAddSecurityToPortfolioArgs = {
  input: AddSecurityToPortfolioInput
}

export type MutationAddSelfDirectedPortfolioArgs = {
  input: AddSelfDirectedPortfolioInput
}

export type MutationCancelInvestmentArgs = {
  input: CancelInvestmentInput
}

export type MutationCancelInvestmentAccountClosureRequestArgs = {
  input: CancelInvestmentAccountClosureRequestInput
}

export type MutationCloseInvestmentAccountArgs = {
  input: CloseInvestmentAccountInput
}

export type MutationCreateProspectUserArgs = {
  input: CreateProspectUserInput
}

export type MutationCreateUploadUrlArgs = {
  input: CreateUploadUrlInput
}

export type MutationEnableQuarterlyRecapsArgs = {
  input: EnableQuarterlyRecapsInput
}

export type MutationLegacyUploadDocumentArgs = {
  input: LegacyUploadDocumentInput
}

export type MutationLinkManualFundingSourceArgs = {
  input: LinkManualFundingSourceInput
}

export type MutationOpenCoreInvestmentAccountArgs = {
  input: OpenCoreInvestmentAccountInput
}

export type MutationOpenEarlyAccountArgs = {
  input: OpenEarlyAccountInput
}

export type MutationPartnerLinkManualFundingSourceArgs = {
  input: PartnerLinkFundingSourceInput
}

export type MutationRecordInvestmentAccountRecapViewArgs = {
  input: RecordInvestmentAccountRecapViewInput
}

export type MutationRegenerateInvestmentAccountRecapPublicTokenArgs = {
  input: RegenerateInvestmentAccountRecapPublicTokenInput
}

export type MutationRemoveSecurityFromPortfolioArgs = {
  input: RemoveSecurityFromPortfolioInput
}

export type MutationRemoveSelfDirectedPortfolioArgs = {
  input: RemoveSelfDirectedPortfolioInput
}

export type MutationRequestEarlyAccountClosureArgs = {
  input: RequestEarlyAccountClosureInput
}

export type MutationRequestInvestmentAccountReopenArgs = {
  input: RequestInvestmentAccountReopenInput
}

export type MutationSaveUploadUrlArgs = {
  input: SaveUploadUrlInput
}

export type MutationSetInvestmentAccountRecapPublicAccessArgs = {
  input: SetInvestmentAccountRecapPublicAccessInput
}

export type MutationUnauthenticatedCreateUploadUrlArgs = {
  input: UnauthenticatedCreateUploadUrlInput
}

export type MutationUnauthenticatedSaveUploadUrlArgs = {
  input: UnauthenticatedSaveUploadUrlInput
}

export type MutationUpdateAccountPortfolioArgs = {
  input: UpdateAccountPortfolioInput
}

export type MutationUpdatePortfolioSecuritiesArgs = {
  input: UpdatePortfolioSecuritiesInput
}

export type MutationUpdateRegistrationArgs = {
  input: RegistrationInput
}

export type MutationValidateUserSuspendedUploadTokenArgs = {
  input: ValidateUserSuspendedUploadTokenInput
}

export type MutationInitiateLaterProgramAccountContributionArgs = {
  input: LaterProgramAccountContributionInput
}

export type MutationLaterWithdrawalArgs = {
  amount: Scalars['Float']
  earlyDistributionTaxExceptionReason?: Maybe<Scalars['String']>
  federalTaxes: Scalars['Float']
  investmentAccountId: Scalars['ID']
  reason?: Maybe<LaterWithdrawalReason>
  stateTaxes: Scalars['Float']
  taxYear: Scalars['Int']
  withdrawalType?: Maybe<LaterWithdrawalType>
}

export type MutationTaxWithholdingAmountsArgs = {
  investmentId: Scalars['ID']
  totalSharesAmount: CurrencyAmountInput
}

export type MutationVerifyLaterAccountOrErrorArgs = {
  investmentAccountId: Scalars['ID']
}

export type MutationScheduleRecurringTransferArgs = {
  input: ScheduleRecurringTransferInput
}

export type MutationCancelRecurringTransferArgs = {
  id: Scalars['ID']
}

export type MutationProtectApplyLifeQuoteArgs = {
  quoteInput: LifeQuoteApplyInput
}

export type MutationProtectCreateLifeQuoteArgs = {
  input: LifeQuoteInput
}

export type MutationProtectUpdateCoverageArgs = {
  coverageResponse: CoverageResponse
}

export type MutationProtectUpdateRecommendedLifeCoverageArgs = {
  calculatorInput: LifeCalculatorInput
}

export type MutationProtectUpdateResponsesArgs = {
  questionResponses: Array<QuestionResponse>
}

export type MutationFeedEventArgs = {
  feedEvent: ActionFeedEvent
}

export type MutationAddFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput
}

export type MutationRemoveFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput
}

export type MutationSetFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput
}

export type MutationCreateJobAlertArgs = {
  alertCriteria: JobAlertCriteriaInput
}

export type MutationRemoveJobAlertArgs = {
  id: Scalars['String']
}

export type MutationAddMilestonesToGroupArgs = {
  addMilestonesToGroupInput: AddMilestonesToMilestoneGroupDefinitionInput
}

export type MutationCreateMilestoneGroupDefinitionArgs = {
  createGroupDefinitionInput: CreateMilestoneGroupDefinitionInput
}

export type MutationRemoveMilestonesFromGroupArgs = {
  removeMilestonesFromGroupInput: RemoveMilestonesFromMilestoneGroupDefinitionInput
}

export type MutationAddActionToMilestoneGroupAchievementActionRuleArgs = {
  addActionToRuleInput: AddActionToMilestoneGroupAchievementActionRuleInput
}

export type MutationCreateMilestoneGroupAchievementActionRuleArgs = {
  createRuleInput: CreateMilestoneGroupAchievementActionRuleInput
}

export type MutationRemoveActionFromMilestoneGroupAchievementActionRuleArgs = {
  removeActionFromRuleInput: RemoveActionFromMilestoneGroupAchievementActionRuleInput
}

export type MutationAddMilestonesToMilestoneHubDefinitionArgs = {
  addActionToRuleInput: AddMilestonesToMilestoneHubDefinitionInput
}

export type MutationCreateMilestoneHubDefinitionArgs = {
  createMilestoneHubDefinitionInput: CreateMilestoneHubDefinitionInput
}

export type MutationRemoveMilestonesFromMilestoneHubDefinitionArgs = {
  removeActionFromRuleInput: RemoveMilestonesFromMilestoneHubDefinitionInput
}

export type MutationDismissMessageArgs = {
  input: DismissMessageInput
}

export type MutationHideMessageByExternalIdArgs = {
  input: HideMessageByExternalIdInput
}

export type MutationReadMessageArgs = {
  input: ReadMessageInput
}

export type MutationMarkLearnContentAsHelpfulArgs = {
  input: MarkLearnContentAsHelpfulInput
}

export type MutationUnmarkLearnContentAsHelpfulArgs = {
  input: UnmarkLearnContentAsHelpfulInput
}

export type MutationMarkLearnContentAsViewedArgs = {
  input: MarkLearnContentAsViewedInput
}

export type MutationUpdateLearnContentProgressArgs = {
  input: UpdateLearnProgressInput
}

export type MutationAnswerLearnQuizQuestionArgs = {
  input: AnswerLearnQuizQuestionInput
}

export type MutationUpdateElapsedTimeForLearnQuizArgs = {
  input: UpdateElapsedTimeForLearnQuizInput
}

export type MutationRespondToLearnPollArgs = {
  input: RespondToLearnPollInput
}

export type MutationAddSearchTermToLearnSearchHistoryArgs = {
  input: AddSearchTermToLearnSearchHistoryInput
}

export type MutationUploadDocumentsArgs = {
  input: UploadDocumentsInput
}

export type MutationUploadUnsolicitedDocumentsArgs = {
  input: UploadUnsolicitedDocumentsInput
}

export type MutationCreateDocumentUploadArgs = {
  input: CreateDocumentUploadInput
}

export type MutationInitiateSmsChallengeArgs = {
  input: InitiateSmsChallengeInput
}

export type MutationInitiateEmailChallengeArgs = {
  input: InitiateEmailChallengeInput
}

export type MutationReinitiateChallengeArgs = {
  input: ReinitiateSmsChallengeInput
}

export type MutationRegisterPhoneAuthenticatorArgs = {
  input: RegisterPhoneAuthenticatorInput
  challengeAnswerInput: ChallengeAnswerInput
}

export type MutationRegisterEmailAuthenticatorArgs = {
  input: RegisterEmailAuthenticatorInput
  challengeAnswerInput: ChallengeAnswerInput
}

export type MutationAuthenticateArgs = {
  input: AuthenticateInput
  challengeAnswerInput?: Maybe<ChallengeAnswerInput>
  alternateAuthenticatorId?: Maybe<Scalars['ID']>
}

export type MutationSetDefaultAuthenticatorArgs = {
  input: SetDefaultAuthenticatorInput
}

export type MutationRefreshAuthTokenArgs = {
  input: RefreshAuthTokenInput
}

export type MutationRegisterCredentialsArgs = {
  input: RegisterCredentialsInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationPasswordResetRequestArgs = {
  input: PasswordResetRequestInput
}

export type MutationVerifyDeviceArgs = {
  input: VerifyDeviceInput
  challengeAnswerInput?: Maybe<ChallengeAnswerInput>
}

export type MutationBlockDeviceArgs = {
  input: BlockDeviceInput
}

export type MutationUnblockDeviceArgs = {
  input: UnblockDeviceInput
}

export type MutationSetAuthenticationPinArgs = {
  input: SetAuthenticationPinInput
}

export type MutationVerifyPasswordsArgs = {
  input: VerifyPasswordsInput
}

export type MutationUpdateCredentialsArgs = {
  input: UserCredentialsInput
}

export type MutationUpdateSecurityQuestionAndAnswerArgs = {
  input: UpdateSecurityQuestionAndAnswerInput
}

export type MutationResetPasswordByTokenArgs = {
  input: ResetPasswordByTokenInput
}

export type MutationResetPasswordWithTokenArgs = {
  input: ResetPasswordWithTokenInput
}

export type MutationChangePasswordArgs = {
  oldPassword: Scalars['String']
  newPassword: Scalars['String']
  securityAnswer?: Maybe<SecurityAnswer>
}

export type MutationChangePasswordAuthArgs = {
  input: ChangePasswordInput
}

export type MutationApplyPromotionArgs = {
  input: ApplyPromotionInput
}

export type MutationDeactivateTierSubscriptionArgs = {
  input: DeactivateTierSubscriptionInput
}

export type MutationRequestSubscriptionMigrationWaiverArgs = {
  input: RequestSubscriptionMigrationWaiverInput
}

export type MutationSubscribeToTierArgs = {
  input: SubscribeToTierInput
}

export type MutationSubscribeUserToTierArgs = {
  input: SubscribeUserToTierInput
}

export type MutationSubscribeUserToTierByProductKeyArgs = {
  input?: Maybe<SubscribeUserToTierByProductKeyInput>
}

export type MutationUnsubscribeUserFromTierArgs = {
  input?: Maybe<UnsubscribeUserFromTierInput>
}

export type MutationSplitDepositSettingsArgs = {
  id: Scalars['ID']
  employerHidden?: Maybe<Scalars['Boolean']>
}

export type MutationSplitDepositArgs = {
  id: Scalars['ID']
}

export type MutationConfigureSplitDepositDirectDepositIntentSettingArgs = {
  input: ConfigureSplitDepositDirectDepositIntentSettingInput
}

export type MutationConfigureSplitDepositDirectDepositSettingArgs = {
  input: ConfigureSplitDepositDirectDepositSettingInput
}

export type MutationChangeOutsideContributionAmountArgs = {
  input: ChangeOutsideContributionAmountInput
}

export type MutationCreateOutsideContributionArgs = {
  input: CreateOutsideContributionInput
}

export type MutationCreateOutsideContributionCheckoutCartArgs = {
  input: CreateOutsideContributionCheckoutCartInput
}

export type MutationAuthenticateForFeeNegotiationArgs = {
  input: AuthenticateForFeeNegotiationInput
}

export type MutationAuthenticateForFeeNegotiationChallengeMethodArgs = {
  input: AuthenticateForFeeNegotiationChallengeMethodInput
}

export type MutationAuthenticateForFeeNegotiationChallengeArgs = {
  input: AuthenticateForFeeNegotiationChallengeInput
}

export type MutationSubmitBankFeeNegotiationArgs = {
  input: SubmitBankFeeNegotiationInput
}

export type MutationSyncBankFeeTransactionsArgs = {
  input: SyncBankFeeTransactionsInput
}

export type MutationSubmitForBillNegotiationArgs = {
  input: SubmitForBillNegotiationInput
}

export type MutationSubmitUserReportedBankFeeRefundArgs = {
  input: SubmitUserReportedBankFeeRefundInput
}

export type MutationSetNegotiationStatusArgs = {
  input: SetNegotiationStatusInput
}

export type MutationSetUserPartnerStatusArgs = {
  input: PartnerStatusInput
}

export type MutationRegisterProspectArgs = {
  input: RegisterProspectInput
}

export type MutationUpdateAttributionArgs = {
  input: UpdateAttributionInput
}

export type MutationStubArgs = {
  id: Scalars['UUID']
}

/** The provided security percent is negative */
export type NegativeSecurityPercentError = {
  __typename?: 'NegativeSecurityPercentError'
  /** The security in question */
  securityId: Scalars['ID']
}

export enum NegotiationMethod {
  Automatic = 'AUTOMATIC',
  Letter = 'LETTER',
}

export type NegotiationServiceConnectionFailure = {
  __typename?: 'NegotiationServiceConnectionFailure'
  message: Scalars['String']
}

/** The next billing date for a user */
export type NextBillingDate = {
  __typename?: 'NextBillingDate'
  next_billing_date?: Maybe<Scalars['String']>
}

export type NextTransferDateResult = RecurringTransferDate | MalformedRecurringTransferException

/** Cannot open early account because the beneficiary id is invalid */
export type NoBeneficiaryFoundException = {
  __typename?: 'NoBeneficiaryFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** No Funding Source Alert. */
export type NoFundingSourceUserAlert = UserAlertsItem & {
  __typename?: 'NoFundingSourceUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** The user needs to close all other investment accounts before closing this account */
export type NonBasicAccountOpenException = {
  __typename?: 'NonBasicAccountOpenException'
  /** message */
  errorMessage?: Maybe<Scalars['String']>
}

export type NoProspectRecord = {
  __typename?: 'NoProspectRecord'
  message: Scalars['String']
}

export type Notification = {
  __typename?: 'Notification'
  category?: Maybe<Scalars['String']>
  subcategory?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  active: Scalars['Boolean']
}

export type NotificationMessage = Message & {
  __typename?: 'NotificationMessage'
  body: MessageTextAsset
  createdAt: Scalars['DateTime']
  deepLink?: Maybe<Scalars['URL']>
  icon?: Maybe<MessageVisualAsset>
  id: Scalars['ID']
  isDismissed: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isRead: Scalars['Boolean']
  messageCategory: MessageCategory
  messageType: MessageType
  readAt?: Maybe<Scalars['DateTime']>
  title: MessageTextAsset
  trackingId?: Maybe<Scalars['ID']>
  updatedAt: Scalars['DateTime']
}

export type Notifications = {
  __typename?: 'Notifications'
  emails?: Maybe<Array<Maybe<Notification>>>
  pushes?: Maybe<Array<Maybe<Notification>>>
}

/** Occupation that a user can select */
export type Occupation = {
  __typename?: 'Occupation'
  id: Scalars['ID']
  name: Scalars['String']
}

export type Offer = {
  __typename?: 'Offer'
  /**
   * Meta field enabling clients to delegate to the backend
   * more logic determining when it is valid to present the Offer.
   *
   * Examples: "SUBSCRIPTION_CANCELLATION", "PASSIONS_PRODUCT_EXPLORATION"
   */
  availableIn?: Maybe<Array<Scalars['String']>>
  /** The cohort of subscribers the Offer is available to (driven by the Offer type). */
  availableTo: OfferAvailability
  createdAt: Scalars['DateTime']
  /** Once subscribed to how long is the Offer valid for. */
  expiresAfter?: Maybe<OfferExpiration>
  expiresAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** What the Offer entitles a subscriber access to. */
  offering: Offering
  /** Amount the subscriber agrees to pay for access to the Offer's offering. */
  price: OfferPrice
  /** URL to the terms and conditions of the Offer. */
  termsUrl: Scalars['URL']
  /** Indicates semantics of the Offer (generally whom it is available to and when). */
  type: OfferType
  updatedAt?: Maybe<Scalars['DateTime']>
}

export enum OfferAvailability {
  All = 'ALL',
  Cancelled = 'CANCELLED',
  Existing = 'EXISTING',
  New = 'NEW',
  None = 'NONE',
}

export type OfferExpiration = {
  __typename?: 'OfferExpiration'
  period: OfferExpirationPeriod
  value: Scalars['Int']
}

export enum OfferExpirationPeriod {
  Month = 'MONTH',
}

export enum OfferGroupsType {
  Category = 'CATEGORY',
  Ranked = 'RANKED',
}

/** An Offering is something that a subscriber subscribes to access to. */
export type Offering = Product | Tier

export type OfferLocation = {
  __typename?: 'OfferLocation'
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
}

export type OfferLocationInput = {
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
}

export type OfferPrice = {
  __typename?: 'OfferPrice'
  amount: CurrencyAmount
  type: OfferPriceType
}

export type OfferPriceInput = {
  amount: CurrencyAmountInput
  type: OfferPriceType
}

export enum OfferPriceType {
  Free = 'FREE',
  Monthly = 'MONTHLY',
}

export enum OfferType {
  Promotional = 'PROMOTIONAL',
  Standard = 'STANDARD',
}

export type OmnibusShareTransferId = {
  __typename?: 'OmnibusShareTransferId'
  value: Scalars['String']
}

export enum OnboardingStepType {
  /** basic */
  Basic = 'basic',
  /** binary question */
  BinaryQuestion = 'binary_question',
  /** binary question with skip option */
  BinaryQuestionWithSkip = 'binary_question_with_skip',
  /** informational */
  Informational = 'informational',
  /** multi choice */
  MultiChoice = 'multi_choice',
  /** success */
  Success = 'success',
}

export type OnboardingTipItem = {
  __typename?: 'OnboardingTipItem'
  body: Scalars['String']
  headline: Scalars['String']
  id: Scalars['ID']
  image: Image
  title: Scalars['String']
  type: OnboardingTipType
}

export type OnboardingTips = {
  __typename?: 'OnboardingTips'
  items: Array<OnboardingTipItem>
}

export enum OnboardingTipType {
  /** introduction */
  Intro = 'intro',
  /** feature */
  Feature = 'feature',
}

/** Online Switches are performed through the Employer's URL. */
export type OnlineSwitch = SwitchInterface & {
  __typename?: 'OnlineSwitch'
  source: SwitchSource
  type: SwitchType
  /** Employer URL */
  url: Scalars['String']
  vendorTargetId?: Maybe<Scalars['ID']>
}

/** Cannot close user account if user has open spend/investment accounts */
export type OpenAccountsException = {
  __typename?: 'OpenAccountsException'
  /** User's open account types */
  openAccountTypes?: Maybe<Array<Scalars['String']>>
}

/** Input for creating a Core InvestmentAccount */
export type OpenCoreInvestmentAccountInput = {
  /** ID of the portfolio for this investment account */
  portfolioId: Scalars['String']
}

/** Result from opening a Core InvestmentAccount */
export type OpenCoreInvestmentAccountResult =
  | CoreAccountAlreadyExistsException
  | InvalidPortfolioIdException
  | InvestmentAccount
  | InvestmentAccountCreationException
  | UserClosedException
  | UserNotFoundException

/** Input for creating an early investment account */
export type OpenEarlyAccountInput = {
  /** Name of investment account */
  investmentAccountName?: Maybe<Scalars['String']>
  /** Beneficiary ID */
  beneficiaryId: Scalars['ID']
  /** Termination age of the investment account */
  terminationAge: Scalars['Int']
  /** State in which to open the investment account (defaults to custodian's state) */
  stateCode?: Maybe<Scalars['String']>
}

/** Result from opening an Early Investment Account */
export type OpenEarlyAccountResult =
  | BeneficiaryAccountExistsException
  | CoreAccountClosedException
  | InternalErrorException
  | InvalidStateException
  | InvalidSubscriptionTierException
  | InvalidTerminationAgeException
  | InvestmentAccount
  | MaxAccountsCreatedException
  | MissingBeneficiarySsnException
  | NoBeneficiaryFoundException
  | UserClosedException
  | UserNotFoundException
  | UserNotVerifiedException

export enum OperationStage {
  ProcessingCredentials = 'PROCESSING_CREDENTIALS',
  AwaitingTfaOption = 'AWAITING_TFA_OPTION',
  ProcessingTfaOption = 'PROCESSING_TFA_OPTION',
  AwaitingTfaCode = 'AWAITING_TFA_CODE',
  ProcessingTfaCode = 'PROCESSING_TFA_CODE',
  AuthCompleted = 'AUTH_COMPLETED',
  AuthFailed = 'AUTH_FAILED',
}

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type OrderBankCardInput = {
  isDocumentsAccepted: Scalars['Boolean']
  prefundTransfer?: Maybe<BankCardPrefundTransfer>
  isReopen?: Maybe<Scalars['Boolean']>
  paymentProcessor?: Maybe<BankCardPaymentProcessor>
  bankType?: Maybe<BankType>
  bankCardTier?: Maybe<BankCardTier>
  employmentStatus?: Maybe<Scalars['String']>
  requestVersion?: Maybe<RequestVersions>
}

export type OrderBankCardResult = BankCardOrder

/** Outside contribution object */
export type OutsideContribution = TimestampsInterface & {
  __typename?: 'OutsideContribution'
  accountId: Scalars['ID']
  checkoutCart: OutsideContributionCheckoutCart
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  failureReason?: Maybe<Scalars['String']>
  id: Scalars['ID']
  investmentId?: Maybe<Scalars['ID']>
  note?: Maybe<Scalars['String']>
  noteAuthor?: Maybe<Scalars['String']>
  paymentMethodId: Scalars['ID']
  state: ContributionState
  transferRequestId?: Maybe<Scalars['ID']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** an outside contribution checkout cart object */
export type OutsideContributionCheckoutCart = TimestampsInterface & {
  __typename?: 'OutsideContributionCheckoutCart'
  code: OutsideContributionCode
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  feeAmount: Scalars['String']
  id: Scalars['ID']
  investmentAmount: Scalars['String']
  paymentIntentId: Scalars['ID']
  status: CheckoutCartStatus
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** Code for outside contribution */
export type OutsideContributionCode = TimestampsInterface & {
  __typename?: 'OutsideContributionCode'
  /** Unique code that has one-to-one relationship with investment Account */
  code: Scalars['String']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  investmentAccountId: Scalars['ID']
  recipientFirstName: Scalars['String']
  /** This is the id of who the contribution is going to. Most likely beneficiary id */
  recipientId: Scalars['ID']
  signupBonusUrl: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
  userId: Scalars['ID']
}

/** Object representing an outside contribution prospect */
export type OutsideContributionProspect = Prospect & {
  __typename?: 'OutsideContributionProspect'
  email: Scalars['String']
  id: Scalars['ID']
}

export type Owner = {
  __typename?: 'Owner'
  description?: Maybe<Scalars['String']>
  greyLogoImageUrl?: Maybe<Scalars['URL']>
  colorBackgroundLogoImageUrl?: Maybe<Scalars['URL']>
  id: Scalars['ID']
  imageUrl?: Maybe<Scalars['URL']>
  monochromeImageUrl?: Maybe<Scalars['URL']>
  name?: Maybe<Scalars['String']>
  slug?: Maybe<Scalars['String']>
  twitterHandle?: Maybe<Scalars['String']>
}

export enum PackageStatus {
  /** Not Found */
  NotFound = 'notFound',
  /** Found – No Status */
  NoStatus = 'noStatus',
  /** Logged at USPS */
  LoggedAtUsps = 'loggedAtUSPS',
  /** Customer Recall */
  CustomerRecall = 'customerRecall',
  /** Delivered */
  Delivered = 'delivered',
  /** Dead Letter */
  DeadLetter = 'deadLetter',
  /** Forwarded to New Address */
  ForwardedToNewAddress = 'forwardedToNewAddress',
  /** Scanned in Route */
  ScannedInRoute = 'scannedInRoute',
  /** Notice Left for Recipient */
  NoticeLeftForRecipient = 'noticeLeftForRecipient',
  /** New Item */
  NewItem = 'newItem',
  /** Out for Delivery */
  OutForDelivery = 'outForDelivery',
  /** Available for Pickup */
  AvailableForPickup = 'availableForPickup',
  /** Returned to Sender */
  ReturnedToSender = 'returnedToSender',
  /** Undeliverable */
  Undeliverable = 'undeliverable',
  /** Delivery Status Not Updated */
  DeliveryStatusNotUpdated = 'deliveryStatusNotUpdated',
  /** Other */
  Other = 'other',
}

/** Specifies Page Information */
export type PageInfo = {
  __typename?: 'PageInfo'
  hasNextPage: Scalars['Boolean']
  hasPreviousPage: Scalars['Boolean']
  limit: Scalars['Int']
}

export type PageInput = {
  after?: Maybe<Scalars['ID']>
  first?: Maybe<Scalars['Int']>
}

export enum PageName {
  AboutPortfolio = 'ABOUT_PORTFOLIO',
  Analyzing = 'ANALYZING',
  BankLinkSuccess = 'BANK_LINK_SUCCESS',
  CardOrderReview = 'CARD_ORDER_REVIEW',
  CardSignature = 'CARD_SIGNATURE',
  ChooseFundingSource = 'CHOOSE_FUNDING_SOURCE',
  ContactInfo = 'CONTACT_INFO',
  CryptoLander = 'CRYPTO_LANDER',
  DirectBankIntegration = 'DIRECT_BANK_INTEGRATION',
  DirectBankIntegrationRedirect = 'DIRECT_BANK_INTEGRATION_REDIRECT',
  DirectToMobile = 'DIRECT_TO_MOBILE',
  EsgDetails = 'ESG_DETAILS',
  EsgEducation = 'ESG_EDUCATION',
  Funding = 'FUNDING',
  Institutions = 'INSTITUTIONS',
  InvestorQuestions = 'INVESTOR_QUESTIONS',
  InvestInterstitial = 'INVEST_INTERSTITIAL',
  ManualFundingSource = 'MANUAL_FUNDING_SOURCE',
  MfaSetUp = 'MFA_SET_UP',
  MocReferralReminder = 'MOC_REFERRAL_REMINDER',
  MocRoutingInterstitial = 'MOC_ROUTING_INTERSTITIAL',
  MocSuccess = 'MOC_SUCCESS',
  Occupation = 'OCCUPATION',
  OneTimeDeposit = 'ONE_TIME_DEPOSIT',
  OneTimeInvestment = 'ONE_TIME_INVESTMENT',
  PersonalInfo = 'PERSONAL_INFO',
  PlaidLinkRedirect = 'PLAID_LINK_REDIRECT',
  PortfolioDetails = 'PORTFOLIO_DETAILS',
  PreviewPortfolio = 'PREVIEW_PORTFOLIO',
  PricingInterstitial = 'PRICING_INTERSTITIAL',
  ProgressScreen_1 = 'PROGRESS_SCREEN_1',
  ProgressScreen_2 = 'PROGRESS_SCREEN_2',
  ProgressScreen_3 = 'PROGRESS_SCREEN_3',
  RecurringDeposit = 'RECURRING_DEPOSIT',
  RecurringInvestment = 'RECURRING_INVESTMENT',
  ReferralDisclosure = 'REFERRAL_DISCLOSURE',
  ReferralReward = 'REFERRAL_REWARD',
  RoundUpsFunding = 'ROUND_UPS_FUNDING',
  RoundUpsInterstitial = 'ROUND_UPS_INTERSTITIAL',
  RoundUpsPast = 'ROUND_UPS_PAST',
  RoundUpsSetUp = 'ROUND_UPS_SET_UP',
  SecondChanceBankLink = 'SECOND_CHANCE_BANK_LINK',
  SecondChanceInstitutions = 'SECOND_CHANCE_INSTITUTIONS',
  SelectPortfolioTheme = 'SELECT_PORTFOLIO_THEME',
  SelectTier = 'SELECT_TIER',
  ShippingAddress = 'SHIPPING_ADDRESS',
  Signup = 'SIGNUP',
  Ssn = 'SSN',
  Success = 'SUCCESS',
  SuitabilityQuestions = 'SUITABILITY_QUESTIONS',
}

/** Query attributes for Direct Deposit Parameterized PDF Generation */
export type ParameterizedPdfInput = {
  /** User ID */
  userId: Scalars['ID']
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Employer Name */
  employerName: Scalars['String']
  /** Date Signed */
  dateSigned: Scalars['String']
  /** Amount Option */
  distributionType: DirectDepositDistribution
  /** Value of Amount Option Chosen */
  distributionAmount?: Maybe<Scalars['Float']>
  /** Session ID */
  sessionId?: Maybe<Scalars['ID']>
}

export type Partner = {
  __typename?: 'Partner'
  accountToken?: Maybe<Scalars['String']>
  authorization?: Maybe<PartnerAuthorizationData>
  clientCredentialsToken?: Maybe<Scalars['String']>
  clientId?: Maybe<Scalars['ID']>
  existingAccountRedirectUri?: Maybe<Scalars['String']>
  externalId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  logoTypeUrl?: Maybe<Scalars['String']>
  name: Scalars['String']
  plaidInstitutionId?: Maybe<Scalars['ID']>
  routingNumbers?: Maybe<Array<PartnerRoutingNumber>>
  user: PartnerUserPayload
  website: Scalars['String']
}

export type PartnerAuthorizationData = {
  __typename?: 'PartnerAuthorizationData'
  provider: Scalars['String']
  uid: Scalars['String']
  accessToken?: Maybe<Scalars['String']>
  refreshToken?: Maybe<Scalars['String']>
  expiresAt?: Maybe<Scalars['DateTime']>
}

export type PartnerChoices = {
  __typename?: 'PartnerChoices'
  body: Scalars['String']
  cta: Cta
  icon: Image
  title: Scalars['String']
}

export type PartnerDetailsResponse = {
  __typename?: 'PartnerDetailsResponse'
  partnerLogoUrl: Scalars['String']
  partnerName: BenefitsPartner
}

export type PartnerDocumentUrlResponse = {
  __typename?: 'PartnerDocumentUrlResponse'
  documentUrl: Scalars['String']
}

/** Input for creating a manual, ACH funding source from a partner account token */
export type PartnerLinkFundingSourceInput = {
  /** the account token associated with a routing and account number */
  accountToken: Scalars['String']
}

/** PartnerLinkFundingSourceResult */
export type PartnerLinkFundingSourceResult =
  | CurrentBankStatementNotProvided
  | FundingSourceAccount
  | FundingSourceAlreadyExists
  | FundingSourceCredentialsExceedLinkLimit
  | InvalidAccountNumber
  | InvalidAccountToken
  | InvalidManualLink
  | InvalidRoutingNumber
  | PreviousFundingSourcePending
  | RdvVerificationRequired

export type PartnerOfferGroup = {
  __typename?: 'PartnerOfferGroup'
  /** display body for the group */
  body?: Maybe<Scalars['String']>
  carouselType: CarouselType
  id: Scalars['ID']
  /** list of offers in the group */
  offers: Array<PartnerOfferGroupItem>
  /** display title for the group */
  title?: Maybe<Scalars['String']>
}

/** Used to customize offer group contents */
export type PartnerOfferGroupFilterInput = {
  /** Location is required for job offers */
  location?: Maybe<OfferLocationInput>
}

export type PartnerOfferGroupItem = JobOffer | PromoOffer | JobSearchOffer | EarnOffer

/** Specifies the offer group type input */
export type PartnerOfferGroupsTypeInput = {
  type: OfferGroupsType
}

export type PartnerRoutingNumber = {
  __typename?: 'PartnerRoutingNumber'
  routingNumber: Scalars['String']
}

export type PartnerStatusInput = {
  product: BenefitsProduct
  partner: BenefitsPartner
  acornsPartnerStatus: AcornsPartnerStatus
  partnerStatus?: Maybe<Scalars['String']>
  partnerUpdatedDt?: Maybe<Scalars['DateTime']>
  partnerEventPayload?: Maybe<Scalars['String']>
}

export type PartnerUrlInput = {
  product: BenefitsProduct
}

export type PartnerUrlResponse = {
  __typename?: 'PartnerUrlResponse'
  partnerUrl: Scalars['String']
  status: AcornsPartnerStatus
}

export type PartnerUserPayload = {
  __typename?: 'PartnerUserPayload'
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  dob?: Maybe<Scalars['String']>
  ssn?: Maybe<Scalars['String']>
  address1?: Maybe<Scalars['String']>
  address2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  zip?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  usCitizen?: Maybe<Scalars['Boolean']>
}

export enum PasswordResetErrors {
  PasswordsDoNotMatch = 'PASSWORDS_DO_NOT_MATCH',
  NewPasswordMatchesOldPassword = 'NEW_PASSWORD_MATCHES_OLD_PASSWORD',
  InvalidPasswordLength = 'INVALID_PASSWORD_LENGTH',
  InvalidPasswordMissingUpperCase = 'INVALID_PASSWORD_MISSING_UPPER_CASE',
  InvalidPasswordMissingLowerCase = 'INVALID_PASSWORD_MISSING_LOWER_CASE',
  InvalidPasswordMissingNumber = 'INVALID_PASSWORD_MISSING_NUMBER',
  InvalidPasswordMissingSpecialCharacter = 'INVALID_PASSWORD_MISSING_SPECIAL_CHARACTER',
  InvalidSsn = 'INVALID_SSN',
}

export type PasswordResetForm = {
  __typename?: 'PasswordResetForm'
  userId?: Maybe<Scalars['ID']>
  fields: Array<Maybe<PasswordResetFormFields>>
}

export type PasswordResetFormFields = {
  __typename?: 'PasswordResetFormFields'
  key: Scalars['String']
  value?: Maybe<Scalars['String']>
}

export type PasswordResetRequestInput = {
  email: Scalars['EmailAddress']
}

/** Decorator type for items that have attached notes for display */
export type PastAnnotatedItem = {
  /** Past Item ID */
  id: Scalars['ID']
  /** Annotation on the item */
  note?: Maybe<Scalars['String']>
  /** Author of the note */
  noteAuthor?: Maybe<Scalars['String']>
}

/** A base set of fields that each type of PastItem must implement */
export type PastCoreCombinedItem = {
  /** Past Item ID */
  id: Scalars['ID']
  isCombinedInvestment: Scalars['Boolean']
}

/** A generic money movement line item for the Core account */
export type PastCoreItem = PastItem & {
  __typename?: 'PastCoreItem'
  /** Past Item ID */
  id: Scalars['ID']
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** The title of the item */
  title: Scalars['String']
  /** The current state of the item */
  status: PastItemStatus
  amount?: Maybe<CurrencyAmount>
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The corresponding product of the item */
  productType: ProductType
}

/** Metrics for core to be displayed in the summary */
export type PastCoreSummary = {
  __typename?: 'PastCoreSummary'
  investments: CurrencyAmount
  /** Total gain / loss including fees */
  netReturns: CurrencyAmount
  dividends: CurrencyAmount
  foundMoneyRewards: CurrencyAmount
  referralRewards: CurrencyAmount
  withdrawals: CurrencyAmount
}

/** A base set of fields that each traded PastItem must implement */
export type PastCoreTradedItem = {
  /** Past Item ID */
  id: Scalars['ID']
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl?: Maybe<Scalars['URL']>
}

/** A base set of fields all Early items share */
export type PastEarlyItem = {
  beneficiaryAccountId: Scalars['String']
}

/** Metrics for early to be displayed in the summary */
export type PastEarlySummary = {
  __typename?: 'PastEarlySummary'
  contributions: CurrencyAmount
  /** Total gain / loss including fees */
  netReturns: CurrencyAmount
  dividends: CurrencyAmount
  withdrawals: CurrencyAmount
}

/** A base set of fields that each type of PastItem must implement */
export type PastItem = {
  /** Past Item ID */
  id: Scalars['ID']
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** The title of the item */
  title: Scalars['String']
  /** The current state of the item */
  status: PastItemStatus
  amount?: Maybe<CurrencyAmount>
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The corresponding product of the item */
  productType: ProductType
}

/** PastItem connection object */
export type PastItemConnection = {
  __typename?: 'PastItemConnection'
  edges: Array<PastItemEdge>
  pageInfo: PageInfo
}

export type PastItemEdge = {
  __typename?: 'PastItemEdge'
  node?: Maybe<PastItem>
  cursor: Scalars['ID']
}

export enum PastItemStatus {
  Pending = 'pending',
  Selling = 'selling',
  Transferring = 'transferring',
  Complete = 'complete',
}

export type PastLaterSummary = {
  __typename?: 'PastLaterSummary'
  contributions: CurrencyAmount
  currentYearContributions: CurrencyAmount
  dividends: CurrencyAmount
  netReturns: CurrencyAmount
  priorYearContributions: CurrencyAmount
  withdrawals: CurrencyAmount
}

/** A generic money movement line item for the Spend account */
export type PastSpendItem = PastItem &
  SpendItem & {
    __typename?: 'PastSpendItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount?: Maybe<CurrencyAmount>
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

/** Metrics for spend to be displayed in the summary */
export type PastSpendSummary = {
  __typename?: 'PastSpendSummary'
  /** @deprecated Will be displayed on Past Core Summary */
  foundMoneyPlus?: Maybe<CurrencyAmount>
  /**
   * Withdrawals for this month. Current month is based on current PST time
   * @deprecated Use `debitsLast30Days`
   */
  debits?: Maybe<CurrencyAmount>
  /**
   * One time or direct deposits for this month. Current month is based on current PST time
   * @deprecated Use `depositsLast30Days`
   */
  deposits?: Maybe<CurrencyAmount>
  /** Withdrawals/purchases for the last 30 days. Based on current PST time */
  debitsLast30Days?: Maybe<CurrencyAmount>
  /** One time or direct deposits for the last 30 days. Based on current PST time */
  depositsLast30Days?: Maybe<CurrencyAmount>
  /** Primary account's current available balance */
  availableBalance?: Maybe<CurrencyAmount>
  instantRoundUps?: Maybe<CurrencyAmount>
}

/** Adds an estimated completion date field for items that correspond to user external transfers */
export type PastUserTransferItem = {
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate?: Maybe<Scalars['DateTime']>
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring?: Maybe<Scalars['Boolean']>
}

/** Query attributes for Direct Deposit PDF URL Generation */
export type PdfDownloadUrlInput = {
  /** User ID */
  userId: Scalars['ID']
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Employer Name */
  employerName: Scalars['String']
  /** Session ID */
  sessionId?: Maybe<Scalars['ID']>
}

/** Returns URL with JWT token to lambda for Front-end */
export type PdfDownloadUrlPayload = {
  __typename?: 'PdfDownloadUrlPayload'
  /** PDF Download URL */
  url: Scalars['String']
}

export type PdfFormLinks = {
  __typename?: 'PdfFormLinks'
  formUrls: Array<Maybe<Scalars['String']>>
  id: Scalars['ID']
}

/** Performance values for a given Investment Account */
export type Performance = {
  __typename?: 'Performance'
  /** Investment account values based on previous market day's closing prices */
  accountValues?: Maybe<Array<Maybe<AccountValue>>>
  /** The dollar change in account value over the reporting period */
  marketChange?: Maybe<Scalars['Float']>
  /** The percentage change in account value over the reporting period */
  marketChangePercent?: Maybe<Scalars['Float']>
  /** The percentage change in account value over the reporting period (excluding fees) */
  marketChangePercentWithoutFees?: Maybe<Scalars['Float']>
  /** The dollar change in account value over the reporting period (excluding fees) */
  marketChangeWithoutFees?: Maybe<Scalars['Float']>
  /** Investment account value based on previous market day's closing prices */
  previousCloseAmount?: Maybe<Scalars['Float']>
  /**
   * The total dollar amount invested over the reporting period
   * @deprecated Will not be supported in the future
   */
  totalInvested?: Maybe<Scalars['Float']>
  /**
   * The total dollar amount invested over the reporting period (including pending investments)
   * @deprecated Will not be supported in the future
   */
  totalInvestedWithPending?: Maybe<Scalars['Float']>
}

export type PersonalInfoInput = {
  address1?: Maybe<Scalars['String']>
  address2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  dob?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  employer?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  occupation?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  ssn?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  usCitizen?: Maybe<Scalars['Boolean']>
  zip?: Maybe<Scalars['String']>
}

/** Miscellaneous attributes and information about a user's phone numbers */
export type Phone = TimestampsInterface & {
  __typename?: 'Phone'
  /** Country code */
  countryCode: Scalars['String']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for phone */
  id: Scalars['ID']
  /** Phone Number */
  phoneNumber: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
  /** Phone has been verified */
  verified: Scalars['Boolean']
}

export type PhoneAuthenticator = Authenticator & {
  __typename?: 'PhoneAuthenticator'
  id: Scalars['ID']
  name: Scalars['String']
  lastUsedAt?: Maybe<Scalars['DateTime']>
  phoneNumber: Scalars['PhoneNumber']
  deviceId: Scalars['ID']
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
}

export type PhoneNumberOptedOutException = {
  __typename?: 'PhoneNumberOptedOutException'
  message?: Maybe<Scalars['String']>
}

export enum PinwheelLinkTokenRequiredJobs {
  DirectDepositSwitch = 'DirectDepositSwitch',
}

export enum PlanPeriod {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  MontHlY = 'MONTHlY',
  Annual = 'ANNUAL',
}

export type PoBoxAddressError = {
  __typename?: 'POBoxAddressError'
  message: Scalars['String']
}

/** Acorns Managed Portfolio Object */
export type Portfolio = BasePortfolio & {
  __typename?: 'Portfolio'
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation
  cashOwed: MonetaryAmount
  currentAllocationPercentage: Scalars['Float']
  currentBalance: MonetaryAmount
  currentBalanceWithPending: MonetaryAmount
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel?: Maybe<PortfolioCustomizationLevel>
  /** Description of the portfolio */
  description: Scalars['String']
  /**
   * Indicates the ETFs that the portfolio is composed of
   * @deprecated Use BasePortfolio.portfolioSecurityAllocations instead
   */
  etfs?: Maybe<Array<Etf>>
  /**
   * Securities currently owned by the Portfolio's InvestmentAccount (will be null
   * if not selected in the context of an InvestmentAccount).
   * @deprecated Use Portfolio.portfolioSecurities instead.
   */
  holdings?: Maybe<Array<PortfolioHolding>>
  /** ID of the Portfolio */
  id: Scalars['ID']
  /** Indicates the minimum ratio that must be allocated to the managed portfolio */
  minimumManagedAllocationPercent: Scalars['Float']
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']
  /** Indicates a key based off of the portfolio name */
  nameKey: Scalars['String']
  pendingBalance: MonetaryAmount
  /**
   * Securities currently owned by the Portfolio's InvestmentAccount (will be null
   * if not selected in the context of an InvestmentAccount).
   */
  portfolioSecurities?: Maybe<Array<PortfolioSecurity>>
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations?: Maybe<Array<PortfolioSecurityAllocation>>
  /** Indicates the display priority */
  position?: Maybe<Scalars['Int']>
  /** Indicates the projection of the portfolio */
  projection?: Maybe<PortfolioProjection>
  /** Indicates how risky the portfolio is */
  riskLevel: PortfolioRiskLevel
  /** Indicates if the portfolio is standard or sustainable */
  theme: PortfolioTheme
  yearToDateReturn?: Maybe<MarketReturn>
}

/** Portfolio Allocation Object */
export type PortfolioAllocation = {
  __typename?: 'PortfolioAllocation'
  /** Percentage of investment allocated to this portfolio */
  allocationPercent: Scalars['Float']
  /** ID of the PortfolioAllocation */
  portfolioId: Scalars['ID']
}

export type PortfolioAlreadyRemovedError = {
  __typename?: 'PortfolioAlreadyRemovedError'
  /** Date and Time of removal if portfolio is already removed */
  portfolioRemovedAt: Scalars['DateTime']
}

export enum PortfolioCustomizationLevel {
  /** Portfolio holdings and allocation percentages are pre-set. */
  None = 'NONE',
  /** Additional pre-approved Security's may be added to the Portfolio at pre-set allocations. */
  Addon = 'ADDON',
  /** Portfolio holdings and allocation percentages are fully configurable. */
  FullyConfigured = 'FULLY_CONFIGURED',
}

/** Portfolio Holding */
export type PortfolioHolding = {
  __typename?: 'PortfolioHolding'
  /** The dollar amount of shares a user has */
  amount: Scalars['Float']
  id: Scalars['ID']
  /** The Acorns-assigned name of the ETF */
  name: Scalars['String']
  /** The actual percentage of a user's portfolio the ETF accounts for */
  percentage: Scalars['Float']
  /** The quanity of shares a user has */
  shares: Scalars['Float']
  /** The ETF's trading symbol */
  symbol: Scalars['String']
}

/** Portfolio Not Found */
export type PortfolioNotFoundException = {
  __typename?: 'PortfolioNotFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Portfolio Not Supported */
export type PortfolioNotSupportedException = {
  __typename?: 'PortfolioNotSupportedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Portfolio Projection */
export type PortfolioProjection = {
  __typename?: 'PortfolioProjection'
  /** The projected average growth rate */
  averageGrowthRate: Scalars['Float']
  /** The projected highest growth rate */
  highestGrowthRate: Scalars['Float']
  /** The projected lowest growth rate */
  lowestGrowthRate: Scalars['Float']
}

export type PortfolioRemovalInProgressError = {
  __typename?: 'PortfolioRemovalInProgressError'
  /** Message displayed to customer when a portfolio removal is already in progress */
  clientMessage: Scalars['String']
}

export enum PortfolioRiskLevel {
  Conservative = 'CONSERVATIVE',
  ModeratelyConservative = 'MODERATELY_CONSERVATIVE',
  Moderate = 'MODERATE',
  ModeratelyAggressive = 'MODERATELY_AGGRESSIVE',
  Aggressive = 'AGGRESSIVE',
  Custom = 'CUSTOM',
}

/** Portfolio Security */
export type PortfolioSecurity = {
  __typename?: 'PortfolioSecurity'
  /** The current percentage of the market value over the customer's total balance */
  currentAllocationPercentage: Scalars['Float']
  id: Scalars['ID']
  /** The market value of shares owned by the customer */
  marketValue: MonetaryAmount
  /** The Acorns-assigned name of the security */
  name: Scalars['String']
  /** The quantity of shares a user has */
  shares: Scalars['Float']
  /** The security's trading symbol */
  symbol: Scalars['String']
  /**
   * DEPRECATED: The target percentage of the market value over the customer's total balance
   * @deprecated Will not be populated with self directed investments release.
   */
  targetAllocationPercentage?: Maybe<Scalars['Float']>
  /** The customer's returns for today */
  todaysReturn: MarketReturn
  /** The customer's returns for all time for the security */
  totalReturn: MarketReturn
}

/** Security allocation */
export type PortfolioSecurityAllocation = {
  __typename?: 'PortfolioSecurityAllocation'
  allocationPercent: Scalars['Float']
  /** @deprecated Use Security.displayName instead */
  displayName: Scalars['String']
  id: Scalars['ID']
  /** Indicates the investment category for the security */
  investmentCategories: InvestmentCategory
  /** @deprecated Use Security.shortName instead */
  name: Scalars['String']
  /** Indicates whether the Security can be removed from an Investment Account's base Portfolio. */
  removableFromBasePortfolio: Scalars['Boolean']
  symbol: Scalars['String']
  security?: Maybe<Security>
}

/** Portfolio Security Limit Reached */
export type PortfolioSecurityLimitReached = {
  __typename?: 'PortfolioSecurityLimitReached'
  /** Maximum amount of security allowed */
  limit: Scalars['Int']
}

export enum PortfolioTheme {
  Standard = 'STANDARD',
  Sustainable = 'SUSTAINABLE',
  SelfDirected = 'SELF_DIRECTED',
}

/** Failed to update portfolio on investment account */
export type PortfolioUpdateFailedException = {
  __typename?: 'PortfolioUpdateFailedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type PositiveCurrencyAmountInput = {
  currency: Currency
  value: Scalars['PositiveFloat']
}

/** quote premium */
export type Premium = {
  __typename?: 'Premium'
  amount: Scalars['Float']
  term: Scalars['Int']
}

/** Query input to get user specific premiums for a life quote */
export type PremiumsInput = {
  /** Provider key */
  providerName: ProviderName
  /** Specific coverage amount to get premiums for */
  coverageAmount?: Maybe<Scalars['Int']>
}

/** Life quote query results */
export type PremiumsResult = {
  __typename?: 'PremiumsResult'
  quoteData: QuoteResult
  quoteStatus: QuoteStatus
}

/** Presentation-driven entity for an associated Product */
export type PresentableProduct = {
  __typename?: 'PresentableProduct'
  /** Keys to strings to display description of associated product */
  descriptionKeys: Array<Scalars['StringKey']>
  /** Associated product */
  product: Product
}

export enum PresentableWithdrawalStatus {
  Pending = 'pending',
  SellingInvestments = 'sellingInvestments',
  Transferring = 'transferring',
  Complete = 'complete',
  Canceled = 'canceled',
  Refunded = 'refunded',
  Failed = 'failed',
}

/** Existing funding source in pending state */
export type PreviousFundingSourcePending = {
  __typename?: 'PreviousFundingSourcePending'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** Canonical representation of an Acorns product that can be used and billed for. */
export type Product = {
  __typename?: 'Product'
  /** Indicates whether or not the Product is available to new Users. */
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  descriptionKeys?: Maybe<Array<Scalars['String']>>
  id: Scalars['ID']
  key: ProductKey
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
}

/** Ref for product name */
export enum ProductKey {
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD',
  Early = 'EARLY',
  EarlyPublishing = 'EARLY_PUBLISHING',
  EarlySelfDirectedInvest = 'EARLY_SELF_DIRECTED_INVEST',
  Earn = 'EARN',
  EarnChoice = 'EARN_CHOICE',
  EarnPrime = 'EARN_PRIME',
  EmergencyFund = 'EMERGENCY_FUND',
  Invest = 'INVEST',
  Later = 'LATER',
  Learn = 'LEARN',
  MightyOakCard = 'MIGHTY_OAK_CARD',
  PremiumEducation = 'PREMIUM_EDUCATION',
  SelfDirectedInvest = 'SELF_DIRECTED_INVEST',
  Spend = 'SPEND',
}

export enum ProductSetupTipType {
  /** spend - setup direct deposit */
  SpendDirectDeposit = 'spend_direct_deposit',
  /** spend - setup recurring deposit */
  SpendRecurringDeposit = 'spend_recurring_deposit',
  /** spend - setup smart deposit */
  SpendSmartDeposit = 'spend_smart_deposit',
  /** spend - smart deposit sweepstakes */
  SpendSmartDepositSweepstakes = 'spend_smart_deposit_sweepstakes',
  /** spend - set spend as primary */
  SpendSetAsPrimary = 'spend_set_as_primary',
  /** spend - incentive to setup direct deposit */
  SpendDirectDepositIncentive = 'spend_direct_deposit_incentive',
  /** invest - link primary checking */
  InvestLinkPrimaryChecking = 'invest_link_primary_checking',
  /** invest - link roundup cards */
  InvestLinkRoundupCards = 'invest_link_roundup_cards',
  /** invest - set auto roundups */
  InvestSetAutoRoundups = 'invest_set_auto_roundups',
  /** invest - schedule regular deposits */
  InvestScheduleRegularDeposits = 'invest_schedule_regular_deposits',
  /** invest - make first investment */
  InvestMakeFirstInvestment = 'invest_make_first_investment',
  /** invest - try sustainable portfolio */
  InvestTrySustainablePortfolio = 'invest_try_sustainable_portfolio',
  /** invest - add bitcoin to diversified portfolio */
  InvestAddBitcoin = 'invest_add_bitcoin',
  /** invest - try self-directed portfolio */
  InvestTrySelfDirectedPortfolio = 'invest_try_self_directed_portfolio',
  /** later - link primary checking */
  LaterLinkPrimaryChecking = 'later_link_primary_checking',
  /** later schedule regular deposits */
  LaterScheduleRegularDeposits = 'later_schedule_regular_deposits',
  /** later - make first investment */
  LaterMakeFirstInvestment = 'later_make_first_investment',
  /** later - set a beneficiary */
  LaterSetABeneficiary = 'later_set_a_beneficiary',
  /** later - try sustainable portfolio */
  LaterTrySustainablePortfolio = 'later_try_sustainable_portfolio',
  /** early - setup recurring transfers */
  EarlyRecurringTransfer = 'early_recurring_transfer',
  /** early - setup direct deposit */
  EarlyDirectDeposit = 'early_direct_deposit',
  /** early - try sustainable portfolio */
  EarlyTrySustainablePortfolio = 'early_try_sustainable_portfolio',
  /** all contexts - nps survey */
  NpsSurvey = 'nps_survey',
  /** all contexts - referral promotion */
  ReferralPromotion = 'referral_promotion',
  /** home - path to million promotion */
  PathToMillion = 'path_to_million',
  /** home - wildfire chrome extension */
  WildfireChromeExtension = 'wildfire_chrome_extension',
  /** home - try sustainable portfolio */
  HomeTrySustainablePortfolio = 'home_try_sustainable_portfolio',
  /** home - link primary checking */
  HomeLinkPrimaryChecking = 'home_link_primary_checking',
  /** home - link roundup cards */
  HomeLinkRoundupCards = 'home_link_roundup_cards',
  /** home - set auto roundups */
  HomeSetAutoRoundups = 'home_set_auto_roundups',
  /** home - try self-directed portfolio */
  HomeTrySelfDirectedPortfolio = 'home_try_self_directed_portfolio',
  /** home - try benefits hub */
  BenefitsHub = 'benefits_hub',
  /** home - harvest bank fees */
  HarvestBankFees = 'harvest_bank_fees',
  /** home - earn safari extension */
  EarnSafariExtension = 'earn_safari_extension',
  /** home - earn android extension */
  EarnAndroidExtension = 'earn_android_extension',
  /** invest hub - link primary checking */
  InvestHubLinkPrimaryChecking = 'invest_hub_link_primary_checking',
  /** invest hub - link roundup cards */
  InvestHubLinkRoundupCards = 'invest_hub_link_roundup_cards',
  /** invest hub - set auto roundups */
  InvestHubSetAutoRoundups = 'invest_hub_set_auto_roundups',
  /** checking engagement wizard - direct deposit */
  CheckingEngagementWizardDirectDeposit = 'checking_engagement_wizard_direct_deposit',
  /** checking engagement wizard - pay bills */
  CheckingEngagementWizardPayBills = 'checking_engagement_wizard_pay_bills',
  /** checking engagement wizard - set auto roundups */
  CheckingEngagementWizardSetAutoRoundups = 'checking_engagement_wizard_set_auto_roundups',
  /** checking engagement wizard - set up emergency fund */
  CheckingEngagementWizardEmergencyFund = 'checking_engagement_wizard_emergency_fund',
  /** checking engagement wizard - activate card */
  CheckingEngagementWizardActivateCard = 'checking_engagement_wizard_activate_card',
}

export enum ProductType {
  Core = 'core',
  Early = 'early',
  Later = 'later',
  Spend = 'spend',
}

/** Miscellaneous attributes and information about a user */
export type Profile = TimestampsInterface & {
  __typename?: 'Profile'
  /** Annual income */
  annualIncome?: Maybe<Scalars['Int']>
  /** Combined annual income */
  combinedAnnualIncome?: Maybe<Scalars['Int']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Employees */
  employees?: Maybe<Employees>
  /** Employment status */
  employmentStatus?: Maybe<EmploymentStatus>
  /** Filing type */
  filingType?: Maybe<FilingType>
  /** First name */
  firstName?: Maybe<Scalars['String']>
  /** Funds availability */
  fundsAvailability?: Maybe<FundsAvailability>
  /** Last name */
  lastName?: Maybe<Scalars['String']>
  /** Marital status */
  maritalStatus?: Maybe<MaritalStatus>
  /** Retirement plan access */
  retirementPlanAccess?: Maybe<RetirementPlanAccess>
  /** Self employed income */
  selfEmployedIncome?: Maybe<Scalars['Int']>
  /** Signature type */
  signatures: Array<Maybe<Signature>>
  /** Last four of SSN */
  ssnLastFour?: Maybe<Scalars['String']>
  /** User has paused their transfers */
  transfersPaused?: Maybe<Scalars['Boolean']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
}

export type ProfileAttribute = {
  key: Scalars['String']
  value: Scalars['JSON']
}

/** Changeable attributes for user profiles */
export type ProfileInput = {
  /** Status of user's employment */
  employmentStatus?: Maybe<EmploymentStatus>
  /** Funds availability */
  fundsAvailability?: Maybe<FundsAvailability>
  /** Marital status */
  maritalStatus?: Maybe<MaritalStatus>
  /** How the user wants to access their retirement plan */
  retirementPlanAccess?: Maybe<RetirementPlanAccess>
  /** How the user files their taxes */
  filingType?: Maybe<FilingType>
  /** Number of employees the user has (if self employed) */
  employees?: Maybe<Employees>
  /** Total annual income */
  combinedAnnualIncome?: Maybe<Scalars['Int']>
  /** Self employed income */
  selfEmployedIncome?: Maybe<Scalars['Int']>
  /** Non-self employed income */
  annualIncome?: Maybe<Scalars['Int']>
  /** Pause transfers */
  transfersPaused?: Maybe<Scalars['Boolean']>
}

export enum ProgramAccountType {
  Plan = 'PLAN',
}

/** Display wrapper for featured promo offer */
export type PromoOffer = {
  __typename?: 'PromoOffer'
  /** Background/featured image */
  backgroundImage: Image
  /** Display body for the offer */
  body?: Maybe<Scalars['String']>
  /** Desktop Background/featured image */
  desktopBackgroundImage: Image
  id: Scalars['ID']
  /** Company/partner logo */
  logo?: Maybe<Image>
  /** Partner url */
  partnerUrl: Scalars['URL']
  /** Display subtitle for the offer */
  subtitle?: Maybe<Scalars['String']>
  /** Display title for the offer */
  title: Scalars['String']
}

/** Time-bound pricing and/or additional incentives offered to subscibers of a particular offering (tier or product). */
export type Promotion = {
  __typename?: 'Promotion'
  /** Wether or not the promotion is available for new applications. */
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  /** How long the promotion lasts once applied to a subscription. */
  duration?: Maybe<PromotionDuration>
  /** When the promotion is set to expire and become inactive. */
  expiresAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** Additional incentives the promotion entitles subscribers to. */
  incentives?: Maybe<Array<Incentive>>
  name: Scalars['String']
  /** Services that the promotion is for. */
  offering: Offering
  /** Metadata indicating in what contexts a client should present the promotion. */
  presentInContexts: Array<Scalars['String']>
  /** Link to legal terms and conditions of the promotion. */
  termsUrl: Scalars['URL']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type PromotionConsumedError = {
  __typename?: 'PromotionConsumedError'
  message: Scalars['String']
}

export type PromotionDuration = {
  __typename?: 'PromotionDuration'
  period: PromotionDurationPeriod
  periodCount: Scalars['Int']
}

export enum PromotionDurationPeriod {
  Month = 'MONTH',
}

export type PromotionExpiredError = {
  __typename?: 'PromotionExpiredError'
  expiredAt: Scalars['DateTime']
  message: Scalars['String']
}

export type PromotionFilterInput = {
  presentInContexts?: Maybe<PromotionPresentInContextsFilterInput>
}

export type PromotionNotFoundError = {
  __typename?: 'PromotionNotFoundError'
  message: Scalars['String']
}

export type PromotionPresentInContextsFilterInput = {
  in?: Maybe<Array<Scalars['String']>>
}

export type Prospect = {
  email: Scalars['String']
  id: Scalars['ID']
}

export enum ProspectType {
  Grow = 'GROW',
  LaterWaitlist = 'LATER_WAITLIST',
  OutsideContribution = 'OUTSIDE_CONTRIBUTION',
}

export type ProtectContext = {
  __typename?: 'ProtectContext'
  style: Scalars['String']
  widgetType: WidgetReferenceType
}

export type ProtectHome = {
  __typename?: 'ProtectHome'
  cta: Cta
  id: Scalars['ID']
  title: Scalars['String']
  widgets: Array<ProtectHomeWidget>
}

export type ProtectHomeWidget = Education | ExploreCarousel | HomeIcons | InsuranceSection

export type ProtectLander = {
  __typename?: 'ProtectLander'
  body: Scalars['String']
  cta: Cta
  id: Scalars['ID']
  image?: Maybe<Image>
  lastCheckinAt?: Maybe<Scalars['DateTime']>
  logo?: Maybe<Image>
  tipTitle: Scalars['String']
  title: Scalars['String']
  tutorialTitle: Scalars['String']
}

export type ProtectLearningCenter = {
  __typename?: 'ProtectLearningCenter'
  articles: Array<Article>
  body: Scalars['String']
  eyebrow: Scalars['String']
  id: Scalars['ID']
  image: Image
  title: Scalars['String']
}

export type Provider = {
  __typename?: 'Provider'
  cta?: Maybe<Cta>
  id: Scalars['ID']
  image: Image
  isSelected: Scalars['Boolean']
  title: Scalars['String']
}

export enum ProviderName {
  /** Ladder Life */
  Ladderlife = 'ladderlife',
}

export type ProviderSearch = {
  __typename?: 'ProviderSearch'
  body: Scalars['String']
  cta: Cta
  insuranceType: InsuranceType
  providers: Array<Provider>
  searchImage?: Maybe<Image>
  searchTitle: Scalars['String']
  subtitle: Scalars['String']
  title: Scalars['String']
  unknownProvider: UnknownProvider
}

export type Query = {
  __typename?: 'Query'
  /** Get the currently authenticated user */
  user?: Maybe<User>
  /** Get an action feed for the currently authenticated user */
  actionFeed?: Maybe<Array<Maybe<ActionCard>>>
  /** Get information about a user's primary funding source */
  fundingSourceInfo?: Maybe<FundingSourceInfo>
  /** @deprecated Use the past queries instead. */
  activity?: Maybe<Array<Maybe<Activity>>>
  /** Get a list of documents the user needs to accept */
  acceptanceDocuments?: Maybe<Array<Maybe<AcceptanceDocument>>>
  /** Get all acceptance documents */
  allAcceptanceDocuments?: Maybe<Array<Maybe<AcceptanceDocument>>>
  acceptanceDocument?: Maybe<AcceptanceDocument>
  /**
   * Fetch recurring investment settings for the specified InvestmentAccount
   * (defaults to the authenticated User's Core InvestmentAccount if not specified).
   */
  recurringInvestmentSettings?: Maybe<RecurringInvestmentSettings>
  /** @deprecated Use Query.investmentAccountsByUserId instead. */
  allInvestmentAccounts?: Maybe<Array<InvestmentAccount>>
  market?: Maybe<Market>
  /** @deprecated Calculations have been updated in newer API's. Use InvestmentAccount.performance instead. */
  performance?: Maybe<Performance>
  settings?: Maybe<Settings>
  notifications?: Maybe<Notifications>
  statements?: Maybe<Array<Maybe<Statement>>>
  /** @deprecated Toggles no longer supported. This will always returns true. */
  toggle?: Maybe<Toggle>
  partner?: Maybe<Partner>
  allSuitabilityQuestions?: Maybe<Array<Maybe<SuitabilityQuestion>>>
  allSecurityQuestions?: Maybe<Array<SecurityQuestion>>
  allCloseAccountReasons?: Maybe<Array<Maybe<CloseAccountReason>>>
  accountStrength?: Maybe<AccountStrengthResult>
  userStatus?: Maybe<UserStatus>
  extensionOwners?: Maybe<Array<Maybe<ExtensionOwner>>>
  extensionCampaignStore?: Maybe<ExtensionCampaignStore>
  extensionCampaignStores?: Maybe<Array<Maybe<ExtensionCampaignStore>>>
  extensionRewardsSummary: ExtensionRewardsSummary
  extensionTransactions?: Maybe<Array<Maybe<ExtensionTransaction>>>
  foundMoneyOffer?: Maybe<FoundMoneyOffer>
  /** @deprecated Use activeEarnOffers instead. */
  foundMoneyOffers?: Maybe<Array<FoundMoneyOffer>>
  foundMoneyCampaigns?: Maybe<Array<FoundMoneyCampaign>>
  foundMoneyRewards?: Maybe<Array<Maybe<FoundMoneyReward>>>
  foundMoneySummary?: Maybe<FoundMoneySummary>
  foundMoneyOfferCategories?: Maybe<Array<FoundMoneyOfferCategory>>
  laterAccounts?: Maybe<Array<Maybe<LaterAccount>>>
  laterBeneficiaries?: Maybe<Array<Maybe<LaterIndividualBeneficiary>>>
  laterHistory?: Maybe<Array<Maybe<LaterHistoryItem>>>
  laterPortfolioPerformance?: Maybe<LaterPortfolioPerformance>
  /** @deprecated Never implemented. */
  laterDeposits?: Maybe<Array<Maybe<LaterDeposit>>>
  /** @deprecated Never implemented. */
  rolloverAccounts?: Maybe<RolloverAccounts>
  /** @deprecated Never implemented. */
  custodianCompanies?: Maybe<Array<Maybe<CustodianCompany>>>
  withholdingDefaults?: Maybe<WithholdingDefaults>
  laterContributionHistory?: Maybe<Array<ContributionHistoryItem>>
  eligibility?: Maybe<Eligibility>
  remoteStrings?: Maybe<Scalars['JSON']>
  /** Fetch a list of accounts for a user */
  accounts: Array<Maybe<Account>>
  /** Fetch a list of addresses for a user */
  addresses: Array<Maybe<Address>>
  /** Fetch all beneficiary alerts for a user */
  alertHubBeneficiaryAlerts?: Maybe<Array<AlertHubBeneficiaryAlert>>
  /** Fetch all beneficiaries for a user */
  beneficiaries?: Maybe<Array<Beneficiary>>
  /** Fetch a beneficiary with a given ID */
  beneficiary?: Maybe<Beneficiary>
  /** Fetch all beneficiary alerts for a user */
  beneficiaryAlerts?: Maybe<Array<Alert>>
  /** Fetch a list of occupations */
  occupations?: Maybe<Array<Maybe<Occupation>>>
  /** Fetch a single profile for a user */
  profile: Profile
  /** Fetch a list of signatures for a user */
  signatures: Array<Maybe<Signature>>
  /** Fetch mighty oak card waiver for user. */
  MightyOakCardWaiver: MightyOakWaiverResult
  /** Fetch billing cycles given an ID */
  billingCycle?: Maybe<BillingCycle>
  /** Fetch billing cycles given a user ID */
  billingCycles?: Maybe<Array<BillingCycle>>
  /** Fetch a fee given the ID */
  fee?: Maybe<Fee>
  /** Fetch all fees given an argument */
  fees?: Maybe<Array<Fee>>
  /** Fetch the next billing date for a user */
  nextBillingDate?: Maybe<NextBillingDate>
  /** Used to determine if an address is deliverable or offer corrections to make it deliverable. */
  addressDeliverability?: Maybe<AddressDeliverabilityResult>
  allBankAccounts?: Maybe<Array<Maybe<BankAccount>>>
  allBankCards?: Maybe<Array<Maybe<BankCard>>>
  bankMetadata?: Maybe<BankMetadata>
  bankCardOrder?: Maybe<BankCardOrder>
  bankTransaction?: Maybe<BankTransaction>
  /** @deprecated Use backend documents instead */
  allBankDocuments?: Maybe<Array<Maybe<BankDocument>>>
  allBankStatements?: Maybe<Array<Maybe<BankStatement>>>
  spendAlerts?: Maybe<Array<Maybe<SpendAlert>>>
  allBankTransactions?: Maybe<BankTransactionConnection>
  spendAtms?: Maybe<SpendAtmsResult>
  spendAccount?: Maybe<SpendAccount>
  bankCardReissue?: Maybe<BankCardReissue>
  bankAccountClosureReasons: Array<BankAccountClosureReason>
  savingsAccountEligibilityByUserId?: Maybe<SavingsAccountEligibility>
  bankAccountDisclosures?: Maybe<Array<Maybe<BankAccountDisclosure>>>
  bankingEmploymentStatuses: Array<Scalars['String']>
  /** Fetch a Financial Institution by external ID */
  financialInstitution?: Maybe<FinancialInstitution>
  /** Fetch all Financial Institutions */
  financialInstitutions: FinancialInstitutionTypePagination
  /** Fetch a linked account */
  linkedAccount?: Maybe<LinkedAccount>
  /** Fetch alerts for linked account */
  linkedAccountAlerts?: Maybe<Array<LinkedAccountAlertsResponse>>
  /** Fetch webhook URLs */
  linkedAccountWebhooks: Webhooks
  /** Fetch linked accounts for a given user */
  linkedAccounts: Array<LinkedAccount>
  /** Fetch a linked subaccount */
  linkedSubaccount?: Maybe<LinkedSubaccount>
  /** Fetch linked subaccounts for a given user */
  linkedSubaccounts: Array<LinkedSubaccount>
  /** Fetch a round up account for a specified linked subaccount */
  roundUpAccount?: Maybe<RoundUpAccount>
  /** List round up accounts for a given user */
  roundUpAccounts: Array<RoundUpAccount>
  /** Fetch a single round up profile for a user */
  roundUpProfile?: Maybe<RoundUpProfile>
  /** List round ups for a given user */
  roundUps: RoundUpTypePagination
  /** Fetch all Core items for the Past screen. Defaults to only return non-pending transactions */
  allPastCoreItems?: Maybe<PastItemConnection>
  /** Fetch all Later items for the Past screen. Defaults to only return non-pending transactions */
  allPastLaterItems?: Maybe<PastItemConnection>
  allPastSpendItems?: Maybe<PastItemConnection>
  /** Fetch all Early items for the Past screen. Defaults to only return non-pending transactions */
  allPastEarlyItems?: Maybe<PastItemConnection>
  pastCoreSummary?: Maybe<PastCoreSummary>
  pastEarlySummary?: Maybe<PastEarlySummary>
  /** Totals for Spend */
  pastSpendSummary?: Maybe<PastSpendSummary>
  /** Fetch all Core items for the Past screen. */
  allPastCoreItemChildren?: Maybe<Array<PastItem>>
  pastSpendTransactionItem?: Maybe<PastItem>
  /** Fetch all pending items across all product types. */
  allPastPendingItems?: Maybe<Array<PastItem>>
  allTransferableFrom?: Maybe<Array<TransferableFrom>>
  allTransferableTo?: Maybe<Array<TransferableTo>>
  estimatedTransferDates?: Maybe<EstimatedTransferDatesPayload>
  allReturnedCheckDeposits?: Maybe<Array<ReturnedCheckDeposit>>
  /** Evaluates check deposit session to determine if it is submittable. */
  evaluateCheckDeposit?: Maybe<EvaluateCheckDepositPayload>
  /** Returns list of categories and nested subcategories for dynamic values in contact form */
  allContactCategories?: Maybe<Array<ContactCategory>>
  /** Returns all support articles */
  allSupportArticles?: Maybe<Array<Maybe<SupportArticle>>>
  /** Returns all the current categories within the Help Center */
  allSupportCategories?: Maybe<Array<Maybe<SupportCategory>>>
  /** Returns all support sections */
  allSupportSections?: Maybe<Array<Maybe<SupportSection>>>
  /** Returns all support ticket forms */
  allSupportTicketForms?: Maybe<Array<Maybe<SupportTicketForm>>>
  /**
   * See if in-app support chat is currently enabled. This is a fault-tolerant
   * query and thus will return `false` rather than fail.
   * @deprecated Replaced with more general supportSchedule query.
   */
  supportChatEnabled: Scalars['Boolean']
  /**
   * See if specified support channel is currently enabled. This is a
   * fault-tolerant query and thus will return `false` rather than fail.
   */
  supportSchedule?: Maybe<ScheduleResult>
  /** Returns contact form alert message if it has been set in Zesty */
  contactFormAlert?: Maybe<ContactFormAlert>
  /** Returns most common faq articles if it has been set in Zesty */
  supportMostCommonFaq?: Maybe<Array<ContactFaq>>
  /** Returns help form submission content */
  helpFormContent?: Maybe<HelpFormContent>
  /** Returns support article given an id */
  supportArticle?: Maybe<SupportArticle>
  /** Returns support section given an id */
  supportSection?: Maybe<SupportSection>
  /** Returns support category given an id */
  supportCategory?: Maybe<SupportCategory>
  /** Returns all articles in section given a sectionId  */
  supportArticlesBySectionId?: Maybe<Array<Maybe<SupportArticle>>>
  /** Returns instant support articles from search term currently in search field */
  instantSearchSupportArticles?: Maybe<Array<Maybe<SearchSupportArticleResult>>>
  /** Return the given support ticket form by id */
  supportTicketForm?: Maybe<SupportTicketForm>
  supportTicketFormField?: Maybe<SupportTicketFormField>
  /** Returns all relevant support articles and all categories given a query */
  searchSupportArticles?: Maybe<SearchSupportResult>
  /** Returns all support sections by category id */
  supportSectionsByCategoryId?: Maybe<Array<Maybe<SupportSection>>>
  /** Returns user winback score */
  userWinbackScore?: Maybe<UserWinbackScoreRes>
  /** Get the Card Delivery Status */
  allCardTrackingStatuses?: Maybe<Array<CardDeliveryStatus>>
  /** Return the user switches' state */
  directDepositState: DirectDepositStatePayload
  /** Generate Updated Base 64 Encoded PDF String */
  generateUpdatedPdf?: Maybe<GenerateUpdatedPdfPayload>
  /** Base 64 Encoded Parameterized PDF String */
  parameterizedPdf?: Maybe<GenerateUpdatedPdfPayload>
  /** PDF Download URL */
  pdfDownloadUrl?: Maybe<PdfDownloadUrlPayload>
  /** Employer Search */
  searchEmployers?: Maybe<SearchEmployersPayload>
  /** Top Employers */
  topEmployers: TopEmployerPayload
  /** Fetch the user's recommended portfolio */
  recommendedPortfolio?: Maybe<Suitability_Portfolio>
  /** Fetch all suitability questions and answers */
  suitabilityResponses?: Maybe<Array<Suitability_SuitabilityResponse>>
  /** Return if a client should use suitability service for a particular user */
  suitabilityServiceEnabled?: Maybe<Scalars['Boolean']>
  allCheckPayments?: Maybe<AllCheckPaymentsResult>
  estimatedCheckPaymentDates?: Maybe<EstimatedCheckPaymentDates>
  verifyCheckPaymentRecipientAddress?: Maybe<VerifyCheckPaymentRecipientAddressResult>
  /** Investment account closure reasons */
  closureReasonsByInvestmentAccountType: Array<InvestmentAccountClosureReason>
  /** Fetch the combined performance of user's investment accounts */
  combinedPerformanceByUserId: CombinedPerformance
  /** Get the currently offered crypto ETF that can be added to a managed Portfolio. */
  cryptoEtf?: Maybe<Etf>
  /** State and Territory regulations for Early Account for the given Custodian */
  earlyAccountClosureReasons: Array<InvestmentAccountClosureReason>
  /** State and Territory regulations for Early Account for the given Custodian */
  earlyAccountStateRegulation: EarlyAccountStateRegulationResult
  /** DEPRECATED - Use InvestmentAccountTransferability instead */
  earlyAccountTransferInfo?: Maybe<EarlyAccountTransferInfo>
  /** Fetches stored information about the ETF. */
  etf?: Maybe<Etf>
  /** Fetches a list of funding source(s) for the user */
  fundingSourceAccounts?: Maybe<Array<FundingSourceAccount>>
  /** Retrieve an Investment by it's unqiue `id`. */
  investment?: Maybe<Investment>
  /** Fetches an investment account for the authorized user */
  investmentAccount?: Maybe<InvestmentAccount>
  /** Return an investment account by the beneficiary ID */
  investmentAccountByBeneficiaryId?: Maybe<InvestmentAccount>
  /** Get an investment account recap by it's unique id. */
  investmentAccountRecap?: Maybe<InvestmentAccountRecap>
  /** Get an investment account recap by it's unique public token. */
  investmentAccountRecapByPublicToken?: Maybe<InvestmentAccountRecap>
  /** Fetch user's investment accounts */
  investmentAccountsByUserId: Array<InvestmentAccount>
  /** Fetch user's referral invitation */
  invitationForUser?: Maybe<Referral>
  /** Portfolios */
  portfolios: Array<Portfolio>
  /** Fetch user's referral */
  referralForUser?: Maybe<Referral>
  /** Fetches a registration record for a prospective user */
  registration: Result
  /** An array of the alerts for a user. */
  userAlerts?: Maybe<Array<UserAlertsResponse>>
  /**  AF cards to show user based on later state, e.g. "Create a beneficiary!" */
  laterAlerts?: Maybe<Array<Alert>>
  /**
   *  Contribution ability per year; only years in the current "tax window" returned
   * @deprecated Use laterUserContributionAbility
   */
  laterContributionAbility?: Maybe<Array<Maybe<ContributionAbility>>>
  laterUserContributionAbility?: Maybe<LaterContributionAbilityResult>
  pastLaterSummary?: Maybe<PastLaterSummary>
  /**  Estimated withholding amounts (only on gains for Roth IRAs) */
  withholdingEstimates?: Maybe<WithholdingEstimates>
  yearLaterReport: YearLaterReport
  recurringTransfers?: Maybe<Array<Maybe<RecurringTransfer>>>
  nextTransferDate?: Maybe<NextTransferDateResult>
  /** present the protect context */
  protectContext?: Maybe<ProtectContext>
  /** retrieve coverage shop cards */
  protectCoverageShop?: Maybe<CoverageShop>
  /** retrieve protect homepage content */
  protectHome?: Maybe<ProtectHome>
  /** Retrieve Insurance Home page info */
  protectInsuranceHome?: Maybe<InsuranceHome>
  /** retrieve lander page content */
  protectLander?: Maybe<ProtectLander>
  /** retrieve protect learning center content */
  protectLearningCenter?: Maybe<ProtectLearningCenter>
  /** Retrieve life calculator survey page info along with previous user input (if available) */
  protectLifeCalculatorSurvey?: Maybe<LifeCalculatorSurvey>
  /** retrieve user specific monthly premiums for life insurance quote */
  protectLifeQuotePremiums?: Maybe<PremiumsResult>
  /** Retrieve life quote survey for screens 1-3 */
  protectLifeQuoteSurvey?: Maybe<LifeQuoteSurvey>
  /** retrieve the full set of questions */
  protectOnboardingQuestions?: Maybe<Array<Question>>
  /** retrieve provider search page content and providers list */
  protectProviders?: Maybe<ProviderSearch>
  /** retrieve insurance recommendations */
  protectRecommendations?: Maybe<Recommendations>
  /** retrieve recommended coverage amount for life insurance */
  protectRecommendedLifeCoverage?: Maybe<RecommendedLifeCoverage>
  /** query account summary information */
  activitySummary?: Maybe<ActivitySummaryResponse>
  /** query finish setup information */
  finishSetup?: Maybe<FinishSetup>
  /** query the account onboarding tips modal */
  onboardingTips?: Maybe<OnboardingTips>
  /** Get personalized offers for a given user */
  personalizedFoundMoney?: Maybe<Array<FoundMoneyCampaignV2>>
  personalizedFoundMoneyV2?: Maybe<Array<FoundMoneyCampaignV2>>
  activeEarnOffers: EarnOfferQueryPage
  /** Retrieve EarnOffer by campaignOfferId with fall back support by campaignId */
  earnOfferByCampaignOfferId?: Maybe<EarnOffer>
  /** Retrieves list of favorite EarnOffers that the user is currently eligible for */
  favoriteEarnOffers: FavoritePartnerOfferGroup
  searchActiveEarnOffers: EarnOfferQueryPage
  partnerOfferGroup?: Maybe<PartnerOfferGroup>
  partnerOfferGroupsByType?: Maybe<Array<PartnerOfferGroup>>
  jobAlerts?: Maybe<Array<JobAlert>>
  jobSearch?: Maybe<Array<Jobs_Offer>>
  jobSearchV2?: Maybe<Jobs_OfferConnection>
  jobSearchPage?: Maybe<JobSearchPage>
  jobEducationContent?: Maybe<Jobs_Education>
  milestoneRules?: Maybe<Array<MilestoneRule>>
  milestone?: Maybe<Milestone>
  milestonesByTheme?: Maybe<MilestoneThemeGroup>
  milestoneHub?: Maybe<MilestoneHub>
  milestoneHubDefinition?: Maybe<MilestoneHubDefinition>
  milestoneHubDefinitions: Array<MilestoneHubDefinition>
  /** @deprecated This does not support the account setup user state, replace with featuredMilestones_v2 */
  featuredMilestones: FeaturedMilestones
  featuredMilestones_v2?: Maybe<FeaturedMilestonesV2>
  milestoneDefinition?: Maybe<MilestoneDefinition>
  milestoneDefinitions?: Maybe<Array<MilestoneDefinition>>
  milestoneGroupDefinition?: Maybe<MilestoneGroupDefinition>
  milestoneGroupDefinitions?: Maybe<Array<MilestoneGroupDefinition>>
  milestoneChallengePointsRuleByMilestoneIdByChallengeId?: Maybe<MilestoneChallengePointsRule>
  milestoneChallengePointsRulesByMilestoneId?: Maybe<Array<MilestoneChallengePointsRule>>
  milestoneChallenge?: Maybe<MilestoneChallenge>
  promoMilestoneChallengeId?: Maybe<Scalars['ID']>
  milestoneEligibilityByScopes?: Maybe<Array<MilestoneEligibility>>
  /** @deprecated This query was only relevant for the initial rollout of milestone hub, replace with milestoneEligibilityByScopes */
  milestoneHubEligible?: Maybe<Eligibility>
  milestoneAchievementActionRule?: Maybe<MilestoneAchievementActionRule>
  milestoneAchievementActionRules: Array<MilestoneAchievementActionRule>
  milestoneGroupAchievementActionRule?: Maybe<MilestoneGroupAchievementActionRule>
  milestoneGroupAchievementActionRules?: Maybe<Array<MilestoneGroupAchievementActionRule>>
  accountPointsRuleByMilestoneId?: Maybe<AccountPointsRule>
  accountPointsRules?: Maybe<Array<AccountPointsRule>>
  milestoneAccountLevelDefinitions?: Maybe<Array<MilestoneAccountLevelDefinition>>
  milestoneAchievementActionTypes: Array<MilestoneAchievementActionType>
  /**
   * Fetches all messages for a user. Leverages Hedwig's DB for
   * notifications/alerts and queries external services for alerts. Make sure a
   * `x-client-platform` header is passed in.
   */
  allMessages?: Maybe<Array<Message>>
  /** Fetches messages for a user. Supports pagination (offset/count) and filtering. */
  messages?: Maybe<MessageConnection>
  /** Returns a list of all Learn Hub tiers and topics combined */
  learnContentCategories?: Maybe<Array<LearnContentCategory>>
  /** Returns a personalized list of featured learn content */
  featuredLearnContentPersonalizedByUserId?: Maybe<Array<FeaturedLearnContentPreview>>
  /** Returns a list of trending content for given tier */
  trendingLearnContentByTierId?: Maybe<Array<TrendingLearnContentPreview>>
  /** Returns a list of trending content for given topic */
  trendingLearnContentByTopicId?: Maybe<Array<TrendingLearnContentPreview>>
  /** Returns a personalized list of trending learn content */
  trendingLearnContentPersonalizedByUserId?: Maybe<Array<TrendingLearnContentPreview>>
  /** Returns a learn media content or null if one does not exist for the ID */
  learnMedia?: Maybe<LearnMedia>
  /** Returns a list of next step actions for the requested media */
  learnNextStepActionsByMediaId?: Maybe<Array<LearnNextStepAction>>
  /** Returns a list of learn content related to the provided media ID */
  relatedLearnContentByMediaId?: Maybe<Array<LearnContentPreview>>
  /** Returns a course or null if it does not exist */
  course?: Maybe<Course>
  /** Returns a list of courses for given tier */
  coursesByTierId?: Maybe<Array<CoursePreview>>
  /** Returns a list of courses for given topic */
  coursesByTopicId?: Maybe<Array<CoursePreview>>
  /** Returns a list of courses for given topic */
  coursesByTopicId_v2?: Maybe<Array<LearnCoursePreview>>
  /** Returns a personalized list of courses */
  coursesPersonalizedByUserId?: Maybe<Array<CoursePreview>>
  /** Returns a list of course next step actions */
  learnNextStepActionsByCourseId?: Maybe<Array<LearnNextStepAction>>
  /** Returns a list of related courses based on shared tags */
  relatedCoursePreviewsByCourseId?: Maybe<Array<CoursePreview>>
  /** Returns a list of related courses based on shared tags */
  relatedCoursePreviewsByCourseId_v2?: Maybe<Array<LearnCoursePreview>>
  /** Returns related Quiz for Course */
  relatedQuizByCourseId?: Maybe<Quiz>
  /** Returns info for completed quiz such as user score, average score, number of total and correct questions */
  completedQuizByQuizId?: Maybe<CompletedQuiz>
  /** Returns a list of question insights related to the incorrect questions */
  learnQuestionInsightsByQuizId?: Maybe<Array<LearnQuestionInsight>>
  /** Returns quiz with given id or null if it does not exists */
  quiz?: Maybe<Quiz>
  /** Returns a list of 5 quizzes that are contained in courses with similar tags as the given course */
  relatedQuizzesByCourseId?: Maybe<Array<QuizPreview>>
  /** Returns the Article with given id */
  learnArticle?: Maybe<LearnArticle>
  /** Returns related Course for Article */
  relatedCourseByArticleId?: Maybe<Course>
  /** Returns a list of related articles based on primary topic */
  relatedLearnContentByArticleId?: Maybe<Array<LearnContentPreview>>
  /** Returns all results that match given term. Results can be filtered and sorted. */
  learnContentBySearchTerm?: Maybe<ContentPreviewConnection>
  /** Returns all results that match given tier. Results can be filtered and sorted. */
  learnContentByTierId?: Maybe<ContentPreviewConnection>
  /** Returns all results that match given topic. Results can be filtered and sorted. */
  learnContentByTopicId?: Maybe<ContentPreviewConnection>
  /** Returns up to 3 recommendations for search terms of at least 3 chars */
  learnContentRecommendationsBySearchTerm?: Maybe<Array<LearnContentPreview>>
  /** Returns recent search terms and popular searches */
  learnContentSearchHistoryByUserId?: Maybe<SearchHistory>
  documentRequest?: Maybe<DocumentRequest>
  documentRequests?: Maybe<DocumentRequestsConnection>
  registeredAuthenticators?: Maybe<Array<Authenticator>>
  authProfile?: Maybe<AuthProfile>
  authAlerts?: Maybe<Array<AuthAlert>>
  passwordResetFormFieldsByToken?: Maybe<PasswordResetForm>
  /** Check for existence of credentials and formatting of input for a given email */
  emailAddressValidation: EmailAddressValidation
  validatePasswordResetToken: ValidatePasswordResetTokenResult
  offer?: Maybe<Offer>
  /** Lookup a specific Product by it's unique id. */
  product?: Maybe<Product>
  /** Lookup a specific Product by it's unique key. */
  productByKey?: Maybe<Product>
  /** List all Products. */
  products?: Maybe<Array<Product>>
  /** Lookup a particular promotion by it's unique id. */
  promotion?: Maybe<Promotion>
  /** Get a list of promotions to which a user is eligible. */
  promotionsByUserId?: Maybe<Array<Promotion>>
  subscriptionMigration?: Maybe<SubscriptionMigration>
  subscriptionMigrationWaiver?: Maybe<SubscriptionMigrationWaiver>
  subscriptionMigrationWaiversByUserId?: Maybe<Array<SubscriptionMigrationWaiver>>
  /** Lookup a Tier by it's unique id. */
  tier?: Maybe<Tier>
  /**
   * Returns a tier group w/ tiers, products, prices, etc. Can not be tied to
   * a specfic user (needs to support anonymous users).
   * id is optional for case of returning default
   */
  tierGroup?: Maybe<TierGroup>
  /** TierGroup for specific user (includes the Tier they are subscribed to) */
  tierGroupForUser?: Maybe<TierGroup>
  /**
   * Returns the cheapest tier option for a given user's open accounts
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByOpenAccounts?: Maybe<TierOption>
  /**
   * Returns the cheapest tier option for a given product key
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByProductKey?: Maybe<TierOption>
  /**
   * For a given TierPriceId, returns the TierOption associated with that price id.
   * Returns InvalidTierPriceId if the tier price id is not found.
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByTierPriceId?: Maybe<TierOptionByTierPriceIdResult>
  /** Any arbitrary subscription (current or historical) */
  tierSubscription?: Maybe<TierSubscription>
  /** A User's TierSubscription by User.uuid. */
  tierSubscriptionByUserId?: Maybe<TierSubscription>
  /**
   * The current subscription for an arbitrary user
   * @deprecated Use Query.tierSubscriptionByUserId.
   */
  tierSubscriptionForUser?: Maybe<TierSubscriptionForUser>
  /** All of a Users's TierSubscriptions by User.uuid. */
  tierSubscriptionHistoryByUserId?: Maybe<TierSubscriptionConnection>
  splitDepositSettings?: Maybe<SplitDepositSettings>
  splitDepositSettingsByUserId?: Maybe<Array<SplitDepositSettings>>
  smartDepositMetadata?: Maybe<SmartDepositMetadataResult>
  /** Fetch a code given the code uuid */
  outsideContributionCode?: Maybe<OutsideContributionCode>
  /** Fetch a code given the code string */
  outsideContributionCodeByCode?: Maybe<OutsideContributionCode>
  /** Fetch a code given the investment account id */
  outsideContributionCodeByInvestmentAccountId?: Maybe<OutsideContributionCode>
  earnCTADataByUserId?: Maybe<Array<EarnCtaRecord>>
  bankFeeNegotiationsByUserId?: Maybe<FeeNegotiationOutput>
  listUtilityServices?: Maybe<Array<Maybe<ServiceNode>>>
  bankFeeNegotiationResultsByUserId?: Maybe<BankFeeNegotiationResults>
  billNegotiationsByUserId?: Maybe<Array<Maybe<BillNegotiation>>>
  bankFeeNegotiationAlerts?: Maybe<Array<BankFeeNegotiationAlert>>
  bankFeesByUserId?: Maybe<Array<BankFee>>
  bankFeeSummaryByUserId?: Maybe<BankFeeSummary>
  authenticateForFeeNegotiationStatusByLinkedAccountId?: Maybe<AuthenticateForFeeNegotiationStatus>
  mailInDocumentsByUserId?: Maybe<Array<Maybe<MailInDocument>>>
  sampleMailInDocument?: Maybe<SampleMailInDocument>
  getPartnerUrl: PartnerUrlResponse
  getPartnerDocumentByUserId: PartnerDocumentUrlResponse
  getPartnerDetails: PartnerDetailsResponse
  advocate?: Maybe<Advocate>
  friend?: Maybe<Friend>
  /** Retrieves contextual information to direct user's registration funnel experience */
  registrationFunnel?: Maybe<RegistrationFunnel>
  securityBySymbol?: Maybe<Security>
  securitiesBySymbols?: Maybe<SecuritiesBySymbolsResponse>
  securityPerformanceBySymbol?: Maybe<SecurityPerformance>
  /** Provide historical end of day prices for many Securities */
  securityPerformancesBySymbol?: Maybe<Array<SecurityPerformance>>
  /**
   * Fuzzy search for Securities by symbol and company name
   * Securities are selected as "candidates" and then ordered by SearchSecuritiesInput.orderby
   * Results are served using a cursor-based pagination dictated by the page-size SearchSecuritiesInput.limit
   * and the cursor SearchSecuritiesInput.after
   */
  searchSecurities?: Maybe<SearchSecuritiesResponse>
  /**
   * Search for securities that are a part of any/all of the provided trading sectors SecuritiesBySectorInput.sectors
   * Securities that contain 1+ of the provided trading sectors are selected and
   * then ordered by SecuritiesBySectorInput.orderBy
   * Results are served using a cursor-based pagination dictated by the page-size SecuritiesBySectorInput.limit
   * and the cursor SecuritiesBySectorInput.after
   */
  securitiesBySector?: Maybe<SecuritiesBySectorResponse>
  cohortEligibility: Array<CohortEligibility>
}

export type QueryActionFeedArgs = {
  input?: Maybe<ActionCardsInput>
}

export type QueryActivityArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type QueryAcceptanceDocumentsArgs = {
  requiredFor?: Maybe<Scalars['String']>
}

export type QueryAllAcceptanceDocumentsArgs = {
  requiredFor?: Maybe<Scalars['String']>
}

export type QueryAcceptanceDocumentArgs = {
  type: Scalars['String']
}

export type QueryRecurringInvestmentSettingsArgs = {
  investmentAccountId?: Maybe<Scalars['ID']>
}

export type QueryPerformanceArgs = {
  start: Scalars['DateTime']
  days: Scalars['Int']
  investmentAccountId?: Maybe<Scalars['ID']>
}

export type QueryStatementsArgs = {
  type: Scalars['String']
  investmentAccountId?: Maybe<Scalars['ID']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type QueryToggleArgs = {
  projectId: Scalars['String']
  toggleId: Scalars['String']
  context?: Maybe<Scalars['JSON']>
}

export type QueryPartnerArgs = {
  oauthToken: Scalars['String']
  payloadToken: Scalars['String']
}

export type QueryAccountStrengthArgs = {
  accountId?: Maybe<Scalars['String']>
}

export type QueryExtensionCampaignStoreArgs = {
  id: Scalars['ID']
  campaignId: Scalars['ID']
}

export type QueryExtensionCampaignStoresArgs = {
  campaignId?: Maybe<Scalars['ID']>
  domain?: Maybe<Scalars['String']>
}

export type QueryFoundMoneyOfferArgs = {
  id: Scalars['ID']
  origin?: Maybe<Scalars['String']>
  sessionId?: Maybe<Scalars['String']>
}

export type QueryFoundMoneyOffersArgs = {
  origin?: Maybe<Scalars['String']>
  sessionId?: Maybe<Scalars['String']>
  promoted?: Maybe<Scalars['Boolean']>
}

export type QueryFoundMoneyCampaignsArgs = {
  origin?: Maybe<Scalars['String']>
  sessionId?: Maybe<Scalars['String']>
}

export type QueryLaterBeneficiariesArgs = {
  investmentAccountId: Scalars['ID']
}

export type QueryLaterHistoryArgs = {
  accountId: Scalars['ID']
  page?: Maybe<Scalars['Int']>
  limit?: Maybe<Scalars['Int']>
}

export type QueryLaterPortfolioPerformanceArgs = {
  accountId: Scalars['ID']
}

export type QueryWithholdingDefaultsArgs = {
  investmentAccountId: Scalars['ID']
  withdrawalAmount: CurrencyAmountInput
  earlyDistributionTaxExceptionReason?: Maybe<Scalars['String']>
}

export type QueryLaterContributionHistoryArgs = {
  investmentAccountId: Scalars['ID']
}

export type QueryEligibilityArgs = {
  eligibilityScope: EligibilityScope
}

export type QueryAccountsArgs = {
  status?: Maybe<Array<Maybe<AccountStatus>>>
}

export type QueryAddressesArgs = {
  addressType?: Maybe<AddressType>
}

export type QueryBeneficiaryArgs = {
  id: Scalars['ID']
}

export type QuerySignaturesArgs = {
  signatureType?: Maybe<SignatureType>
}

export type QueryBillingCycleArgs = {
  id?: Maybe<Scalars['ID']>
}

export type QueryBillingCyclesArgs = {
  state?: Maybe<Array<Maybe<BillingCycleState>>>
}

export type QueryFeeArgs = {
  id: Scalars['ID']
}

export type QueryFeesArgs = {
  billingCycleId?: Maybe<Scalars['ID']>
  accountId?: Maybe<Scalars['ID']>
}

export type QueryAddressDeliverabilityArgs = {
  input: AddressDeliverabilityInput
}

export type QueryAllBankAccountsArgs = {
  input: AllBankAccountsInput
}

export type QueryAllBankCardsArgs = {
  filter?: Maybe<AllBankCardsFilter>
}

export type QueryBankTransactionArgs = {
  id: Scalars['ID']
  bankAccountType?: Maybe<BankAccountType>
}

export type QueryAllBankDocumentsArgs = {
  input: AllBankDocumentsInput
}

export type QueryAllBankTransactionsArgs = {
  pagination?: Maybe<PageInput>
  accountId?: Maybe<Scalars['ID']>
}

export type QuerySpendAtmsArgs = {
  input: SpendAtmsInput
}

export type QuerySavingsAccountEligibilityByUserIdArgs = {
  type: SavingsAccountType
}

export type QueryBankAccountDisclosuresArgs = {
  input: BankAccountDisclosureFilter
}

export type QueryFinancialInstitutionArgs = {
  externalId: Scalars['String']
  linkable?: Maybe<Scalars['Boolean']>
}

export type QueryFinancialInstitutionsArgs = {
  includeBlacklisted?: Maybe<Scalars['Boolean']>
  supportsAuth?: Maybe<Scalars['Boolean']>
  supportsFunding?: Maybe<Scalars['Boolean']>
  q?: Maybe<Scalars['String']>
  includeDirectBank?: Maybe<Scalars['Boolean']>
  pageInput?: Maybe<PageInput>
}

export type QueryLinkedAccountArgs = {
  linkedAccountId: Scalars['ID']
}

export type QueryLinkedAccountsArgs = {
  linked?: Maybe<Scalars['Boolean']>
  externalSources?: Maybe<Array<LinkedAccountExternalSourceEnum>>
}

export type QueryLinkedSubaccountArgs = {
  linkedSubaccountId: Scalars['ID']
}

export type QueryLinkedSubaccountsArgs = {
  linked?: Maybe<Scalars['Boolean']>
}

export type QueryRoundUpAccountArgs = {
  linkedSubaccountId: Scalars['ID']
}

export type QueryRoundUpsArgs = {
  state?: Maybe<Array<RoundUpState>>
  transactionDateAfter?: Maybe<Scalars['String']>
  transactionDateBefore?: Maybe<Scalars['String']>
  investmentId?: Maybe<Scalars['ID']>
  autoInvestable?: Maybe<Scalars['Boolean']>
  manual?: Maybe<Scalars['Boolean']>
  instant?: Maybe<Scalars['Boolean']>
  targetAccountId?: Maybe<Scalars['ID']>
  pageInput?: Maybe<PageInput>
}

export type QueryAllPastCoreItemsArgs = {
  excludeFees?: Maybe<Scalars['Boolean']>
  pagination?: Maybe<PageInput>
  filter?: Maybe<AllPastCoreItemsSchemaFilter>
}

export type QueryAllPastLaterItemsArgs = {
  excludeFees?: Maybe<Scalars['Boolean']>
  pagination?: Maybe<PageInput>
  filter?: Maybe<AllPastLaterItemsSchemaFilter>
}

export type QueryAllPastSpendItemsArgs = {
  accountId?: Maybe<Scalars['String']>
  pagination?: Maybe<PageInput>
  filter?: Maybe<AllPastSpendItemsSchemaFilter>
}

export type QueryAllPastEarlyItemsArgs = {
  excludeFees?: Maybe<Scalars['Boolean']>
  pagination?: Maybe<PageInput>
  filter?: Maybe<AllPastEarlyItemsSchemaFilter>
  beneficiaryAccountId: Scalars['String']
}

export type QueryPastEarlySummaryArgs = {
  beneficiaryAccountId: Scalars['String']
}

export type QueryAllPastCoreItemChildrenArgs = {
  pastItemId: Scalars['ID']
}

export type QueryPastSpendTransactionItemArgs = {
  transactionId: Scalars['String']
}

export type QueryAllTransferableToArgs = {
  input: AllTransferableToInput
}

export type QueryEstimatedTransferDatesArgs = {
  input: EstimatedTransferDatesInput
}

export type QueryEvaluateCheckDepositArgs = {
  input: EvaluateCheckDepositInput
}

export type QueryAllSupportArticlesArgs = {
  filter?: Maybe<AllSupportArticlesFilterInput>
  isPrivate?: Maybe<Scalars['Boolean']>
}

export type QueryAllSupportSectionsArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>
}

export type QuerySupportScheduleArgs = {
  input: ScheduleInput
}

export type QueryHelpFormContentArgs = {
  form: HelpFormType
}

export type QuerySupportArticleArgs = {
  id: Scalars['ID']
  isPrivate?: Maybe<Scalars['Boolean']>
}

export type QuerySupportSectionArgs = {
  sectionId: Scalars['ID']
  isPrivate?: Maybe<Scalars['Boolean']>
}

export type QuerySupportCategoryArgs = {
  categoryId: Scalars['ID']
}

export type QuerySupportArticlesBySectionIdArgs = {
  sectionId: Scalars['ID']
  isPrivate?: Maybe<Scalars['Boolean']>
}

export type QueryInstantSearchSupportArticlesArgs = {
  query: Scalars['String']
  isPrivate: Scalars['Boolean']
}

export type QuerySupportTicketFormArgs = {
  id: Scalars['ID']
}

export type QuerySupportTicketFormFieldArgs = {
  id: Scalars['ID']
}

export type QuerySearchSupportArticlesArgs = {
  query: Scalars['String']
  isPrivate: Scalars['Boolean']
}

export type QuerySupportSectionsByCategoryIdArgs = {
  categoryId: Scalars['ID']
  isPrivate?: Maybe<Scalars['Boolean']>
}

export type QueryUserWinbackScoreArgs = {
  userId: Scalars['ID']
}

export type QueryAllCardTrackingStatusesArgs = {
  userId?: Maybe<Scalars['ID']>
}

export type QueryGenerateUpdatedPdfArgs = {
  input: PdfDownloadUrlInput
}

export type QueryParameterizedPdfArgs = {
  input: ParameterizedPdfInput
}

export type QueryPdfDownloadUrlArgs = {
  input: PdfDownloadUrlInput
}

export type QuerySearchEmployersArgs = {
  input: SearchEmployersInput
}

export type QueryAllCheckPaymentsArgs = {
  pageInput?: Maybe<PageInput>
}

export type QueryVerifyCheckPaymentRecipientAddressArgs = {
  input: VerifyCheckPaymentRecipientAddressInputType
}

export type QueryClosureReasonsByInvestmentAccountTypeArgs = {
  product?: Maybe<InvestmentProduct>
}

export type QueryCombinedPerformanceByUserIdArgs = {
  filter?: Maybe<InvestmentAccountsByUserIdFilter>
  days?: Maybe<Scalars['Int']>
}

export type QueryEarlyAccountStateRegulationArgs = {
  stateCode?: Maybe<Scalars['String']>
}

export type QueryEarlyAccountTransferInfoArgs = {
  investmentAccountId: Scalars['ID']
}

export type QueryEtfArgs = {
  symbol: Scalars['String']
}

export type QueryInvestmentArgs = {
  id: Scalars['ID']
}

export type QueryInvestmentAccountArgs = {
  id: Scalars['ID']
}

export type QueryInvestmentAccountByBeneficiaryIdArgs = {
  beneficiaryId: Scalars['ID']
}

export type QueryInvestmentAccountRecapArgs = {
  id: Scalars['ID']
}

export type QueryInvestmentAccountRecapByPublicTokenArgs = {
  publicToken: Scalars['ID']
}

export type QueryInvestmentAccountsByUserIdArgs = {
  filter?: Maybe<InvestmentAccountsByUserIdFilter>
}

export type QueryPortfoliosArgs = {
  customizedWithSecuritySymbols?: Maybe<Array<Scalars['String']>>
}

export type QueryLaterContributionAbilityArgs = {
  investmentAccountId?: Maybe<Scalars['ID']>
}

export type QueryPastLaterSummaryArgs = {
  investmentAccountId?: Maybe<Scalars['ID']>
}

export type QueryWithholdingEstimatesArgs = {
  federalWithholdingPercentage: Scalars['Float']
  investmentAccountId: Scalars['ID']
  reason?: Maybe<LaterWithdrawalReason>
  stateWithholdingPercentage: Scalars['Float']
  withdrawalAmount: CurrencyAmountInput
}

export type QueryYearLaterReportArgs = {
  year: Scalars['Int']
}

export type QueryRecurringTransfersArgs = {
  filter?: Maybe<RecurringTransfersFilterInput>
}

export type QueryNextTransferDateArgs = {
  recurrenceRule: RecurrenceRuleInput
}

export type QueryProtectInsuranceHomeArgs = {
  insuranceType: InsuranceType
}

export type QueryProtectLifeQuotePremiumsArgs = {
  parameters: PremiumsInput
}

export type QueryProtectLifeQuoteSurveyArgs = {
  providerName: ProviderName
}

export type QueryProtectProvidersArgs = {
  insuranceType: InsuranceType
}

export type QueryActivitySummaryArgs = {
  product?: Maybe<ActivitySummaryProduct>
  accountId?: Maybe<Scalars['ID']>
}

export type QueryFinishSetupArgs = {
  feedContext: FeedContext
  accountId: Scalars['ID']
}

export type QueryOnboardingTipsArgs = {
  feedContext: FeedContext
}

export type QueryActiveEarnOffersArgs = {
  tag?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  cursor?: Maybe<Scalars['String']>
}

export type QueryEarnOfferByCampaignOfferIdArgs = {
  campaignOfferId: Scalars['String']
  origin: Scalars['String']
  sessionId: Scalars['String']
}

export type QuerySearchActiveEarnOffersArgs = {
  searchTerm: Scalars['String']
  tag?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  cursor?: Maybe<Scalars['String']>
}

export type QueryPartnerOfferGroupArgs = {
  id: Scalars['String']
  filter?: Maybe<PartnerOfferGroupFilterInput>
}

export type QueryPartnerOfferGroupsByTypeArgs = {
  partnerOfferGroupsTypeInput: PartnerOfferGroupsTypeInput
}

export type QueryJobSearchArgs = {
  searchCriteria: JobSearchCriteriaInput
}

export type QueryJobSearchV2Args = {
  searchCriteria: JobSearchCriteriaInput
  pagination: PageInput
  saveAsRecentSearch?: Maybe<Scalars['Boolean']>
}

export type QueryMilestoneArgs = {
  id: Scalars['ID']
}

export type QueryMilestonesByThemeArgs = {
  theme: MilestoneTheme
  filter?: Maybe<MilestoneByThemeFilterInput>
}

export type QueryMilestoneHubDefinitionArgs = {
  id: Scalars['ID']
}

export type QueryMilestoneDefinitionArgs = {
  id: Scalars['ID']
}

export type QueryMilestoneGroupDefinitionArgs = {
  groupID: Scalars['ID']
}

export type QueryMilestoneChallengePointsRuleByMilestoneIdByChallengeIdArgs = {
  milestoneID: Scalars['ID']
  challengeID: Scalars['ID']
}

export type QueryMilestoneChallengePointsRulesByMilestoneIdArgs = {
  milestoneID: Scalars['ID']
}

export type QueryMilestoneChallengeArgs = {
  id: Scalars['ID']
}

export type QueryMilestoneEligibilityByScopesArgs = {
  scopes: Array<MilestoneEligibilityScope>
}

export type QueryMilestoneHubEligibleArgs = {
  registrationCompletedAt: Scalars['DateTime']
}

export type QueryMilestoneAchievementActionRuleArgs = {
  milestoneID: Scalars['ID']
}

export type QueryMilestoneGroupAchievementActionRuleArgs = {
  milestoneGroupID: Scalars['ID']
}

export type QueryAccountPointsRuleByMilestoneIdArgs = {
  milestoneID: Scalars['ID']
}

export type QueryAllMessagesArgs = {
  statusFilters?: Maybe<Array<MessageStatusFilterInput>>
  typeFilters?: Maybe<Array<MessageType>>
  categoryFilters?: Maybe<Array<MessageCategory>>
}

export type QueryMessagesArgs = {
  pagination?: Maybe<MessagePageInput>
  statusFilters?: Maybe<Array<MessageStatusFilterInput>>
  typeFilters?: Maybe<Array<MessageType>>
  categoryFilters?: Maybe<Array<MessageCategory>>
}

export type QueryTrendingLearnContentByTierIdArgs = {
  tierId: Scalars['ID']
}

export type QueryTrendingLearnContentByTopicIdArgs = {
  topicId: Scalars['ID']
}

export type QueryLearnMediaArgs = {
  id: Scalars['ID']
}

export type QueryLearnNextStepActionsByMediaIdArgs = {
  mediaId: Scalars['ID']
}

export type QueryRelatedLearnContentByMediaIdArgs = {
  mediaId: Scalars['ID']
}

export type QueryCourseArgs = {
  id: Scalars['ID']
}

export type QueryCoursesByTierIdArgs = {
  tierId: Scalars['ID']
}

export type QueryCoursesByTopicIdArgs = {
  topicId: Scalars['ID']
}

export type QueryCoursesByTopicId_V2Args = {
  topicId: Scalars['ID']
}

export type QueryLearnNextStepActionsByCourseIdArgs = {
  courseId: Scalars['ID']
}

export type QueryRelatedCoursePreviewsByCourseIdArgs = {
  courseId: Scalars['ID']
}

export type QueryRelatedCoursePreviewsByCourseId_V2Args = {
  courseId: Scalars['ID']
}

export type QueryRelatedQuizByCourseIdArgs = {
  courseId: Scalars['ID']
}

export type QueryCompletedQuizByQuizIdArgs = {
  quizId: Scalars['ID']
}

export type QueryLearnQuestionInsightsByQuizIdArgs = {
  quizId: Scalars['ID']
}

export type QueryQuizArgs = {
  id: Scalars['ID']
}

export type QueryRelatedQuizzesByCourseIdArgs = {
  courseId: Scalars['ID']
}

export type QueryLearnArticleArgs = {
  id: Scalars['ID']
}

export type QueryRelatedCourseByArticleIdArgs = {
  articleId: Scalars['ID']
}

export type QueryRelatedLearnContentByArticleIdArgs = {
  articleId: Scalars['ID']
}

export type QueryLearnContentBySearchTermArgs = {
  term: Scalars['String']
  filter?: Maybe<LearnContentFilterInput>
  sort?: Maybe<LearnContentSortType>
  pagination: LearnContentPageInput
}

export type QueryLearnContentByTierIdArgs = {
  filter: LearnContentFilterByTierIdInput
  sort?: Maybe<LearnContentSortType>
  pagination: LearnContentPageInput
}

export type QueryLearnContentByTopicIdArgs = {
  filter: LearnContentFilterByTopicIdInput
  sort?: Maybe<LearnContentSortType>
  pagination: LearnContentPageInput
}

export type QueryLearnContentRecommendationsBySearchTermArgs = {
  term: Scalars['String']
}

export type QueryDocumentRequestArgs = {
  input: DocumentRequestInput
}

export type QueryDocumentRequestsArgs = {
  input: DocumentRequestsInput
}

export type QueryPasswordResetFormFieldsByTokenArgs = {
  resetToken: Scalars['String']
}

export type QueryEmailAddressValidationArgs = {
  email: Scalars['EmailAddress']
}

export type QueryValidatePasswordResetTokenArgs = {
  resetToken: Scalars['String']
}

export type QueryOfferArgs = {
  id: Scalars['ID']
}

export type QueryProductArgs = {
  id: Scalars['ID']
}

export type QueryProductByKeyArgs = {
  productKey: ProductKey
}

export type QueryPromotionArgs = {
  id: Scalars['ID']
}

export type QueryPromotionsByUserIdArgs = {
  filter?: Maybe<PromotionFilterInput>
  limit?: Maybe<Scalars['Int']>
}

export type QuerySubscriptionMigrationArgs = {
  id: Scalars['ID']
}

export type QuerySubscriptionMigrationWaiverArgs = {
  id: Scalars['ID']
}

export type QueryTierArgs = {
  id: Scalars['ID']
}

export type QueryTierGroupArgs = {
  id?: Maybe<Scalars['ID']>
}

export type QueryTierOptionByProductKeyArgs = {
  productKey: ProductKey
  tierGroupId?: Maybe<Scalars['ID']>
}

export type QueryTierOptionByTierPriceIdArgs = {
  tierPriceId: Scalars['ID']
}

export type QueryTierSubscriptionArgs = {
  id: Scalars['ID']
}

export type QueryTierSubscriptionHistoryByUserIdArgs = {
  after?: Maybe<Scalars['String']>
  limit?: Maybe<Scalars['Int']>
  reverse?: Maybe<Scalars['Boolean']>
}

export type QuerySplitDepositSettingsArgs = {
  id: Scalars['ID']
}

export type QuerySplitDepositSettingsByUserIdArgs = {
  filter?: Maybe<SplitDepositSettingsFilterInput>
  normalizeToFrequency?: Maybe<SplitDepositNormalizationFrequency>
}

export type QuerySmartDepositMetadataArgs = {
  smartDepositMetadataInput: SmartDepositMetadataInput
}

export type QueryOutsideContributionCodeArgs = {
  id: Scalars['ID']
}

export type QueryOutsideContributionCodeByCodeArgs = {
  code: Scalars['String']
}

export type QueryOutsideContributionCodeByInvestmentAccountIdArgs = {
  investmentAccountId: Scalars['ID']
}

export type QueryEarnCtaDataByUserIdArgs = {
  id: Scalars['ID']
}

export type QueryListUtilityServicesArgs = {
  first?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  nameFilter?: Maybe<Scalars['String']>
}

export type QueryBankFeesByUserIdArgs = {
  first: Scalars['Int']
  offset: Scalars['Int']
  statusFilter: Array<Maybe<FeeStatusFilter>>
}

export type QueryAuthenticateForFeeNegotiationStatusByLinkedAccountIdArgs = {
  linkedAccountId: Scalars['ID']
}

export type QueryMailInDocumentsByUserIdArgs = {
  mailInDocumentTypeFilter: Array<Maybe<MailInDocumentType>>
}

export type QuerySampleMailInDocumentArgs = {
  typeFilter: MailInDocumentType
}

export type QueryGetPartnerUrlArgs = {
  input: PartnerUrlInput
}

export type QueryGetPartnerDocumentByUserIdArgs = {
  input: PartnerUrlInput
}

export type QueryGetPartnerDetailsArgs = {
  input: PartnerUrlInput
}

export type QueryFriendArgs = {
  advocateReferralCode?: Maybe<Scalars['String']>
}

export type QueryRegistrationFunnelArgs = {
  filter: RegistrationFunnelFilter
}

export type QuerySecurityBySymbolArgs = {
  input: SecurityBySymbolInput
}

export type QuerySecuritiesBySymbolsArgs = {
  input: SecuritiesBySymbolsInput
}

export type QuerySecurityPerformanceBySymbolArgs = {
  input: SecurityPerformanceBySymbolInput
}

export type QuerySecurityPerformancesBySymbolArgs = {
  input: SecurityPerformancesBySymbolInput
}

export type QuerySearchSecuritiesArgs = {
  input: SearchSecuritiesInput
}

export type QuerySecuritiesBySectorArgs = {
  input: SecuritiesBySectorInput
}

export type QueryCohortEligibilityArgs = {
  scopes: Array<CohortEligibilityScope>
}

/** Insurance onboarding question */
export type Question = {
  __typename?: 'Question'
  /** body text */
  body?: Maybe<Scalars['String']>
  /** Default answer */
  defaultAnswer?: Maybe<Answer>
  /** eyebrow text */
  eyebrow?: Maybe<Scalars['String']>
  /** headline text */
  headline?: Maybe<Scalars['String']>
  /** Internal question ID */
  id: Scalars['ID']
  /** image */
  image?: Maybe<Image>
  /** Possible answers to be selected for the related question */
  possibleAnswers?: Maybe<Array<Answer>>
  /** tip text */
  tip?: Maybe<Scalars['String']>
  /** title text */
  title?: Maybe<Scalars['String']>
  /** Onboarding step type */
  type: OnboardingStepType
}

/** Possible answer for questions */
export type QuestionAnswer = {
  __typename?: 'QuestionAnswer'
  /** name identifier */
  name: QuestionAnswerName
  /** Question Answer text */
  title: Scalars['String']
}

export enum QuestionAnswerName {
  /** male gender */
  Male = 'male',
  /** female gender */
  Female = 'female',
  /** other genders */
  Other = 'other',
  /** boolean yes */
  Yes = 'yes',
  /** boolean no */
  No = 'no',
}

/** A user response for a question */
export type QuestionResponse = {
  /** Question asked */
  questionId: Scalars['ID']
  /** Associated answers to the question */
  answers: Array<Scalars['ID']>
}

export type Quiz = {
  __typename?: 'Quiz'
  authors: Array<LearnAuthor>
  description: Scalars['String']
  duration: LearnContentDuration
  featuredImage?: Maybe<LearnVisualAsset>
  id: Scalars['ID']
  metadata: LearnMetadata
  questions: Array<LearnQuestion>
  theme: QuizTheme
  tier: LearnTier
  title: Scalars['String']
  topics: Array<LearnTopic>
}

export type QuizPreview = {
  __typename?: 'QuizPreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  primaryTopicName: Scalars['String']
  progress?: Maybe<LearnProgress>
  quizTheme: QuizTheme
  tierName: Scalars['String']
  title: Scalars['String']
}

export type QuizPreviewLocked = {
  __typename?: 'QuizPreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  title: Scalars['String']
}

export type QuizTheme = LearnThemeLiteral

export enum QuoteOrigin {
  /** indicates user accessed quote through Protect */
  Protect = 'PROTECT',
  /** indicates user accessed quote through Found Money */
  FoundMoney = 'FOUND_MONEY',
}

export type QuoteResult = IneligibilityLander | LifeQuoteResultSliders

export type QuoteSlider = {
  __typename?: 'QuoteSlider'
  body?: Maybe<Scalars['String']>
  defaultValue: Scalars['Int']
  headline: Scalars['String']
  maxLabel?: Maybe<Scalars['String']>
  minLabel?: Maybe<Scalars['String']>
  possibleValues: Array<Scalars['Int']>
  questionName: Scalars['String']
  tip?: Maybe<Tip>
}

export enum QuoteStatus {
  /** successfully retrieved insurance quote */
  Success = 'success',
  /** user is ineligible for insurance quote */
  Ineligible = 'ineligible',
}

/** A user's metadata */
export type QuoteUserMetadata = {
  /** campaign id */
  campaignId: Scalars['ID']
  /** session id */
  sessionId: Scalars['ID']
  /** quote origin */
  origin: QuoteOrigin
}

/** The link token for use in the client created account link URL. */
export type RawLinkSession = {
  __typename?: 'RawLinkSession'
  /** The External ID that should be used in the link creation process. */
  externalId: Scalars['ID']
  /** The Link Token a client should use for account linking. */
  token: Scalars['String']
}

/** RDVs are required user alert. */
export type RdvRequiredUserAlert = UserAlertsItem & {
  __typename?: 'RdvRequiredUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** The current funding source must be verified with RDVs prior to linking */
export type RdvVerificationRequired = {
  __typename?: 'RdvVerificationRequired'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

export type ReadMessageInput = {
  messageId: Scalars['ID']
}

export type RecaptchaException = {
  __typename?: 'RecaptchaException'
  errorCodes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type Recommendations = {
  __typename?: 'Recommendations'
  body: Scalars['String']
  cta: Cta
  id: Scalars['ID']
  image: Image
  title: Scalars['String']
  widgets: Array<RecommendationWidget>
}

export type RecommendationWidget = BriefInsuranceSection

/** Return type for the protectRecommendedLifeCoverage query */
export type RecommendedLifeCoverage = {
  __typename?: 'RecommendedLifeCoverage'
  about: AboutSection
  cta: Cta
  disclaimer: Disclaimer
  title: Scalars['String']
  widgets: Array<RecommendedLifeCoverageWidget>
}

export type RecommendedLifeCoverageWidget =
  | CollapsedLifeRecommendation
  | ExpandedLifeRecommendation
  | InsuranceCarousel

/** Duplicate Record Exists Error */
export type RecordAlreadyExistsError = {
  __typename?: 'RecordAlreadyExistsError'
  message: Scalars['String']
}

export type RecordDoesNotExistError = {
  __typename?: 'RecordDoesNotExistError'
  message: Scalars['String']
}

/** Record view_at for investment account recap. */
export type RecordInvestmentAccountRecapViewInput = {
  /** The unique identifier of the investment account recap for which to update view_at timestamp. */
  investmentAccountRecapId: Scalars['ID']
}

/** Result of record view_at timestamp for investment account recap. */
export type RecordInvestmentAccountRecapViewResult =
  | InvestmentAccountRecap
  | InvestmentAccountRecapNotFoundException

export enum RecurrenceFrequency {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
}

export type RecurrenceRule = {
  __typename?: 'RecurrenceRule'
  frequency: RecurrenceFrequency
  byWeekDay?: Maybe<Array<DayOfWeek>>
  byMonthDay?: Maybe<Array<Scalars['Int']>>
  interval: Scalars['Int']
  startDate?: Maybe<Scalars['DateTime']>
  endDate?: Maybe<Scalars['DateTime']>
}

export type RecurrenceRuleInput = {
  frequency: RecurrenceFrequency
  byWeekDay?: Maybe<Array<DayOfWeek>>
  byMonthDay?: Maybe<Array<Scalars['Int']>>
  interval: Scalars['Int']
  startDate?: Maybe<Scalars['DateTime']>
  endDate?: Maybe<Scalars['DateTime']>
}

export type RecurringInvestmentInput = {
  amount: Scalars['Float']
  day: Scalars['Int']
  frequency: InvestmentFrequency
  investmentAccountId?: Maybe<Scalars['String']>
}

export type RecurringInvestmentPayload = {
  __typename?: 'RecurringInvestmentPayload'
  recurringInvestmentSettings: RecurringInvestmentSettings
}

/** Recurring deposit settings for an account */
export type RecurringInvestmentSettings = TimestampsInterface & {
  __typename?: 'RecurringInvestmentSettings'
  amount?: Maybe<Scalars['Float']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  day?: Maybe<Scalars['Int']>
  frequency?: Maybe<InvestmentFrequency>
  /** Next scheduled date of a configured recurring investment. */
  nextInvestmentAt?: Maybe<Scalars['Date']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export type RecurringTransfer = {
  __typename?: 'RecurringTransfer'
  id: Scalars['ID']
  recurrenceRule: RecurrenceRule
  active: Scalars['Boolean']
  transferEvent: RecurringTransferEvent
  nextTransferDate?: Maybe<Scalars['Date']>
}

export type RecurringTransferAccount = {
  __typename?: 'RecurringTransferAccount'
  type: RecurringTransferAccountType
  id: Scalars['ID']
}

export type RecurringTransferAccountIdFilterInput = {
  targetAccountId: Scalars['ID']
  filter?: Maybe<RecurringTransferDirectionFilterInput>
}

export type RecurringTransferAccountInput = {
  type: RecurringTransferAccountType
  id: Scalars['ID']
}

export enum RecurringTransferAccountType {
  Spend = 'SPEND',
}

export type RecurringTransferDate = {
  __typename?: 'RecurringTransferDate'
  nextTransferDate?: Maybe<Scalars['Date']>
}

export enum RecurringTransferDirection {
  Deposit = 'DEPOSIT',
  Withdrawal = 'WITHDRAWAL',
}

export type RecurringTransferDirectionFilterInput = {
  direction: RecurringTransferDirection
}

export type RecurringTransferEvent = {
  __typename?: 'RecurringTransferEvent'
  targetAccount: RecurringTransferAccount
  fundingSource: RecurringTransferFundingSource
  direction: RecurringTransferDirection
  amount: CurrencyAmount
}

export type RecurringTransferEventInput = {
  targetAccount: RecurringTransferAccountInput
  fundingSource: RecurringTransferFundingSourceInput
  direction: RecurringTransferDirection
  amount: CurrencyAmountInput
}

export type RecurringTransferFundingSource = {
  __typename?: 'RecurringTransferFundingSource'
  type: RecurringTransferFundingSourceType
  id: Scalars['ID']
}

export type RecurringTransferFundingSourceInput = {
  type: RecurringTransferFundingSourceType
  id: Scalars['ID']
}

export enum RecurringTransferFundingSourceType {
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
}

export type RecurringTransferPathException = {
  __typename?: 'RecurringTransferPathException'
  path: Array<Scalars['String']>
  exception: RecurringTransferPathExceptionCase
}

export enum RecurringTransferPathExceptionCase {
  Blank = 'BLANK',
  InvalidValue = 'INVALID_VALUE',
}

export type RecurringTransfersFilterInput = {
  targetAccountType: RecurringTransferAccountType
  filter?: Maybe<RecurringTransferAccountIdFilterInput>
}

/** Fetch a referral */
export type Referral = {
  __typename?: 'Referral'
  code: Scalars['String']
  referreeRewardAmount: Scalars['Float']
  referrerRewardAmount: Scalars['Float']
  url: Scalars['String']
}

/** Object with friend campaign information such as completed events and reward statuses */
export type ReferralCampaign = {
  __typename?: 'ReferralCampaign'
  /** The id of the friend participating in the campaign */
  friendUserId?: Maybe<Scalars['ID']>
  /** The email of the friend participating in the campaign */
  friendEmail: Scalars['String']
  /** The id of the advocate participating in the campaign */
  advocateUserId?: Maybe<Scalars['ID']>
  /** The email of the advocate participating in the campaign */
  advocateEmail: Scalars['String']
  /** The id of the referral campaign that is also associated with the campaign id in Extole */
  campaignId: Scalars['ID']
  /** The name of the campaign */
  name?: Maybe<Scalars['String']>
  /** A list of events and their statuses to earn reward */
  events?: Maybe<Array<ReferralEvent>>
  /** Friend Reward for completing all necessary steps */
  friendRewards?: Maybe<Array<ReferralReward>>
  /**
   * Advocate Reward for completing all necessary steps. The object assumes that the
   * advocateUserId on type ReferralCampaign is the user that will receive the reward, but
   * friends can potentially have multiple advocates. Further investigation may be required.
   */
  advocateRewards?: Maybe<Array<ReferralReward>>
}

/** Object containing status of event associated with a Referral */
export type ReferralEvent = {
  __typename?: 'ReferralEvent'
  /**
   * Referral event nonce
   * @deprecated Field no longer supported
   */
  referralEventId?: Maybe<Scalars['String']>
  /** Type of referral event */
  referralEventType: ReferralEventType
  /** Status based on activity of friend */
  status: ReferralEventStatus
  /** Date event was completed if status is 'COMPLETED' */
  dateCompleted?: Maybe<Scalars['DateTime']>
}

/** input type specifying the parameters to create an event */
export type ReferralEventInput = {
  eventType: ReferralEventType
  userId: Scalars['String']
  eventNonce?: Maybe<Scalars['ID']>
  eventDetails?: Maybe<Scalars['JSON']>
}

/** Status of referral events */
export enum ReferralEventStatus {
  /** Friend has initiated event but event has not fully processed */
  Pending = 'PENDING',
  /** Friend has completed event */
  Completed = 'COMPLETED',
  /** Friend has not started or completed event */
  NotStarted = 'NOT_STARTED',
}

/** Descriptions of User actions needed to earn reward */
export enum ReferralEventType {
  /** User has made initial investment into core account */
  InvestCore = 'INVEST_CORE',
  /** User has made initial investment into early account */
  InvestEarly = 'INVEST_EARLY',
  /** User has made initial investment into later account */
  InvestLater = 'INVEST_LATER',
  /** User has signed the referral agreement */
  ReferralAgreementSigned = 'REFERRAL_AGREEMENT_SIGNED',
  /** User has initialized the registration process */
  SignedUp = 'SIGNED_UP',
  /** User has been verified */
  UserVerified = 'USER_VERIFIED',
  /** User has a funding source linked */
  FsLinked = 'FS_LINKED',
  /** User has completed registration */
  RegistrationCompleted = 'REGISTRATION_COMPLETED',
  /** User has opened a Later account */
  LaterAccountOpened = 'LATER_ACCOUNT_OPENED',
  /** User has opened an Early account */
  EarlyAccountOpened = 'EARLY_ACCOUNT_OPENED',
  /** User has opened a Spend account */
  SpendAccountOpened = 'SPEND_ACCOUNT_OPENED',
  /** User has made a transfer into a Spend Account */
  DepositSpend = 'DEPOSIT_SPEND',
  /** User has paid their subscription */
  SubscriptionPaid = 'SUBSCRIPTION_PAID',
  /** Unknown referral event type */
  Unknown = 'UNKNOWN',
}

/** Object that holds referral statistics for an Acorns User */
export type ReferralHistory = {
  __typename?: 'ReferralHistory'
  /** The number of status pending referrals for a user */
  numPendingReferrals?: Maybe<Scalars['Int']>
  /** The number of completed referrals for a user */
  numCompletedReferrals?: Maybe<Scalars['Int']>
  /** The total monetary reward amount the user has earned */
  totalReferralRewardsEarned?: Maybe<CurrencyAmount>
  friendSummary?: Maybe<Array<FriendSummary>>
}

/** Object containing reward information for completing a campaign */
export type ReferralReward = {
  __typename?: 'ReferralReward'
  /** Name of the referral reward */
  name?: Maybe<Scalars['String']>
  /** Value of reward for completing all events in a campaign */
  value: Scalars['String']
  /** Value type for completing all events in a campaign */
  valueType?: Maybe<ReferralValueType>
  /** The status of the reward associated with activity campaign */
  rewardStatus?: Maybe<ReferralRewardStatus>
  /** The date the reward was fulfilled (if applicable) */
  rewardFulfilledAtDate?: Maybe<Scalars['DateTime']>
}

/** The current status of a referral reward */
export enum ReferralRewardStatus {
  /** Reward has not been created */
  NotCreated = 'NOT_CREATED',
  /** User has earned reward by completing all campaign steps, but reward still needs to be issued. */
  Earned = 'EARNED',
  /** Reward has been issued by Acorns */
  Fulfilled = 'FULFILLED',
}

/** Summary of updated reward */
export type ReferralRewardSummary = {
  __typename?: 'ReferralRewardSummary'
  /** Status of this referral for Friend/Acorns User */
  status: ReferralRewardStatus
  /** The Acorns User acting as an advocate for this referral reward */
  advocateUserId?: Maybe<Scalars['ID']>
}

export enum ReferralRewardUpdateStatus {
  /** User and Friend have been rewarded */
  Rewarded = 'REWARDED',
  /** Referral has been cancelled */
  Cancelled = 'CANCELLED',
}

export enum ReferralStatus {
  /** Referral has been sent to a friend */
  Sent = 'SENT',
  /** Friend has used referral code but still has events they need to complete */
  Pending = 'PENDING',
  /** User and Friend have completed referral and should be rewarded */
  Completed = 'COMPLETED',
  /** User and Friend have been rewarded */
  Rewarded = 'REWARDED',
  /** Referral has expired because events were not finished before campaign end date */
  Expired = 'EXPIRED',
  /** Referral has been cancelled */
  Cancelled = 'CANCELLED',
}

/** input type specifyig the parameters that can be updated */
export type ReferralUserUpdateInput = {
  userId?: Maybe<Scalars['ID']>
  email: Scalars['String']
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
}

/** Value types of reward associated with completion of a referral */
export enum ReferralValueType {
  Usd = 'USD',
}

export type RefreshAuthTokenInput = {
  refreshToken: Scalars['String']
  pin?: Maybe<Scalars['String']>
}

export type RefreshAuthTokenRateLimitedException = {
  __typename?: 'RefreshAuthTokenRateLimitedException'
  message?: Maybe<Scalars['String']>
}

/** refreshAuthToken results */
export type RefreshAuthTokenResult =
  | AuthSession
  | TokenExpiredException
  | InvalidPinException
  | RefreshAuthTokenRateLimitedException
  | UserSuspendedException

export type RefreshTokenNotFoundException = {
  __typename?: 'RefreshTokenNotFoundException'
  userId: Scalars['ID']
}

/** Configuration for regenerating the public token of an investment account recap. */
export type RegenerateInvestmentAccountRecapPublicTokenInput = {
  /** The unique identifier of the investment account recap for which a public token is being regenerated. */
  id: Scalars['ID']
}

/** Result of regenerating the public token of an investment account recap. */
export type RegenerateInvestmentAccountRecapPublicTokenResult =
  | InvestmentAccountRecap
  | InvestmentAccountRecapNotFoundException

export type RegisterCredentialsInput = {
  email: Scalars['EmailAddress']
  password: Scalars['String']
  udid: Scalars['String']
  usResident: Scalars['Boolean']
  acceptanceDocumentVersionUuids: Array<Maybe<Scalars['String']>>
}

/** registerCredentials results */
export type RegisterCredentialsResult =
  | AuthSession
  | EmailTakenException
  | InvalidPasswordException
  | MissingRequiredAgreementsException

export type RegisterEmailAuthenticatorInput = {
  email: Scalars['EmailAddress']
  name?: Maybe<Scalars['String']>
  setDefault?: Maybe<Scalars['Boolean']>
}

export type RegisterEmailAuthenticatorResult =
  | EmailAuthenticator
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeExpiredException
  | AuthenticatorTypeAlreadyRegisteredException
  | ExistingEmailVerifiedException

/** Returns a Linked Account Type or AsyncLinkSessionResult. */
export type RegisterLinkSessionResult = AsyncLinkSessionResult | LinkedAccount

export type RegisterPhoneAuthenticatorInput = {
  phoneNumber: Scalars['PhoneNumber']
  name?: Maybe<Scalars['String']>
  setDefault?: Maybe<Scalars['Boolean']>
}

export type RegisterPhoneAuthenticatorResult =
  | PhoneAuthenticator
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeExpiredException
  | InvalidPhoneNumberException
  | AuthenticatorTypeAlreadyRegisteredException

/** Input for the registerProspect mutation initially registering a prospect user. */
export type RegisterProspectInput = {
  /** Flag indicating if source identifier can be overridden or not */
  amendableSource?: Maybe<Scalars['Boolean']>
  /** Email address for prospect used during initial sign-up */
  email?: Maybe<Scalars['String']>
  /** Contextual attributes representing parameters surrounding user sign-up */
  sourceAttributes: SourceAttributesInput
}

/** Union for the result of the registerProspect mutation */
export type RegisterProspectResult =
  | InvalidConversionIdentifierException
  | InvalidSourceAttributesException
  | RegistrationFunnel

/** Information about funnel experience */
export type RegistrationFunnel = {
  __typename?: 'RegistrationFunnel'
  /** List of pages within funnel */
  flow: Array<RegistrationPage>
  /** User's funnel information */
  metadata: FunnelMetadata
  sourceAttributes: SourceAttributes
}

/** Available fields to filter for a specific user's funnel experience */
export type RegistrationFunnelFilter = {
  /** Email address for prospect that was used during initial sign up */
  email?: Maybe<Scalars['String']>
  /** User's unique identifier */
  userId?: Maybe<Scalars['ID']>
}

/** Registration fields */
export type RegistrationInput = {
  /** The entry point for a registration */
  funnel: Funnel
}

/** Single page within registration flow */
export type RegistrationPage = {
  __typename?: 'RegistrationPage'
  actions: Array<RegistrationPageAction>
  isBackEnabled: Scalars['Boolean']
  name: PageName
}

/** CTAs that can be performed on the page */
export type RegistrationPageAction = {
  __typename?: 'RegistrationPageAction'
  /** Page that CTA will route to */
  nextPage: PageName
  type: ActionType
}

export type ReinitiateSmsChallengeInput = {
  challengeId: Scalars['ID']
}

export type ReinitiateSmsChallengeResult =
  | SmsAuthChallenge
  | EmailAuthChallenge
  | AuthChallengeExpiredException

export type ReissueBankCardEligibility = ReissueBankCardEligible | ReissueBankCardIneligible

export type ReissueBankCardEligible = {
  __typename?: 'ReissueBankCardEligible'
  originalCardCreatedAt: Scalars['Date']
}

export type ReissueBankCardExistsError = {
  __typename?: 'ReissueBankCardExistsError'
  /** BankCardRequest id / new bank card id */
  id: Scalars['ID']
}

export type ReissueBankCardIneligible = {
  __typename?: 'ReissueBankCardIneligible'
  issues: Array<Maybe<ReissueBankCardIneligibleIssue>>
}

export enum ReissueBankCardIneligibleIssue {
  CardAdminLocked = 'CARD_ADMIN_LOCKED',
  ActiveBankCardRequest = 'ACTIVE_BANK_CARD_REQUEST',
}

export type ReissueBankCardInput = {
  reason: BankCardRequestReason
  reasonComment?: Maybe<Scalars['String']>
  reasonDate?: Maybe<Scalars['Date']>
  mailingAddress: BankCardRequestMailingAddressInput
}

export type ReissueBankCardResult = BankCardRequest | ReissueBankCardExistsError

export enum RejectedReason {
  DocumentExpired = 'documentExpired',
  IncorrectDocumentType = 'incorrectDocumentType',
  IncorrectName = 'incorrectName',
  InvalidResidentialAddress = 'invalidResidentialAddress',
  MissingName = 'missingName',
  NoVisibleDate = 'noVisibleDate',
  PoorImageQuality = 'poorImageQuality',
  MismatchedName = 'mismatchedName',
  NotEligibleForPromotion = 'notEligibleForPromotion',
  SsnAlreadyUsed = 'ssnAlreadyUsed',
}

export type RejectUploadedDocumentInput = {
  note?: Maybe<Scalars['String']>
  reason: RejectedReason
  documentRequestId: Scalars['ID']
  reviewerId: Scalars['ID']
}

/** Relink Linked Account Alert. */
export type RelinkLinkedAccountAlert = UserAlertsItem & {
  __typename?: 'RelinkLinkedAccountAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type RemoveActionFromMilestoneAchievementActionRuleInput = {
  /** the action to remove from the list of side-effects the milestone can trigger when it is completed */
  actionToRemove: MilestoneAchievementActionType
  milestoneID: Scalars['ID']
}

export type RemoveActionFromMilestoneAchievementActionRuleResult =
  | MilestoneAchievementActionRule
  | RecordDoesNotExistError

export type RemoveActionFromMilestoneGroupAchievementActionRuleInput = {
  /** the action to remove from the list of side-effects the milestone group can trigger when it is completed */
  actionToRemove: MilestoneAchievementActionType
  milestoneGroupID: Scalars['ID']
}

export type RemoveActionFromMilestoneGroupAchievementActionRuleResult =
  | MilestoneGroupAchievementActionRule
  | RecordDoesNotExistError

/** Indicates remove operation succeeded */
export type RemovedJobAlert = {
  __typename?: 'RemovedJobAlert'
  id: Scalars['ID']
}

export type RemoveJobAlertResult = RemovedJobAlert

export type RemoveMilestoneFromMilestoneGroupDefinitionResult =
  | MilestoneGroupDefinition
  | RecordDoesNotExistError

export type RemoveMilestonesFromMilestoneGroupDefinitionInput = {
  milestoneGroupID: Scalars['ID']
  /** the milestone IDs to remove from the milestone group */
  milestoneIDsToRemove: Array<Scalars['ID']>
}

export type RemoveMilestonesFromMilestoneHubDefinitionInput = {
  milestoneHubId: Scalars['ID']
  /** the list of milestone ids to remove from the milestone hub definition */
  milestonesToRemove: Array<Scalars['ID']>
}

export type RemoveMilestonesFromMilestoneHubDefinitionResult =
  | RecordDoesNotExistError
  | MilestoneHubDefinition

/** Input to remove a security from a portfolio */
export type RemoveSecurityFromPortfolioInput = {
  /** The market exchange symbol of the ETF to remove from the portfolio */
  symbol: Scalars['String']
  /** Investment account ID */
  investmentAccountId: Scalars['ID']
}

/** Result from removing a security from a portfolio */
export type RemoveSecurityFromPortfolioResult =
  | InvestmentAccountNotFoundException
  | InvestmentAccountNotSupportedException
  | Portfolio
  | PortfolioNotFoundException
  | PortfolioNotSupportedException
  | SecurityNotSupportedException

/** Remove self directed portfolio from an investment account closure request */
export type RemoveSelfDirectedPortfolioInput = {
  /** The ID of the investment account to be closed */
  investmentAccountId: Scalars['ID']
  /** List of closure reason keys */
  accountClosureReasons?: Maybe<Array<Scalars['String']>>
  /** Any closure reason comments the user may have */
  comments?: Maybe<Scalars['String']>
}

/** Self Directed Portfolio Closure Response */
export type RemoveSelfDirectedPortfolioResult =
  | AccountNotFoundException
  | InvestmentAccount
  | InvestmentAccountAlreadyClosed
  | InvestmentAccountClosureInProgress
  | PortfolioAlreadyRemovedError
  | PortfolioNotFoundException
  | PortfolioRemovalInProgressError

/** Reopen User Account Response */
export type ReopenUserAccountResult =
  | UserNotFoundException
  | UserReopenLockedException
  | UserReopenSuspendedException
  | User_V2

export type ReportBankCardLostStolenInput = {
  lockReason: BankCardPermanentLockReason
}

export type ReportBankCardLostStolenPayload = {
  __typename?: 'ReportBankCardLostStolenPayload'
  bankCard?: Maybe<BankCard>
}

export type RequestAccountClosureInput = {
  comments?: Maybe<Scalars['String']>
  reason: Scalars['String']
}

export type RequestDocumentUploadInput = {
  documentType: DocumentType
  /** ID of the entity being indirectly referenced by this request */
  externalId?: Maybe<Scalars['ID']>
  /** ID of previously rejected document request */
  parentRequestId?: Maybe<Scalars['ID']>
  requestedFileCount?: Maybe<Scalars['Int']>
  /** ID of support rep that requested the document */
  requesterId?: Maybe<Scalars['ID']>
  /** Idempotency key for ensuring that duplicate requests are not made */
  requestKey?: Maybe<Scalars['String']>
}

/** Input for closing an early investment account */
export type RequestEarlyAccountClosureInput = {
  /** The ID's of the early accounts to be closed */
  investmentAccountIds: Array<Scalars['ID']>
  /** The reason for the account closure */
  reason: InvestmentAccountClosureReason
}

/** Result from closing an Investment Account */
export type RequestEarlyAccountClosureResult =
  | AccountAlreadyClosedException
  | ClosureRequestExistsException
  | FundingSourceRequiresRdvException
  | InternalErrorException
  | InvalidAccountTypeException
  | InvestmentAccount
  | InvestmentAccountNeedsTransferException
  | MissingFundingSourceException

/** Input for requesting to reopen an investment account */
export type RequestInvestmentAccountReopenInput = {
  /** The ID of the investment account to be reopened */
  investmentAccountId: Scalars['ID']
}

/** Result from requesting to reopen an investment account */
export type RequestInvestmentAccountReopenResult =
  | ExistingRequestPendingReview
  | ExistingRequestPendingUserAction
  | InvalidSubscriptionTierException
  | InvestmentAccountNotClosedException
  | InvestmentAccountNotFoundException
  | InvestmentAccountReopenRequest

export type RequestSubscriptionMigrationWaiverInput = {
  reason: SubscriptionMigrationWaiverReason
  subscriptionMigrationId: Scalars['ID']
}

export type RequestSubscriptionMigrationWaiverResult =
  | InvalidTierForMigrationError
  | SubscriptionMigrationInvalidError
  | SubscriptionMigrationWaiver

export enum RequestVersions {
  September_2022 = 'SEPTEMBER_2022',
}

export type ResetPasswordByTokenException = {
  __typename?: 'ResetPasswordByTokenException'
  message?: Maybe<Scalars['String']>
}

export type ResetPasswordByTokenInput = {
  newPw: Scalars['String']
  newPwConfirmation: Scalars['String']
  securityAnswer?: Maybe<Scalars['String']>
  last4Ssn?: Maybe<Scalars['String']>
  resetToken: Scalars['String']
}

/** resetPasswordByTokenResult */
export type ResetPasswordByTokenResult =
  | ResetPasswordByTokenSuccess
  | ResetPasswordByTokenException
  | InvalidPasswordException
  | UserCredentialsNotFoundException
  | IncorrectSecurityAnswerException
  | IncorrectSsnException

export type ResetPasswordByTokenSuccess = {
  __typename?: 'ResetPasswordByTokenSuccess'
  userId: Scalars['ID']
}

export type ResetPasswordWithTokenInput = {
  password: Scalars['String']
  passwordConfirmation: Scalars['String']
  resetToken: Scalars['String']
  last4Ssn?: Maybe<Scalars['String']>
}

/** resetPasswordWithTokenResult */
export type ResetPasswordWithTokenResult =
  | ResetPasswordWithTokenSuccess
  | InvalidPasswordResetTokenException
  | UserCredentialsNotFoundException
  | InvalidPasswordResetException

export type ResetPasswordWithTokenSuccess = {
  __typename?: 'ResetPasswordWithTokenSuccess'
  userId: Scalars['ID']
}

export type ResourceNotFoundError = {
  __typename?: 'ResourceNotFoundError'
  requestId: Scalars['ID']
}

export type RespondToLearnPollInput = {
  pollId: Scalars['ID']
  selectedOption: Scalars['String']
}

export type RespondToLearnPollResult =
  | LearnPollResponse
  | InvalidOptionException
  | RecordDoesNotExistError

export type RestoreLoginAccessInput = {
  userId: Scalars['ID']
}

export type RestoreLoginAccessResult = AuthProfile | AuthProfileNotFoundException

/** A registration record for a prospective user */
export type Result = {
  __typename?: 'Result'
  funnel: Funnel
}

export enum RetirementPlanAccess {
  /** Single user has access to an employer's retirement plan */
  Yes = 'yes',
  /** Single user has no access to retirement plan */
  No = 'no',
  /** Married user and spouse have access to a retirement plan */
  Both = 'both',
  /** Married user has access to a retirement plan without spouse */
  OnlyMe = 'onlyMe',
  /** Married user does not have access to a retirement plan, but spouse does */
  Spouse = 'spouse',
  /** Neither married user nor spouse have access to a retirement plan */
  Neither = 'neither',
}

/** A returned check */
export type ReturnedCheckDeposit = {
  __typename?: 'ReturnedCheckDeposit'
  /** Amount for check. */
  amount: CurrencyAmount
  /** Date check was returned. */
  rejectedDate: Scalars['DateTime']
  /** Returned Check Deposit Image URL for front of check. */
  frontCheckImageUrl: Scalars['String']
  /** Returned Check Deposit Image URL for back of check. */
  backCheckImageUrl: Scalars['String']
}

export enum RevokeAccessReasons {
  CoreAccountReview = 'CORE_ACCOUNT_REVIEW',
  CoreCastleLock = 'CORE_CASTLE_LOCK',
  CoreChargeback = 'CORE_CHARGEBACK',
  CoreDisputedTransaction = 'CORE_DISPUTED_TRANSACTION',
  CoreLeinLevyLock = 'CORE_LEIN_LEVY_LOCK',
  CorePendingApprovalApplicationWithdrawn = 'CORE_PENDING_APPROVAL_APPLICATION_WITHDRAWN',
  CorePotentialAccountTakeover = 'CORE_POTENTIAL_ACCOUNT_TAKEOVER',
  CoreSuspiciousInvestmentActivity = 'CORE_SUSPICIOUS_INVESTMENT_ACTIVITY',
  CoreCollection = 'CORE_COLLECTION',
  CoreBrokerDealerAssociation = 'CORE_BROKER_DEALER_ASSOCIATION',
  CoreW9Required = 'CORE_W9_REQUIRED',
  Deceased = 'DECEASED',
  DelayedRiskWithdrawals = 'DELAYED_RISK_WITHDRAWALS',
  DuplicateAccount = 'DUPLICATE_ACCOUNT',
  EarlyTransferInProgress = 'EARLY_TRANSFER_IN_PROGRESS',
  Fraud = 'FRAUD',
  LaterRolloverInProgress = 'LATER_ROLLOVER_IN_PROGRESS',
  OtherNotListed = 'OTHER_NOT_LISTED',
  PlaidMismatch = 'PLAID_MISMATCH',
  ProfitStarsDispute = 'PROFIT_STARS_DISPUTE',
  SpendReturnedTransfer = 'SPEND_RETURNED_TRANSFER',
  SpendSuspiciousTransferActivity = 'SPEND_SUSPICIOUS_TRANSFER_ACTIVITY',
  SpendDisputedIncomingTransferR10 = 'SPEND_DISPUTED_INCOMING_TRANSFER_R10',
  SuspiciousMrdcPendingClosure = 'SUSPICIOUS_MRDC_PENDING_CLOSURE',
  SuspiciousMrdcContactSpendRisk = 'SUSPICIOUS_MRDC_CONTACT_SPEND_RISK',
  SpendGeneralSuspension = 'SPEND_GENERAL_SUSPENSION',
  ThreeWayCallRequired = 'THREE_WAY_CALL_REQUIRED',
  ReferralPromotionFraud = 'REFERRAL_PROMOTION_FRAUD',
  Underage = 'UNDERAGE',
  UnsupportedCustomer = 'UNSUPPORTED_CUSTOMER',
}

export type RevokeLoginAccessInput = {
  reason: RevokeAccessReasons
  userId: Scalars['ID']
}

export type RevokeLoginAccessResult = AuthProfile | UserCredentialsNotFoundException

export type RevokePasswordResetTokenInput = {
  plaintextToken: Scalars['String']
}

export type RevokePasswordResetTokenResult =
  | RevokePasswordResetTokenSuccess
  | InvalidPasswordResetTokenException

export type RevokePasswordResetTokenSuccess = {
  __typename?: 'RevokePasswordResetTokenSuccess'
  userId: Scalars['String']
}

export type RewardSummary = {
  __typename?: 'RewardSummary'
  value: Scalars['Float']
  currency: Scalars['String']
}

export enum RiskStatus {
  Fixable = 'fixable',
  Confirmable = 'confirmable',
  HardReject = 'hard_reject',
}

export enum RolloverAccountCode {
  Est = 'EST',
  Roi = 'ROI',
  Esr = 'ESR',
  Drb = 'DRB',
  Ria = 'RIA',
  Skt = 'SKT',
  Sep = 'SEP',
  Sti = 'STI',
  Gvb = 'GVB',
  Tia = 'TIA',
}

export type RolloverAccounts = {
  __typename?: 'RolloverAccounts'
  accounts?: Maybe<Array<Maybe<RolloverAccountType>>>
}

export type RolloverAccountType = {
  __typename?: 'RolloverAccountType'
  name: Scalars['String']
  code: RolloverAccountCode
}

/** A transaction with excess change to invest into an Acorns account */
export type RoundUp = TimestampsInterface & {
  __typename?: 'RoundUp'
  amount: Scalars['Float']
  change: Scalars['Float']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  instant: Scalars['Boolean']
  investmentId?: Maybe<Scalars['ID']>
  investmentNonce?: Maybe<Scalars['ID']>
  linkedSubaccountId: Scalars['ID']
  manual: Scalars['Boolean']
  multiplier?: Maybe<Scalars['Float']>
  name: Scalars['String']
  roundUpAccount: RoundUpAccount
  roundUpProfile: RoundUpProfile
  state: RoundUpState
  /** The target account in which this round up has been invested. */
  targetAccountId?: Maybe<Scalars['ID']>
  total?: Maybe<Scalars['Float']>
  transactionDate: Scalars['DateTime']
  transactionDisplayDate: Scalars['Date']
  transactionId: Scalars['ID']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
}

/** Round up settings for a specific linked account */
export type RoundUpAccount = TimestampsInterface & {
  __typename?: 'RoundUpAccount'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  enabled: Scalars['Boolean']
  linkedSubaccountId: Scalars['ID']
  roundUpProfile: RoundUpProfile
  roundUps: Array<RoundUp>
  startDate?: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
}

/** Round up settings for a user */
export type RoundUpProfile = TimestampsInterface & {
  __typename?: 'RoundUpProfile'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  multiplier: Scalars['Float']
  realTimeRoundUpEligible: Scalars['Boolean']
  roundUpAccounts: Array<RoundUpAccount>
  roundUpCount: Scalars['Int']
  roundUpTotal: Scalars['Float']
  roundUps: Array<RoundUp>
  roundUpsEnabled: Scalars['Boolean']
  /**
   * True if user has auto roundups off (making all roundups manual, even from
   * Spend accounts)or at least one enabled non-spend roundup account.
   */
  showRoundUpsProgress: Scalars['Boolean']
  /** The target account to which a user's round up investments will be made. */
  targetAccountId?: Maybe<Scalars['ID']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
  wholeDollarAmount: Scalars['Float']
}

/** Round up settings for a user */
export type RoundUpProfileRoundUpCountArgs = {
  state?: Maybe<Array<RoundUpState>>
  spend?: Maybe<Scalars['Boolean']>
  targetAccountId?: Maybe<Scalars['ID']>
}

/** Round up settings for a user */
export type RoundUpProfileRoundUpTotalArgs = {
  state?: Maybe<Array<RoundUpState>>
  spend?: Maybe<Scalars['Boolean']>
  targetAccountId?: Maybe<Scalars['ID']>
}

/** Changeable attributes for user profiles */
export type RoundUpProfileInput = {
  /** Toggle global user setting for auto round ups */
  roundUpsEnabled?: Maybe<Scalars['Boolean']>
  /** Round up multiplier */
  multiplier?: Maybe<Scalars['Float']>
  /** Round up to custom dollar amount */
  wholeDollarAmount?: Maybe<Scalars['Float']>
  /** Acorns account ID of roundups destination */
  targetAccountId?: Maybe<Scalars['ID']>
}

export enum RoundUpState {
  /** Round ups that have yet to be invested */
  Pending = 'pending',
  /** Round ups which are ready to be invested */
  Waiting = 'waiting',
  /** Round ups that requested to be invested but have not been transferred */
  RoundedUp = 'roundedUp',
  /** Round ups associated with an investment */
  Invested = 'invested',
  /** Round ups that were canceled, either before or after an investment was created */
  Canceled = 'canceled',
  /** Round ups that will be invested automatically */
  AutoInvestable = 'autoInvestable',
}

export enum RoundUpType {
  RealTime = 'realTime',
  Auto = 'auto',
}

/** An individual edge within the paginated list of RoundUpType */
export type RoundUpTypeEdge = {
  __typename?: 'RoundUpTypeEdge'
  /** The unique key used for pagination */
  cursor: Scalars['ID']
  /** The RoundUpType record in the edge */
  node: RoundUp
}

/** Relay style pagination information for RoundUpType */
export type RoundUpTypePagination = {
  __typename?: 'RoundUpTypePagination'
  edges: Array<RoundUpTypeEdge>
  pageInfo: PageInfo
}

export enum SalaryInterval {
  Hour = 'HOUR',
  Week = 'WEEK',
  Month = 'MONTH',
  Year = 'YEAR',
}

export type SamePasswordsException = {
  __typename?: 'SamePasswordsException'
  message?: Maybe<Scalars['String']>
}

export type SampleMailInDocument = {
  __typename?: 'SampleMailInDocument'
  /** Type of mail-in document. */
  mailType: MailInDocumentType
  /** Hyperlink to the pdf sample document. */
  letterUrl?: Maybe<Scalars['URL']>
}

/** Input for saving an upload url after direct to s3 upload */
export type SaveUploadUrlInput = {
  /** the upload uuid from the upload object */
  uploadUuid: Scalars['ID']
}

export type SavingsAccountEligibility = {
  __typename?: 'SavingsAccountEligibility'
  isEligibleForOpen: Scalars['Boolean']
  notEligibleReasons: Array<SavingsAccountEligibilityRequirement>
}

export enum SavingsAccountEligibilityRequirement {
  NeedsCheckingAccount = 'NEEDS_CHECKING_ACCOUNT',
  NeedsDirectDeposit = 'NEEDS_DIRECT_DEPOSIT',
  NeedsOtherBankingPartner = 'NEEDS_OTHER_BANKING_PARTNER',
}

export enum SavingsAccountType {
  EmergencySavings = 'EMERGENCY_SAVINGS',
}

export type ScheduleInput = {
  type: ScheduleType
}

export type ScheduleRecurringTransferInput = {
  recurrenceRule: RecurrenceRuleInput
  transferEvent: RecurringTransferEventInput
}

export type ScheduleRecurringTransferResult =
  | RecurringTransfer
  | MalformedRecurringTransferException

export type ScheduleResult = {
  __typename?: 'ScheduleResult'
  active: Scalars['Boolean']
  name?: Maybe<Scalars['String']>
}

export enum ScheduleType {
  Chat = 'chat',
  Email = 'email',
  Phone = 'phone',
}

/** Query attributes for Employer Search */
export type SearchEmployersInput = {
  /** Search Term */
  searchTerm?: Maybe<Scalars['String']>
  /** Switch Type */
  switchType?: Maybe<SwitchType>
  /** Session ID */
  sessionId?: Maybe<Scalars['ID']>
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
}

/** Search Results */
export type SearchEmployersPayload = {
  __typename?: 'SearchEmployersPayload'
  results?: Maybe<Array<Employer>>
  /** Unique Tracking ID */
  trackingId: Scalars['ID']
}

export type SearchHistory = {
  __typename?: 'SearchHistory'
  popularSearches?: Maybe<Array<Scalars['String']>>
  recentSearches: Array<Scalars['String']>
}

export type SearchSecuritiesInput = {
  search: Scalars['String']
  orderBy?: Maybe<SearchSecuritiesOrderBy>
  limit?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
}

export enum SearchSecuritiesOrderBy {
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by match score in descending order */
  BestMatch = 'BEST_MATCH',
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by market cap in descending order */
  MarketCap = 'MARKET_CAP',
  /**
   * Securities that match caller input LevenshteinDistanceThreshold or better
   * ordered by share price (open_price) in descending order
   */
  SharePrice = 'SHARE_PRICE',
}

export type SearchSecuritiesPageInfo = {
  __typename?: 'SearchSecuritiesPageInfo'
  totalMatches?: Maybe<Scalars['Int']>
  hasPreviousPage: Scalars['Boolean']
  hasNextPage: Scalars['Boolean']
  prevPageCursor?: Maybe<Scalars['String']>
  nextPageCursor?: Maybe<Scalars['String']>
  count: Scalars['Int']
}

export type SearchSecuritiesResponse = {
  __typename?: 'SearchSecuritiesResponse'
  securities: Array<Security>
  pageInfo?: Maybe<SearchSecuritiesPageInfo>
}

export type SearchSupportArticleResult = {
  __typename?: 'SearchSupportArticleResult'
  id: Scalars['ID']
  author: SupportAuthor
  draft: Scalars['Boolean']
  promoted: Scalars['Boolean']
  position?: Maybe<Scalars['Int']>
  section: SupportSection
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
  name: Scalars['String']
  title: Scalars['String']
  outdated: Scalars['Boolean']
  editedAt: Scalars['DateTime']
  body: Scalars['String']
  snippet: Scalars['String']
  resultType: Scalars['String']
}

export type SearchSupportResult = {
  __typename?: 'SearchSupportResult'
  relevantSearchCategories: Array<Maybe<SupportCategory>>
  relevantSearchArticles: Array<Maybe<SearchSupportArticleResult>>
}

/** Secret Squirrel Error */
export type SecretSquirrelException = {
  __typename?: 'SecretSquirrelException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type SecuritiesBySectorInput = {
  sectors: Array<TradingSector>
  orderBy?: Maybe<SecuritiesBySectorOrderBy>
  limit?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
}

export enum SecuritiesBySectorOrderBy {
  /** Securities that contain the provided trading sector(s) ordered by market cap in descending order */
  MarketCap = 'MARKET_CAP',
  /** Securities that contain the provided trading sector(s) ordered by share price (open_price) in descending order */
  SharePrice = 'SHARE_PRICE',
}

export type SecuritiesBySectorPageInfo = {
  __typename?: 'SecuritiesBySectorPageInfo'
  totalMatches?: Maybe<Scalars['Int']>
  hasPreviousPage: Scalars['Boolean']
  hasNextPage: Scalars['Boolean']
  prevPageCursor?: Maybe<Scalars['String']>
  nextPageCursor?: Maybe<Scalars['String']>
  count: Scalars['Int']
}

export type SecuritiesBySectorResponse = {
  __typename?: 'SecuritiesBySectorResponse'
  securities: Array<Security>
  pageInfo?: Maybe<SecuritiesBySectorPageInfo>
}

export type SecuritiesBySymbolsInput = {
  symbols: Array<Scalars['TickerSymbol']>
}

export type SecuritiesBySymbolsResponse = {
  __typename?: 'SecuritiesBySymbolsResponse'
  securities: Array<Security>
}

export type Security = {
  id: Scalars['ID']
  symbol: Scalars['TickerSymbol']
  type: SecurityType
  week52High: BigCurrencyAmount
  week52Low: BigCurrencyAmount
  currentPrice: BigCurrencyAmount
  lastClosePrice: BigCurrencyAmount
  openPrice: BigCurrencyAmount
  shortName: Scalars['String']
  longName: Scalars['String']
  volume: Scalars['BigDecimal']
  marketCap: Scalars['BigDecimal']
  profile: SecurityProfile
  /** @deprecated Use Security.profile. */
  securityProfile: SecurityProfile
  headlines: Array<SecurityHeadline>
  /** @deprecated Use Security.headlines. */
  securityHeadlines: Array<SecurityHeadline>
  lastUpdatedAt: Scalars['DateTime']
  earliestPriceDate: Scalars['Date']
  displayName: Scalars['String']
}

/** Describes a target allocation percentage for the specified security */
export type SecurityAllocationTarget = {
  /** ID or Symbol of the targeted security */
  securityId: Scalars['String']
  /** Target allocation percentage, ex: 33 -> 33% */
  securityPercent: Scalars['Int']
}

export type SecurityAnswer = {
  questionId: Scalars['ID']
  response: Scalars['String']
}

export type SecurityBySymbolInput = {
  symbol: Scalars['TickerSymbol']
}

export type SecurityGain = {
  __typename?: 'SecurityGain'
  percent?: Maybe<Scalars['BigDecimal']>
  marketValue?: Maybe<BigCurrencyAmount>
}

export type SecurityHeadline = {
  __typename?: 'SecurityHeadline'
  createdAt: Scalars['DateTime']
  source: Scalars['String']
  headline: Scalars['String']
  storyUrl: Scalars['URL']
  thumbnailUrl?: Maybe<Scalars['URL']>
}

/** Security Not Supported */
export type SecurityNotSupportedException = {
  __typename?: 'SecurityNotSupportedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type SecurityPerformance = {
  __typename?: 'SecurityPerformance'
  symbol: Scalars['TickerSymbol']
  gain: SecurityGain
  prices?: Maybe<Array<SecurityPrice>>
}

export type SecurityPerformanceBySymbolInput = {
  symbol: Scalars['TickerSymbol']
  startDate: Scalars['DateTime']
  /** Only the Date component is used */
  endDate: Scalars['DateTime']
  /** Only the Date component is used */
  interval?: Maybe<Scalars['Int']>
  maxPoints?: Maybe<Scalars['Int']>
}

export type SecurityPerformancesBySymbolInput = {
  symbols: Array<Scalars['TickerSymbol']>
  startDate: Scalars['DateTime']
  /** Only the Date component is used */
  endDate: Scalars['DateTime']
  /** Only the Date component is used */
  interval?: Maybe<Scalars['Int']>
  maxPoints?: Maybe<Scalars['Int']>
}

export type SecurityPrice = {
  __typename?: 'SecurityPrice'
  date: Scalars['Date']
  marketValue: BigCurrencyAmount
  timestamp: Scalars['DateTime']
  unadjustedMarketValue?: Maybe<BigCurrencyAmount>
}

export type SecurityProfile = {
  __typename?: 'SecurityProfile'
  description?: Maybe<Scalars['String']>
  tradingSectors: Array<TradingSector>
  logoUrl?: Maybe<Scalars['URL']>
  defaultLogoUrl?: Maybe<Scalars['URL']>
}

export type SecurityQuestion = {
  __typename?: 'SecurityQuestion'
  id?: Maybe<Scalars['ID']>
  text?: Maybe<Scalars['String']>
}

export type SecurityQuestionInput = {
  answer1: Scalars['String']
  question1: Scalars['String']
}

export enum SecurityType {
  Etf = 'ETF',
  Stock = 'STOCK',
  Bond = 'BOND',
}

/** User Directed Portfolio Object */
export type SelfDirectedPortfolio = BasePortfolio & {
  __typename?: 'SelfDirectedPortfolio'
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation
  cashOwed: MonetaryAmount
  currentAllocationPercentage: Scalars['Float']
  currentBalance: MonetaryAmount
  currentBalanceWithPending: MonetaryAmount
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel?: Maybe<PortfolioCustomizationLevel>
  /** Description of the portfolio */
  description: Scalars['String']
  /** ID of the Portfolio */
  id: Scalars['ID']
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']
  pendingBalance: MonetaryAmount
  /**
   * Securities currently owned by the Portfolio's InvestmentAccount (will be null
   * if not selected in the context of an InvestmentAccount).
   */
  portfolioSecurities?: Maybe<Array<PortfolioSecurity>>
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations?: Maybe<Array<PortfolioSecurityAllocation>>
  /** Contains requirement statuses for removing the portfolio */
  requirements: AccountRequirements
  status: SelfDirectedPortfolioStatus
  yearToDateReturn?: Maybe<MarketReturn>
}

export enum SelfDirectedPortfolioStatus {
  /** Self Directed Portfolio is open */
  Open = 'OPEN',
  /** Self Directed Portfolio has started the closure process */
  PendingClosure = 'PENDING_CLOSURE',
  /** Self Directed Portfolio has been removed */
  Closed = 'CLOSED',
}

export type SendCheckPaymentInput = {
  nonce: Scalars['String']
  recipient: CheckPaymentRecipientInput
  recipientAddress: CheckPaymentAddressInput
  amount: CurrencyAmountInput
  memo?: Maybe<Scalars['String']>
  fromAccountId: Scalars['ID']
}

/** Check or errors */
export type SendCheckPaymentResult =
  | CheckPayment
  | AuthorizationError
  | DuplicateActionError
  | InvalidAddressError

export type ServiceNode = {
  __typename?: 'ServiceNode'
  /** ID of the service provider */
  serviceId: Scalars['ID']
  /** Name of the service provider */
  serviceName: Scalars['String']
  /** Name of the customer's plan with the company */
  logoUrl: Scalars['URL']
}

/**
 * legacy return type for createUser
 * needed to support client backwards compatibility until createUser is deprecated
 */
export type Session = {
  __typename?: 'Session'
  uuid: Scalars['ID']
  token: Scalars['ID']
  refreshToken?: Maybe<Scalars['ID']>
  redirectUrl?: Maybe<Scalars['String']>
}

export type SetAuthenticationPinInput = {
  pin: Scalars['String']
  pinConfirmation: Scalars['String']
}

/** set authentication pin results */
export type SetAuthenticationPinResult =
  | SetAuthenticationPinSuccess
  | InvalidPinException
  | UserCredentialsNotFoundException

export type SetAuthenticationPinSuccess = {
  __typename?: 'SetAuthenticationPINSuccess'
  userId: Scalars['ID']
}

/** Response to a beneficiary ssn update */
export type SetBeneficiarySsnResult =
  | Beneficiary
  | BeneficiaryNotFoundException
  | InternalErrorException
  | InvalidSsnException
  | SecretSquirrelException
  | SsnAlreadyInUseException
  | SsnMatchesCustodianException
  | SsnUpdateForbiddenException

export type SetDefaultAuthenticatorInput = {
  authenticatorId: Scalars['ID']
}

export type SetDefaultAuthenticatorResult =
  | PhoneAuthenticator
  | EmailAuthenticator
  | AuthenticatorNotFoundException
  | AuthenticatorAlreadyDefaultException

/** Configuration for setting public access of investment account recaps. */
export type SetInvestmentAccountRecapPublicAccessInput = {
  /** The unique identifier of the investment account recap for which public access is being modified. */
  id: Scalars['ID']
  /** Whether or not the recap is public. */
  public: Scalars['Boolean']
}

/** Result of modifying the public access of an investment account recap. */
export type SetInvestmentAccountRecapPublicAccessResult =
  | InvestmentAccountRecap
  | InvestmentAccountRecapNotFoundException

/** Options to set an account with a linking error */
export type SetLinkingErrorInput = {
  /** Error to give the linked account */
  code: LinkedAccountLinkingErrorsEnum
}

export type SetNegotiationStatusInput = {
  /** UserId */
  userId: Scalars['ID']
  /** Negotiation type */
  negotiationMethod: NegotiationMethod
  /** Bank fee negotiation ID. */
  submissionId: Scalars['ID']
  /** The current status for this negotiation submission. */
  status: BankFeeNegotiationStatus
  /** Amount refunded through negotiation. */
  refundAmount?: Maybe<Scalars['Float']>
  /** Service invoking this mutation */
  operator: Scalars['String']
}

export type SetNegotiationStatusResult = {
  __typename?: 'SetNegotiationStatusResult'
  message: Scalars['String']
}

export type SetPortfolioInput = {
  id: Scalars['ID']
}

export type Settings = {
  __typename?: 'Settings'
  /** @deprecated Highly non-performant! */
  automaticRoundup: Scalars['Boolean']
  /** @deprecated Highly non-performant! */
  allowDebitCard: Scalars['Boolean']
  /** @deprecated Highly non-performant! */
  threshold: Scalars['Int']
  /** @deprecated Highly non-performant! */
  dollarRoundupAmount: Scalars['Float']
  /** @deprecated Highly non-performant! */
  roundupMultiplier: Scalars['Int']
  depositsSuspended?: Maybe<Scalars['Boolean']>
  /** @deprecated Highly non-performant! */
  notifications: Notifications
}

export type SetUpTip = {
  __typename?: 'SetUpTip'
  backgroundImage: Image
  body: Scalars['String']
  ctaDetails: ActionFeedCta
  id: Scalars['ID']
  image: Image
  type: ProductSetupTipType
}

export enum ShareTransferType {
  /** Move shares from trading account to master holding account */
  Buy = 'BUY',
  /** Move shares from master holding account to trading account */
  Sell = 'SELL',
  /** Move shares from chargeback account to holding account */
  ChargebackBuy = 'CHARGEBACK_BUY',
  /** Move shares from holding account to chargeback account */
  ChargebackSell = 'CHARGEBACK_SELL',
}

export type Signature = TimestampsInterface & {
  __typename?: 'Signature'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Type of profile */
  profile?: Maybe<Profile>
  /** Type of signature */
  signatureType: SignatureType
  /** SVG file */
  svgFile: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
}

export enum SignatureType {
  /** A signature for the user investment certificate */
  Certificate = 'certificate',
  /** A signature used for the user spend debit card */
  DebitCard = 'debitCard',
  /** A signature used for the user direct deposit PDF form */
  DirectDeposit = 'directDeposit',
  /** A signature used for a user's utility bill negotiation */
  UtilityBillNegotiation = 'utilityBillNegotiation',
  /** A signature used for a user's bank fee negotiation */
  BankFeeNegotiation = 'bankFeeNegotiation',
}

export type SmartDepositMetadataInput = {
  supportedTargetAccounts: Array<SplitDepositTargetAccountType>
}

export type SmartDepositMetadataResult = {
  __typename?: 'SmartDepositMetadataResult'
  recommendedAllocations: Array<SplitDepositAllocation>
  targetAccounts: Array<SplitDepositTargetAccount>
}

export type SmsAuthChallenge = AuthChallenge & {
  __typename?: 'SMSAuthChallenge'
  id: Scalars['ID']
  maskedPhoneNumber: Scalars['String']
  alternateAuthenticators: Array<AuthenticatorInfo>
}

export type SocialCopies = {
  __typename?: 'SocialCopies'
  campaignTaxonomy?: Maybe<Scalars['String']>
  category?: Maybe<Scalars['String']>
  copy?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  targetMedium?: Maybe<Scalars['String']>
}

/** Extra detailed attributes for source of user's arrival to registration. */
export type SourceAttributes = {
  __typename?: 'SourceAttributes'
  /** s2 - Affiliate for Impact Radius or campaign ID */
  affiliateCampaignID?: Maybe<Scalars['String']>
  /** Unique ID for user journey exposed by Button */
  buttonSourceToken?: Maybe<Scalars['String']>
  /** carrier - Mobile carrier */
  carrier?: Maybe<Scalars['String']>
  /** clickid - Unique Impact Radius referral ID */
  clickID?: Maybe<Scalars['String']>
  /** code - Referral code of advocate the user registered with */
  code?: Maybe<Scalars['String']>
  /** referral_code - Referral code of referrer (either user-to-user or partner) that the user registered with */
  referralCode?: Maybe<Scalars['String']>
  /** Identifier for the prospect's attribution channel */
  sourceID: Scalars['String']
}

/** Source attribute object represented as is today. Should be normalized moving forward. */
export type SourceAttributesInput = {
  /** Unnormalized source attributes for supporting backwards compatibility with existing services */
  rawJSON: Scalars['String']
  /** Identifier for the prospect's attribution channel */
  sourceID: Scalars['String']
}

export type SpendAccount = {
  __typename?: 'SpendAccount'
  status: SpendAccountStatus
  isReopenable?: Maybe<Scalars['Boolean']>
  isEligible: Scalars['Boolean']
  lockReason?: Maybe<BankAccountLockReason>
  bankCardOrder?: Maybe<BankCardOrder>
  isDirectDepositIncentiveEligible: Scalars['Boolean']
  bankType?: Maybe<BankType>
  accountId?: Maybe<Scalars['ID']>
}

export enum SpendAccountStatus {
  NotOpened = 'NOT_OPENED',
  Open = 'OPEN',
  Closed = 'CLOSED',
  Reopening = 'REOPENING',
  Locked = 'LOCKED',
  Opening = 'OPENING',
}

export type SpendAlert = {
  userId: Scalars['ID']
  type: Scalars['String']
}

export type SpendAtm = {
  __typename?: 'SpendAtm'
  address: SpendAtmAddress
  phoneNumber?: Maybe<Scalars['String']>
  atmName: Scalars['String']
  imageUrl?: Maybe<Scalars['String']>
}

export type SpendAtmAddress = {
  __typename?: 'SpendAtmAddress'
  latitude: Scalars['String']
  longitude: Scalars['String']
  addressLine?: Maybe<Scalars['String']>
  cityName?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
}

export type SpendAtmReimbursementItem = PastItem &
  SpendItem & {
    __typename?: 'SpendATMReimbursementItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendAtmsCoordinateInput = {
  latitude: Scalars['String']
  longitude: Scalars['String']
}

export type SpendAtmsInput = {
  searchCoordinate: SpendAtmsCoordinateInput
  searchRadius?: Maybe<Scalars['Float']>
}

export type SpendAtmsPayload = {
  __typename?: 'SpendAtmsPayload'
  atms?: Maybe<Array<Maybe<SpendAtm>>>
  executedSearchRadius?: Maybe<Scalars['String']>
}

export type SpendAtmsResult = SpendAtmsPayload | SpendAtmVendorUnavailableError

export type SpendAtmVendorUnavailableError = {
  __typename?: 'SpendAtmVendorUnavailableError'
  requestId?: Maybe<Scalars['String']>
}

export type SpendAtmWithdrawalItem = PastItem &
  SpendItem & {
    __typename?: 'SpendATMWithdrawalItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendBillPayItem = PastItem &
  SpendItem & {
    __typename?: 'SpendBillPayItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendCheckDepositItem = PastItem &
  SpendItem & {
    __typename?: 'SpendCheckDepositItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendCheckPaymentItem = PastItem &
  SpendItem & {
    __typename?: 'SpendCheckPaymentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendDigitalWalletItem = PastItem &
  SpendItem & {
    __typename?: 'SpendDigitalWalletItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendDirectDepositItem = PastItem &
  SpendItem & {
    __typename?: 'SpendDirectDepositItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendDisputesResponse = {
  __typename?: 'SpendDisputesResponse'
  id?: Maybe<Scalars['Int']>
  creationDateTime?: Maybe<Scalars['DateTime']>
  disputeDateTime?: Maybe<Scalars['DateTime']>
  description: Scalars['String']
  questions: Array<SpendTransactionsDisputeQuestions>
  transactions: Array<SpendTransactionsResponse>
}

export type SpendECheckItem = PastItem &
  SpendItem & {
    __typename?: 'SpendECheckItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

/** A base set of fields that each PastItem from Spend transactions must implement */
export type SpendItem = {
  /** When funds associated with the transaction became available. */
  availableAt?: Maybe<Scalars['DateTime']>
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String']
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String']
}

export type SpendPurchaseItem = PastItem &
  SpendItem & {
    __typename?: 'SpendPurchaseItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendRealTimeRoundUpItem = PastItem &
  SpendItem & {
    __typename?: 'SpendRealTimeRoundUpItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    /** The investment amount after being multiplied. */
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    /** The investment amount prior to being multiplied */
    initialAmount?: Maybe<CurrencyAmount>
    multiplier?: Maybe<Scalars['Int']>
  }

export type SpendTransactionsDisputeCustomersResponse = {
  __typename?: 'SpendTransactionsDisputeCustomersResponse'
  customerNumber?: Maybe<Scalars['String']>
  accountNumber?: Maybe<Scalars['String']>
  applicationCode?: Maybe<Scalars['String']>
  productCode?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  disputes: Array<SpendDisputesResponse>
}

export type SpendTransactionsDisputeQuestions = {
  __typename?: 'SpendTransactionsDisputeQuestions'
  question?: Maybe<Scalars['String']>
  answer?: Maybe<Scalars['String']>
}

export type SpendTransactionsDisputeResponse = {
  __typename?: 'SpendTransactionsDisputeResponse'
  customers: SpendTransactionsDisputeCustomersResponse
  bankType: BankType
}

export type SpendTransactionsDisputeResult = SpendTransactionsDisputeResponse

export type SpendTransactionsInput = {
  id: Scalars['ID']
  amount: Scalars['String']
  description: Scalars['String']
  createdAt?: Maybe<Scalars['DateTime']>
  availableAt?: Maybe<Scalars['DateTime']>
  settledAt?: Maybe<Scalars['DateTime']>
  status: BankTransactionStatus
  tag?: Maybe<Scalars['String']>
  type: BankTransactionType
  typeCode: Scalars['String']
  updatedAt?: Maybe<Scalars['DateTime']>
  voidedAt?: Maybe<Scalars['DateTime']>
}

export type SpendTransactionsResponse = {
  __typename?: 'SpendTransactionsResponse'
  id?: Maybe<Scalars['Int']>
  status?: Maybe<Scalars['String']>
  description: Scalars['String']
  postingDate: Scalars['DateTime']
  amount: Scalars['Float']
  disputedAmount: Scalars['Float']
  transactionCode: Scalars['String']
  coreTransactionId: Scalars['String']
}

export type SpendTransferInItem = PastItem &
  SpendItem &
  PastUserTransferItem & {
    __typename?: 'SpendTransferInItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate?: Maybe<Scalars['DateTime']>
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring?: Maybe<Scalars['Boolean']>
  }

export type SpendTransferOutItem = PastItem &
  SpendItem &
  PastUserTransferItem & {
    __typename?: 'SpendTransferOutItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The corresponding product of the item */
    productType: ProductType
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate?: Maybe<Scalars['DateTime']>
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring?: Maybe<Scalars['Boolean']>
  }

export type SplitDeposit = {
  __typename?: 'SplitDeposit'
  allocations: Array<SplitDepositAllocation>
  createdAt: Scalars['String']
  distributedAt?: Maybe<Scalars['String']>
  expectedNextDepositAmount?: Maybe<Scalars['String']>
  expectedNextDepositAt?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isCancelable: Scalars['Boolean']
  isCanceled: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
  /** @deprecated deprecated, use allocations instead */
  savingsRatePercent: Scalars['String']
  settingsId: Scalars['ID']
  /** @deprecated deprecated, use allocations instead */
  splitDistribution: DistributionAmounts
  transactionAmount: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
  willDistributeAutomaticallyAt?: Maybe<Scalars['String']>
}

export type SplitDepositAllocation = {
  allocationPercent: Scalars['String']
  nickname?: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type SplitDepositAllocationInput = {
  allocationPercent: Scalars['String']
  nickname?: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type SplitDepositDailyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositDailyRecurrenceRule'
  frequency: SplitDepositRecurrenceFrequency
}

export type SplitDepositDirectDepositAllocation = SplitDepositAllocation & {
  __typename?: 'SplitDepositDirectDepositAllocation'
  allocationPercent: Scalars['String']
  nickname?: Maybe<Scalars['String']>
  normalizedAmount?: Maybe<FormattedMonetaryAmount>
  normalizedDailyAmount?: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type SplitDepositDirectDepositIntentSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositDirectDepositIntentSetting'
  allocations: Array<SplitDepositDirectDepositAllocation>
  createdAt: Scalars['String']
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  estimatedPaycheckAmount: CurrencyAmount
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
  name: Scalars['String']
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
  deposits?: Maybe<Array<SplitDeposit>>
}

export type SplitDepositDirectDepositIntentSettingDepositsArgs = {
  orderBy?: Maybe<Order>
  limit?: Maybe<Scalars['Int']>
}

export type SplitDepositDirectDepositSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositDirectDepositSetting'
  allocations: Array<SplitDepositDirectDepositAllocation>
  awaitingConfiguration: Scalars['Boolean']
  createdAt: Scalars['String']
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
  monthlyTotals: Array<MonthlyTotal>
  name: Scalars['String']
  normalizedAmount?: Maybe<FormattedMonetaryAmount>
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
  deposits?: Maybe<Array<SplitDeposit>>
  totalAmounts?: Maybe<TotalAmounts>
}

export type SplitDepositDirectDepositSettingDepositsArgs = {
  orderBy?: Maybe<Order>
  limit?: Maybe<Scalars['Int']>
}

export type SplitDepositMonthlyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositMonthlyRecurrenceRule'
  byMonthDay: Array<Scalars['Int']>
  frequency: SplitDepositRecurrenceFrequency
}

export type SplitDepositMutation = {
  __typename?: 'SplitDepositMutation'
  id: Scalars['ID']
  userId: Scalars['ID']
  execute: SplitDeposit
  cancel: SplitDeposit
}

export enum SplitDepositNormalizationFrequency {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY',
}

export type SplitDepositRecurrenceAllocation = SplitDepositAllocation & {
  __typename?: 'SplitDepositRecurrenceAllocation'
  allocationPercent: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  legacyRecurrenceAmount?: Maybe<FormattedMonetaryAmount>
  legacyRecurrenceRule?: Maybe<SplitDepositRecurrenceRule>
  nickname?: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export enum SplitDepositRecurrenceFrequency {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
}

export type SplitDepositRecurrenceRule = {
  frequency: SplitDepositRecurrenceFrequency
}

export type SplitDepositRecurrenceSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositRecurrenceSetting'
  allocations: Array<SplitDepositRecurrenceAllocation>
  createdAt: Scalars['String']
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  monthlyTotals: Array<MonthlyTotal>
  name: Scalars['String']
  normalizedAmount?: Maybe<FormattedMonetaryAmount>
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
  deposits?: Maybe<Array<SplitDeposit>>
}

export type SplitDepositRecurrenceSettingDepositsArgs = {
  orderBy?: Maybe<Order>
  limit?: Maybe<Scalars['Int']>
}

export type SplitDepositSettings = {
  allocations: Array<SplitDepositAllocation>
  createdAt: Scalars['String']
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  name: Scalars['String']
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
  deposits?: Maybe<Array<SplitDeposit>>
}

export type SplitDepositSettingsDepositsArgs = {
  orderBy?: Maybe<Order>
  limit?: Maybe<Scalars['Int']>
}

export type SplitDepositSettingsFilterInput = {
  settingTypes: Array<SplitDepositSettingType>
  showHiddenEmployerSettings?: Maybe<Scalars['Boolean']>
}

export type SplitDepositSettingsMutation = {
  __typename?: 'SplitDepositSettingsMutation'
  employer: Scalars['String']
  employerHidden: Scalars['Boolean']
  id: Scalars['ID']
  userId: Scalars['ID']
  configure: SplitDepositSettings
}

export type SplitDepositSettingsMutationConfigureArgs = {
  input: ConfigureSettingsInput
}

export enum SplitDepositSettingType {
  DirectDeposit = 'DIRECT_DEPOSIT',
  DirectDepositIntent = 'DIRECT_DEPOSIT_INTENT',
  Recurrence = 'RECURRENCE',
}

export type SplitDepositTargetAccount = {
  __typename?: 'SplitDepositTargetAccount'
  nickname?: Maybe<Scalars['String']>
  targetAccountId?: Maybe<Scalars['ID']>
  targetAccountType: SplitDepositTargetAccountType
}

export enum SplitDepositTargetAccountType {
  Spend = 'SPEND',
  Invest = 'INVEST',
  Later = 'LATER',
  Early = 'EARLY',
  Save = 'SAVE',
}

export type SplitDepositWeeklyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositWeeklyRecurrenceRule'
  byWeekDay: Array<DayOfWeek>
  frequency: SplitDepositRecurrenceFrequency
}

/** This SSN already belongs to another beneficiary for this custodian */
export type SsnAlreadyInUseException = {
  __typename?: 'SsnAlreadyInUseException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** SSN supporting document requested user alert. */
export type SsnDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'SSNDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** This SSN is a duplicate of the current custodian's SSN */
export type SsnMatchesCustodianException = {
  __typename?: 'SsnMatchesCustodianException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Beneficiary's ssn cannot be updated */
export type SsnUpdateForbiddenException = {
  __typename?: 'SsnUpdateForbiddenException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type SsnUsedError = {
  __typename?: 'SSNUsedError'
  message: Scalars['String']
}

/** Attributes for starting PDF Switch */
export type StartAcornsPdfSwitchInput = {
  /** [DEPRECATED] Use employerName instead. */
  name?: Maybe<Scalars['String']>
  /** Employer Name */
  employerName?: Maybe<Scalars['String']>
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Session ID */
  sessionId?: Maybe<Scalars['ID']>
}

/** Starts a check deposit session. */
export type StartCheckDepositInput = {
  /** The client info to pass to Ensenta for validation purposes */
  clientInfo: ClientInfo
}

/** Starts a check deposit session with our vendor. */
export type StartCheckDepositPayload = {
  __typename?: 'StartCheckDepositPayload'
  /** Token that represents a session with our vendor. */
  sessionToken: Scalars['String']
}

/** Attributes for starting Online Switch */
export type StartOnlineSwitchInput = {
  /** Employer ID */
  employerId: Scalars['ID']
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Session ID */
  sessionId?: Maybe<Scalars['ID']>
}

export type StartOnlineSwitchPayload = SwitchPayloadInterface & {
  __typename?: 'StartOnlineSwitchPayload'
  userSwitch: UserSwitch
}

/** Changeable attributes for addresses */
export type StartSubmittableSwitchAddressInput = {
  /** Street 1 */
  street1: Scalars['String']
  /** Street 2 */
  street2?: Maybe<Scalars['String']>
  /** City */
  city: Scalars['String']
  /** State */
  state: Scalars['String']
  /** Country */
  country: Scalars['String']
  /** Zip code */
  zipCode: Scalars['String']
}

/** Attributes for starting Submittable Switch */
export type StartSubmittableSwitchInput = {
  /** Employer ID */
  employerId: Scalars['ID']
  /** Bank Account ID */
  bankAccountId?: Maybe<Scalars['ID']>
  /** Session ID */
  sessionId?: Maybe<Scalars['ID']>
  /** Employee ID */
  nonSsnEmployeeId?: Maybe<Scalars['String']>
  /** Employer Address */
  employerLocationAddress?: Maybe<StartSubmittableSwitchAddressInput>
}

export type StartSubmittableSwitchPayload = SwitchPayloadInterface & {
  __typename?: 'StartSubmittableSwitchPayload'
  userSwitch: UserSwitch
}

export enum StateCode {
  Al = 'AL',
  Ak = 'AK',
  Az = 'AZ',
  Ar = 'AR',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ia = 'IA',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Me = 'ME',
  Md = 'MD',
  Ma = 'MA',
  Mi = 'MI',
  Mn = 'MN',
  Ms = 'MS',
  Mo = 'MO',
  Mt = 'MT',
  Ne = 'NE',
  Nv = 'NV',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Ny = 'NY',
  Nc = 'NC',
  Nd = 'ND',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Vt = 'VT',
  Va = 'VA',
  Wa = 'WA',
  Wv = 'WV',
  Wi = 'WI',
  Wy = 'WY',
  As = 'AS',
  Dc = 'DC',
  Fm = 'FM',
  Gu = 'GU',
  Mh = 'MH',
  Mp = 'MP',
  Pw = 'PW',
  Pr = 'PR',
  Vi = 'VI',
}

export type Statement = {
  __typename?: 'Statement'
  id: Scalars['ID']
  month: Scalars['Int']
  year: Scalars['Int']
  statementType: StatementType
  createdAt: Scalars['DateTime']
  updatedAt?: Maybe<Scalars['DateTime']>
  day: Scalars['Int']
  startDate?: Maybe<Scalars['DateTime']>
  endDate?: Maybe<Scalars['DateTime']>
  uploaded?: Maybe<Scalars['Boolean']>
  archivableId?: Maybe<Scalars['ID']>
  archivableType?: Maybe<Scalars['String']>
  s3Filename?: Maybe<Scalars['String']>
  investmentAccountId: Scalars['ID']
  link?: Maybe<StatementLink>
  investmentAccountType?: Maybe<InvestmentAccountType>
  formType?: Maybe<FormType>
  portfolioType: StatementPortfolioType
}

export type StatementLink = {
  __typename?: 'StatementLink'
  url: Scalars['String']
  downloadUrl: Scalars['String']
}

export enum StatementPortfolioType {
  SelfDirected = 'SELF_DIRECTED',
  Customized = 'CUSTOMIZED',
  Managed = 'MANAGED',
}

export enum StatementType {
  User = 'user',
  DailyUserTradeConfirmation = 'daily_user_trade_confirmation',
  Tax = 'tax',
}

export type Stock = Security & {
  __typename?: 'Stock'
  id: Scalars['ID']
  symbol: Scalars['TickerSymbol']
  type: SecurityType
  week52High: BigCurrencyAmount
  week52Low: BigCurrencyAmount
  currentPrice: BigCurrencyAmount
  lastClosePrice: BigCurrencyAmount
  openPrice: BigCurrencyAmount
  shortName: Scalars['String']
  longName: Scalars['String']
  volume: Scalars['BigDecimal']
  marketCap: Scalars['BigDecimal']
  profile: SecurityProfile
  /** @deprecated Use Security.profile. */
  securityProfile: SecurityProfile
  headlines: Array<SecurityHeadline>
  /** @deprecated Use Security.headlines. */
  securityHeadlines: Array<SecurityHeadline>
  lastUpdatedAt: Scalars['DateTime']
  earliestPriceDate: Scalars['Date']
  displayName: Scalars['String']
}

export type StringKeyAsset = {
  __typename?: 'StringKeyAsset'
  args: Array<Scalars['String']>
  key: Scalars['StringKey']
}

export type SubcategoryMessage = {
  __typename?: 'SubcategoryMessage'
  id: Scalars['ID']
  title?: Maybe<Scalars['String']>
  body?: Maybe<Scalars['String']>
  ctaText?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type Submission = {
  __typename?: 'Submission'
  /** The name of the bank associated with this negotiation submission. */
  bank: BankName
  /** The ID of the associated bank connection. */
  linkedAccountId: Scalars['ID']
  /** The date the negotiation submission was created. Ex: 'Tue, 29 Dec 2020 04:16:41 GMT' */
  created: Scalars['DateTime']
  /** A uinique identifier for this submission: 'Chase Bank_1609215401.1132371'  */
  key: Scalars['String']
  /** The current status for this negotaition submission. */
  status: SubmissionStatus
  /** The date this submission was last edited. Ex: 'Fri, 22 Jan 2021 03:25:33 GMT' */
  updated: Scalars['DateTime']
  /** The fee type string. Ex: 'Overdraft fees' */
  feeSynopsis?: Maybe<Scalars['String']>
}

export type SubmissionError = {
  __typename?: 'SubmissionError'
  errors?: Maybe<Array<Maybe<Scalars['String']>>>
}

export enum SubmissionStatus {
  Pending = 'PENDING',
  ConnectionError = 'CONNECTION_ERROR',
  Completed = 'COMPLETED',
  DelayCharge = 'DELAY_CHARGE',
  Collect = 'COLLECT',
  MailInPending = 'MAIL_IN_PENDING',
  MailInError = 'MAIL_IN_ERROR',
  MailInSent = 'MAIL_IN_SENT',
  MailInEscalated = 'MAIL_IN_ESCALATED',
}

export type SubmitBankFeeNegotiationInput = {
  linkedAccountId: Scalars['ID']
}

export type SubmitBankFeeNegotiationResponse = {
  __typename?: 'SubmitBankFeeNegotiationResponse'
  message: Scalars['String']
  status: Scalars['String']
}

export type SubmitBankFeeNegotiationResult =
  | SubmitBankFeeNegotiationResponse
  | LinkedAccountNotFound

export type SubmitForBillNegotiationInput = {
  /** The ID of the user doing negotiation */
  userId: Scalars['ID']
  /** The ID for the utility bill company */
  serviceId: Scalars['ID']
  /** Name of the customer's plan with the company */
  planName: Scalars['String']
  /** Cost of the plan. Non zero positive number. */
  planCost: Scalars['Amount']
  /** Frequency of the plan charge. Ex: Monthly, Weekly */
  planRenewal: PlanPeriod
  /** Email of the user with the bill company */
  planEmail: Scalars['EmailAddress']
  /** Account number with the utility company */
  planAccountNumber?: Maybe<Scalars['String']>
  /** Duration for which the user has been a customer of the said company */
  customerDuration: Scalars['Float']
  /** Time units for customer duration. Ex: Week, Month, Year */
  customerPeriod: CustomerPeriod
  /** Circumstance for submitting the bill negotiation request. Ex: Personal, Financial */
  circumstances: Circumstance
}

export type SubmitSpendTransactionsDisputeInput = {
  cardNumber: Scalars['String']
  message: Scalars['String']
  spendCardDetails: Scalars['String']
  merchantInfo: Scalars['String']
  eSignature: Scalars['String']
  disputeReason: Scalars['String']
  selectedTransactions: Array<SpendTransactionsInput>
}

/** Submittable Switches are performed via Click Switch API. */
export type SubmittableSwitch = SwitchInterface & {
  __typename?: 'SubmittableSwitch'
  requiresEmployerMailingAddress?: Maybe<Scalars['Boolean']>
  requiresNonSsnEmployeeId?: Maybe<Scalars['Boolean']>
  requiresSsnLastFour?: Maybe<Scalars['Boolean']>
  source: SwitchSource
  type: SwitchType
  vendorTargetId: Scalars['ID']
}

export type SubmitUserReportedBankFeeRefundInput = {
  /** UserId */
  userId: Scalars['ID']
  /** Bank fee negotiation ID. */
  submissionId: Scalars['ID']
  /** Amount refunded through negotiation. */
  refundAmount: Scalars['Amount']
}

export type SubmitUserReportedBankFeeRefundResult = {
  __typename?: 'SubmitUserReportedBankFeeRefundResult'
  message: Scalars['String']
}

export type SubscriberIneligibleError = {
  __typename?: 'SubscriberIneligibleError'
  message: Scalars['String']
}

export type SubscribeToTierInput = {
  feedback?: Maybe<Scalars['String']>
  tierId: Scalars['ID']
  tierPriceId: Scalars['ID']
  userId: Scalars['ID']
}

export type SubscribeToTierResult = InvalidTier | InvalidTierPrice | TierSubscription

export type SubscribeUserToTierByProductKeyInput = {
  /** Deprecated */
  createdBy?: Maybe<TierSubscriptionCreatedBy>
  /**
   * Subscription requests with an effective date earlier than the current subscription's createdAt
   * timestamp will be ignored. Defaults to current time.
   */
  effectiveAt?: Maybe<Scalars['DateTime']>
  productKey: ProductKey
  tierGroupId?: Maybe<Scalars['ID']>
}

export type SubscribeUserToTierInput = {
  /** Deprecated */
  createdBy?: Maybe<TierSubscriptionCreatedBy>
  tierPriceId: Scalars['ID']
}

export type SubscribeUserToTierResult =
  | InvalidTierPriceId
  | TierDowngradeActionRequired
  | TierSubscription

export type Subscription = {
  __typename?: 'Subscription'
  /** Returns new messages created */
  onMessageCreated: Message
}

export type SubscriptionMigration = {
  __typename?: 'SubscriptionMigration'
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  effectiveAt: Scalars['DateTime']
  fromTier: Tier
  id: Scalars['ID']
  toTier: Tier
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type SubscriptionMigrationInvalidError = {
  __typename?: 'SubscriptionMigrationInvalidError'
  message: Scalars['String']
}

export type SubscriptionMigrationWaiver = {
  __typename?: 'SubscriptionMigrationWaiver'
  accepted: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  migration: SubscriptionMigration
  reason: SubscriptionMigrationWaiverReason
  updatedAt?: Maybe<Scalars['DateTime']>
}

export enum SubscriptionMigrationWaiverReason {
  FinancialHardship = 'FINANCIAL_HARDSHIP',
}

/** transition actions for a subscription */
export enum SubscriptionTransitionAction {
  AddPromotion = 'ADD_PROMOTION',
  Deactivate = 'DEACTIVATE',
  Downgrade = 'DOWNGRADE',
  Upgrade = 'UPGRADE',
}

export type Suitability = {
  __typename?: 'Suitability'
  answer?: Maybe<Scalars['String']>
  answerId?: Maybe<Scalars['ID']>
  pickerId?: Maybe<Scalars['String']>
  questionId?: Maybe<Scalars['ID']>
}

/** Recommended portfolio for user based off their suitability responses */
export type Suitability_Portfolio = {
  __typename?: 'suitability_Portfolio'
  /** the portfolio description */
  description: Scalars['String']
  /** The portfolio ID */
  id: Scalars['ID']
  /** The portfolio name */
  name: Scalars['String']
}

/** Possible answer for a suitability question */
export type Suitability_SuitabilityAnswer = {
  __typename?: 'suitability_SuitabilityAnswer'
  /** Human readable text to display a description to an answer */
  description?: Maybe<Scalars['String']>
  /** Internal ID for a suitability answer */
  id: Scalars['ID']
  /** Value for clients to use to fetch strings */
  key: Scalars['String']
  /** Summary of an answer used for displaying why a portfolio was recommended */
  summary?: Maybe<Scalars['String']>
  /** Human readable text to display an answer to a suitability question */
  text: Scalars['String']
}

/** A user's input to update their suitabiliity */
export type Suitability_SuitabilityInput = {
  /** The question ID */
  questionId: Scalars['ID']
  /** The answer ID */
  answerId: Scalars['ID']
}

/** Suitability question asked for recommending portfolios */
export type Suitability_SuitabilityQuestion = {
  __typename?: 'suitability_SuitabilityQuestion'
  /** Default answer to the related suitability question */
  defaultAnswer?: Maybe<Suitability_SuitabilityAnswer>
  /** Internal ID for a suitability question */
  id: Scalars['ID']
  /** Value for clients to use to fetch strings */
  key: Scalars['String']
  /** Possible answers to be selected for the related question */
  possibleAnswers: Array<Suitability_SuitabilityAnswer>
  /** Human readable text to display the suitability question */
  text: Scalars['String']
}

/** A given user's suitability response for each question and answer */
export type Suitability_SuitabilityResponse = {
  __typename?: 'suitability_SuitabilityResponse'
  /** Associated answer to the suitability question */
  answer?: Maybe<Suitability_SuitabilityAnswer>
  /** Default answer to the related suitability question */
  question: Suitability_SuitabilityQuestion
}

/** Return wrapper type for the UpdateSuitability mutation */
export type Suitability_UpdateSuitabilityResult = {
  __typename?: 'suitability_UpdateSuitabilityResult'
  /** The recommended portfolio for the user's suitability responses */
  recommendedPortfolio?: Maybe<Suitability_Portfolio>
  /** Internal ID for a suitability answer */
  suitabilityResponses: Array<Suitability_SuitabilityResponse>
}

export type SuitabilityAnswer = {
  __typename?: 'SuitabilityAnswer'
  id: Scalars['ID']
  answer: Scalars['String']
}

export type SuitabilityInput = {
  questionId: Scalars['ID']
  answerId: Scalars['ID']
}

export type SuitabilityQuestion = {
  __typename?: 'SuitabilityQuestion'
  id: Scalars['ID']
  pickerId: Scalars['ID']
  placeholder: Scalars['String']
  answers: Array<Maybe<SuitabilityAnswer>>
  defaultAnswer: SuitabilityAnswer
}

export type SummaryItem = {
  __typename?: 'SummaryItem'
  amount: CurrencyAmount
  title: Scalars['String']
}

export type SupportArticle = {
  __typename?: 'SupportArticle'
  id: Scalars['ID']
  title: Scalars['String']
  body: Scalars['String']
  editedAt: Scalars['DateTime']
  sectionId: Scalars['ID']
  author: SupportAuthor
  promoted?: Maybe<Scalars['Boolean']>
  section: SupportSection
  category: SupportCategory
  private?: Maybe<Scalars['Boolean']>
}

export type SupportAuthor = {
  __typename?: 'SupportAuthor'
  id: Scalars['ID']
  name: Scalars['String']
  photo: SupportAuthorPhoto
}

export type SupportAuthorPhoto = {
  __typename?: 'SupportAuthorPhoto'
  contentUrl: Scalars['String']
}

export type SupportCategory = {
  __typename?: 'SupportCategory'
  description: Scalars['String']
  id: Scalars['ID']
  name: Scalars['String']
}

export type SupportSection = {
  __typename?: 'SupportSection'
  id: Scalars['ID']
  name: Scalars['String']
  articles: Array<Maybe<SupportArticle>>
  category: SupportCategory
  categoryId: Scalars['ID']
}

export type SupportTicket = {
  __typename?: 'SupportTicket'
  description: Scalars['String']
  id: Scalars['ID']
  subject: Scalars['String']
  url: Scalars['String']
}

export type SupportTicketForm = {
  __typename?: 'SupportTicketForm'
  id: Scalars['ID']
  displayName?: Maybe<Scalars['String']>
  ticketFields?: Maybe<Array<Maybe<SupportTicketFormField>>>
  active?: Maybe<Scalars['Boolean']>
  isDefault?: Maybe<Scalars['Boolean']>
  createdAt?: Maybe<Scalars['DateTime']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type SupportTicketFormField = {
  __typename?: 'SupportTicketFormField'
  active?: Maybe<Scalars['Boolean']>
  createdAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  id: Scalars['ID']
  required?: Maybe<Scalars['Boolean']>
  title: Scalars['String']
  type: Scalars['String']
  systemFieldOptions?: Maybe<Array<Maybe<CustomFieldOption>>>
  customFieldOptions?: Maybe<Array<Maybe<CustomFieldOption>>>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type SupportTicketResponse = SupportTicket | RecaptchaException

export type SupportTicketWithCustomFieldsResponse = SupportTicket | SubmissionError

export type SupportUser = {
  __typename?: 'SupportUser'
  name?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
}

/** Common attributes for all Switch Types */
export type SwitchInterface = {
  source: SwitchSource
  type: SwitchType
}

export enum SwitchMethod {
  /** Used clickswitch */
  Clickswitch = 'clickswitch',
  /** Used clickswitch and online */
  ClickswitchOnline = 'clickswitchOnline',
  /** Used clickswitch, online, and PDF */
  ClickswitchOnlinePdf = 'clickswitchOnlinePdf',
  /** Used clickswitch and PDF */
  ClickswitchPdf = 'clickswitchPdf',
  /** Used online */
  Online = 'online',
  /** Used online and PDF */
  OnlinePdf = 'onlinePdf',
  /** Used pdf */
  Pdf = 'pdf',
  /** Unknown */
  Unknown = 'unknown',
  /** None */
  None = 'none',
}

export type SwitchPayloadInterface = {
  userSwitch: UserSwitch
}

export enum SwitchSource {
  Acorns = 'acorns',
  ClickSwitch = 'clickSwitch',
}

export enum SwitchState {
  /** Attempted to setup direct deposit */
  Attempted = 'attempted',
  /** Completed direct deposit setup */
  Switched = 'switched',
  /** Viewed PDF screen or went to Online Portal */
  Viewed = 'viewed',
  /** User has not interacted with direct deposit in Acorns */
  NoInteraction = 'noInteraction',
}

export enum SwitchStatus {
  /** New for processing */
  New = 'new',
  /** Ready for processing */
  Ready = 'ready',
  /** Sent to ClickSwitch */
  Submitted = 'submitted',
  /** PDF generated */
  PdfGenerated = 'pdfGenerated',
  /** Deposit confirmed in Spend account */
  Completed = 'completed',
  /** PDF downloaded */
  PdfDownloaded = 'pdfDownloaded',
}

export enum SwitchType {
  /** Default PDF */
  Pdf = 'pdf',
  /** Online */
  Online = 'online',
  /** Submittable Generic */
  Submittable = 'submittable',
  /** Submittable Custom */
  SubmittableCustom = 'submittableCustom',
}

export type SyncBankFeeTransactionsInput = {
  /** UserID */
  userId: Scalars['ID']
}

export type SyncBankFeeTransactionsResult = {
  __typename?: 'SyncBankFeeTransactionsResult'
  message: Scalars['String']
}

export type SystemCardLockedSpendAlert = SpendAlert & {
  __typename?: 'SystemCardLockedSpendAlert'
  userId: Scalars['ID']
  type: Scalars['String']
}

export type TaxWithholdingAmounts = {
  __typename?: 'TaxWithholdingAmounts'
  /**  total amount that will be withheld from the feds */
  federalWithholdingAmount: MonetaryAmount
  /**  total amount that will be withheld from the state */
  stateWithholdingAmount: MonetaryAmount
}

export enum TfaNotification {
  PushNotification = 'PUSH_NOTIFICATION',
}

export type TfaOptions = {
  __typename?: 'TfaOptions'
  /** A list of phone numbers to send a TFA code. */
  phone?: Maybe<Array<Scalars['String']>>
  /** A list of emails to send a TFA code. */
  email?: Maybe<Array<Scalars['String']>>
  /** A list of questions to select from and answer. */
  question?: Maybe<Array<Scalars['String']>>
  notification?: Maybe<Array<TfaNotification>>
}

export enum TfaStatus {
  Required = 'REQUIRED',
  Failed = 'FAILED',
  Authorized = 'AUTHORIZED',
  Pending = 'PENDING',
}

export enum TfaType {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Question = 'QUESTION',
  Notification = 'NOTIFICATION',
  Pending = 'PENDING',
}

export type Tier = {
  __typename?: 'Tier'
  /** Indicates whether a tier is active or deprecated */
  active: Scalars['Boolean']
  /** Image asset path in CDN */
  assetPath?: Maybe<Scalars['String']>
  /** Associated grouping of products */
  bundles?: Maybe<Array<Bundle>>
  description: Scalars['String']
  /** Name of tier to display in certain positions where space is limited */
  displayName?: Maybe<Scalars['String']>
  /** @deprecated Use Query.products and Tier.products instead. */
  excludedProducts: Array<TierProduct>
  id: Scalars['ID']
  /** @deprecated Use Query.products and Tier.products instead. */
  includedProducts: Array<TierProduct>
  key: TierKey
  name: Scalars['String']
  /** Associated Products available when subscribed to this Tier. */
  products?: Maybe<Array<Product>>
  /**
   * (DONT USE) Internal only, may be removed without warning.
   * @deprecated Use Query.tierGroupForUser to determine the subscriber's Tier Group.
   */
  tierGroupId: Scalars['ID']
  /** Price of Tier */
  tierPrice: TierPrice
}

/** Individual action in a list of required actions */
export type TierDowngradeAction = {
  __typename?: 'TierDowngradeAction'
  key: TierDowngradeActionKey
}

/** Actions that must be taken to complete a downgrade workflow */
export enum TierDowngradeActionKey {
  CloseEarlyAccount = 'CLOSE_EARLY_ACCOUNT',
  CloseEmergencyFundAccount = 'CLOSE_EMERGENCY_FUND_ACCOUNT',
  CloseInvestAccount = 'CLOSE_INVEST_ACCOUNT',
  CloseLaterAccount = 'CLOSE_LATER_ACCOUNT',
  CloseSelfDirectedInvest = 'CLOSE_SELF_DIRECTED_INVEST',
  CloseSpendAccount = 'CLOSE_SPEND_ACCOUNT',
}

/** The list of required actions */
export type TierDowngradeActionRequired = {
  __typename?: 'TierDowngradeActionRequired'
  actions: Array<TierDowngradeAction>
}

/** Grouping of Tiers w/default tier, etc. */
export type TierGroup = {
  __typename?: 'TierGroup'
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  /** Used to key A/B test off of */
  id: Scalars['ID']
  /** Tier ID which is the "preferred" one (i.e "Acorns recommends") */
  preferredTierId: Scalars['ID']
  tierOptions: Array<TierOption>
  updatedAt: Scalars['DateTime']
  winbackTierOption?: Maybe<TierOption>
}

export enum TierKey {
  /** Hardship $1 tier for our winback campaign */
  Assist = 'ASSIST',
  /** Legacy $2 SPEND tier */
  Bronze = 'BRONZE',
  Copper = 'COPPER',
  /** Promotional tier for Cricket Wireless subscribers. */
  Cricket = 'CRICKET',
  Gold = 'GOLD',
  /** Promotional free tier for active military and veterans */
  Military = 'MILITARY',
  Null = 'NULL',
  Platinum = 'PLATINUM',
  Silver = 'SILVER',
}

/** Combination of a Tier and available prices to choose from. */
export type TierOption = {
  __typename?: 'TierOption'
  preferredTierPrice: TierPrice
  tier: Tier
  tierPrices: Array<TierPrice>
}

export type TierOptionByTierPriceIdResult = InvalidTierPriceId | TierOption

/** Pricing configuration used for a tier */
export type TierPrice = {
  __typename?: 'TierPrice'
  amount: CurrencyAmount
  billingFrequency: BillingFrequency
  id: Scalars['ID']
  /** (DONT USE) Internal only, may be removed without warning. */
  tierId: Scalars['ID']
}

/** (Deprecated) Minimal representation of an Acorns product. */
export type TierProduct = {
  __typename?: 'TierProduct'
  /** used as unique identifier for this product */
  key: ProductKey
}

/** Unique combo of Tier and TierPrice tied to a User */
export type TierSubscription = {
  __typename?: 'TierSubscription'
  /** Reference to an Promotion the subscriber is actively consuming. */
  activePromotion?: Maybe<Promotion>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<TierSubscriptionCreatedBy>
  id: Scalars['ID']
  migration?: Maybe<SubscriptionMigration>
  migrationId?: Maybe<Scalars['ID']>
  /** The Offer the subscriber subscribed to for access to their Tier. */
  offer?: Maybe<Offer>
  /** Indicates when the subscribers current Offer expires. */
  offerExpiresAt?: Maybe<Scalars['DateTime']>
  /** Indicates when a promotion was applied to the subscription. */
  promotionAppliedAt?: Maybe<Scalars['DateTime']>
  /** Indication of when a subscribers promotion ends. */
  promotionExpiresAt?: Maybe<Scalars['DateTime']>
  status: TierSubscriptionStatus
  tier: Tier
  tierPrice: TierPrice
  transition?: Maybe<TierSubscriptionTransition>
  updatedAt: Scalars['DateTime']
}

export type TierSubscriptionAlreadyDeactivated = {
  __typename?: 'TierSubscriptionAlreadyDeactivated'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type TierSubscriptionConnection = {
  __typename?: 'TierSubscriptionConnection'
  edges: Array<TierSubscription>
  pageInfo: TierSubscriptionPageInfo
}

export enum TierSubscriptionCreatedBy {
  /** Subscription created by the pre-launch backfill script */
  Backfill = 'BACKFILL',
  /** Flag to indicate user ought to be billed by the "legacy" billing system */
  LegacyUser = 'LEGACY_USER',
  /** Subscription record that was created as a result of a migration */
  Migration = 'MIGRATION',
  /** User auto-subscribed based on the status of their open accounts */
  SubscribedByOpenAccounts = 'SUBSCRIBED_BY_OPEN_ACCOUNTS',
  /** Subscription created via INTERNAL client request (either an admin or an internal process) */
  System = 'SYSTEM',
  /** Subscription created via EXTERNAL client request */
  User = 'USER',
}

/** account deactivation reasons */
export enum TierSubscriptionDeactivationReason {
  AcornsCostsTooMuch = 'ACORNS_COSTS_TOO_MUCH',
  CantAffordToInvestAtThisTime = 'CANT_AFFORD_TO_INVEST_AT_THIS_TIME',
  ConcernedAboutTheMarket = 'CONCERNED_ABOUT_THE_MARKET',
  DontWantToInvest = 'DONT_WANT_TO_INVEST',
  NotEnoughControlOverMyInvestments = 'NOT_ENOUGH_CONTROL_OVER_MY_INVESTMENTS',
  NotSureHowAcornsWorks = 'NOT_SURE_HOW_ACORNS_WORKS',
  NotTheRightTimeToInvest = 'NOT_THE_RIGHT_TIME_TO_INVEST',
  Other = 'OTHER',
  PoorInvestmentPerformance = 'POOR_INVESTMENT_PERFORMANCE',
  SwitchingToAnotherService = 'SWITCHING_TO_ANOTHER_SERVICE',
  ThisIsTemporaryIllBeBack = 'THIS_IS_TEMPORARY_ILL_BE_BACK',
  TroubleConnectingMyBank = 'TROUBLE_CONNECTING_MY_BANK',
  UnexpectedChargesToMyBank = 'UNEXPECTED_CHARGES_TO_MY_BANK',
}

export type TierSubscriptionForUser =
  | TierSubscription
  | TierSubscriptionNotFound
  | TierSubscriptionUnsubscribed

/** Returned if there is no found tier subscription */
export type TierSubscriptionNotFound = {
  __typename?: 'TierSubscriptionNotFound'
  message: Scalars['String']
}

/** Metadata for pagination of Tier Subscription History */
export type TierSubscriptionPageInfo = {
  __typename?: 'TierSubscriptionPageInfo'
  cursor?: Maybe<Scalars['String']>
  hasNext: Scalars['Boolean']
}

/** Status of a tier subscription */
export enum TierSubscriptionStatus {
  /** An active subscription */
  Active = 'ACTIVE',
  /** A cancelled subscription */
  Inactive = 'INACTIVE',
  /** In the process of either upgrading or downgrading a subscription */
  Transitioning = 'TRANSITIONING',
}

/** Information about a transitioning subscription */
export type TierSubscriptionTransition = {
  __typename?: 'TierSubscriptionTransition'
  desiredTier?: Maybe<Tier>
  /**
   * Once we've decoupled our Tier and TierPrice, we'll need to make sure we're
   * subscribing the user to the proper Tier and TierPrice
   */
  desiredTierPrice?: Maybe<TierPrice>
  initiatedAt: Scalars['DateTime']
  subscriptionDeactivationReason?: Maybe<TierSubscriptionDeactivationReason>
  transitionAction: SubscriptionTransitionAction
}

/** User has unsubscribed from their tier (account closed) */
export type TierSubscriptionUnsubscribed = {
  __typename?: 'TierSubscriptionUnsubscribed'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type TimestampsInterface = {
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** Details for tips */
export type Tip = {
  __typename?: 'Tip'
  body: Scalars['String']
  image?: Maybe<Image>
  title?: Maybe<Scalars['String']>
}

export type Toggle = {
  __typename?: 'Toggle'
  id: Scalars['String']
  value: Scalars['Boolean']
  invalid?: Maybe<Scalars['Boolean']>
}

export type TokenExpiredException = {
  __typename?: 'TokenExpiredException'
  message?: Maybe<Scalars['String']>
}

/** Top Employer Name and Logo */
export type TopEmployer = {
  __typename?: 'TopEmployer'
  /** Employer Name */
  employerName: Scalars['String']
  /** Employer switch type */
  employerSwitchType: SwitchType
  /** Employer Logo URL */
  logo: Scalars['String']
  /** Employer online URL */
  onlineSwitchUrl?: Maybe<Scalars['String']>
}

/** Top Employer List */
export type TopEmployerPayload = {
  __typename?: 'TopEmployerPayload'
  topEmployersList: Array<TopEmployer>
}

export type TopHolding = {
  __typename?: 'TopHolding'
  symbol?: Maybe<Scalars['TickerSymbol']>
  securityName: Scalars['String']
  /** The number of shares that this security makes up of the ETF */
  numberOfShares?: Maybe<Scalars['BigDecimal']>
  /** The percentage of shares that this security makes up of the ETF */
  sharePercentage: Scalars['BigDecimal']
  /** The market value that this security makes up of the ETF */
  marketValue: BigCurrencyAmount
}

export type TotalAmounts = {
  __typename?: 'TotalAmounts'
  totalContributedAmount: CurrencyAmount
  totalDepositedAmount: CurrencyAmount
}

export enum TradingSector {
  BasicMaterials = 'BASIC_MATERIALS',
  CommunicationServices = 'COMMUNICATION_SERVICES',
  ConsumerCyclical = 'CONSUMER_CYCLICAL',
  ConsumerDefensive = 'CONSUMER_DEFENSIVE',
  Energy = 'ENERGY',
  FinancialServices = 'FINANCIAL_SERVICES',
  HealthCare = 'HEALTH_CARE',
  Industrials = 'INDUSTRIALS',
  RealEstate = 'REAL_ESTATE',
  Technology = 'TECHNOLOGY',
  Utilities = 'UTILITIES',
}

export enum TransactionCategory {
  Fee = 'FEE',
  Refund = 'REFUND',
}

export type TransactionResult = {
  __typename?: 'TransactionResult'
  id: Scalars['String']
}

/** Transfer transactions object */
export type Transfer = {
  __typename?: 'Transfer'
  id: Scalars['ID']
  amount: CurrencyAmount
  state: TransferState
  from: TransferableAccount
  to: TransferableAccount
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** When this was cancelled. NULL if never cancelled */
  canceledAt?: Maybe<Scalars['DateTime']>
}

export type TransferableAccount = {
  __typename?: 'TransferableAccount'
  id: Scalars['ID']
  /** The name of the account. e.g. Chase Checking */
  name: Scalars['String']
  /** The type of Acorns account we are tracking for the user */
  type: TransferableAccountTypeEnum
  /**
   * A snapshot of the accounts last balance if available to acorns. External
   * accounts wont have this. This is the value of the AVAILABLE balance.
   */
  balance?: Maybe<CurrencyAmount>
  /** The last 4 digits of the account or null if unavailable */
  accountNumberMasked?: Maybe<Scalars['String']>
  /** Whether an account is linked from plaid, spend, paypal, direct_bank or manual */
  externalSource?: Maybe<ExternalSource>
}

export enum TransferableAccountTypeEnum {
  Spend = 'spend',
  Save = 'save',
  Core = 'core',
  External = 'external',
  Later = 'later',
  Early = 'early',
}

/** Info on accounts that can be transferred from */
export type TransferableFrom = {
  __typename?: 'TransferableFrom'
  from: TransferableAccount
}

/** Info about accounts that can be transferred to */
export type TransferableTo = {
  __typename?: 'TransferableTo'
  to: TransferableAccount
  /** This field will be null if there is no max limit */
  min?: Maybe<CurrencyAmount>
  /** This field will be null if there is no max limit */
  max?: Maybe<CurrencyAmount>
}

export type TransferInternalSharesInput = {
  idempotencyKey: Scalars['String']
  shareTransferType: ShareTransferType
  internalShareTransfer: Array<InternalShareTransferInput>
}

export type TransferInternalSharesResult = OmnibusShareTransferId | InternalShareTransferFailed

export enum TransferState {
  Initiated = 'initiated',
  Transferring = 'transferring',
  Completed = 'completed',
  Canceled = 'canceled',
}

export type TrendingLearnContentPreview =
  | LearnArticlePreview
  | LearnArticlePreviewLocked
  | LearnMediaPreview
  | LearnMediaPreviewLocked

export type UnableToCancelCheckError = {
  __typename?: 'UnableToCancelCheckError'
  requestId: Scalars['ID']
}

/** Input for unauthenticated creation of an upload url for direct to s3 upload */
export type UnauthenticatedCreateUploadUrlInput = {
  /** the suspended upload token of the user uploading a document */
  token: Scalars['String']
  /** the file_name upload document */
  fileName: Scalars['String']
  /** the document type of the upload document */
  documentType: DocumentType
}

/** Input for saving an upload url after direct to s3 upload */
export type UnauthenticatedSaveUploadUrlInput = {
  /** the upload uuid from the upload object */
  uploadUuids: Array<Scalars['ID']>
  /** the suspended upload token of the user uploading a document */
  token: Scalars['String']
}

/** LegacyUploadDocumentResult */
export type UnauthenticatedSaveUploadUrlResult = DocumentUploads | UploadSaveError

export type UnauthorizedException = {
  __typename?: 'UnauthorizedException'
  message?: Maybe<Scalars['String']>
}

export type UnblockDeviceInput = {
  deviceId: Scalars['ID']
}

/** unblockDevice results */
export type UnblockDeviceResult = Device | DeviceNotFoundException

/** Unknown provider */
export type UnknownProvider = {
  __typename?: 'UnknownProvider'
  cta: Cta
  image: Image
  subtitle?: Maybe<Scalars['String']>
}

export type UnlockBankCardPayload = {
  __typename?: 'UnlockBankCardPayload'
  bankCard?: Maybe<BankCard>
}

export type UnmarkLearnContentAsHelpfulInput = {
  contentId: Scalars['ID']
}

export type UnmarkLearnContentAsHelpfulResult =
  | UpdateLearnContentHelpfulnessResult
  | RecordDoesNotExistError

/** The LinkedAccount associated with the linked_account_id will never be valid with the external provider */
export type UnrecoverableLinkedAccountError = {
  __typename?: 'UnrecoverableLinkedAccountError'
  /** ID of the unrecoverable LinkedAccount */
  linkedAccountId: Scalars['ID']
}

export type UnsubscribeUserFromTierInput = {
  /** Deprecated */
  createdBy?: Maybe<TierSubscriptionCreatedBy>
}

export type UnsubscribeUserFromTierResult =
  | TierDowngradeActionRequired
  | TierSubscriptionUnsubscribed

/** The associated beneficiary does not have a verified SSN */
export type UnverifiedBeneficiarySsnAlert = Alert & {
  __typename?: 'UnverifiedBeneficiarySsnAlert'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /**
   * Internal ID of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  beneficiaryId: Scalars['ID']
  /**
   * First name of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  firstName: Scalars['String']
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String']
  userId: Scalars['ID']
}

/** The associated beneficiary does not have a verified SSN */
export type UnverifiedBeneficiarySsnAlertItem = UserAlertsItem & {
  __typename?: 'UnverifiedBeneficiarySsnAlertItem'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Source attribute object containing properties that can be updated. */
export type UpdatableAttributesInput = {
  /** Name of targeted group for ad in Adjust */
  adGroup?: Maybe<Scalars['String']>
  /** Name of campaign in Adjust */
  campaign?: Maybe<Scalars['String']>
  /** Click label of install with referral ID in Adjust */
  clickLabel?: Maybe<Scalars['String']>
  /** Creative content name in Adjust */
  creative?: Maybe<Scalars['String']>
  /** Name of funnel user wants to experience */
  funnel?: Maybe<FunnelName>
  /** Identifier for the prospect's attribution channel */
  sourceID?: Maybe<Scalars['String']>
  /** Full name of tracker in Adjust */
  trackerName?: Maybe<Scalars['String']>
  /** Six character token ID in Adjust */
  trackerToken?: Maybe<Scalars['String']>
}

export type UpdateAccountPointsRuleInput = {
  /** detailed explanation about how points are earned */
  details?: Maybe<Scalars['String']>
  milestoneID: Scalars['ID']
  /** number of points earned per completion */
  pointsPerCompletion?: Maybe<Scalars['Int']>
  /** summarized explanation about how points are earned */
  summary?: Maybe<Scalars['String']>
}

export type UpdateAccountPointsRuleResult =
  | RecordAlreadyExistsError
  | RecordDoesNotExistError
  | AccountPointsRule

/** Input to update account portfolio */
export type UpdateAccountPortfolioInput = {
  /** Portfolio Risk Type */
  riskLevel: PortfolioRiskLevel
  /** Portfolio theme */
  theme: PortfolioTheme
  /** Investment account ID */
  investmentAccountId: Scalars['ID']
}

/** Update Account Portfolio Response */
export type UpdateAccountPortfolioResponse =
  | InvalidActionOnAccount
  | InvestmentAccount
  | InvestmentAccountNotFoundException
  | PortfolioNotFoundException
  | PortfolioUpdateFailedException

export type UpdateAttributionInput = {
  /** Email address for prospect used during initial sign-up */
  email?: Maybe<Scalars['String']>
  /** Contextual attributes representing parameters surrounding user sign-up */
  sourceAttributes: UpdatableAttributesInput
  /** Unique user identifier */
  userId?: Maybe<Scalars['ID']>
}

/** Union for the result of the updateAttribution mutation */
export type UpdateAttributionResult =
  | InvalidConversionIdentifierException
  | InvalidSourceAttributesException
  | NoProspectRecord
  | RegistrationFunnel

export type UpdateAuthEmailInput = {
  email: Scalars['EmailAddress']
}

export type UpdateAuthEmailResult = AuthProfile | ExistingEmailVerifiedException

export type UpdateAuthPhoneNumberInput = {
  phoneNumber: Scalars['PhoneNumber']
}

export type UpdateAuthPhoneNumberResult =
  | AuthProfile
  | InvalidPhoneNumberException
  | ExistingPhoneVerifiedException

export type UpdateBankAccountGoalInput = {
  accountId: Scalars['ID']
  currentGoal: BankAccountGoalInput
}

export type UpdateBankAccountGoalPayload = {
  __typename?: 'UpdateBankAccountGoalPayload'
  requestId: Scalars['ID']
}

export type UpdateBankAccountGoalResult = UpdateBankAccountGoalPayload

export type UpdateBankCardPinInput = {
  newPin: Scalars['BankCardPin']
}

export type UpdateBankCardPinPayload = {
  __typename?: 'UpdateBankCardPinPayload'
  bankCard?: Maybe<BankCard>
}

/** Response to a beneficiary update */
export type UpdateBeneficiaryInfoResult =
  | Beneficiary
  | BeneficiaryNotFoundException
  | InternalErrorException
  | InvalidAddressException
  | InvalidEmailException
  | InvalidPhoneException

/** Return type for the ProtectUpdateCoverage mutation */
export type UpdateCoverageResponse = {
  __typename?: 'UpdateCoverageResponse'
  success: Scalars['Boolean']
}

/** updateCredentials results */
export type UpdateCredentialsResult =
  | Credentials
  | EmailTakenException
  | BlockedEmailDomainException
  | UserCredentialsNotFoundException

export type UpdateElapsedTimeForLearnQuizInput = {
  elapsedTimeMilliseconds: MillisecondsInput
  quizId: Scalars['ID']
}

export type UpdateElapsedTimeForLearnQuizResult =
  | LearnContentElapsedMillisecondsUpdatedResult
  | RecordDoesNotExistError

export type UpdateLearnContentHelpfulnessResult = {
  __typename?: 'UpdateLearnContentHelpfulnessResult'
  contentId: Scalars['ID']
  isHelpful: Scalars['Boolean']
}

export type UpdateLearnProgressInput = {
  contentId: Scalars['ID']
  contentProgress: LearnProgressInput
}

export type UpdateLearnProgressResult = LearnProgressUpdatedResult | RecordDoesNotExistError

/** Attributes for updating the linked account */
export type UpdateLinkedAccountInput = {
  /** Plaid link session id */
  linkSessionId: Scalars['String']
}

export type UpdateMessageFailed = {
  __typename?: 'UpdateMessageFailed'
  errorMessage: Scalars['String']
}

export type UpdateMessageIgnored = {
  __typename?: 'UpdateMessageIgnored'
  requestId: Scalars['ID']
}

export type UpdateMessageResult = AlertMessage | NotificationMessage | UpdateMessageIgnored

export type UpdateMilestoneAccountLevelDefinitionInput = {
  /** what is the background image when active */
  activeBackgroundUrl?: Maybe<Scalars['String']>
  /** what is the foreground image when active */
  activeForegroundUrl?: Maybe<Scalars['String']>
  /** level id, e.g. 3 */
  id: Scalars['Int']
  /** what is the background image when inactive */
  inactiveBackgroundUrl?: Maybe<Scalars['String']>
}

export type UpdateMilestoneAccountLevelDefinitionResult =
  | MilestoneAccountLevelDefinition
  | RecordDoesNotExistError

export type UpdateMilestoneChallengeDefinitionInput = {
  /** additional information about this challenge */
  details?: Maybe<Scalars['String']>
  id: Scalars['ID']
  logo?: Maybe<ImageInput>
  /** descriptive identifier */
  name: Scalars['String']
}

export type UpdateMilestoneChallengeDefinitionResult =
  | MilestoneChallengeDefinition
  | RecordDoesNotExistError

export type UpdateMilestoneChallengePointsRuleInput = {
  challengeID: Scalars['ID']
  /** legal copy about how points are earned */
  earningDetails?: Maybe<Scalars['String']>
  /** summarized information about how points are earned */
  earningSummary?: Maybe<Scalars['String']>
  milestoneID: Scalars['ID']
}

export type UpdateMilestoneChallengePointsRuleResult =
  | MilestoneChallengePointsRule
  | RecordDoesNotExistError

export type UpdateMilestoneDefinitionInput = {
  id: Scalars['ID']
  /** an optional logo used for inactive milestone states (e.g. LOCKED, NOT_STARTED) */
  inactiveLogo?: Maybe<ImageInput>
  /** default logo */
  logo?: Maybe<ImageInput>
  /** descriptive identifier */
  name?: Maybe<Scalars['String']>
}

export type UpdateMilestoneDefinitionResult = MilestoneDefinition | RecordDoesNotExistError

/** Input for updatePortfolioSecurities */
export type UpdatePortfolioSecuritiesInput = {
  /** Investment Account ID */
  investmentAccountId: Scalars['ID']
  /** Portfolio ID */
  portfolioId: Scalars['ID']
  /** List of Securities and their target allocation percent */
  securityAllocations: Array<SecurityAllocationTarget>
}

/** Result of updating a portfolio's securities */
export type UpdatePortfolioSecuritiesResult =
  | CustomerAgreementRequiredException
  | InvalidAllocationPercentError
  | InvalidSecurityError
  | InvalidSecurityForAllocationError
  | InvestmentAccount
  | LiquidationUnavailableError
  | NegativeSecurityPercentError
  | PortfolioSecurityLimitReached

/** Return type for ProtectUpdateRecommendedLifeCoverage mutation */
export type UpdateRecommendedCoverageResponse = {
  __typename?: 'UpdateRecommendedCoverageResponse'
  success: Scalars['Boolean']
}

/** Returned if failure updating reward */
export type UpdateReferralRewardError = {
  __typename?: 'UpdateReferralRewardError'
  message: Scalars['String']
}

export type UpdateReferralRewardResponse = ReferralRewardSummary | UpdateReferralRewardError

export type UpdateSecurityQuestionAndAnswerInput = {
  questionId: Scalars['ID']
  answer: Scalars['String']
}

export type UpdateSecurityQuestionAndAnswerResult =
  | UpdateSecurityQuestionAndAnswerSuccess
  | InvalidSecurityQuestionException

export type UpdateSecurityQuestionAndAnswerSuccess = {
  __typename?: 'UpdateSecurityQuestionAndAnswerSuccess'
  userId: Scalars['ID']
  questionId: Scalars['ID']
  questionText: Scalars['String']
}

export type UpdateUserInfoResult = User | SsnUsedError | InvalidSsnError | PoBoxAddressError

export type UpgradeAuthenticationResult =
  | AuthSession
  | AuthenticationAlreadyUpgradedException
  | UserCredentialsNotFoundException

/** Uploads a check image to the provided session. */
export type UploadCheckInput = {
  checkImage: CheckImage
  /** The session the image will be uploaded to. */
  sessionToken: Scalars['String']
}

/** Response from uploading a check image. */
export type UploadCheckPayload = {
  __typename?: 'UploadCheckPayload'
  /** Session image was uploaded to. */
  sessionToken: Scalars['String']
}

export type UploadDocumentsInput = {
  documentRequestId: Scalars['ID']
  documents: Array<Scalars['Upload']>
  documentType: DocumentType
}

/** The upload does not exist. Must call CreateUploadUrl first. */
export type UploadDoesNotExist = {
  __typename?: 'UploadDoesNotExist'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** The upload does not exist. Must call CreateUploadUrl first. */
export type UploadDoesNotExistError = {
  __typename?: 'UploadDoesNotExistError'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The upload uuid */
  uploadUuid?: Maybe<Scalars['ID']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

export type UploadFailedError = {
  __typename?: 'UploadFailedError'
  message: Scalars['String']
}

/** Errors from backend upload */
export type UploadSaveError = {
  __typename?: 'UploadSaveError'
  uploadExceptions: Array<UploadSaveExceptions>
}

/** Exceptions from upload error */
export type UploadSaveExceptions = FileDoesNotExistError | UploadDoesNotExistError

export type UploadUnsolicitedDocumentsInput = {
  documents: Array<Scalars['Upload']>
  documentType: DocumentType
  /** Idempotency key for ensuring that duplicate requests are not made */
  requestKey?: Maybe<Scalars['String']>
  status?: Maybe<DocumentStatus>
}

/** An upload url */
export type UploadUrl = {
  __typename?: 'UploadUrl'
  key: Scalars['String']
  policy: Scalars['String']
  uploadUuid: Scalars['ID']
  url: Scalars['String']
  userId: Scalars['ID']
  xAmzAlgorithm: Scalars['String']
  xAmzCredential: Scalars['String']
  xAmzDate: Scalars['String']
  xAmzSecurityToken: Scalars['String']
  xAmzSignature: Scalars['String']
}

export type User = {
  __typename?: 'User'
  uuid: Scalars['ID']
  email: Scalars['String']
  phoneNumber?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  dob?: Maybe<Scalars['String']>
  usCitizen?: Maybe<Scalars['Boolean']>
  employer?: Maybe<Scalars['String']>
  occupation?: Maybe<Scalars['String']>
  verified?: Maybe<Scalars['Boolean']>
  pinCreated?: Maybe<Scalars['Boolean']>
  registrationComplete?: Maybe<Scalars['Boolean']>
  registrationCompletedAt?: Maybe<Scalars['DateTime']>
  sourceId?: Maybe<Scalars['String']>
  closedAt?: Maybe<Scalars['DateTime']>
  address1?: Maybe<Scalars['String']>
  address2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['USStateName']>
  zip?: Maybe<Scalars['String']>
  fundingSource?: Maybe<FundingSource>
  fundingSourceCanChange?: Maybe<Scalars['Boolean']>
  fundingSourceChangeRequiresApproval?: Maybe<Scalars['Boolean']>
  portfolio?: Maybe<Portfolio>
  uploads: Array<UserUpload>
  pendingBalance?: Maybe<Scalars['Float']>
  currentBalance: Scalars['Float']
  allocationProfileId?: Maybe<Scalars['ID']>
  recommendedAllocationProfileId?: Maybe<Scalars['ID']>
  /** @deprecated Field no longer supported */
  employedAffiliatedWithBrokerDealer?: Maybe<Scalars['Boolean']>
  /** @deprecated Field no longer supported */
  shareholderOrDirector?: Maybe<Scalars['Boolean']>
  /** @deprecated Field no longer supported */
  subjectToBackupWithholding?: Maybe<Scalars['Boolean']>
  /** @deprecated Field no longer supported */
  securityQuestion: SecurityQuestion
  /** @deprecated Use Query.suitabilityResponses instead. */
  suitability?: Maybe<Array<Maybe<Suitability>>>
  /** @deprecated Field no longer supported */
  referralCode?: Maybe<Scalars['String']>
  /** @deprecated Use Query.userAlerts instead. */
  alerts?: Maybe<Array<Maybe<UserAlert>>>
  /** @deprecated Highly non-performant! */
  totals: UserTotals
  /** @deprecated Highly non-performant! */
  dailyChange?: Maybe<UserDailyChange>
  /** @deprecated Use RoundUpProfile.roundUpTotal instead. */
  roundUps: UserRoundUps
  /** @deprecated Use Profile.maritalStatus instead. */
  maritalStatus?: Maybe<MaritalStatusType>
  investmentAccounts?: Maybe<Array<InvestmentAccount>>
}

/** Object representing an acorns user */
export type User_V2 = {
  __typename?: 'User_v2'
  closedAt?: Maybe<Scalars['Date']>
  email: Scalars['String']
  uuid: Scalars['ID']
}

/** A user alert. */
export type UserAlert = UserAlertsItem & {
  __typename?: 'UserAlert'
  id: Scalars['ID']
  /** The type of the alert */
  type: Scalars['String']
  key: Scalars['String']
  title: Scalars['String']
  description: Scalars['String']
  metadata?: Maybe<Scalars['String']>
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type UserAlertsItem = {
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Response from user alert query */
export type UserAlertsResponse =
  | AddressDocumentRequestedUserAlert
  | BankDocumentRequestedUserAlert
  | IdentityDocumentRequestedUserAlert
  | InsufficientFundsUserAlert
  | InvestmentsPausedUserAlert
  | MiscDocumentRequestedUserAlert
  | NoFundingSourceUserAlert
  | RdvRequiredUserAlert
  | SsnDocumentRequestedUserAlert
  | UserAlert
  | W9DocumentRequestedUserAlert

export type UserCardLockedSpendAlert = SpendAlert & {
  __typename?: 'UserCardLockedSpendAlert'
  userId: Scalars['ID']
  type: Scalars['String']
}

/** The provided user is closed */
export type UserClosedException = {
  __typename?: 'UserClosedException'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The provided user id */
  userId?: Maybe<Scalars['ID']>
}

export type UserCredentialsInput = {
  email: Scalars['EmailAddress']
}

export type UserCredentialsNotFoundException = {
  __typename?: 'UserCredentialsNotFoundException'
  message?: Maybe<Scalars['String']>
}

export type UserDailyChange = {
  __typename?: 'UserDailyChange'
  accountChange?: Maybe<Scalars['Float']>
  accountPercent?: Maybe<Scalars['Float']>
  change?: Maybe<Scalars['Float']>
  percentage?: Maybe<Scalars['Float']>
  marketChange?: Maybe<Scalars['Float']>
  marketPercent?: Maybe<Scalars['Float']>
}

/** A reopen check for an investment account reopen request. */
export type UserInvestmentAccountReopenCheck = TimestampsInterface & {
  __typename?: 'UserInvestmentAccountReopenCheck'
  /** The ID of the reopen request to which this check belongs. */
  accountReopenRequestId: Scalars['Int']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The UUID of the investment account for which this check was made. */
  investmentAccountId: Scalars['ID']
  /** A boolean indicating whether this check passed or failed.  */
  passed: Scalars['Boolean']
  /** The check type. */
  reopenCheckType: InvestmentAccountReopenCheck
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** UUID of the user to whom the account the reopen request was made for belongs. */
  userUuid: Scalars['ID']
}

export type UserLockedException = {
  __typename?: 'UserLockedException'
  message?: Maybe<Scalars['String']>
}

/** No user was found for the ID provided */
export type UserNotFound = {
  __typename?: 'UserNotFound'
  /** The provided user id */
  userId?: Maybe<Scalars['ID']>
}

/** No user was found for the ID provided */
export type UserNotFoundException = {
  __typename?: 'UserNotFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The provided user id */
  userId?: Maybe<Scalars['ID']>
}

/** Custodian must be verified in order to open an Early Account */
export type UserNotVerifiedException = {
  __typename?: 'UserNotVerifiedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type UserPartnerStatusResponse = {
  __typename?: 'UserPartnerStatusResponse'
  message: Scalars['String']
}

/** The provided user is locked */
export type UserReopenLockedException = {
  __typename?: 'UserReopenLockedException'
  /** The date the user was locked */
  lockedAt: Scalars['DateTime']
  /** The provided user id */
  userId?: Maybe<Scalars['ID']>
}

/** The provided user is suspended */
export type UserReopenSuspendedException = {
  __typename?: 'UserReopenSuspendedException'
  /** The date the user was suspended */
  suspendedAt: Scalars['DateTime']
  /** The reason the user was suspended */
  suspendedReason?: Maybe<Scalars['String']>
  /** The provided user id */
  userId?: Maybe<Scalars['ID']>
}

export type UserRoundUps = {
  __typename?: 'UserRoundUps'
  total: Scalars['Float']
  waiting: Scalars['Float']
}

export type UserStatus = {
  __typename?: 'UserStatus'
  userId: Scalars['String']
  closed: Scalars['Boolean']
  closedAt?: Maybe<Scalars['DateTime']>
  verified: Scalars['Boolean']
  verifiedAt?: Maybe<Scalars['DateTime']>
  registrationComplete: Scalars['Boolean']
  registrationCompleteAt?: Maybe<Scalars['DateTime']>
}

export type UserSuspendedException = {
  __typename?: 'UserSuspendedException'
  message?: Maybe<Scalars['String']>
  suspensionReasonValid?: Maybe<Scalars['Boolean']>
}

/** Token has incorrect length */
export type UserSuspendedUploadTokenLengthError = {
  __typename?: 'UserSuspendedUploadTokenLengthError'
  /** expected length of token */
  length: Scalars['Int']
}

/** Validation response for suspended upload token */
export type UserSuspendedUploadTokenValidation = {
  __typename?: 'UserSuspendedUploadTokenValidation'
  reason: Scalars['String']
  tokenValid: Scalars['Boolean']
}

/** Describes a user request for a direct deposit switch. */
export type UserSwitch = {
  __typename?: 'UserSwitch'
  /** Creation Date */
  createdAt: Scalars['String']
  /** Switch ID */
  id: Scalars['ID']
  /** Indicates whether the user is already depositing on the Spend account or not. */
  isComplete: Scalars['Boolean']
  /** Status of the direct deposit switch. */
  status: SwitchStatus
  /** Switch Type */
  switchType: SwitchType
  /** Last Updated Date */
  updatedAt: Scalars['String']
  /** User ID */
  userId: Scalars['ID']
  /** Switch ID provided by the vendor. */
  vendorSwitchId?: Maybe<Scalars['ID']>
}

export type UserTotals = {
  __typename?: 'UserTotals'
  totalInvested?: Maybe<Scalars['Float']>
  totalDeposits?: Maybe<Scalars['Float']>
  totalWithdrawn?: Maybe<Scalars['Float']>
  totalDividends?: Maybe<Scalars['Float']>
  totalFees?: Maybe<Scalars['Float']>
  totalReferrals?: Maybe<Scalars['Float']>
  totalFoundMoney?: Maybe<Scalars['Float']>
  totalGainLoss?: Maybe<Scalars['Float']>
  totalOtherRewards?: Maybe<Scalars['Float']>
  /** @deprecated Use RoundUpProfile.roundUpTotal instead. */
  totalRoundUps?: Maybe<Scalars['Float']>
}

export type UserUpload = {
  __typename?: 'UserUpload'
  id: Scalars['ID']
  documentType?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
}

export type UserWinbackErrors = {
  __typename?: 'userWinbackErrors'
  message?: Maybe<Scalars['String']>
  error?: Maybe<Scalars['String']>
}

export type UserWinbackScore = {
  __typename?: 'userWinbackScore'
  userId?: Maybe<Scalars['String']>
  churnProbability?: Maybe<Scalars['Float']>
  predictedRevenue?: Maybe<Scalars['Float']>
}

export type UserWinbackScoreRes = UserWinbackScore | UserWinbackErrors

export enum UsStateCodes {
  /** Alabama */
  Al = 'AL',
  /** Alaska */
  Ak = 'AK',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** Arkansas */
  Ar = 'AR',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** Delaware */
  De = 'DE',
  /** District Of Columbia */
  Dc = 'DC',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Florida */
  Fl = 'FL',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Iowa */
  Ia = 'IA',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Maryland */
  Md = 'MD',
  /** Massachusetts */
  Ma = 'MA',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Mississippi */
  Ms = 'MS',
  /** Missouri */
  Mo = 'MO',
  /** Montana */
  Mt = 'MT',
  /** Nebraska */
  Ne = 'NE',
  /** Nevada */
  Nv = 'NV',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** New York */
  Ny = 'NY',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Palau */
  Pw = 'PW',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Vermont */
  Vt = 'VT',
  /** U.S. Virgin Islands */
  Vi = 'VI',
  /** Virginia */
  Va = 'VA',
  /** Washington */
  Wa = 'WA',
  /** West Virginia */
  Wv = 'WV',
  /** Wisconsin */
  Wi = 'WI',
  /** Wyoming */
  Wy = 'WY',
  /** Armed Forces America */
  Aa = 'AA',
  /** Armed Forces Europe */
  Ae = 'AE',
  /** Armed Forces Pacific */
  Ap = 'AP',
}

export type ValidatePasswordResetTokenResult =
  | ValidatePasswordResetTokenSuccess
  | InvalidPasswordResetTokenException

export type ValidatePasswordResetTokenSuccess = {
  __typename?: 'ValidatePasswordResetTokenSuccess'
  displaySsnField: Scalars['Boolean']
}

/** Input for validating a user suspended upload token */
export type ValidateUserSuspendedUploadTokenInput = {
  /** Upload token */
  token: Scalars['String']
}

/** Result from validating document uploader token */
export type ValidateUserSuspendedUploadTokenResult =
  | UserSuspendedUploadTokenLengthError
  | UserSuspendedUploadTokenValidation

export type VerifyCheckPaymentRecipientAddressInputType = {
  recipient: CheckPaymentRecipientInput
  recipientAddress: CheckPaymentAddressInput
}

/** Address deliverable by mail carrier or InvalidAddressError */
export type VerifyCheckPaymentRecipientAddressResult =
  | CheckPaymentRecipientAddressType
  | InvalidAddressError
  | AuthorizationError

export type VerifyDeviceInput = {
  deviceId: Scalars['ID']
}

/** verifyDevice results */
export type VerifyDeviceResult = SmsAuthChallenge | EmailAuthChallenge | DeviceNotFoundException

export type VerifyPasswordsInput = {
  oldPassword: Scalars['String']
  newPassword: Scalars['String']
}

/** verifyPasswords results */
export type VerifyPasswordsResult =
  | VerifyPasswordsSuccess
  | IncorrectOldPasswordException
  | SamePasswordsException
  | InvalidPasswordException
  | UnauthorizedException

export type VerifyPasswordsSuccess = {
  __typename?: 'VerifyPasswordsSuccess'
  isValid: Scalars['Boolean']
}

export type VersionMismatchException = {
  __typename?: 'VersionMismatchException'
  latestVersion?: Maybe<Scalars['ID']>
}

export type ViewedLearnContentResult = {
  __typename?: 'ViewedLearnContentResult'
  contentId: Scalars['ID']
}

/** W9 document requested. */
export type W9DocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'W9DocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** URLs for linked account webhooks */
export type Webhooks = {
  __typename?: 'Webhooks'
  /** URL for plaid webhooks */
  plaid: Scalars['String']
}

/** A URL which represents the location of the account linking source the client should use. */
export type WebviewLinkSession = {
  __typename?: 'WebviewLinkSession'
  /** The URL a client should use for account linking. */
  url: Scalars['URL']
}

export enum WidgetReferenceType {
  /** Protect Context */
  ProtectContext = 'protect_context',
  /** Protect Onboarding Questions */
  ProtectOnboarding = 'protect_onboarding',
  /** Onboarding Results/Recommendations */
  ProtectRecommendations = 'protect_recommendations',
  /** Protect Home page */
  ProtectHome = 'protect_home',
  /** Protect Provider Search */
  ProtectProviders = 'protect_providers',
  /** Protect Insurance Home */
  ProtectInsuranceHome = 'protect_insurance_home',
  /** Protect Coverage Shop */
  ProtectCoverageShop = 'protect_coverage_shop',
  /** Auto Insurance Offer Query */
  ProtectAutoInsurance = 'protect_auto_insurance',
  /** Life Insurance Offer Query */
  ProtectLifeInsurance = 'protect_life_insurance',
  /** Renters Insurance Offer Query */
  ProtectRentersInsurance = 'protect_renters_insurance',
  /** Home Insurance Offer Query */
  ProtectHomeInsurance = 'protect_home_insurance',
  /** Pet Insurance Offer Query */
  ProtectPetInsurance = 'protect_pet_insurance',
}

/** Withdrawal Investment Object */
export type Withdrawal = {
  __typename?: 'Withdrawal'
  amount: Scalars['Float']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  presentableWithdrawalStatus: PresentableWithdrawalStatus
}

export type WithholdingDefaults = {
  __typename?: 'WithholdingDefaults'
  federalWithholdingPercentage: Scalars['Float']
  stateWithholdingPercentage: Scalars['Float']
  showStateWithholdingField: Scalars['Boolean']
  showFederalWithholdingField: Scalars['Boolean']
}

export type WithholdingEstimates = {
  __typename?: 'WithholdingEstimates'
  /**  estimated amount that will be delivered to the customer */
  estimatedCustomerAmount: MonetaryAmount
  /**  estimated total amount that will be withheld for federal taxes */
  estimatedFederalWithholdingAmount: MonetaryAmount
  /**  estimated total amount that will be withheld for state taxes */
  estimatedStateWithholdingAmount: MonetaryAmount
  /**  estimated earnings that will be taxed */
  estimatedTaxableEarnings: MonetaryAmount
  /**  estimated total amount that will be withheld (state and federal) */
  estimatedTotalWithholdingAmount: MonetaryAmount
}

export type YearLaterReport = {
  __typename?: 'YearLaterReport'
  accountBalance: Scalars['Float']
  accountCreationDate: Scalars['String']
  accountPerformance: Scalars['Float']
  accountType: Scalars['String']
  firstDepositAmountForYear?: Maybe<Scalars['Float']>
  firstDepositDateForYear?: Maybe<Scalars['String']>
  recurringContributionAmount: Scalars['Float']
  recurringContributionFrequency?: Maybe<InvestmentFrequency>
  totalDeposits: Scalars['Float']
  totalDepositsForYear: Scalars['Float']
  totalDividends: Scalars['Float']
  totalNetReturns: Scalars['Float']
  totalWithdrawals: Scalars['Float']
  userAge: Scalars['Int']
}

export type ResolverTypeWrapper<T> = Promise<T> | T

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>
}

export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>
}

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>
}
export type StitchingResolver<TResult, TParent, TContext, TArgs> =
  | LegacyStitchingResolver<TResult, TParent, TContext, TArgs>
  | NewStitchingResolver<TResult, TParent, TContext, TArgs>
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => Promise<TResult> | TResult

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs
> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {}
> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo,
) => Maybe<TTypes> | Promise<Maybe<TTypes>>

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo,
) => boolean | Promise<boolean>

export type NextResolverFn<T> = () => Promise<T>

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Query: ResolverTypeWrapper<{}>
  User: ResolverTypeWrapper<User>
  ID: ResolverTypeWrapper<Scalars['ID']>
  String: ResolverTypeWrapper<Scalars['String']>
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>
  USStateName: ResolverTypeWrapper<Scalars['USStateName']>
  FundingSource: ResolverTypeWrapper<FundingSource>
  Int: ResolverTypeWrapper<Scalars['Int']>
  URL: ResolverTypeWrapper<Scalars['URL']>
  JSON: ResolverTypeWrapper<Scalars['JSON']>
  Portfolio: ResolverTypeWrapper<Portfolio>
  BasePortfolio: ResolversTypes['Portfolio'] | ResolversTypes['SelfDirectedPortfolio']
  PortfolioAllocation: ResolverTypeWrapper<PortfolioAllocation>
  Float: ResolverTypeWrapper<Scalars['Float']>
  MonetaryAmount: ResolverTypeWrapper<MonetaryAmount>
  Currency: Currency
  PortfolioCustomizationLevel: PortfolioCustomizationLevel
  PortfolioSecurity: ResolverTypeWrapper<PortfolioSecurity>
  MarketReturn: ResolverTypeWrapper<MarketReturn>
  PortfolioSecurityAllocation: ResolverTypeWrapper<PortfolioSecurityAllocation>
  InvestmentCategory: ResolverTypeWrapper<InvestmentCategory>
  Security: ResolversTypes['Fund'] | ResolversTypes['Stock']
  TickerSymbol: ResolverTypeWrapper<Scalars['TickerSymbol']>
  SecurityType: SecurityType
  BigCurrencyAmount: ResolverTypeWrapper<BigCurrencyAmount>
  BigDecimal: ResolverTypeWrapper<Scalars['BigDecimal']>
  SecurityProfile: ResolverTypeWrapper<SecurityProfile>
  TradingSector: TradingSector
  SecurityHeadline: ResolverTypeWrapper<SecurityHeadline>
  Date: ResolverTypeWrapper<Scalars['Date']>
  ETF: ResolverTypeWrapper<Etf>
  Holding: ResolverTypeWrapper<Holding>
  ETFTimescale: EtfTimescale
  ETFPerformance: ResolverTypeWrapper<EtfPerformance>
  ETFGain: ResolverTypeWrapper<EtfGain>
  ETFPrice: ResolverTypeWrapper<EtfPrice>
  PortfolioHolding: ResolverTypeWrapper<PortfolioHolding>
  PortfolioProjection: ResolverTypeWrapper<PortfolioProjection>
  PortfolioRiskLevel: PortfolioRiskLevel
  PortfolioTheme: PortfolioTheme
  UserUpload: ResolverTypeWrapper<UserUpload>
  SecurityQuestion: ResolverTypeWrapper<SecurityQuestion>
  Suitability: ResolverTypeWrapper<Suitability>
  UserAlert: ResolverTypeWrapper<UserAlert>
  UserAlertsItem:
    | ResolversTypes['UserAlert']
    | ResolversTypes['MissingSsnBeneficiaryAlertItem']
    | ResolversTypes['UnverifiedBeneficiarySsnAlertItem']
    | ResolversTypes['LinkedAccountAlert']
    | ResolversTypes['RelinkLinkedAccountAlert']
    | ResolversTypes['AddressDocumentRequestedUserAlert']
    | ResolversTypes['BankDocumentRequestedUserAlert']
    | ResolversTypes['IdentityDocumentRequestedUserAlert']
    | ResolversTypes['InsufficientFundsUserAlert']
    | ResolversTypes['InvestmentsPausedUserAlert']
    | ResolversTypes['MiscDocumentRequestedUserAlert']
    | ResolversTypes['NoFundingSourceUserAlert']
    | ResolversTypes['RdvRequiredUserAlert']
    | ResolversTypes['SSNDocumentRequestedUserAlert']
    | ResolversTypes['W9DocumentRequestedUserAlert']
  UserTotals: ResolverTypeWrapper<UserTotals>
  UserDailyChange: ResolverTypeWrapper<UserDailyChange>
  UserRoundUps: ResolverTypeWrapper<UserRoundUps>
  MaritalStatusType: MaritalStatusType
  InvestmentAccount: ResolverTypeWrapper<InvestmentAccount>
  TimestampsInterface:
    | ResolversTypes['InvestmentAccount']
    | ResolversTypes['RecurringInvestmentSettings']
    | ResolversTypes['Beneficiary']
    | ResolversTypes['Address']
    | ResolversTypes['Phone']
    | ResolversTypes['Account']
    | ResolversTypes['Profile']
    | ResolversTypes['Signature']
    | ResolversTypes['BillingCycle']
    | ResolversTypes['Credit']
    | ResolversTypes['Fee']
    | ResolversTypes['FeeExecution']
    | ResolversTypes['FinancialInstitution']
    | ResolversTypes['LinkedAccount']
    | ResolversTypes['LinkedSubaccount']
    | ResolversTypes['RoundUpAccount']
    | ResolversTypes['RoundUpProfile']
    | ResolversTypes['RoundUp']
    | ResolversTypes['FundingSourceAccount']
    | ResolversTypes['OutsideContributionCode']
    | ResolversTypes['InvestmentAccountReopenRequest']
    | ResolversTypes['InvestmentAccountReopenRequestAction']
    | ResolversTypes['InvestmentAccountReopenRequestNote']
    | ResolversTypes['UserInvestmentAccountReopenCheck']
    | ResolversTypes['OutsideContributionCheckoutCart']
    | ResolversTypes['OutsideContribution']
  InvestmentAccountType: InvestmentAccountType
  Withdrawal: ResolverTypeWrapper<Withdrawal>
  PresentableWithdrawalStatus: PresentableWithdrawalStatus
  Performance: ResolverTypeWrapper<Performance>
  AccountValue: ResolverTypeWrapper<AccountValue>
  InvestmentProduct: InvestmentProduct
  InvestmentAccountRecap: ResolverTypeWrapper<InvestmentAccountRecap>
  InvestmentAccountOutsideContribution: ResolverTypeWrapper<InvestmentAccountOutsideContribution>
  RecurringInvestmentSettings: ResolverTypeWrapper<RecurringInvestmentSettings>
  InvestmentFrequency: InvestmentFrequency
  AccountRequirements: ResolverTypeWrapper<AccountRequirements>
  AccountRequirement: ResolverTypeWrapper<AccountRequirement>
  AccountRequirementStatus: AccountRequirementStatus
  AccountRequirementType: AccountRequirementType
  InvestmentAccountStatus: InvestmentAccountStatus
  InvestmentAccountSummary: ResolverTypeWrapper<InvestmentAccountSummary>
  InvestmentAccountTransferability: ResolverTypeWrapper<InvestmentAccountTransferability>
  USStateCodes: UsStateCodes
  Beneficiary: ResolverTypeWrapper<Beneficiary>
  Address: ResolverTypeWrapper<Address>
  AddressType: AddressType
  Email: ResolverTypeWrapper<Scalars['Email']>
  Phone: ResolverTypeWrapper<Phone>
  ActionCardsInput: ActionCardsInput
  ActionFeedContext: ActionFeedContext
  ActionCard: ResolverTypeWrapper<ActionCard>
  ActionCardStyle: ActionCardStyle
  ActionCardButton: ResolverTypeWrapper<ActionCardButton>
  FundingSourceInfo: ResolverTypeWrapper<FundingSourceInfo>
  FundingSourceType: FundingSourceType
  Activity: ResolverTypeWrapper<Activity>
  ActivityType: ActivityType
  AcceptanceDocument: ResolverTypeWrapper<AcceptanceDocument>
  Market: ResolverTypeWrapper<Market>
  Settings: ResolverTypeWrapper<Settings>
  Notifications: ResolverTypeWrapper<Notifications>
  Notification: ResolverTypeWrapper<Notification>
  Statement: ResolverTypeWrapper<Statement>
  StatementType: StatementType
  StatementLink: ResolverTypeWrapper<StatementLink>
  FormType: FormType
  StatementPortfolioType: StatementPortfolioType
  Toggle: ResolverTypeWrapper<Toggle>
  Partner: ResolverTypeWrapper<Partner>
  PartnerAuthorizationData: ResolverTypeWrapper<PartnerAuthorizationData>
  PartnerRoutingNumber: ResolverTypeWrapper<PartnerRoutingNumber>
  PartnerUserPayload: ResolverTypeWrapper<PartnerUserPayload>
  SuitabilityQuestion: ResolverTypeWrapper<SuitabilityQuestion>
  SuitabilityAnswer: ResolverTypeWrapper<SuitabilityAnswer>
  CloseAccountReason: ResolverTypeWrapper<CloseAccountReason>
  AccountStrengthResult: ResolverTypeWrapper<AccountStrengthResult>
  AccountAchievement: ResolverTypeWrapper<AccountAchievement>
  AchievementItem: AchievementItem
  UserStatus: ResolverTypeWrapper<UserStatus>
  ExtensionOwner: ResolverTypeWrapper<ExtensionOwner>
  ExtensionCampaign: ResolverTypeWrapper<ExtensionCampaign>
  ExtensionCampaignBackgroundImage: ResolverTypeWrapper<ExtensionCampaignBackgroundImage>
  ExtensionCampaignCtaDetails: ResolverTypeWrapper<ExtensionCampaignCtaDetails>
  ExtensionCampaignStore: ResolverTypeWrapper<ExtensionCampaignStore>
  ExtensionRewardsSummary: ResolverTypeWrapper<ExtensionRewardsSummary>
  RewardSummary: ResolverTypeWrapper<RewardSummary>
  ExtensionTransaction: ResolverTypeWrapper<ExtensionTransaction>
  FoundMoneyOffer: ResolverTypeWrapper<FoundMoneyOffer>
  BackgroundImage: ResolverTypeWrapper<BackgroundImage>
  CtaDetails: ResolverTypeWrapper<CtaDetails>
  DealType: DealType
  Owner: ResolverTypeWrapper<Owner>
  SocialCopies: ResolverTypeWrapper<SocialCopies>
  CondensedSocialCopies: ResolverTypeWrapper<CondensedSocialCopies>
  FoundMoneyCampaign: ResolverTypeWrapper<FoundMoneyCampaign>
  FoundMoneyReward: ResolverTypeWrapper<FoundMoneyReward>
  FoundMoneySummary: ResolverTypeWrapper<FoundMoneySummary>
  FoundMoneyOfferCategory: ResolverTypeWrapper<FoundMoneyOfferCategory>
  LaterAccount: ResolverTypeWrapper<LaterAccount>
  LaterAccountCodes: LaterAccountCodes
  LaterPortfolioPerformance: ResolverTypeWrapper<LaterPortfolioPerformance>
  LaterAccountStatus: LaterAccountStatus
  LaterIndividualBeneficiary: ResolverTypeWrapper<LaterIndividualBeneficiary>
  LaterBeneficiary:
    | ResolversTypes['LaterIndividualBeneficiary']
    | ResolversTypes['LaterEntityBeneficiary']
  BeneficiaryType: BeneficiaryType
  LaterHistoryItem: ResolversTypes['LaterDeposit'] | ResolversTypes['LaterWithdrawal']
  LaterHistoryItemType: LaterHistoryItemType
  LaterDeposit: ResolverTypeWrapper<LaterDeposit>
  LaterDepositType: LaterDepositType
  RolloverAccounts: ResolverTypeWrapper<RolloverAccounts>
  RolloverAccountType: ResolverTypeWrapper<RolloverAccountType>
  RolloverAccountCode: RolloverAccountCode
  CustodianCompany: ResolverTypeWrapper<CustodianCompany>
  CurrencyAmountInput: CurrencyAmountInput
  WithholdingDefaults: ResolverTypeWrapper<WithholdingDefaults>
  ContributionHistoryItem: ResolverTypeWrapper<ContributionHistoryItem>
  EligibilityScope: EligibilityScope
  Eligibility: ResolverTypeWrapper<Eligibility>
  AccountStatus: AccountStatus
  Account: ResolverTypeWrapper<Account>
  AccountType: AccountType
  AlertHubBeneficiaryAlert:
    | ResolversTypes['MissingSsnBeneficiaryAlertItem']
    | ResolversTypes['UnverifiedBeneficiarySsnAlertItem']
  MissingSsnBeneficiaryAlertItem: ResolverTypeWrapper<MissingSsnBeneficiaryAlertItem>
  UnverifiedBeneficiarySsnAlertItem: ResolverTypeWrapper<UnverifiedBeneficiarySsnAlertItem>
  Alert:
    | ResolversTypes['BeneficiaryRequestedLaterAlert']
    | ResolversTypes['MissingSsnBeneficiaryAlert']
    | ResolversTypes['UnverifiedBeneficiarySsnAlert']
  Occupation: ResolverTypeWrapper<Occupation>
  Profile: ResolverTypeWrapper<Profile>
  Employees: Employees
  EmploymentStatus: EmploymentStatus
  FilingType: FilingType
  FundsAvailability: FundsAvailability
  MaritalStatus: MaritalStatus
  RetirementPlanAccess: RetirementPlanAccess
  Signature: ResolverTypeWrapper<Signature>
  SignatureType: SignatureType
  MightyOakWaiverResult:
    | ResolversTypes['BillingProfileNotFoundException']
    | ResolversTypes['MightyOakCardWaiver']
    | ResolversTypes['MightyOakCardWaiverExpiredException']
    | ResolversTypes['MightyOakCardWaiverNotFoundException']
  BillingProfileNotFoundException: ResolverTypeWrapper<BillingProfileNotFoundException>
  MightyOakCardWaiver: ResolverTypeWrapper<MightyOakCardWaiver>
  MightyOakCardWaiverExpiredException: ResolverTypeWrapper<MightyOakCardWaiverExpiredException>
  MightyOakCardWaiverNotFoundException: ResolverTypeWrapper<MightyOakCardWaiverNotFoundException>
  BillingCycle: ResolverTypeWrapper<BillingCycle>
  Credit: ResolverTypeWrapper<Credit>
  FeeExecutionMethod: FeeExecutionMethod
  Fee: ResolverTypeWrapper<Fee>
  FeeExecution: ResolverTypeWrapper<FeeExecution>
  FeeType: FeeType
  BillingCycleState: BillingCycleState
  TierSubscription: ResolverTypeWrapper<TierSubscription>
  Promotion: ResolverTypeWrapper<
    Omit<Promotion, 'offering'> & { offering: ResolversTypes['Offering'] }
  >
  PromotionDuration: ResolverTypeWrapper<PromotionDuration>
  PromotionDurationPeriod: PromotionDurationPeriod
  Incentive: ResolversTypes['MonetaryIncentive']
  Offering: ResolversTypes['Product'] | ResolversTypes['Tier']
  Product: ResolverTypeWrapper<Product>
  ProductKey: ProductKey
  Tier: ResolverTypeWrapper<Tier>
  Bundle: ResolverTypeWrapper<Bundle>
  PresentableProduct: ResolverTypeWrapper<PresentableProduct>
  StringKey: ResolverTypeWrapper<Scalars['StringKey']>
  TierProduct: ResolverTypeWrapper<TierProduct>
  TierKey: TierKey
  TierPrice: ResolverTypeWrapper<TierPrice>
  CurrencyAmount: ResolverTypeWrapper<CurrencyAmount>
  BillingFrequency: BillingFrequency
  TierSubscriptionCreatedBy: TierSubscriptionCreatedBy
  SubscriptionMigration: ResolverTypeWrapper<SubscriptionMigration>
  Offer: ResolverTypeWrapper<Omit<Offer, 'offering'> & { offering: ResolversTypes['Offering'] }>
  OfferAvailability: OfferAvailability
  OfferExpiration: ResolverTypeWrapper<OfferExpiration>
  OfferExpirationPeriod: OfferExpirationPeriod
  OfferPrice: ResolverTypeWrapper<OfferPrice>
  OfferPriceType: OfferPriceType
  OfferType: OfferType
  TierSubscriptionStatus: TierSubscriptionStatus
  TierSubscriptionTransition: ResolverTypeWrapper<TierSubscriptionTransition>
  TierSubscriptionDeactivationReason: TierSubscriptionDeactivationReason
  SubscriptionTransitionAction: SubscriptionTransitionAction
  NextBillingDate: ResolverTypeWrapper<NextBillingDate>
  AddressDeliverabilityInput: AddressDeliverabilityInput
  AddressDeliverabilityResult:
    | ResolversTypes['AddressDeliverabilityVerified']
    | ResolversTypes['AddressDeliverabilityVerificationError']
    | ResolversTypes['AddressDeliverabilityCorrectedAddress']
    | ResolversTypes['AddressDeliverabilityUnavailableError']
  AddressDeliverabilityVerified: ResolverTypeWrapper<AddressDeliverabilityVerified>
  AddressDeliverabilityAdditionalInfo: ResolverTypeWrapper<AddressDeliverabilityAdditionalInfo>
  AddressDeliverabilityVerificationError: ResolverTypeWrapper<
    AddressDeliverabilityVerificationError
  >
  AddressDeliverabilityVerificationErrorFailureReason: AddressDeliverabilityVerificationErrorFailureReason
  AddressDeliverabilityCorrectedAddress: ResolverTypeWrapper<AddressDeliverabilityCorrectedAddress>
  AddressDeliverabilityUnavailableError: ResolverTypeWrapper<AddressDeliverabilityUnavailableError>
  AllBankAccountsInput: AllBankAccountsInput
  BankAccountType: BankAccountType
  BankAccount: ResolverTypeWrapper<BankAccount>
  BankAccountStatus: BankAccountStatus
  BankAccountLockReason: BankAccountLockReason
  BankAccountRequirements: ResolverTypeWrapper<BankAccountRequirements>
  BankAccountRequirement: ResolverTypeWrapper<BankAccountRequirement>
  BankAccountRequirementStatus: BankAccountRequirementStatus
  BankAccountRequirementType: BankAccountRequirementType
  BankAccountGoals: ResolverTypeWrapper<BankAccountGoals>
  BankAccountGoal: ResolverTypeWrapper<BankAccountGoal>
  BankAccountGoalType: BankAccountGoalType
  BankType: BankType
  AllBankCardsFilter: AllBankCardsFilter
  BankCard: ResolverTypeWrapper<BankCard>
  CardNumberMasked: ResolverTypeWrapper<Scalars['CardNumberMasked']>
  BankCardTier: BankCardTier
  BankCardType: BankCardType
  BankCardLockReason: BankCardLockReason
  BankCardLockTypeCode: BankCardLockTypeCode
  BankCardStatus: BankCardStatus
  BankCardPaymentProcessor: BankCardPaymentProcessor
  BankMetadata: ResolverTypeWrapper<BankMetadata>
  BankMetadataTotals: ResolverTypeWrapper<BankMetadataTotals>
  BankCardOrder: ResolverTypeWrapper<BankCardOrder>
  BankCardOrderStatus: BankCardOrderStatus
  BankCardOrderAddressVerification: ResolverTypeWrapper<BankCardOrderAddressVerification>
  BankCardOrderVerificationStatus: BankCardOrderVerificationStatus
  BankCardOrderAddressVerificationActions: BankCardOrderAddressVerificationActions
  BankCardOrderIdentityVerification: ResolverTypeWrapper<BankCardOrderIdentityVerification>
  BankCardOrderIdentityVerificationActions: BankCardOrderIdentityVerificationActions
  BankCardOrderPrefundVerification: ResolverTypeWrapper<BankCardOrderPrefundVerification>
  BankCardOrderPrefundVerificationActions: BankCardOrderPrefundVerificationActions
  BankCardOrderFundingSourceVerification: ResolverTypeWrapper<
    BankCardOrderFundingSourceVerification
  >
  BankCardOrderFundingSourceVerificationActions: BankCardOrderFundingSourceVerificationActions
  BankCardOrderFundingSourceVerificationPendingReason: BankCardOrderFundingSourceVerificationPendingReason
  BankCardOrderFailureReason: BankCardOrderFailureReason
  KycStatus: KycStatus
  RequestVersions: RequestVersions
  BankTransaction: ResolverTypeWrapper<BankTransaction>
  BankTransactionStatus: BankTransactionStatus
  BankTransactionType: BankTransactionType
  AllBankDocumentsInput: AllBankDocumentsInput
  BankDocument: ResolverTypeWrapper<BankDocument>
  BankStatement: ResolverTypeWrapper<BankStatement>
  BankStatementType: BankStatementType
  SpendAlert:
    | ResolversTypes['SystemCardLockedSpendAlert']
    | ResolversTypes['UserCardLockedSpendAlert']
  PageInput: PageInput
  BankTransactionConnection: ResolverTypeWrapper<BankTransactionConnection>
  BankTransactionEdge: ResolverTypeWrapper<BankTransactionEdge>
  PageInfo: ResolverTypeWrapper<PageInfo>
  SpendAtmsInput: SpendAtmsInput
  SpendAtmsCoordinateInput: SpendAtmsCoordinateInput
  SpendAtmsResult:
    | ResolversTypes['SpendAtmsPayload']
    | ResolversTypes['SpendAtmVendorUnavailableError']
  SpendAtmsPayload: ResolverTypeWrapper<SpendAtmsPayload>
  SpendAtm: ResolverTypeWrapper<SpendAtm>
  SpendAtmAddress: ResolverTypeWrapper<SpendAtmAddress>
  SpendAtmVendorUnavailableError: ResolverTypeWrapper<SpendAtmVendorUnavailableError>
  SpendAccount: ResolverTypeWrapper<SpendAccount>
  SpendAccountStatus: SpendAccountStatus
  BankCardReissue: ResolverTypeWrapper<
    Omit<BankCardReissue, 'reissueBankCardEligibility'> & {
      reissueBankCardEligibility: ResolversTypes['ReissueBankCardEligibility']
    }
  >
  BankCardRequest: ResolverTypeWrapper<BankCardRequest>
  BankCardRequestStatus: BankCardRequestStatus
  BankCardRequestReason: BankCardRequestReason
  BankCardRequestMailingAddress: ResolverTypeWrapper<BankCardRequestMailingAddress>
  ReissueBankCardEligibility:
    | ResolversTypes['ReissueBankCardEligible']
    | ResolversTypes['ReissueBankCardIneligible']
  ReissueBankCardEligible: ResolverTypeWrapper<ReissueBankCardEligible>
  ReissueBankCardIneligible: ResolverTypeWrapper<ReissueBankCardIneligible>
  ReissueBankCardIneligibleIssue: ReissueBankCardIneligibleIssue
  BankAccountClosureReason: BankAccountClosureReason
  SavingsAccountType: SavingsAccountType
  SavingsAccountEligibility: ResolverTypeWrapper<SavingsAccountEligibility>
  SavingsAccountEligibilityRequirement: SavingsAccountEligibilityRequirement
  BankAccountDisclosureFilter: BankAccountDisclosureFilter
  BankAccountDisclosure: ResolverTypeWrapper<BankAccountDisclosure>
  FinancialInstitution: ResolverTypeWrapper<FinancialInstitution>
  LinkProviderType: LinkProviderType
  FinancialInstitutionTypePagination: ResolverTypeWrapper<FinancialInstitutionTypePagination>
  FinancialInstitutionTypeEdge: ResolverTypeWrapper<FinancialInstitutionTypeEdge>
  LinkedAccount: ResolverTypeWrapper<LinkedAccount>
  LinkedAccountExternalSourceEnum: LinkedAccountExternalSourceEnum
  LinkedSubaccount: ResolverTypeWrapper<LinkedSubaccount>
  LinkedSubaccountRoleEnum: LinkedSubaccountRoleEnum
  LinkedSubaccountPaymentEngineEnum: LinkedSubaccountPaymentEngineEnum
  FundingSourceStatusEnum: FundingSourceStatusEnum
  LinkedAccountStatusEnum: LinkedAccountStatusEnum
  LinkedAccountAlertsResponse:
    | ResolversTypes['LinkedAccountAlert']
    | ResolversTypes['RelinkLinkedAccountAlert']
  LinkedAccountAlert: ResolverTypeWrapper<LinkedAccountAlert>
  RelinkLinkedAccountAlert: ResolverTypeWrapper<RelinkLinkedAccountAlert>
  Webhooks: ResolverTypeWrapper<Webhooks>
  RoundUpAccount: ResolverTypeWrapper<RoundUpAccount>
  RoundUpProfile: ResolverTypeWrapper<RoundUpProfile>
  RoundUpState: RoundUpState
  RoundUp: ResolverTypeWrapper<RoundUp>
  RoundUpTypePagination: ResolverTypeWrapper<RoundUpTypePagination>
  RoundUpTypeEdge: ResolverTypeWrapper<RoundUpTypeEdge>
  AllPastCoreItemsSchemaFilter: AllPastCoreItemsSchemaFilter
  PastItemConnection: ResolverTypeWrapper<PastItemConnection>
  PastItemEdge: ResolverTypeWrapper<PastItemEdge>
  PastItem:
    | ResolversTypes['CoreACHSubscriptionFeeItem']
    | ResolversTypes['CoreAdjustmentItem']
    | ResolversTypes['CoreCashForwardItem']
    | ResolversTypes['CoreCollectionItem']
    | ResolversTypes['CoreDividendsItem']
    | ResolversTypes['CoreEmployeeCreditItem']
    | ResolversTypes['CoreFeeInvestmentItem']
    | ResolversTypes['CoreFoundMoneyRewardItem']
    | ResolversTypes['CoreGiftCardCreditRedemptionItem']
    | ResolversTypes['CoreHoldingsTransferInItem']
    | ResolversTypes['CoreInvestmentItem']
    | ResolversTypes['CoreLocalFoundMoneyItem']
    | ResolversTypes['CorePartnerRewardItem']
    | ResolversTypes['CoreRebalanceItem']
    | ResolversTypes['CoreReferralRewardItem']
    | ResolversTypes['CoreRoundUpsItem']
    | ResolversTypes['CoreWithdrawalItem']
    | ResolversTypes['EarlyDividendsItem']
    | ResolversTypes['EarlyFeeInvestmentItem']
    | ResolversTypes['EarlyGiftItem']
    | ResolversTypes['EarlyInvestmentItem']
    | ResolversTypes['EarlyWithdrawalItem']
    | ResolversTypes['LaterDividendsItem']
    | ResolversTypes['LaterFeeInvestmentItem']
    | ResolversTypes['LaterInvestmentItem']
    | ResolversTypes['LaterRebalanceItem']
    | ResolversTypes['LaterWithdrawalItem']
    | ResolversTypes['PastCoreItem']
    | ResolversTypes['PastSpendItem']
    | ResolversTypes['SpendATMReimbursementItem']
    | ResolversTypes['SpendATMWithdrawalItem']
    | ResolversTypes['SpendBillPayItem']
    | ResolversTypes['SpendCheckDepositItem']
    | ResolversTypes['SpendCheckPaymentItem']
    | ResolversTypes['SpendDigitalWalletItem']
    | ResolversTypes['SpendDirectDepositItem']
    | ResolversTypes['SpendECheckItem']
    | ResolversTypes['SpendPurchaseItem']
    | ResolversTypes['SpendRealTimeRoundUpItem']
    | ResolversTypes['SpendTransferInItem']
    | ResolversTypes['SpendTransferOutItem']
  PastItemStatus: PastItemStatus
  ProductType: ProductType
  AllPastLaterItemsSchemaFilter: AllPastLaterItemsSchemaFilter
  AllPastSpendItemsSchemaFilter: AllPastSpendItemsSchemaFilter
  AllPastEarlyItemsSchemaFilter: AllPastEarlyItemsSchemaFilter
  PastCoreSummary: ResolverTypeWrapper<PastCoreSummary>
  PastEarlySummary: ResolverTypeWrapper<PastEarlySummary>
  PastSpendSummary: ResolverTypeWrapper<PastSpendSummary>
  TransferableFrom: ResolverTypeWrapper<TransferableFrom>
  TransferableAccount: ResolverTypeWrapper<TransferableAccount>
  TransferableAccountTypeEnum: TransferableAccountTypeEnum
  ExternalSource: ExternalSource
  AllTransferableToInput: AllTransferableToInput
  TransferableTo: ResolverTypeWrapper<TransferableTo>
  EstimatedTransferDatesInput: EstimatedTransferDatesInput
  EstimatedTransferDatesPayload: ResolverTypeWrapper<EstimatedTransferDatesPayload>
  ReturnedCheckDeposit: ResolverTypeWrapper<ReturnedCheckDeposit>
  EvaluateCheckDepositInput: EvaluateCheckDepositInput
  EvaluateCheckDepositPayload: ResolverTypeWrapper<EvaluateCheckDepositPayload>
  DepositRiskFactor: ResolverTypeWrapper<DepositRiskFactor>
  DepositField: DepositField
  RiskStatus: RiskStatus
  ContactCategory: ResolverTypeWrapper<ContactCategory>
  ContactSubcategory: ResolverTypeWrapper<ContactSubcategory>
  ContactFaq: ResolverTypeWrapper<ContactFaq>
  SubcategoryMessage: ResolverTypeWrapper<SubcategoryMessage>
  AllSupportArticlesFilterInput: AllSupportArticlesFilterInput
  SupportArticle: ResolverTypeWrapper<SupportArticle>
  SupportAuthor: ResolverTypeWrapper<SupportAuthor>
  SupportAuthorPhoto: ResolverTypeWrapper<SupportAuthorPhoto>
  SupportSection: ResolverTypeWrapper<SupportSection>
  SupportCategory: ResolverTypeWrapper<SupportCategory>
  SupportTicketForm: ResolverTypeWrapper<SupportTicketForm>
  SupportTicketFormField: ResolverTypeWrapper<SupportTicketFormField>
  CustomFieldOption: ResolverTypeWrapper<CustomFieldOption>
  ScheduleInput: ScheduleInput
  ScheduleType: ScheduleType
  ScheduleResult: ResolverTypeWrapper<ScheduleResult>
  ContactFormAlert: ResolverTypeWrapper<ContactFormAlert>
  HelpFormType: HelpFormType
  HelpFormContent: ResolverTypeWrapper<HelpFormContent>
  SearchSupportArticleResult: ResolverTypeWrapper<SearchSupportArticleResult>
  SearchSupportResult: ResolverTypeWrapper<SearchSupportResult>
  userWinbackScoreRes: ResolversTypes['userWinbackScore'] | ResolversTypes['userWinbackErrors']
  userWinbackScore: ResolverTypeWrapper<UserWinbackScore>
  userWinbackErrors: ResolverTypeWrapper<UserWinbackErrors>
  CardDeliveryStatus: ResolverTypeWrapper<CardDeliveryStatus>
  PackageStatus: PackageStatus
  DirectDepositStatePayload: ResolverTypeWrapper<DirectDepositStatePayload>
  DirectDepositState: ResolverTypeWrapper<DirectDepositState>
  SwitchMethod: SwitchMethod
  SwitchState: SwitchState
  PdfDownloadUrlInput: PdfDownloadUrlInput
  GenerateUpdatedPdfPayload: ResolverTypeWrapper<GenerateUpdatedPdfPayload>
  ParameterizedPdfInput: ParameterizedPdfInput
  DirectDepositDistribution: DirectDepositDistribution
  PdfDownloadUrlPayload: ResolverTypeWrapper<PdfDownloadUrlPayload>
  SearchEmployersInput: SearchEmployersInput
  SwitchType: SwitchType
  SearchEmployersPayload: ResolverTypeWrapper<SearchEmployersPayload>
  Employer: ResolverTypeWrapper<
    Omit<Employer, 'switch'> & { switch: ResolversTypes['AbstractSwitch'] }
  >
  AbstractSwitch:
    | ResolversTypes['AcornsPdfSwitch']
    | ResolversTypes['OnlineSwitch']
    | ResolversTypes['SubmittableSwitch']
  AcornsPdfSwitch: ResolverTypeWrapper<AcornsPdfSwitch>
  SwitchInterface:
    | ResolversTypes['AcornsPdfSwitch']
    | ResolversTypes['OnlineSwitch']
    | ResolversTypes['SubmittableSwitch']
  SwitchSource: SwitchSource
  OnlineSwitch: ResolverTypeWrapper<OnlineSwitch>
  SubmittableSwitch: ResolverTypeWrapper<SubmittableSwitch>
  TopEmployerPayload: ResolverTypeWrapper<TopEmployerPayload>
  TopEmployer: ResolverTypeWrapper<TopEmployer>
  suitability_Portfolio: ResolverTypeWrapper<Suitability_Portfolio>
  suitability_SuitabilityResponse: ResolverTypeWrapper<Suitability_SuitabilityResponse>
  suitability_SuitabilityAnswer: ResolverTypeWrapper<Suitability_SuitabilityAnswer>
  suitability_SuitabilityQuestion: ResolverTypeWrapper<Suitability_SuitabilityQuestion>
  AllCheckPaymentsResult:
    | ResolversTypes['CheckPaymentConnection']
    | ResolversTypes['AuthorizationError']
  CheckPaymentConnection: ResolverTypeWrapper<CheckPaymentConnection>
  CheckPaymentEdge: ResolverTypeWrapper<CheckPaymentEdge>
  CheckPayment: ResolverTypeWrapper<CheckPayment>
  CheckPaymentAddress: ResolverTypeWrapper<CheckPaymentAddress>
  CheckPaymentStatus: CheckPaymentStatus
  CheckPaymentFailureReason: CheckPaymentFailureReason
  AuthorizationError: ResolverTypeWrapper<AuthorizationError>
  EstimatedCheckPaymentDates: ResolverTypeWrapper<EstimatedCheckPaymentDates>
  VerifyCheckPaymentRecipientAddressInputType: VerifyCheckPaymentRecipientAddressInputType
  CheckPaymentRecipientInput: CheckPaymentRecipientInput
  CheckPaymentAddressInput: CheckPaymentAddressInput
  VerifyCheckPaymentRecipientAddressResult:
    | ResolversTypes['CheckPaymentRecipientAddressType']
    | ResolversTypes['InvalidAddressError']
    | ResolversTypes['AuthorizationError']
  CheckPaymentRecipientAddressType: ResolverTypeWrapper<CheckPaymentRecipientAddressType>
  CheckPaymentRecipient: ResolverTypeWrapper<CheckPaymentRecipient>
  InvalidAddressError: ResolverTypeWrapper<InvalidAddressError>
  InvestmentAccountClosureReason: InvestmentAccountClosureReason
  InvestmentAccountsByUserIdFilter: InvestmentAccountsByUserIdFilter
  CombinedPerformance: ResolverTypeWrapper<CombinedPerformance>
  EarlyAccountStateRegulationResult:
    | ResolversTypes['EarlyAccountStateRegulation']
    | ResolversTypes['InternalErrorException']
    | ResolversTypes['InvalidStateException']
    | ResolversTypes['UserNotFoundException']
  EarlyAccountStateRegulation: ResolverTypeWrapper<EarlyAccountStateRegulation>
  EarlyInvestmentAccountType: EarlyInvestmentAccountType
  InternalErrorException: ResolverTypeWrapper<InternalErrorException>
  InvalidStateException: ResolverTypeWrapper<InvalidStateException>
  UserNotFoundException: ResolverTypeWrapper<UserNotFoundException>
  EarlyAccountTransferInfo: ResolverTypeWrapper<EarlyAccountTransferInfo>
  FundingSourceAccount: ResolverTypeWrapper<FundingSourceAccount>
  FundingSourceRoleEnum: FundingSourceRoleEnum
  FundingSourceStatus: FundingSourceStatus
  Investment: ResolverTypeWrapper<Investment>
  InvestmentAllocation: ResolverTypeWrapper<InvestmentAllocation>
  InvestmentAllocationStatus: InvestmentAllocationStatus
  InvestmentAllocationType: InvestmentAllocationType
  InvestmentStatus: InvestmentStatus
  Referral: ResolverTypeWrapper<Referral>
  Result: ResolverTypeWrapper<Result>
  Funnel: Funnel
  UserAlertsResponse:
    | ResolversTypes['AddressDocumentRequestedUserAlert']
    | ResolversTypes['BankDocumentRequestedUserAlert']
    | ResolversTypes['IdentityDocumentRequestedUserAlert']
    | ResolversTypes['InsufficientFundsUserAlert']
    | ResolversTypes['InvestmentsPausedUserAlert']
    | ResolversTypes['MiscDocumentRequestedUserAlert']
    | ResolversTypes['NoFundingSourceUserAlert']
    | ResolversTypes['RdvRequiredUserAlert']
    | ResolversTypes['SSNDocumentRequestedUserAlert']
    | ResolversTypes['UserAlert']
    | ResolversTypes['W9DocumentRequestedUserAlert']
  AddressDocumentRequestedUserAlert: ResolverTypeWrapper<AddressDocumentRequestedUserAlert>
  DocumentType: DocumentType
  BankDocumentRequestedUserAlert: ResolverTypeWrapper<BankDocumentRequestedUserAlert>
  IdentityDocumentRequestedUserAlert: ResolverTypeWrapper<IdentityDocumentRequestedUserAlert>
  InsufficientFundsUserAlert: ResolverTypeWrapper<InsufficientFundsUserAlert>
  InvestmentsPausedUserAlert: ResolverTypeWrapper<InvestmentsPausedUserAlert>
  MiscDocumentRequestedUserAlert: ResolverTypeWrapper<MiscDocumentRequestedUserAlert>
  NoFundingSourceUserAlert: ResolverTypeWrapper<NoFundingSourceUserAlert>
  RdvRequiredUserAlert: ResolverTypeWrapper<RdvRequiredUserAlert>
  SSNDocumentRequestedUserAlert: ResolverTypeWrapper<SsnDocumentRequestedUserAlert>
  W9DocumentRequestedUserAlert: ResolverTypeWrapper<W9DocumentRequestedUserAlert>
  ContributionAbility: ResolverTypeWrapper<ContributionAbility>
  LaterContributionAbilityResult: ResolversTypes['ContributionAbilityByYear']
  ContributionAbilityByYear: ResolverTypeWrapper<ContributionAbilityByYear>
  PastLaterSummary: ResolverTypeWrapper<PastLaterSummary>
  LaterWithdrawalReason: LaterWithdrawalReason
  WithholdingEstimates: ResolverTypeWrapper<WithholdingEstimates>
  YearLaterReport: ResolverTypeWrapper<YearLaterReport>
  RecurringTransfersFilterInput: RecurringTransfersFilterInput
  RecurringTransferAccountType: RecurringTransferAccountType
  RecurringTransferAccountIdFilterInput: RecurringTransferAccountIdFilterInput
  RecurringTransferDirectionFilterInput: RecurringTransferDirectionFilterInput
  RecurringTransferDirection: RecurringTransferDirection
  RecurringTransfer: ResolverTypeWrapper<RecurringTransfer>
  RecurrenceRule: ResolverTypeWrapper<RecurrenceRule>
  RecurrenceFrequency: RecurrenceFrequency
  DayOfWeek: DayOfWeek
  RecurringTransferEvent: ResolverTypeWrapper<RecurringTransferEvent>
  RecurringTransferAccount: ResolverTypeWrapper<RecurringTransferAccount>
  RecurringTransferFundingSource: ResolverTypeWrapper<RecurringTransferFundingSource>
  RecurringTransferFundingSourceType: RecurringTransferFundingSourceType
  RecurrenceRuleInput: RecurrenceRuleInput
  NextTransferDateResult:
    | ResolversTypes['RecurringTransferDate']
    | ResolversTypes['MalformedRecurringTransferException']
  RecurringTransferDate: ResolverTypeWrapper<RecurringTransferDate>
  MalformedRecurringTransferException: ResolverTypeWrapper<MalformedRecurringTransferException>
  RecurringTransferPathException: ResolverTypeWrapper<RecurringTransferPathException>
  RecurringTransferPathExceptionCase: RecurringTransferPathExceptionCase
  ProtectContext: ResolverTypeWrapper<ProtectContext>
  WidgetReferenceType: WidgetReferenceType
  CoverageShop: ResolverTypeWrapper<
    Omit<CoverageShop, 'widgets'> & { widgets: Array<ResolversTypes['CoverageShopWidget']> }
  >
  Disclaimer: ResolverTypeWrapper<Disclaimer>
  Cta: ResolverTypeWrapper<Cta>
  Image: ResolverTypeWrapper<Image>
  CtaType: CtaType
  Modal: ResolverTypeWrapper<Modal>
  ModalType: ModalType
  CoverageShopWidget:
    | ResolversTypes['FeaturedOffers']
    | ResolversTypes['InsuranceCarousel']
    | ResolversTypes['PartnerChoices']
  FeaturedOffers: ResolverTypeWrapper<FeaturedOffers>
  FeaturedOffer: ResolverTypeWrapper<FeaturedOffer>
  InsuranceCarousel: ResolverTypeWrapper<InsuranceCarousel>
  InsuranceType: InsuranceType
  CarouselOffer: ResolverTypeWrapper<CarouselOffer>
  PartnerChoices: ResolverTypeWrapper<PartnerChoices>
  ProtectHome: ResolverTypeWrapper<
    Omit<ProtectHome, 'widgets'> & { widgets: Array<ResolversTypes['ProtectHomeWidget']> }
  >
  ProtectHomeWidget:
    | ResolversTypes['Education']
    | ResolversTypes['ExploreCarousel']
    | ResolversTypes['HomeIcons']
    | ResolversTypes['InsuranceSection']
  Education: ResolverTypeWrapper<Education>
  Article: ResolverTypeWrapper<Article>
  ExploreCarousel: ResolverTypeWrapper<ExploreCarousel>
  InsuranceSection: ResolverTypeWrapper<InsuranceSection>
  HomeIcons: ResolverTypeWrapper<HomeIcons>
  HomeIcon: ResolverTypeWrapper<HomeIcon>
  InsuranceHome: ResolverTypeWrapper<
    Omit<InsuranceHome, 'widgets'> & { widgets: Array<ResolversTypes['InsuranceHomeWidget']> }
  >
  InsuranceHomeWidget:
    | ResolversTypes['CoverageAsk']
    | ResolversTypes['CoverageCalculator']
    | ResolversTypes['CoverageGrow']
    | ResolversTypes['CoverageKnown']
    | ResolversTypes['CoverageUnknown']
    | ResolversTypes['InsuranceCarousel']
  CoverageAsk: ResolverTypeWrapper<CoverageAsk>
  CoverageCalculator: ResolverTypeWrapper<CoverageCalculator>
  CoverageGrow: ResolverTypeWrapper<CoverageGrow>
  CoverageKnown: ResolverTypeWrapper<CoverageKnown>
  EducationSection: ResolverTypeWrapper<EducationSection>
  CoverageUnknown: ResolverTypeWrapper<CoverageUnknown>
  ProtectLander: ResolverTypeWrapper<ProtectLander>
  ProtectLearningCenter: ResolverTypeWrapper<ProtectLearningCenter>
  LifeCalculatorSurvey: ResolverTypeWrapper<LifeCalculatorSurvey>
  LifeCalculatorQuestion: ResolverTypeWrapper<LifeCalculatorQuestion>
  Tip: ResolverTypeWrapper<Tip>
  LifeCalculatorQuestionType: LifeCalculatorQuestionType
  PremiumsInput: PremiumsInput
  ProviderName: ProviderName
  PremiumsResult: ResolverTypeWrapper<
    Omit<PremiumsResult, 'quoteData'> & { quoteData: ResolversTypes['QuoteResult'] }
  >
  QuoteResult: ResolversTypes['IneligibilityLander'] | ResolversTypes['LifeQuoteResultSliders']
  IneligibilityLander: ResolverTypeWrapper<IneligibilityLander>
  LifeQuoteResultSliders: ResolverTypeWrapper<LifeQuoteResultSliders>
  Footer: ResolverTypeWrapper<Footer>
  Header: ResolverTypeWrapper<Header>
  Premium: ResolverTypeWrapper<Premium>
  QuoteSlider: ResolverTypeWrapper<QuoteSlider>
  QuoteStatus: QuoteStatus
  LifeQuoteSurvey: ResolverTypeWrapper<LifeQuoteSurvey>
  LifeQuoteStep: ResolverTypeWrapper<LifeQuoteStep>
  LifeQuoteQuestion: ResolverTypeWrapper<LifeQuoteQuestion>
  QuestionAnswer: ResolverTypeWrapper<QuestionAnswer>
  QuestionAnswerName: QuestionAnswerName
  LifeQuoteQuestionType: LifeQuoteQuestionType
  Question: ResolverTypeWrapper<Question>
  Answer: ResolverTypeWrapper<Answer>
  AnswerType: AnswerType
  OnboardingStepType: OnboardingStepType
  ProviderSearch: ResolverTypeWrapper<ProviderSearch>
  Provider: ResolverTypeWrapper<Provider>
  UnknownProvider: ResolverTypeWrapper<UnknownProvider>
  Recommendations: ResolverTypeWrapper<
    Omit<Recommendations, 'widgets'> & { widgets: Array<ResolversTypes['RecommendationWidget']> }
  >
  RecommendationWidget: ResolversTypes['BriefInsuranceSection']
  BriefInsuranceSection: ResolverTypeWrapper<BriefInsuranceSection>
  RecommendedLifeCoverage: ResolverTypeWrapper<
    Omit<RecommendedLifeCoverage, 'widgets'> & {
      widgets: Array<ResolversTypes['RecommendedLifeCoverageWidget']>
    }
  >
  AboutSection: ResolverTypeWrapper<AboutSection>
  RecommendedLifeCoverageWidget:
    | ResolversTypes['CollapsedLifeRecommendation']
    | ResolversTypes['ExpandedLifeRecommendation']
    | ResolversTypes['InsuranceCarousel']
  CollapsedLifeRecommendation: ResolverTypeWrapper<CollapsedLifeRecommendation>
  ExpandedLifeRecommendation: ResolverTypeWrapper<ExpandedLifeRecommendation>
  LifeCoverageBreakdown: ResolverTypeWrapper<LifeCoverageBreakdown>
  LifeCoverageBreakdownCategory: ResolverTypeWrapper<LifeCoverageBreakdownCategory>
  ActivitySummaryProduct: ActivitySummaryProduct
  ActivitySummaryResponse: ResolverTypeWrapper<ActivitySummaryResponse>
  SummaryItem: ResolverTypeWrapper<SummaryItem>
  FeedContext: FeedContext
  FinishSetup: ResolverTypeWrapper<FinishSetup>
  SetUpTip: ResolverTypeWrapper<SetUpTip>
  ActionFeedCta: ResolverTypeWrapper<ActionFeedCta>
  ActionFeedCtaType: ActionFeedCtaType
  ProductSetupTipType: ProductSetupTipType
  OnboardingTips: ResolverTypeWrapper<OnboardingTips>
  OnboardingTipItem: ResolverTypeWrapper<OnboardingTipItem>
  OnboardingTipType: OnboardingTipType
  FoundMoneyCampaignV2: ResolverTypeWrapper<FoundMoneyCampaignV2>
  FoundMoneyCampaignOfferV2: ResolverTypeWrapper<FoundMoneyCampaignOfferV2>
  EarnOfferQueryPage: ResolverTypeWrapper<EarnOfferQueryPage>
  EarnOffer: ResolverTypeWrapper<EarnOffer>
  BadgeCategory: BadgeCategory
  EarnOfferCtaDetails: ResolverTypeWrapper<EarnOfferCtaDetails>
  EarnPageInfo: ResolverTypeWrapper<EarnPageInfo>
  FavoritePartnerOfferGroup: ResolverTypeWrapper<
    Omit<FavoritePartnerOfferGroup, 'offers'> & {
      offers: Array<ResolversTypes['PartnerOfferGroupItem']>
    }
  >
  PartnerOfferGroupItem:
    | ResolversTypes['JobOffer']
    | ResolversTypes['PromoOffer']
    | ResolversTypes['JobSearchOffer']
    | ResolversTypes['EarnOffer']
  JobOffer: ResolverTypeWrapper<JobOffer>
  OfferLocation: ResolverTypeWrapper<OfferLocation>
  JobOfferSalary: ResolverTypeWrapper<JobOfferSalary>
  SalaryInterval: SalaryInterval
  PromoOffer: ResolverTypeWrapper<PromoOffer>
  JobSearchOffer: ResolverTypeWrapper<JobSearchOffer>
  JobSearchFilter: ResolverTypeWrapper<JobSearchFilter>
  JobSearchFilterKey: JobSearchFilterKey
  PartnerOfferGroupFilterInput: PartnerOfferGroupFilterInput
  OfferLocationInput: OfferLocationInput
  PartnerOfferGroup: ResolverTypeWrapper<
    Omit<PartnerOfferGroup, 'offers'> & { offers: Array<ResolversTypes['PartnerOfferGroupItem']> }
  >
  CarouselType: CarouselType
  PartnerOfferGroupsTypeInput: PartnerOfferGroupsTypeInput
  OfferGroupsType: OfferGroupsType
  JobAlert: ResolverTypeWrapper<JobAlert>
  JobSearchCriteriaInput: JobSearchCriteriaInput
  JobSearchFilterInput: JobSearchFilterInput
  JobLocationInput: JobLocationInput
  jobs_Offer: ResolverTypeWrapper<Jobs_Offer>
  JobLocation: ResolverTypeWrapper<JobLocation>
  jobs_OfferSalary: ResolverTypeWrapper<Jobs_OfferSalary>
  jobs_OfferConnection: ResolverTypeWrapper<Jobs_OfferConnection>
  jobs_OfferEdge: ResolverTypeWrapper<Jobs_OfferEdge>
  JobSearchPage: ResolverTypeWrapper<JobSearchPage>
  JobSearchCriteria: ResolverTypeWrapper<JobSearchCriteria>
  jobs_Education: ResolverTypeWrapper<Jobs_Education>
  jobs_Article: ResolverTypeWrapper<Jobs_Article>
  MilestoneRule: ResolverTypeWrapper<MilestoneRule>
  MilestoneRuleArgInput: MilestoneRuleArgInput
  MilestoneTheme: MilestoneTheme
  Milestone: ResolverTypeWrapper<
    Omit<Milestone, 'progress'> & { progress: ResolversTypes['MilestoneProgress'] }
  >
  Destination: ResolverTypeWrapper<Destination>
  EducationTip: ResolverTypeWrapper<EducationTip>
  MilestoneProgress:
    | ResolversTypes['CurrencyMilestoneProgress']
    | ResolversTypes['DiscreteMilestoneProgress']
  CurrencyMilestoneProgress: ResolverTypeWrapper<CurrencyMilestoneProgress>
  DiscreteMilestoneProgress: ResolverTypeWrapper<DiscreteMilestoneProgress>
  MilestoneStatus: MilestoneStatus
  AccountPoints: ResolverTypeWrapper<AccountPoints>
  ChallengePointsEarned: ResolverTypeWrapper<ChallengePointsEarned>
  MilestoneRuleType: MilestoneRuleType
  MilestoneByThemeFilterInput: MilestoneByThemeFilterInput
  MilestoneThemeGroup: ResolverTypeWrapper<
    Omit<MilestoneThemeGroup, 'contents'> & {
      contents: Array<ResolversTypes['MilestoneThemeGroupContent']>
    }
  >
  MilestoneThemeGroupContent: ResolversTypes['MilestoneRuleGroup'] | ResolversTypes['Milestone']
  MilestoneRuleGroup: ResolverTypeWrapper<
    Omit<MilestoneRuleGroup, 'contents'> & {
      contents: Array<ResolversTypes['MilestoneRuleGroupContent']>
    }
  >
  MilestoneRuleGroupContent: ResolversTypes['Milestone']
  MilestoneHub: ResolverTypeWrapper<
    Omit<MilestoneHub, 'groupedMilestones'> & {
      groupedMilestones: Array<ResolversTypes['MilestoneGroup']>
    }
  >
  MilestoneAccountLevelDefinition: ResolverTypeWrapper<MilestoneAccountLevelDefinition>
  MilestoneHubAccount: ResolverTypeWrapper<MilestoneHubAccount>
  MilestoneGroup: ResolversTypes['MilestoneRuleGroup'] | ResolversTypes['MilestoneThemeGroup']
  MilestoneHubDefinition: ResolverTypeWrapper<MilestoneHubDefinition>
  FeaturedMilestones: ResolverTypeWrapper<FeaturedMilestones>
  FeaturedMilestonesV2:
    | ResolversTypes['AccountSetupMilestones']
    | ResolversTypes['FeaturedMilestones']
  AccountSetupMilestones: ResolverTypeWrapper<AccountSetupMilestones>
  MilestoneDefinition: ResolverTypeWrapper<MilestoneDefinition>
  AccountPointsRule: ResolverTypeWrapper<AccountPointsRule>
  MilestoneChallengePointsRule: ResolverTypeWrapper<MilestoneChallengePointsRule>
  MilestoneGroupDefinition: ResolverTypeWrapper<MilestoneGroupDefinition>
  MilestoneChallenge: ResolverTypeWrapper<
    Omit<MilestoneChallenge, 'groupedMilestones'> & {
      groupedMilestones: Array<ResolversTypes['MilestoneGroup']>
    }
  >
  MilestoneEligibilityScope: MilestoneEligibilityScope
  MilestoneEligibility: ResolverTypeWrapper<MilestoneEligibility>
  MilestoneAchievementActionRule: ResolverTypeWrapper<MilestoneAchievementActionRule>
  MilestoneAchievementActionType: MilestoneAchievementActionType
  MilestoneGroupAchievementActionRule: ResolverTypeWrapper<MilestoneGroupAchievementActionRule>
  MessageStatusFilterInput: MessageStatusFilterInput
  MessageStatus: MessageStatus
  MessageType: MessageType
  MessageCategory: MessageCategory
  Message: ResolversTypes['AlertMessage'] | ResolversTypes['NotificationMessage']
  MessageTextAsset: ResolversTypes['StringKeyAsset']
  StringKeyAsset: ResolverTypeWrapper<StringKeyAsset>
  MessageVisualAsset: ResolversTypes['DesignLibraryIcon'] | ResolversTypes['Image']
  DesignLibraryIcon: ResolverTypeWrapper<DesignLibraryIcon>
  IconType: IconType
  MessagePageInput: MessagePageInput
  MessageConnection: ResolverTypeWrapper<MessageConnection>
  MessageEdge: ResolverTypeWrapper<MessageEdge>
  MessagePageInfo: ResolverTypeWrapper<MessagePageInfo>
  LearnContentCategory: ResolversTypes['LearnTier'] | ResolversTypes['LearnTopic']
  LearnTier: ResolverTypeWrapper<
    Omit<LearnTier, 'icon'> & { icon: ResolversTypes['LearnVisualAsset'] }
  >
  LearnVisualAsset: ResolversTypes['Image']
  LearnTopic: ResolverTypeWrapper<
    Omit<LearnTopic, 'icon'> & { icon: ResolversTypes['LearnVisualAsset'] }
  >
  FeaturedLearnContentPreview:
    | ResolversTypes['LearnArticlePreview']
    | ResolversTypes['LearnMediaPreview']
  LearnArticlePreview: ResolverTypeWrapper<
    Omit<LearnArticlePreview, 'duration' | 'featuredImage'> & {
      duration: ResolversTypes['LearnContentDuration']
      featuredImage: ResolversTypes['LearnVisualAsset']
    }
  >
  LearnContentType: LearnContentType
  LearnContentDuration: ResolversTypes['Milliseconds']
  Milliseconds: ResolverTypeWrapper<Milliseconds>
  LearnProgress: ResolverTypeWrapper<LearnProgress>
  LearnProgressUnit: LearnProgressUnit
  LearnMediaPreview: ResolverTypeWrapper<
    Omit<LearnMediaPreview, 'audioTheme' | 'duration' | 'featuredImage'> & {
      audioTheme?: Maybe<ResolversTypes['LearnMediaTheme']>
      duration: ResolversTypes['LearnContentDuration']
      featuredImage: ResolversTypes['LearnVisualAsset']
    }
  >
  LearnMediaTheme: ResolversTypes['LearnThemeLiteral']
  LearnThemeLiteral: ResolverTypeWrapper<LearnThemeLiteral>
  LearnMediaType: LearnMediaType
  TrendingLearnContentPreview:
    | ResolversTypes['LearnArticlePreview']
    | ResolversTypes['LearnArticlePreviewLocked']
    | ResolversTypes['LearnMediaPreview']
    | ResolversTypes['LearnMediaPreviewLocked']
  LearnArticlePreviewLocked: ResolverTypeWrapper<
    Omit<LearnArticlePreviewLocked, 'duration' | 'featuredImage'> & {
      duration: ResolversTypes['LearnContentDuration']
      featuredImage: ResolversTypes['LearnVisualAsset']
    }
  >
  LearnMediaPreviewLocked: ResolverTypeWrapper<
    Omit<LearnMediaPreviewLocked, 'duration' | 'featuredImage'> & {
      duration: ResolversTypes['LearnContentDuration']
      featuredImage: ResolversTypes['LearnVisualAsset']
    }
  >
  LearnMedia: ResolversTypes['LearnMediaArticle']
  LearnMediaArticle: ResolverTypeWrapper<
    Omit<LearnMediaArticle, 'audioTheme' | 'featuredImage'> & {
      audioTheme?: Maybe<ResolversTypes['LearnMediaTheme']>
      featuredImage?: Maybe<ResolversTypes['LearnVisualAsset']>
    }
  >
  LearnAuthor: ResolverTypeWrapper<
    Omit<LearnAuthor, 'photo'> & { photo?: Maybe<ResolversTypes['LearnVisualAsset']> }
  >
  LearnInsight: ResolverTypeWrapper<LearnInsight>
  LearnMediaReference: ResolverTypeWrapper<
    Omit<LearnMediaReference, 'duration' | 'theme'> & {
      duration: ResolversTypes['LearnContentDuration']
      theme?: Maybe<ResolversTypes['LearnMediaTheme']>
    }
  >
  LearnAspectRatioType: LearnAspectRatioType
  LearnMetadata: ResolverTypeWrapper<
    Omit<LearnMetadata, 'contentStats' | 'interactionState'> & {
      contentStats?: Maybe<ResolversTypes['LearnContentCommunityStats']>
      interactionState?: Maybe<ResolversTypes['LearnContentInteractionState']>
    }
  >
  LearnContentCommunityStats: ResolversTypes['LearnContentStats']
  LearnContentStats: ResolverTypeWrapper<LearnContentStats>
  LearnContentInteractionState: ResolversTypes['LearnInteractionState']
  LearnInteractionState: ResolverTypeWrapper<
    Omit<LearnInteractionState, 'elapsedTime'> & {
      elapsedTime?: Maybe<ResolversTypes['LearnContentDuration']>
    }
  >
  LearnPoll: ResolverTypeWrapper<LearnPoll>
  LearnPollType: LearnPollType
  LearnTag: ResolverTypeWrapper<LearnTag>
  LearnNextStepAction: ResolverTypeWrapper<LearnNextStepAction>
  LearnContentPreview:
    | ResolversTypes['CoursePreview']
    | ResolversTypes['CoursePreviewLocked']
    | ResolversTypes['LearnArticlePreview']
    | ResolversTypes['LearnArticlePreviewLocked']
    | ResolversTypes['LearnMediaPreview']
    | ResolversTypes['LearnMediaPreviewLocked']
    | ResolversTypes['LearnPollPreview']
    | ResolversTypes['LearnPollPreviewLocked']
    | ResolversTypes['LessonPreview']
    | ResolversTypes['LessonPreviewLocked']
    | ResolversTypes['QuizPreview']
    | ResolversTypes['QuizPreviewLocked']
  CoursePreview: ResolverTypeWrapper<
    Omit<CoursePreview, 'courseTheme' | 'duration' | 'featuredImage'> & {
      courseTheme: ResolversTypes['CourseTheme']
      duration: ResolversTypes['LearnContentDuration']
      featuredImage: ResolversTypes['LearnVisualAsset']
    }
  >
  CourseTheme: ResolversTypes['LearnThemeLiteral']
  CoursePreviewLocked: ResolverTypeWrapper<
    Omit<CoursePreviewLocked, 'duration' | 'featuredImage'> & {
      duration: ResolversTypes['LearnContentDuration']
      featuredImage: ResolversTypes['LearnVisualAsset']
    }
  >
  LearnPollPreview: ResolverTypeWrapper<LearnPollPreview>
  LearnPollOption: ResolverTypeWrapper<LearnPollOption>
  LearnPollPreviewLocked: ResolverTypeWrapper<LearnPollPreviewLocked>
  LessonPreview: ResolverTypeWrapper<
    Omit<LessonPreview, 'duration' | 'featuredImage'> & {
      duration: ResolversTypes['LearnContentDuration']
      featuredImage: ResolversTypes['LearnVisualAsset']
    }
  >
  LessonPreviewLocked: ResolverTypeWrapper<
    Omit<LessonPreviewLocked, 'duration' | 'featuredImage'> & {
      duration: ResolversTypes['LearnContentDuration']
      featuredImage: ResolversTypes['LearnVisualAsset']
    }
  >
  QuizPreview: ResolverTypeWrapper<
    Omit<QuizPreview, 'duration' | 'featuredImage' | 'quizTheme'> & {
      duration: ResolversTypes['LearnContentDuration']
      featuredImage: ResolversTypes['LearnVisualAsset']
      quizTheme: ResolversTypes['QuizTheme']
    }
  >
  QuizTheme: ResolversTypes['LearnThemeLiteral']
  QuizPreviewLocked: ResolverTypeWrapper<
    Omit<QuizPreviewLocked, 'duration' | 'featuredImage'> & {
      duration: ResolversTypes['LearnContentDuration']
      featuredImage: ResolversTypes['LearnVisualAsset']
    }
  >
  Course: ResolverTypeWrapper<
    Omit<Course, 'duration' | 'featuredImage' | 'theme'> & {
      duration: ResolversTypes['LearnContentDuration']
      featuredImage: ResolversTypes['LearnVisualAsset']
      theme: ResolversTypes['CourseTheme']
    }
  >
  Lesson: ResolverTypeWrapper<Lesson>
  LearnCoursePreview: ResolversTypes['CoursePreview'] | ResolversTypes['CoursePreviewLocked']
  Quiz: ResolverTypeWrapper<
    Omit<Quiz, 'duration' | 'featuredImage' | 'theme'> & {
      duration: ResolversTypes['LearnContentDuration']
      featuredImage?: Maybe<ResolversTypes['LearnVisualAsset']>
      theme: ResolversTypes['QuizTheme']
    }
  >
  LearnQuestion: ResolverTypeWrapper<LearnQuestion>
  LearnAnswer: ResolverTypeWrapper<LearnAnswer>
  LearnQuestionInsight: ResolverTypeWrapper<LearnQuestionInsight>
  LearnQuestionType: LearnQuestionType
  LearnRangeType: LearnRangeType
  CompletedQuiz: ResolverTypeWrapper<CompletedQuiz>
  LearnArticle: ResolverTypeWrapper<
    Omit<LearnArticle, 'contentImage' | 'duration' | 'featuredImage'> & {
      contentImage?: Maybe<ResolversTypes['LearnVisualAsset']>
      duration: ResolversTypes['LearnContentDuration']
      featuredImage: ResolversTypes['LearnVisualAsset']
    }
  >
  LearnContentFilterInput: LearnContentFilterInput
  LearnSearchContentType: LearnSearchContentType
  MillisecondsInput: MillisecondsInput
  LearnContentViewStatus: LearnContentViewStatus
  LearnContentSortType: LearnContentSortType
  LearnContentPageInput: LearnContentPageInput
  ContentPreviewConnection: ResolverTypeWrapper<ContentPreviewConnection>
  LearnConnection: ResolversTypes['ContentPreviewConnection']
  LearnEdge: ResolversTypes['ContentPreviewEdge']
  LearnPageInfo: ResolverTypeWrapper<LearnPageInfo>
  ContentPreviewEdge: ResolverTypeWrapper<
    Omit<ContentPreviewEdge, 'node'> & { node: ResolversTypes['LearnContentPreview'] }
  >
  LearnContentFilterByTierIdInput: LearnContentFilterByTierIdInput
  LearnContentFilterByTopicIdInput: LearnContentFilterByTopicIdInput
  SearchHistory: ResolverTypeWrapper<SearchHistory>
  DocumentRequestInput: DocumentRequestInput
  DocumentRequest: ResolverTypeWrapper<DocumentRequest>
  Document: ResolverTypeWrapper<Document>
  RejectedReason: RejectedReason
  DocumentStatus: DocumentStatus
  DocumentRequestsInput: DocumentRequestsInput
  DocumentRequestsPageInput: DocumentRequestsPageInput
  DocumentQueryType: DocumentQueryType
  DocumentRequestsConnection: ResolverTypeWrapper<DocumentRequestsConnection>
  DocumentRequestEdge: ResolverTypeWrapper<DocumentRequestEdge>
  DocumentRequestsPageInfo: ResolverTypeWrapper<DocumentRequestsPageInfo>
  Authenticator: ResolversTypes['PhoneAuthenticator'] | ResolversTypes['EmailAuthenticator']
  AuthProfile: ResolverTypeWrapper<AuthProfile>
  EmailAddress: ResolverTypeWrapper<Scalars['EmailAddress']>
  LoginAccess: ResolverTypeWrapper<LoginAccess>
  AuthAlert: ResolversTypes['MfaMissingAuthAlert']
  PasswordResetForm: ResolverTypeWrapper<PasswordResetForm>
  PasswordResetFormFields: ResolverTypeWrapper<PasswordResetFormFields>
  EmailAddressValidation: ResolverTypeWrapper<EmailAddressValidation>
  ValidatePasswordResetTokenResult:
    | ResolversTypes['ValidatePasswordResetTokenSuccess']
    | ResolversTypes['InvalidPasswordResetTokenException']
  ValidatePasswordResetTokenSuccess: ResolverTypeWrapper<ValidatePasswordResetTokenSuccess>
  InvalidPasswordResetTokenException: ResolverTypeWrapper<InvalidPasswordResetTokenException>
  PromotionFilterInput: PromotionFilterInput
  PromotionPresentInContextsFilterInput: PromotionPresentInContextsFilterInput
  SubscriptionMigrationWaiver: ResolverTypeWrapper<SubscriptionMigrationWaiver>
  SubscriptionMigrationWaiverReason: SubscriptionMigrationWaiverReason
  TierGroup: ResolverTypeWrapper<TierGroup>
  TierOption: ResolverTypeWrapper<TierOption>
  TierOptionByTierPriceIdResult: ResolversTypes['InvalidTierPriceId'] | ResolversTypes['TierOption']
  InvalidTierPriceId: ResolverTypeWrapper<InvalidTierPriceId>
  TierSubscriptionForUser:
    | ResolversTypes['TierSubscription']
    | ResolversTypes['TierSubscriptionNotFound']
    | ResolversTypes['TierSubscriptionUnsubscribed']
  TierSubscriptionNotFound: ResolverTypeWrapper<TierSubscriptionNotFound>
  TierSubscriptionUnsubscribed: ResolverTypeWrapper<TierSubscriptionUnsubscribed>
  TierSubscriptionConnection: ResolverTypeWrapper<TierSubscriptionConnection>
  TierSubscriptionPageInfo: ResolverTypeWrapper<TierSubscriptionPageInfo>
  SplitDepositSettings:
    | ResolversTypes['SplitDepositDirectDepositIntentSetting']
    | ResolversTypes['SplitDepositDirectDepositSetting']
    | ResolversTypes['SplitDepositRecurrenceSetting']
  SplitDepositAllocation:
    | ResolversTypes['SplitDepositDirectDepositAllocation']
    | ResolversTypes['SplitDepositRecurrenceAllocation']
  SplitDepositTargetAccountType: SplitDepositTargetAccountType
  DistributionType: DistributionType
  Order: Order
  SplitDeposit: ResolverTypeWrapper<SplitDeposit>
  DistributionAmounts: ResolverTypeWrapper<DistributionAmounts>
  SplitDepositSettingsFilterInput: SplitDepositSettingsFilterInput
  SplitDepositSettingType: SplitDepositSettingType
  SplitDepositNormalizationFrequency: SplitDepositNormalizationFrequency
  SmartDepositMetadataInput: SmartDepositMetadataInput
  SmartDepositMetadataResult: ResolverTypeWrapper<SmartDepositMetadataResult>
  SplitDepositTargetAccount: ResolverTypeWrapper<SplitDepositTargetAccount>
  OutsideContributionCode: ResolverTypeWrapper<OutsideContributionCode>
  EarnCTARecord: ResolverTypeWrapper<EarnCtaRecord>
  FeeNegotiationOutput: ResolverTypeWrapper<FeeNegotiationOutput>
  FeeNegotiation: ResolverTypeWrapper<FeeNegotiation>
  BankConnection: ResolverTypeWrapper<BankConnection>
  BankConnectionStatus: BankConnectionStatus
  BankFeeNegotiationStatus: BankFeeNegotiationStatus
  BankFeeNegotiationGQLStatus: BankFeeNegotiationGqlStatus
  BankFeeNegotiationResults: ResolverTypeWrapper<BankFeeNegotiationResults>
  ServiceNode: ResolverTypeWrapper<ServiceNode>
  BillNegotiation: ResolverTypeWrapper<BillNegotiation>
  MailInNegotiationStatus: MailInNegotiationStatus
  BankFeeNegotiationAlert: ResolverTypeWrapper<BankFeeNegotiationAlert>
  BankFeeConnectionAlert: ResolverTypeWrapper<BankFeeConnectionAlert>
  BankName: BankName
  SubmissionStatus: SubmissionStatus
  BankFeeNegotiationAlertType: BankFeeNegotiationAlertType
  FeeStatusFilter: FeeStatusFilter
  BankFee: ResolverTypeWrapper<BankFee>
  BankFeeType: BankFeeType
  TransactionCategory: TransactionCategory
  FeeStatus: FeeStatus
  BankFeeSummary: ResolverTypeWrapper<BankFeeSummary>
  FeeStatusSummary: ResolverTypeWrapper<FeeStatusSummary>
  BankFeeConnection: ResolverTypeWrapper<BankFeeConnection>
  ConnectionStatus: ConnectionStatus
  Submission: ResolverTypeWrapper<Submission>
  AuthenticateForFeeNegotiationStatus: ResolverTypeWrapper<AuthenticateForFeeNegotiationStatus>
  CredentialStatus: CredentialStatus
  TfaOptions: ResolverTypeWrapper<TfaOptions>
  TfaNotification: TfaNotification
  TfaStatus: TfaStatus
  TfaType: TfaType
  OperationStage: OperationStage
  AutomationError: ResolverTypeWrapper<AutomationError>
  AutomationErrorCode: AutomationErrorCode
  MailInDocumentType: MailInDocumentType
  MailInDocument: ResolverTypeWrapper<MailInDocument>
  LOBThumbNails: ResolverTypeWrapper<LobThumbNails>
  SampleMailInDocument: ResolverTypeWrapper<SampleMailInDocument>
  PartnerUrlInput: PartnerUrlInput
  BenefitsProduct: BenefitsProduct
  PartnerUrlResponse: ResolverTypeWrapper<PartnerUrlResponse>
  AcornsPartnerStatus: AcornsPartnerStatus
  PartnerDocumentUrlResponse: ResolverTypeWrapper<PartnerDocumentUrlResponse>
  PartnerDetailsResponse: ResolverTypeWrapper<PartnerDetailsResponse>
  BenefitsPartner: BenefitsPartner
  Advocate: ResolverTypeWrapper<Advocate>
  Friend: ResolverTypeWrapper<Friend>
  ReferralCampaign: ResolverTypeWrapper<ReferralCampaign>
  ReferralEvent: ResolverTypeWrapper<ReferralEvent>
  ReferralEventType: ReferralEventType
  ReferralEventStatus: ReferralEventStatus
  ReferralReward: ResolverTypeWrapper<ReferralReward>
  ReferralValueType: ReferralValueType
  ReferralRewardStatus: ReferralRewardStatus
  FriendStatus: FriendStatus
  FriendExperienceContent: ResolverTypeWrapper<FriendExperienceContent>
  ReferralHistory: ResolverTypeWrapper<ReferralHistory>
  FriendSummary: ResolverTypeWrapper<FriendSummary>
  ExperienceContent: ResolverTypeWrapper<ExperienceContent>
  RegistrationFunnelFilter: RegistrationFunnelFilter
  RegistrationFunnel: ResolverTypeWrapper<RegistrationFunnel>
  RegistrationPage: ResolverTypeWrapper<RegistrationPage>
  RegistrationPageAction: ResolverTypeWrapper<RegistrationPageAction>
  PageName: PageName
  ActionType: ActionType
  FunnelMetadata: ResolverTypeWrapper<FunnelMetadata>
  FunnelName: FunnelName
  SourceAttributes: ResolverTypeWrapper<SourceAttributes>
  SecurityBySymbolInput: SecurityBySymbolInput
  SecuritiesBySymbolsInput: SecuritiesBySymbolsInput
  SecuritiesBySymbolsResponse: ResolverTypeWrapper<SecuritiesBySymbolsResponse>
  SecurityPerformanceBySymbolInput: SecurityPerformanceBySymbolInput
  SecurityPerformance: ResolverTypeWrapper<SecurityPerformance>
  SecurityGain: ResolverTypeWrapper<SecurityGain>
  SecurityPrice: ResolverTypeWrapper<SecurityPrice>
  SecurityPerformancesBySymbolInput: SecurityPerformancesBySymbolInput
  SearchSecuritiesInput: SearchSecuritiesInput
  SearchSecuritiesOrderBy: SearchSecuritiesOrderBy
  SearchSecuritiesResponse: ResolverTypeWrapper<SearchSecuritiesResponse>
  SearchSecuritiesPageInfo: ResolverTypeWrapper<SearchSecuritiesPageInfo>
  SecuritiesBySectorInput: SecuritiesBySectorInput
  SecuritiesBySectorOrderBY: SecuritiesBySectorOrderBy
  SecuritiesBySectorResponse: ResolverTypeWrapper<SecuritiesBySectorResponse>
  SecuritiesBySectorPageInfo: ResolverTypeWrapper<SecuritiesBySectorPageInfo>
  CohortEligibilityScope: CohortEligibilityScope
  CohortEligibility: ResolverTypeWrapper<CohortEligibility>
  Mutation: ResolverTypeWrapper<{}>
  Void: ResolverTypeWrapper<Scalars['Void']>
  SetPortfolioInput: SetPortfolioInput
  RequestAccountClosureInput: RequestAccountClosureInput
  ConnectACHAccountInput: ConnectAchAccountInput
  RoutingNumber: ResolverTypeWrapper<Scalars['RoutingNumber']>
  AccountNumber: ResolverTypeWrapper<Scalars['AccountNumber']>
  ConnectACHAccountResult:
    | ResolversTypes['InstitutionNotSupportedError']
    | ResolversTypes['ConnectACHAccountSucceeded']
  InstitutionNotSupportedError: ResolverTypeWrapper<InstitutionNotSupportedError>
  ConnectACHAccountSucceeded: ResolverTypeWrapper<ConnectAchAccountSucceeded>
  Session: ResolverTypeWrapper<Session>
  TransactionResult: ResolverTypeWrapper<TransactionResult>
  MakeInvestmentInput: MakeInvestmentInput
  InvestmentTypes: InvestmentTypes
  MakeInvestmentPayload: ResolverTypeWrapper<MakeInvestmentPayload>
  RecurringInvestmentInput: RecurringInvestmentInput
  RecurringInvestmentPayload: ResolverTypeWrapper<RecurringInvestmentPayload>
  StateCode: StateCode
  LadderResponse: ResolverTypeWrapper<LadderResponse>
  LadderQuoteStatus: ResolverTypeWrapper<LadderQuoteStatus>
  LadderQuote: ResolverTypeWrapper<LadderQuote>
  LadderLinkResponse: ResolverTypeWrapper<LadderLinkResponse>
  CustodianAddressInput: CustodianAddressInput
  PdfFormLinks: ResolverTypeWrapper<PdfFormLinks>
  InvestmentAccountTypes: InvestmentAccountTypes
  CreateInvestmentAccountResponse: ResolverTypeWrapper<CreateInvestmentAccountResponse>
  ProfileAttribute: ProfileAttribute
  laterTotalLiquidationInput: LaterTotalLiquidationInput
  LaterWithdrawalType: LaterWithdrawalType
  LaterIndividualBeneficiaryResponse: ResolverTypeWrapper<LaterIndividualBeneficiaryResponse>
  ContactInfoInput: ContactInfoInput
  EmploymentInput: EmploymentInput
  SuitabilityInput: SuitabilityInput
  InvestorQuestionsInput: InvestorQuestionsInput
  PersonalInfoInput: PersonalInfoInput
  UpdateUserInfoResult:
    | ResolversTypes['User']
    | ResolversTypes['SSNUsedError']
    | ResolversTypes['InvalidSSNError']
    | ResolversTypes['POBoxAddressError']
  SSNUsedError: ResolverTypeWrapper<SsnUsedError>
  InvalidSSNError: ResolverTypeWrapper<InvalidSsnError>
  POBoxAddressError: ResolverTypeWrapper<PoBoxAddressError>
  SecurityQuestionInput: SecurityQuestionInput
  BeneficiaryInput: BeneficiaryInput
  CreateBeneficiaryResult:
    | ResolversTypes['Beneficiary']
    | ResolversTypes['BeneficiaryExceedsAgeLimitException']
    | ResolversTypes['InternalErrorException']
    | ResolversTypes['InvalidDateOfBirthException']
    | ResolversTypes['InvalidFirstNameException']
    | ResolversTypes['InvalidLastNameException']
  BeneficiaryExceedsAgeLimitException: ResolverTypeWrapper<BeneficiaryExceedsAgeLimitException>
  InvalidDateOfBirthException: ResolverTypeWrapper<InvalidDateOfBirthException>
  InvalidFirstNameException: ResolverTypeWrapper<InvalidFirstNameException>
  InvalidLastNameException: ResolverTypeWrapper<InvalidLastNameException>
  DeactivateBeneficiaryResult:
    | ResolversTypes['Beneficiary']
    | ResolversTypes['BeneficiaryNotFoundException']
    | ResolversTypes['InternalErrorException']
  BeneficiaryNotFoundException: ResolverTypeWrapper<BeneficiaryNotFoundException>
  SetBeneficiarySsnResult:
    | ResolversTypes['Beneficiary']
    | ResolversTypes['BeneficiaryNotFoundException']
    | ResolversTypes['InternalErrorException']
    | ResolversTypes['InvalidSsnException']
    | ResolversTypes['SecretSquirrelException']
    | ResolversTypes['SsnAlreadyInUseException']
    | ResolversTypes['SsnMatchesCustodianException']
    | ResolversTypes['SsnUpdateForbiddenException']
  InvalidSsnException: ResolverTypeWrapper<InvalidSsnException>
  SecretSquirrelException: ResolverTypeWrapper<SecretSquirrelException>
  SsnAlreadyInUseException: ResolverTypeWrapper<SsnAlreadyInUseException>
  SsnMatchesCustodianException: ResolverTypeWrapper<SsnMatchesCustodianException>
  SsnUpdateForbiddenException: ResolverTypeWrapper<SsnUpdateForbiddenException>
  AddressInput: AddressInput
  BeneficiaryInfoInput: BeneficiaryInfoInput
  UpdateBeneficiaryInfoResult:
    | ResolversTypes['Beneficiary']
    | ResolversTypes['BeneficiaryNotFoundException']
    | ResolversTypes['InternalErrorException']
    | ResolversTypes['InvalidAddressException']
    | ResolversTypes['InvalidEmailException']
    | ResolversTypes['InvalidPhoneException']
  InvalidAddressException: ResolverTypeWrapper<InvalidAddressException>
  InvalidEmailException: ResolverTypeWrapper<InvalidEmailException>
  InvalidPhoneException: ResolverTypeWrapper<InvalidPhoneException>
  ProfileInput: ProfileInput
  ActivateBankCardInput: ActivateBankCardInput
  ActivateBankCardPayload: ResolverTypeWrapper<ActivateBankCardPayload>
  CreateBankAccountInput: CreateBankAccountInput
  CreateBankAccountPayload: ResolverTypeWrapper<CreateBankAccountPayload>
  LockBankCardInput: LockBankCardInput
  BankCardTemporaryLockReason: BankCardTemporaryLockReason
  LockBankCardPayload: ResolverTypeWrapper<LockBankCardPayload>
  OrderBankCardInput: OrderBankCardInput
  BankCardPrefundTransfer: BankCardPrefundTransfer
  PositiveCurrencyAmountInput: PositiveCurrencyAmountInput
  PositiveFloat: ResolverTypeWrapper<Scalars['PositiveFloat']>
  OrderBankCardResult: ResolversTypes['BankCardOrder']
  UnlockBankCardPayload: ResolverTypeWrapper<UnlockBankCardPayload>
  UpdateBankCardPinInput: UpdateBankCardPinInput
  BankCardPin: ResolverTypeWrapper<Scalars['BankCardPin']>
  UpdateBankCardPinPayload: ResolverTypeWrapper<UpdateBankCardPinPayload>
  ReportBankCardLostStolenInput: ReportBankCardLostStolenInput
  BankCardPermanentLockReason: BankCardPermanentLockReason
  ReportBankCardLostStolenPayload: ResolverTypeWrapper<ReportBankCardLostStolenPayload>
  DeleteExpiredBankCardOrderResult:
    | ResolversTypes['BankCardOrder']
    | ResolversTypes['DeleteExpiredBankCardOrderNotFoundError']
    | ResolversTypes['DeleteExpiredBankCardOrderNotExpiredError']
    | ResolversTypes['DeleteExpiredBankCardOrderCardTierNotFoundError']
  DeleteExpiredBankCardOrderNotFoundError: ResolverTypeWrapper<
    DeleteExpiredBankCardOrderNotFoundError
  >
  DeleteExpiredBankCardOrderNotExpiredError: ResolverTypeWrapper<
    DeleteExpiredBankCardOrderNotExpiredError
  >
  DeleteExpiredBankCardOrderCardTierNotFoundError: ResolverTypeWrapper<
    DeleteExpiredBankCardOrderCardTierNotFoundError
  >
  CloseBankAccountInput: CloseBankAccountInput
  CloseBankAccountResult: ResolversTypes['BankAccount'] | ResolversTypes['BankAccountNotFoundError']
  BankAccountNotFoundError: ResolverTypeWrapper<BankAccountNotFoundError>
  ReissueBankCardInput: ReissueBankCardInput
  BankCardRequestMailingAddressInput: BankCardRequestMailingAddressInput
  ReissueBankCardResult:
    | ResolversTypes['BankCardRequest']
    | ResolversTypes['ReissueBankCardExistsError']
  ReissueBankCardExistsError: ResolverTypeWrapper<ReissueBankCardExistsError>
  SubmitSpendTransactionsDisputeInput: SubmitSpendTransactionsDisputeInput
  SpendTransactionsInput: SpendTransactionsInput
  SpendTransactionsDisputeResult: ResolversTypes['SpendTransactionsDisputeResponse']
  SpendTransactionsDisputeResponse: ResolverTypeWrapper<SpendTransactionsDisputeResponse>
  SpendTransactionsDisputeCustomersResponse: ResolverTypeWrapper<
    SpendTransactionsDisputeCustomersResponse
  >
  SpendDisputesResponse: ResolverTypeWrapper<SpendDisputesResponse>
  SpendTransactionsDisputeQuestions: ResolverTypeWrapper<SpendTransactionsDisputeQuestions>
  SpendTransactionsResponse: ResolverTypeWrapper<SpendTransactionsResponse>
  CreateSavingsAccountInput: CreateSavingsAccountInput
  BankAccountGoalInput: BankAccountGoalInput
  CreateSavingsAccountResult:
    | ResolversTypes['CreateSavingsAccountPayload']
    | ResolversTypes['CreateSavingsAccountVerificationError']
  CreateSavingsAccountPayload: ResolverTypeWrapper<CreateSavingsAccountPayload>
  CreateSavingsAccountVerificationError: ResolverTypeWrapper<CreateSavingsAccountVerificationError>
  UpdateBankAccountGoalInput: UpdateBankAccountGoalInput
  UpdateBankAccountGoalResult: ResolversTypes['UpdateBankAccountGoalPayload']
  UpdateBankAccountGoalPayload: ResolverTypeWrapper<UpdateBankAccountGoalPayload>
  AssignLinkedSubaccountInput: AssignLinkedSubaccountInput
  CreatePlaidLinkedAccountInput: CreatePlaidLinkedAccountInput
  GenerateLinkSessionInput: GenerateLinkSessionInput
  LinkSessionLanguage: LinkSessionLanguage
  LinkSessionResult:
    | ResolversTypes['RawLinkSession']
    | ResolversTypes['UnrecoverableLinkedAccountError']
    | ResolversTypes['WebviewLinkSession']
  RawLinkSession: ResolverTypeWrapper<RawLinkSession>
  UnrecoverableLinkedAccountError: ResolverTypeWrapper<UnrecoverableLinkedAccountError>
  WebviewLinkSession: ResolverTypeWrapper<WebviewLinkSession>
  LinkSessionInput: LinkSessionInput
  RegisterLinkSessionResult:
    | ResolversTypes['AsyncLinkSessionResult']
    | ResolversTypes['LinkedAccount']
  AsyncLinkSessionResult: ResolverTypeWrapper<AsyncLinkSessionResult>
  SetLinkingErrorInput: SetLinkingErrorInput
  LinkedAccountLinkingErrorsEnum: LinkedAccountLinkingErrorsEnum
  UpdateLinkedAccountInput: UpdateLinkedAccountInput
  RoundUpProfileInput: RoundUpProfileInput
  InitiateTransferInput: InitiateTransferInput
  InitiateTransferPayload: ResolverTypeWrapper<InitiateTransferPayload>
  Transfer: ResolverTypeWrapper<Transfer>
  TransferState: TransferState
  CancelTransferPayload: ResolverTypeWrapper<CancelTransferPayload>
  StartCheckDepositInput: StartCheckDepositInput
  ClientInfo: ClientInfo
  StartCheckDepositPayload: ResolverTypeWrapper<StartCheckDepositPayload>
  UploadCheckInput: UploadCheckInput
  CheckImage: CheckImage
  ImageType: ImageType
  UploadCheckPayload: ResolverTypeWrapper<UploadCheckPayload>
  CompleteCheckDepositInput: CompleteCheckDepositInput
  CompleteCheckDepositPayload: ResolverTypeWrapper<CompleteCheckDepositPayload>
  CreateSupportTicketInput: CreateSupportTicketInput
  SupportTicket: ResolverTypeWrapper<SupportTicket>
  SupportTicketResponse: ResolversTypes['SupportTicket'] | ResolversTypes['RecaptchaException']
  RecaptchaException: ResolverTypeWrapper<RecaptchaException>
  CreateCustomSupportTicketInput: CreateCustomSupportTicketInput
  SupportTicketWithCustomFieldsResponse:
    | ResolversTypes['SupportTicket']
    | ResolversTypes['SubmissionError']
  SubmissionError: ResolverTypeWrapper<SubmissionError>
  CreateSuspendedUserSupportTicketInput: CreateSuspendedUserSupportTicketInput
  CreateDirectDepositLinkInfoInput: CreateDirectDepositLinkInfoInput
  PinwheelLinkTokenRequiredJobs: PinwheelLinkTokenRequiredJobs
  DirectDepositVendor: DirectDepositVendor
  CreateDirectDepositLinkInfoSwitch:
    | ResolversTypes['CreateDirectDepositLinkInfoFailure']
    | ResolversTypes['CreateDirectDepositLinkInfoPayload']
  CreateDirectDepositLinkInfoFailure: ResolverTypeWrapper<CreateDirectDepositLinkInfoFailure>
  CreateDirectDepositLinkInfoPayload: ResolverTypeWrapper<CreateDirectDepositLinkInfoPayload>
  CreatePinwheelLinkToken: ResolverTypeWrapper<CreatePinwheelLinkToken>
  StartAcornsPdfSwitchInput: StartAcornsPdfSwitchInput
  StartOnlineSwitchInput: StartOnlineSwitchInput
  StartOnlineSwitchPayload: ResolverTypeWrapper<StartOnlineSwitchPayload>
  SwitchPayloadInterface:
    | ResolversTypes['StartOnlineSwitchPayload']
    | ResolversTypes['StartSubmittableSwitchPayload']
  UserSwitch: ResolverTypeWrapper<UserSwitch>
  SwitchStatus: SwitchStatus
  StartSubmittableSwitchInput: StartSubmittableSwitchInput
  StartSubmittableSwitchAddressInput: StartSubmittableSwitchAddressInput
  StartSubmittableSwitchPayload: ResolverTypeWrapper<StartSubmittableSwitchPayload>
  suitability_SuitabilityInput: Suitability_SuitabilityInput
  suitability_UpdateSuitabilityResult: ResolverTypeWrapper<Suitability_UpdateSuitabilityResult>
  CancelCheckPaymentResult:
    | ResolversTypes['CheckPayment']
    | ResolversTypes['ResourceNotFoundError']
    | ResolversTypes['UnableToCancelCheckError']
    | ResolversTypes['AuthorizationError']
  ResourceNotFoundError: ResolverTypeWrapper<ResourceNotFoundError>
  UnableToCancelCheckError: ResolverTypeWrapper<UnableToCancelCheckError>
  SendCheckPaymentInput: SendCheckPaymentInput
  SendCheckPaymentResult:
    | ResolversTypes['CheckPayment']
    | ResolversTypes['AuthorizationError']
    | ResolversTypes['DuplicateActionError']
    | ResolversTypes['InvalidAddressError']
  DuplicateActionError: ResolverTypeWrapper<DuplicateActionError>
  AcceptDocumentInput: AcceptDocumentInput
  AcceptanceDocumentType: AcceptanceDocumentType
  AcceptDocumentResponse:
    | ResolversTypes['AcceptedDocument']
    | ResolversTypes['DocumentNotFound']
    | ResolversTypes['UserNotFound']
  AcceptedDocument: ResolverTypeWrapper<AcceptedDocument>
  DocumentNotFound: ResolverTypeWrapper<DocumentNotFound>
  UserNotFound: ResolverTypeWrapper<UserNotFound>
  AddSecurityToPortfolioInput: AddSecurityToPortfolioInput
  AddSecurityToPortfolioResult:
    | ResolversTypes['InvestmentAccountNotFoundException']
    | ResolversTypes['InvestmentAccountNotSupportedException']
    | ResolversTypes['Portfolio']
    | ResolversTypes['PortfolioNotFoundException']
    | ResolversTypes['PortfolioNotSupportedException']
    | ResolversTypes['SecurityNotSupportedException']
  InvestmentAccountNotFoundException: ResolverTypeWrapper<InvestmentAccountNotFoundException>
  InvestmentAccountNotSupportedException: ResolverTypeWrapper<
    InvestmentAccountNotSupportedException
  >
  PortfolioNotFoundException: ResolverTypeWrapper<PortfolioNotFoundException>
  PortfolioNotSupportedException: ResolverTypeWrapper<PortfolioNotSupportedException>
  SecurityNotSupportedException: ResolverTypeWrapper<SecurityNotSupportedException>
  AddSelfDirectedPortfolioInput: AddSelfDirectedPortfolioInput
  AddSelfDirectedPortfolioResult:
    | ResolversTypes['CustomerAgreementRequiredException']
    | ResolversTypes['InvalidInvestmentAccountException']
    | ResolversTypes['InvalidSubscriptionTierException']
    | ResolversTypes['InvestmentAccount']
    | ResolversTypes['PortfolioNotFoundException']
  CustomerAgreementRequiredException: ResolverTypeWrapper<CustomerAgreementRequiredException>
  InvalidInvestmentAccountException: ResolverTypeWrapper<InvalidInvestmentAccountException>
  InvalidSubscriptionTierException: ResolverTypeWrapper<InvalidSubscriptionTierException>
  CancelInvestmentInput: CancelInvestmentInput
  CancelInvestmentResult:
    | ResolversTypes['CancelInvestmentPayload']
    | ResolversTypes['InvestmentNotFoundException']
    | ResolversTypes['InvestmentUncancellableException']
  CancelInvestmentPayload: ResolverTypeWrapper<CancelInvestmentPayload>
  InvestmentNotFoundException: ResolverTypeWrapper<InvestmentNotFoundException>
  InvestmentUncancellableException: ResolverTypeWrapper<InvestmentUncancellableException>
  CancelInvestmentAccountClosureRequestInput: CancelInvestmentAccountClosureRequestInput
  CancelInvestmentAccountClosureRequestResult:
    | ResolversTypes['AccountClosedException']
    | ResolversTypes['AccountNotFoundException']
    | ResolversTypes['ClosureRequestDoesNotExistException']
    | ResolversTypes['InvestmentAccount']
  AccountClosedException: ResolverTypeWrapper<AccountClosedException>
  AccountNotFoundException: ResolverTypeWrapper<AccountNotFoundException>
  ClosureRequestDoesNotExistException: ResolverTypeWrapper<ClosureRequestDoesNotExistException>
  CloseInvestmentAccountInput: CloseInvestmentAccountInput
  CloseInvestmentAccountResult:
    | ResolversTypes['AccountNotFoundException']
    | ResolversTypes['InvestmentAccount']
    | ResolversTypes['InvestmentAccountAlreadyClosed']
    | ResolversTypes['InvestmentAccountClosureInProgress']
    | ResolversTypes['NonBasicAccountOpenException']
  InvestmentAccountAlreadyClosed: ResolverTypeWrapper<InvestmentAccountAlreadyClosed>
  InvestmentAccountClosureInProgress: ResolverTypeWrapper<InvestmentAccountClosureInProgress>
  NonBasicAccountOpenException: ResolverTypeWrapper<NonBasicAccountOpenException>
  CloseUserAccountResult:
    | ResolversTypes['OpenAccountsException']
    | ResolversTypes['UserNotFoundException']
    | ResolversTypes['User_v2']
  OpenAccountsException: ResolverTypeWrapper<OpenAccountsException>
  User_v2: ResolverTypeWrapper<User_V2>
  CreateProspectUserInput: CreateProspectUserInput
  ProspectType: ProspectType
  CreateProspectUserResult:
    | ResolversTypes['GrowProspect']
    | ResolversTypes['InternalErrorException']
    | ResolversTypes['LaterWaitlistProspect']
    | ResolversTypes['OutsideContributionProspect']
    | ResolversTypes['User_v2']
  GrowProspect: ResolverTypeWrapper<GrowProspect>
  Prospect:
    | ResolversTypes['GrowProspect']
    | ResolversTypes['LaterWaitlistProspect']
    | ResolversTypes['OutsideContributionProspect']
  LaterWaitlistProspect: ResolverTypeWrapper<LaterWaitlistProspect>
  OutsideContributionProspect: ResolverTypeWrapper<OutsideContributionProspect>
  CreateUploadUrlInput: CreateUploadUrlInput
  CreateUploadUrlResult: ResolversTypes['UploadUrl']
  UploadUrl: ResolverTypeWrapper<UploadUrl>
  EnableQuarterlyRecapsInput: EnableQuarterlyRecapsInput
  EnableQuarterlyRecapsResult:
    | ResolversTypes['InvalidSubscriptionTierException']
    | ResolversTypes['InvestmentAccount']
    | ResolversTypes['InvestmentAccountNotFoundException']
    | ResolversTypes['InvestmentAccountNotSupportedException']
  LegacyUploadDocumentInput: LegacyUploadDocumentInput
  Upload: ResolverTypeWrapper<Scalars['Upload']>
  LegacyUploadDocumentResult:
    | ResolversTypes['FileDoesNotExistInS3']
    | ResolversTypes['FileTooLarge']
    | ResolversTypes['InvalidFile']
    | ResolversTypes['LegacyUploadDocument']
    | ResolversTypes['UploadDoesNotExist']
  FileDoesNotExistInS3: ResolverTypeWrapper<FileDoesNotExistInS3>
  FileTooLarge: ResolverTypeWrapper<FileTooLarge>
  InvalidFile: ResolverTypeWrapper<InvalidFile>
  LegacyUploadDocument: ResolverTypeWrapper<LegacyUploadDocument>
  UploadDoesNotExist: ResolverTypeWrapper<UploadDoesNotExist>
  LinkManualFundingSourceInput: LinkManualFundingSourceInput
  LinkManualFundingSourceResult:
    | ResolversTypes['CurrentBankStatementNotProvided']
    | ResolversTypes['FundingSourceAccount']
    | ResolversTypes['FundingSourceAlreadyExists']
    | ResolversTypes['FundingSourceCredentialsExceedLinkLimit']
    | ResolversTypes['InvalidAccountNumber']
    | ResolversTypes['InvalidManualLink']
    | ResolversTypes['InvalidRoutingNumber']
    | ResolversTypes['PreviousFundingSourcePending']
    | ResolversTypes['RdvVerificationRequired']
  CurrentBankStatementNotProvided: ResolverTypeWrapper<CurrentBankStatementNotProvided>
  FundingSourceAlreadyExists: ResolverTypeWrapper<FundingSourceAlreadyExists>
  FundingSourceCredentialsExceedLinkLimit: ResolverTypeWrapper<
    FundingSourceCredentialsExceedLinkLimit
  >
  InvalidAccountNumber: ResolverTypeWrapper<InvalidAccountNumber>
  InvalidManualLink: ResolverTypeWrapper<InvalidManualLink>
  InvalidRoutingNumber: ResolverTypeWrapper<InvalidRoutingNumber>
  PreviousFundingSourcePending: ResolverTypeWrapper<PreviousFundingSourcePending>
  RdvVerificationRequired: ResolverTypeWrapper<RdvVerificationRequired>
  OpenCoreInvestmentAccountInput: OpenCoreInvestmentAccountInput
  OpenCoreInvestmentAccountResult:
    | ResolversTypes['CoreAccountAlreadyExistsException']
    | ResolversTypes['InvalidPortfolioIdException']
    | ResolversTypes['InvestmentAccount']
    | ResolversTypes['InvestmentAccountCreationException']
    | ResolversTypes['UserClosedException']
    | ResolversTypes['UserNotFoundException']
  CoreAccountAlreadyExistsException: ResolverTypeWrapper<CoreAccountAlreadyExistsException>
  InvalidPortfolioIdException: ResolverTypeWrapper<InvalidPortfolioIdException>
  InvestmentAccountCreationException: ResolverTypeWrapper<InvestmentAccountCreationException>
  UserClosedException: ResolverTypeWrapper<UserClosedException>
  OpenEarlyAccountInput: OpenEarlyAccountInput
  OpenEarlyAccountResult:
    | ResolversTypes['BeneficiaryAccountExistsException']
    | ResolversTypes['CoreAccountClosedException']
    | ResolversTypes['InternalErrorException']
    | ResolversTypes['InvalidStateException']
    | ResolversTypes['InvalidSubscriptionTierException']
    | ResolversTypes['InvalidTerminationAgeException']
    | ResolversTypes['InvestmentAccount']
    | ResolversTypes['MaxAccountsCreatedException']
    | ResolversTypes['MissingBeneficiarySsnException']
    | ResolversTypes['NoBeneficiaryFoundException']
    | ResolversTypes['UserClosedException']
    | ResolversTypes['UserNotFoundException']
    | ResolversTypes['UserNotVerifiedException']
  BeneficiaryAccountExistsException: ResolverTypeWrapper<BeneficiaryAccountExistsException>
  CoreAccountClosedException: ResolverTypeWrapper<CoreAccountClosedException>
  InvalidTerminationAgeException: ResolverTypeWrapper<InvalidTerminationAgeException>
  MaxAccountsCreatedException: ResolverTypeWrapper<MaxAccountsCreatedException>
  MissingBeneficiarySsnException: ResolverTypeWrapper<MissingBeneficiarySsnException>
  NoBeneficiaryFoundException: ResolverTypeWrapper<NoBeneficiaryFoundException>
  UserNotVerifiedException: ResolverTypeWrapper<UserNotVerifiedException>
  PartnerLinkFundingSourceInput: PartnerLinkFundingSourceInput
  PartnerLinkFundingSourceResult:
    | ResolversTypes['CurrentBankStatementNotProvided']
    | ResolversTypes['FundingSourceAccount']
    | ResolversTypes['FundingSourceAlreadyExists']
    | ResolversTypes['FundingSourceCredentialsExceedLinkLimit']
    | ResolversTypes['InvalidAccountNumber']
    | ResolversTypes['InvalidAccountToken']
    | ResolversTypes['InvalidManualLink']
    | ResolversTypes['InvalidRoutingNumber']
    | ResolversTypes['PreviousFundingSourcePending']
    | ResolversTypes['RdvVerificationRequired']
  InvalidAccountToken: ResolverTypeWrapper<InvalidAccountToken>
  RecordInvestmentAccountRecapViewInput: RecordInvestmentAccountRecapViewInput
  RecordInvestmentAccountRecapViewResult:
    | ResolversTypes['InvestmentAccountRecap']
    | ResolversTypes['InvestmentAccountRecapNotFoundException']
  InvestmentAccountRecapNotFoundException: ResolverTypeWrapper<
    InvestmentAccountRecapNotFoundException
  >
  RegenerateInvestmentAccountRecapPublicTokenInput: RegenerateInvestmentAccountRecapPublicTokenInput
  RegenerateInvestmentAccountRecapPublicTokenResult:
    | ResolversTypes['InvestmentAccountRecap']
    | ResolversTypes['InvestmentAccountRecapNotFoundException']
  RemoveSecurityFromPortfolioInput: RemoveSecurityFromPortfolioInput
  RemoveSecurityFromPortfolioResult:
    | ResolversTypes['InvestmentAccountNotFoundException']
    | ResolversTypes['InvestmentAccountNotSupportedException']
    | ResolversTypes['Portfolio']
    | ResolversTypes['PortfolioNotFoundException']
    | ResolversTypes['PortfolioNotSupportedException']
    | ResolversTypes['SecurityNotSupportedException']
  RemoveSelfDirectedPortfolioInput: RemoveSelfDirectedPortfolioInput
  RemoveSelfDirectedPortfolioResult:
    | ResolversTypes['AccountNotFoundException']
    | ResolversTypes['InvestmentAccount']
    | ResolversTypes['InvestmentAccountAlreadyClosed']
    | ResolversTypes['InvestmentAccountClosureInProgress']
    | ResolversTypes['PortfolioAlreadyRemovedError']
    | ResolversTypes['PortfolioNotFoundException']
    | ResolversTypes['PortfolioRemovalInProgressError']
  PortfolioAlreadyRemovedError: ResolverTypeWrapper<PortfolioAlreadyRemovedError>
  PortfolioRemovalInProgressError: ResolverTypeWrapper<PortfolioRemovalInProgressError>
  ReopenUserAccountResult:
    | ResolversTypes['UserNotFoundException']
    | ResolversTypes['UserReopenLockedException']
    | ResolversTypes['UserReopenSuspendedException']
    | ResolversTypes['User_v2']
  UserReopenLockedException: ResolverTypeWrapper<UserReopenLockedException>
  UserReopenSuspendedException: ResolverTypeWrapper<UserReopenSuspendedException>
  RequestEarlyAccountClosureInput: RequestEarlyAccountClosureInput
  RequestEarlyAccountClosureResult:
    | ResolversTypes['AccountAlreadyClosedException']
    | ResolversTypes['ClosureRequestExistsException']
    | ResolversTypes['FundingSourceRequiresRdvException']
    | ResolversTypes['InternalErrorException']
    | ResolversTypes['InvalidAccountTypeException']
    | ResolversTypes['InvestmentAccount']
    | ResolversTypes['InvestmentAccountNeedsTransferException']
    | ResolversTypes['MissingFundingSourceException']
  AccountAlreadyClosedException: ResolverTypeWrapper<AccountAlreadyClosedException>
  ClosureRequestExistsException: ResolverTypeWrapper<ClosureRequestExistsException>
  FundingSourceRequiresRdvException: ResolverTypeWrapper<FundingSourceRequiresRdvException>
  InvalidAccountTypeException: ResolverTypeWrapper<InvalidAccountTypeException>
  InvestmentAccountNeedsTransferException: ResolverTypeWrapper<
    InvestmentAccountNeedsTransferException
  >
  MissingFundingSourceException: ResolverTypeWrapper<MissingFundingSourceException>
  RequestInvestmentAccountReopenInput: RequestInvestmentAccountReopenInput
  RequestInvestmentAccountReopenResult:
    | ResolversTypes['ExistingRequestPendingReview']
    | ResolversTypes['ExistingRequestPendingUserAction']
    | ResolversTypes['InvalidSubscriptionTierException']
    | ResolversTypes['InvestmentAccountNotClosedException']
    | ResolversTypes['InvestmentAccountNotFoundException']
    | ResolversTypes['InvestmentAccountReopenRequest']
  ExistingRequestPendingReview: ResolverTypeWrapper<ExistingRequestPendingReview>
  InvestmentAccountReopenRequest: ResolverTypeWrapper<InvestmentAccountReopenRequest>
  InvestmentAccountReopenRequestAction: ResolverTypeWrapper<InvestmentAccountReopenRequestAction>
  InvestmentAccountReopenRequestNote: ResolverTypeWrapper<InvestmentAccountReopenRequestNote>
  UserInvestmentAccountReopenCheck: ResolverTypeWrapper<UserInvestmentAccountReopenCheck>
  InvestmentAccountReopenCheck: InvestmentAccountReopenCheck
  InvestmentAccountReopenRequestState: InvestmentAccountReopenRequestState
  ExistingRequestPendingUserAction: ResolverTypeWrapper<ExistingRequestPendingUserAction>
  InvestmentAccountNotClosedException: ResolverTypeWrapper<InvestmentAccountNotClosedException>
  SaveUploadUrlInput: SaveUploadUrlInput
  SetInvestmentAccountRecapPublicAccessInput: SetInvestmentAccountRecapPublicAccessInput
  SetInvestmentAccountRecapPublicAccessResult:
    | ResolversTypes['InvestmentAccountRecap']
    | ResolversTypes['InvestmentAccountRecapNotFoundException']
  UnauthenticatedCreateUploadUrlInput: UnauthenticatedCreateUploadUrlInput
  UnauthenticatedSaveUploadUrlInput: UnauthenticatedSaveUploadUrlInput
  UnauthenticatedSaveUploadUrlResult:
    | ResolversTypes['DocumentUploads']
    | ResolversTypes['UploadSaveError']
  DocumentUploads: ResolverTypeWrapper<DocumentUploads>
  UploadSaveError: ResolverTypeWrapper<
    Omit<UploadSaveError, 'uploadExceptions'> & {
      uploadExceptions: Array<ResolversTypes['UploadSaveExceptions']>
    }
  >
  UploadSaveExceptions:
    | ResolversTypes['FileDoesNotExistError']
    | ResolversTypes['UploadDoesNotExistError']
  FileDoesNotExistError: ResolverTypeWrapper<FileDoesNotExistError>
  UploadDoesNotExistError: ResolverTypeWrapper<UploadDoesNotExistError>
  UpdateAccountPortfolioInput: UpdateAccountPortfolioInput
  UpdateAccountPortfolioResponse:
    | ResolversTypes['InvalidActionOnAccount']
    | ResolversTypes['InvestmentAccount']
    | ResolversTypes['InvestmentAccountNotFoundException']
    | ResolversTypes['PortfolioNotFoundException']
    | ResolversTypes['PortfolioUpdateFailedException']
  InvalidActionOnAccount: ResolverTypeWrapper<InvalidActionOnAccount>
  PortfolioUpdateFailedException: ResolverTypeWrapper<PortfolioUpdateFailedException>
  UpdatePortfolioSecuritiesInput: UpdatePortfolioSecuritiesInput
  SecurityAllocationTarget: SecurityAllocationTarget
  UpdatePortfolioSecuritiesResult:
    | ResolversTypes['CustomerAgreementRequiredException']
    | ResolversTypes['InvalidAllocationPercentError']
    | ResolversTypes['InvalidSecurityError']
    | ResolversTypes['InvalidSecurityForAllocationError']
    | ResolversTypes['InvestmentAccount']
    | ResolversTypes['LiquidationUnavailableError']
    | ResolversTypes['NegativeSecurityPercentError']
    | ResolversTypes['PortfolioSecurityLimitReached']
  InvalidAllocationPercentError: ResolverTypeWrapper<InvalidAllocationPercentError>
  InvalidSecurityError: ResolverTypeWrapper<InvalidSecurityError>
  InvalidSecurityForAllocationError: ResolverTypeWrapper<InvalidSecurityForAllocationError>
  InvalidSecurityForAllocationReasonEnum: InvalidSecurityForAllocationReasonEnum
  LiquidationUnavailableError: ResolverTypeWrapper<LiquidationUnavailableError>
  LiquidationUnavailableReason: LiquidationUnavailableReason
  NegativeSecurityPercentError: ResolverTypeWrapper<NegativeSecurityPercentError>
  PortfolioSecurityLimitReached: ResolverTypeWrapper<PortfolioSecurityLimitReached>
  RegistrationInput: RegistrationInput
  ValidateUserSuspendedUploadTokenInput: ValidateUserSuspendedUploadTokenInput
  ValidateUserSuspendedUploadTokenResult:
    | ResolversTypes['UserSuspendedUploadTokenLengthError']
    | ResolversTypes['UserSuspendedUploadTokenValidation']
  UserSuspendedUploadTokenLengthError: ResolverTypeWrapper<UserSuspendedUploadTokenLengthError>
  UserSuspendedUploadTokenValidation: ResolverTypeWrapper<UserSuspendedUploadTokenValidation>
  LaterProgramAccountContributionInput: LaterProgramAccountContributionInput
  ProgramAccountType: ProgramAccountType
  LaterProgramAccountContributionResult:
    | ResolversTypes['LaterContributionLimitMet']
    | ResolversTypes['LaterFullContributionSuccess']
    | ResolversTypes['LaterPartialContributionSuccess']
  LaterContributionLimitMet: ResolverTypeWrapper<LaterContributionLimitMet>
  LaterFullContributionSuccess: ResolverTypeWrapper<LaterFullContributionSuccess>
  LaterPartialContributionSuccess: ResolverTypeWrapper<LaterPartialContributionSuccess>
  TaxWithholdingAmounts: ResolverTypeWrapper<TaxWithholdingAmounts>
  LaterAccountInfoOrError:
    | ResolversTypes['LaterAccountAlreadyVerified']
    | ResolversTypes['LaterAccountIneligibleForVerification']
    | ResolversTypes['LaterAccountInfo']
    | ResolversTypes['LaterAccountNotFound']
  LaterAccountAlreadyVerified: ResolverTypeWrapper<LaterAccountAlreadyVerified>
  LaterTypedException:
    | ResolversTypes['LaterAccountAlreadyVerified']
    | ResolversTypes['LaterAccountIneligibleForVerification']
    | ResolversTypes['LaterAccountNotFound']
    | ResolversTypes['InvalidLaterInput']
  LaterAccountIneligibleForVerification: ResolverTypeWrapper<LaterAccountIneligibleForVerification>
  LaterAccountInfo: ResolverTypeWrapper<LaterAccountInfo>
  LaterAccountNotFound: ResolverTypeWrapper<LaterAccountNotFound>
  ScheduleRecurringTransferInput: ScheduleRecurringTransferInput
  RecurringTransferEventInput: RecurringTransferEventInput
  RecurringTransferAccountInput: RecurringTransferAccountInput
  RecurringTransferFundingSourceInput: RecurringTransferFundingSourceInput
  ScheduleRecurringTransferResult:
    | ResolversTypes['RecurringTransfer']
    | ResolversTypes['MalformedRecurringTransferException']
  CancelRecurringTransferResult:
    | ResolversTypes['RecurringTransfer']
    | ResolversTypes['VersionMismatchException']
  VersionMismatchException: ResolverTypeWrapper<VersionMismatchException>
  LifeQuoteApplyInput: LifeQuoteApplyInput
  LifeQuoteResponse: ResolverTypeWrapper<LifeQuoteResponse>
  LifeQuoteInput: LifeQuoteInput
  QuoteUserMetadata: QuoteUserMetadata
  QuoteOrigin: QuoteOrigin
  CoverageResponse: CoverageResponse
  UpdateCoverageResponse: ResolverTypeWrapper<UpdateCoverageResponse>
  LifeCalculatorInput: LifeCalculatorInput
  LifeCalculatorUserResponse: LifeCalculatorUserResponse
  UpdateRecommendedCoverageResponse: ResolverTypeWrapper<UpdateRecommendedCoverageResponse>
  QuestionResponse: QuestionResponse
  ActionFeedEvent: ActionFeedEvent
  ActionFeedEventAction: ActionFeedEventAction
  ActionFeedEventType: ActionFeedEventType
  ActionFeedEventResponse: ResolverTypeWrapper<ActionFeedEventResponse>
  FavoritePartnerOfferInput: FavoritePartnerOfferInput
  JobAlertCriteriaInput: JobAlertCriteriaInput
  CreateJobAlertResult: ResolversTypes['JobAlert']
  RemoveJobAlertResult: ResolversTypes['RemovedJobAlert']
  RemovedJobAlert: ResolverTypeWrapper<RemovedJobAlert>
  AddMilestonesToMilestoneGroupDefinitionInput: AddMilestonesToMilestoneGroupDefinitionInput
  AddMilestoneToMilestoneGroupDefinitionResult:
    | ResolversTypes['MilestoneGroupDefinition']
    | ResolversTypes['RecordDoesNotExistError']
  RecordDoesNotExistError: ResolverTypeWrapper<RecordDoesNotExistError>
  CreateMilestoneGroupDefinitionInput: CreateMilestoneGroupDefinitionInput
  CreateMilestoneGroupDefinitionResult:
    | ResolversTypes['MilestoneGroupDefinition']
    | ResolversTypes['RecordAlreadyExistsError']
    | ResolversTypes['RecordDoesNotExistError']
  RecordAlreadyExistsError: ResolverTypeWrapper<RecordAlreadyExistsError>
  RemoveMilestonesFromMilestoneGroupDefinitionInput: RemoveMilestonesFromMilestoneGroupDefinitionInput
  RemoveMilestoneFromMilestoneGroupDefinitionResult:
    | ResolversTypes['MilestoneGroupDefinition']
    | ResolversTypes['RecordDoesNotExistError']
  AddActionToMilestoneGroupAchievementActionRuleInput: AddActionToMilestoneGroupAchievementActionRuleInput
  AddActionToMilestoneGroupAchievementActionRuleResult:
    | ResolversTypes['MilestoneGroupAchievementActionRule']
    | ResolversTypes['RecordDoesNotExistError']
  CreateMilestoneGroupAchievementActionRuleInput: CreateMilestoneGroupAchievementActionRuleInput
  CreateMilestoneGroupAchievementActionRuleResult:
    | ResolversTypes['MilestoneGroupAchievementActionRule']
    | ResolversTypes['RecordAlreadyExistsError']
    | ResolversTypes['RecordDoesNotExistError']
  RemoveActionFromMilestoneGroupAchievementActionRuleInput: RemoveActionFromMilestoneGroupAchievementActionRuleInput
  RemoveActionFromMilestoneGroupAchievementActionRuleResult:
    | ResolversTypes['MilestoneGroupAchievementActionRule']
    | ResolversTypes['RecordDoesNotExistError']
  AddMilestonesToMilestoneHubDefinitionInput: AddMilestonesToMilestoneHubDefinitionInput
  AddMilestonesToMilestoneHubDefinitionResult:
    | ResolversTypes['RecordDoesNotExistError']
    | ResolversTypes['MilestoneHubDefinition']
  CreateMilestoneHubDefinitionInput: CreateMilestoneHubDefinitionInput
  CreateMilestoneHubDefinitionResult:
    | ResolversTypes['RecordAlreadyExistsError']
    | ResolversTypes['RecordDoesNotExistError']
    | ResolversTypes['MilestoneHubDefinition']
  RemoveMilestonesFromMilestoneHubDefinitionInput: RemoveMilestonesFromMilestoneHubDefinitionInput
  RemoveMilestonesFromMilestoneHubDefinitionResult:
    | ResolversTypes['RecordDoesNotExistError']
    | ResolversTypes['MilestoneHubDefinition']
  DismissMessageInput: DismissMessageInput
  UpdateMessageResult:
    | ResolversTypes['AlertMessage']
    | ResolversTypes['NotificationMessage']
    | ResolversTypes['UpdateMessageIgnored']
  AlertMessage: ResolverTypeWrapper<
    Omit<AlertMessage, 'body' | 'icon' | 'title'> & {
      body: ResolversTypes['MessageTextAsset']
      icon?: Maybe<ResolversTypes['MessageVisualAsset']>
      title: ResolversTypes['MessageTextAsset']
    }
  >
  NotificationMessage: ResolverTypeWrapper<
    Omit<NotificationMessage, 'body' | 'icon' | 'title'> & {
      body: ResolversTypes['MessageTextAsset']
      icon?: Maybe<ResolversTypes['MessageVisualAsset']>
      title: ResolversTypes['MessageTextAsset']
    }
  >
  UpdateMessageIgnored: ResolverTypeWrapper<UpdateMessageIgnored>
  HideMessageByExternalIdInput: HideMessageByExternalIdInput
  MarkAllAsReadResult:
    | ResolversTypes['MarkAllAsReadSuccess']
    | ResolversTypes['UpdateMessageFailed']
  MarkAllAsReadSuccess: ResolverTypeWrapper<MarkAllAsReadSuccess>
  UpdateMessageFailed: ResolverTypeWrapper<UpdateMessageFailed>
  ReadMessageInput: ReadMessageInput
  MarkLearnContentAsHelpfulInput: MarkLearnContentAsHelpfulInput
  MarkLearnContentAsHelpfulResult:
    | ResolversTypes['UpdateLearnContentHelpfulnessResult']
    | ResolversTypes['RecordDoesNotExistError']
  UpdateLearnContentHelpfulnessResult: ResolverTypeWrapper<UpdateLearnContentHelpfulnessResult>
  UnmarkLearnContentAsHelpfulInput: UnmarkLearnContentAsHelpfulInput
  UnmarkLearnContentAsHelpfulResult:
    | ResolversTypes['UpdateLearnContentHelpfulnessResult']
    | ResolversTypes['RecordDoesNotExistError']
  MarkLearnContentAsViewedInput: MarkLearnContentAsViewedInput
  MarkLearnContentAsViewedResult:
    | ResolversTypes['ViewedLearnContentResult']
    | ResolversTypes['RecordDoesNotExistError']
  ViewedLearnContentResult: ResolverTypeWrapper<ViewedLearnContentResult>
  UpdateLearnProgressInput: UpdateLearnProgressInput
  LearnProgressInput: LearnProgressInput
  UpdateLearnProgressResult:
    | ResolversTypes['LearnProgressUpdatedResult']
    | ResolversTypes['RecordDoesNotExistError']
  LearnProgressUpdatedResult: ResolverTypeWrapper<LearnProgressUpdatedResult>
  AnswerLearnQuizQuestionInput: AnswerLearnQuizQuestionInput
  LearnAnswerInput: LearnAnswerInput
  AnswerLearnQuizQuestionResult:
    | ResolversTypes['LearnQuizAnswerResult']
    | ResolversTypes['RecordDoesNotExistError']
  LearnQuizAnswerResult: ResolverTypeWrapper<LearnQuizAnswerResult>
  UpdateElapsedTimeForLearnQuizInput: UpdateElapsedTimeForLearnQuizInput
  UpdateElapsedTimeForLearnQuizResult:
    | ResolversTypes['LearnContentElapsedMillisecondsUpdatedResult']
    | ResolversTypes['RecordDoesNotExistError']
  LearnContentElapsedMillisecondsUpdatedResult: ResolverTypeWrapper<
    LearnContentElapsedMillisecondsUpdatedResult
  >
  RespondToLearnPollInput: RespondToLearnPollInput
  RespondToLearnPollResult:
    | ResolversTypes['LearnPollResponse']
    | ResolversTypes['InvalidOptionException']
    | ResolversTypes['RecordDoesNotExistError']
  LearnPollResponse: ResolverTypeWrapper<LearnPollResponse>
  InvalidOptionException: ResolverTypeWrapper<InvalidOptionException>
  AddSearchTermToLearnSearchHistoryInput: AddSearchTermToLearnSearchHistoryInput
  AddSearchTermToLearnSearchHistoryResult: ResolversTypes['LearnSearchTermSavedResult']
  LearnSearchTermSavedResult: ResolverTypeWrapper<LearnSearchTermSavedResult>
  UploadDocumentsInput: UploadDocumentsInput
  FileOrException:
    | ResolversTypes['File']
    | ResolversTypes['FileSizeError']
    | ResolversTypes['UploadFailedError']
  File: ResolverTypeWrapper<File>
  FileSizeError: ResolverTypeWrapper<FileSizeError>
  UploadFailedError: ResolverTypeWrapper<UploadFailedError>
  UploadUnsolicitedDocumentsInput: UploadUnsolicitedDocumentsInput
  CreateDocumentUploadInput: CreateDocumentUploadInput
  CreateDocumentUpload: ResolverTypeWrapper<CreateDocumentUpload>
  InitiateSMSChallengeInput: InitiateSmsChallengeInput
  PhoneNumber: ResolverTypeWrapper<Scalars['PhoneNumber']>
  InitiateSMSChallengeResult:
    | ResolversTypes['SMSAuthChallenge']
    | ResolversTypes['InvalidPhoneNumberException']
  SMSAuthChallenge: ResolverTypeWrapper<SmsAuthChallenge>
  AuthChallenge: ResolversTypes['SMSAuthChallenge'] | ResolversTypes['EmailAuthChallenge']
  AuthenticatorInfo: ResolverTypeWrapper<AuthenticatorInfo>
  AuthType: AuthType
  InvalidPhoneNumberException: ResolverTypeWrapper<InvalidPhoneNumberException>
  InitiateEmailChallengeInput: InitiateEmailChallengeInput
  InitiateEmailChallengeResult:
    | ResolversTypes['EmailAuthChallenge']
    | ResolversTypes['ExistingEmailVerifiedException']
  EmailAuthChallenge: ResolverTypeWrapper<EmailAuthChallenge>
  ExistingEmailVerifiedException: ResolverTypeWrapper<ExistingEmailVerifiedException>
  ReinitiateSMSChallengeInput: ReinitiateSmsChallengeInput
  ReinitiateSMSChallengeResult:
    | ResolversTypes['SMSAuthChallenge']
    | ResolversTypes['EmailAuthChallenge']
    | ResolversTypes['AuthChallengeExpiredException']
  AuthChallengeExpiredException: ResolverTypeWrapper<AuthChallengeExpiredException>
  RegisterPhoneAuthenticatorInput: RegisterPhoneAuthenticatorInput
  ChallengeAnswerInput: ChallengeAnswerInput
  RegisterPhoneAuthenticatorResult:
    | ResolversTypes['PhoneAuthenticator']
    | ResolversTypes['AuthChallengeAnswerIncorrectException']
    | ResolversTypes['AuthChallengeAnswerAttemptsExhaustedException']
    | ResolversTypes['AuthChallengeExpiredException']
    | ResolversTypes['InvalidPhoneNumberException']
    | ResolversTypes['AuthenticatorTypeAlreadyRegisteredException']
  PhoneAuthenticator: ResolverTypeWrapper<PhoneAuthenticator>
  AuthChallengeAnswerIncorrectException: ResolverTypeWrapper<AuthChallengeAnswerIncorrectException>
  AuthChallengeAnswerAttemptsExhaustedException: ResolverTypeWrapper<
    AuthChallengeAnswerAttemptsExhaustedException
  >
  AuthenticatorTypeAlreadyRegisteredException: ResolverTypeWrapper<
    AuthenticatorTypeAlreadyRegisteredException
  >
  RegisterEmailAuthenticatorInput: RegisterEmailAuthenticatorInput
  RegisterEmailAuthenticatorResult:
    | ResolversTypes['EmailAuthenticator']
    | ResolversTypes['AuthChallengeAnswerIncorrectException']
    | ResolversTypes['AuthChallengeAnswerAttemptsExhaustedException']
    | ResolversTypes['AuthChallengeExpiredException']
    | ResolversTypes['AuthenticatorTypeAlreadyRegisteredException']
    | ResolversTypes['ExistingEmailVerifiedException']
  EmailAuthenticator: ResolverTypeWrapper<EmailAuthenticator>
  AuthenticateInput: AuthenticateInput
  AuthenticateResult:
    | ResolversTypes['SMSAuthChallenge']
    | ResolversTypes['EmailAuthChallenge']
    | ResolversTypes['AuthSession']
    | ResolversTypes['AuthenticatorUnavailableException']
    | ResolversTypes['InvalidCredentialsException']
    | ResolversTypes['UserSuspendedException']
    | ResolversTypes['DeviceBlockedException']
    | ResolversTypes['UserLockedException']
    | ResolversTypes['LoginRateLimitedException']
    | ResolversTypes['PhoneNumberOptedOutException']
    | ResolversTypes['AuthChallengeAnswerIncorrectException']
    | ResolversTypes['AuthChallengeAnswerAttemptsExhaustedException']
    | ResolversTypes['AuthChallengeExpiredException']
    | ResolversTypes['AuthenticatorTypeAlreadyRegisteredException']
  AuthSession: ResolverTypeWrapper<AuthSession>
  AuthenticatorUnavailableException: ResolverTypeWrapper<AuthenticatorUnavailableException>
  InvalidCredentialsException: ResolverTypeWrapper<InvalidCredentialsException>
  UserSuspendedException: ResolverTypeWrapper<UserSuspendedException>
  DeviceBlockedException: ResolverTypeWrapper<DeviceBlockedException>
  UserLockedException: ResolverTypeWrapper<UserLockedException>
  LoginRateLimitedException: ResolverTypeWrapper<LoginRateLimitedException>
  PhoneNumberOptedOutException: ResolverTypeWrapper<PhoneNumberOptedOutException>
  SetDefaultAuthenticatorInput: SetDefaultAuthenticatorInput
  SetDefaultAuthenticatorResult:
    | ResolversTypes['PhoneAuthenticator']
    | ResolversTypes['EmailAuthenticator']
    | ResolversTypes['AuthenticatorNotFoundException']
    | ResolversTypes['AuthenticatorAlreadyDefaultException']
  AuthenticatorNotFoundException: ResolverTypeWrapper<AuthenticatorNotFoundException>
  AuthenticatorAlreadyDefaultException: ResolverTypeWrapper<AuthenticatorAlreadyDefaultException>
  RefreshAuthTokenInput: RefreshAuthTokenInput
  RefreshAuthTokenResult:
    | ResolversTypes['AuthSession']
    | ResolversTypes['TokenExpiredException']
    | ResolversTypes['InvalidPinException']
    | ResolversTypes['RefreshAuthTokenRateLimitedException']
    | ResolversTypes['UserSuspendedException']
  TokenExpiredException: ResolverTypeWrapper<TokenExpiredException>
  InvalidPinException: ResolverTypeWrapper<InvalidPinException>
  RefreshAuthTokenRateLimitedException: ResolverTypeWrapper<RefreshAuthTokenRateLimitedException>
  RegisterCredentialsInput: RegisterCredentialsInput
  RegisterCredentialsResult:
    | ResolversTypes['AuthSession']
    | ResolversTypes['EmailTakenException']
    | ResolversTypes['InvalidPasswordException']
    | ResolversTypes['MissingRequiredAgreementsException']
  EmailTakenException: ResolverTypeWrapper<EmailTakenException>
  InvalidPasswordException: ResolverTypeWrapper<InvalidPasswordException>
  MissingRequiredAgreementsException: ResolverTypeWrapper<MissingRequiredAgreementsException>
  CreateUserInput: CreateUserInput
  PasswordResetRequestInput: PasswordResetRequestInput
  VerifyDeviceInput: VerifyDeviceInput
  VerifyDeviceResult:
    | ResolversTypes['SMSAuthChallenge']
    | ResolversTypes['EmailAuthChallenge']
    | ResolversTypes['DeviceNotFoundException']
  DeviceNotFoundException: ResolverTypeWrapper<DeviceNotFoundException>
  BlockDeviceInput: BlockDeviceInput
  BlockDeviceResult: ResolversTypes['Device'] | ResolversTypes['DeviceNotFoundException']
  Device: ResolverTypeWrapper<Device>
  UnblockDeviceInput: UnblockDeviceInput
  UnblockDeviceResult: ResolversTypes['Device'] | ResolversTypes['DeviceNotFoundException']
  SetAuthenticationPINInput: SetAuthenticationPinInput
  SetAuthenticationPINResult:
    | ResolversTypes['SetAuthenticationPINSuccess']
    | ResolversTypes['InvalidPinException']
    | ResolversTypes['UserCredentialsNotFoundException']
  SetAuthenticationPINSuccess: ResolverTypeWrapper<SetAuthenticationPinSuccess>
  UserCredentialsNotFoundException: ResolverTypeWrapper<UserCredentialsNotFoundException>
  VerifyPasswordsInput: VerifyPasswordsInput
  VerifyPasswordsResult:
    | ResolversTypes['VerifyPasswordsSuccess']
    | ResolversTypes['IncorrectOldPasswordException']
    | ResolversTypes['SamePasswordsException']
    | ResolversTypes['InvalidPasswordException']
    | ResolversTypes['UnauthorizedException']
  VerifyPasswordsSuccess: ResolverTypeWrapper<VerifyPasswordsSuccess>
  IncorrectOldPasswordException: ResolverTypeWrapper<IncorrectOldPasswordException>
  SamePasswordsException: ResolverTypeWrapper<SamePasswordsException>
  UnauthorizedException: ResolverTypeWrapper<UnauthorizedException>
  UserCredentialsInput: UserCredentialsInput
  UpdateCredentialsResult:
    | ResolversTypes['Credentials']
    | ResolversTypes['EmailTakenException']
    | ResolversTypes['BlockedEmailDomainException']
    | ResolversTypes['UserCredentialsNotFoundException']
  Credentials: ResolverTypeWrapper<Credentials>
  BlockedEmailDomainException: ResolverTypeWrapper<BlockedEmailDomainException>
  UpdateSecurityQuestionAndAnswerInput: UpdateSecurityQuestionAndAnswerInput
  UpdateSecurityQuestionAndAnswerResult:
    | ResolversTypes['UpdateSecurityQuestionAndAnswerSuccess']
    | ResolversTypes['InvalidSecurityQuestionException']
  UpdateSecurityQuestionAndAnswerSuccess: ResolverTypeWrapper<
    UpdateSecurityQuestionAndAnswerSuccess
  >
  InvalidSecurityQuestionException: ResolverTypeWrapper<InvalidSecurityQuestionException>
  ResetPasswordByTokenInput: ResetPasswordByTokenInput
  ResetPasswordByTokenResult:
    | ResolversTypes['ResetPasswordByTokenSuccess']
    | ResolversTypes['ResetPasswordByTokenException']
    | ResolversTypes['InvalidPasswordException']
    | ResolversTypes['UserCredentialsNotFoundException']
    | ResolversTypes['IncorrectSecurityAnswerException']
    | ResolversTypes['IncorrectSsnException']
  ResetPasswordByTokenSuccess: ResolverTypeWrapper<ResetPasswordByTokenSuccess>
  ResetPasswordByTokenException: ResolverTypeWrapper<ResetPasswordByTokenException>
  IncorrectSecurityAnswerException: ResolverTypeWrapper<IncorrectSecurityAnswerException>
  IncorrectSsnException: ResolverTypeWrapper<IncorrectSsnException>
  ResetPasswordWithTokenInput: ResetPasswordWithTokenInput
  ResetPasswordWithTokenResult:
    | ResolversTypes['ResetPasswordWithTokenSuccess']
    | ResolversTypes['InvalidPasswordResetTokenException']
    | ResolversTypes['UserCredentialsNotFoundException']
    | ResolversTypes['InvalidPasswordResetException']
  ResetPasswordWithTokenSuccess: ResolverTypeWrapper<ResetPasswordWithTokenSuccess>
  InvalidPasswordResetException: ResolverTypeWrapper<InvalidPasswordResetException>
  PasswordResetErrors: PasswordResetErrors
  SecurityAnswer: SecurityAnswer
  ChangePasswordInput: ChangePasswordInput
  ChangePasswordResult:
    | ResolversTypes['ChangePasswordSuccess']
    | ResolversTypes['IncorrectOldPasswordException']
    | ResolversTypes['InvalidPasswordException']
    | ResolversTypes['IncorrectSecurityAnswerException']
  ChangePasswordSuccess: ResolverTypeWrapper<ChangePasswordSuccess>
  UpgradeAuthenticationResult:
    | ResolversTypes['AuthSession']
    | ResolversTypes['AuthenticationAlreadyUpgradedException']
    | ResolversTypes['UserCredentialsNotFoundException']
  AuthenticationAlreadyUpgradedException: ResolverTypeWrapper<
    AuthenticationAlreadyUpgradedException
  >
  LogoutResult:
    | ResolversTypes['LogoutSuccess']
    | ResolversTypes['RefreshTokenNotFoundException']
    | ResolversTypes['AuthTokenNotFoundException']
  LogoutSuccess: ResolverTypeWrapper<LogoutSuccess>
  RefreshTokenNotFoundException: ResolverTypeWrapper<RefreshTokenNotFoundException>
  AuthTokenNotFoundException: ResolverTypeWrapper<AuthTokenNotFoundException>
  ApplyPromotionInput: ApplyPromotionInput
  ApplyPromotionResult:
    | ResolversTypes['PromotionConsumedError']
    | ResolversTypes['PromotionExpiredError']
    | ResolversTypes['PromotionNotFoundError']
    | ResolversTypes['SubscriberIneligibleError']
    | ResolversTypes['TierSubscription']
  PromotionConsumedError: ResolverTypeWrapper<PromotionConsumedError>
  PromotionExpiredError: ResolverTypeWrapper<PromotionExpiredError>
  PromotionNotFoundError: ResolverTypeWrapper<PromotionNotFoundError>
  SubscriberIneligibleError: ResolverTypeWrapper<SubscriberIneligibleError>
  DeactivateTierSubscriptionInput: DeactivateTierSubscriptionInput
  DeactivateTierSubscriptionResult:
    | ResolversTypes['TierSubscription']
    | ResolversTypes['TierSubscriptionAlreadyDeactivated']
  TierSubscriptionAlreadyDeactivated: ResolverTypeWrapper<TierSubscriptionAlreadyDeactivated>
  RequestSubscriptionMigrationWaiverInput: RequestSubscriptionMigrationWaiverInput
  RequestSubscriptionMigrationWaiverResult:
    | ResolversTypes['InvalidTierForMigrationError']
    | ResolversTypes['SubscriptionMigrationInvalidError']
    | ResolversTypes['SubscriptionMigrationWaiver']
  InvalidTierForMigrationError: ResolverTypeWrapper<InvalidTierForMigrationError>
  SubscriptionMigrationInvalidError: ResolverTypeWrapper<SubscriptionMigrationInvalidError>
  SubscribeToTierInput: SubscribeToTierInput
  SubscribeToTierResult:
    | ResolversTypes['InvalidTier']
    | ResolversTypes['InvalidTierPrice']
    | ResolversTypes['TierSubscription']
  InvalidTier: ResolverTypeWrapper<InvalidTier>
  InvalidTierPrice: ResolverTypeWrapper<InvalidTierPrice>
  SubscribeUserToTierInput: SubscribeUserToTierInput
  SubscribeUserToTierResult:
    | ResolversTypes['InvalidTierPriceId']
    | ResolversTypes['TierDowngradeActionRequired']
    | ResolversTypes['TierSubscription']
  TierDowngradeActionRequired: ResolverTypeWrapper<TierDowngradeActionRequired>
  TierDowngradeAction: ResolverTypeWrapper<TierDowngradeAction>
  TierDowngradeActionKey: TierDowngradeActionKey
  SubscribeUserToTierByProductKeyInput: SubscribeUserToTierByProductKeyInput
  UnsubscribeUserFromTierInput: UnsubscribeUserFromTierInput
  UnsubscribeUserFromTierResult:
    | ResolversTypes['TierDowngradeActionRequired']
    | ResolversTypes['TierSubscriptionUnsubscribed']
  SplitDepositSettingsMutation: ResolverTypeWrapper<SplitDepositSettingsMutation>
  ConfigureSettingsInput: ConfigureSettingsInput
  SplitDepositMutation: ResolverTypeWrapper<SplitDepositMutation>
  ConfigureSplitDepositDirectDepositIntentSettingInput: ConfigureSplitDepositDirectDepositIntentSettingInput
  SplitDepositAllocationInput: SplitDepositAllocationInput
  ConfigureSplitDepositDirectDepositIntentSettingResult:
    | ResolversTypes['ConfigureSplitDepositDirectDepositIntentPayload']
    | ResolversTypes['ConfigureSplitDepositDirectDepositIntentGenericError']
  ConfigureSplitDepositDirectDepositIntentPayload: ResolverTypeWrapper<
    ConfigureSplitDepositDirectDepositIntentPayload
  >
  SplitDepositDirectDepositIntentSetting: ResolverTypeWrapper<
    SplitDepositDirectDepositIntentSetting
  >
  SplitDepositDirectDepositAllocation: ResolverTypeWrapper<SplitDepositDirectDepositAllocation>
  FormattedMonetaryAmount: ResolverTypeWrapper<FormattedMonetaryAmount>
  ConfigureSplitDepositDirectDepositIntentGenericError: ResolverTypeWrapper<
    ConfigureSplitDepositDirectDepositIntentGenericError
  >
  ConfigureSplitDepositDirectDepositSettingInput: ConfigureSplitDepositDirectDepositSettingInput
  ConfigureSplitDepositDirectDepositSettingResult:
    | ResolversTypes['ConfigureSplitDepositDirectDepositSettingPayload']
    | ResolversTypes['ConfigureSplitDepositDirectDepositSettingGenericError']
  ConfigureSplitDepositDirectDepositSettingPayload: ResolverTypeWrapper<
    ConfigureSplitDepositDirectDepositSettingPayload
  >
  SplitDepositDirectDepositSetting: ResolverTypeWrapper<SplitDepositDirectDepositSetting>
  MonthlyTotal: ResolverTypeWrapper<MonthlyTotal>
  TotalAmounts: ResolverTypeWrapper<TotalAmounts>
  ConfigureSplitDepositDirectDepositSettingGenericError: ResolverTypeWrapper<
    ConfigureSplitDepositDirectDepositSettingGenericError
  >
  ChangeOutsideContributionAmountInput: ChangeOutsideContributionAmountInput
  ChangeOutsideContributionAmountResult:
    | ResolversTypes['ContributionAmountAboveThresholdError']
    | ResolversTypes['ContributionAmountBelowThresholdError']
    | ResolversTypes['OutsideContributionCheckoutCart']
  ContributionAmountAboveThresholdError: ResolverTypeWrapper<ContributionAmountAboveThresholdError>
  ContributionAmountBelowThresholdError: ResolverTypeWrapper<ContributionAmountBelowThresholdError>
  OutsideContributionCheckoutCart: ResolverTypeWrapper<OutsideContributionCheckoutCart>
  CheckoutCartStatus: CheckoutCartStatus
  CreateOutsideContributionInput: CreateOutsideContributionInput
  CreateOutsideContributionResult:
    | ResolversTypes['ContributionActionRequiredError']
    | ResolversTypes['ContributionCardDeclinedError']
    | ResolversTypes['ContributionInvalidOwnerEmailError']
    | ResolversTypes['OutsideContribution']
  ContributionActionRequiredError: ResolverTypeWrapper<ContributionActionRequiredError>
  ContributionRequiredAction: ContributionRequiredAction
  ContributionCardDeclinedError: ResolverTypeWrapper<ContributionCardDeclinedError>
  ContributionInvalidOwnerEmailError: ResolverTypeWrapper<ContributionInvalidOwnerEmailError>
  OutsideContribution: ResolverTypeWrapper<OutsideContribution>
  ContributionState: ContributionState
  CreateOutsideContributionCheckoutCartInput: CreateOutsideContributionCheckoutCartInput
  CreateOutsideContributionCheckoutCartResult:
    | ResolversTypes['ContributionAmountAboveThresholdError']
    | ResolversTypes['ContributionAmountBelowThresholdError']
    | ResolversTypes['OutsideContributionCheckoutCart']
  AuthenticateForFeeNegotiationInput: AuthenticateForFeeNegotiationInput
  AuthenticateForFeeNegotiationResult:
    | ResolversTypes['AuthenticateForFeeNegotiationStatus']
    | ResolversTypes['LinkedAccountNotFound']
    | ResolversTypes['NegotiationServiceConnectionFailure']
  LinkedAccountNotFound: ResolverTypeWrapper<LinkedAccountNotFound>
  NegotiationServiceConnectionFailure: ResolverTypeWrapper<NegotiationServiceConnectionFailure>
  AuthenticateForFeeNegotiationChallengeMethodInput: AuthenticateForFeeNegotiationChallengeMethodInput
  AuthenticateNegotiationStatusResult:
    | ResolversTypes['AuthenticateForFeeNegotiationStatus']
    | ResolversTypes['LinkedAccountNotFound']
  AuthenticateForFeeNegotiationChallengeInput: AuthenticateForFeeNegotiationChallengeInput
  SubmitBankFeeNegotiationInput: SubmitBankFeeNegotiationInput
  SubmitBankFeeNegotiationResult:
    | ResolversTypes['SubmitBankFeeNegotiationResponse']
    | ResolversTypes['LinkedAccountNotFound']
  SubmitBankFeeNegotiationResponse: ResolverTypeWrapper<SubmitBankFeeNegotiationResponse>
  SyncBankFeeTransactionsInput: SyncBankFeeTransactionsInput
  SyncBankFeeTransactionsResult: ResolverTypeWrapper<SyncBankFeeTransactionsResult>
  SubmitForBillNegotiationInput: SubmitForBillNegotiationInput
  Amount: ResolverTypeWrapper<Scalars['Amount']>
  PlanPeriod: PlanPeriod
  CustomerPeriod: CustomerPeriod
  Circumstance: Circumstance
  BillNegotiationSubmitResult: ResolverTypeWrapper<BillNegotiationSubmitResult>
  SubmitUserReportedBankFeeRefundInput: SubmitUserReportedBankFeeRefundInput
  SubmitUserReportedBankFeeRefundResult: ResolverTypeWrapper<SubmitUserReportedBankFeeRefundResult>
  SetNegotiationStatusInput: SetNegotiationStatusInput
  NegotiationMethod: NegotiationMethod
  SetNegotiationStatusResult: ResolverTypeWrapper<SetNegotiationStatusResult>
  PartnerStatusInput: PartnerStatusInput
  UserPartnerStatusResponse: ResolverTypeWrapper<UserPartnerStatusResponse>
  RegisterProspectInput: RegisterProspectInput
  SourceAttributesInput: SourceAttributesInput
  RegisterProspectResult:
    | ResolversTypes['InvalidConversionIdentifierException']
    | ResolversTypes['InvalidSourceAttributesException']
    | ResolversTypes['RegistrationFunnel']
  InvalidConversionIdentifierException: ResolverTypeWrapper<InvalidConversionIdentifierException>
  InvalidSourceAttributesException: ResolverTypeWrapper<InvalidSourceAttributesException>
  UpdateAttributionInput: UpdateAttributionInput
  UpdatableAttributesInput: UpdatableAttributesInput
  UpdateAttributionResult:
    | ResolversTypes['InvalidConversionIdentifierException']
    | ResolversTypes['InvalidSourceAttributesException']
    | ResolversTypes['NoProspectRecord']
    | ResolversTypes['RegistrationFunnel']
  NoProspectRecord: ResolverTypeWrapper<NoProspectRecord>
  UUID: ResolverTypeWrapper<Scalars['UUID']>
  Subscription: ResolverTypeWrapper<{}>
  AcceptUploadedDocumentInput: AcceptUploadedDocumentInput
  AddActionToMilestoneAchievementActionRuleInput: AddActionToMilestoneAchievementActionRuleInput
  AddActionToMilestoneAchievementActionRuleResult:
    | ResolversTypes['MilestoneAchievementActionRule']
    | ResolversTypes['RecordAlreadyExistsError']
    | ResolversTypes['RecordDoesNotExistError']
  AddDocumentUrlsInput: AddDocumentUrlsInput
  DocumentInput: DocumentInput
  AdvocateFriendsStatuses: ResolverTypeWrapper<AdvocateFriendsStatuses>
  AuthProfileAlreadyExistsException: ResolverTypeWrapper<AuthProfileAlreadyExistsException>
  AuthProfileNotFoundException: ResolverTypeWrapper<AuthProfileNotFoundException>
  BackendJobBatch: ResolverTypeWrapper<BackendJobBatch>
  BackendJobBatchType: BackendJobBatchType
  BackendJobBatchStatus: BackendJobBatchStatus
  BackendJobBatchAutomatedOrdersFilterInput: BackendJobBatchAutomatedOrdersFilterInput
  BackendJobBatchTimeframe: BackendJobBatchTimeframe
  BackendJobBatchMoneyMovementFilterInput: BackendJobBatchMoneyMovementFilterInput
  BackendJobBatchOrdersFilterInput: BackendJobBatchOrdersFilterInput
  BackendJobBatchProfitStarsFilterInput: BackendJobBatchProfitStarsFilterInput
  BackendJobBatchSummary: ResolverTypeWrapper<BackendJobBatchSummary>
  BackendJobBatchSummaryFilterInput: BackendJobBatchSummaryFilterInput
  BatchAddTierSubscriptions: ResolverTypeWrapper<BatchAddTierSubscriptions>
  BatchAddTierSubscriptionsInput: BatchAddTierSubscriptionsInput
  BatchAddTierSubscriptionsResult:
    | ResolversTypes['BatchAddTierSubscriptions']
    | ResolversTypes['InvalidTier']
    | ResolversTypes['InvalidTierPrice']
  BeneficiaryRequestedLaterAlert: ResolverTypeWrapper<BeneficiaryRequestedLaterAlert>
  CacheControlScope: CacheControlScope
  CancelRequestedDocumentInput: CancelRequestedDocumentInput
  ChallengeDeliveryType: ChallengeDeliveryType
  ChangeSecuritySymbolInput: ChangeSecuritySymbolInput
  ChangeSecuritySymbolResult:
    | ResolversTypes['Fund']
    | ResolversTypes['Stock']
    | ResolversTypes['InvalidSecurityForSymbolChangeError']
    | ResolversTypes['InvalidSymbolForSymbolChangeError']
  Fund: ResolverTypeWrapper<Fund>
  TopHolding: ResolverTypeWrapper<TopHolding>
  Stock: ResolverTypeWrapper<Stock>
  InvalidSecurityForSymbolChangeError: ResolverTypeWrapper<InvalidSecurityForSymbolChangeError>
  InvalidSymbolForSymbolChangeError: ResolverTypeWrapper<InvalidSymbolForSymbolChangeError>
  CoreACHSubscriptionFeeItem: ResolverTypeWrapper<CoreAchSubscriptionFeeItem>
  CoreAdjustmentItem: ResolverTypeWrapper<CoreAdjustmentItem>
  PastCoreTradedItem:
    | ResolversTypes['CoreAdjustmentItem']
    | ResolversTypes['CoreDividendsItem']
    | ResolversTypes['CoreEmployeeCreditItem']
    | ResolversTypes['CoreFeeInvestmentItem']
    | ResolversTypes['CoreFoundMoneyRewardItem']
    | ResolversTypes['CoreGiftCardCreditRedemptionItem']
    | ResolversTypes['CoreInvestmentItem']
    | ResolversTypes['CoreLocalFoundMoneyItem']
    | ResolversTypes['CorePartnerRewardItem']
    | ResolversTypes['CoreRebalanceItem']
    | ResolversTypes['CoreReferralRewardItem']
    | ResolversTypes['CoreRoundUpsItem']
    | ResolversTypes['CoreWithdrawalItem']
    | ResolversTypes['EarlyDividendsItem']
    | ResolversTypes['EarlyFeeInvestmentItem']
    | ResolversTypes['EarlyGiftItem']
    | ResolversTypes['EarlyInvestmentItem']
    | ResolversTypes['EarlyWithdrawalItem']
    | ResolversTypes['LaterDividendsItem']
    | ResolversTypes['LaterFeeInvestmentItem']
    | ResolversTypes['LaterInvestmentItem']
    | ResolversTypes['LaterRebalanceItem']
    | ResolversTypes['LaterWithdrawalItem']
  CoreCashForwardItem: ResolverTypeWrapper<CoreCashForwardItem>
  CoreCollectionItem: ResolverTypeWrapper<CoreCollectionItem>
  CoreDividendsItem: ResolverTypeWrapper<CoreDividendsItem>
  CoreEmployeeCreditItem: ResolverTypeWrapper<CoreEmployeeCreditItem>
  CoreFeeInvestmentItem: ResolverTypeWrapper<CoreFeeInvestmentItem>
  CoreFoundMoneyRewardItem: ResolverTypeWrapper<CoreFoundMoneyRewardItem>
  CoreGiftCardCreditRedemptionItem: ResolverTypeWrapper<CoreGiftCardCreditRedemptionItem>
  CoreHoldingsTransferInItem: ResolverTypeWrapper<CoreHoldingsTransferInItem>
  CoreInvestmentItem: ResolverTypeWrapper<CoreInvestmentItem>
  PastCoreCombinedItem: ResolversTypes['CoreInvestmentItem'] | ResolversTypes['CoreRoundUpsItem']
  PastUserTransferItem:
    | ResolversTypes['CoreInvestmentItem']
    | ResolversTypes['CoreRoundUpsItem']
    | ResolversTypes['CoreWithdrawalItem']
    | ResolversTypes['EarlyInvestmentItem']
    | ResolversTypes['EarlyWithdrawalItem']
    | ResolversTypes['LaterInvestmentItem']
    | ResolversTypes['LaterWithdrawalItem']
    | ResolversTypes['SpendTransferInItem']
    | ResolversTypes['SpendTransferOutItem']
  CoreLocalFoundMoneyItem: ResolverTypeWrapper<CoreLocalFoundMoneyItem>
  CorePartnerRewardItem: ResolverTypeWrapper<CorePartnerRewardItem>
  CoreRebalanceItem: ResolverTypeWrapper<CoreRebalanceItem>
  CoreReferralRewardItem: ResolverTypeWrapper<CoreReferralRewardItem>
  CoreRoundUpsItem: ResolverTypeWrapper<CoreRoundUpsItem>
  RoundUpType: RoundUpType
  CoreWithdrawalItem: ResolverTypeWrapper<CoreWithdrawalItem>
  CreateAccountPointsRuleInput: CreateAccountPointsRuleInput
  CreateAccountPointsRuleResult:
    | ResolversTypes['RecordAlreadyExistsError']
    | ResolversTypes['RecordDoesNotExistError']
    | ResolversTypes['AccountPointsRule']
  CreateAuthProfileInput: CreateAuthProfileInput
  CreateAuthProfileResult:
    | ResolversTypes['AuthProfile']
    | ResolversTypes['AuthProfileAlreadyExistsException']
  CreateMilestoneAccountLevelDefinitionInput: CreateMilestoneAccountLevelDefinitionInput
  CreateMilestoneAccountLevelDefinitionResult:
    | ResolversTypes['MilestoneAccountLevelDefinition']
    | ResolversTypes['RecordAlreadyExistsError']
  CreateMilestoneAchievementActionRuleInput: CreateMilestoneAchievementActionRuleInput
  CreateMilestoneAchievementActionRuleResult:
    | ResolversTypes['MilestoneAchievementActionRule']
    | ResolversTypes['RecordAlreadyExistsError']
    | ResolversTypes['RecordDoesNotExistError']
  CreateMilestoneChallengeDefinitionInput: CreateMilestoneChallengeDefinitionInput
  ImageInput: ImageInput
  CreateMilestoneChallengeDefinitionResult:
    | ResolversTypes['MilestoneChallengeDefinition']
    | ResolversTypes['RecordAlreadyExistsError']
    | ResolversTypes['RecordDoesNotExistError']
  MilestoneChallengeDefinition: ResolverTypeWrapper<MilestoneChallengeDefinition>
  CreateMilestoneChallengePointsRuleInput: CreateMilestoneChallengePointsRuleInput
  CreateMilestoneChallengePointsRuleResult:
    | ResolversTypes['MilestoneChallengePointsRule']
    | ResolversTypes['RecordAlreadyExistsError']
    | ResolversTypes['RecordDoesNotExistError']
  CreateMilestoneDefinitionInput: CreateMilestoneDefinitionInput
  CreateMilestoneDefinitionResult:
    | ResolversTypes['MilestoneDefinition']
    | ResolversTypes['RecordAlreadyExistsError']
    | ResolversTypes['RecordDoesNotExistError']
  CreateMilestoneRuleInput: CreateMilestoneRuleInput
  CreateMilestoneRuleResult:
    | ResolversTypes['MilestoneRule']
    | ResolversTypes['RecordAlreadyExistsError']
  CreateOfferInput: CreateOfferInput
  OfferPriceInput: OfferPriceInput
  CreateOfferResult: ResolversTypes['Offer']
  CreateSecurityQuestionInput: CreateSecurityQuestionInput
  CreateSubscriptionMigrationInput: CreateSubscriptionMigrationInput
  CreateSubscriptionMigrationResult: ResolversTypes['SubscriptionMigration']
  DeactivateSecurityFailed: ResolverTypeWrapper<DeactivateSecurityFailed>
  DeactivateSecurityInput: DeactivateSecurityInput
  DeactivateSecurityResult:
    | ResolversTypes['Fund']
    | ResolversTypes['Stock']
    | ResolversTypes['DeactivateSecurityFailed']
  DeregisterAuthenticatorInput: DeregisterAuthenticatorInput
  DeregisterAuthenticatorResult:
    | ResolversTypes['PhoneAuthenticator']
    | ResolversTypes['EmailAuthenticator']
    | ResolversTypes['AuthenticatorNotFoundException']
  Dividend: ResolverTypeWrapper<Dividend>
  DividendFrequency: DividendFrequency
  DividendsBySymbolInput: DividendsBySymbolInput
  EarlyDividendsItem: ResolverTypeWrapper<EarlyDividendsItem>
  PastEarlyItem:
    | ResolversTypes['EarlyDividendsItem']
    | ResolversTypes['EarlyFeeInvestmentItem']
    | ResolversTypes['EarlyGiftItem']
    | ResolversTypes['EarlyInvestmentItem']
    | ResolversTypes['EarlyWithdrawalItem']
  EarlyFeeInvestmentItem: ResolverTypeWrapper<EarlyFeeInvestmentItem>
  EarlyGiftItem: ResolverTypeWrapper<EarlyGiftItem>
  PastAnnotatedItem: ResolversTypes['EarlyGiftItem']
  EarlyInvestmentItem: ResolverTypeWrapper<EarlyInvestmentItem>
  EarlyWithdrawalItem: ResolverTypeWrapper<EarlyWithdrawalItem>
  EditSecurityQuestionInput: EditSecurityQuestionInput
  EditSecurityQuestionResult:
    | ResolversTypes['SecurityQuestion']
    | ResolversTypes['InvalidSecurityQuestionException']
  ExistingPhoneVerifiedException: ResolverTypeWrapper<ExistingPhoneVerifiedException>
  HideMessageInput: HideMessageInput
  InternalShareTransferFailed: ResolverTypeWrapper<InternalShareTransferFailed>
  InternalShareTransferInput: InternalShareTransferInput
  InvalidLaterInput: ResolverTypeWrapper<InvalidLaterInput>
  InvalidTierPriceCombination: ResolverTypeWrapper<InvalidTierPriceCombination>
  LaterDividendsItem: ResolverTypeWrapper<LaterDividendsItem>
  LaterEntityBeneficiary: ResolverTypeWrapper<LaterEntityBeneficiary>
  LaterFeeInvestmentItem: ResolverTypeWrapper<LaterFeeInvestmentItem>
  LaterInvestmentItem: ResolverTypeWrapper<LaterInvestmentItem>
  LaterRebalanceItem: ResolverTypeWrapper<LaterRebalanceItem>
  LaterWithdrawal: ResolverTypeWrapper<LaterWithdrawal>
  LaterWithdrawalItem: ResolverTypeWrapper<LaterWithdrawalItem>
  LaterWithholdingValues: ResolverTypeWrapper<LaterWithholdingValues>
  LogoutDeviceInput: LogoutDeviceInput
  LogoutDeviceResult:
    | ResolversTypes['LogoutDeviceSuccess']
    | ResolversTypes['RefreshTokenNotFoundException']
    | ResolversTypes['DeviceNotFoundException']
  LogoutDeviceSuccess: ResolverTypeWrapper<LogoutDeviceSuccess>
  Long: ResolverTypeWrapper<Scalars['Long']>
  MfaMissingAuthAlert: ResolverTypeWrapper<MfaMissingAuthAlert>
  MissingSsnBeneficiaryAlert: ResolverTypeWrapper<MissingSsnBeneficiaryAlert>
  MonetaryIncentive: ResolverTypeWrapper<MonetaryIncentive>
  OmnibusShareTransferId: ResolverTypeWrapper<OmnibusShareTransferId>
  PastCoreItem: ResolverTypeWrapper<PastCoreItem>
  PastSpendItem: ResolverTypeWrapper<PastSpendItem>
  SpendItem:
    | ResolversTypes['PastSpendItem']
    | ResolversTypes['SpendATMReimbursementItem']
    | ResolversTypes['SpendATMWithdrawalItem']
    | ResolversTypes['SpendBillPayItem']
    | ResolversTypes['SpendCheckDepositItem']
    | ResolversTypes['SpendCheckPaymentItem']
    | ResolversTypes['SpendDigitalWalletItem']
    | ResolversTypes['SpendDirectDepositItem']
    | ResolversTypes['SpendECheckItem']
    | ResolversTypes['SpendPurchaseItem']
    | ResolversTypes['SpendRealTimeRoundUpItem']
    | ResolversTypes['SpendTransferInItem']
    | ResolversTypes['SpendTransferOutItem']
  ReferralEventInput: ReferralEventInput
  ReferralRewardSummary: ResolverTypeWrapper<ReferralRewardSummary>
  ReferralRewardUpdateStatus: ReferralRewardUpdateStatus
  ReferralStatus: ReferralStatus
  ReferralUserUpdateInput: ReferralUserUpdateInput
  RejectUploadedDocumentInput: RejectUploadedDocumentInput
  RemoveActionFromMilestoneAchievementActionRuleInput: RemoveActionFromMilestoneAchievementActionRuleInput
  RemoveActionFromMilestoneAchievementActionRuleResult:
    | ResolversTypes['MilestoneAchievementActionRule']
    | ResolversTypes['RecordDoesNotExistError']
  RequestDocumentUploadInput: RequestDocumentUploadInput
  RestoreLoginAccessInput: RestoreLoginAccessInput
  RestoreLoginAccessResult:
    | ResolversTypes['AuthProfile']
    | ResolversTypes['AuthProfileNotFoundException']
  RevokeAccessReasons: RevokeAccessReasons
  RevokeLoginAccessInput: RevokeLoginAccessInput
  RevokeLoginAccessResult:
    | ResolversTypes['AuthProfile']
    | ResolversTypes['UserCredentialsNotFoundException']
  RevokePasswordResetTokenInput: RevokePasswordResetTokenInput
  RevokePasswordResetTokenResult:
    | ResolversTypes['RevokePasswordResetTokenSuccess']
    | ResolversTypes['InvalidPasswordResetTokenException']
  RevokePasswordResetTokenSuccess: ResolverTypeWrapper<RevokePasswordResetTokenSuccess>
  SelfDirectedPortfolio: ResolverTypeWrapper<SelfDirectedPortfolio>
  SelfDirectedPortfolioStatus: SelfDirectedPortfolioStatus
  ShareTransferType: ShareTransferType
  Short: ResolverTypeWrapper<Scalars['Short']>
  SpendATMReimbursementItem: ResolverTypeWrapper<SpendAtmReimbursementItem>
  SpendATMWithdrawalItem: ResolverTypeWrapper<SpendAtmWithdrawalItem>
  SpendBillPayItem: ResolverTypeWrapper<SpendBillPayItem>
  SpendCheckDepositItem: ResolverTypeWrapper<SpendCheckDepositItem>
  SpendCheckPaymentItem: ResolverTypeWrapper<SpendCheckPaymentItem>
  SpendDigitalWalletItem: ResolverTypeWrapper<SpendDigitalWalletItem>
  SpendDirectDepositItem: ResolverTypeWrapper<SpendDirectDepositItem>
  SpendECheckItem: ResolverTypeWrapper<SpendECheckItem>
  SpendPurchaseItem: ResolverTypeWrapper<SpendPurchaseItem>
  SpendRealTimeRoundUpItem: ResolverTypeWrapper<SpendRealTimeRoundUpItem>
  SpendTransferInItem: ResolverTypeWrapper<SpendTransferInItem>
  SpendTransferOutItem: ResolverTypeWrapper<SpendTransferOutItem>
  SplitDepositDailyRecurrenceRule: ResolverTypeWrapper<SplitDepositDailyRecurrenceRule>
  SplitDepositRecurrenceRule:
    | ResolversTypes['SplitDepositDailyRecurrenceRule']
    | ResolversTypes['SplitDepositMonthlyRecurrenceRule']
    | ResolversTypes['SplitDepositWeeklyRecurrenceRule']
  SplitDepositRecurrenceFrequency: SplitDepositRecurrenceFrequency
  SplitDepositMonthlyRecurrenceRule: ResolverTypeWrapper<SplitDepositMonthlyRecurrenceRule>
  SplitDepositRecurrenceAllocation: ResolverTypeWrapper<SplitDepositRecurrenceAllocation>
  SplitDepositRecurrenceSetting: ResolverTypeWrapper<SplitDepositRecurrenceSetting>
  SplitDepositWeeklyRecurrenceRule: ResolverTypeWrapper<SplitDepositWeeklyRecurrenceRule>
  SupportUser: ResolverTypeWrapper<SupportUser>
  SystemCardLockedSpendAlert: ResolverTypeWrapper<SystemCardLockedSpendAlert>
  Time: ResolverTypeWrapper<Scalars['Time']>
  TransferInternalSharesInput: TransferInternalSharesInput
  TransferInternalSharesResult:
    | ResolversTypes['OmnibusShareTransferId']
    | ResolversTypes['InternalShareTransferFailed']
  UnverifiedBeneficiarySsnAlert: ResolverTypeWrapper<UnverifiedBeneficiarySsnAlert>
  UpdateAccountPointsRuleInput: UpdateAccountPointsRuleInput
  UpdateAccountPointsRuleResult:
    | ResolversTypes['RecordAlreadyExistsError']
    | ResolversTypes['RecordDoesNotExistError']
    | ResolversTypes['AccountPointsRule']
  UpdateAuthEmailInput: UpdateAuthEmailInput
  UpdateAuthEmailResult:
    | ResolversTypes['AuthProfile']
    | ResolversTypes['ExistingEmailVerifiedException']
  UpdateAuthPhoneNumberInput: UpdateAuthPhoneNumberInput
  UpdateAuthPhoneNumberResult:
    | ResolversTypes['AuthProfile']
    | ResolversTypes['InvalidPhoneNumberException']
    | ResolversTypes['ExistingPhoneVerifiedException']
  UpdateMilestoneAccountLevelDefinitionInput: UpdateMilestoneAccountLevelDefinitionInput
  UpdateMilestoneAccountLevelDefinitionResult:
    | ResolversTypes['MilestoneAccountLevelDefinition']
    | ResolversTypes['RecordDoesNotExistError']
  UpdateMilestoneChallengeDefinitionInput: UpdateMilestoneChallengeDefinitionInput
  UpdateMilestoneChallengeDefinitionResult:
    | ResolversTypes['MilestoneChallengeDefinition']
    | ResolversTypes['RecordDoesNotExistError']
  UpdateMilestoneChallengePointsRuleInput: UpdateMilestoneChallengePointsRuleInput
  UpdateMilestoneChallengePointsRuleResult:
    | ResolversTypes['MilestoneChallengePointsRule']
    | ResolversTypes['RecordDoesNotExistError']
  UpdateMilestoneDefinitionInput: UpdateMilestoneDefinitionInput
  UpdateMilestoneDefinitionResult:
    | ResolversTypes['MilestoneDefinition']
    | ResolversTypes['RecordDoesNotExistError']
  UpdateReferralRewardError: ResolverTypeWrapper<UpdateReferralRewardError>
  UpdateReferralRewardResponse:
    | ResolversTypes['ReferralRewardSummary']
    | ResolversTypes['UpdateReferralRewardError']
  UserCardLockedSpendAlert: ResolverTypeWrapper<UserCardLockedSpendAlert>
}

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Query: {}
  User: User
  ID: Scalars['ID']
  String: Scalars['String']
  Boolean: Scalars['Boolean']
  DateTime: Scalars['DateTime']
  USStateName: Scalars['USStateName']
  FundingSource: FundingSource
  Int: Scalars['Int']
  URL: Scalars['URL']
  JSON: Scalars['JSON']
  Portfolio: Portfolio
  BasePortfolio: ResolversParentTypes['Portfolio'] | ResolversParentTypes['SelfDirectedPortfolio']
  PortfolioAllocation: PortfolioAllocation
  Float: Scalars['Float']
  MonetaryAmount: MonetaryAmount
  PortfolioSecurity: PortfolioSecurity
  MarketReturn: MarketReturn
  PortfolioSecurityAllocation: PortfolioSecurityAllocation
  InvestmentCategory: InvestmentCategory
  Security: ResolversParentTypes['Fund'] | ResolversParentTypes['Stock']
  TickerSymbol: Scalars['TickerSymbol']
  BigCurrencyAmount: BigCurrencyAmount
  BigDecimal: Scalars['BigDecimal']
  SecurityProfile: SecurityProfile
  SecurityHeadline: SecurityHeadline
  Date: Scalars['Date']
  ETF: Etf
  Holding: Holding
  ETFPerformance: EtfPerformance
  ETFGain: EtfGain
  ETFPrice: EtfPrice
  PortfolioHolding: PortfolioHolding
  PortfolioProjection: PortfolioProjection
  UserUpload: UserUpload
  SecurityQuestion: SecurityQuestion
  Suitability: Suitability
  UserAlert: UserAlert
  UserAlertsItem:
    | ResolversParentTypes['UserAlert']
    | ResolversParentTypes['MissingSsnBeneficiaryAlertItem']
    | ResolversParentTypes['UnverifiedBeneficiarySsnAlertItem']
    | ResolversParentTypes['LinkedAccountAlert']
    | ResolversParentTypes['RelinkLinkedAccountAlert']
    | ResolversParentTypes['AddressDocumentRequestedUserAlert']
    | ResolversParentTypes['BankDocumentRequestedUserAlert']
    | ResolversParentTypes['IdentityDocumentRequestedUserAlert']
    | ResolversParentTypes['InsufficientFundsUserAlert']
    | ResolversParentTypes['InvestmentsPausedUserAlert']
    | ResolversParentTypes['MiscDocumentRequestedUserAlert']
    | ResolversParentTypes['NoFundingSourceUserAlert']
    | ResolversParentTypes['RdvRequiredUserAlert']
    | ResolversParentTypes['SSNDocumentRequestedUserAlert']
    | ResolversParentTypes['W9DocumentRequestedUserAlert']
  UserTotals: UserTotals
  UserDailyChange: UserDailyChange
  UserRoundUps: UserRoundUps
  InvestmentAccount: InvestmentAccount
  TimestampsInterface:
    | ResolversParentTypes['InvestmentAccount']
    | ResolversParentTypes['RecurringInvestmentSettings']
    | ResolversParentTypes['Beneficiary']
    | ResolversParentTypes['Address']
    | ResolversParentTypes['Phone']
    | ResolversParentTypes['Account']
    | ResolversParentTypes['Profile']
    | ResolversParentTypes['Signature']
    | ResolversParentTypes['BillingCycle']
    | ResolversParentTypes['Credit']
    | ResolversParentTypes['Fee']
    | ResolversParentTypes['FeeExecution']
    | ResolversParentTypes['FinancialInstitution']
    | ResolversParentTypes['LinkedAccount']
    | ResolversParentTypes['LinkedSubaccount']
    | ResolversParentTypes['RoundUpAccount']
    | ResolversParentTypes['RoundUpProfile']
    | ResolversParentTypes['RoundUp']
    | ResolversParentTypes['FundingSourceAccount']
    | ResolversParentTypes['OutsideContributionCode']
    | ResolversParentTypes['InvestmentAccountReopenRequest']
    | ResolversParentTypes['InvestmentAccountReopenRequestAction']
    | ResolversParentTypes['InvestmentAccountReopenRequestNote']
    | ResolversParentTypes['UserInvestmentAccountReopenCheck']
    | ResolversParentTypes['OutsideContributionCheckoutCart']
    | ResolversParentTypes['OutsideContribution']
  Withdrawal: Withdrawal
  Performance: Performance
  AccountValue: AccountValue
  InvestmentAccountRecap: InvestmentAccountRecap
  InvestmentAccountOutsideContribution: InvestmentAccountOutsideContribution
  RecurringInvestmentSettings: RecurringInvestmentSettings
  AccountRequirements: AccountRequirements
  AccountRequirement: AccountRequirement
  InvestmentAccountSummary: InvestmentAccountSummary
  InvestmentAccountTransferability: InvestmentAccountTransferability
  Beneficiary: Beneficiary
  Address: Address
  Email: Scalars['Email']
  Phone: Phone
  ActionCardsInput: ActionCardsInput
  ActionCard: ActionCard
  ActionCardButton: ActionCardButton
  FundingSourceInfo: FundingSourceInfo
  Activity: Activity
  AcceptanceDocument: AcceptanceDocument
  Market: Market
  Settings: Settings
  Notifications: Notifications
  Notification: Notification
  Statement: Statement
  StatementLink: StatementLink
  Toggle: Toggle
  Partner: Partner
  PartnerAuthorizationData: PartnerAuthorizationData
  PartnerRoutingNumber: PartnerRoutingNumber
  PartnerUserPayload: PartnerUserPayload
  SuitabilityQuestion: SuitabilityQuestion
  SuitabilityAnswer: SuitabilityAnswer
  CloseAccountReason: CloseAccountReason
  AccountStrengthResult: AccountStrengthResult
  AccountAchievement: AccountAchievement
  UserStatus: UserStatus
  ExtensionOwner: ExtensionOwner
  ExtensionCampaign: ExtensionCampaign
  ExtensionCampaignBackgroundImage: ExtensionCampaignBackgroundImage
  ExtensionCampaignCtaDetails: ExtensionCampaignCtaDetails
  ExtensionCampaignStore: ExtensionCampaignStore
  ExtensionRewardsSummary: ExtensionRewardsSummary
  RewardSummary: RewardSummary
  ExtensionTransaction: ExtensionTransaction
  FoundMoneyOffer: FoundMoneyOffer
  BackgroundImage: BackgroundImage
  CtaDetails: CtaDetails
  Owner: Owner
  SocialCopies: SocialCopies
  CondensedSocialCopies: CondensedSocialCopies
  FoundMoneyCampaign: FoundMoneyCampaign
  FoundMoneyReward: FoundMoneyReward
  FoundMoneySummary: FoundMoneySummary
  FoundMoneyOfferCategory: FoundMoneyOfferCategory
  LaterAccount: LaterAccount
  LaterPortfolioPerformance: LaterPortfolioPerformance
  LaterIndividualBeneficiary: LaterIndividualBeneficiary
  LaterBeneficiary:
    | ResolversParentTypes['LaterIndividualBeneficiary']
    | ResolversParentTypes['LaterEntityBeneficiary']
  LaterHistoryItem: ResolversParentTypes['LaterDeposit'] | ResolversParentTypes['LaterWithdrawal']
  LaterDeposit: LaterDeposit
  RolloverAccounts: RolloverAccounts
  RolloverAccountType: RolloverAccountType
  CustodianCompany: CustodianCompany
  CurrencyAmountInput: CurrencyAmountInput
  WithholdingDefaults: WithholdingDefaults
  ContributionHistoryItem: ContributionHistoryItem
  Eligibility: Eligibility
  Account: Account
  AlertHubBeneficiaryAlert:
    | ResolversParentTypes['MissingSsnBeneficiaryAlertItem']
    | ResolversParentTypes['UnverifiedBeneficiarySsnAlertItem']
  MissingSsnBeneficiaryAlertItem: MissingSsnBeneficiaryAlertItem
  UnverifiedBeneficiarySsnAlertItem: UnverifiedBeneficiarySsnAlertItem
  Alert:
    | ResolversParentTypes['BeneficiaryRequestedLaterAlert']
    | ResolversParentTypes['MissingSsnBeneficiaryAlert']
    | ResolversParentTypes['UnverifiedBeneficiarySsnAlert']
  Occupation: Occupation
  Profile: Profile
  Signature: Signature
  MightyOakWaiverResult:
    | ResolversParentTypes['BillingProfileNotFoundException']
    | ResolversParentTypes['MightyOakCardWaiver']
    | ResolversParentTypes['MightyOakCardWaiverExpiredException']
    | ResolversParentTypes['MightyOakCardWaiverNotFoundException']
  BillingProfileNotFoundException: BillingProfileNotFoundException
  MightyOakCardWaiver: MightyOakCardWaiver
  MightyOakCardWaiverExpiredException: MightyOakCardWaiverExpiredException
  MightyOakCardWaiverNotFoundException: MightyOakCardWaiverNotFoundException
  BillingCycle: BillingCycle
  Credit: Credit
  Fee: Fee
  FeeExecution: FeeExecution
  TierSubscription: TierSubscription
  Promotion: Omit<Promotion, 'offering'> & { offering: ResolversParentTypes['Offering'] }
  PromotionDuration: PromotionDuration
  Incentive: ResolversParentTypes['MonetaryIncentive']
  Offering: ResolversParentTypes['Product'] | ResolversParentTypes['Tier']
  Product: Product
  Tier: Tier
  Bundle: Bundle
  PresentableProduct: PresentableProduct
  StringKey: Scalars['StringKey']
  TierProduct: TierProduct
  TierPrice: TierPrice
  CurrencyAmount: CurrencyAmount
  SubscriptionMigration: SubscriptionMigration
  Offer: Omit<Offer, 'offering'> & { offering: ResolversParentTypes['Offering'] }
  OfferExpiration: OfferExpiration
  OfferPrice: OfferPrice
  TierSubscriptionTransition: TierSubscriptionTransition
  NextBillingDate: NextBillingDate
  AddressDeliverabilityInput: AddressDeliverabilityInput
  AddressDeliverabilityResult:
    | ResolversParentTypes['AddressDeliverabilityVerified']
    | ResolversParentTypes['AddressDeliverabilityVerificationError']
    | ResolversParentTypes['AddressDeliverabilityCorrectedAddress']
    | ResolversParentTypes['AddressDeliverabilityUnavailableError']
  AddressDeliverabilityVerified: AddressDeliverabilityVerified
  AddressDeliverabilityAdditionalInfo: AddressDeliverabilityAdditionalInfo
  AddressDeliverabilityVerificationError: AddressDeliverabilityVerificationError
  AddressDeliverabilityCorrectedAddress: AddressDeliverabilityCorrectedAddress
  AddressDeliverabilityUnavailableError: AddressDeliverabilityUnavailableError
  AllBankAccountsInput: AllBankAccountsInput
  BankAccount: BankAccount
  BankAccountRequirements: BankAccountRequirements
  BankAccountRequirement: BankAccountRequirement
  BankAccountGoals: BankAccountGoals
  BankAccountGoal: BankAccountGoal
  AllBankCardsFilter: AllBankCardsFilter
  BankCard: BankCard
  CardNumberMasked: Scalars['CardNumberMasked']
  BankMetadata: BankMetadata
  BankMetadataTotals: BankMetadataTotals
  BankCardOrder: BankCardOrder
  BankCardOrderAddressVerification: BankCardOrderAddressVerification
  BankCardOrderIdentityVerification: BankCardOrderIdentityVerification
  BankCardOrderPrefundVerification: BankCardOrderPrefundVerification
  BankCardOrderFundingSourceVerification: BankCardOrderFundingSourceVerification
  BankTransaction: BankTransaction
  AllBankDocumentsInput: AllBankDocumentsInput
  BankDocument: BankDocument
  BankStatement: BankStatement
  SpendAlert:
    | ResolversParentTypes['SystemCardLockedSpendAlert']
    | ResolversParentTypes['UserCardLockedSpendAlert']
  PageInput: PageInput
  BankTransactionConnection: BankTransactionConnection
  BankTransactionEdge: BankTransactionEdge
  PageInfo: PageInfo
  SpendAtmsInput: SpendAtmsInput
  SpendAtmsCoordinateInput: SpendAtmsCoordinateInput
  SpendAtmsResult:
    | ResolversParentTypes['SpendAtmsPayload']
    | ResolversParentTypes['SpendAtmVendorUnavailableError']
  SpendAtmsPayload: SpendAtmsPayload
  SpendAtm: SpendAtm
  SpendAtmAddress: SpendAtmAddress
  SpendAtmVendorUnavailableError: SpendAtmVendorUnavailableError
  SpendAccount: SpendAccount
  BankCardReissue: Omit<BankCardReissue, 'reissueBankCardEligibility'> & {
    reissueBankCardEligibility: ResolversParentTypes['ReissueBankCardEligibility']
  }
  BankCardRequest: BankCardRequest
  BankCardRequestMailingAddress: BankCardRequestMailingAddress
  ReissueBankCardEligibility:
    | ResolversParentTypes['ReissueBankCardEligible']
    | ResolversParentTypes['ReissueBankCardIneligible']
  ReissueBankCardEligible: ReissueBankCardEligible
  ReissueBankCardIneligible: ReissueBankCardIneligible
  SavingsAccountEligibility: SavingsAccountEligibility
  BankAccountDisclosureFilter: BankAccountDisclosureFilter
  BankAccountDisclosure: BankAccountDisclosure
  FinancialInstitution: FinancialInstitution
  FinancialInstitutionTypePagination: FinancialInstitutionTypePagination
  FinancialInstitutionTypeEdge: FinancialInstitutionTypeEdge
  LinkedAccount: LinkedAccount
  LinkedSubaccount: LinkedSubaccount
  LinkedAccountAlertsResponse:
    | ResolversParentTypes['LinkedAccountAlert']
    | ResolversParentTypes['RelinkLinkedAccountAlert']
  LinkedAccountAlert: LinkedAccountAlert
  RelinkLinkedAccountAlert: RelinkLinkedAccountAlert
  Webhooks: Webhooks
  RoundUpAccount: RoundUpAccount
  RoundUpProfile: RoundUpProfile
  RoundUp: RoundUp
  RoundUpTypePagination: RoundUpTypePagination
  RoundUpTypeEdge: RoundUpTypeEdge
  AllPastCoreItemsSchemaFilter: AllPastCoreItemsSchemaFilter
  PastItemConnection: PastItemConnection
  PastItemEdge: PastItemEdge
  PastItem:
    | ResolversParentTypes['CoreACHSubscriptionFeeItem']
    | ResolversParentTypes['CoreAdjustmentItem']
    | ResolversParentTypes['CoreCashForwardItem']
    | ResolversParentTypes['CoreCollectionItem']
    | ResolversParentTypes['CoreDividendsItem']
    | ResolversParentTypes['CoreEmployeeCreditItem']
    | ResolversParentTypes['CoreFeeInvestmentItem']
    | ResolversParentTypes['CoreFoundMoneyRewardItem']
    | ResolversParentTypes['CoreGiftCardCreditRedemptionItem']
    | ResolversParentTypes['CoreHoldingsTransferInItem']
    | ResolversParentTypes['CoreInvestmentItem']
    | ResolversParentTypes['CoreLocalFoundMoneyItem']
    | ResolversParentTypes['CorePartnerRewardItem']
    | ResolversParentTypes['CoreRebalanceItem']
    | ResolversParentTypes['CoreReferralRewardItem']
    | ResolversParentTypes['CoreRoundUpsItem']
    | ResolversParentTypes['CoreWithdrawalItem']
    | ResolversParentTypes['EarlyDividendsItem']
    | ResolversParentTypes['EarlyFeeInvestmentItem']
    | ResolversParentTypes['EarlyGiftItem']
    | ResolversParentTypes['EarlyInvestmentItem']
    | ResolversParentTypes['EarlyWithdrawalItem']
    | ResolversParentTypes['LaterDividendsItem']
    | ResolversParentTypes['LaterFeeInvestmentItem']
    | ResolversParentTypes['LaterInvestmentItem']
    | ResolversParentTypes['LaterRebalanceItem']
    | ResolversParentTypes['LaterWithdrawalItem']
    | ResolversParentTypes['PastCoreItem']
    | ResolversParentTypes['PastSpendItem']
    | ResolversParentTypes['SpendATMReimbursementItem']
    | ResolversParentTypes['SpendATMWithdrawalItem']
    | ResolversParentTypes['SpendBillPayItem']
    | ResolversParentTypes['SpendCheckDepositItem']
    | ResolversParentTypes['SpendCheckPaymentItem']
    | ResolversParentTypes['SpendDigitalWalletItem']
    | ResolversParentTypes['SpendDirectDepositItem']
    | ResolversParentTypes['SpendECheckItem']
    | ResolversParentTypes['SpendPurchaseItem']
    | ResolversParentTypes['SpendRealTimeRoundUpItem']
    | ResolversParentTypes['SpendTransferInItem']
    | ResolversParentTypes['SpendTransferOutItem']
  AllPastLaterItemsSchemaFilter: AllPastLaterItemsSchemaFilter
  AllPastSpendItemsSchemaFilter: AllPastSpendItemsSchemaFilter
  AllPastEarlyItemsSchemaFilter: AllPastEarlyItemsSchemaFilter
  PastCoreSummary: PastCoreSummary
  PastEarlySummary: PastEarlySummary
  PastSpendSummary: PastSpendSummary
  TransferableFrom: TransferableFrom
  TransferableAccount: TransferableAccount
  AllTransferableToInput: AllTransferableToInput
  TransferableTo: TransferableTo
  EstimatedTransferDatesInput: EstimatedTransferDatesInput
  EstimatedTransferDatesPayload: EstimatedTransferDatesPayload
  ReturnedCheckDeposit: ReturnedCheckDeposit
  EvaluateCheckDepositInput: EvaluateCheckDepositInput
  EvaluateCheckDepositPayload: EvaluateCheckDepositPayload
  DepositRiskFactor: DepositRiskFactor
  ContactCategory: ContactCategory
  ContactSubcategory: ContactSubcategory
  ContactFaq: ContactFaq
  SubcategoryMessage: SubcategoryMessage
  AllSupportArticlesFilterInput: AllSupportArticlesFilterInput
  SupportArticle: SupportArticle
  SupportAuthor: SupportAuthor
  SupportAuthorPhoto: SupportAuthorPhoto
  SupportSection: SupportSection
  SupportCategory: SupportCategory
  SupportTicketForm: SupportTicketForm
  SupportTicketFormField: SupportTicketFormField
  CustomFieldOption: CustomFieldOption
  ScheduleInput: ScheduleInput
  ScheduleResult: ScheduleResult
  ContactFormAlert: ContactFormAlert
  HelpFormContent: HelpFormContent
  SearchSupportArticleResult: SearchSupportArticleResult
  SearchSupportResult: SearchSupportResult
  userWinbackScoreRes:
    | ResolversParentTypes['userWinbackScore']
    | ResolversParentTypes['userWinbackErrors']
  userWinbackScore: UserWinbackScore
  userWinbackErrors: UserWinbackErrors
  CardDeliveryStatus: CardDeliveryStatus
  DirectDepositStatePayload: DirectDepositStatePayload
  DirectDepositState: DirectDepositState
  PdfDownloadUrlInput: PdfDownloadUrlInput
  GenerateUpdatedPdfPayload: GenerateUpdatedPdfPayload
  ParameterizedPdfInput: ParameterizedPdfInput
  PdfDownloadUrlPayload: PdfDownloadUrlPayload
  SearchEmployersInput: SearchEmployersInput
  SearchEmployersPayload: SearchEmployersPayload
  Employer: Omit<Employer, 'switch'> & { switch: ResolversParentTypes['AbstractSwitch'] }
  AbstractSwitch:
    | ResolversParentTypes['AcornsPdfSwitch']
    | ResolversParentTypes['OnlineSwitch']
    | ResolversParentTypes['SubmittableSwitch']
  AcornsPdfSwitch: AcornsPdfSwitch
  SwitchInterface:
    | ResolversParentTypes['AcornsPdfSwitch']
    | ResolversParentTypes['OnlineSwitch']
    | ResolversParentTypes['SubmittableSwitch']
  OnlineSwitch: OnlineSwitch
  SubmittableSwitch: SubmittableSwitch
  TopEmployerPayload: TopEmployerPayload
  TopEmployer: TopEmployer
  suitability_Portfolio: Suitability_Portfolio
  suitability_SuitabilityResponse: Suitability_SuitabilityResponse
  suitability_SuitabilityAnswer: Suitability_SuitabilityAnswer
  suitability_SuitabilityQuestion: Suitability_SuitabilityQuestion
  AllCheckPaymentsResult:
    | ResolversParentTypes['CheckPaymentConnection']
    | ResolversParentTypes['AuthorizationError']
  CheckPaymentConnection: CheckPaymentConnection
  CheckPaymentEdge: CheckPaymentEdge
  CheckPayment: CheckPayment
  CheckPaymentAddress: CheckPaymentAddress
  AuthorizationError: AuthorizationError
  EstimatedCheckPaymentDates: EstimatedCheckPaymentDates
  VerifyCheckPaymentRecipientAddressInputType: VerifyCheckPaymentRecipientAddressInputType
  CheckPaymentRecipientInput: CheckPaymentRecipientInput
  CheckPaymentAddressInput: CheckPaymentAddressInput
  VerifyCheckPaymentRecipientAddressResult:
    | ResolversParentTypes['CheckPaymentRecipientAddressType']
    | ResolversParentTypes['InvalidAddressError']
    | ResolversParentTypes['AuthorizationError']
  CheckPaymentRecipientAddressType: CheckPaymentRecipientAddressType
  CheckPaymentRecipient: CheckPaymentRecipient
  InvalidAddressError: InvalidAddressError
  InvestmentAccountsByUserIdFilter: InvestmentAccountsByUserIdFilter
  CombinedPerformance: CombinedPerformance
  EarlyAccountStateRegulationResult:
    | ResolversParentTypes['EarlyAccountStateRegulation']
    | ResolversParentTypes['InternalErrorException']
    | ResolversParentTypes['InvalidStateException']
    | ResolversParentTypes['UserNotFoundException']
  EarlyAccountStateRegulation: EarlyAccountStateRegulation
  InternalErrorException: InternalErrorException
  InvalidStateException: InvalidStateException
  UserNotFoundException: UserNotFoundException
  EarlyAccountTransferInfo: EarlyAccountTransferInfo
  FundingSourceAccount: FundingSourceAccount
  Investment: Investment
  InvestmentAllocation: InvestmentAllocation
  Referral: Referral
  Result: Result
  UserAlertsResponse:
    | ResolversParentTypes['AddressDocumentRequestedUserAlert']
    | ResolversParentTypes['BankDocumentRequestedUserAlert']
    | ResolversParentTypes['IdentityDocumentRequestedUserAlert']
    | ResolversParentTypes['InsufficientFundsUserAlert']
    | ResolversParentTypes['InvestmentsPausedUserAlert']
    | ResolversParentTypes['MiscDocumentRequestedUserAlert']
    | ResolversParentTypes['NoFundingSourceUserAlert']
    | ResolversParentTypes['RdvRequiredUserAlert']
    | ResolversParentTypes['SSNDocumentRequestedUserAlert']
    | ResolversParentTypes['UserAlert']
    | ResolversParentTypes['W9DocumentRequestedUserAlert']
  AddressDocumentRequestedUserAlert: AddressDocumentRequestedUserAlert
  BankDocumentRequestedUserAlert: BankDocumentRequestedUserAlert
  IdentityDocumentRequestedUserAlert: IdentityDocumentRequestedUserAlert
  InsufficientFundsUserAlert: InsufficientFundsUserAlert
  InvestmentsPausedUserAlert: InvestmentsPausedUserAlert
  MiscDocumentRequestedUserAlert: MiscDocumentRequestedUserAlert
  NoFundingSourceUserAlert: NoFundingSourceUserAlert
  RdvRequiredUserAlert: RdvRequiredUserAlert
  SSNDocumentRequestedUserAlert: SsnDocumentRequestedUserAlert
  W9DocumentRequestedUserAlert: W9DocumentRequestedUserAlert
  ContributionAbility: ContributionAbility
  LaterContributionAbilityResult: ResolversParentTypes['ContributionAbilityByYear']
  ContributionAbilityByYear: ContributionAbilityByYear
  PastLaterSummary: PastLaterSummary
  WithholdingEstimates: WithholdingEstimates
  YearLaterReport: YearLaterReport
  RecurringTransfersFilterInput: RecurringTransfersFilterInput
  RecurringTransferAccountIdFilterInput: RecurringTransferAccountIdFilterInput
  RecurringTransferDirectionFilterInput: RecurringTransferDirectionFilterInput
  RecurringTransfer: RecurringTransfer
  RecurrenceRule: RecurrenceRule
  RecurringTransferEvent: RecurringTransferEvent
  RecurringTransferAccount: RecurringTransferAccount
  RecurringTransferFundingSource: RecurringTransferFundingSource
  RecurrenceRuleInput: RecurrenceRuleInput
  NextTransferDateResult:
    | ResolversParentTypes['RecurringTransferDate']
    | ResolversParentTypes['MalformedRecurringTransferException']
  RecurringTransferDate: RecurringTransferDate
  MalformedRecurringTransferException: MalformedRecurringTransferException
  RecurringTransferPathException: RecurringTransferPathException
  ProtectContext: ProtectContext
  CoverageShop: Omit<CoverageShop, 'widgets'> & {
    widgets: Array<ResolversParentTypes['CoverageShopWidget']>
  }
  Disclaimer: Disclaimer
  Cta: Cta
  Image: Image
  Modal: Modal
  CoverageShopWidget:
    | ResolversParentTypes['FeaturedOffers']
    | ResolversParentTypes['InsuranceCarousel']
    | ResolversParentTypes['PartnerChoices']
  FeaturedOffers: FeaturedOffers
  FeaturedOffer: FeaturedOffer
  InsuranceCarousel: InsuranceCarousel
  CarouselOffer: CarouselOffer
  PartnerChoices: PartnerChoices
  ProtectHome: Omit<ProtectHome, 'widgets'> & {
    widgets: Array<ResolversParentTypes['ProtectHomeWidget']>
  }
  ProtectHomeWidget:
    | ResolversParentTypes['Education']
    | ResolversParentTypes['ExploreCarousel']
    | ResolversParentTypes['HomeIcons']
    | ResolversParentTypes['InsuranceSection']
  Education: Education
  Article: Article
  ExploreCarousel: ExploreCarousel
  InsuranceSection: InsuranceSection
  HomeIcons: HomeIcons
  HomeIcon: HomeIcon
  InsuranceHome: Omit<InsuranceHome, 'widgets'> & {
    widgets: Array<ResolversParentTypes['InsuranceHomeWidget']>
  }
  InsuranceHomeWidget:
    | ResolversParentTypes['CoverageAsk']
    | ResolversParentTypes['CoverageCalculator']
    | ResolversParentTypes['CoverageGrow']
    | ResolversParentTypes['CoverageKnown']
    | ResolversParentTypes['CoverageUnknown']
    | ResolversParentTypes['InsuranceCarousel']
  CoverageAsk: CoverageAsk
  CoverageCalculator: CoverageCalculator
  CoverageGrow: CoverageGrow
  CoverageKnown: CoverageKnown
  EducationSection: EducationSection
  CoverageUnknown: CoverageUnknown
  ProtectLander: ProtectLander
  ProtectLearningCenter: ProtectLearningCenter
  LifeCalculatorSurvey: LifeCalculatorSurvey
  LifeCalculatorQuestion: LifeCalculatorQuestion
  Tip: Tip
  PremiumsInput: PremiumsInput
  PremiumsResult: Omit<PremiumsResult, 'quoteData'> & {
    quoteData: ResolversParentTypes['QuoteResult']
  }
  QuoteResult:
    | ResolversParentTypes['IneligibilityLander']
    | ResolversParentTypes['LifeQuoteResultSliders']
  IneligibilityLander: IneligibilityLander
  LifeQuoteResultSliders: LifeQuoteResultSliders
  Footer: Footer
  Header: Header
  Premium: Premium
  QuoteSlider: QuoteSlider
  LifeQuoteSurvey: LifeQuoteSurvey
  LifeQuoteStep: LifeQuoteStep
  LifeQuoteQuestion: LifeQuoteQuestion
  QuestionAnswer: QuestionAnswer
  Question: Question
  Answer: Answer
  ProviderSearch: ProviderSearch
  Provider: Provider
  UnknownProvider: UnknownProvider
  Recommendations: Omit<Recommendations, 'widgets'> & {
    widgets: Array<ResolversParentTypes['RecommendationWidget']>
  }
  RecommendationWidget: ResolversParentTypes['BriefInsuranceSection']
  BriefInsuranceSection: BriefInsuranceSection
  RecommendedLifeCoverage: Omit<RecommendedLifeCoverage, 'widgets'> & {
    widgets: Array<ResolversParentTypes['RecommendedLifeCoverageWidget']>
  }
  AboutSection: AboutSection
  RecommendedLifeCoverageWidget:
    | ResolversParentTypes['CollapsedLifeRecommendation']
    | ResolversParentTypes['ExpandedLifeRecommendation']
    | ResolversParentTypes['InsuranceCarousel']
  CollapsedLifeRecommendation: CollapsedLifeRecommendation
  ExpandedLifeRecommendation: ExpandedLifeRecommendation
  LifeCoverageBreakdown: LifeCoverageBreakdown
  LifeCoverageBreakdownCategory: LifeCoverageBreakdownCategory
  ActivitySummaryResponse: ActivitySummaryResponse
  SummaryItem: SummaryItem
  FinishSetup: FinishSetup
  SetUpTip: SetUpTip
  ActionFeedCta: ActionFeedCta
  OnboardingTips: OnboardingTips
  OnboardingTipItem: OnboardingTipItem
  FoundMoneyCampaignV2: FoundMoneyCampaignV2
  FoundMoneyCampaignOfferV2: FoundMoneyCampaignOfferV2
  EarnOfferQueryPage: EarnOfferQueryPage
  EarnOffer: EarnOffer
  EarnOfferCtaDetails: EarnOfferCtaDetails
  EarnPageInfo: EarnPageInfo
  FavoritePartnerOfferGroup: Omit<FavoritePartnerOfferGroup, 'offers'> & {
    offers: Array<ResolversParentTypes['PartnerOfferGroupItem']>
  }
  PartnerOfferGroupItem:
    | ResolversParentTypes['JobOffer']
    | ResolversParentTypes['PromoOffer']
    | ResolversParentTypes['JobSearchOffer']
    | ResolversParentTypes['EarnOffer']
  JobOffer: JobOffer
  OfferLocation: OfferLocation
  JobOfferSalary: JobOfferSalary
  PromoOffer: PromoOffer
  JobSearchOffer: JobSearchOffer
  JobSearchFilter: JobSearchFilter
  PartnerOfferGroupFilterInput: PartnerOfferGroupFilterInput
  OfferLocationInput: OfferLocationInput
  PartnerOfferGroup: Omit<PartnerOfferGroup, 'offers'> & {
    offers: Array<ResolversParentTypes['PartnerOfferGroupItem']>
  }
  PartnerOfferGroupsTypeInput: PartnerOfferGroupsTypeInput
  JobAlert: JobAlert
  JobSearchCriteriaInput: JobSearchCriteriaInput
  JobSearchFilterInput: JobSearchFilterInput
  JobLocationInput: JobLocationInput
  jobs_Offer: Jobs_Offer
  JobLocation: JobLocation
  jobs_OfferSalary: Jobs_OfferSalary
  jobs_OfferConnection: Jobs_OfferConnection
  jobs_OfferEdge: Jobs_OfferEdge
  JobSearchPage: JobSearchPage
  JobSearchCriteria: JobSearchCriteria
  jobs_Education: Jobs_Education
  jobs_Article: Jobs_Article
  MilestoneRule: MilestoneRule
  Milestone: Omit<Milestone, 'progress'> & { progress: ResolversParentTypes['MilestoneProgress'] }
  Destination: Destination
  EducationTip: EducationTip
  MilestoneProgress:
    | ResolversParentTypes['CurrencyMilestoneProgress']
    | ResolversParentTypes['DiscreteMilestoneProgress']
  CurrencyMilestoneProgress: CurrencyMilestoneProgress
  DiscreteMilestoneProgress: DiscreteMilestoneProgress
  AccountPoints: AccountPoints
  ChallengePointsEarned: ChallengePointsEarned
  MilestoneByThemeFilterInput: MilestoneByThemeFilterInput
  MilestoneThemeGroup: Omit<MilestoneThemeGroup, 'contents'> & {
    contents: Array<ResolversParentTypes['MilestoneThemeGroupContent']>
  }
  MilestoneThemeGroupContent:
    | ResolversParentTypes['MilestoneRuleGroup']
    | ResolversParentTypes['Milestone']
  MilestoneRuleGroup: Omit<MilestoneRuleGroup, 'contents'> & {
    contents: Array<ResolversParentTypes['MilestoneRuleGroupContent']>
  }
  MilestoneRuleGroupContent: ResolversParentTypes['Milestone']
  MilestoneHub: Omit<MilestoneHub, 'groupedMilestones'> & {
    groupedMilestones: Array<ResolversParentTypes['MilestoneGroup']>
  }
  MilestoneAccountLevelDefinition: MilestoneAccountLevelDefinition
  MilestoneHubAccount: MilestoneHubAccount
  MilestoneGroup:
    | ResolversParentTypes['MilestoneRuleGroup']
    | ResolversParentTypes['MilestoneThemeGroup']
  MilestoneHubDefinition: MilestoneHubDefinition
  FeaturedMilestones: FeaturedMilestones
  FeaturedMilestonesV2:
    | ResolversParentTypes['AccountSetupMilestones']
    | ResolversParentTypes['FeaturedMilestones']
  AccountSetupMilestones: AccountSetupMilestones
  MilestoneDefinition: MilestoneDefinition
  AccountPointsRule: AccountPointsRule
  MilestoneChallengePointsRule: MilestoneChallengePointsRule
  MilestoneGroupDefinition: MilestoneGroupDefinition
  MilestoneChallenge: Omit<MilestoneChallenge, 'groupedMilestones'> & {
    groupedMilestones: Array<ResolversParentTypes['MilestoneGroup']>
  }
  MilestoneEligibility: MilestoneEligibility
  MilestoneAchievementActionRule: MilestoneAchievementActionRule
  MilestoneGroupAchievementActionRule: MilestoneGroupAchievementActionRule
  MessageStatusFilterInput: MessageStatusFilterInput
  Message: ResolversParentTypes['AlertMessage'] | ResolversParentTypes['NotificationMessage']
  MessageTextAsset: ResolversParentTypes['StringKeyAsset']
  StringKeyAsset: StringKeyAsset
  MessageVisualAsset: ResolversParentTypes['DesignLibraryIcon'] | ResolversParentTypes['Image']
  DesignLibraryIcon: DesignLibraryIcon
  MessagePageInput: MessagePageInput
  MessageConnection: MessageConnection
  MessageEdge: MessageEdge
  MessagePageInfo: MessagePageInfo
  LearnContentCategory: ResolversParentTypes['LearnTier'] | ResolversParentTypes['LearnTopic']
  LearnTier: Omit<LearnTier, 'icon'> & { icon: ResolversParentTypes['LearnVisualAsset'] }
  LearnVisualAsset: ResolversParentTypes['Image']
  LearnTopic: Omit<LearnTopic, 'icon'> & { icon: ResolversParentTypes['LearnVisualAsset'] }
  FeaturedLearnContentPreview:
    | ResolversParentTypes['LearnArticlePreview']
    | ResolversParentTypes['LearnMediaPreview']
  LearnArticlePreview: Omit<LearnArticlePreview, 'duration' | 'featuredImage'> & {
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage: ResolversParentTypes['LearnVisualAsset']
  }
  LearnContentDuration: ResolversParentTypes['Milliseconds']
  Milliseconds: Milliseconds
  LearnProgress: LearnProgress
  LearnMediaPreview: Omit<LearnMediaPreview, 'audioTheme' | 'duration' | 'featuredImage'> & {
    audioTheme?: Maybe<ResolversParentTypes['LearnMediaTheme']>
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage: ResolversParentTypes['LearnVisualAsset']
  }
  LearnMediaTheme: ResolversParentTypes['LearnThemeLiteral']
  LearnThemeLiteral: LearnThemeLiteral
  TrendingLearnContentPreview:
    | ResolversParentTypes['LearnArticlePreview']
    | ResolversParentTypes['LearnArticlePreviewLocked']
    | ResolversParentTypes['LearnMediaPreview']
    | ResolversParentTypes['LearnMediaPreviewLocked']
  LearnArticlePreviewLocked: Omit<LearnArticlePreviewLocked, 'duration' | 'featuredImage'> & {
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage: ResolversParentTypes['LearnVisualAsset']
  }
  LearnMediaPreviewLocked: Omit<LearnMediaPreviewLocked, 'duration' | 'featuredImage'> & {
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage: ResolversParentTypes['LearnVisualAsset']
  }
  LearnMedia: ResolversParentTypes['LearnMediaArticle']
  LearnMediaArticle: Omit<LearnMediaArticle, 'audioTheme' | 'featuredImage'> & {
    audioTheme?: Maybe<ResolversParentTypes['LearnMediaTheme']>
    featuredImage?: Maybe<ResolversParentTypes['LearnVisualAsset']>
  }
  LearnAuthor: Omit<LearnAuthor, 'photo'> & {
    photo?: Maybe<ResolversParentTypes['LearnVisualAsset']>
  }
  LearnInsight: LearnInsight
  LearnMediaReference: Omit<LearnMediaReference, 'duration' | 'theme'> & {
    duration: ResolversParentTypes['LearnContentDuration']
    theme?: Maybe<ResolversParentTypes['LearnMediaTheme']>
  }
  LearnMetadata: Omit<LearnMetadata, 'contentStats' | 'interactionState'> & {
    contentStats?: Maybe<ResolversParentTypes['LearnContentCommunityStats']>
    interactionState?: Maybe<ResolversParentTypes['LearnContentInteractionState']>
  }
  LearnContentCommunityStats: ResolversParentTypes['LearnContentStats']
  LearnContentStats: LearnContentStats
  LearnContentInteractionState: ResolversParentTypes['LearnInteractionState']
  LearnInteractionState: Omit<LearnInteractionState, 'elapsedTime'> & {
    elapsedTime?: Maybe<ResolversParentTypes['LearnContentDuration']>
  }
  LearnPoll: LearnPoll
  LearnTag: LearnTag
  LearnNextStepAction: LearnNextStepAction
  LearnContentPreview:
    | ResolversParentTypes['CoursePreview']
    | ResolversParentTypes['CoursePreviewLocked']
    | ResolversParentTypes['LearnArticlePreview']
    | ResolversParentTypes['LearnArticlePreviewLocked']
    | ResolversParentTypes['LearnMediaPreview']
    | ResolversParentTypes['LearnMediaPreviewLocked']
    | ResolversParentTypes['LearnPollPreview']
    | ResolversParentTypes['LearnPollPreviewLocked']
    | ResolversParentTypes['LessonPreview']
    | ResolversParentTypes['LessonPreviewLocked']
    | ResolversParentTypes['QuizPreview']
    | ResolversParentTypes['QuizPreviewLocked']
  CoursePreview: Omit<CoursePreview, 'courseTheme' | 'duration' | 'featuredImage'> & {
    courseTheme: ResolversParentTypes['CourseTheme']
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage: ResolversParentTypes['LearnVisualAsset']
  }
  CourseTheme: ResolversParentTypes['LearnThemeLiteral']
  CoursePreviewLocked: Omit<CoursePreviewLocked, 'duration' | 'featuredImage'> & {
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage: ResolversParentTypes['LearnVisualAsset']
  }
  LearnPollPreview: LearnPollPreview
  LearnPollOption: LearnPollOption
  LearnPollPreviewLocked: LearnPollPreviewLocked
  LessonPreview: Omit<LessonPreview, 'duration' | 'featuredImage'> & {
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage: ResolversParentTypes['LearnVisualAsset']
  }
  LessonPreviewLocked: Omit<LessonPreviewLocked, 'duration' | 'featuredImage'> & {
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage: ResolversParentTypes['LearnVisualAsset']
  }
  QuizPreview: Omit<QuizPreview, 'duration' | 'featuredImage' | 'quizTheme'> & {
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage: ResolversParentTypes['LearnVisualAsset']
    quizTheme: ResolversParentTypes['QuizTheme']
  }
  QuizTheme: ResolversParentTypes['LearnThemeLiteral']
  QuizPreviewLocked: Omit<QuizPreviewLocked, 'duration' | 'featuredImage'> & {
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage: ResolversParentTypes['LearnVisualAsset']
  }
  Course: Omit<Course, 'duration' | 'featuredImage' | 'theme'> & {
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage: ResolversParentTypes['LearnVisualAsset']
    theme: ResolversParentTypes['CourseTheme']
  }
  Lesson: Lesson
  LearnCoursePreview:
    | ResolversParentTypes['CoursePreview']
    | ResolversParentTypes['CoursePreviewLocked']
  Quiz: Omit<Quiz, 'duration' | 'featuredImage' | 'theme'> & {
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage?: Maybe<ResolversParentTypes['LearnVisualAsset']>
    theme: ResolversParentTypes['QuizTheme']
  }
  LearnQuestion: LearnQuestion
  LearnAnswer: LearnAnswer
  LearnQuestionInsight: LearnQuestionInsight
  CompletedQuiz: CompletedQuiz
  LearnArticle: Omit<LearnArticle, 'contentImage' | 'duration' | 'featuredImage'> & {
    contentImage?: Maybe<ResolversParentTypes['LearnVisualAsset']>
    duration: ResolversParentTypes['LearnContentDuration']
    featuredImage: ResolversParentTypes['LearnVisualAsset']
  }
  LearnContentFilterInput: LearnContentFilterInput
  MillisecondsInput: MillisecondsInput
  LearnContentPageInput: LearnContentPageInput
  ContentPreviewConnection: ContentPreviewConnection
  LearnConnection: ResolversParentTypes['ContentPreviewConnection']
  LearnEdge: ResolversParentTypes['ContentPreviewEdge']
  LearnPageInfo: LearnPageInfo
  ContentPreviewEdge: Omit<ContentPreviewEdge, 'node'> & {
    node: ResolversParentTypes['LearnContentPreview']
  }
  LearnContentFilterByTierIdInput: LearnContentFilterByTierIdInput
  LearnContentFilterByTopicIdInput: LearnContentFilterByTopicIdInput
  SearchHistory: SearchHistory
  DocumentRequestInput: DocumentRequestInput
  DocumentRequest: DocumentRequest
  Document: Document
  DocumentRequestsInput: DocumentRequestsInput
  DocumentRequestsPageInput: DocumentRequestsPageInput
  DocumentRequestsConnection: DocumentRequestsConnection
  DocumentRequestEdge: DocumentRequestEdge
  DocumentRequestsPageInfo: DocumentRequestsPageInfo
  Authenticator:
    | ResolversParentTypes['PhoneAuthenticator']
    | ResolversParentTypes['EmailAuthenticator']
  AuthProfile: AuthProfile
  EmailAddress: Scalars['EmailAddress']
  LoginAccess: LoginAccess
  AuthAlert: ResolversParentTypes['MfaMissingAuthAlert']
  PasswordResetForm: PasswordResetForm
  PasswordResetFormFields: PasswordResetFormFields
  EmailAddressValidation: EmailAddressValidation
  ValidatePasswordResetTokenResult:
    | ResolversParentTypes['ValidatePasswordResetTokenSuccess']
    | ResolversParentTypes['InvalidPasswordResetTokenException']
  ValidatePasswordResetTokenSuccess: ValidatePasswordResetTokenSuccess
  InvalidPasswordResetTokenException: InvalidPasswordResetTokenException
  PromotionFilterInput: PromotionFilterInput
  PromotionPresentInContextsFilterInput: PromotionPresentInContextsFilterInput
  SubscriptionMigrationWaiver: SubscriptionMigrationWaiver
  TierGroup: TierGroup
  TierOption: TierOption
  TierOptionByTierPriceIdResult:
    | ResolversParentTypes['InvalidTierPriceId']
    | ResolversParentTypes['TierOption']
  InvalidTierPriceId: InvalidTierPriceId
  TierSubscriptionForUser:
    | ResolversParentTypes['TierSubscription']
    | ResolversParentTypes['TierSubscriptionNotFound']
    | ResolversParentTypes['TierSubscriptionUnsubscribed']
  TierSubscriptionNotFound: TierSubscriptionNotFound
  TierSubscriptionUnsubscribed: TierSubscriptionUnsubscribed
  TierSubscriptionConnection: TierSubscriptionConnection
  TierSubscriptionPageInfo: TierSubscriptionPageInfo
  SplitDepositSettings:
    | ResolversParentTypes['SplitDepositDirectDepositIntentSetting']
    | ResolversParentTypes['SplitDepositDirectDepositSetting']
    | ResolversParentTypes['SplitDepositRecurrenceSetting']
  SplitDepositAllocation:
    | ResolversParentTypes['SplitDepositDirectDepositAllocation']
    | ResolversParentTypes['SplitDepositRecurrenceAllocation']
  SplitDeposit: SplitDeposit
  DistributionAmounts: DistributionAmounts
  SplitDepositSettingsFilterInput: SplitDepositSettingsFilterInput
  SmartDepositMetadataInput: SmartDepositMetadataInput
  SmartDepositMetadataResult: SmartDepositMetadataResult
  SplitDepositTargetAccount: SplitDepositTargetAccount
  OutsideContributionCode: OutsideContributionCode
  EarnCTARecord: EarnCtaRecord
  FeeNegotiationOutput: FeeNegotiationOutput
  FeeNegotiation: FeeNegotiation
  BankConnection: BankConnection
  BankFeeNegotiationResults: BankFeeNegotiationResults
  ServiceNode: ServiceNode
  BillNegotiation: BillNegotiation
  BankFeeNegotiationAlert: BankFeeNegotiationAlert
  BankFeeConnectionAlert: BankFeeConnectionAlert
  BankFee: BankFee
  BankFeeSummary: BankFeeSummary
  FeeStatusSummary: FeeStatusSummary
  BankFeeConnection: BankFeeConnection
  Submission: Submission
  AuthenticateForFeeNegotiationStatus: AuthenticateForFeeNegotiationStatus
  TfaOptions: TfaOptions
  AutomationError: AutomationError
  MailInDocument: MailInDocument
  LOBThumbNails: LobThumbNails
  SampleMailInDocument: SampleMailInDocument
  PartnerUrlInput: PartnerUrlInput
  PartnerUrlResponse: PartnerUrlResponse
  PartnerDocumentUrlResponse: PartnerDocumentUrlResponse
  PartnerDetailsResponse: PartnerDetailsResponse
  Advocate: Advocate
  Friend: Friend
  ReferralCampaign: ReferralCampaign
  ReferralEvent: ReferralEvent
  ReferralReward: ReferralReward
  FriendExperienceContent: FriendExperienceContent
  ReferralHistory: ReferralHistory
  FriendSummary: FriendSummary
  ExperienceContent: ExperienceContent
  RegistrationFunnelFilter: RegistrationFunnelFilter
  RegistrationFunnel: RegistrationFunnel
  RegistrationPage: RegistrationPage
  RegistrationPageAction: RegistrationPageAction
  FunnelMetadata: FunnelMetadata
  SourceAttributes: SourceAttributes
  SecurityBySymbolInput: SecurityBySymbolInput
  SecuritiesBySymbolsInput: SecuritiesBySymbolsInput
  SecuritiesBySymbolsResponse: SecuritiesBySymbolsResponse
  SecurityPerformanceBySymbolInput: SecurityPerformanceBySymbolInput
  SecurityPerformance: SecurityPerformance
  SecurityGain: SecurityGain
  SecurityPrice: SecurityPrice
  SecurityPerformancesBySymbolInput: SecurityPerformancesBySymbolInput
  SearchSecuritiesInput: SearchSecuritiesInput
  SearchSecuritiesResponse: SearchSecuritiesResponse
  SearchSecuritiesPageInfo: SearchSecuritiesPageInfo
  SecuritiesBySectorInput: SecuritiesBySectorInput
  SecuritiesBySectorResponse: SecuritiesBySectorResponse
  SecuritiesBySectorPageInfo: SecuritiesBySectorPageInfo
  CohortEligibility: CohortEligibility
  Mutation: {}
  Void: Scalars['Void']
  SetPortfolioInput: SetPortfolioInput
  RequestAccountClosureInput: RequestAccountClosureInput
  ConnectACHAccountInput: ConnectAchAccountInput
  RoutingNumber: Scalars['RoutingNumber']
  AccountNumber: Scalars['AccountNumber']
  ConnectACHAccountResult:
    | ResolversParentTypes['InstitutionNotSupportedError']
    | ResolversParentTypes['ConnectACHAccountSucceeded']
  InstitutionNotSupportedError: InstitutionNotSupportedError
  ConnectACHAccountSucceeded: ConnectAchAccountSucceeded
  Session: Session
  TransactionResult: TransactionResult
  MakeInvestmentInput: MakeInvestmentInput
  MakeInvestmentPayload: MakeInvestmentPayload
  RecurringInvestmentInput: RecurringInvestmentInput
  RecurringInvestmentPayload: RecurringInvestmentPayload
  LadderResponse: LadderResponse
  LadderQuoteStatus: LadderQuoteStatus
  LadderQuote: LadderQuote
  LadderLinkResponse: LadderLinkResponse
  CustodianAddressInput: CustodianAddressInput
  PdfFormLinks: PdfFormLinks
  CreateInvestmentAccountResponse: CreateInvestmentAccountResponse
  ProfileAttribute: ProfileAttribute
  laterTotalLiquidationInput: LaterTotalLiquidationInput
  LaterIndividualBeneficiaryResponse: LaterIndividualBeneficiaryResponse
  ContactInfoInput: ContactInfoInput
  EmploymentInput: EmploymentInput
  SuitabilityInput: SuitabilityInput
  InvestorQuestionsInput: InvestorQuestionsInput
  PersonalInfoInput: PersonalInfoInput
  UpdateUserInfoResult:
    | ResolversParentTypes['User']
    | ResolversParentTypes['SSNUsedError']
    | ResolversParentTypes['InvalidSSNError']
    | ResolversParentTypes['POBoxAddressError']
  SSNUsedError: SsnUsedError
  InvalidSSNError: InvalidSsnError
  POBoxAddressError: PoBoxAddressError
  SecurityQuestionInput: SecurityQuestionInput
  BeneficiaryInput: BeneficiaryInput
  CreateBeneficiaryResult:
    | ResolversParentTypes['Beneficiary']
    | ResolversParentTypes['BeneficiaryExceedsAgeLimitException']
    | ResolversParentTypes['InternalErrorException']
    | ResolversParentTypes['InvalidDateOfBirthException']
    | ResolversParentTypes['InvalidFirstNameException']
    | ResolversParentTypes['InvalidLastNameException']
  BeneficiaryExceedsAgeLimitException: BeneficiaryExceedsAgeLimitException
  InvalidDateOfBirthException: InvalidDateOfBirthException
  InvalidFirstNameException: InvalidFirstNameException
  InvalidLastNameException: InvalidLastNameException
  DeactivateBeneficiaryResult:
    | ResolversParentTypes['Beneficiary']
    | ResolversParentTypes['BeneficiaryNotFoundException']
    | ResolversParentTypes['InternalErrorException']
  BeneficiaryNotFoundException: BeneficiaryNotFoundException
  SetBeneficiarySsnResult:
    | ResolversParentTypes['Beneficiary']
    | ResolversParentTypes['BeneficiaryNotFoundException']
    | ResolversParentTypes['InternalErrorException']
    | ResolversParentTypes['InvalidSsnException']
    | ResolversParentTypes['SecretSquirrelException']
    | ResolversParentTypes['SsnAlreadyInUseException']
    | ResolversParentTypes['SsnMatchesCustodianException']
    | ResolversParentTypes['SsnUpdateForbiddenException']
  InvalidSsnException: InvalidSsnException
  SecretSquirrelException: SecretSquirrelException
  SsnAlreadyInUseException: SsnAlreadyInUseException
  SsnMatchesCustodianException: SsnMatchesCustodianException
  SsnUpdateForbiddenException: SsnUpdateForbiddenException
  AddressInput: AddressInput
  BeneficiaryInfoInput: BeneficiaryInfoInput
  UpdateBeneficiaryInfoResult:
    | ResolversParentTypes['Beneficiary']
    | ResolversParentTypes['BeneficiaryNotFoundException']
    | ResolversParentTypes['InternalErrorException']
    | ResolversParentTypes['InvalidAddressException']
    | ResolversParentTypes['InvalidEmailException']
    | ResolversParentTypes['InvalidPhoneException']
  InvalidAddressException: InvalidAddressException
  InvalidEmailException: InvalidEmailException
  InvalidPhoneException: InvalidPhoneException
  ProfileInput: ProfileInput
  ActivateBankCardInput: ActivateBankCardInput
  ActivateBankCardPayload: ActivateBankCardPayload
  CreateBankAccountInput: CreateBankAccountInput
  CreateBankAccountPayload: CreateBankAccountPayload
  LockBankCardInput: LockBankCardInput
  LockBankCardPayload: LockBankCardPayload
  OrderBankCardInput: OrderBankCardInput
  BankCardPrefundTransfer: BankCardPrefundTransfer
  PositiveCurrencyAmountInput: PositiveCurrencyAmountInput
  PositiveFloat: Scalars['PositiveFloat']
  OrderBankCardResult: ResolversParentTypes['BankCardOrder']
  UnlockBankCardPayload: UnlockBankCardPayload
  UpdateBankCardPinInput: UpdateBankCardPinInput
  BankCardPin: Scalars['BankCardPin']
  UpdateBankCardPinPayload: UpdateBankCardPinPayload
  ReportBankCardLostStolenInput: ReportBankCardLostStolenInput
  ReportBankCardLostStolenPayload: ReportBankCardLostStolenPayload
  DeleteExpiredBankCardOrderResult:
    | ResolversParentTypes['BankCardOrder']
    | ResolversParentTypes['DeleteExpiredBankCardOrderNotFoundError']
    | ResolversParentTypes['DeleteExpiredBankCardOrderNotExpiredError']
    | ResolversParentTypes['DeleteExpiredBankCardOrderCardTierNotFoundError']
  DeleteExpiredBankCardOrderNotFoundError: DeleteExpiredBankCardOrderNotFoundError
  DeleteExpiredBankCardOrderNotExpiredError: DeleteExpiredBankCardOrderNotExpiredError
  DeleteExpiredBankCardOrderCardTierNotFoundError: DeleteExpiredBankCardOrderCardTierNotFoundError
  CloseBankAccountInput: CloseBankAccountInput
  CloseBankAccountResult:
    | ResolversParentTypes['BankAccount']
    | ResolversParentTypes['BankAccountNotFoundError']
  BankAccountNotFoundError: BankAccountNotFoundError
  ReissueBankCardInput: ReissueBankCardInput
  BankCardRequestMailingAddressInput: BankCardRequestMailingAddressInput
  ReissueBankCardResult:
    | ResolversParentTypes['BankCardRequest']
    | ResolversParentTypes['ReissueBankCardExistsError']
  ReissueBankCardExistsError: ReissueBankCardExistsError
  SubmitSpendTransactionsDisputeInput: SubmitSpendTransactionsDisputeInput
  SpendTransactionsInput: SpendTransactionsInput
  SpendTransactionsDisputeResult: ResolversParentTypes['SpendTransactionsDisputeResponse']
  SpendTransactionsDisputeResponse: SpendTransactionsDisputeResponse
  SpendTransactionsDisputeCustomersResponse: SpendTransactionsDisputeCustomersResponse
  SpendDisputesResponse: SpendDisputesResponse
  SpendTransactionsDisputeQuestions: SpendTransactionsDisputeQuestions
  SpendTransactionsResponse: SpendTransactionsResponse
  CreateSavingsAccountInput: CreateSavingsAccountInput
  BankAccountGoalInput: BankAccountGoalInput
  CreateSavingsAccountResult:
    | ResolversParentTypes['CreateSavingsAccountPayload']
    | ResolversParentTypes['CreateSavingsAccountVerificationError']
  CreateSavingsAccountPayload: CreateSavingsAccountPayload
  CreateSavingsAccountVerificationError: CreateSavingsAccountVerificationError
  UpdateBankAccountGoalInput: UpdateBankAccountGoalInput
  UpdateBankAccountGoalResult: ResolversParentTypes['UpdateBankAccountGoalPayload']
  UpdateBankAccountGoalPayload: UpdateBankAccountGoalPayload
  AssignLinkedSubaccountInput: AssignLinkedSubaccountInput
  CreatePlaidLinkedAccountInput: CreatePlaidLinkedAccountInput
  GenerateLinkSessionInput: GenerateLinkSessionInput
  LinkSessionResult:
    | ResolversParentTypes['RawLinkSession']
    | ResolversParentTypes['UnrecoverableLinkedAccountError']
    | ResolversParentTypes['WebviewLinkSession']
  RawLinkSession: RawLinkSession
  UnrecoverableLinkedAccountError: UnrecoverableLinkedAccountError
  WebviewLinkSession: WebviewLinkSession
  LinkSessionInput: LinkSessionInput
  RegisterLinkSessionResult:
    | ResolversParentTypes['AsyncLinkSessionResult']
    | ResolversParentTypes['LinkedAccount']
  AsyncLinkSessionResult: AsyncLinkSessionResult
  SetLinkingErrorInput: SetLinkingErrorInput
  UpdateLinkedAccountInput: UpdateLinkedAccountInput
  RoundUpProfileInput: RoundUpProfileInput
  InitiateTransferInput: InitiateTransferInput
  InitiateTransferPayload: InitiateTransferPayload
  Transfer: Transfer
  CancelTransferPayload: CancelTransferPayload
  StartCheckDepositInput: StartCheckDepositInput
  ClientInfo: ClientInfo
  StartCheckDepositPayload: StartCheckDepositPayload
  UploadCheckInput: UploadCheckInput
  CheckImage: CheckImage
  UploadCheckPayload: UploadCheckPayload
  CompleteCheckDepositInput: CompleteCheckDepositInput
  CompleteCheckDepositPayload: CompleteCheckDepositPayload
  CreateSupportTicketInput: CreateSupportTicketInput
  SupportTicket: SupportTicket
  SupportTicketResponse:
    | ResolversParentTypes['SupportTicket']
    | ResolversParentTypes['RecaptchaException']
  RecaptchaException: RecaptchaException
  CreateCustomSupportTicketInput: CreateCustomSupportTicketInput
  SupportTicketWithCustomFieldsResponse:
    | ResolversParentTypes['SupportTicket']
    | ResolversParentTypes['SubmissionError']
  SubmissionError: SubmissionError
  CreateSuspendedUserSupportTicketInput: CreateSuspendedUserSupportTicketInput
  CreateDirectDepositLinkInfoInput: CreateDirectDepositLinkInfoInput
  CreateDirectDepositLinkInfoSwitch:
    | ResolversParentTypes['CreateDirectDepositLinkInfoFailure']
    | ResolversParentTypes['CreateDirectDepositLinkInfoPayload']
  CreateDirectDepositLinkInfoFailure: CreateDirectDepositLinkInfoFailure
  CreateDirectDepositLinkInfoPayload: CreateDirectDepositLinkInfoPayload
  CreatePinwheelLinkToken: CreatePinwheelLinkToken
  StartAcornsPdfSwitchInput: StartAcornsPdfSwitchInput
  StartOnlineSwitchInput: StartOnlineSwitchInput
  StartOnlineSwitchPayload: StartOnlineSwitchPayload
  SwitchPayloadInterface:
    | ResolversParentTypes['StartOnlineSwitchPayload']
    | ResolversParentTypes['StartSubmittableSwitchPayload']
  UserSwitch: UserSwitch
  StartSubmittableSwitchInput: StartSubmittableSwitchInput
  StartSubmittableSwitchAddressInput: StartSubmittableSwitchAddressInput
  StartSubmittableSwitchPayload: StartSubmittableSwitchPayload
  suitability_SuitabilityInput: Suitability_SuitabilityInput
  suitability_UpdateSuitabilityResult: Suitability_UpdateSuitabilityResult
  CancelCheckPaymentResult:
    | ResolversParentTypes['CheckPayment']
    | ResolversParentTypes['ResourceNotFoundError']
    | ResolversParentTypes['UnableToCancelCheckError']
    | ResolversParentTypes['AuthorizationError']
  ResourceNotFoundError: ResourceNotFoundError
  UnableToCancelCheckError: UnableToCancelCheckError
  SendCheckPaymentInput: SendCheckPaymentInput
  SendCheckPaymentResult:
    | ResolversParentTypes['CheckPayment']
    | ResolversParentTypes['AuthorizationError']
    | ResolversParentTypes['DuplicateActionError']
    | ResolversParentTypes['InvalidAddressError']
  DuplicateActionError: DuplicateActionError
  AcceptDocumentInput: AcceptDocumentInput
  AcceptDocumentResponse:
    | ResolversParentTypes['AcceptedDocument']
    | ResolversParentTypes['DocumentNotFound']
    | ResolversParentTypes['UserNotFound']
  AcceptedDocument: AcceptedDocument
  DocumentNotFound: DocumentNotFound
  UserNotFound: UserNotFound
  AddSecurityToPortfolioInput: AddSecurityToPortfolioInput
  AddSecurityToPortfolioResult:
    | ResolversParentTypes['InvestmentAccountNotFoundException']
    | ResolversParentTypes['InvestmentAccountNotSupportedException']
    | ResolversParentTypes['Portfolio']
    | ResolversParentTypes['PortfolioNotFoundException']
    | ResolversParentTypes['PortfolioNotSupportedException']
    | ResolversParentTypes['SecurityNotSupportedException']
  InvestmentAccountNotFoundException: InvestmentAccountNotFoundException
  InvestmentAccountNotSupportedException: InvestmentAccountNotSupportedException
  PortfolioNotFoundException: PortfolioNotFoundException
  PortfolioNotSupportedException: PortfolioNotSupportedException
  SecurityNotSupportedException: SecurityNotSupportedException
  AddSelfDirectedPortfolioInput: AddSelfDirectedPortfolioInput
  AddSelfDirectedPortfolioResult:
    | ResolversParentTypes['CustomerAgreementRequiredException']
    | ResolversParentTypes['InvalidInvestmentAccountException']
    | ResolversParentTypes['InvalidSubscriptionTierException']
    | ResolversParentTypes['InvestmentAccount']
    | ResolversParentTypes['PortfolioNotFoundException']
  CustomerAgreementRequiredException: CustomerAgreementRequiredException
  InvalidInvestmentAccountException: InvalidInvestmentAccountException
  InvalidSubscriptionTierException: InvalidSubscriptionTierException
  CancelInvestmentInput: CancelInvestmentInput
  CancelInvestmentResult:
    | ResolversParentTypes['CancelInvestmentPayload']
    | ResolversParentTypes['InvestmentNotFoundException']
    | ResolversParentTypes['InvestmentUncancellableException']
  CancelInvestmentPayload: CancelInvestmentPayload
  InvestmentNotFoundException: InvestmentNotFoundException
  InvestmentUncancellableException: InvestmentUncancellableException
  CancelInvestmentAccountClosureRequestInput: CancelInvestmentAccountClosureRequestInput
  CancelInvestmentAccountClosureRequestResult:
    | ResolversParentTypes['AccountClosedException']
    | ResolversParentTypes['AccountNotFoundException']
    | ResolversParentTypes['ClosureRequestDoesNotExistException']
    | ResolversParentTypes['InvestmentAccount']
  AccountClosedException: AccountClosedException
  AccountNotFoundException: AccountNotFoundException
  ClosureRequestDoesNotExistException: ClosureRequestDoesNotExistException
  CloseInvestmentAccountInput: CloseInvestmentAccountInput
  CloseInvestmentAccountResult:
    | ResolversParentTypes['AccountNotFoundException']
    | ResolversParentTypes['InvestmentAccount']
    | ResolversParentTypes['InvestmentAccountAlreadyClosed']
    | ResolversParentTypes['InvestmentAccountClosureInProgress']
    | ResolversParentTypes['NonBasicAccountOpenException']
  InvestmentAccountAlreadyClosed: InvestmentAccountAlreadyClosed
  InvestmentAccountClosureInProgress: InvestmentAccountClosureInProgress
  NonBasicAccountOpenException: NonBasicAccountOpenException
  CloseUserAccountResult:
    | ResolversParentTypes['OpenAccountsException']
    | ResolversParentTypes['UserNotFoundException']
    | ResolversParentTypes['User_v2']
  OpenAccountsException: OpenAccountsException
  User_v2: User_V2
  CreateProspectUserInput: CreateProspectUserInput
  CreateProspectUserResult:
    | ResolversParentTypes['GrowProspect']
    | ResolversParentTypes['InternalErrorException']
    | ResolversParentTypes['LaterWaitlistProspect']
    | ResolversParentTypes['OutsideContributionProspect']
    | ResolversParentTypes['User_v2']
  GrowProspect: GrowProspect
  Prospect:
    | ResolversParentTypes['GrowProspect']
    | ResolversParentTypes['LaterWaitlistProspect']
    | ResolversParentTypes['OutsideContributionProspect']
  LaterWaitlistProspect: LaterWaitlistProspect
  OutsideContributionProspect: OutsideContributionProspect
  CreateUploadUrlInput: CreateUploadUrlInput
  CreateUploadUrlResult: ResolversParentTypes['UploadUrl']
  UploadUrl: UploadUrl
  EnableQuarterlyRecapsInput: EnableQuarterlyRecapsInput
  EnableQuarterlyRecapsResult:
    | ResolversParentTypes['InvalidSubscriptionTierException']
    | ResolversParentTypes['InvestmentAccount']
    | ResolversParentTypes['InvestmentAccountNotFoundException']
    | ResolversParentTypes['InvestmentAccountNotSupportedException']
  LegacyUploadDocumentInput: LegacyUploadDocumentInput
  Upload: Scalars['Upload']
  LegacyUploadDocumentResult:
    | ResolversParentTypes['FileDoesNotExistInS3']
    | ResolversParentTypes['FileTooLarge']
    | ResolversParentTypes['InvalidFile']
    | ResolversParentTypes['LegacyUploadDocument']
    | ResolversParentTypes['UploadDoesNotExist']
  FileDoesNotExistInS3: FileDoesNotExistInS3
  FileTooLarge: FileTooLarge
  InvalidFile: InvalidFile
  LegacyUploadDocument: LegacyUploadDocument
  UploadDoesNotExist: UploadDoesNotExist
  LinkManualFundingSourceInput: LinkManualFundingSourceInput
  LinkManualFundingSourceResult:
    | ResolversParentTypes['CurrentBankStatementNotProvided']
    | ResolversParentTypes['FundingSourceAccount']
    | ResolversParentTypes['FundingSourceAlreadyExists']
    | ResolversParentTypes['FundingSourceCredentialsExceedLinkLimit']
    | ResolversParentTypes['InvalidAccountNumber']
    | ResolversParentTypes['InvalidManualLink']
    | ResolversParentTypes['InvalidRoutingNumber']
    | ResolversParentTypes['PreviousFundingSourcePending']
    | ResolversParentTypes['RdvVerificationRequired']
  CurrentBankStatementNotProvided: CurrentBankStatementNotProvided
  FundingSourceAlreadyExists: FundingSourceAlreadyExists
  FundingSourceCredentialsExceedLinkLimit: FundingSourceCredentialsExceedLinkLimit
  InvalidAccountNumber: InvalidAccountNumber
  InvalidManualLink: InvalidManualLink
  InvalidRoutingNumber: InvalidRoutingNumber
  PreviousFundingSourcePending: PreviousFundingSourcePending
  RdvVerificationRequired: RdvVerificationRequired
  OpenCoreInvestmentAccountInput: OpenCoreInvestmentAccountInput
  OpenCoreInvestmentAccountResult:
    | ResolversParentTypes['CoreAccountAlreadyExistsException']
    | ResolversParentTypes['InvalidPortfolioIdException']
    | ResolversParentTypes['InvestmentAccount']
    | ResolversParentTypes['InvestmentAccountCreationException']
    | ResolversParentTypes['UserClosedException']
    | ResolversParentTypes['UserNotFoundException']
  CoreAccountAlreadyExistsException: CoreAccountAlreadyExistsException
  InvalidPortfolioIdException: InvalidPortfolioIdException
  InvestmentAccountCreationException: InvestmentAccountCreationException
  UserClosedException: UserClosedException
  OpenEarlyAccountInput: OpenEarlyAccountInput
  OpenEarlyAccountResult:
    | ResolversParentTypes['BeneficiaryAccountExistsException']
    | ResolversParentTypes['CoreAccountClosedException']
    | ResolversParentTypes['InternalErrorException']
    | ResolversParentTypes['InvalidStateException']
    | ResolversParentTypes['InvalidSubscriptionTierException']
    | ResolversParentTypes['InvalidTerminationAgeException']
    | ResolversParentTypes['InvestmentAccount']
    | ResolversParentTypes['MaxAccountsCreatedException']
    | ResolversParentTypes['MissingBeneficiarySsnException']
    | ResolversParentTypes['NoBeneficiaryFoundException']
    | ResolversParentTypes['UserClosedException']
    | ResolversParentTypes['UserNotFoundException']
    | ResolversParentTypes['UserNotVerifiedException']
  BeneficiaryAccountExistsException: BeneficiaryAccountExistsException
  CoreAccountClosedException: CoreAccountClosedException
  InvalidTerminationAgeException: InvalidTerminationAgeException
  MaxAccountsCreatedException: MaxAccountsCreatedException
  MissingBeneficiarySsnException: MissingBeneficiarySsnException
  NoBeneficiaryFoundException: NoBeneficiaryFoundException
  UserNotVerifiedException: UserNotVerifiedException
  PartnerLinkFundingSourceInput: PartnerLinkFundingSourceInput
  PartnerLinkFundingSourceResult:
    | ResolversParentTypes['CurrentBankStatementNotProvided']
    | ResolversParentTypes['FundingSourceAccount']
    | ResolversParentTypes['FundingSourceAlreadyExists']
    | ResolversParentTypes['FundingSourceCredentialsExceedLinkLimit']
    | ResolversParentTypes['InvalidAccountNumber']
    | ResolversParentTypes['InvalidAccountToken']
    | ResolversParentTypes['InvalidManualLink']
    | ResolversParentTypes['InvalidRoutingNumber']
    | ResolversParentTypes['PreviousFundingSourcePending']
    | ResolversParentTypes['RdvVerificationRequired']
  InvalidAccountToken: InvalidAccountToken
  RecordInvestmentAccountRecapViewInput: RecordInvestmentAccountRecapViewInput
  RecordInvestmentAccountRecapViewResult:
    | ResolversParentTypes['InvestmentAccountRecap']
    | ResolversParentTypes['InvestmentAccountRecapNotFoundException']
  InvestmentAccountRecapNotFoundException: InvestmentAccountRecapNotFoundException
  RegenerateInvestmentAccountRecapPublicTokenInput: RegenerateInvestmentAccountRecapPublicTokenInput
  RegenerateInvestmentAccountRecapPublicTokenResult:
    | ResolversParentTypes['InvestmentAccountRecap']
    | ResolversParentTypes['InvestmentAccountRecapNotFoundException']
  RemoveSecurityFromPortfolioInput: RemoveSecurityFromPortfolioInput
  RemoveSecurityFromPortfolioResult:
    | ResolversParentTypes['InvestmentAccountNotFoundException']
    | ResolversParentTypes['InvestmentAccountNotSupportedException']
    | ResolversParentTypes['Portfolio']
    | ResolversParentTypes['PortfolioNotFoundException']
    | ResolversParentTypes['PortfolioNotSupportedException']
    | ResolversParentTypes['SecurityNotSupportedException']
  RemoveSelfDirectedPortfolioInput: RemoveSelfDirectedPortfolioInput
  RemoveSelfDirectedPortfolioResult:
    | ResolversParentTypes['AccountNotFoundException']
    | ResolversParentTypes['InvestmentAccount']
    | ResolversParentTypes['InvestmentAccountAlreadyClosed']
    | ResolversParentTypes['InvestmentAccountClosureInProgress']
    | ResolversParentTypes['PortfolioAlreadyRemovedError']
    | ResolversParentTypes['PortfolioNotFoundException']
    | ResolversParentTypes['PortfolioRemovalInProgressError']
  PortfolioAlreadyRemovedError: PortfolioAlreadyRemovedError
  PortfolioRemovalInProgressError: PortfolioRemovalInProgressError
  ReopenUserAccountResult:
    | ResolversParentTypes['UserNotFoundException']
    | ResolversParentTypes['UserReopenLockedException']
    | ResolversParentTypes['UserReopenSuspendedException']
    | ResolversParentTypes['User_v2']
  UserReopenLockedException: UserReopenLockedException
  UserReopenSuspendedException: UserReopenSuspendedException
  RequestEarlyAccountClosureInput: RequestEarlyAccountClosureInput
  RequestEarlyAccountClosureResult:
    | ResolversParentTypes['AccountAlreadyClosedException']
    | ResolversParentTypes['ClosureRequestExistsException']
    | ResolversParentTypes['FundingSourceRequiresRdvException']
    | ResolversParentTypes['InternalErrorException']
    | ResolversParentTypes['InvalidAccountTypeException']
    | ResolversParentTypes['InvestmentAccount']
    | ResolversParentTypes['InvestmentAccountNeedsTransferException']
    | ResolversParentTypes['MissingFundingSourceException']
  AccountAlreadyClosedException: AccountAlreadyClosedException
  ClosureRequestExistsException: ClosureRequestExistsException
  FundingSourceRequiresRdvException: FundingSourceRequiresRdvException
  InvalidAccountTypeException: InvalidAccountTypeException
  InvestmentAccountNeedsTransferException: InvestmentAccountNeedsTransferException
  MissingFundingSourceException: MissingFundingSourceException
  RequestInvestmentAccountReopenInput: RequestInvestmentAccountReopenInput
  RequestInvestmentAccountReopenResult:
    | ResolversParentTypes['ExistingRequestPendingReview']
    | ResolversParentTypes['ExistingRequestPendingUserAction']
    | ResolversParentTypes['InvalidSubscriptionTierException']
    | ResolversParentTypes['InvestmentAccountNotClosedException']
    | ResolversParentTypes['InvestmentAccountNotFoundException']
    | ResolversParentTypes['InvestmentAccountReopenRequest']
  ExistingRequestPendingReview: ExistingRequestPendingReview
  InvestmentAccountReopenRequest: InvestmentAccountReopenRequest
  InvestmentAccountReopenRequestAction: InvestmentAccountReopenRequestAction
  InvestmentAccountReopenRequestNote: InvestmentAccountReopenRequestNote
  UserInvestmentAccountReopenCheck: UserInvestmentAccountReopenCheck
  ExistingRequestPendingUserAction: ExistingRequestPendingUserAction
  InvestmentAccountNotClosedException: InvestmentAccountNotClosedException
  SaveUploadUrlInput: SaveUploadUrlInput
  SetInvestmentAccountRecapPublicAccessInput: SetInvestmentAccountRecapPublicAccessInput
  SetInvestmentAccountRecapPublicAccessResult:
    | ResolversParentTypes['InvestmentAccountRecap']
    | ResolversParentTypes['InvestmentAccountRecapNotFoundException']
  UnauthenticatedCreateUploadUrlInput: UnauthenticatedCreateUploadUrlInput
  UnauthenticatedSaveUploadUrlInput: UnauthenticatedSaveUploadUrlInput
  UnauthenticatedSaveUploadUrlResult:
    | ResolversParentTypes['DocumentUploads']
    | ResolversParentTypes['UploadSaveError']
  DocumentUploads: DocumentUploads
  UploadSaveError: Omit<UploadSaveError, 'uploadExceptions'> & {
    uploadExceptions: Array<ResolversParentTypes['UploadSaveExceptions']>
  }
  UploadSaveExceptions:
    | ResolversParentTypes['FileDoesNotExistError']
    | ResolversParentTypes['UploadDoesNotExistError']
  FileDoesNotExistError: FileDoesNotExistError
  UploadDoesNotExistError: UploadDoesNotExistError
  UpdateAccountPortfolioInput: UpdateAccountPortfolioInput
  UpdateAccountPortfolioResponse:
    | ResolversParentTypes['InvalidActionOnAccount']
    | ResolversParentTypes['InvestmentAccount']
    | ResolversParentTypes['InvestmentAccountNotFoundException']
    | ResolversParentTypes['PortfolioNotFoundException']
    | ResolversParentTypes['PortfolioUpdateFailedException']
  InvalidActionOnAccount: InvalidActionOnAccount
  PortfolioUpdateFailedException: PortfolioUpdateFailedException
  UpdatePortfolioSecuritiesInput: UpdatePortfolioSecuritiesInput
  SecurityAllocationTarget: SecurityAllocationTarget
  UpdatePortfolioSecuritiesResult:
    | ResolversParentTypes['CustomerAgreementRequiredException']
    | ResolversParentTypes['InvalidAllocationPercentError']
    | ResolversParentTypes['InvalidSecurityError']
    | ResolversParentTypes['InvalidSecurityForAllocationError']
    | ResolversParentTypes['InvestmentAccount']
    | ResolversParentTypes['LiquidationUnavailableError']
    | ResolversParentTypes['NegativeSecurityPercentError']
    | ResolversParentTypes['PortfolioSecurityLimitReached']
  InvalidAllocationPercentError: InvalidAllocationPercentError
  InvalidSecurityError: InvalidSecurityError
  InvalidSecurityForAllocationError: InvalidSecurityForAllocationError
  LiquidationUnavailableError: LiquidationUnavailableError
  NegativeSecurityPercentError: NegativeSecurityPercentError
  PortfolioSecurityLimitReached: PortfolioSecurityLimitReached
  RegistrationInput: RegistrationInput
  ValidateUserSuspendedUploadTokenInput: ValidateUserSuspendedUploadTokenInput
  ValidateUserSuspendedUploadTokenResult:
    | ResolversParentTypes['UserSuspendedUploadTokenLengthError']
    | ResolversParentTypes['UserSuspendedUploadTokenValidation']
  UserSuspendedUploadTokenLengthError: UserSuspendedUploadTokenLengthError
  UserSuspendedUploadTokenValidation: UserSuspendedUploadTokenValidation
  LaterProgramAccountContributionInput: LaterProgramAccountContributionInput
  LaterProgramAccountContributionResult:
    | ResolversParentTypes['LaterContributionLimitMet']
    | ResolversParentTypes['LaterFullContributionSuccess']
    | ResolversParentTypes['LaterPartialContributionSuccess']
  LaterContributionLimitMet: LaterContributionLimitMet
  LaterFullContributionSuccess: LaterFullContributionSuccess
  LaterPartialContributionSuccess: LaterPartialContributionSuccess
  TaxWithholdingAmounts: TaxWithholdingAmounts
  LaterAccountInfoOrError:
    | ResolversParentTypes['LaterAccountAlreadyVerified']
    | ResolversParentTypes['LaterAccountIneligibleForVerification']
    | ResolversParentTypes['LaterAccountInfo']
    | ResolversParentTypes['LaterAccountNotFound']
  LaterAccountAlreadyVerified: LaterAccountAlreadyVerified
  LaterTypedException:
    | ResolversParentTypes['LaterAccountAlreadyVerified']
    | ResolversParentTypes['LaterAccountIneligibleForVerification']
    | ResolversParentTypes['LaterAccountNotFound']
    | ResolversParentTypes['InvalidLaterInput']
  LaterAccountIneligibleForVerification: LaterAccountIneligibleForVerification
  LaterAccountInfo: LaterAccountInfo
  LaterAccountNotFound: LaterAccountNotFound
  ScheduleRecurringTransferInput: ScheduleRecurringTransferInput
  RecurringTransferEventInput: RecurringTransferEventInput
  RecurringTransferAccountInput: RecurringTransferAccountInput
  RecurringTransferFundingSourceInput: RecurringTransferFundingSourceInput
  ScheduleRecurringTransferResult:
    | ResolversParentTypes['RecurringTransfer']
    | ResolversParentTypes['MalformedRecurringTransferException']
  CancelRecurringTransferResult:
    | ResolversParentTypes['RecurringTransfer']
    | ResolversParentTypes['VersionMismatchException']
  VersionMismatchException: VersionMismatchException
  LifeQuoteApplyInput: LifeQuoteApplyInput
  LifeQuoteResponse: LifeQuoteResponse
  LifeQuoteInput: LifeQuoteInput
  QuoteUserMetadata: QuoteUserMetadata
  CoverageResponse: CoverageResponse
  UpdateCoverageResponse: UpdateCoverageResponse
  LifeCalculatorInput: LifeCalculatorInput
  LifeCalculatorUserResponse: LifeCalculatorUserResponse
  UpdateRecommendedCoverageResponse: UpdateRecommendedCoverageResponse
  QuestionResponse: QuestionResponse
  ActionFeedEvent: ActionFeedEvent
  ActionFeedEventResponse: ActionFeedEventResponse
  FavoritePartnerOfferInput: FavoritePartnerOfferInput
  JobAlertCriteriaInput: JobAlertCriteriaInput
  CreateJobAlertResult: ResolversParentTypes['JobAlert']
  RemoveJobAlertResult: ResolversParentTypes['RemovedJobAlert']
  RemovedJobAlert: RemovedJobAlert
  AddMilestonesToMilestoneGroupDefinitionInput: AddMilestonesToMilestoneGroupDefinitionInput
  AddMilestoneToMilestoneGroupDefinitionResult:
    | ResolversParentTypes['MilestoneGroupDefinition']
    | ResolversParentTypes['RecordDoesNotExistError']
  RecordDoesNotExistError: RecordDoesNotExistError
  CreateMilestoneGroupDefinitionInput: CreateMilestoneGroupDefinitionInput
  CreateMilestoneGroupDefinitionResult:
    | ResolversParentTypes['MilestoneGroupDefinition']
    | ResolversParentTypes['RecordAlreadyExistsError']
    | ResolversParentTypes['RecordDoesNotExistError']
  RecordAlreadyExistsError: RecordAlreadyExistsError
  RemoveMilestonesFromMilestoneGroupDefinitionInput: RemoveMilestonesFromMilestoneGroupDefinitionInput
  RemoveMilestoneFromMilestoneGroupDefinitionResult:
    | ResolversParentTypes['MilestoneGroupDefinition']
    | ResolversParentTypes['RecordDoesNotExistError']
  AddActionToMilestoneGroupAchievementActionRuleInput: AddActionToMilestoneGroupAchievementActionRuleInput
  AddActionToMilestoneGroupAchievementActionRuleResult:
    | ResolversParentTypes['MilestoneGroupAchievementActionRule']
    | ResolversParentTypes['RecordDoesNotExistError']
  CreateMilestoneGroupAchievementActionRuleInput: CreateMilestoneGroupAchievementActionRuleInput
  CreateMilestoneGroupAchievementActionRuleResult:
    | ResolversParentTypes['MilestoneGroupAchievementActionRule']
    | ResolversParentTypes['RecordAlreadyExistsError']
    | ResolversParentTypes['RecordDoesNotExistError']
  RemoveActionFromMilestoneGroupAchievementActionRuleInput: RemoveActionFromMilestoneGroupAchievementActionRuleInput
  RemoveActionFromMilestoneGroupAchievementActionRuleResult:
    | ResolversParentTypes['MilestoneGroupAchievementActionRule']
    | ResolversParentTypes['RecordDoesNotExistError']
  AddMilestonesToMilestoneHubDefinitionInput: AddMilestonesToMilestoneHubDefinitionInput
  AddMilestonesToMilestoneHubDefinitionResult:
    | ResolversParentTypes['RecordDoesNotExistError']
    | ResolversParentTypes['MilestoneHubDefinition']
  CreateMilestoneHubDefinitionInput: CreateMilestoneHubDefinitionInput
  CreateMilestoneHubDefinitionResult:
    | ResolversParentTypes['RecordAlreadyExistsError']
    | ResolversParentTypes['RecordDoesNotExistError']
    | ResolversParentTypes['MilestoneHubDefinition']
  RemoveMilestonesFromMilestoneHubDefinitionInput: RemoveMilestonesFromMilestoneHubDefinitionInput
  RemoveMilestonesFromMilestoneHubDefinitionResult:
    | ResolversParentTypes['RecordDoesNotExistError']
    | ResolversParentTypes['MilestoneHubDefinition']
  DismissMessageInput: DismissMessageInput
  UpdateMessageResult:
    | ResolversParentTypes['AlertMessage']
    | ResolversParentTypes['NotificationMessage']
    | ResolversParentTypes['UpdateMessageIgnored']
  AlertMessage: Omit<AlertMessage, 'body' | 'icon' | 'title'> & {
    body: ResolversParentTypes['MessageTextAsset']
    icon?: Maybe<ResolversParentTypes['MessageVisualAsset']>
    title: ResolversParentTypes['MessageTextAsset']
  }
  NotificationMessage: Omit<NotificationMessage, 'body' | 'icon' | 'title'> & {
    body: ResolversParentTypes['MessageTextAsset']
    icon?: Maybe<ResolversParentTypes['MessageVisualAsset']>
    title: ResolversParentTypes['MessageTextAsset']
  }
  UpdateMessageIgnored: UpdateMessageIgnored
  HideMessageByExternalIdInput: HideMessageByExternalIdInput
  MarkAllAsReadResult:
    | ResolversParentTypes['MarkAllAsReadSuccess']
    | ResolversParentTypes['UpdateMessageFailed']
  MarkAllAsReadSuccess: MarkAllAsReadSuccess
  UpdateMessageFailed: UpdateMessageFailed
  ReadMessageInput: ReadMessageInput
  MarkLearnContentAsHelpfulInput: MarkLearnContentAsHelpfulInput
  MarkLearnContentAsHelpfulResult:
    | ResolversParentTypes['UpdateLearnContentHelpfulnessResult']
    | ResolversParentTypes['RecordDoesNotExistError']
  UpdateLearnContentHelpfulnessResult: UpdateLearnContentHelpfulnessResult
  UnmarkLearnContentAsHelpfulInput: UnmarkLearnContentAsHelpfulInput
  UnmarkLearnContentAsHelpfulResult:
    | ResolversParentTypes['UpdateLearnContentHelpfulnessResult']
    | ResolversParentTypes['RecordDoesNotExistError']
  MarkLearnContentAsViewedInput: MarkLearnContentAsViewedInput
  MarkLearnContentAsViewedResult:
    | ResolversParentTypes['ViewedLearnContentResult']
    | ResolversParentTypes['RecordDoesNotExistError']
  ViewedLearnContentResult: ViewedLearnContentResult
  UpdateLearnProgressInput: UpdateLearnProgressInput
  LearnProgressInput: LearnProgressInput
  UpdateLearnProgressResult:
    | ResolversParentTypes['LearnProgressUpdatedResult']
    | ResolversParentTypes['RecordDoesNotExistError']
  LearnProgressUpdatedResult: LearnProgressUpdatedResult
  AnswerLearnQuizQuestionInput: AnswerLearnQuizQuestionInput
  LearnAnswerInput: LearnAnswerInput
  AnswerLearnQuizQuestionResult:
    | ResolversParentTypes['LearnQuizAnswerResult']
    | ResolversParentTypes['RecordDoesNotExistError']
  LearnQuizAnswerResult: LearnQuizAnswerResult
  UpdateElapsedTimeForLearnQuizInput: UpdateElapsedTimeForLearnQuizInput
  UpdateElapsedTimeForLearnQuizResult:
    | ResolversParentTypes['LearnContentElapsedMillisecondsUpdatedResult']
    | ResolversParentTypes['RecordDoesNotExistError']
  LearnContentElapsedMillisecondsUpdatedResult: LearnContentElapsedMillisecondsUpdatedResult
  RespondToLearnPollInput: RespondToLearnPollInput
  RespondToLearnPollResult:
    | ResolversParentTypes['LearnPollResponse']
    | ResolversParentTypes['InvalidOptionException']
    | ResolversParentTypes['RecordDoesNotExistError']
  LearnPollResponse: LearnPollResponse
  InvalidOptionException: InvalidOptionException
  AddSearchTermToLearnSearchHistoryInput: AddSearchTermToLearnSearchHistoryInput
  AddSearchTermToLearnSearchHistoryResult: ResolversParentTypes['LearnSearchTermSavedResult']
  LearnSearchTermSavedResult: LearnSearchTermSavedResult
  UploadDocumentsInput: UploadDocumentsInput
  FileOrException:
    | ResolversParentTypes['File']
    | ResolversParentTypes['FileSizeError']
    | ResolversParentTypes['UploadFailedError']
  File: File
  FileSizeError: FileSizeError
  UploadFailedError: UploadFailedError
  UploadUnsolicitedDocumentsInput: UploadUnsolicitedDocumentsInput
  CreateDocumentUploadInput: CreateDocumentUploadInput
  CreateDocumentUpload: CreateDocumentUpload
  InitiateSMSChallengeInput: InitiateSmsChallengeInput
  PhoneNumber: Scalars['PhoneNumber']
  InitiateSMSChallengeResult:
    | ResolversParentTypes['SMSAuthChallenge']
    | ResolversParentTypes['InvalidPhoneNumberException']
  SMSAuthChallenge: SmsAuthChallenge
  AuthChallenge:
    | ResolversParentTypes['SMSAuthChallenge']
    | ResolversParentTypes['EmailAuthChallenge']
  AuthenticatorInfo: AuthenticatorInfo
  InvalidPhoneNumberException: InvalidPhoneNumberException
  InitiateEmailChallengeInput: InitiateEmailChallengeInput
  InitiateEmailChallengeResult:
    | ResolversParentTypes['EmailAuthChallenge']
    | ResolversParentTypes['ExistingEmailVerifiedException']
  EmailAuthChallenge: EmailAuthChallenge
  ExistingEmailVerifiedException: ExistingEmailVerifiedException
  ReinitiateSMSChallengeInput: ReinitiateSmsChallengeInput
  ReinitiateSMSChallengeResult:
    | ResolversParentTypes['SMSAuthChallenge']
    | ResolversParentTypes['EmailAuthChallenge']
    | ResolversParentTypes['AuthChallengeExpiredException']
  AuthChallengeExpiredException: AuthChallengeExpiredException
  RegisterPhoneAuthenticatorInput: RegisterPhoneAuthenticatorInput
  ChallengeAnswerInput: ChallengeAnswerInput
  RegisterPhoneAuthenticatorResult:
    | ResolversParentTypes['PhoneAuthenticator']
    | ResolversParentTypes['AuthChallengeAnswerIncorrectException']
    | ResolversParentTypes['AuthChallengeAnswerAttemptsExhaustedException']
    | ResolversParentTypes['AuthChallengeExpiredException']
    | ResolversParentTypes['InvalidPhoneNumberException']
    | ResolversParentTypes['AuthenticatorTypeAlreadyRegisteredException']
  PhoneAuthenticator: PhoneAuthenticator
  AuthChallengeAnswerIncorrectException: AuthChallengeAnswerIncorrectException
  AuthChallengeAnswerAttemptsExhaustedException: AuthChallengeAnswerAttemptsExhaustedException
  AuthenticatorTypeAlreadyRegisteredException: AuthenticatorTypeAlreadyRegisteredException
  RegisterEmailAuthenticatorInput: RegisterEmailAuthenticatorInput
  RegisterEmailAuthenticatorResult:
    | ResolversParentTypes['EmailAuthenticator']
    | ResolversParentTypes['AuthChallengeAnswerIncorrectException']
    | ResolversParentTypes['AuthChallengeAnswerAttemptsExhaustedException']
    | ResolversParentTypes['AuthChallengeExpiredException']
    | ResolversParentTypes['AuthenticatorTypeAlreadyRegisteredException']
    | ResolversParentTypes['ExistingEmailVerifiedException']
  EmailAuthenticator: EmailAuthenticator
  AuthenticateInput: AuthenticateInput
  AuthenticateResult:
    | ResolversParentTypes['SMSAuthChallenge']
    | ResolversParentTypes['EmailAuthChallenge']
    | ResolversParentTypes['AuthSession']
    | ResolversParentTypes['AuthenticatorUnavailableException']
    | ResolversParentTypes['InvalidCredentialsException']
    | ResolversParentTypes['UserSuspendedException']
    | ResolversParentTypes['DeviceBlockedException']
    | ResolversParentTypes['UserLockedException']
    | ResolversParentTypes['LoginRateLimitedException']
    | ResolversParentTypes['PhoneNumberOptedOutException']
    | ResolversParentTypes['AuthChallengeAnswerIncorrectException']
    | ResolversParentTypes['AuthChallengeAnswerAttemptsExhaustedException']
    | ResolversParentTypes['AuthChallengeExpiredException']
    | ResolversParentTypes['AuthenticatorTypeAlreadyRegisteredException']
  AuthSession: AuthSession
  AuthenticatorUnavailableException: AuthenticatorUnavailableException
  InvalidCredentialsException: InvalidCredentialsException
  UserSuspendedException: UserSuspendedException
  DeviceBlockedException: DeviceBlockedException
  UserLockedException: UserLockedException
  LoginRateLimitedException: LoginRateLimitedException
  PhoneNumberOptedOutException: PhoneNumberOptedOutException
  SetDefaultAuthenticatorInput: SetDefaultAuthenticatorInput
  SetDefaultAuthenticatorResult:
    | ResolversParentTypes['PhoneAuthenticator']
    | ResolversParentTypes['EmailAuthenticator']
    | ResolversParentTypes['AuthenticatorNotFoundException']
    | ResolversParentTypes['AuthenticatorAlreadyDefaultException']
  AuthenticatorNotFoundException: AuthenticatorNotFoundException
  AuthenticatorAlreadyDefaultException: AuthenticatorAlreadyDefaultException
  RefreshAuthTokenInput: RefreshAuthTokenInput
  RefreshAuthTokenResult:
    | ResolversParentTypes['AuthSession']
    | ResolversParentTypes['TokenExpiredException']
    | ResolversParentTypes['InvalidPinException']
    | ResolversParentTypes['RefreshAuthTokenRateLimitedException']
    | ResolversParentTypes['UserSuspendedException']
  TokenExpiredException: TokenExpiredException
  InvalidPinException: InvalidPinException
  RefreshAuthTokenRateLimitedException: RefreshAuthTokenRateLimitedException
  RegisterCredentialsInput: RegisterCredentialsInput
  RegisterCredentialsResult:
    | ResolversParentTypes['AuthSession']
    | ResolversParentTypes['EmailTakenException']
    | ResolversParentTypes['InvalidPasswordException']
    | ResolversParentTypes['MissingRequiredAgreementsException']
  EmailTakenException: EmailTakenException
  InvalidPasswordException: InvalidPasswordException
  MissingRequiredAgreementsException: MissingRequiredAgreementsException
  CreateUserInput: CreateUserInput
  PasswordResetRequestInput: PasswordResetRequestInput
  VerifyDeviceInput: VerifyDeviceInput
  VerifyDeviceResult:
    | ResolversParentTypes['SMSAuthChallenge']
    | ResolversParentTypes['EmailAuthChallenge']
    | ResolversParentTypes['DeviceNotFoundException']
  DeviceNotFoundException: DeviceNotFoundException
  BlockDeviceInput: BlockDeviceInput
  BlockDeviceResult:
    | ResolversParentTypes['Device']
    | ResolversParentTypes['DeviceNotFoundException']
  Device: Device
  UnblockDeviceInput: UnblockDeviceInput
  UnblockDeviceResult:
    | ResolversParentTypes['Device']
    | ResolversParentTypes['DeviceNotFoundException']
  SetAuthenticationPINInput: SetAuthenticationPinInput
  SetAuthenticationPINResult:
    | ResolversParentTypes['SetAuthenticationPINSuccess']
    | ResolversParentTypes['InvalidPinException']
    | ResolversParentTypes['UserCredentialsNotFoundException']
  SetAuthenticationPINSuccess: SetAuthenticationPinSuccess
  UserCredentialsNotFoundException: UserCredentialsNotFoundException
  VerifyPasswordsInput: VerifyPasswordsInput
  VerifyPasswordsResult:
    | ResolversParentTypes['VerifyPasswordsSuccess']
    | ResolversParentTypes['IncorrectOldPasswordException']
    | ResolversParentTypes['SamePasswordsException']
    | ResolversParentTypes['InvalidPasswordException']
    | ResolversParentTypes['UnauthorizedException']
  VerifyPasswordsSuccess: VerifyPasswordsSuccess
  IncorrectOldPasswordException: IncorrectOldPasswordException
  SamePasswordsException: SamePasswordsException
  UnauthorizedException: UnauthorizedException
  UserCredentialsInput: UserCredentialsInput
  UpdateCredentialsResult:
    | ResolversParentTypes['Credentials']
    | ResolversParentTypes['EmailTakenException']
    | ResolversParentTypes['BlockedEmailDomainException']
    | ResolversParentTypes['UserCredentialsNotFoundException']
  Credentials: Credentials
  BlockedEmailDomainException: BlockedEmailDomainException
  UpdateSecurityQuestionAndAnswerInput: UpdateSecurityQuestionAndAnswerInput
  UpdateSecurityQuestionAndAnswerResult:
    | ResolversParentTypes['UpdateSecurityQuestionAndAnswerSuccess']
    | ResolversParentTypes['InvalidSecurityQuestionException']
  UpdateSecurityQuestionAndAnswerSuccess: UpdateSecurityQuestionAndAnswerSuccess
  InvalidSecurityQuestionException: InvalidSecurityQuestionException
  ResetPasswordByTokenInput: ResetPasswordByTokenInput
  ResetPasswordByTokenResult:
    | ResolversParentTypes['ResetPasswordByTokenSuccess']
    | ResolversParentTypes['ResetPasswordByTokenException']
    | ResolversParentTypes['InvalidPasswordException']
    | ResolversParentTypes['UserCredentialsNotFoundException']
    | ResolversParentTypes['IncorrectSecurityAnswerException']
    | ResolversParentTypes['IncorrectSsnException']
  ResetPasswordByTokenSuccess: ResetPasswordByTokenSuccess
  ResetPasswordByTokenException: ResetPasswordByTokenException
  IncorrectSecurityAnswerException: IncorrectSecurityAnswerException
  IncorrectSsnException: IncorrectSsnException
  ResetPasswordWithTokenInput: ResetPasswordWithTokenInput
  ResetPasswordWithTokenResult:
    | ResolversParentTypes['ResetPasswordWithTokenSuccess']
    | ResolversParentTypes['InvalidPasswordResetTokenException']
    | ResolversParentTypes['UserCredentialsNotFoundException']
    | ResolversParentTypes['InvalidPasswordResetException']
  ResetPasswordWithTokenSuccess: ResetPasswordWithTokenSuccess
  InvalidPasswordResetException: InvalidPasswordResetException
  SecurityAnswer: SecurityAnswer
  ChangePasswordInput: ChangePasswordInput
  ChangePasswordResult:
    | ResolversParentTypes['ChangePasswordSuccess']
    | ResolversParentTypes['IncorrectOldPasswordException']
    | ResolversParentTypes['InvalidPasswordException']
    | ResolversParentTypes['IncorrectSecurityAnswerException']
  ChangePasswordSuccess: ChangePasswordSuccess
  UpgradeAuthenticationResult:
    | ResolversParentTypes['AuthSession']
    | ResolversParentTypes['AuthenticationAlreadyUpgradedException']
    | ResolversParentTypes['UserCredentialsNotFoundException']
  AuthenticationAlreadyUpgradedException: AuthenticationAlreadyUpgradedException
  LogoutResult:
    | ResolversParentTypes['LogoutSuccess']
    | ResolversParentTypes['RefreshTokenNotFoundException']
    | ResolversParentTypes['AuthTokenNotFoundException']
  LogoutSuccess: LogoutSuccess
  RefreshTokenNotFoundException: RefreshTokenNotFoundException
  AuthTokenNotFoundException: AuthTokenNotFoundException
  ApplyPromotionInput: ApplyPromotionInput
  ApplyPromotionResult:
    | ResolversParentTypes['PromotionConsumedError']
    | ResolversParentTypes['PromotionExpiredError']
    | ResolversParentTypes['PromotionNotFoundError']
    | ResolversParentTypes['SubscriberIneligibleError']
    | ResolversParentTypes['TierSubscription']
  PromotionConsumedError: PromotionConsumedError
  PromotionExpiredError: PromotionExpiredError
  PromotionNotFoundError: PromotionNotFoundError
  SubscriberIneligibleError: SubscriberIneligibleError
  DeactivateTierSubscriptionInput: DeactivateTierSubscriptionInput
  DeactivateTierSubscriptionResult:
    | ResolversParentTypes['TierSubscription']
    | ResolversParentTypes['TierSubscriptionAlreadyDeactivated']
  TierSubscriptionAlreadyDeactivated: TierSubscriptionAlreadyDeactivated
  RequestSubscriptionMigrationWaiverInput: RequestSubscriptionMigrationWaiverInput
  RequestSubscriptionMigrationWaiverResult:
    | ResolversParentTypes['InvalidTierForMigrationError']
    | ResolversParentTypes['SubscriptionMigrationInvalidError']
    | ResolversParentTypes['SubscriptionMigrationWaiver']
  InvalidTierForMigrationError: InvalidTierForMigrationError
  SubscriptionMigrationInvalidError: SubscriptionMigrationInvalidError
  SubscribeToTierInput: SubscribeToTierInput
  SubscribeToTierResult:
    | ResolversParentTypes['InvalidTier']
    | ResolversParentTypes['InvalidTierPrice']
    | ResolversParentTypes['TierSubscription']
  InvalidTier: InvalidTier
  InvalidTierPrice: InvalidTierPrice
  SubscribeUserToTierInput: SubscribeUserToTierInput
  SubscribeUserToTierResult:
    | ResolversParentTypes['InvalidTierPriceId']
    | ResolversParentTypes['TierDowngradeActionRequired']
    | ResolversParentTypes['TierSubscription']
  TierDowngradeActionRequired: TierDowngradeActionRequired
  TierDowngradeAction: TierDowngradeAction
  SubscribeUserToTierByProductKeyInput: SubscribeUserToTierByProductKeyInput
  UnsubscribeUserFromTierInput: UnsubscribeUserFromTierInput
  UnsubscribeUserFromTierResult:
    | ResolversParentTypes['TierDowngradeActionRequired']
    | ResolversParentTypes['TierSubscriptionUnsubscribed']
  SplitDepositSettingsMutation: SplitDepositSettingsMutation
  ConfigureSettingsInput: ConfigureSettingsInput
  SplitDepositMutation: SplitDepositMutation
  ConfigureSplitDepositDirectDepositIntentSettingInput: ConfigureSplitDepositDirectDepositIntentSettingInput
  SplitDepositAllocationInput: SplitDepositAllocationInput
  ConfigureSplitDepositDirectDepositIntentSettingResult:
    | ResolversParentTypes['ConfigureSplitDepositDirectDepositIntentPayload']
    | ResolversParentTypes['ConfigureSplitDepositDirectDepositIntentGenericError']
  ConfigureSplitDepositDirectDepositIntentPayload: ConfigureSplitDepositDirectDepositIntentPayload
  SplitDepositDirectDepositIntentSetting: SplitDepositDirectDepositIntentSetting
  SplitDepositDirectDepositAllocation: SplitDepositDirectDepositAllocation
  FormattedMonetaryAmount: FormattedMonetaryAmount
  ConfigureSplitDepositDirectDepositIntentGenericError: ConfigureSplitDepositDirectDepositIntentGenericError
  ConfigureSplitDepositDirectDepositSettingInput: ConfigureSplitDepositDirectDepositSettingInput
  ConfigureSplitDepositDirectDepositSettingResult:
    | ResolversParentTypes['ConfigureSplitDepositDirectDepositSettingPayload']
    | ResolversParentTypes['ConfigureSplitDepositDirectDepositSettingGenericError']
  ConfigureSplitDepositDirectDepositSettingPayload: ConfigureSplitDepositDirectDepositSettingPayload
  SplitDepositDirectDepositSetting: SplitDepositDirectDepositSetting
  MonthlyTotal: MonthlyTotal
  TotalAmounts: TotalAmounts
  ConfigureSplitDepositDirectDepositSettingGenericError: ConfigureSplitDepositDirectDepositSettingGenericError
  ChangeOutsideContributionAmountInput: ChangeOutsideContributionAmountInput
  ChangeOutsideContributionAmountResult:
    | ResolversParentTypes['ContributionAmountAboveThresholdError']
    | ResolversParentTypes['ContributionAmountBelowThresholdError']
    | ResolversParentTypes['OutsideContributionCheckoutCart']
  ContributionAmountAboveThresholdError: ContributionAmountAboveThresholdError
  ContributionAmountBelowThresholdError: ContributionAmountBelowThresholdError
  OutsideContributionCheckoutCart: OutsideContributionCheckoutCart
  CreateOutsideContributionInput: CreateOutsideContributionInput
  CreateOutsideContributionResult:
    | ResolversParentTypes['ContributionActionRequiredError']
    | ResolversParentTypes['ContributionCardDeclinedError']
    | ResolversParentTypes['ContributionInvalidOwnerEmailError']
    | ResolversParentTypes['OutsideContribution']
  ContributionActionRequiredError: ContributionActionRequiredError
  ContributionCardDeclinedError: ContributionCardDeclinedError
  ContributionInvalidOwnerEmailError: ContributionInvalidOwnerEmailError
  OutsideContribution: OutsideContribution
  CreateOutsideContributionCheckoutCartInput: CreateOutsideContributionCheckoutCartInput
  CreateOutsideContributionCheckoutCartResult:
    | ResolversParentTypes['ContributionAmountAboveThresholdError']
    | ResolversParentTypes['ContributionAmountBelowThresholdError']
    | ResolversParentTypes['OutsideContributionCheckoutCart']
  AuthenticateForFeeNegotiationInput: AuthenticateForFeeNegotiationInput
  AuthenticateForFeeNegotiationResult:
    | ResolversParentTypes['AuthenticateForFeeNegotiationStatus']
    | ResolversParentTypes['LinkedAccountNotFound']
    | ResolversParentTypes['NegotiationServiceConnectionFailure']
  LinkedAccountNotFound: LinkedAccountNotFound
  NegotiationServiceConnectionFailure: NegotiationServiceConnectionFailure
  AuthenticateForFeeNegotiationChallengeMethodInput: AuthenticateForFeeNegotiationChallengeMethodInput
  AuthenticateNegotiationStatusResult:
    | ResolversParentTypes['AuthenticateForFeeNegotiationStatus']
    | ResolversParentTypes['LinkedAccountNotFound']
  AuthenticateForFeeNegotiationChallengeInput: AuthenticateForFeeNegotiationChallengeInput
  SubmitBankFeeNegotiationInput: SubmitBankFeeNegotiationInput
  SubmitBankFeeNegotiationResult:
    | ResolversParentTypes['SubmitBankFeeNegotiationResponse']
    | ResolversParentTypes['LinkedAccountNotFound']
  SubmitBankFeeNegotiationResponse: SubmitBankFeeNegotiationResponse
  SyncBankFeeTransactionsInput: SyncBankFeeTransactionsInput
  SyncBankFeeTransactionsResult: SyncBankFeeTransactionsResult
  SubmitForBillNegotiationInput: SubmitForBillNegotiationInput
  Amount: Scalars['Amount']
  BillNegotiationSubmitResult: BillNegotiationSubmitResult
  SubmitUserReportedBankFeeRefundInput: SubmitUserReportedBankFeeRefundInput
  SubmitUserReportedBankFeeRefundResult: SubmitUserReportedBankFeeRefundResult
  SetNegotiationStatusInput: SetNegotiationStatusInput
  SetNegotiationStatusResult: SetNegotiationStatusResult
  PartnerStatusInput: PartnerStatusInput
  UserPartnerStatusResponse: UserPartnerStatusResponse
  RegisterProspectInput: RegisterProspectInput
  SourceAttributesInput: SourceAttributesInput
  RegisterProspectResult:
    | ResolversParentTypes['InvalidConversionIdentifierException']
    | ResolversParentTypes['InvalidSourceAttributesException']
    | ResolversParentTypes['RegistrationFunnel']
  InvalidConversionIdentifierException: InvalidConversionIdentifierException
  InvalidSourceAttributesException: InvalidSourceAttributesException
  UpdateAttributionInput: UpdateAttributionInput
  UpdatableAttributesInput: UpdatableAttributesInput
  UpdateAttributionResult:
    | ResolversParentTypes['InvalidConversionIdentifierException']
    | ResolversParentTypes['InvalidSourceAttributesException']
    | ResolversParentTypes['NoProspectRecord']
    | ResolversParentTypes['RegistrationFunnel']
  NoProspectRecord: NoProspectRecord
  UUID: Scalars['UUID']
  Subscription: {}
  AcceptUploadedDocumentInput: AcceptUploadedDocumentInput
  AddActionToMilestoneAchievementActionRuleInput: AddActionToMilestoneAchievementActionRuleInput
  AddActionToMilestoneAchievementActionRuleResult:
    | ResolversParentTypes['MilestoneAchievementActionRule']
    | ResolversParentTypes['RecordAlreadyExistsError']
    | ResolversParentTypes['RecordDoesNotExistError']
  AddDocumentUrlsInput: AddDocumentUrlsInput
  DocumentInput: DocumentInput
  AdvocateFriendsStatuses: AdvocateFriendsStatuses
  AuthProfileAlreadyExistsException: AuthProfileAlreadyExistsException
  AuthProfileNotFoundException: AuthProfileNotFoundException
  BackendJobBatch: BackendJobBatch
  BackendJobBatchAutomatedOrdersFilterInput: BackendJobBatchAutomatedOrdersFilterInput
  BackendJobBatchMoneyMovementFilterInput: BackendJobBatchMoneyMovementFilterInput
  BackendJobBatchOrdersFilterInput: BackendJobBatchOrdersFilterInput
  BackendJobBatchProfitStarsFilterInput: BackendJobBatchProfitStarsFilterInput
  BackendJobBatchSummary: BackendJobBatchSummary
  BackendJobBatchSummaryFilterInput: BackendJobBatchSummaryFilterInput
  BatchAddTierSubscriptions: BatchAddTierSubscriptions
  BatchAddTierSubscriptionsInput: BatchAddTierSubscriptionsInput
  BatchAddTierSubscriptionsResult:
    | ResolversParentTypes['BatchAddTierSubscriptions']
    | ResolversParentTypes['InvalidTier']
    | ResolversParentTypes['InvalidTierPrice']
  BeneficiaryRequestedLaterAlert: BeneficiaryRequestedLaterAlert
  CancelRequestedDocumentInput: CancelRequestedDocumentInput
  ChangeSecuritySymbolInput: ChangeSecuritySymbolInput
  ChangeSecuritySymbolResult:
    | ResolversParentTypes['Fund']
    | ResolversParentTypes['Stock']
    | ResolversParentTypes['InvalidSecurityForSymbolChangeError']
    | ResolversParentTypes['InvalidSymbolForSymbolChangeError']
  Fund: Fund
  TopHolding: TopHolding
  Stock: Stock
  InvalidSecurityForSymbolChangeError: InvalidSecurityForSymbolChangeError
  InvalidSymbolForSymbolChangeError: InvalidSymbolForSymbolChangeError
  CoreACHSubscriptionFeeItem: CoreAchSubscriptionFeeItem
  CoreAdjustmentItem: CoreAdjustmentItem
  PastCoreTradedItem:
    | ResolversParentTypes['CoreAdjustmentItem']
    | ResolversParentTypes['CoreDividendsItem']
    | ResolversParentTypes['CoreEmployeeCreditItem']
    | ResolversParentTypes['CoreFeeInvestmentItem']
    | ResolversParentTypes['CoreFoundMoneyRewardItem']
    | ResolversParentTypes['CoreGiftCardCreditRedemptionItem']
    | ResolversParentTypes['CoreInvestmentItem']
    | ResolversParentTypes['CoreLocalFoundMoneyItem']
    | ResolversParentTypes['CorePartnerRewardItem']
    | ResolversParentTypes['CoreRebalanceItem']
    | ResolversParentTypes['CoreReferralRewardItem']
    | ResolversParentTypes['CoreRoundUpsItem']
    | ResolversParentTypes['CoreWithdrawalItem']
    | ResolversParentTypes['EarlyDividendsItem']
    | ResolversParentTypes['EarlyFeeInvestmentItem']
    | ResolversParentTypes['EarlyGiftItem']
    | ResolversParentTypes['EarlyInvestmentItem']
    | ResolversParentTypes['EarlyWithdrawalItem']
    | ResolversParentTypes['LaterDividendsItem']
    | ResolversParentTypes['LaterFeeInvestmentItem']
    | ResolversParentTypes['LaterInvestmentItem']
    | ResolversParentTypes['LaterRebalanceItem']
    | ResolversParentTypes['LaterWithdrawalItem']
  CoreCashForwardItem: CoreCashForwardItem
  CoreCollectionItem: CoreCollectionItem
  CoreDividendsItem: CoreDividendsItem
  CoreEmployeeCreditItem: CoreEmployeeCreditItem
  CoreFeeInvestmentItem: CoreFeeInvestmentItem
  CoreFoundMoneyRewardItem: CoreFoundMoneyRewardItem
  CoreGiftCardCreditRedemptionItem: CoreGiftCardCreditRedemptionItem
  CoreHoldingsTransferInItem: CoreHoldingsTransferInItem
  CoreInvestmentItem: CoreInvestmentItem
  PastCoreCombinedItem:
    | ResolversParentTypes['CoreInvestmentItem']
    | ResolversParentTypes['CoreRoundUpsItem']
  PastUserTransferItem:
    | ResolversParentTypes['CoreInvestmentItem']
    | ResolversParentTypes['CoreRoundUpsItem']
    | ResolversParentTypes['CoreWithdrawalItem']
    | ResolversParentTypes['EarlyInvestmentItem']
    | ResolversParentTypes['EarlyWithdrawalItem']
    | ResolversParentTypes['LaterInvestmentItem']
    | ResolversParentTypes['LaterWithdrawalItem']
    | ResolversParentTypes['SpendTransferInItem']
    | ResolversParentTypes['SpendTransferOutItem']
  CoreLocalFoundMoneyItem: CoreLocalFoundMoneyItem
  CorePartnerRewardItem: CorePartnerRewardItem
  CoreRebalanceItem: CoreRebalanceItem
  CoreReferralRewardItem: CoreReferralRewardItem
  CoreRoundUpsItem: CoreRoundUpsItem
  CoreWithdrawalItem: CoreWithdrawalItem
  CreateAccountPointsRuleInput: CreateAccountPointsRuleInput
  CreateAccountPointsRuleResult:
    | ResolversParentTypes['RecordAlreadyExistsError']
    | ResolversParentTypes['RecordDoesNotExistError']
    | ResolversParentTypes['AccountPointsRule']
  CreateAuthProfileInput: CreateAuthProfileInput
  CreateAuthProfileResult:
    | ResolversParentTypes['AuthProfile']
    | ResolversParentTypes['AuthProfileAlreadyExistsException']
  CreateMilestoneAccountLevelDefinitionInput: CreateMilestoneAccountLevelDefinitionInput
  CreateMilestoneAccountLevelDefinitionResult:
    | ResolversParentTypes['MilestoneAccountLevelDefinition']
    | ResolversParentTypes['RecordAlreadyExistsError']
  CreateMilestoneAchievementActionRuleInput: CreateMilestoneAchievementActionRuleInput
  CreateMilestoneAchievementActionRuleResult:
    | ResolversParentTypes['MilestoneAchievementActionRule']
    | ResolversParentTypes['RecordAlreadyExistsError']
    | ResolversParentTypes['RecordDoesNotExistError']
  CreateMilestoneChallengeDefinitionInput: CreateMilestoneChallengeDefinitionInput
  ImageInput: ImageInput
  CreateMilestoneChallengeDefinitionResult:
    | ResolversParentTypes['MilestoneChallengeDefinition']
    | ResolversParentTypes['RecordAlreadyExistsError']
    | ResolversParentTypes['RecordDoesNotExistError']
  MilestoneChallengeDefinition: MilestoneChallengeDefinition
  CreateMilestoneChallengePointsRuleInput: CreateMilestoneChallengePointsRuleInput
  CreateMilestoneChallengePointsRuleResult:
    | ResolversParentTypes['MilestoneChallengePointsRule']
    | ResolversParentTypes['RecordAlreadyExistsError']
    | ResolversParentTypes['RecordDoesNotExistError']
  CreateMilestoneDefinitionInput: CreateMilestoneDefinitionInput
  CreateMilestoneDefinitionResult:
    | ResolversParentTypes['MilestoneDefinition']
    | ResolversParentTypes['RecordAlreadyExistsError']
    | ResolversParentTypes['RecordDoesNotExistError']
  CreateMilestoneRuleInput: CreateMilestoneRuleInput
  CreateMilestoneRuleResult:
    | ResolversParentTypes['MilestoneRule']
    | ResolversParentTypes['RecordAlreadyExistsError']
  CreateOfferInput: CreateOfferInput
  OfferPriceInput: OfferPriceInput
  CreateOfferResult: ResolversParentTypes['Offer']
  CreateSecurityQuestionInput: CreateSecurityQuestionInput
  CreateSubscriptionMigrationInput: CreateSubscriptionMigrationInput
  CreateSubscriptionMigrationResult: ResolversParentTypes['SubscriptionMigration']
  DeactivateSecurityFailed: DeactivateSecurityFailed
  DeactivateSecurityInput: DeactivateSecurityInput
  DeactivateSecurityResult:
    | ResolversParentTypes['Fund']
    | ResolversParentTypes['Stock']
    | ResolversParentTypes['DeactivateSecurityFailed']
  DeregisterAuthenticatorInput: DeregisterAuthenticatorInput
  DeregisterAuthenticatorResult:
    | ResolversParentTypes['PhoneAuthenticator']
    | ResolversParentTypes['EmailAuthenticator']
    | ResolversParentTypes['AuthenticatorNotFoundException']
  Dividend: Dividend
  DividendsBySymbolInput: DividendsBySymbolInput
  EarlyDividendsItem: EarlyDividendsItem
  PastEarlyItem:
    | ResolversParentTypes['EarlyDividendsItem']
    | ResolversParentTypes['EarlyFeeInvestmentItem']
    | ResolversParentTypes['EarlyGiftItem']
    | ResolversParentTypes['EarlyInvestmentItem']
    | ResolversParentTypes['EarlyWithdrawalItem']
  EarlyFeeInvestmentItem: EarlyFeeInvestmentItem
  EarlyGiftItem: EarlyGiftItem
  PastAnnotatedItem: ResolversParentTypes['EarlyGiftItem']
  EarlyInvestmentItem: EarlyInvestmentItem
  EarlyWithdrawalItem: EarlyWithdrawalItem
  EditSecurityQuestionInput: EditSecurityQuestionInput
  EditSecurityQuestionResult:
    | ResolversParentTypes['SecurityQuestion']
    | ResolversParentTypes['InvalidSecurityQuestionException']
  ExistingPhoneVerifiedException: ExistingPhoneVerifiedException
  HideMessageInput: HideMessageInput
  InternalShareTransferFailed: InternalShareTransferFailed
  InternalShareTransferInput: InternalShareTransferInput
  InvalidLaterInput: InvalidLaterInput
  InvalidTierPriceCombination: InvalidTierPriceCombination
  LaterDividendsItem: LaterDividendsItem
  LaterEntityBeneficiary: LaterEntityBeneficiary
  LaterFeeInvestmentItem: LaterFeeInvestmentItem
  LaterInvestmentItem: LaterInvestmentItem
  LaterRebalanceItem: LaterRebalanceItem
  LaterWithdrawal: LaterWithdrawal
  LaterWithdrawalItem: LaterWithdrawalItem
  LaterWithholdingValues: LaterWithholdingValues
  LogoutDeviceInput: LogoutDeviceInput
  LogoutDeviceResult:
    | ResolversParentTypes['LogoutDeviceSuccess']
    | ResolversParentTypes['RefreshTokenNotFoundException']
    | ResolversParentTypes['DeviceNotFoundException']
  LogoutDeviceSuccess: LogoutDeviceSuccess
  Long: Scalars['Long']
  MfaMissingAuthAlert: MfaMissingAuthAlert
  MissingSsnBeneficiaryAlert: MissingSsnBeneficiaryAlert
  MonetaryIncentive: MonetaryIncentive
  OmnibusShareTransferId: OmnibusShareTransferId
  PastCoreItem: PastCoreItem
  PastSpendItem: PastSpendItem
  SpendItem:
    | ResolversParentTypes['PastSpendItem']
    | ResolversParentTypes['SpendATMReimbursementItem']
    | ResolversParentTypes['SpendATMWithdrawalItem']
    | ResolversParentTypes['SpendBillPayItem']
    | ResolversParentTypes['SpendCheckDepositItem']
    | ResolversParentTypes['SpendCheckPaymentItem']
    | ResolversParentTypes['SpendDigitalWalletItem']
    | ResolversParentTypes['SpendDirectDepositItem']
    | ResolversParentTypes['SpendECheckItem']
    | ResolversParentTypes['SpendPurchaseItem']
    | ResolversParentTypes['SpendRealTimeRoundUpItem']
    | ResolversParentTypes['SpendTransferInItem']
    | ResolversParentTypes['SpendTransferOutItem']
  ReferralEventInput: ReferralEventInput
  ReferralRewardSummary: ReferralRewardSummary
  ReferralUserUpdateInput: ReferralUserUpdateInput
  RejectUploadedDocumentInput: RejectUploadedDocumentInput
  RemoveActionFromMilestoneAchievementActionRuleInput: RemoveActionFromMilestoneAchievementActionRuleInput
  RemoveActionFromMilestoneAchievementActionRuleResult:
    | ResolversParentTypes['MilestoneAchievementActionRule']
    | ResolversParentTypes['RecordDoesNotExistError']
  RequestDocumentUploadInput: RequestDocumentUploadInput
  RestoreLoginAccessInput: RestoreLoginAccessInput
  RestoreLoginAccessResult:
    | ResolversParentTypes['AuthProfile']
    | ResolversParentTypes['AuthProfileNotFoundException']
  RevokeLoginAccessInput: RevokeLoginAccessInput
  RevokeLoginAccessResult:
    | ResolversParentTypes['AuthProfile']
    | ResolversParentTypes['UserCredentialsNotFoundException']
  RevokePasswordResetTokenInput: RevokePasswordResetTokenInput
  RevokePasswordResetTokenResult:
    | ResolversParentTypes['RevokePasswordResetTokenSuccess']
    | ResolversParentTypes['InvalidPasswordResetTokenException']
  RevokePasswordResetTokenSuccess: RevokePasswordResetTokenSuccess
  SelfDirectedPortfolio: SelfDirectedPortfolio
  Short: Scalars['Short']
  SpendATMReimbursementItem: SpendAtmReimbursementItem
  SpendATMWithdrawalItem: SpendAtmWithdrawalItem
  SpendBillPayItem: SpendBillPayItem
  SpendCheckDepositItem: SpendCheckDepositItem
  SpendCheckPaymentItem: SpendCheckPaymentItem
  SpendDigitalWalletItem: SpendDigitalWalletItem
  SpendDirectDepositItem: SpendDirectDepositItem
  SpendECheckItem: SpendECheckItem
  SpendPurchaseItem: SpendPurchaseItem
  SpendRealTimeRoundUpItem: SpendRealTimeRoundUpItem
  SpendTransferInItem: SpendTransferInItem
  SpendTransferOutItem: SpendTransferOutItem
  SplitDepositDailyRecurrenceRule: SplitDepositDailyRecurrenceRule
  SplitDepositRecurrenceRule:
    | ResolversParentTypes['SplitDepositDailyRecurrenceRule']
    | ResolversParentTypes['SplitDepositMonthlyRecurrenceRule']
    | ResolversParentTypes['SplitDepositWeeklyRecurrenceRule']
  SplitDepositMonthlyRecurrenceRule: SplitDepositMonthlyRecurrenceRule
  SplitDepositRecurrenceAllocation: SplitDepositRecurrenceAllocation
  SplitDepositRecurrenceSetting: SplitDepositRecurrenceSetting
  SplitDepositWeeklyRecurrenceRule: SplitDepositWeeklyRecurrenceRule
  SupportUser: SupportUser
  SystemCardLockedSpendAlert: SystemCardLockedSpendAlert
  Time: Scalars['Time']
  TransferInternalSharesInput: TransferInternalSharesInput
  TransferInternalSharesResult:
    | ResolversParentTypes['OmnibusShareTransferId']
    | ResolversParentTypes['InternalShareTransferFailed']
  UnverifiedBeneficiarySsnAlert: UnverifiedBeneficiarySsnAlert
  UpdateAccountPointsRuleInput: UpdateAccountPointsRuleInput
  UpdateAccountPointsRuleResult:
    | ResolversParentTypes['RecordAlreadyExistsError']
    | ResolversParentTypes['RecordDoesNotExistError']
    | ResolversParentTypes['AccountPointsRule']
  UpdateAuthEmailInput: UpdateAuthEmailInput
  UpdateAuthEmailResult:
    | ResolversParentTypes['AuthProfile']
    | ResolversParentTypes['ExistingEmailVerifiedException']
  UpdateAuthPhoneNumberInput: UpdateAuthPhoneNumberInput
  UpdateAuthPhoneNumberResult:
    | ResolversParentTypes['AuthProfile']
    | ResolversParentTypes['InvalidPhoneNumberException']
    | ResolversParentTypes['ExistingPhoneVerifiedException']
  UpdateMilestoneAccountLevelDefinitionInput: UpdateMilestoneAccountLevelDefinitionInput
  UpdateMilestoneAccountLevelDefinitionResult:
    | ResolversParentTypes['MilestoneAccountLevelDefinition']
    | ResolversParentTypes['RecordDoesNotExistError']
  UpdateMilestoneChallengeDefinitionInput: UpdateMilestoneChallengeDefinitionInput
  UpdateMilestoneChallengeDefinitionResult:
    | ResolversParentTypes['MilestoneChallengeDefinition']
    | ResolversParentTypes['RecordDoesNotExistError']
  UpdateMilestoneChallengePointsRuleInput: UpdateMilestoneChallengePointsRuleInput
  UpdateMilestoneChallengePointsRuleResult:
    | ResolversParentTypes['MilestoneChallengePointsRule']
    | ResolversParentTypes['RecordDoesNotExistError']
  UpdateMilestoneDefinitionInput: UpdateMilestoneDefinitionInput
  UpdateMilestoneDefinitionResult:
    | ResolversParentTypes['MilestoneDefinition']
    | ResolversParentTypes['RecordDoesNotExistError']
  UpdateReferralRewardError: UpdateReferralRewardError
  UpdateReferralRewardResponse:
    | ResolversParentTypes['ReferralRewardSummary']
    | ResolversParentTypes['UpdateReferralRewardError']
  UserCardLockedSpendAlert: UserCardLockedSpendAlert
}

export type AboutSectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AboutSection'] = ResolversParentTypes['AboutSection']
> = {
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AbstractSwitchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AbstractSwitch'] = ResolversParentTypes['AbstractSwitch']
> = {
  __resolveType: TypeResolveFn<
    'AcornsPdfSwitch' | 'OnlineSwitch' | 'SubmittableSwitch',
    ParentType,
    ContextType
  >
}

export type AcceptanceDocumentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AcceptanceDocument'] = ResolversParentTypes['AcceptanceDocument']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  summaryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  summaryUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  mustScrollToBottom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  requiredFor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AcceptDocumentResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AcceptDocumentResponse'] = ResolversParentTypes['AcceptDocumentResponse']
> = {
  __resolveType: TypeResolveFn<
    'AcceptedDocument' | 'DocumentNotFound' | 'UserNotFound',
    ParentType,
    ContextType
  >
}

export type AcceptedDocumentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AcceptedDocument'] = ResolversParentTypes['AcceptedDocument']
> = {
  acceptedDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  documentType?: Resolver<ResolversTypes['AcceptanceDocumentType'], ParentType, ContextType>
  documentUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  documentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  signature?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']
> = {
  accountType?: Resolver<ResolversTypes['AccountType'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  creatorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['AccountStatus'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountAchievementResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountAchievement'] = ResolversParentTypes['AccountAchievement']
> = {
  achievement?: Resolver<ResolversTypes['AchievementItem'], ParentType, ContextType>
  completed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  dateCompleted?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountAlreadyClosedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountAlreadyClosedException'] = ResolversParentTypes['AccountAlreadyClosedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountClosedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountClosedException'] = ResolversParentTypes['AccountClosedException']
> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountNotFoundException'] = ResolversParentTypes['AccountNotFoundException']
> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface AccountNumberScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['AccountNumber'], any> {
  name: 'AccountNumber'
}

export type AccountPointsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountPoints'] = ResolversParentTypes['AccountPoints']
> = {
  details?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  detailsKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  earned?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  pointsPerCompletion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  summaryKey?: Resolver<Maybe<ResolversTypes['StringKey']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountPointsRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountPointsRule'] = ResolversParentTypes['AccountPointsRule']
> = {
  details?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  detailsKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  milestoneID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  pointsPerCompletion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  summaryKey?: Resolver<Maybe<ResolversTypes['StringKey']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountRequirementResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountRequirement'] = ResolversParentTypes['AccountRequirement']
> = {
  actionable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  status?: Resolver<ResolversTypes['AccountRequirementStatus'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['AccountRequirementType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountRequirementsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountRequirements'] = ResolversParentTypes['AccountRequirements']
> = {
  close?: Resolver<Array<ResolversTypes['AccountRequirement']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountSetupMilestonesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountSetupMilestones'] = ResolversParentTypes['AccountSetupMilestones']
> = {
  descriptionKey?: Resolver<Maybe<ResolversTypes['StringKey']>, ParentType, ContextType>
  groupProgress?: Resolver<ResolversTypes['DiscreteMilestoneProgress'], ParentType, ContextType>
  milestones?: Resolver<Array<ResolversTypes['Milestone']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountStrengthResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountStrengthResult'] = ResolversParentTypes['AccountStrengthResult']
> = {
  achievements?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['AccountAchievement']>>>,
    ParentType,
    ContextType
  >
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountValueResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountValue'] = ResolversParentTypes['AccountValue']
> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  timestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AcornsPdfSwitchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AcornsPdfSwitch'] = ResolversParentTypes['AcornsPdfSwitch']
> = {
  source?: Resolver<ResolversTypes['SwitchSource'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ActionCardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ActionCard'] = ResolversParentTypes['ActionCard']
> = {
  userCardDigest?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  style?: Resolver<ResolversTypes['ActionCardStyle'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  eyebrow?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  headline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  imageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  image?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  heroImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  ctaDetails?: Resolver<Maybe<ResolversTypes['ActionCardButton']>, ParentType, ContextType>
  widget?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  ownerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ActionCardButtonResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ActionCardButton'] = ResolversParentTypes['ActionCardButton']
> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  videoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  video?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  image?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ActionFeedCtaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ActionFeedCta'] = ResolversParentTypes['ActionFeedCta']
> = {
  hideCardIfUnknown?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<Maybe<ResolversTypes['ActionFeedCtaType']>, ParentType, ContextType>
  video?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  videoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ActionFeedEventResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ActionFeedEventResponse'] = ResolversParentTypes['ActionFeedEventResponse']
> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ActivateBankCardPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ActivateBankCardPayload'] = ResolversParentTypes['ActivateBankCardPayload']
> = {
  bankCard?: Resolver<Maybe<ResolversTypes['BankCard']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ActivityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Activity'] = ResolversParentTypes['Activity']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['ActivityType'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  pending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  meta?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ActivitySummaryResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ActivitySummaryResponse'] = ResolversParentTypes['ActivitySummaryResponse']
> = {
  activitySummaryItems?: Resolver<
    Maybe<Array<ResolversTypes['SummaryItem']>>,
    ParentType,
    ContextType
  >
  numberOfDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  total?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AddActionToMilestoneAchievementActionRuleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddActionToMilestoneAchievementActionRuleResult'] = ResolversParentTypes['AddActionToMilestoneAchievementActionRuleResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneAchievementActionRule' | 'RecordAlreadyExistsError' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type AddActionToMilestoneGroupAchievementActionRuleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddActionToMilestoneGroupAchievementActionRuleResult'] = ResolversParentTypes['AddActionToMilestoneGroupAchievementActionRuleResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneGroupAchievementActionRule' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type AddMilestonesToMilestoneHubDefinitionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddMilestonesToMilestoneHubDefinitionResult'] = ResolversParentTypes['AddMilestonesToMilestoneHubDefinitionResult']
> = {
  __resolveType: TypeResolveFn<
    'RecordDoesNotExistError' | 'MilestoneHubDefinition',
    ParentType,
    ContextType
  >
}

export type AddMilestoneToMilestoneGroupDefinitionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddMilestoneToMilestoneGroupDefinitionResult'] = ResolversParentTypes['AddMilestoneToMilestoneGroupDefinitionResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneGroupDefinition' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type AddressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']
> = {
  addressType?: Resolver<ResolversTypes['AddressType'], ParentType, ContextType>
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  street1?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  zipCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AddressDeliverabilityAdditionalInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddressDeliverabilityAdditionalInfo'] = ResolversParentTypes['AddressDeliverabilityAdditionalInfo']
> = {
  isPoBox?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  isBusiness?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  isPrivateMailbox?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  isVacant?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AddressDeliverabilityCorrectedAddressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddressDeliverabilityCorrectedAddress'] = ResolversParentTypes['AddressDeliverabilityCorrectedAddress']
> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  street1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  additionalInfo?: Resolver<
    Maybe<ResolversTypes['AddressDeliverabilityAdditionalInfo']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AddressDeliverabilityResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddressDeliverabilityResult'] = ResolversParentTypes['AddressDeliverabilityResult']
> = {
  __resolveType: TypeResolveFn<
    | 'AddressDeliverabilityVerified'
    | 'AddressDeliverabilityVerificationError'
    | 'AddressDeliverabilityCorrectedAddress'
    | 'AddressDeliverabilityUnavailableError',
    ParentType,
    ContextType
  >
}

export type AddressDeliverabilityUnavailableErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddressDeliverabilityUnavailableError'] = ResolversParentTypes['AddressDeliverabilityUnavailableError']
> = {
  requestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AddressDeliverabilityVerificationErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddressDeliverabilityVerificationError'] = ResolversParentTypes['AddressDeliverabilityVerificationError']
> = {
  requestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  failureReason?: Resolver<
    Maybe<ResolversTypes['AddressDeliverabilityVerificationErrorFailureReason']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AddressDeliverabilityVerifiedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddressDeliverabilityVerified'] = ResolversParentTypes['AddressDeliverabilityVerified']
> = {
  requestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  additionalInfo?: Resolver<
    Maybe<ResolversTypes['AddressDeliverabilityAdditionalInfo']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AddressDocumentRequestedUserAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddressDocumentRequestedUserAlert'] = ResolversParentTypes['AddressDocumentRequestedUserAlert']
> = {
  requestedDocumentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AddSearchTermToLearnSearchHistoryResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddSearchTermToLearnSearchHistoryResult'] = ResolversParentTypes['AddSearchTermToLearnSearchHistoryResult']
> = {
  __resolveType: TypeResolveFn<'LearnSearchTermSavedResult', ParentType, ContextType>
}

export type AddSecurityToPortfolioResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddSecurityToPortfolioResult'] = ResolversParentTypes['AddSecurityToPortfolioResult']
> = {
  __resolveType: TypeResolveFn<
    | 'InvestmentAccountNotFoundException'
    | 'InvestmentAccountNotSupportedException'
    | 'Portfolio'
    | 'PortfolioNotFoundException'
    | 'PortfolioNotSupportedException'
    | 'SecurityNotSupportedException',
    ParentType,
    ContextType
  >
}

export type AddSelfDirectedPortfolioResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddSelfDirectedPortfolioResult'] = ResolversParentTypes['AddSelfDirectedPortfolioResult']
> = {
  __resolveType: TypeResolveFn<
    | 'CustomerAgreementRequiredException'
    | 'InvalidInvestmentAccountException'
    | 'InvalidSubscriptionTierException'
    | 'InvestmentAccount'
    | 'PortfolioNotFoundException',
    ParentType,
    ContextType
  >
}

export type AdvocateResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Advocate'] = ResolversParentTypes['Advocate']
> = {
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  referralCodes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  friends?: Resolver<Maybe<Array<ResolversTypes['Friend']>>, ParentType, ContextType>
  referralHistory?: Resolver<Maybe<ResolversTypes['ReferralHistory']>, ParentType, ContextType>
  experienceContent?: Resolver<Maybe<ResolversTypes['ExperienceContent']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AdvocateFriendsStatusesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AdvocateFriendsStatuses'] = ResolversParentTypes['AdvocateFriendsStatuses']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  referralCodes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  friends?: Resolver<Maybe<Array<ResolversTypes['Friend']>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Alert'] = ResolversParentTypes['Alert']
> = {
  __resolveType: TypeResolveFn<
    | 'BeneficiaryRequestedLaterAlert'
    | 'MissingSsnBeneficiaryAlert'
    | 'UnverifiedBeneficiarySsnAlert',
    ParentType,
    ContextType
  >
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
}

export type AlertHubBeneficiaryAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertHubBeneficiaryAlert'] = ResolversParentTypes['AlertHubBeneficiaryAlert']
> = {
  __resolveType: TypeResolveFn<
    'MissingSsnBeneficiaryAlertItem' | 'UnverifiedBeneficiarySsnAlertItem',
    ParentType,
    ContextType
  >
}

export type AlertMessageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertMessage'] = ResolversParentTypes['AlertMessage']
> = {
  body?: Resolver<ResolversTypes['MessageTextAsset'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  deepLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  icon?: Resolver<Maybe<ResolversTypes['MessageVisualAsset']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  isDismissed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  messageCategory?: Resolver<ResolversTypes['MessageCategory'], ParentType, ContextType>
  messageType?: Resolver<ResolversTypes['MessageType'], ParentType, ContextType>
  readAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['MessageTextAsset'], ParentType, ContextType>
  trackingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AllCheckPaymentsResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AllCheckPaymentsResult'] = ResolversParentTypes['AllCheckPaymentsResult']
> = {
  __resolveType: TypeResolveFn<
    'CheckPaymentConnection' | 'AuthorizationError',
    ParentType,
    ContextType
  >
}

export interface AmountScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Amount'], any> {
  name: 'Amount'
}

export type AnswerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Answer'] = ResolversParentTypes['Answer']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['AnswerType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AnswerLearnQuizQuestionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AnswerLearnQuizQuestionResult'] = ResolversParentTypes['AnswerLearnQuizQuestionResult']
> = {
  __resolveType: TypeResolveFn<
    'LearnQuizAnswerResult' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type ApplyPromotionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ApplyPromotionResult'] = ResolversParentTypes['ApplyPromotionResult']
> = {
  __resolveType: TypeResolveFn<
    | 'PromotionConsumedError'
    | 'PromotionExpiredError'
    | 'PromotionNotFoundError'
    | 'SubscriberIneligibleError'
    | 'TierSubscription',
    ParentType,
    ContextType
  >
}

export type ArticleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Article'] = ResolversParentTypes['Article']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<Maybe<ResolversTypes['Cta']>, ParentType, ContextType>
  eyebrow?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AsyncLinkSessionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AsyncLinkSessionResult'] = ResolversParentTypes['AsyncLinkSessionResult']
> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthAlert'] = ResolversParentTypes['AuthAlert']
> = {
  __resolveType: TypeResolveFn<'MfaMissingAuthAlert', ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
}

export type AuthChallengeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthChallenge'] = ResolversParentTypes['AuthChallenge']
> = {
  __resolveType: TypeResolveFn<'SMSAuthChallenge' | 'EmailAuthChallenge', ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  alternateAuthenticators?: Resolver<
    Array<ResolversTypes['AuthenticatorInfo']>,
    ParentType,
    ContextType
  >
}

export type AuthChallengeAnswerAttemptsExhaustedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthChallengeAnswerAttemptsExhaustedException'] = ResolversParentTypes['AuthChallengeAnswerAttemptsExhaustedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthChallengeAnswerIncorrectExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthChallengeAnswerIncorrectException'] = ResolversParentTypes['AuthChallengeAnswerIncorrectException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthChallengeExpiredExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthChallengeExpiredException'] = ResolversParentTypes['AuthChallengeExpiredException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthenticateForFeeNegotiationResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthenticateForFeeNegotiationResult'] = ResolversParentTypes['AuthenticateForFeeNegotiationResult']
> = {
  __resolveType: TypeResolveFn<
    | 'AuthenticateForFeeNegotiationStatus'
    | 'LinkedAccountNotFound'
    | 'NegotiationServiceConnectionFailure',
    ParentType,
    ContextType
  >
}

export type AuthenticateForFeeNegotiationStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthenticateForFeeNegotiationStatus'] = ResolversParentTypes['AuthenticateForFeeNegotiationStatus']
> = {
  credentialStatus?: Resolver<ResolversTypes['CredentialStatus'], ParentType, ContextType>
  tfaOptions?: Resolver<Maybe<ResolversTypes['TfaOptions']>, ParentType, ContextType>
  tfaStatus?: Resolver<ResolversTypes['TfaStatus'], ParentType, ContextType>
  tfaType?: Resolver<ResolversTypes['TfaType'], ParentType, ContextType>
  tfaMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  operationStage?: Resolver<ResolversTypes['OperationStage'], ParentType, ContextType>
  operationError?: Resolver<Maybe<ResolversTypes['AutomationError']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthenticateNegotiationStatusResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthenticateNegotiationStatusResult'] = ResolversParentTypes['AuthenticateNegotiationStatusResult']
> = {
  __resolveType: TypeResolveFn<
    'AuthenticateForFeeNegotiationStatus' | 'LinkedAccountNotFound',
    ParentType,
    ContextType
  >
}

export type AuthenticateResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthenticateResult'] = ResolversParentTypes['AuthenticateResult']
> = {
  __resolveType: TypeResolveFn<
    | 'SMSAuthChallenge'
    | 'EmailAuthChallenge'
    | 'AuthSession'
    | 'AuthenticatorUnavailableException'
    | 'InvalidCredentialsException'
    | 'UserSuspendedException'
    | 'DeviceBlockedException'
    | 'UserLockedException'
    | 'LoginRateLimitedException'
    | 'PhoneNumberOptedOutException'
    | 'AuthChallengeAnswerIncorrectException'
    | 'AuthChallengeAnswerAttemptsExhaustedException'
    | 'AuthChallengeExpiredException'
    | 'AuthenticatorTypeAlreadyRegisteredException',
    ParentType,
    ContextType
  >
}

export type AuthenticationAlreadyUpgradedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthenticationAlreadyUpgradedException'] = ResolversParentTypes['AuthenticationAlreadyUpgradedException']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthenticatorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Authenticator'] = ResolversParentTypes['Authenticator']
> = {
  __resolveType: TypeResolveFn<'PhoneAuthenticator' | 'EmailAuthenticator', ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  lastUsedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
}

export type AuthenticatorAlreadyDefaultExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthenticatorAlreadyDefaultException'] = ResolversParentTypes['AuthenticatorAlreadyDefaultException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthenticatorInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthenticatorInfo'] = ResolversParentTypes['AuthenticatorInfo']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['AuthType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthenticatorNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthenticatorNotFoundException'] = ResolversParentTypes['AuthenticatorNotFoundException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthenticatorTypeAlreadyRegisteredExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthenticatorTypeAlreadyRegisteredException'] = ResolversParentTypes['AuthenticatorTypeAlreadyRegisteredException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthenticatorUnavailableExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthenticatorUnavailableException'] = ResolversParentTypes['AuthenticatorUnavailableException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthorizationErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthorizationError'] = ResolversParentTypes['AuthorizationError']
> = {
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthProfileResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthProfile'] = ResolversParentTypes['AuthProfile']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  email?: Resolver<Maybe<ResolversTypes['EmailAddress']>, ParentType, ContextType>
  emailVerifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  phoneNumberVerifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  requireLoginChallenge?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  defaultAuthenticator?: Resolver<Maybe<ResolversTypes['Authenticator']>, ParentType, ContextType>
  loginAccess?: Resolver<Maybe<ResolversTypes['LoginAccess']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthProfileAlreadyExistsExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthProfileAlreadyExistsException'] = ResolversParentTypes['AuthProfileAlreadyExistsException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthProfileNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthProfileNotFoundException'] = ResolversParentTypes['AuthProfileNotFoundException']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthSessionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthSession'] = ResolversParentTypes['AuthSession']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  token?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  refreshToken?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  identityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  redirectUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AuthTokenNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthTokenNotFoundException'] = ResolversParentTypes['AuthTokenNotFoundException']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AutomationErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AutomationError'] = ResolversParentTypes['AutomationError']
> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  errorCode?: Resolver<Maybe<ResolversTypes['AutomationErrorCode']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BackendJobBatchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BackendJobBatch'] = ResolversParentTypes['BackendJobBatch']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['BackendJobBatchType'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['BackendJobBatchStatus'], ParentType, ContextType>
  totalJobs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  processedJobs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  failedJobs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  pendingJobs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  successPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  pendingPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BackendJobBatchSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BackendJobBatchSummary'] = ResolversParentTypes['BackendJobBatchSummary']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  totalInvestmentCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  customerCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  totalInvestmentAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  totalHoldingsAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BackgroundImageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BackgroundImage'] = ResolversParentTypes['BackgroundImage']
> = {
  horizontalFocalPoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  url?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  verticalFocalPoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankAccount'] = ResolversParentTypes['BankAccount']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  balance?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  currentBalance?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  availableBalance?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  pendingBalance?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  routingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['BankAccountType'], ParentType, ContextType>
  referenceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  accountHolderReferenceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  closedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  isEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['BankAccountStatus'], ParentType, ContextType>
  isLocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  lockReason?: Resolver<Maybe<ResolversTypes['BankAccountLockReason']>, ParentType, ContextType>
  isPendingClosure?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  requirements?: Resolver<ResolversTypes['BankAccountRequirements'], ParentType, ContextType>
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  goals?: Resolver<ResolversTypes['BankAccountGoals'], ParentType, ContextType>
  bankType?: Resolver<ResolversTypes['BankType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankAccountDisclosureResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankAccountDisclosure'] = ResolversParentTypes['BankAccountDisclosure']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summaryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  summaryUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  mustScrollToBottom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  requiredFor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankAccountGoalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankAccountGoal'] = ResolversParentTypes['BankAccountGoal']
> = {
  type?: Resolver<ResolversTypes['BankAccountGoalType'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankAccountGoalsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankAccountGoals'] = ResolversParentTypes['BankAccountGoals']
> = {
  currentGoal?: Resolver<Maybe<ResolversTypes['BankAccountGoal']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankAccountNotFoundErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankAccountNotFoundError'] = ResolversParentTypes['BankAccountNotFoundError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankAccountRequirementResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankAccountRequirement'] = ResolversParentTypes['BankAccountRequirement']
> = {
  actionable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  status?: Resolver<ResolversTypes['BankAccountRequirementStatus'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['BankAccountRequirementType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankAccountRequirementsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankAccountRequirements'] = ResolversParentTypes['BankAccountRequirements']
> = {
  close?: Resolver<Array<ResolversTypes['BankAccountRequirement']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankCardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankCard'] = ResolversParentTypes['BankCard']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  cardNumberMasked?: Resolver<Maybe<ResolversTypes['CardNumberMasked']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  activatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  expireMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  expireYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  tier?: Resolver<ResolversTypes['BankCardTier'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['BankCardType'], ParentType, ContextType>
  referenceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  lockReason?: Resolver<Maybe<ResolversTypes['BankCardLockReason']>, ParentType, ContextType>
  lockTypeCode?: Resolver<ResolversTypes['BankCardLockTypeCode'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['BankCardStatus'], ParentType, ContextType>
  paymentProcessor?: Resolver<ResolversTypes['BankCardPaymentProcessor'], ParentType, ContextType>
  bankType?: Resolver<ResolversTypes['BankType'], ParentType, ContextType>
  userActivatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankCardOrderResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankCardOrder'] = ResolversParentTypes['BankCardOrder']
> = {
  cardOrderStatus?: Resolver<ResolversTypes['BankCardOrderStatus'], ParentType, ContextType>
  addressVerification?: Resolver<
    Maybe<ResolversTypes['BankCardOrderAddressVerification']>,
    ParentType,
    ContextType
  >
  identityVerification?: Resolver<
    Maybe<ResolversTypes['BankCardOrderIdentityVerification']>,
    ParentType,
    ContextType
  >
  prefundVerification?: Resolver<
    Maybe<ResolversTypes['BankCardOrderPrefundVerification']>,
    ParentType,
    ContextType
  >
  fundingSourceVerification?: Resolver<
    Maybe<ResolversTypes['BankCardOrderFundingSourceVerification']>,
    ParentType,
    ContextType
  >
  failureReason?: Resolver<
    Maybe<ResolversTypes['BankCardOrderFailureReason']>,
    ParentType,
    ContextType
  >
  bankType?: Resolver<Maybe<ResolversTypes['BankType']>, ParentType, ContextType>
  bankCardTier?: Resolver<Maybe<ResolversTypes['BankCardTier']>, ParentType, ContextType>
  kycStatus?: Resolver<Maybe<ResolversTypes['KycStatus']>, ParentType, ContextType>
  fundingInitiated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  requestVersion?: Resolver<Maybe<ResolversTypes['RequestVersions']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankCardOrderAddressVerificationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankCardOrderAddressVerification'] = ResolversParentTypes['BankCardOrderAddressVerification']
> = {
  status?: Resolver<ResolversTypes['BankCardOrderVerificationStatus'], ParentType, ContextType>
  actionRequired?: Resolver<
    Maybe<ResolversTypes['BankCardOrderAddressVerificationActions']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankCardOrderFundingSourceVerificationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankCardOrderFundingSourceVerification'] = ResolversParentTypes['BankCardOrderFundingSourceVerification']
> = {
  status?: Resolver<ResolversTypes['BankCardOrderVerificationStatus'], ParentType, ContextType>
  actionRequired?: Resolver<
    Maybe<ResolversTypes['BankCardOrderFundingSourceVerificationActions']>,
    ParentType,
    ContextType
  >
  pendingReason?: Resolver<
    Maybe<ResolversTypes['BankCardOrderFundingSourceVerificationPendingReason']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankCardOrderIdentityVerificationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankCardOrderIdentityVerification'] = ResolversParentTypes['BankCardOrderIdentityVerification']
> = {
  status?: Resolver<ResolversTypes['BankCardOrderVerificationStatus'], ParentType, ContextType>
  actionRequired?: Resolver<
    Maybe<ResolversTypes['BankCardOrderIdentityVerificationActions']>,
    ParentType,
    ContextType
  >
  documentUploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankCardOrderPrefundVerificationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankCardOrderPrefundVerification'] = ResolversParentTypes['BankCardOrderPrefundVerification']
> = {
  status?: Resolver<ResolversTypes['BankCardOrderVerificationStatus'], ParentType, ContextType>
  actionRequired?: Resolver<
    Maybe<ResolversTypes['BankCardOrderPrefundVerificationActions']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface BankCardPinScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['BankCardPin'], any> {
  name: 'BankCardPin'
}

export type BankCardReissueResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankCardReissue'] = ResolversParentTypes['BankCardReissue']
> = {
  bankCardRequest?: Resolver<Maybe<ResolversTypes['BankCardRequest']>, ParentType, ContextType>
  reissueBankCardEligibility?: Resolver<
    ResolversTypes['ReissueBankCardEligibility'],
    ParentType,
    ContextType
  >
  bankType?: Resolver<ResolversTypes['BankType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankCardRequestResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankCardRequest'] = ResolversParentTypes['BankCardRequest']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  requestedDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['BankCardRequestStatus'], ParentType, ContextType>
  reason?: Resolver<ResolversTypes['BankCardRequestReason'], ParentType, ContextType>
  isReissue?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  reasonDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>
  reasonComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  issuedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>
  isActivated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  previousBankCardId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  mailingAddress?: Resolver<
    Maybe<ResolversTypes['BankCardRequestMailingAddress']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankCardRequestMailingAddressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankCardRequestMailingAddress'] = ResolversParentTypes['BankCardRequestMailingAddress']
> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  street1?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  zipCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankConnection'] = ResolversParentTypes['BankConnection']
> = {
  bank?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  linkedAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  lastSubmissionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  nextSubmissionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  eligible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  accountStatus?: Resolver<Maybe<ResolversTypes['BankConnectionStatus']>, ParentType, ContextType>
  institutionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  totalNegotiableFees?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  negotiationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  logoUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankDocumentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankDocument'] = ResolversParentTypes['BankDocument']
> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankDocumentRequestedUserAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankDocumentRequestedUserAlert'] = ResolversParentTypes['BankDocumentRequestedUserAlert']
> = {
  requestedDocumentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankFeeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankFee'] = ResolversParentTypes['BankFee']
> = {
  amount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['BankFeeType'], ParentType, ContextType>
  category?: Resolver<ResolversTypes['TransactionCategory'], ParentType, ContextType>
  linkedSubAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  linkedAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  transactionDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['FeeStatus'], ParentType, ContextType>
  submissionKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  digit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankFeeConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankFeeConnection'] = ResolversParentTypes['BankFeeConnection']
> = {
  bank?: Resolver<ResolversTypes['BankName'], ParentType, ContextType>
  linkedAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['ConnectionStatus'], ParentType, ContextType>
  feeSynopsis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  latestSubmission?: Resolver<Maybe<ResolversTypes['Submission']>, ParentType, ContextType>
  submissions?: Resolver<Maybe<Array<ResolversTypes['Submission']>>, ParentType, ContextType>
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  institutionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  totalNegotiableFees?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  mailInEligibility?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  logoUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankFeeConnectionAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankFeeConnectionAlert'] = ResolversParentTypes['BankFeeConnectionAlert']
> = {
  bankName?: Resolver<ResolversTypes['BankName'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['SubmissionStatus'], ParentType, ContextType>
  linkedAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  negotiationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankFeeNegotiationAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankFeeNegotiationAlert'] = ResolversParentTypes['BankFeeNegotiationAlert']
> = {
  alertData?: Resolver<
    Maybe<Array<ResolversTypes['BankFeeConnectionAlert']>>,
    ParentType,
    ContextType
  >
  type?: Resolver<ResolversTypes['BankFeeNegotiationAlertType'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankFeeNegotiationResultsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankFeeNegotiationResults'] = ResolversParentTypes['BankFeeNegotiationResults']
> = {
  totalRefundedFees?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankFeeSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankFeeSummary'] = ResolversParentTypes['BankFeeSummary']
> = {
  totalNegotiableFees?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  totalReimbursedFees?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  totalNegotiatedFees?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  coffeeCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  feesFound?: Resolver<ResolversTypes['FeeStatusSummary'], ParentType, ContextType>
  linkedAccounts?: Resolver<Array<ResolversTypes['BankFeeConnection']>, ParentType, ContextType>
  lastSync?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankMetadataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankMetadata'] = ResolversParentTypes['BankMetadata']
> = {
  totals?: Resolver<Maybe<ResolversTypes['BankMetadataTotals']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankMetadataTotalsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankMetadataTotals'] = ResolversParentTypes['BankMetadataTotals']
> = {
  oak?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  royalOak?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankStatementResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankStatement'] = ResolversParentTypes['BankStatement']
> = {
  type?: Resolver<ResolversTypes['BankStatementType'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  year?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  month?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankTransactionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankTransaction'] = ResolversParentTypes['BankTransaction']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  settledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  voidedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  status?: Resolver<ResolversTypes['BankTransactionStatus'], ParentType, ContextType>
  tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  bankCard?: Resolver<Maybe<ResolversTypes['BankCard']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  typeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['BankTransactionType'], ParentType, ContextType>
  nachaCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankTransactionConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankTransactionConnection'] = ResolversParentTypes['BankTransactionConnection']
> = {
  edges?: Resolver<Array<Maybe<ResolversTypes['BankTransactionEdge']>>, ParentType, ContextType>
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BankTransactionEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BankTransactionEdge'] = ResolversParentTypes['BankTransactionEdge']
> = {
  node?: Resolver<Maybe<ResolversTypes['BankTransaction']>, ParentType, ContextType>
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BasePortfolioResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BasePortfolio'] = ResolversParentTypes['BasePortfolio']
> = {
  __resolveType: TypeResolveFn<'Portfolio' | 'SelfDirectedPortfolio', ParentType, ContextType>
  accountAllocation?: Resolver<ResolversTypes['PortfolioAllocation'], ParentType, ContextType>
  cashOwed?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  currentAllocationPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  currentBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  currentBalanceWithPending?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  customizationLevel?: Resolver<
    Maybe<ResolversTypes['PortfolioCustomizationLevel']>,
    ParentType,
    ContextType
  >
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  pendingBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  portfolioSecurities?: Resolver<
    Maybe<Array<ResolversTypes['PortfolioSecurity']>>,
    ParentType,
    ContextType
  >
  portfolioSecurityAllocations?: Resolver<
    Maybe<Array<ResolversTypes['PortfolioSecurityAllocation']>>,
    ParentType,
    ContextType
  >
  yearToDateReturn?: Resolver<Maybe<ResolversTypes['MarketReturn']>, ParentType, ContextType>
}

export type BatchAddTierSubscriptionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BatchAddTierSubscriptions'] = ResolversParentTypes['BatchAddTierSubscriptions']
> = {
  addedIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>
  unaddedIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BatchAddTierSubscriptionsResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BatchAddTierSubscriptionsResult'] = ResolversParentTypes['BatchAddTierSubscriptionsResult']
> = {
  __resolveType: TypeResolveFn<
    'BatchAddTierSubscriptions' | 'InvalidTier' | 'InvalidTierPrice',
    ParentType,
    ContextType
  >
}

export type BeneficiaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Beneficiary'] = ResolversParentTypes['Beneficiary']
> = {
  addresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['Address']>>>, ParentType, ContextType>
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  custodianId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  custodianNickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  dateOfBirth?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  deactivatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  email?: Resolver<Maybe<ResolversTypes['Email']>, ParentType, ContextType>
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  phoneNumbers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Phone']>>>, ParentType, ContextType>
  ssnPresent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  investmentAccount?: Resolver<Maybe<ResolversTypes['InvestmentAccount']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BeneficiaryAccountExistsExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BeneficiaryAccountExistsException'] = ResolversParentTypes['BeneficiaryAccountExistsException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BeneficiaryExceedsAgeLimitExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BeneficiaryExceedsAgeLimitException'] = ResolversParentTypes['BeneficiaryExceedsAgeLimitException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BeneficiaryNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BeneficiaryNotFoundException'] = ResolversParentTypes['BeneficiaryNotFoundException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BeneficiaryRequestedLaterAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BeneficiaryRequestedLaterAlert'] = ResolversParentTypes['BeneficiaryRequestedLaterAlert']
> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BigCurrencyAmountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BigCurrencyAmount'] = ResolversParentTypes['BigCurrencyAmount']
> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>
  value?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface BigDecimalScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['BigDecimal'], any> {
  name: 'BigDecimal'
}

export type BillingCycleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BillingCycle'] = ResolversParentTypes['BillingCycle']
> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  amountCollected?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  amountOwed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  credits?: Resolver<
    Array<Maybe<ResolversTypes['Credit']>>,
    ParentType,
    ContextType,
    RequireFields<BillingCycleCreditsArgs, never>
  >
  endDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  extension?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  fees?: Resolver<
    Array<Maybe<ResolversTypes['Fee']>>,
    ParentType,
    ContextType,
    RequireFields<BillingCycleFeesArgs, never>
  >
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  invoiceDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  startDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['BillingCycleState'], ParentType, ContextType>
  tierSubscriptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  tierSubscription?: Resolver<Maybe<ResolversTypes['TierSubscription']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BillingProfileNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BillingProfileNotFoundException'] = ResolversParentTypes['BillingProfileNotFoundException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BillNegotiationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BillNegotiation'] = ResolversParentTypes['BillNegotiation']
> = {
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  sendDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  serviceName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  logoUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  negotiationStatus?: Resolver<ResolversTypes['MailInNegotiationStatus'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BillNegotiationSubmitResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BillNegotiationSubmitResult'] = ResolversParentTypes['BillNegotiationSubmitResult']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BlockDeviceResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BlockDeviceResult'] = ResolversParentTypes['BlockDeviceResult']
> = {
  __resolveType: TypeResolveFn<'Device' | 'DeviceNotFoundException', ParentType, ContextType>
}

export type BlockedEmailDomainExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BlockedEmailDomainException'] = ResolversParentTypes['BlockedEmailDomainException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BriefInsuranceSectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BriefInsuranceSection'] = ResolversParentTypes['BriefInsuranceSection']
> = {
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  insuranceType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  recommendType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BundleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Bundle'] = ResolversParentTypes['Bundle']
> = {
  iconPath?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  products?: Resolver<Array<ResolversTypes['PresentableProduct']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CancelCheckPaymentResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CancelCheckPaymentResult'] = ResolversParentTypes['CancelCheckPaymentResult']
> = {
  __resolveType: TypeResolveFn<
    'CheckPayment' | 'ResourceNotFoundError' | 'UnableToCancelCheckError' | 'AuthorizationError',
    ParentType,
    ContextType
  >
}

export type CancelInvestmentAccountClosureRequestResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CancelInvestmentAccountClosureRequestResult'] = ResolversParentTypes['CancelInvestmentAccountClosureRequestResult']
> = {
  __resolveType: TypeResolveFn<
    | 'AccountClosedException'
    | 'AccountNotFoundException'
    | 'ClosureRequestDoesNotExistException'
    | 'InvestmentAccount',
    ParentType,
    ContextType
  >
}

export type CancelInvestmentPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CancelInvestmentPayload'] = ResolversParentTypes['CancelInvestmentPayload']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CancelInvestmentResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CancelInvestmentResult'] = ResolversParentTypes['CancelInvestmentResult']
> = {
  __resolveType: TypeResolveFn<
    'CancelInvestmentPayload' | 'InvestmentNotFoundException' | 'InvestmentUncancellableException',
    ParentType,
    ContextType
  >
}

export type CancelRecurringTransferResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CancelRecurringTransferResult'] = ResolversParentTypes['CancelRecurringTransferResult']
> = {
  __resolveType: TypeResolveFn<
    'RecurringTransfer' | 'VersionMismatchException',
    ParentType,
    ContextType
  >
}

export type CancelTransferPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CancelTransferPayload'] = ResolversParentTypes['CancelTransferPayload']
> = {
  transactionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CardDeliveryStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CardDeliveryStatus'] = ResolversParentTypes['CardDeliveryStatus']
> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  picNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  referenceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PackageStatus'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface CardNumberMaskedScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['CardNumberMasked'], any> {
  name: 'CardNumberMasked'
}

export type CarouselOfferResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CarouselOffer'] = ResolversParentTypes['CarouselOffer']
> = {
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  fastQuote?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  logo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  offerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  ownerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  tip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ChallengePointsEarnedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ChallengePointsEarned'] = ResolversParentTypes['ChallengePointsEarned']
> = {
  challengeID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  details?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  earningProgress?: Resolver<ResolversTypes['DiscreteMilestoneProgress'], ParentType, ContextType>
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ChangeOutsideContributionAmountResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ChangeOutsideContributionAmountResult'] = ResolversParentTypes['ChangeOutsideContributionAmountResult']
> = {
  __resolveType: TypeResolveFn<
    | 'ContributionAmountAboveThresholdError'
    | 'ContributionAmountBelowThresholdError'
    | 'OutsideContributionCheckoutCart',
    ParentType,
    ContextType
  >
}

export type ChangePasswordResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ChangePasswordResult'] = ResolversParentTypes['ChangePasswordResult']
> = {
  __resolveType: TypeResolveFn<
    | 'ChangePasswordSuccess'
    | 'IncorrectOldPasswordException'
    | 'InvalidPasswordException'
    | 'IncorrectSecurityAnswerException',
    ParentType,
    ContextType
  >
}

export type ChangePasswordSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ChangePasswordSuccess'] = ResolversParentTypes['ChangePasswordSuccess']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ChangeSecuritySymbolResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ChangeSecuritySymbolResult'] = ResolversParentTypes['ChangeSecuritySymbolResult']
> = {
  __resolveType: TypeResolveFn<
    'Fund' | 'Stock' | 'InvalidSecurityForSymbolChangeError' | 'InvalidSymbolForSymbolChangeError',
    ParentType,
    ContextType
  >
}

export type CheckPaymentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CheckPayment'] = ResolversParentTypes['CheckPayment']
> = {
  fromAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  recipientName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  recipientAddress?: Resolver<ResolversTypes['CheckPaymentAddress'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  memo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  estimatedArrivalAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['CheckPaymentStatus'], ParentType, ContextType>
  checkNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  trackingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  failedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  failureReason?: Resolver<
    Maybe<ResolversTypes['CheckPaymentFailureReason']>,
    ParentType,
    ContextType
  >
  canceledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckPaymentAddressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CheckPaymentAddress'] = ResolversParentTypes['CheckPaymentAddress']
> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  street1?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  zipCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckPaymentConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CheckPaymentConnection'] = ResolversParentTypes['CheckPaymentConnection']
> = {
  edges?: Resolver<Array<ResolversTypes['CheckPaymentEdge']>, ParentType, ContextType>
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckPaymentEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CheckPaymentEdge'] = ResolversParentTypes['CheckPaymentEdge']
> = {
  node?: Resolver<ResolversTypes['CheckPayment'], ParentType, ContextType>
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckPaymentRecipientResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CheckPaymentRecipient'] = ResolversParentTypes['CheckPaymentRecipient']
> = {
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  businessName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckPaymentRecipientAddressTypeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CheckPaymentRecipientAddressType'] = ResolversParentTypes['CheckPaymentRecipientAddressType']
> = {
  recipient?: Resolver<ResolversTypes['CheckPaymentRecipient'], ParentType, ContextType>
  recipientAddress?: Resolver<ResolversTypes['CheckPaymentAddress'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CloseAccountReasonResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CloseAccountReason'] = ResolversParentTypes['CloseAccountReason']
> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CloseBankAccountResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CloseBankAccountResult'] = ResolversParentTypes['CloseBankAccountResult']
> = {
  __resolveType: TypeResolveFn<'BankAccount' | 'BankAccountNotFoundError', ParentType, ContextType>
}

export type CloseInvestmentAccountResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CloseInvestmentAccountResult'] = ResolversParentTypes['CloseInvestmentAccountResult']
> = {
  __resolveType: TypeResolveFn<
    | 'AccountNotFoundException'
    | 'InvestmentAccount'
    | 'InvestmentAccountAlreadyClosed'
    | 'InvestmentAccountClosureInProgress'
    | 'NonBasicAccountOpenException',
    ParentType,
    ContextType
  >
}

export type CloseUserAccountResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CloseUserAccountResult'] = ResolversParentTypes['CloseUserAccountResult']
> = {
  __resolveType: TypeResolveFn<
    'OpenAccountsException' | 'UserNotFoundException' | 'User_v2',
    ParentType,
    ContextType
  >
}

export type ClosureRequestDoesNotExistExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ClosureRequestDoesNotExistException'] = ResolversParentTypes['ClosureRequestDoesNotExistException']
> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ClosureRequestExistsExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ClosureRequestExistsException'] = ResolversParentTypes['ClosureRequestExistsException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CohortEligibilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CohortEligibility'] = ResolversParentTypes['CohortEligibility']
> = {
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['CohortEligibilityScope'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CollapsedLifeRecommendationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CollapsedLifeRecommendation'] = ResolversParentTypes['CollapsedLifeRecommendation']
> = {
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  recommendedCoverage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CombinedPerformanceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CombinedPerformance'] = ResolversParentTypes['CombinedPerformance']
> = {
  accountValues?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['AccountValue']>>>,
    ParentType,
    ContextType
  >
  bondValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  cryptoValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  currentBalance?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  marketChange?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  marketChangePercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  marketChangePercentWithoutFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  marketChangeWithoutFees?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >
  netInvestments?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  stockValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  totalInvested?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  totalInvestedWithPending?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CompleteCheckDepositPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CompleteCheckDepositPayload'] = ResolversParentTypes['CompleteCheckDepositPayload']
> = {
  sessionToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CompletedQuizResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CompletedQuiz'] = ResolversParentTypes['CompletedQuiz']
> = {
  communityAvgPercents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  correctQuestions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  totalQuestions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  userScorePercents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CondensedSocialCopiesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CondensedSocialCopies'] = ResolversParentTypes['CondensedSocialCopies']
> = {
  sms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  twitter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  all?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ConfigureSplitDepositDirectDepositIntentGenericErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConfigureSplitDepositDirectDepositIntentGenericError'] = ResolversParentTypes['ConfigureSplitDepositDirectDepositIntentGenericError']
> = {
  requestId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ConfigureSplitDepositDirectDepositIntentPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConfigureSplitDepositDirectDepositIntentPayload'] = ResolversParentTypes['ConfigureSplitDepositDirectDepositIntentPayload']
> = {
  intent?: Resolver<
    ResolversTypes['SplitDepositDirectDepositIntentSetting'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ConfigureSplitDepositDirectDepositIntentSettingResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConfigureSplitDepositDirectDepositIntentSettingResult'] = ResolversParentTypes['ConfigureSplitDepositDirectDepositIntentSettingResult']
> = {
  __resolveType: TypeResolveFn<
    | 'ConfigureSplitDepositDirectDepositIntentPayload'
    | 'ConfigureSplitDepositDirectDepositIntentGenericError',
    ParentType,
    ContextType
  >
}

export type ConfigureSplitDepositDirectDepositSettingGenericErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConfigureSplitDepositDirectDepositSettingGenericError'] = ResolversParentTypes['ConfigureSplitDepositDirectDepositSettingGenericError']
> = {
  requestId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ConfigureSplitDepositDirectDepositSettingPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConfigureSplitDepositDirectDepositSettingPayload'] = ResolversParentTypes['ConfigureSplitDepositDirectDepositSettingPayload']
> = {
  setting?: Resolver<ResolversTypes['SplitDepositDirectDepositSetting'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ConfigureSplitDepositDirectDepositSettingResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConfigureSplitDepositDirectDepositSettingResult'] = ResolversParentTypes['ConfigureSplitDepositDirectDepositSettingResult']
> = {
  __resolveType: TypeResolveFn<
    | 'ConfigureSplitDepositDirectDepositSettingPayload'
    | 'ConfigureSplitDepositDirectDepositSettingGenericError',
    ParentType,
    ContextType
  >
}

export type ConnectAchAccountResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConnectACHAccountResult'] = ResolversParentTypes['ConnectACHAccountResult']
> = {
  __resolveType: TypeResolveFn<
    'InstitutionNotSupportedError' | 'ConnectACHAccountSucceeded',
    ParentType,
    ContextType
  >
}

export type ConnectAchAccountSucceededResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConnectACHAccountSucceeded'] = ResolversParentTypes['ConnectACHAccountSucceeded']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContactCategoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContactCategory'] = ResolversParentTypes['ContactCategory']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  subcategories?: Resolver<
    Maybe<Array<ResolversTypes['ContactSubcategory']>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContactFaqResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContactFaq'] = ResolversParentTypes['ContactFaq']
> = {
  answer?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  href?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContactFormAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContactFormAlert'] = ResolversParentTypes['ContactFormAlert']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContactSubcategoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContactSubcategory'] = ResolversParentTypes['ContactSubcategory']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  faqs?: Resolver<Array<ResolversTypes['ContactFaq']>, ParentType, ContextType>
  chatEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  emailEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  phoneEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  message?: Resolver<Maybe<ResolversTypes['SubcategoryMessage']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContentPreviewConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContentPreviewConnection'] = ResolversParentTypes['ContentPreviewConnection']
> = {
  edges?: Resolver<Array<ResolversTypes['ContentPreviewEdge']>, ParentType, ContextType>
  pageInfo?: Resolver<ResolversTypes['LearnPageInfo'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContentPreviewEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContentPreviewEdge'] = ResolversParentTypes['ContentPreviewEdge']
> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  node?: Resolver<ResolversTypes['LearnContentPreview'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContributionAbilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContributionAbility'] = ResolversParentTypes['ContributionAbility']
> = {
  canContribute?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  planLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  remaining?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  taxYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  yearToDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContributionAbilityByYearResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContributionAbilityByYear'] = ResolversParentTypes['ContributionAbilityByYear']
> = {
  contributionAbilities?: Resolver<
    Maybe<Array<ResolversTypes['ContributionAbility']>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContributionActionRequiredErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContributionActionRequiredError'] = ResolversParentTypes['ContributionActionRequiredError']
> = {
  paymentIntentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  redirectUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  requiredAction?: Resolver<ResolversTypes['ContributionRequiredAction'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContributionAmountAboveThresholdErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContributionAmountAboveThresholdError'] = ResolversParentTypes['ContributionAmountAboveThresholdError']
> = {
  maximumThresholdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContributionAmountBelowThresholdErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContributionAmountBelowThresholdError'] = ResolversParentTypes['ContributionAmountBelowThresholdError']
> = {
  minimumThresholdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContributionCardDeclinedErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContributionCardDeclinedError'] = ResolversParentTypes['ContributionCardDeclinedError']
> = {
  paymentIntentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContributionHistoryItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContributionHistoryItem'] = ResolversParentTypes['ContributionHistoryItem']
> = {
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ContributionInvalidOwnerEmailErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContributionInvalidOwnerEmailError'] = ResolversParentTypes['ContributionInvalidOwnerEmailError']
> = {
  providedEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreAccountAlreadyExistsExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreAccountAlreadyExistsException'] = ResolversParentTypes['CoreAccountAlreadyExistsException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreAccountClosedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreAccountClosedException'] = ResolversParentTypes['CoreAccountClosedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreAchSubscriptionFeeItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreACHSubscriptionFeeItem'] = ResolversParentTypes['CoreACHSubscriptionFeeItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreAdjustmentItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreAdjustmentItem'] = ResolversParentTypes['CoreAdjustmentItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreCashForwardItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreCashForwardItem'] = ResolversParentTypes['CoreCashForwardItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  relatedMonth?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreCollectionItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreCollectionItem'] = ResolversParentTypes['CoreCollectionItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreDividendsItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreDividendsItem'] = ResolversParentTypes['CoreDividendsItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  etfCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  etfTicker?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreEmployeeCreditItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreEmployeeCreditItem'] = ResolversParentTypes['CoreEmployeeCreditItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreFeeInvestmentItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreFeeInvestmentItem'] = ResolversParentTypes['CoreFeeInvestmentItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreFoundMoneyRewardItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreFoundMoneyRewardItem'] = ResolversParentTypes['CoreFoundMoneyRewardItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  partnerLogoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreGiftCardCreditRedemptionItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreGiftCardCreditRedemptionItem'] = ResolversParentTypes['CoreGiftCardCreditRedemptionItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreHoldingsTransferInItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreHoldingsTransferInItem'] = ResolversParentTypes['CoreHoldingsTransferInItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreInvestmentItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreInvestmentItem'] = ResolversParentTypes['CoreInvestmentItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  isCombinedInvestment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreLocalFoundMoneyItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreLocalFoundMoneyItem'] = ResolversParentTypes['CoreLocalFoundMoneyItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  partnerLogoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CorePartnerRewardItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CorePartnerRewardItem'] = ResolversParentTypes['CorePartnerRewardItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  partnerLogoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreRebalanceItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreRebalanceItem'] = ResolversParentTypes['CoreRebalanceItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreReferralRewardItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreReferralRewardItem'] = ResolversParentTypes['CoreReferralRewardItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreRoundUpsItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreRoundUpsItem'] = ResolversParentTypes['CoreRoundUpsItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  isCombinedInvestment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  type?: Resolver<ResolversTypes['RoundUpType'], ParentType, ContextType>
  initialAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  multiplier?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  transactionAmount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoreWithdrawalItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoreWithdrawalItem'] = ResolversParentTypes['CoreWithdrawalItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CourseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Course'] = ResolversParentTypes['Course']
> = {
  authors?: Resolver<Array<ResolversTypes['LearnAuthor']>, ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  lessons?: Resolver<Array<ResolversTypes['Lesson']>, ParentType, ContextType>
  metadata?: Resolver<ResolversTypes['LearnMetadata'], ParentType, ContextType>
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  tags?: Resolver<Array<ResolversTypes['LearnTag']>, ParentType, ContextType>
  theme?: Resolver<ResolversTypes['CourseTheme'], ParentType, ContextType>
  tier?: Resolver<ResolversTypes['LearnTier'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  topics?: Resolver<Array<ResolversTypes['LearnTopic']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoursePreviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoursePreview'] = ResolversParentTypes['CoursePreview']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>
  courseTheme?: Resolver<ResolversTypes['CourseTheme'], ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  numberOfLessons?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  progress?: Resolver<Maybe<ResolversTypes['LearnProgress']>, ParentType, ContextType>
  relatedQuizProgress?: Resolver<Maybe<ResolversTypes['LearnProgress']>, ParentType, ContextType>
  tierName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoursePreviewLockedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoursePreviewLocked'] = ResolversParentTypes['CoursePreviewLocked']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  numberOfLessons?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CourseThemeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CourseTheme'] = ResolversParentTypes['CourseTheme']
> = {
  __resolveType: TypeResolveFn<'LearnThemeLiteral', ParentType, ContextType>
}

export type CoverageAskResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoverageAsk'] = ResolversParentTypes['CoverageAsk']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  noCta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  yesCta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoverageCalculatorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoverageCalculator'] = ResolversParentTypes['CoverageCalculator']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  headline?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  recommendedCoverage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoverageGrowResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoverageGrow'] = ResolversParentTypes['CoverageGrow']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoverageKnownResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoverageKnown'] = ResolversParentTypes['CoverageKnown']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  educationSection?: Resolver<ResolversTypes['EducationSection'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  subtitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoverageShopResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoverageShop'] = ResolversParentTypes['CoverageShop']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  legalDisclaimer?: Resolver<ResolversTypes['Disclaimer'], ParentType, ContextType>
  modals?: Resolver<Array<ResolversTypes['Modal']>, ParentType, ContextType>
  partnerDisclaimer?: Resolver<ResolversTypes['Disclaimer'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  widgets?: Resolver<Array<ResolversTypes['CoverageShopWidget']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CoverageShopWidgetResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoverageShopWidget'] = ResolversParentTypes['CoverageShopWidget']
> = {
  __resolveType: TypeResolveFn<
    'FeaturedOffers' | 'InsuranceCarousel' | 'PartnerChoices',
    ParentType,
    ContextType
  >
}

export type CoverageUnknownResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CoverageUnknown'] = ResolversParentTypes['CoverageUnknown']
> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  educationSection?: Resolver<ResolversTypes['EducationSection'], ParentType, ContextType>
  icon?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  subtitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateAccountPointsRuleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateAccountPointsRuleResult'] = ResolversParentTypes['CreateAccountPointsRuleResult']
> = {
  __resolveType: TypeResolveFn<
    'RecordAlreadyExistsError' | 'RecordDoesNotExistError' | 'AccountPointsRule',
    ParentType,
    ContextType
  >
}

export type CreateAuthProfileResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateAuthProfileResult'] = ResolversParentTypes['CreateAuthProfileResult']
> = {
  __resolveType: TypeResolveFn<
    'AuthProfile' | 'AuthProfileAlreadyExistsException',
    ParentType,
    ContextType
  >
}

export type CreateBankAccountPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateBankAccountPayload'] = ResolversParentTypes['CreateBankAccountPayload']
> = {
  bankAccount?: Resolver<Maybe<ResolversTypes['BankAccount']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateBeneficiaryResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateBeneficiaryResult'] = ResolversParentTypes['CreateBeneficiaryResult']
> = {
  __resolveType: TypeResolveFn<
    | 'Beneficiary'
    | 'BeneficiaryExceedsAgeLimitException'
    | 'InternalErrorException'
    | 'InvalidDateOfBirthException'
    | 'InvalidFirstNameException'
    | 'InvalidLastNameException',
    ParentType,
    ContextType
  >
}

export type CreateDirectDepositLinkInfoFailureResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateDirectDepositLinkInfoFailure'] = ResolversParentTypes['CreateDirectDepositLinkInfoFailure']
> = {
  failureMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateDirectDepositLinkInfoPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateDirectDepositLinkInfoPayload'] = ResolversParentTypes['CreateDirectDepositLinkInfoPayload']
> = {
  results?: Resolver<ResolversTypes['CreatePinwheelLinkToken'], ParentType, ContextType>
  vendor?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateDirectDepositLinkInfoSwitchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateDirectDepositLinkInfoSwitch'] = ResolversParentTypes['CreateDirectDepositLinkInfoSwitch']
> = {
  __resolveType: TypeResolveFn<
    'CreateDirectDepositLinkInfoFailure' | 'CreateDirectDepositLinkInfoPayload',
    ParentType,
    ContextType
  >
}

export type CreateDocumentUploadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateDocumentUpload'] = ResolversParentTypes['CreateDocumentUpload']
> = {
  expiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  uploadUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  requestedDocumentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateInvestmentAccountResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateInvestmentAccountResponse'] = ResolversParentTypes['CreateInvestmentAccountResponse']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  userUuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  iraType?: Resolver<ResolversTypes['InvestmentAccountTypes'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateJobAlertResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateJobAlertResult'] = ResolversParentTypes['CreateJobAlertResult']
> = {
  __resolveType: TypeResolveFn<'JobAlert', ParentType, ContextType>
}

export type CreateMilestoneAccountLevelDefinitionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateMilestoneAccountLevelDefinitionResult'] = ResolversParentTypes['CreateMilestoneAccountLevelDefinitionResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneAccountLevelDefinition' | 'RecordAlreadyExistsError',
    ParentType,
    ContextType
  >
}

export type CreateMilestoneAchievementActionRuleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateMilestoneAchievementActionRuleResult'] = ResolversParentTypes['CreateMilestoneAchievementActionRuleResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneAchievementActionRule' | 'RecordAlreadyExistsError' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type CreateMilestoneChallengeDefinitionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateMilestoneChallengeDefinitionResult'] = ResolversParentTypes['CreateMilestoneChallengeDefinitionResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneChallengeDefinition' | 'RecordAlreadyExistsError' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type CreateMilestoneChallengePointsRuleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateMilestoneChallengePointsRuleResult'] = ResolversParentTypes['CreateMilestoneChallengePointsRuleResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneChallengePointsRule' | 'RecordAlreadyExistsError' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type CreateMilestoneDefinitionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateMilestoneDefinitionResult'] = ResolversParentTypes['CreateMilestoneDefinitionResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneDefinition' | 'RecordAlreadyExistsError' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type CreateMilestoneGroupAchievementActionRuleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateMilestoneGroupAchievementActionRuleResult'] = ResolversParentTypes['CreateMilestoneGroupAchievementActionRuleResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneGroupAchievementActionRule' | 'RecordAlreadyExistsError' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type CreateMilestoneGroupDefinitionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateMilestoneGroupDefinitionResult'] = ResolversParentTypes['CreateMilestoneGroupDefinitionResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneGroupDefinition' | 'RecordAlreadyExistsError' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type CreateMilestoneHubDefinitionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateMilestoneHubDefinitionResult'] = ResolversParentTypes['CreateMilestoneHubDefinitionResult']
> = {
  __resolveType: TypeResolveFn<
    'RecordAlreadyExistsError' | 'RecordDoesNotExistError' | 'MilestoneHubDefinition',
    ParentType,
    ContextType
  >
}

export type CreateMilestoneRuleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateMilestoneRuleResult'] = ResolversParentTypes['CreateMilestoneRuleResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneRule' | 'RecordAlreadyExistsError',
    ParentType,
    ContextType
  >
}

export type CreateOfferResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateOfferResult'] = ResolversParentTypes['CreateOfferResult']
> = {
  __resolveType: TypeResolveFn<'Offer', ParentType, ContextType>
}

export type CreateOutsideContributionCheckoutCartResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateOutsideContributionCheckoutCartResult'] = ResolversParentTypes['CreateOutsideContributionCheckoutCartResult']
> = {
  __resolveType: TypeResolveFn<
    | 'ContributionAmountAboveThresholdError'
    | 'ContributionAmountBelowThresholdError'
    | 'OutsideContributionCheckoutCart',
    ParentType,
    ContextType
  >
}

export type CreateOutsideContributionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateOutsideContributionResult'] = ResolversParentTypes['CreateOutsideContributionResult']
> = {
  __resolveType: TypeResolveFn<
    | 'ContributionActionRequiredError'
    | 'ContributionCardDeclinedError'
    | 'ContributionInvalidOwnerEmailError'
    | 'OutsideContribution',
    ParentType,
    ContextType
  >
}

export type CreatePinwheelLinkTokenResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreatePinwheelLinkToken'] = ResolversParentTypes['CreatePinwheelLinkToken']
> = {
  expires?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  mode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateProspectUserResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateProspectUserResult'] = ResolversParentTypes['CreateProspectUserResult']
> = {
  __resolveType: TypeResolveFn<
    | 'GrowProspect'
    | 'InternalErrorException'
    | 'LaterWaitlistProspect'
    | 'OutsideContributionProspect'
    | 'User_v2',
    ParentType,
    ContextType
  >
}

export type CreateSavingsAccountPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateSavingsAccountPayload'] = ResolversParentTypes['CreateSavingsAccountPayload']
> = {
  bankAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateSavingsAccountResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateSavingsAccountResult'] = ResolversParentTypes['CreateSavingsAccountResult']
> = {
  __resolveType: TypeResolveFn<
    'CreateSavingsAccountPayload' | 'CreateSavingsAccountVerificationError',
    ParentType,
    ContextType
  >
}

export type CreateSavingsAccountVerificationErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateSavingsAccountVerificationError'] = ResolversParentTypes['CreateSavingsAccountVerificationError']
> = {
  notEligibleReasons?: Resolver<
    Array<ResolversTypes['SavingsAccountEligibilityRequirement']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateSubscriptionMigrationResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateSubscriptionMigrationResult'] = ResolversParentTypes['CreateSubscriptionMigrationResult']
> = {
  __resolveType: TypeResolveFn<'SubscriptionMigration', ParentType, ContextType>
}

export type CreateUploadUrlResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateUploadUrlResult'] = ResolversParentTypes['CreateUploadUrlResult']
> = {
  __resolveType: TypeResolveFn<'UploadUrl', ParentType, ContextType>
}

export type CredentialsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Credentials'] = ResolversParentTypes['Credentials']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  email?: Resolver<ResolversTypes['EmailAddress'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreditResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Credit'] = ResolversParentTypes['Credit']
> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  assessedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  billingCycle?: Resolver<ResolversTypes['BillingCycle'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  discountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CtaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Cta'] = ResolversParentTypes['Cta']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  type?: Resolver<ResolversTypes['CtaType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CtaDetailsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CtaDetails'] = ResolversParentTypes['CtaDetails']
> = {
  android?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  ios?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  web?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  buttonUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userMetadata?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  internallyRouted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CurrencyAmountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CurrencyAmount'] = ResolversParentTypes['CurrencyAmount']
> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CurrencyMilestoneProgressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CurrencyMilestoneProgress'] = ResolversParentTypes['CurrencyMilestoneProgress']
> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>
  currentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  targetAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CurrentBankStatementNotProvidedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CurrentBankStatementNotProvided'] = ResolversParentTypes['CurrentBankStatementNotProvided']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CustodianCompanyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CustodianCompany'] = ResolversParentTypes['CustodianCompany']
> = {
  companyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CustomerAgreementRequiredExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CustomerAgreementRequiredException'] = ResolversParentTypes['CustomerAgreementRequiredException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  requiredAcceptanceDocumentTypes?: Resolver<
    Array<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CustomFieldOptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CustomFieldOption'] = ResolversParentTypes['CustomFieldOption']
> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  raw_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  default?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date'
}

export interface DateTimeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime'
}

export type DeactivateBeneficiaryResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeactivateBeneficiaryResult'] = ResolversParentTypes['DeactivateBeneficiaryResult']
> = {
  __resolveType: TypeResolveFn<
    'Beneficiary' | 'BeneficiaryNotFoundException' | 'InternalErrorException',
    ParentType,
    ContextType
  >
}

export type DeactivateSecurityFailedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeactivateSecurityFailed'] = ResolversParentTypes['DeactivateSecurityFailed']
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DeactivateSecurityResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeactivateSecurityResult'] = ResolversParentTypes['DeactivateSecurityResult']
> = {
  __resolveType: TypeResolveFn<
    'Fund' | 'Stock' | 'DeactivateSecurityFailed',
    ParentType,
    ContextType
  >
}

export type DeactivateTierSubscriptionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeactivateTierSubscriptionResult'] = ResolversParentTypes['DeactivateTierSubscriptionResult']
> = {
  __resolveType: TypeResolveFn<
    'TierSubscription' | 'TierSubscriptionAlreadyDeactivated',
    ParentType,
    ContextType
  >
}

export type DeleteExpiredBankCardOrderCardTierNotFoundErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteExpiredBankCardOrderCardTierNotFoundError'] = ResolversParentTypes['DeleteExpiredBankCardOrderCardTierNotFoundError']
> = {
  failureMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DeleteExpiredBankCardOrderNotExpiredErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteExpiredBankCardOrderNotExpiredError'] = ResolversParentTypes['DeleteExpiredBankCardOrderNotExpiredError']
> = {
  expiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DeleteExpiredBankCardOrderNotFoundErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteExpiredBankCardOrderNotFoundError'] = ResolversParentTypes['DeleteExpiredBankCardOrderNotFoundError']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DeleteExpiredBankCardOrderResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteExpiredBankCardOrderResult'] = ResolversParentTypes['DeleteExpiredBankCardOrderResult']
> = {
  __resolveType: TypeResolveFn<
    | 'BankCardOrder'
    | 'DeleteExpiredBankCardOrderNotFoundError'
    | 'DeleteExpiredBankCardOrderNotExpiredError'
    | 'DeleteExpiredBankCardOrderCardTierNotFoundError',
    ParentType,
    ContextType
  >
}

export type DepositRiskFactorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DepositRiskFactor'] = ResolversParentTypes['DepositRiskFactor']
> = {
  fields?: Resolver<Array<ResolversTypes['DepositField']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['RiskStatus'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DeregisterAuthenticatorResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeregisterAuthenticatorResult'] = ResolversParentTypes['DeregisterAuthenticatorResult']
> = {
  __resolveType: TypeResolveFn<
    'PhoneAuthenticator' | 'EmailAuthenticator' | 'AuthenticatorNotFoundException',
    ParentType,
    ContextType
  >
}

export type DesignLibraryIconResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DesignLibraryIcon'] = ResolversParentTypes['DesignLibraryIcon']
> = {
  icon?: Resolver<ResolversTypes['IconType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DestinationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Destination'] = ResolversParentTypes['Destination']
> = {
  deepLink?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  labelKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DeviceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Device'] = ResolversParentTypes['Device']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  lastLoginAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  hasActiveSession?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  isBlocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  firstLoginAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  appVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userAgent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  blockTrigger?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DeviceBlockedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeviceBlockedException'] = ResolversParentTypes['DeviceBlockedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DeviceNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeviceNotFoundException'] = ResolversParentTypes['DeviceNotFoundException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DirectDepositStateResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DirectDepositState'] = ResolversParentTypes['DirectDepositState']
> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  switchMethod?: Resolver<ResolversTypes['SwitchMethod'], ParentType, ContextType>
  switchState?: Resolver<ResolversTypes['SwitchState'], ParentType, ContextType>
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DirectDepositStatePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DirectDepositStatePayload'] = ResolversParentTypes['DirectDepositStatePayload']
> = {
  state?: Resolver<Maybe<ResolversTypes['DirectDepositState']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DisclaimerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Disclaimer'] = ResolversParentTypes['Disclaimer']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<Maybe<ResolversTypes['Cta']>, ParentType, ContextType>
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DiscreteMilestoneProgressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DiscreteMilestoneProgress'] = ResolversParentTypes['DiscreteMilestoneProgress']
> = {
  currentInt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  targetInt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DistributionAmountsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DistributionAmounts'] = ResolversParentTypes['DistributionAmounts']
> = {
  investment?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  retirement?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  savings?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DividendResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Dividend'] = ResolversParentTypes['Dividend']
> = {
  symbol?: Resolver<ResolversTypes['TickerSymbol'], ParentType, ContextType>
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>
  payableDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>
  recordDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>
  amountPerShare?: Resolver<Maybe<ResolversTypes['BigDecimal']>, ParentType, ContextType>
  frequency?: Resolver<ResolversTypes['DividendFrequency'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DocumentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Document'] = ResolversParentTypes['Document']
> = {
  uploadedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DocumentNotFoundResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DocumentNotFound'] = ResolversParentTypes['DocumentNotFound']
> = {
  documentType?: Resolver<ResolversTypes['AcceptanceDocumentType'], ParentType, ContextType>
  documentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DocumentRequestResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DocumentRequest'] = ResolversParentTypes['DocumentRequest']
> = {
  acceptedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  canceledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  documents?: Resolver<Maybe<Array<ResolversTypes['Document']>>, ParentType, ContextType>
  documentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>
  externalId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  parentRequest?: Resolver<Maybe<ResolversTypes['DocumentRequest']>, ParentType, ContextType>
  parentRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  rejectedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  rejectedNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  rejectedReason?: Resolver<Maybe<ResolversTypes['RejectedReason']>, ParentType, ContextType>
  requestedFileCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  requesterId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  requestKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  reviewerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  status?: Resolver<ResolversTypes['DocumentStatus'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DocumentRequestEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DocumentRequestEdge'] = ResolversParentTypes['DocumentRequestEdge']
> = {
  node?: Resolver<Maybe<ResolversTypes['DocumentRequest']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DocumentRequestsConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DocumentRequestsConnection'] = ResolversParentTypes['DocumentRequestsConnection']
> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['DocumentRequestEdge']>>, ParentType, ContextType>
  pageInfo?: Resolver<ResolversTypes['DocumentRequestsPageInfo'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DocumentRequestsPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DocumentRequestsPageInfo'] = ResolversParentTypes['DocumentRequestsPageInfo']
> = {
  hasNext?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DocumentUploadsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DocumentUploads'] = ResolversParentTypes['DocumentUploads']
> = {
  uploadDocuments?: Resolver<Array<ResolversTypes['LegacyUploadDocument']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DuplicateActionErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DuplicateActionError'] = ResolversParentTypes['DuplicateActionError']
> = {
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EarlyAccountStateRegulationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarlyAccountStateRegulation'] = ResolversParentTypes['EarlyAccountStateRegulation']
> = {
  accountType?: Resolver<ResolversTypes['EarlyInvestmentAccountType'], ParentType, ContextType>
  defaultAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  maxAge?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  minAge?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  stateCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EarlyAccountStateRegulationResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarlyAccountStateRegulationResult'] = ResolversParentTypes['EarlyAccountStateRegulationResult']
> = {
  __resolveType: TypeResolveFn<
    | 'EarlyAccountStateRegulation'
    | 'InternalErrorException'
    | 'InvalidStateException'
    | 'UserNotFoundException',
    ParentType,
    ContextType
  >
}

export type EarlyAccountTransferInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarlyAccountTransferInfo'] = ResolversParentTypes['EarlyAccountTransferInfo']
> = {
  stateCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  terminationAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  terminationDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EarlyDividendsItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarlyDividendsItem'] = ResolversParentTypes['EarlyDividendsItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  etfCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  etfTicker?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EarlyFeeInvestmentItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarlyFeeInvestmentItem'] = ResolversParentTypes['EarlyFeeInvestmentItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EarlyGiftItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarlyGiftItem'] = ResolversParentTypes['EarlyGiftItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  noteAuthor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EarlyInvestmentItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarlyInvestmentItem'] = ResolversParentTypes['EarlyInvestmentItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EarlyWithdrawalItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarlyWithdrawalItem'] = ResolversParentTypes['EarlyWithdrawalItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EarnCtaRecordResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarnCTARecord'] = ResolversParentTypes['EarnCTARecord']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  partnerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  ctaDates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Date']>>>, ParentType, ContextType>
  devicePlatform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EarnOfferResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarnOffer'] = ResolversParentTypes['EarnOffer']
> = {
  affiliateCategoryList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  affiliateCategoryType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  backgroundColorHex?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  backgroundImageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  badgeCategory?: Resolver<Maybe<ResolversTypes['BadgeCategory']>, ParentType, ContextType>
  campaignDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  campaignOfferId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  colorBackgroundLogoImageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  colorImageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  ctaDetails?: Resolver<ResolversTypes['EarnOfferCtaDetails'], ParentType, ContextType>
  dealType?: Resolver<Maybe<ResolversTypes['DealType']>, ParentType, ContextType>
  desktopBackgroundImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  details?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  devicePlatforms?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  displayBody?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  displayEndDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  displayStartDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  displaySubtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  displayTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  exclusions?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  favoriteRank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  featuredCategoryOffer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  featuredCategoryOfferRank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  incentiveSummary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  isFavorite?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  keyphraseCategoryNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  merchantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  ownerDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  ownerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  promoted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  promotionRank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  termsAndConditionsUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  visibilityEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  visibilityStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  webviewEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EarnOfferCtaDetailsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarnOfferCtaDetails'] = ResolversParentTypes['EarnOfferCtaDetails']
> = {
  android?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  buttonUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  chromeExt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  internallyRouted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  ios?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  notificationTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  notificationUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  repeatTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userMetadata?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  web?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EarnOfferQueryPageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarnOfferQueryPage'] = ResolversParentTypes['EarnOfferQueryPage']
> = {
  earnOffers?: Resolver<Array<ResolversTypes['EarnOffer']>, ParentType, ContextType>
  pageInfo?: Resolver<ResolversTypes['EarnPageInfo'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EarnPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EarnPageInfo'] = ResolversParentTypes['EarnPageInfo']
> = {
  endCursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EditSecurityQuestionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EditSecurityQuestionResult'] = ResolversParentTypes['EditSecurityQuestionResult']
> = {
  __resolveType: TypeResolveFn<
    'SecurityQuestion' | 'InvalidSecurityQuestionException',
    ParentType,
    ContextType
  >
}

export type EducationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Education'] = ResolversParentTypes['Education']
> = {
  articles?: Resolver<Array<ResolversTypes['Article']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EducationSectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EducationSection'] = ResolversParentTypes['EducationSection']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EducationTipResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EducationTip'] = ResolversParentTypes['EducationTip']
> = {
  detailsKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  summaryKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EligibilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Eligibility'] = ResolversParentTypes['Eligibility']
> = {
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface EmailScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Email'], any> {
  name: 'Email'
}

export interface EmailAddressScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['EmailAddress'], any> {
  name: 'EmailAddress'
}

export type EmailAddressValidationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EmailAddressValidation'] = ResolversParentTypes['EmailAddressValidation']
> = {
  email?: Resolver<ResolversTypes['EmailAddress'], ParentType, ContextType>
  deliverable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  credentialsExist?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  possibleTypo?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  suggestion?: Resolver<Maybe<ResolversTypes['EmailAddress']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EmailAuthChallengeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EmailAuthChallenge'] = ResolversParentTypes['EmailAuthChallenge']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  maskedEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  alternateAuthenticators?: Resolver<
    Array<ResolversTypes['AuthenticatorInfo']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EmailAuthenticatorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EmailAuthenticator'] = ResolversParentTypes['EmailAuthenticator']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  lastUsedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  email?: Resolver<ResolversTypes['EmailAddress'], ParentType, ContextType>
  deviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EmailTakenExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EmailTakenException'] = ResolversParentTypes['EmailTakenException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EmployerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Employer'] = ResolversParentTypes['Employer']
> = {
  clickSwitchTargetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  dunsName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  dunsNumber?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  switch?: Resolver<ResolversTypes['AbstractSwitch'], ParentType, ContextType>
  switchType?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EnableQuarterlyRecapsResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EnableQuarterlyRecapsResult'] = ResolversParentTypes['EnableQuarterlyRecapsResult']
> = {
  __resolveType: TypeResolveFn<
    | 'InvalidSubscriptionTierException'
    | 'InvestmentAccount'
    | 'InvestmentAccountNotFoundException'
    | 'InvestmentAccountNotSupportedException',
    ParentType,
    ContextType
  >
}

export type EstimatedCheckPaymentDatesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EstimatedCheckPaymentDates'] = ResolversParentTypes['EstimatedCheckPaymentDates']
> = {
  estimatedTransferAtText?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  estimatedShippingAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  estimatedArrivalAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EstimatedTransferDatesPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EstimatedTransferDatesPayload'] = ResolversParentTypes['EstimatedTransferDatesPayload']
> = {
  estimatedTransferCompletedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EtfResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ETF'] = ResolversParentTypes['ETF']
> = {
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  annualHigh?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  annualLow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  currentPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  holdings?: Resolver<Maybe<Array<ResolversTypes['Holding']>>, ParentType, ContextType>
  investmentCategories?: Resolver<ResolversTypes['InvestmentCategory'], ParentType, ContextType>
  lastClosePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  netAssets?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  openPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  ownedShares?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  percent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  performance?: Resolver<
    ResolversTypes['ETFPerformance'],
    ParentType,
    ContextType,
    RequireFields<EtfPerformanceArgs, 'timescale' | 'timespan'>
  >
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  priceRangeOverWeek?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  removable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  volume?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  ytdReturn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  ytdReturnPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EtfGainResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ETFGain'] = ResolversParentTypes['ETFGain']
> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EtfPerformanceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ETFPerformance'] = ResolversParentTypes['ETFPerformance']
> = {
  gain?: Resolver<Maybe<ResolversTypes['ETFGain']>, ParentType, ContextType>
  prices?: Resolver<Maybe<Array<ResolversTypes['ETFPrice']>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EtfPriceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ETFPrice'] = ResolversParentTypes['ETFPrice']
> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EvaluateCheckDepositPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EvaluateCheckDepositPayload'] = ResolversParentTypes['EvaluateCheckDepositPayload']
> = {
  ocrAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  riskFactors?: Resolver<Array<ResolversTypes['DepositRiskFactor']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExistingEmailVerifiedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExistingEmailVerifiedException'] = ResolversParentTypes['ExistingEmailVerifiedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExistingPhoneVerifiedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExistingPhoneVerifiedException'] = ResolversParentTypes['ExistingPhoneVerifiedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExistingRequestPendingReviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExistingRequestPendingReview'] = ResolversParentTypes['ExistingRequestPendingReview']
> = {
  reopenRequest?: Resolver<
    ResolversTypes['InvestmentAccountReopenRequest'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExistingRequestPendingUserActionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExistingRequestPendingUserAction'] = ResolversParentTypes['ExistingRequestPendingUserAction']
> = {
  reopenRequest?: Resolver<
    ResolversTypes['InvestmentAccountReopenRequest'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExpandedLifeRecommendationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExpandedLifeRecommendation'] = ResolversParentTypes['ExpandedLifeRecommendation']
> = {
  coverageBreakdown?: Resolver<ResolversTypes['LifeCoverageBreakdown'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExperienceContentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExperienceContent'] = ResolversParentTypes['ExperienceContent']
> = {
  rawContent?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExploreCarouselResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExploreCarousel'] = ResolversParentTypes['ExploreCarousel']
> = {
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  widgets?: Resolver<Array<ResolversTypes['InsuranceSection']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExtensionCampaignResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExtensionCampaign'] = ResolversParentTypes['ExtensionCampaign']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  displayTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  backgroundImage?: Resolver<
    Maybe<ResolversTypes['ExtensionCampaignBackgroundImage']>,
    ParentType,
    ContextType
  >
  backgroundImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  backgroundColorHex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  ctaTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  ctaDetails?: Resolver<ResolversTypes['ExtensionCampaignCtaDetails'], ParentType, ContextType>
  stores?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['ExtensionCampaignStore']>>>,
    ParentType,
    ContextType
  >
  rank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  termsAndConditionsUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  incentiveSummary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  displayEndDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExtensionCampaignBackgroundImageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExtensionCampaignBackgroundImage'] = ResolversParentTypes['ExtensionCampaignBackgroundImage']
> = {
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  horizontalFocalPoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  verticalFocalPoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExtensionCampaignCtaDetailsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExtensionCampaignCtaDetails'] = ResolversParentTypes['ExtensionCampaignCtaDetails']
> = {
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  repeatTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  notificationTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  chromeExt?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  userAttribution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  notificationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExtensionCampaignStoreResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExtensionCampaignStore'] = ResolversParentTypes['ExtensionCampaignStore']
> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  domain?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  checkoutMatchType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  checkoutMatchRegex?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  checkoutTotalAmountSelector?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  conversionMatchType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  conversionMatchRegex?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  conversionTotalAmountSelector?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExtensionOwnerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExtensionOwner'] = ResolversParentTypes['ExtensionOwner']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  imageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  monochromeImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  colorBackgroundLogoImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  greyLogoImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  twitterHandle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  campaigns?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['ExtensionCampaign']>>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExtensionRewardsSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExtensionRewardsSummary'] = ResolversParentTypes['ExtensionRewardsSummary']
> = {
  totalRewardsDollarValue?: Resolver<ResolversTypes['RewardSummary'], ParentType, ContextType>
  totalPendingRewardsDollarValue?: Resolver<
    ResolversTypes['RewardSummary'],
    ParentType,
    ContextType
  >
  totalFulfilledRewardsDollarValue?: Resolver<
    ResolversTypes['RewardSummary'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExtensionTransactionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExtensionTransaction'] = ResolversParentTypes['ExtensionTransaction']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  campaignId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  salesAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  activatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  convertedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  confirmedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  lockedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userUuid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FavoritePartnerOfferGroupResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FavoritePartnerOfferGroup'] = ResolversParentTypes['FavoritePartnerOfferGroup']
> = {
  offers?: Resolver<Array<ResolversTypes['PartnerOfferGroupItem']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FeaturedLearnContentPreviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FeaturedLearnContentPreview'] = ResolversParentTypes['FeaturedLearnContentPreview']
> = {
  __resolveType: TypeResolveFn<'LearnArticlePreview' | 'LearnMediaPreview', ParentType, ContextType>
}

export type FeaturedMilestonesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FeaturedMilestones'] = ResolversParentTypes['FeaturedMilestones']
> = {
  milestones?: Resolver<Array<ResolversTypes['Milestone']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FeaturedMilestonesV2Resolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FeaturedMilestonesV2'] = ResolversParentTypes['FeaturedMilestonesV2']
> = {
  __resolveType: TypeResolveFn<
    'AccountSetupMilestones' | 'FeaturedMilestones',
    ParentType,
    ContextType
  >
}

export type FeaturedOfferResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FeaturedOffer'] = ResolversParentTypes['FeaturedOffer']
> = {
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  fastQuote?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  logo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  offerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  ownerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  tip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FeaturedOffersResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FeaturedOffers'] = ResolversParentTypes['FeaturedOffers']
> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  offers?: Resolver<Array<ResolversTypes['FeaturedOffer']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FeeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Fee'] = ResolversParentTypes['Fee']
> = {
  accountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  assessedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  balance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  billingCycle?: Resolver<ResolversTypes['BillingCycle'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  discountedAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  feeCategoryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  feeExecutions?: Resolver<Array<Maybe<ResolversTypes['FeeExecution']>>, ParentType, ContextType>
  feeType?: Resolver<ResolversTypes['FeeType'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FeeExecutionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FeeExecution'] = ResolversParentTypes['FeeExecution']
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  executionMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  externalId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  fundingAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FeeNegotiationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FeeNegotiation'] = ResolversParentTypes['FeeNegotiation']
> = {
  connection?: Resolver<ResolversTypes['BankConnection'], ParentType, ContextType>
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  internalStatus?: Resolver<
    Maybe<ResolversTypes['BankFeeNegotiationStatus']>,
    ParentType,
    ContextType
  >
  status?: Resolver<Maybe<ResolversTypes['BankFeeNegotiationGQLStatus']>, ParentType, ContextType>
  updated?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  feeSynopsis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  negotiatedAmount?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  refundAmount?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FeeNegotiationOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FeeNegotiationOutput'] = ResolversParentTypes['FeeNegotiationOutput']
> = {
  negotiations?: Resolver<Maybe<Array<ResolversTypes['FeeNegotiation']>>, ParentType, ContextType>
  summary?: Resolver<Maybe<ResolversTypes['BankFeeNegotiationResults']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FeeStatusSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FeeStatusSummary'] = ResolversParentTypes['FeeStatusSummary']
> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  negotiable?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  processing?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  negotiated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  unnegotiable?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FileResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['File'] = ResolversParentTypes['File']
> = {
  documentRequestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  encoding?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  mimetype?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FileDoesNotExistErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FileDoesNotExistError'] = ResolversParentTypes['FileDoesNotExistError']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  uploadUuid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FileDoesNotExistInS3Resolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FileDoesNotExistInS3'] = ResolversParentTypes['FileDoesNotExistInS3']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FileOrExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FileOrException'] = ResolversParentTypes['FileOrException']
> = {
  __resolveType: TypeResolveFn<
    'File' | 'FileSizeError' | 'UploadFailedError',
    ParentType,
    ContextType
  >
}

export type FileSizeErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FileSizeError'] = ResolversParentTypes['FileSizeError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FileTooLargeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FileTooLarge'] = ResolversParentTypes['FileTooLarge']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FinancialInstitutionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FinancialInstitution'] = ResolversParentTypes['FinancialInstitution']
> = {
  blacklisted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  boost?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  directBank?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  hasMfa?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  linkProviderType?: Resolver<Maybe<ResolversTypes['LinkProviderType']>, ParentType, ContextType>
  logoUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  oauthUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  products?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FinancialInstitutionTypeEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FinancialInstitutionTypeEdge'] = ResolversParentTypes['FinancialInstitutionTypeEdge']
> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  node?: Resolver<ResolversTypes['FinancialInstitution'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FinancialInstitutionTypePaginationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FinancialInstitutionTypePagination'] = ResolversParentTypes['FinancialInstitutionTypePagination']
> = {
  edges?: Resolver<Array<ResolversTypes['FinancialInstitutionTypeEdge']>, ParentType, ContextType>
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FinishSetupResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FinishSetup'] = ResolversParentTypes['FinishSetup']
> = {
  eyebrow?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  tips?: Resolver<Array<ResolversTypes['SetUpTip']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FooterResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Footer'] = ResolversParentTypes['Footer']
> = {
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FormattedMonetaryAmountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FormattedMonetaryAmount'] = ResolversParentTypes['FormattedMonetaryAmount']
> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FoundMoneyCampaignResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FoundMoneyCampaign'] = ResolversParentTypes['FoundMoneyCampaign']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  ownerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  backgroundImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  ownerImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  offers?: Resolver<Array<ResolversTypes['FoundMoneyOffer']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FoundMoneyCampaignOfferV2Resolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FoundMoneyCampaignOfferV2'] = ResolversParentTypes['FoundMoneyCampaignOfferV2']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  incentiveSummary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FoundMoneyCampaignV2Resolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FoundMoneyCampaignV2'] = ResolversParentTypes['FoundMoneyCampaignV2']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  cohortSlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  imageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  backgroundImageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  backgroundColorHex?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  colorBackgroundLogoImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  colorImageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  ownerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  offers?: Resolver<Array<ResolversTypes['FoundMoneyCampaignOfferV2']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FoundMoneyOfferResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FoundMoneyOffer'] = ResolversParentTypes['FoundMoneyOffer']
> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  backgroundColorHex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  backgroundImage?: Resolver<Maybe<ResolversTypes['BackgroundImage']>, ParentType, ContextType>
  backgroundImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  colorBackgroundLogoImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  campaignId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  ctaDetails?: Resolver<Maybe<ResolversTypes['CtaDetails']>, ParentType, ContextType>
  ctaTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  dealType?: Resolver<Maybe<ResolversTypes['DealType']>, ParentType, ContextType>
  devicePlatforms?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>
  displayEndDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  displayStartDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  displayTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  displaySubtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>
  promoted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  promotionRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  rank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  redemptionAction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  socialCopies?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SocialCopies']>>>,
    ParentType,
    ContextType
  >
  condensedSocialCopies?: Resolver<
    Maybe<ResolversTypes['CondensedSocialCopies']>,
    ParentType,
    ContextType
  >
  termsAndConditionsUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  webviewEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FoundMoneyOfferCategoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FoundMoneyOfferCategory'] = ResolversParentTypes['FoundMoneyOfferCategory']
> = {
  featuredOffer?: Resolver<Maybe<ResolversTypes['FoundMoneyOffer']>, ParentType, ContextType>
  iconUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  offers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FoundMoneyOffer']>>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FoundMoneyRewardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FoundMoneyReward'] = ResolversParentTypes['FoundMoneyReward']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  campaignOwnerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  campaignOwnerImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  colorBackgroundLogoImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  categoryIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  dollarValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  daysFulfilledWithin?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  originationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  originationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  fulfillmentDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  isFoundMoneyPlus?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FoundMoneySummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FoundMoneySummary'] = ResolversParentTypes['FoundMoneySummary']
> = {
  totalRewardsDollarValue?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >
  totalPendingRewardsDollarValue?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >
  totalFulfilledRewardsDollarValue?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FriendResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Friend'] = ResolversParentTypes['Friend']
> = {
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  advocateUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  campaigns?: Resolver<Maybe<Array<ResolversTypes['ReferralCampaign']>>, ParentType, ContextType>
  status?: Resolver<Maybe<ResolversTypes['FriendStatus']>, ParentType, ContextType>
  friendExperienceContent?: Resolver<
    Maybe<ResolversTypes['FriendExperienceContent']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FriendExperienceContentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FriendExperienceContent'] = ResolversParentTypes['FriendExperienceContent']
> = {
  advocateFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  advocateLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  advocateMinimumIncentive?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FriendSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FriendSummary'] = ResolversParentTypes['FriendSummary']
> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  status?: Resolver<Maybe<ResolversTypes['FriendStatus']>, ParentType, ContextType>
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FundResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Fund'] = ResolversParentTypes['Fund']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  symbol?: Resolver<ResolversTypes['TickerSymbol'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['SecurityType'], ParentType, ContextType>
  week52High?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  week52Low?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  currentPrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  lastClosePrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  openPrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  shortName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  longName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  volume?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>
  marketCap?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>
  profile?: Resolver<ResolversTypes['SecurityProfile'], ParentType, ContextType>
  securityProfile?: Resolver<ResolversTypes['SecurityProfile'], ParentType, ContextType>
  headlines?: Resolver<Array<ResolversTypes['SecurityHeadline']>, ParentType, ContextType>
  securityHeadlines?: Resolver<Array<ResolversTypes['SecurityHeadline']>, ParentType, ContextType>
  topHoldings?: Resolver<Array<ResolversTypes['TopHolding']>, ParentType, ContextType>
  lastUpdatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  earliestPriceDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  numberOfHoldings?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FundingSourceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FundingSource'] = ResolversParentTypes['FundingSource']
> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  fundingType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  last4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  verificationStatus?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  icon?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  alert?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  rdvSettledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  rdvTriggeredAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FundingSourceAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FundingSourceAccount'] = ResolversParentTypes['FundingSourceAccount']
> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  alert?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  balance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  bankRoutingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  canCancel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  canTriggerRdv?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  canVerifyRdv?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  frozen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  fundType?: Resolver<ResolversTypes['FundingSourceType'], ParentType, ContextType>
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  institutionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  insufficientFunds?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  last4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  linked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  linkedSubaccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  rdvSettledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  rdvTriggeredAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  role?: Resolver<Maybe<ResolversTypes['FundingSourceRoleEnum']>, ParentType, ContextType>
  status?: Resolver<ResolversTypes['FundingSourceStatus'], ParentType, ContextType>
  transfersApproved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  uuid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  verificationStatus?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FundingSourceAlreadyExistsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FundingSourceAlreadyExists'] = ResolversParentTypes['FundingSourceAlreadyExists']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FundingSourceCredentialsExceedLinkLimitResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FundingSourceCredentialsExceedLinkLimit'] = ResolversParentTypes['FundingSourceCredentialsExceedLinkLimit']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FundingSourceInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FundingSourceInfo'] = ResolversParentTypes['FundingSourceInfo']
> = {
  type?: Resolver<Maybe<ResolversTypes['FundingSourceType']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  verificationStatus?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  icon?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  alert?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  rdvSettledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  rdvTriggeredAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  accountNumberLastFour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  balance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  canChange?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  changeRequiresApproval?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  linkedSubaccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FundingSourceRequiresRdvExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FundingSourceRequiresRdvException'] = ResolversParentTypes['FundingSourceRequiresRdvException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FunnelMetadataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FunnelMetadata'] = ResolversParentTypes['FunnelMetadata']
> = {
  name?: Resolver<ResolversTypes['FunnelName'], ParentType, ContextType>
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type GenerateUpdatedPdfPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenerateUpdatedPdfPayload'] = ResolversParentTypes['GenerateUpdatedPdfPayload']
> = {
  pdf?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type GrowProspectResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GrowProspect'] = ResolversParentTypes['GrowProspect']
> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type HeaderResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Header'] = ResolversParentTypes['Header']
> = {
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type HelpFormContentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HelpFormContent'] = ResolversParentTypes['HelpFormContent']
> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type HoldingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Holding'] = ResolversParentTypes['Holding']
> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  percent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type HomeIconResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HomeIcon'] = ResolversParentTypes['HomeIcon']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  icon?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type HomeIconsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HomeIcons'] = ResolversParentTypes['HomeIcons']
> = {
  icons?: Resolver<Array<ResolversTypes['HomeIcon']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type IdentityDocumentRequestedUserAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['IdentityDocumentRequestedUserAlert'] = ResolversParentTypes['IdentityDocumentRequestedUserAlert']
> = {
  requestedDocumentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ImageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Image'] = ResolversParentTypes['Image']
> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type IncentiveResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Incentive'] = ResolversParentTypes['Incentive']
> = {
  __resolveType: TypeResolveFn<'MonetaryIncentive', ParentType, ContextType>
  copyKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
}

export type IncorrectOldPasswordExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['IncorrectOldPasswordException'] = ResolversParentTypes['IncorrectOldPasswordException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type IncorrectSecurityAnswerExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['IncorrectSecurityAnswerException'] = ResolversParentTypes['IncorrectSecurityAnswerException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type IncorrectSsnExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['IncorrectSsnException'] = ResolversParentTypes['IncorrectSsnException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type IneligibilityLanderResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['IneligibilityLander'] = ResolversParentTypes['IneligibilityLander']
> = {
  alternatePartners?: Resolver<Maybe<ResolversTypes['InsuranceCarousel']>, ParentType, ContextType>
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  disclaimer?: Resolver<Maybe<ResolversTypes['Disclaimer']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  logo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InitiateEmailChallengeResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InitiateEmailChallengeResult'] = ResolversParentTypes['InitiateEmailChallengeResult']
> = {
  __resolveType: TypeResolveFn<
    'EmailAuthChallenge' | 'ExistingEmailVerifiedException',
    ParentType,
    ContextType
  >
}

export type InitiateSmsChallengeResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InitiateSMSChallengeResult'] = ResolversParentTypes['InitiateSMSChallengeResult']
> = {
  __resolveType: TypeResolveFn<
    'SMSAuthChallenge' | 'InvalidPhoneNumberException',
    ParentType,
    ContextType
  >
}

export type InitiateTransferPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InitiateTransferPayload'] = ResolversParentTypes['InitiateTransferPayload']
> = {
  transfer?: Resolver<Maybe<ResolversTypes['Transfer']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InstitutionNotSupportedErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InstitutionNotSupportedError'] = ResolversParentTypes['InstitutionNotSupportedError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InsufficientFundsUserAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InsufficientFundsUserAlert'] = ResolversParentTypes['InsufficientFundsUserAlert']
> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InsuranceCarouselResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InsuranceCarousel'] = ResolversParentTypes['InsuranceCarousel']
> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  insuranceType?: Resolver<ResolversTypes['InsuranceType'], ParentType, ContextType>
  offers?: Resolver<Array<ResolversTypes['CarouselOffer']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InsuranceHomeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InsuranceHome'] = ResolversParentTypes['InsuranceHome']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  disclaimerBody?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  disclaimerCta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  insuranceType?: Resolver<ResolversTypes['InsuranceType'], ParentType, ContextType>
  modals?: Resolver<Array<ResolversTypes['Modal']>, ParentType, ContextType>
  subtitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  widgets?: Resolver<Array<ResolversTypes['InsuranceHomeWidget']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InsuranceHomeWidgetResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InsuranceHomeWidget'] = ResolversParentTypes['InsuranceHomeWidget']
> = {
  __resolveType: TypeResolveFn<
    | 'CoverageAsk'
    | 'CoverageCalculator'
    | 'CoverageGrow'
    | 'CoverageKnown'
    | 'CoverageUnknown'
    | 'InsuranceCarousel',
    ParentType,
    ContextType
  >
}

export type InsuranceSectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InsuranceSection'] = ResolversParentTypes['InsuranceSection']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  insuranceType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  recommendType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InternalErrorExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InternalErrorException'] = ResolversParentTypes['InternalErrorException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InternalShareTransferFailedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InternalShareTransferFailed'] = ResolversParentTypes['InternalShareTransferFailed']
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidAccountNumberResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidAccountNumber'] = ResolversParentTypes['InvalidAccountNumber']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidAccountTokenResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidAccountToken'] = ResolversParentTypes['InvalidAccountToken']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidAccountTypeExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidAccountTypeException'] = ResolversParentTypes['InvalidAccountTypeException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidActionOnAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidActionOnAccount'] = ResolversParentTypes['InvalidActionOnAccount']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidAddressErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidAddressError'] = ResolversParentTypes['InvalidAddressError']
> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidAddressExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidAddressException'] = ResolversParentTypes['InvalidAddressException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidAllocationPercentErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidAllocationPercentError'] = ResolversParentTypes['InvalidAllocationPercentError']
> = {
  maxAllocationPercent?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidConversionIdentifierExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidConversionIdentifierException'] = ResolversParentTypes['InvalidConversionIdentifierException']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidCredentialsExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidCredentialsException'] = ResolversParentTypes['InvalidCredentialsException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidDateOfBirthExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidDateOfBirthException'] = ResolversParentTypes['InvalidDateOfBirthException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidEmailExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidEmailException'] = ResolversParentTypes['InvalidEmailException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidFileResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidFile'] = ResolversParentTypes['InvalidFile']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidFirstNameExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidFirstNameException'] = ResolversParentTypes['InvalidFirstNameException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidInvestmentAccountExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidInvestmentAccountException'] = ResolversParentTypes['InvalidInvestmentAccountException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidLastNameExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidLastNameException'] = ResolversParentTypes['InvalidLastNameException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidLaterInputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidLaterInput'] = ResolversParentTypes['InvalidLaterInput']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidManualLinkResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidManualLink'] = ResolversParentTypes['InvalidManualLink']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidOptionExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidOptionException'] = ResolversParentTypes['InvalidOptionException']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidPasswordExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidPasswordException'] = ResolversParentTypes['InvalidPasswordException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidPasswordResetExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidPasswordResetException'] = ResolversParentTypes['InvalidPasswordResetException']
> = {
  errors?: Resolver<Array<ResolversTypes['PasswordResetErrors']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidPasswordResetTokenExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidPasswordResetTokenException'] = ResolversParentTypes['InvalidPasswordResetTokenException']
> = {
  invalidToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidPhoneExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidPhoneException'] = ResolversParentTypes['InvalidPhoneException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidPhoneNumberExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidPhoneNumberException'] = ResolversParentTypes['InvalidPhoneNumberException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidPinExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidPinException'] = ResolversParentTypes['InvalidPinException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidPortfolioIdExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidPortfolioIdException'] = ResolversParentTypes['InvalidPortfolioIdException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidRoutingNumberResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidRoutingNumber'] = ResolversParentTypes['InvalidRoutingNumber']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidSecurityErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidSecurityError'] = ResolversParentTypes['InvalidSecurityError']
> = {
  securityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidSecurityForAllocationErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidSecurityForAllocationError'] = ResolversParentTypes['InvalidSecurityForAllocationError']
> = {
  reason?: Resolver<
    ResolversTypes['InvalidSecurityForAllocationReasonEnum'],
    ParentType,
    ContextType
  >
  securityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidSecurityForSymbolChangeErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidSecurityForSymbolChangeError'] = ResolversParentTypes['InvalidSecurityForSymbolChangeError']
> = {
  error_reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidSecurityQuestionExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidSecurityQuestionException'] = ResolversParentTypes['InvalidSecurityQuestionException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidSourceAttributesExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidSourceAttributesException'] = ResolversParentTypes['InvalidSourceAttributesException']
> = {
  incorrectAttributes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidSsnErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidSSNError'] = ResolversParentTypes['InvalidSSNError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidSsnExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidSsnException'] = ResolversParentTypes['InvalidSsnException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidStateExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidStateException'] = ResolversParentTypes['InvalidStateException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidSubscriptionTierExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidSubscriptionTierException'] = ResolversParentTypes['InvalidSubscriptionTierException']
> = {
  currentUserTierKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidSymbolForSymbolChangeErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidSymbolForSymbolChangeError'] = ResolversParentTypes['InvalidSymbolForSymbolChangeError']
> = {
  error_reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidTerminationAgeExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidTerminationAgeException'] = ResolversParentTypes['InvalidTerminationAgeException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidTierResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidTier'] = ResolversParentTypes['InvalidTier']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  validTiers?: Resolver<Array<ResolversTypes['Tier']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidTierForMigrationErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidTierForMigrationError'] = ResolversParentTypes['InvalidTierForMigrationError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidTierPriceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidTierPrice'] = ResolversParentTypes['InvalidTierPrice']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  validTierPrices?: Resolver<Array<ResolversTypes['TierPrice']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidTierPriceCombinationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidTierPriceCombination'] = ResolversParentTypes['InvalidTierPriceCombination']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  tier?: Resolver<ResolversTypes['Tier'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvalidTierPriceIdResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvalidTierPriceId'] = ResolversParentTypes['InvalidTierPriceId']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Investment'] = ResolversParentTypes['Investment']
> = {
  allocations?: Resolver<
    Maybe<Array<ResolversTypes['InvestmentAllocation']>>,
    ParentType,
    ContextType
  >
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  details?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  executionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  pending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  receivedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  requestedAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  shares?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  status?: Resolver<ResolversTypes['InvestmentStatus'], ParentType, ContextType>
  tradeConfirmationUrls?: Resolver<Maybe<Array<ResolversTypes['URL']>>, ParentType, ContextType>
  transferredAmount?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  typeHelp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccount'] = ResolversParentTypes['InvestmentAccount']
> = {
  beneficiaryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  cashBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  cashOwed?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  closedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  currentBalance?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  currentBalanceWithPending?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  hasInvested?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  investmentAccountType?: Resolver<ResolversTypes['InvestmentAccountType'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  netInvestments?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  pendingBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  pendingWithdrawals?: Resolver<Array<ResolversTypes['Withdrawal']>, ParentType, ContextType>
  performance?: Resolver<
    Maybe<ResolversTypes['Performance']>,
    ParentType,
    ContextType,
    RequireFields<InvestmentAccountPerformanceArgs, 'days'>
  >
  portfolio?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>
  portfolios?: Resolver<Maybe<Array<ResolversTypes['BasePortfolio']>>, ParentType, ContextType>
  product?: Resolver<ResolversTypes['InvestmentProduct'], ParentType, ContextType>
  quarterlyRecap?: Resolver<
    Maybe<ResolversTypes['InvestmentAccountRecap']>,
    ParentType,
    ContextType
  >
  quarterlyRecapsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  recommendedPortfolio?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>
  recurringInvestmentSettings?: Resolver<
    Maybe<ResolversTypes['RecurringInvestmentSettings']>,
    ParentType,
    ContextType
  >
  requirements?: Resolver<ResolversTypes['AccountRequirements'], ParentType, ContextType>
  returnsAllTime?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['InvestmentAccountStatus'], ParentType, ContextType>
  summary?: Resolver<
    ResolversTypes['InvestmentAccountSummary'],
    ParentType,
    ContextType,
    RequireFields<InvestmentAccountSummaryArgs, 'startPeriod' | 'endPeriod'>
  >
  totalAccountValue?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  totalBonds?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  totalCrypto?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  totalEquities?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  transferability?: Resolver<
    Maybe<ResolversTypes['InvestmentAccountTransferability']>,
    ParentType,
    ContextType
  >
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  uuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  yearToDateReturn?: Resolver<Maybe<ResolversTypes['MarketReturn']>, ParentType, ContextType>
  beneficiary?: Resolver<Maybe<ResolversTypes['Beneficiary']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountAlreadyClosedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountAlreadyClosed'] = ResolversParentTypes['InvestmentAccountAlreadyClosed']
> = {
  accountClosedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountClosureInProgressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountClosureInProgress'] = ResolversParentTypes['InvestmentAccountClosureInProgress']
> = {
  clientMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountCreationExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountCreationException'] = ResolversParentTypes['InvestmentAccountCreationException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountNeedsTransferExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountNeedsTransferException'] = ResolversParentTypes['InvestmentAccountNeedsTransferException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountNotClosedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountNotClosedException'] = ResolversParentTypes['InvestmentAccountNotClosedException']
> = {
  accountType?: Resolver<Maybe<ResolversTypes['InvestmentAccountType']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountNotFoundException'] = ResolversParentTypes['InvestmentAccountNotFoundException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountNotSupportedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountNotSupportedException'] = ResolversParentTypes['InvestmentAccountNotSupportedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountOutsideContributionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountOutsideContribution'] = ResolversParentTypes['InvestmentAccountOutsideContribution']
> = {
  amount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  contributorName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountRecapResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountRecap'] = ResolversParentTypes['InvestmentAccountRecap']
> = {
  contributionsByOthers?: Resolver<
    Maybe<Array<ResolversTypes['InvestmentAccountOutsideContribution']>>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  endsAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  investmentAccount?: Resolver<ResolversTypes['InvestmentAccount'], ParentType, ContextType>
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  latestAccountValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  performance?: Resolver<Maybe<ResolversTypes['Performance']>, ParentType, ContextType>
  public?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  publicUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  startsAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  totalContributions?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>
  totalContributionsByOthers?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  viewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountRecapNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountRecapNotFoundException'] = ResolversParentTypes['InvestmentAccountRecapNotFoundException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountReopenRequestResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountReopenRequest'] = ResolversParentTypes['InvestmentAccountReopenRequest']
> = {
  adminActions?: Resolver<
    Array<ResolversTypes['InvestmentAccountReopenRequestAction']>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  investmentAccount?: Resolver<ResolversTypes['InvestmentAccount'], ParentType, ContextType>
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  notes?: Resolver<
    Array<ResolversTypes['InvestmentAccountReopenRequestNote']>,
    ParentType,
    ContextType
  >
  reopenChecks?: Resolver<
    Array<ResolversTypes['UserInvestmentAccountReopenCheck']>,
    ParentType,
    ContextType
  >
  state?: Resolver<ResolversTypes['InvestmentAccountReopenRequestState'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  user?: Resolver<ResolversTypes['User_v2'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountReopenRequestActionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountReopenRequestAction'] = ResolversParentTypes['InvestmentAccountReopenRequestAction']
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  fromState?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  investmentAccount?: Resolver<ResolversTypes['InvestmentAccount'], ParentType, ContextType>
  note?: Resolver<
    Maybe<ResolversTypes['InvestmentAccountReopenRequestNote']>,
    ParentType,
    ContextType
  >
  reopenRequest?: Resolver<
    ResolversTypes['InvestmentAccountReopenRequest'],
    ParentType,
    ContextType
  >
  toState?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountReopenRequestNoteResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountReopenRequestNote'] = ResolversParentTypes['InvestmentAccountReopenRequestNote']
> = {
  adminAction?: Resolver<
    ResolversTypes['InvestmentAccountReopenRequestAction'],
    ParentType,
    ContextType
  >
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  emailSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  reopenRequest?: Resolver<
    ResolversTypes['InvestmentAccountReopenRequest'],
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountSummary'] = ResolversParentTypes['InvestmentAccountSummary']
> = {
  firstInvestmentDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  mostRecentOneTimeInvestmentDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >
  totalCredits?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalDividends?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalFoundMoneyRewards?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalInvested?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalOneTime?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalOutsideContributions?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalPlan?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalRecurring?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalReferralRewards?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalRoundUps?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalRtru?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAccountTransferabilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAccountTransferability'] = ResolversParentTypes['InvestmentAccountTransferability']
> = {
  transferAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  transferDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  transferReached?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  transferStateCode?: Resolver<ResolversTypes['USStateCodes'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentAllocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentAllocation'] = ResolversParentTypes['InvestmentAllocation']
> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  price?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  selfDirected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['InvestmentAllocationStatus'], ParentType, ContextType>
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['InvestmentAllocationType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentCategoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentCategory'] = ResolversParentTypes['InvestmentCategory']
> = {
  bond?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  crypto?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  equity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  realEstate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentNotFoundException'] = ResolversParentTypes['InvestmentNotFoundException']
> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentsPausedUserAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentsPausedUserAlert'] = ResolversParentTypes['InvestmentsPausedUserAlert']
> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InvestmentUncancellableExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvestmentUncancellableException'] = ResolversParentTypes['InvestmentUncancellableException']
> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type JobAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobAlert'] = ResolversParentTypes['JobAlert']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  keyPhrase?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  location?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type JobLocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobLocation'] = ResolversParentTypes['JobLocation']
> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type JobOfferResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobOffer'] = ResolversParentTypes['JobOffer']
> = {
  companyLogo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  industryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  jobName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  location?: Resolver<ResolversTypes['OfferLocation'], ParentType, ContextType>
  salary?: Resolver<Maybe<ResolversTypes['JobOfferSalary']>, ParentType, ContextType>
  tags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type JobOfferSalaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobOfferSalary'] = ResolversParentTypes['JobOfferSalary']
> = {
  interval?: Resolver<ResolversTypes['SalaryInterval'], ParentType, ContextType>
  maxValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  minValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Jobs_ArticleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['jobs_Article'] = ResolversParentTypes['jobs_Article']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<Maybe<ResolversTypes['Cta']>, ParentType, ContextType>
  eyebrow?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Jobs_EducationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['jobs_Education'] = ResolversParentTypes['jobs_Education']
> = {
  articles?: Resolver<Array<ResolversTypes['jobs_Article']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Jobs_OfferResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['jobs_Offer'] = ResolversParentTypes['jobs_Offer']
> = {
  companyLogo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  industryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  jobName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  location?: Resolver<ResolversTypes['JobLocation'], ParentType, ContextType>
  salary?: Resolver<Maybe<ResolversTypes['jobs_OfferSalary']>, ParentType, ContextType>
  tags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Jobs_OfferConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['jobs_OfferConnection'] = ResolversParentTypes['jobs_OfferConnection']
> = {
  edges?: Resolver<Array<ResolversTypes['jobs_OfferEdge']>, ParentType, ContextType>
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Jobs_OfferEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['jobs_OfferEdge'] = ResolversParentTypes['jobs_OfferEdge']
> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  node?: Resolver<ResolversTypes['jobs_Offer'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Jobs_OfferSalaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['jobs_OfferSalary'] = ResolversParentTypes['jobs_OfferSalary']
> = {
  interval?: Resolver<ResolversTypes['SalaryInterval'], ParentType, ContextType>
  maxValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  minValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type JobSearchCriteriaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobSearchCriteria'] = ResolversParentTypes['JobSearchCriteria']
> = {
  filters?: Resolver<Array<ResolversTypes['JobSearchFilter']>, ParentType, ContextType>
  location?: Resolver<ResolversTypes['JobLocation'], ParentType, ContextType>
  searchRadius?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type JobSearchFilterResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobSearchFilter'] = ResolversParentTypes['JobSearchFilter']
> = {
  key?: Resolver<ResolversTypes['JobSearchFilterKey'], ParentType, ContextType>
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type JobSearchOfferResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobSearchOffer'] = ResolversParentTypes['JobSearchOffer']
> = {
  backgroundImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  desktopBackgroundImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  searchFilters?: Resolver<Array<ResolversTypes['JobSearchFilter']>, ParentType, ContextType>
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type JobSearchPageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobSearchPage'] = ResolversParentTypes['JobSearchPage']
> = {
  recentSearches?: Resolver<Array<ResolversTypes['JobSearchCriteria']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON'
}

export type LadderLinkResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LadderLinkResponse'] = ResolversParentTypes['LadderLinkResponse']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  urlExpires?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LadderQuoteResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LadderQuote'] = ResolversParentTypes['LadderQuote']
> = {
  coverage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  term?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  monthlyPremium?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LadderQuoteStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LadderQuoteStatus'] = ResolversParentTypes['LadderQuoteStatus']
> = {
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  complete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  eligible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LadderResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LadderResponse'] = ResolversParentTypes['LadderResponse']
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  quoteStatus?: Resolver<Maybe<ResolversTypes['LadderQuoteStatus']>, ParentType, ContextType>
  quotes?: Resolver<Array<Maybe<ResolversTypes['LadderQuote']>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterAccount'] = ResolversParentTypes['LaterAccount']
> = {
  accountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  code?: Resolver<ResolversTypes['LaterAccountCodes'], ParentType, ContextType>
  portfolioId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  portfolioName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  performance?: Resolver<
    Maybe<ResolversTypes['LaterPortfolioPerformance']>,
    ParentType,
    ContextType
  >
  recurringSettings?: Resolver<
    Maybe<ResolversTypes['RecurringInvestmentSettings']>,
    ParentType,
    ContextType
  >
  contributionLimit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  status?: Resolver<Maybe<ResolversTypes['LaterAccountStatus']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterAccountAlreadyVerifiedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterAccountAlreadyVerified'] = ResolversParentTypes['LaterAccountAlreadyVerified']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterAccountIneligibleForVerificationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterAccountIneligibleForVerification'] = ResolversParentTypes['LaterAccountIneligibleForVerification']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterAccountInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterAccountInfo'] = ResolversParentTypes['LaterAccountInfo']
> = {
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  plan?: Resolver<ResolversTypes['InvestmentAccountTypes'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['LaterAccountStatus'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterAccountInfoOrErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterAccountInfoOrError'] = ResolversParentTypes['LaterAccountInfoOrError']
> = {
  __resolveType: TypeResolveFn<
    | 'LaterAccountAlreadyVerified'
    | 'LaterAccountIneligibleForVerification'
    | 'LaterAccountInfo'
    | 'LaterAccountNotFound',
    ParentType,
    ContextType
  >
}

export type LaterAccountNotFoundResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterAccountNotFound'] = ResolversParentTypes['LaterAccountNotFound']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterBeneficiaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterBeneficiary'] = ResolversParentTypes['LaterBeneficiary']
> = {
  __resolveType: TypeResolveFn<
    'LaterIndividualBeneficiary' | 'LaterEntityBeneficiary',
    ParentType,
    ContextType
  >
  type?: Resolver<Maybe<ResolversTypes['BeneficiaryType']>, ParentType, ContextType>
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  percentageShare?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  beneficiaryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
}

export type LaterContributionAbilityResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterContributionAbilityResult'] = ResolversParentTypes['LaterContributionAbilityResult']
> = {
  __resolveType: TypeResolveFn<'ContributionAbilityByYear', ParentType, ContextType>
}

export type LaterContributionLimitMetResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterContributionLimitMet'] = ResolversParentTypes['LaterContributionLimitMet']
> = {
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterDepositResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterDeposit'] = ResolversParentTypes['LaterDeposit']
> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<Maybe<ResolversTypes['LaterHistoryItemType']>, ParentType, ContextType>
  depositId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  depositType?: Resolver<Maybe<ResolversTypes['LaterDepositType']>, ParentType, ContextType>
  taxYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  reversible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  tradeConfirmUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  pending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterDividendsItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterDividendsItem'] = ResolversParentTypes['LaterDividendsItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  etfCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  etfTicker?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterEntityBeneficiaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterEntityBeneficiary'] = ResolversParentTypes['LaterEntityBeneficiary']
> = {
  beneficiaryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<Maybe<ResolversTypes['BeneficiaryType']>, ParentType, ContextType>
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  percentageShare?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterFeeInvestmentItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterFeeInvestmentItem'] = ResolversParentTypes['LaterFeeInvestmentItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterFullContributionSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterFullContributionSuccess'] = ResolversParentTypes['LaterFullContributionSuccess']
> = {
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterHistoryItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterHistoryItem'] = ResolversParentTypes['LaterHistoryItem']
> = {
  __resolveType: TypeResolveFn<'LaterDeposit' | 'LaterWithdrawal', ParentType, ContextType>
  type?: Resolver<Maybe<ResolversTypes['LaterHistoryItemType']>, ParentType, ContextType>
  taxYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  reversible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  tradeConfirmUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  pending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
}

export type LaterIndividualBeneficiaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterIndividualBeneficiary'] = ResolversParentTypes['LaterIndividualBeneficiary']
> = {
  beneficiaryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  birthDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  relationship?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  percentageShare?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  addressLine1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  addressLine2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  type?: Resolver<Maybe<ResolversTypes['BeneficiaryType']>, ParentType, ContextType>
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterIndividualBeneficiaryResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterIndividualBeneficiaryResponse'] = ResolversParentTypes['LaterIndividualBeneficiaryResponse']
> = {
  accountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  beneficiaryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  percentageShare?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  birthDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  relationship?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  addressLine1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  addressLine2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterInvestmentItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterInvestmentItem'] = ResolversParentTypes['LaterInvestmentItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterPartialContributionSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterPartialContributionSuccess'] = ResolversParentTypes['LaterPartialContributionSuccess']
> = {
  acceptedAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterPortfolioPerformanceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterPortfolioPerformance'] = ResolversParentTypes['LaterPortfolioPerformance']
> = {
  periodMarketChange?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  periodMarketChangePercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  periodMarketChangeWithoutFees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  periodMarketChangePercentWithoutFees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterProgramAccountContributionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterProgramAccountContributionResult'] = ResolversParentTypes['LaterProgramAccountContributionResult']
> = {
  __resolveType: TypeResolveFn<
    | 'LaterContributionLimitMet'
    | 'LaterFullContributionSuccess'
    | 'LaterPartialContributionSuccess',
    ParentType,
    ContextType
  >
}

export type LaterRebalanceItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterRebalanceItem'] = ResolversParentTypes['LaterRebalanceItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterTypedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterTypedException'] = ResolversParentTypes['LaterTypedException']
> = {
  __resolveType: TypeResolveFn<
    | 'LaterAccountAlreadyVerified'
    | 'LaterAccountIneligibleForVerification'
    | 'LaterAccountNotFound'
    | 'InvalidLaterInput',
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
}

export type LaterWaitlistProspectResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterWaitlistProspect'] = ResolversParentTypes['LaterWaitlistProspect']
> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterWithdrawalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterWithdrawal'] = ResolversParentTypes['LaterWithdrawal']
> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  withdrawalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  type?: Resolver<Maybe<ResolversTypes['LaterHistoryItemType']>, ParentType, ContextType>
  withdrawalType?: Resolver<Maybe<ResolversTypes['LaterWithdrawalType']>, ParentType, ContextType>
  taxYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  federalTaxes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  stateTaxes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  earlyDistributionTaxExceptionReason?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  reversible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  tradeConfirmUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  pending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterWithdrawalItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterWithdrawalItem'] = ResolversParentTypes['LaterWithdrawalItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  federalWithholdings?: Resolver<
    Maybe<ResolversTypes['LaterWithholdingValues']>,
    ParentType,
    ContextType
  >
  stateWithholdings?: Resolver<
    Maybe<ResolversTypes['LaterWithholdingValues']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LaterWithholdingValuesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaterWithholdingValues'] = ResolversParentTypes['LaterWithholdingValues']
> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnAnswerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnAnswer'] = ResolversParentTypes['LearnAnswer']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  isCorrect?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnArticleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnArticle'] = ResolversParentTypes['LearnArticle']
> = {
  authors?: Resolver<Array<ResolversTypes['LearnAuthor']>, ParentType, ContextType>
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  contentImage?: Resolver<Maybe<ResolversTypes['LearnVisualAsset']>, ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  metadata?: Resolver<ResolversTypes['LearnMetadata'], ParentType, ContextType>
  publishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  tags?: Resolver<Array<ResolversTypes['LearnTag']>, ParentType, ContextType>
  tier?: Resolver<ResolversTypes['LearnTier'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  topics?: Resolver<Array<ResolversTypes['LearnTopic']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnArticlePreviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnArticlePreview'] = ResolversParentTypes['LearnArticlePreview']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  progress?: Resolver<Maybe<ResolversTypes['LearnProgress']>, ParentType, ContextType>
  tierName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  views?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnArticlePreviewLockedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnArticlePreviewLocked'] = ResolversParentTypes['LearnArticlePreviewLocked']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  views?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnAuthorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnAuthor'] = ResolversParentTypes['LearnAuthor']
> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  photo?: Resolver<Maybe<ResolversTypes['LearnVisualAsset']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnConnection'] = ResolversParentTypes['LearnConnection']
> = {
  __resolveType: TypeResolveFn<'ContentPreviewConnection', ParentType, ContextType>
  edges?: Resolver<Array<ResolversTypes['LearnEdge']>, ParentType, ContextType>
  pageInfo?: Resolver<ResolversTypes['LearnPageInfo'], ParentType, ContextType>
}

export type LearnContentCategoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnContentCategory'] = ResolversParentTypes['LearnContentCategory']
> = {
  __resolveType: TypeResolveFn<'LearnTier' | 'LearnTopic', ParentType, ContextType>
}

export type LearnContentCommunityStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnContentCommunityStats'] = ResolversParentTypes['LearnContentCommunityStats']
> = {
  __resolveType: TypeResolveFn<'LearnContentStats', ParentType, ContextType>
}

export type LearnContentDurationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnContentDuration'] = ResolversParentTypes['LearnContentDuration']
> = {
  __resolveType: TypeResolveFn<'Milliseconds', ParentType, ContextType>
}

export type LearnContentElapsedMillisecondsUpdatedResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnContentElapsedMillisecondsUpdatedResult'] = ResolversParentTypes['LearnContentElapsedMillisecondsUpdatedResult']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  elapsedTime?: Resolver<ResolversTypes['Milliseconds'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnContentInteractionStateResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnContentInteractionState'] = ResolversParentTypes['LearnContentInteractionState']
> = {
  __resolveType: TypeResolveFn<'LearnInteractionState', ParentType, ContextType>
}

export type LearnContentPreviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnContentPreview'] = ResolversParentTypes['LearnContentPreview']
> = {
  __resolveType: TypeResolveFn<
    | 'CoursePreview'
    | 'CoursePreviewLocked'
    | 'LearnArticlePreview'
    | 'LearnArticlePreviewLocked'
    | 'LearnMediaPreview'
    | 'LearnMediaPreviewLocked'
    | 'LearnPollPreview'
    | 'LearnPollPreviewLocked'
    | 'LessonPreview'
    | 'LessonPreviewLocked'
    | 'QuizPreview'
    | 'QuizPreviewLocked',
    ParentType,
    ContextType
  >
}

export type LearnContentStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnContentStats'] = ResolversParentTypes['LearnContentStats']
> = {
  communityAvg?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  views?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnCoursePreviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnCoursePreview'] = ResolversParentTypes['LearnCoursePreview']
> = {
  __resolveType: TypeResolveFn<'CoursePreview' | 'CoursePreviewLocked', ParentType, ContextType>
}

export type LearnEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnEdge'] = ResolversParentTypes['LearnEdge']
> = {
  __resolveType: TypeResolveFn<'ContentPreviewEdge', ParentType, ContextType>
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
}

export type LearnInsightResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnInsight'] = ResolversParentTypes['LearnInsight']
> = {
  cuePointMillis?: Resolver<ResolversTypes['Milliseconds'], ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnInteractionStateResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnInteractionState'] = ResolversParentTypes['LearnInteractionState']
> = {
  elapsedTime?: Resolver<Maybe<ResolversTypes['LearnContentDuration']>, ParentType, ContextType>
  isFavorites?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isHelpful?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  progress?: Resolver<Maybe<ResolversTypes['LearnProgress']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnMediaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnMedia'] = ResolversParentTypes['LearnMedia']
> = {
  __resolveType: TypeResolveFn<'LearnMediaArticle', ParentType, ContextType>
}

export type LearnMediaArticleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnMediaArticle'] = ResolversParentTypes['LearnMediaArticle']
> = {
  audioTheme?: Resolver<Maybe<ResolversTypes['LearnMediaTheme']>, ParentType, ContextType>
  authors?: Resolver<Array<ResolversTypes['LearnAuthor']>, ParentType, ContextType>
  featuredImage?: Resolver<Maybe<ResolversTypes['LearnVisualAsset']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  insights?: Resolver<Array<ResolversTypes['LearnInsight']>, ParentType, ContextType>
  media?: Resolver<ResolversTypes['LearnMediaReference'], ParentType, ContextType>
  metadata?: Resolver<ResolversTypes['LearnMetadata'], ParentType, ContextType>
  polls?: Resolver<Array<ResolversTypes['LearnPoll']>, ParentType, ContextType>
  preEventDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  startsAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  tags?: Resolver<Array<ResolversTypes['LearnTag']>, ParentType, ContextType>
  tier?: Resolver<ResolversTypes['LearnTier'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  topics?: Resolver<Array<ResolversTypes['LearnTopic']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnMediaPreviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnMediaPreview'] = ResolversParentTypes['LearnMediaPreview']
> = {
  audioTheme?: Resolver<Maybe<ResolversTypes['LearnMediaTheme']>, ParentType, ContextType>
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  mediaType?: Resolver<Maybe<ResolversTypes['LearnMediaType']>, ParentType, ContextType>
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  progress?: Resolver<Maybe<ResolversTypes['LearnProgress']>, ParentType, ContextType>
  startsAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  tierName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  views?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnMediaPreviewLockedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnMediaPreviewLocked'] = ResolversParentTypes['LearnMediaPreviewLocked']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  mediaType?: Resolver<Maybe<ResolversTypes['LearnMediaType']>, ParentType, ContextType>
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  views?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnMediaReferenceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnMediaReference'] = ResolversParentTypes['LearnMediaReference']
> = {
  aspectRatio?: Resolver<ResolversTypes['LearnAspectRatioType'], ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  theme?: Resolver<Maybe<ResolversTypes['LearnMediaTheme']>, ParentType, ContextType>
  transcript?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  type?: Resolver<ResolversTypes['LearnMediaType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnMediaThemeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnMediaTheme'] = ResolversParentTypes['LearnMediaTheme']
> = {
  __resolveType: TypeResolveFn<'LearnThemeLiteral', ParentType, ContextType>
}

export type LearnMetadataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnMetadata'] = ResolversParentTypes['LearnMetadata']
> = {
  contentStats?: Resolver<
    Maybe<ResolversTypes['LearnContentCommunityStats']>,
    ParentType,
    ContextType
  >
  interactionState?: Resolver<
    Maybe<ResolversTypes['LearnContentInteractionState']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnNextStepActionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnNextStepAction'] = ResolversParentTypes['LearnNextStepAction']
> = {
  ctaLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  illustration?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnPageInfo'] = ResolversParentTypes['LearnPageInfo']
> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  cursor?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnPollResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnPoll'] = ResolversParentTypes['LearnPoll']
> = {
  cuePointMillis?: Resolver<Maybe<ResolversTypes['Milliseconds']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  options?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  pollType?: Resolver<ResolversTypes['LearnPollType'], ParentType, ContextType>
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnPollOptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnPollOption'] = ResolversParentTypes['LearnPollOption']
> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  option?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnPollPreviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnPollPreview'] = ResolversParentTypes['LearnPollPreview']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>
  options?: Resolver<Maybe<Array<ResolversTypes['LearnPollOption']>>, ParentType, ContextType>
  pollType?: Resolver<ResolversTypes['LearnPollType'], ParentType, ContextType>
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnPollPreviewLockedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnPollPreviewLocked'] = ResolversParentTypes['LearnPollPreviewLocked']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnPollResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnPollResponse'] = ResolversParentTypes['LearnPollResponse']
> = {
  isSuccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  selectedOption?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  stats?: Resolver<Maybe<Array<ResolversTypes['LearnPollOption']>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnProgressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnProgress'] = ResolversParentTypes['LearnProgress']
> = {
  currentValue?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  unitType?: Resolver<ResolversTypes['LearnProgressUnit'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnProgressUpdatedResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnProgressUpdatedResult'] = ResolversParentTypes['LearnProgressUpdatedResult']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  progress?: Resolver<ResolversTypes['LearnProgress'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnQuestionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnQuestion'] = ResolversParentTypes['LearnQuestion']
> = {
  answers?: Resolver<Array<ResolversTypes['LearnAnswer']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  incrementStep?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  insight?: Resolver<Maybe<ResolversTypes['LearnQuestionInsight']>, ParentType, ContextType>
  questionBody?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  questionType?: Resolver<ResolversTypes['LearnQuestionType'], ParentType, ContextType>
  rangeEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  rangeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  rangeStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  rangeType?: Resolver<Maybe<ResolversTypes['LearnRangeType']>, ParentType, ContextType>
  statement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  statementHighLight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  unitType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnQuestionInsightResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnQuestionInsight'] = ResolversParentTypes['LearnQuestionInsight']
> = {
  featuredImage?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  insightText?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  media?: Resolver<Maybe<ResolversTypes['LearnMediaReference']>, ParentType, ContextType>
  mediaType?: Resolver<Maybe<ResolversTypes['LearnMediaType']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnQuizAnswerResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnQuizAnswerResult'] = ResolversParentTypes['LearnQuizAnswerResult']
> = {
  isCorrect?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  questionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  quizId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnSearchTermSavedResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnSearchTermSavedResult'] = ResolversParentTypes['LearnSearchTermSavedResult']
> = {
  term?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnTagResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnTag'] = ResolversParentTypes['LearnTag']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnThemeLiteralResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnThemeLiteral'] = ResolversParentTypes['LearnThemeLiteral']
> = {
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnTierResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnTier'] = ResolversParentTypes['LearnTier']
> = {
  icon?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnTopicResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnTopic'] = ResolversParentTypes['LearnTopic']
> = {
  icon?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LearnVisualAssetResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LearnVisualAsset'] = ResolversParentTypes['LearnVisualAsset']
> = {
  __resolveType: TypeResolveFn<'Image', ParentType, ContextType>
}

export type LegacyUploadDocumentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LegacyUploadDocument'] = ResolversParentTypes['LegacyUploadDocument']
> = {
  documentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LegacyUploadDocumentResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LegacyUploadDocumentResult'] = ResolversParentTypes['LegacyUploadDocumentResult']
> = {
  __resolveType: TypeResolveFn<
    | 'FileDoesNotExistInS3'
    | 'FileTooLarge'
    | 'InvalidFile'
    | 'LegacyUploadDocument'
    | 'UploadDoesNotExist',
    ParentType,
    ContextType
  >
}

export type LessonResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Lesson'] = ResolversParentTypes['Lesson']
> = {
  authors?: Resolver<Array<ResolversTypes['LearnAuthor']>, ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  insights?: Resolver<Array<ResolversTypes['LearnInsight']>, ParentType, ContextType>
  media?: Resolver<ResolversTypes['LearnMediaReference'], ParentType, ContextType>
  metadata?: Resolver<ResolversTypes['LearnMetadata'], ParentType, ContextType>
  polls?: Resolver<Array<ResolversTypes['LearnPoll']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LessonPreviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LessonPreview'] = ResolversParentTypes['LessonPreview']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  parentContentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LessonPreviewLockedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LessonPreviewLocked'] = ResolversParentTypes['LessonPreviewLocked']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  parentContentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LifeCalculatorQuestionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LifeCalculatorQuestion'] = ResolversParentTypes['LifeCalculatorQuestion']
> = {
  column?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  maxDigits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  maxValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  minValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  placeholder?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  row?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  tip?: Resolver<Maybe<ResolversTypes['Tip']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['LifeCalculatorQuestionType'], ParentType, ContextType>
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LifeCalculatorSurveyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LifeCalculatorSurvey'] = ResolversParentTypes['LifeCalculatorSurvey']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  modals?: Resolver<Array<ResolversTypes['Modal']>, ParentType, ContextType>
  questions?: Resolver<Array<ResolversTypes['LifeCalculatorQuestion']>, ParentType, ContextType>
  tip?: Resolver<ResolversTypes['Tip'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  tutorialTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LifeCoverageBreakdownResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LifeCoverageBreakdown'] = ResolversParentTypes['LifeCoverageBreakdown']
> = {
  debt?: Resolver<ResolversTypes['LifeCoverageBreakdownCategory'], ParentType, ContextType>
  education?: Resolver<ResolversTypes['LifeCoverageBreakdownCategory'], ParentType, ContextType>
  expenses?: Resolver<ResolversTypes['LifeCoverageBreakdownCategory'], ParentType, ContextType>
  nearestCoverage?: Resolver<
    ResolversTypes['LifeCoverageBreakdownCategory'],
    ParentType,
    ContextType
  >
  savings?: Resolver<ResolversTypes['LifeCoverageBreakdownCategory'], ParentType, ContextType>
  totalNeeds?: Resolver<ResolversTypes['LifeCoverageBreakdownCategory'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LifeCoverageBreakdownCategoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LifeCoverageBreakdownCategory'] = ResolversParentTypes['LifeCoverageBreakdownCategory']
> = {
  tip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LifeQuoteQuestionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LifeQuoteQuestion'] = ResolversParentTypes['LifeQuoteQuestion']
> = {
  answers?: Resolver<Maybe<Array<ResolversTypes['QuestionAnswer']>>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  maxValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  minValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  placeholder?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  required?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  tip?: Resolver<Maybe<ResolversTypes['Tip']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['LifeQuoteQuestionType'], ParentType, ContextType>
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LifeQuoteResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LifeQuoteResponse'] = ResolversParentTypes['LifeQuoteResponse']
> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LifeQuoteResultSlidersResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LifeQuoteResultSliders'] = ResolversParentTypes['LifeQuoteResultSliders']
> = {
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  footer?: Resolver<ResolversTypes['Footer'], ParentType, ContextType>
  header?: Resolver<ResolversTypes['Header'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  modals?: Resolver<Array<ResolversTypes['Modal']>, ParentType, ContextType>
  navBody?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  navTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  partnerBody?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  partnerTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  partnerUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  premiums?: Resolver<Maybe<Array<ResolversTypes['Premium']>>, ParentType, ContextType>
  requestedCoverage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  sliders?: Resolver<Array<ResolversTypes['QuoteSlider']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LifeQuoteStepResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LifeQuoteStep'] = ResolversParentTypes['LifeQuoteStep']
> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  cta?: Resolver<Maybe<ResolversTypes['Cta']>, ParentType, ContextType>
  footer?: Resolver<Maybe<ResolversTypes['Footer']>, ParentType, ContextType>
  navBody?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  navTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  questions?: Resolver<Array<ResolversTypes['LifeQuoteQuestion']>, ParentType, ContextType>
  tip?: Resolver<Maybe<ResolversTypes['Tip']>, ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LifeQuoteSurveyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LifeQuoteSurvey'] = ResolversParentTypes['LifeQuoteSurvey']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  modals?: Resolver<Array<ResolversTypes['Modal']>, ParentType, ContextType>
  steps?: Resolver<Array<ResolversTypes['LifeQuoteStep']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LinkedAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LinkedAccount'] = ResolversParentTypes['LinkedAccount']
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  externalId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  externalSource?: Resolver<
    ResolversTypes['LinkedAccountExternalSourceEnum'],
    ParentType,
    ContextType
  >
  financialInstitution?: Resolver<
    Maybe<ResolversTypes['FinancialInstitution']>,
    ParentType,
    ContextType
  >
  financialInstitutionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  institutionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  linked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  linkedSubaccounts?: Resolver<Array<ResolversTypes['LinkedSubaccount']>, ParentType, ContextType>
  logoUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  publicToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  status?: Resolver<ResolversTypes['LinkedAccountStatusEnum'], ParentType, ContextType>
  transactionsLastSyncedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LinkedAccountAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LinkedAccountAlert'] = ResolversParentTypes['LinkedAccountAlert']
> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LinkedAccountAlertsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LinkedAccountAlertsResponse'] = ResolversParentTypes['LinkedAccountAlertsResponse']
> = {
  __resolveType: TypeResolveFn<
    'LinkedAccountAlert' | 'RelinkLinkedAccountAlert',
    ParentType,
    ContextType
  >
}

export type LinkedAccountNotFoundResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LinkedAccountNotFound'] = ResolversParentTypes['LinkedAccountNotFound']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LinkedSubaccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LinkedSubaccount'] = ResolversParentTypes['LinkedSubaccount']
> = {
  accountNumberLastFour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  allowedRoles?: Resolver<
    Array<ResolversTypes['LinkedSubaccountRoleEnum']>,
    ParentType,
    ContextType
  >
  balanceAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  balanceCurrent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  balanceLimit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  externalSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  linked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  linkedAccount?: Resolver<ResolversTypes['LinkedAccount'], ParentType, ContextType>
  linkedAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  officialName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  paymentEngines?: Resolver<
    Array<ResolversTypes['LinkedSubaccountPaymentEngineEnum']>,
    ParentType,
    ContextType
  >
  role?: Resolver<Maybe<ResolversTypes['LinkedSubaccountRoleEnum']>, ParentType, ContextType>
  routingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  status?: Resolver<Maybe<ResolversTypes['FundingSourceStatusEnum']>, ParentType, ContextType>
  subaccountSubtype?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  subaccountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  transactionsLastSyncedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  transfersApproved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  transfersAtRisk?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LinkManualFundingSourceResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LinkManualFundingSourceResult'] = ResolversParentTypes['LinkManualFundingSourceResult']
> = {
  __resolveType: TypeResolveFn<
    | 'CurrentBankStatementNotProvided'
    | 'FundingSourceAccount'
    | 'FundingSourceAlreadyExists'
    | 'FundingSourceCredentialsExceedLinkLimit'
    | 'InvalidAccountNumber'
    | 'InvalidManualLink'
    | 'InvalidRoutingNumber'
    | 'PreviousFundingSourcePending'
    | 'RdvVerificationRequired',
    ParentType,
    ContextType
  >
}

export type LinkSessionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LinkSessionResult'] = ResolversParentTypes['LinkSessionResult']
> = {
  __resolveType: TypeResolveFn<
    'RawLinkSession' | 'UnrecoverableLinkedAccountError' | 'WebviewLinkSession',
    ParentType,
    ContextType
  >
}

export type LiquidationUnavailableErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LiquidationUnavailableError'] = ResolversParentTypes['LiquidationUnavailableError']
> = {
  reason?: Resolver<ResolversTypes['LiquidationUnavailableReason'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LobThumbNailsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LOBThumbNails'] = ResolversParentTypes['LOBThumbNails']
> = {
  small?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  medium?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  large?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LockBankCardPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LockBankCardPayload'] = ResolversParentTypes['LockBankCardPayload']
> = {
  bankCard?: Resolver<Maybe<ResolversTypes['BankCard']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LoginAccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LoginAccess'] = ResolversParentTypes['LoginAccess']
> = {
  loginAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  loginRevokedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  loginRevokedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LoginRateLimitedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LoginRateLimitedException'] = ResolversParentTypes['LoginRateLimitedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LogoutDeviceResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogoutDeviceResult'] = ResolversParentTypes['LogoutDeviceResult']
> = {
  __resolveType: TypeResolveFn<
    'LogoutDeviceSuccess' | 'RefreshTokenNotFoundException' | 'DeviceNotFoundException',
    ParentType,
    ContextType
  >
}

export type LogoutDeviceSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogoutDeviceSuccess'] = ResolversParentTypes['LogoutDeviceSuccess']
> = {
  Device?: Resolver<ResolversTypes['Device'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LogoutResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogoutResult'] = ResolversParentTypes['LogoutResult']
> = {
  __resolveType: TypeResolveFn<
    'LogoutSuccess' | 'RefreshTokenNotFoundException' | 'AuthTokenNotFoundException',
    ParentType,
    ContextType
  >
}

export type LogoutSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogoutSuccess'] = ResolversParentTypes['LogoutSuccess']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface LongScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Long'], any> {
  name: 'Long'
}

export type MailInDocumentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MailInDocument'] = ResolversParentTypes['MailInDocument']
> = {
  mailType?: Resolver<ResolversTypes['MailInDocumentType'], ParentType, ContextType>
  recipientName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  sendDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  letterId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  letterUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  status?: Resolver<ResolversTypes['MailInNegotiationStatus'], ParentType, ContextType>
  letterThumbnails?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['LOBThumbNails']>>>,
    ParentType,
    ContextType
  >
  expectedDeliveryDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MakeInvestmentPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MakeInvestmentPayload'] = ResolversParentTypes['MakeInvestmentPayload']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MalformedRecurringTransferExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MalformedRecurringTransferException'] = ResolversParentTypes['MalformedRecurringTransferException']
> = {
  pathExceptions?: Resolver<
    Array<ResolversTypes['RecurringTransferPathException']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MarkAllAsReadResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MarkAllAsReadResult'] = ResolversParentTypes['MarkAllAsReadResult']
> = {
  __resolveType: TypeResolveFn<
    'MarkAllAsReadSuccess' | 'UpdateMessageFailed',
    ParentType,
    ContextType
  >
}

export type MarkAllAsReadSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MarkAllAsReadSuccess'] = ResolversParentTypes['MarkAllAsReadSuccess']
> = {
  markedAsReadCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MarketResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Market'] = ResolversParentTypes['Market']
> = {
  isOpen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MarketReturnResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MarketReturn'] = ResolversParentTypes['MarketReturn']
> = {
  marketValue?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  percent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MarkLearnContentAsHelpfulResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MarkLearnContentAsHelpfulResult'] = ResolversParentTypes['MarkLearnContentAsHelpfulResult']
> = {
  __resolveType: TypeResolveFn<
    'UpdateLearnContentHelpfulnessResult' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type MarkLearnContentAsViewedResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MarkLearnContentAsViewedResult'] = ResolversParentTypes['MarkLearnContentAsViewedResult']
> = {
  __resolveType: TypeResolveFn<
    'ViewedLearnContentResult' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type MaxAccountsCreatedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MaxAccountsCreatedException'] = ResolversParentTypes['MaxAccountsCreatedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MessageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']
> = {
  __resolveType: TypeResolveFn<'AlertMessage' | 'NotificationMessage', ParentType, ContextType>
  body?: Resolver<ResolversTypes['MessageTextAsset'], ParentType, ContextType>
  deepLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  icon?: Resolver<Maybe<ResolversTypes['MessageVisualAsset']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['MessageTextAsset'], ParentType, ContextType>
  trackingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
}

export type MessageConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MessageConnection'] = ResolversParentTypes['MessageConnection']
> = {
  edges?: Resolver<Array<ResolversTypes['MessageEdge']>, ParentType, ContextType>
  pageInfo?: Resolver<ResolversTypes['MessagePageInfo'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MessageEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MessageEdge'] = ResolversParentTypes['MessageEdge']
> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  node?: Resolver<ResolversTypes['Message'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MessagePageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MessagePageInfo'] = ResolversParentTypes['MessagePageInfo']
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MessageTextAssetResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MessageTextAsset'] = ResolversParentTypes['MessageTextAsset']
> = {
  __resolveType: TypeResolveFn<'StringKeyAsset', ParentType, ContextType>
}

export type MessageVisualAssetResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MessageVisualAsset'] = ResolversParentTypes['MessageVisualAsset']
> = {
  __resolveType: TypeResolveFn<'DesignLibraryIcon' | 'Image', ParentType, ContextType>
}

export type MfaMissingAuthAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MfaMissingAuthAlert'] = ResolversParentTypes['MfaMissingAuthAlert']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MightyOakCardWaiverResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MightyOakCardWaiver'] = ResolversParentTypes['MightyOakCardWaiver']
> = {
  mightyOakCardWaiverPeriodEndDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MightyOakCardWaiverExpiredExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MightyOakCardWaiverExpiredException'] = ResolversParentTypes['MightyOakCardWaiverExpiredException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MightyOakCardWaiverNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MightyOakCardWaiverNotFoundException'] = ResolversParentTypes['MightyOakCardWaiverNotFoundException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MightyOakWaiverResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MightyOakWaiverResult'] = ResolversParentTypes['MightyOakWaiverResult']
> = {
  __resolveType: TypeResolveFn<
    | 'BillingProfileNotFoundException'
    | 'MightyOakCardWaiver'
    | 'MightyOakCardWaiverExpiredException'
    | 'MightyOakCardWaiverNotFoundException',
    ParentType,
    ContextType
  >
}

export type MilestoneResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Milestone'] = ResolversParentTypes['Milestone']
> = {
  descriptionKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  destination?: Resolver<Maybe<ResolversTypes['Destination']>, ParentType, ContextType>
  detailsKey?: Resolver<Maybe<ResolversTypes['StringKey']>, ParentType, ContextType>
  educationTip?: Resolver<ResolversTypes['EducationTip'], ParentType, ContextType>
  firstCompletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  inactiveLogo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  lastCompletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  logo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  nameKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  progress?: Resolver<ResolversTypes['MilestoneProgress'], ParentType, ContextType>
  simpleNameKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['MilestoneStatus'], ParentType, ContextType>
  theme?: Resolver<ResolversTypes['MilestoneTheme'], ParentType, ContextType>
  timesCompleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  accountPoints?: Resolver<ResolversTypes['AccountPoints'], ParentType, ContextType>
  challengePoints?: Resolver<
    Maybe<ResolversTypes['ChallengePointsEarned']>,
    ParentType,
    ContextType,
    RequireFields<MilestoneChallengePointsArgs, 'challengeId'>
  >
  isRepeatable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  rule?: Resolver<ResolversTypes['MilestoneRuleType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneAccountLevelDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneAccountLevelDefinition'] = ResolversParentTypes['MilestoneAccountLevelDefinition']
> = {
  activeBackground?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  activeForeground?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  inactiveBackground?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  max?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  min?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneAchievementActionRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneAchievementActionRule'] = ResolversParentTypes['MilestoneAchievementActionRule']
> = {
  actions?: Resolver<
    Array<ResolversTypes['MilestoneAchievementActionType']>,
    ParentType,
    ContextType
  >
  milestoneID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneChallengeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneChallenge'] = ResolversParentTypes['MilestoneChallenge']
> = {
  closingAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  details?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  endsAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  faqDeepLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  milestonesCompleted?: Resolver<
    ResolversTypes['DiscreteMilestoneProgress'],
    ParentType,
    ContextType
  >
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  pointsEarned?: Resolver<
    Maybe<ResolversTypes['DiscreteMilestoneProgress']>,
    ParentType,
    ContextType
  >
  rulesDeepLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  groupedMilestones?: Resolver<Array<ResolversTypes['MilestoneGroup']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneChallengeDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneChallengeDefinition'] = ResolversParentTypes['MilestoneChallengeDefinition']
> = {
  details?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  endsAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  milestones?: Resolver<Array<ResolversTypes['MilestoneDefinition']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  startsAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneChallengePointsRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneChallengePointsRule'] = ResolversParentTypes['MilestoneChallengePointsRule']
> = {
  challengeID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  details?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  maxPointsAllowed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  pointsPerCompletion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneDefinition'] = ResolversParentTypes['MilestoneDefinition']
> = {
  arg1DateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  arg1Int?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  inactiveLogo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  isRepeatable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  logo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  milestoneGroups?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  rule?: Resolver<ResolversTypes['MilestoneRule'], ParentType, ContextType>
  theme?: Resolver<ResolversTypes['MilestoneTheme'], ParentType, ContextType>
  accountPointsRule?: Resolver<Maybe<ResolversTypes['AccountPointsRule']>, ParentType, ContextType>
  challengePointsRule?: Resolver<
    Maybe<ResolversTypes['MilestoneChallengePointsRule']>,
    ParentType,
    ContextType,
    RequireFields<MilestoneDefinitionChallengePointsRuleArgs, 'challengeId'>
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneEligibilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneEligibility'] = ResolversParentTypes['MilestoneEligibility']
> = {
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  scope?: Resolver<ResolversTypes['MilestoneEligibilityScope'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneGroupResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneGroup'] = ResolversParentTypes['MilestoneGroup']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneRuleGroup' | 'MilestoneThemeGroup',
    ParentType,
    ContextType
  >
}

export type MilestoneGroupAchievementActionRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneGroupAchievementActionRule'] = ResolversParentTypes['MilestoneGroupAchievementActionRule']
> = {
  actions?: Resolver<
    Array<ResolversTypes['MilestoneAchievementActionType']>,
    ParentType,
    ContextType
  >
  milestoneGroupID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneGroupDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneGroupDefinition'] = ResolversParentTypes['MilestoneGroupDefinition']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  milestoneIDs?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneHubResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneHub'] = ResolversParentTypes['MilestoneHub']
> = {
  levelDefinitions?: Resolver<
    Array<ResolversTypes['MilestoneAccountLevelDefinition']>,
    ParentType,
    ContextType
  >
  userAccount?: Resolver<ResolversTypes['MilestoneHubAccount'], ParentType, ContextType>
  groupedMilestones?: Resolver<Array<ResolversTypes['MilestoneGroup']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneHubAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneHubAccount'] = ResolversParentTypes['MilestoneHubAccount']
> = {
  accountPointsProgress?: Resolver<
    ResolversTypes['DiscreteMilestoneProgress'],
    ParentType,
    ContextType
  >
  currentLevel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  milestoneProgress?: Resolver<ResolversTypes['DiscreteMilestoneProgress'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneHubDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneHubDefinition'] = ResolversParentTypes['MilestoneHubDefinition']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  milestoneIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneProgressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneProgress'] = ResolversParentTypes['MilestoneProgress']
> = {
  __resolveType: TypeResolveFn<
    'CurrencyMilestoneProgress' | 'DiscreteMilestoneProgress',
    ParentType,
    ContextType
  >
}

export type MilestoneRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneRule'] = ResolversParentTypes['MilestoneRule']
> = {
  argInput?: Resolver<ResolversTypes['MilestoneRuleArgInput'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  themes?: Resolver<Array<ResolversTypes['MilestoneTheme']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneRuleGroupResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneRuleGroup'] = ResolversParentTypes['MilestoneRuleGroup']
> = {
  contents?: Resolver<Array<ResolversTypes['MilestoneRuleGroupContent']>, ParentType, ContextType>
  descriptionKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  groupCompletion?: Resolver<ResolversTypes['DiscreteMilestoneProgress'], ParentType, ContextType>
  logo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  nameKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  rule?: Resolver<ResolversTypes['MilestoneRuleType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneRuleGroupContentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneRuleGroupContent'] = ResolversParentTypes['MilestoneRuleGroupContent']
> = {
  __resolveType: TypeResolveFn<'Milestone', ParentType, ContextType>
}

export type MilestoneThemeGroupResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneThemeGroup'] = ResolversParentTypes['MilestoneThemeGroup']
> = {
  contents?: Resolver<Array<ResolversTypes['MilestoneThemeGroupContent']>, ParentType, ContextType>
  descriptionKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  destination?: Resolver<Maybe<ResolversTypes['Destination']>, ParentType, ContextType>
  groupCompletion?: Resolver<ResolversTypes['DiscreteMilestoneProgress'], ParentType, ContextType>
  groupPointsProgress?: Resolver<
    Maybe<ResolversTypes['DiscreteMilestoneProgress']>,
    ParentType,
    ContextType
  >
  isLocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  logo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  nameKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  theme?: Resolver<ResolversTypes['MilestoneTheme'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MilestoneThemeGroupContentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MilestoneThemeGroupContent'] = ResolversParentTypes['MilestoneThemeGroupContent']
> = {
  __resolveType: TypeResolveFn<'MilestoneRuleGroup' | 'Milestone', ParentType, ContextType>
}

export type MillisecondsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Milliseconds'] = ResolversParentTypes['Milliseconds']
> = {
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MiscDocumentRequestedUserAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MiscDocumentRequestedUserAlert'] = ResolversParentTypes['MiscDocumentRequestedUserAlert']
> = {
  requestedDocumentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MissingBeneficiarySsnExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MissingBeneficiarySsnException'] = ResolversParentTypes['MissingBeneficiarySsnException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MissingFundingSourceExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MissingFundingSourceException'] = ResolversParentTypes['MissingFundingSourceException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MissingRequiredAgreementsExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MissingRequiredAgreementsException'] = ResolversParentTypes['MissingRequiredAgreementsException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MissingSsnBeneficiaryAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MissingSsnBeneficiaryAlert'] = ResolversParentTypes['MissingSsnBeneficiaryAlert']
> = {
  beneficiary?: Resolver<ResolversTypes['Beneficiary'], ParentType, ContextType>
  beneficiaryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MissingSsnBeneficiaryAlertItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MissingSsnBeneficiaryAlertItem'] = ResolversParentTypes['MissingSsnBeneficiaryAlertItem']
> = {
  beneficiary?: Resolver<ResolversTypes['Beneficiary'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ModalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Modal'] = ResolversParentTypes['Modal']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  campaignId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  cta?: Resolver<Array<ResolversTypes['Cta']>, ParentType, ContextType>
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['ModalType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MonetaryAmountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MonetaryAmount'] = ResolversParentTypes['MonetaryAmount']
> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MonetaryIncentiveResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MonetaryIncentive'] = ResolversParentTypes['MonetaryIncentive']
> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  copyKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  recurring?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  totalAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MonthlyTotalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MonthlyTotal'] = ResolversParentTypes['MonthlyTotal']
> = {
  isPredicted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  totalAmount?: Resolver<ResolversTypes['FormattedMonetaryAmount'], ParentType, ContextType>
  yearMonth?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MutationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']
> = {
  destroySession?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType>
  changePIN?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationChangePinArgs, 'oldPIN' | 'newPIN' | 'questionId' | 'answer'>
  >
  resetPassword?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationResetPasswordArgs, 'email'>
  >
  resetPIN?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationResetPinArgs, 'email'>
  >
  updateNotification?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateNotificationArgs, 'channel' | 'active'>
  >
  agreeToAcceptanceDocument?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationAgreeToAcceptanceDocumentArgs, 'id'>
  >
  setPortfolio?: Resolver<
    ResolversTypes['User'],
    ParentType,
    ContextType,
    RequireFields<MutationSetPortfolioArgs, 'input'>
  >
  requestAccountClosure?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationRequestAccountClosureArgs, 'input'>
  >
  suspendDeposits?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationSuspendDepositsArgs, 'suspended'>
  >
  linkACHAccount?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationLinkAchAccountArgs, 'routing' | 'account'>
  >
  connectACHAccount?: Resolver<
    ResolversTypes['ConnectACHAccountResult'],
    ParentType,
    ContextType,
    RequireFields<MutationConnectAchAccountArgs, 'input'>
  >
  submitRDVs?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationSubmitRdVsArgs, 'deposits'>
  >
  redeemGiftcard?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationRedeemGiftcardArgs, 'pin'>
  >
  sessionRefresh?: Resolver<
    Maybe<ResolversTypes['Session']>,
    ParentType,
    ContextType,
    RequireFields<MutationSessionRefreshArgs, 'pin'>
  >
  refreshCookie?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType>
  createExtensionTransaction?: Resolver<
    Maybe<ResolversTypes['TransactionResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateExtensionTransactionArgs, 'campaignId'>
  >
  updateExtensionTransaction?: Resolver<
    Maybe<ResolversTypes['TransactionResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateExtensionTransactionArgs, 'id' | 'status'>
  >
  makeInvestment?: Resolver<
    ResolversTypes['MakeInvestmentPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationMakeInvestmentArgs, 'input'>
  >
  updateRecurringInvestment?: Resolver<
    ResolversTypes['RecurringInvestmentPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateRecurringInvestmentArgs, 'input'>
  >
  stopRecurringInvestment?: Resolver<
    ResolversTypes['RecurringInvestmentPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationStopRecurringInvestmentArgs, never>
  >
  createLadderQuote?: Resolver<
    Maybe<ResolversTypes['LadderResponse']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCreateLadderQuoteArgs,
      'firstName' | 'lastName' | 'age' | 'email' | 'phone' | 'address' | 'city' | 'state' | 'zip'
    >
  >
  updateLadderQuote?: Resolver<
    Maybe<ResolversTypes['LadderResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateLadderQuoteArgs, 'quoteId' | 'coverage'>
  >
  connectLadderCustomer?: Resolver<
    Maybe<ResolversTypes['LadderLinkResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationConnectLadderCustomerArgs, 'quoteId'>
  >
  createRollover?: Resolver<
    Maybe<ResolversTypes['PdfFormLinks']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateRolloverArgs, 'custodianName' | 'accountBalance'>
  >
  createTransfer?: Resolver<
    Maybe<ResolversTypes['PdfFormLinks']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTransferArgs, 'custodianName' | 'accountBalance'>
  >
  submitSignature?: Resolver<
    Maybe<ResolversTypes['PdfFormLinks']>,
    ParentType,
    ContextType,
    RequireFields<MutationSubmitSignatureArgs, 'signature'>
  >
  createInvestmentAccount?: Resolver<
    Maybe<ResolversTypes['CreateInvestmentAccountResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateInvestmentAccountArgs, never>
  >
  createIRAWithProfile?: Resolver<
    Maybe<ResolversTypes['CreateInvestmentAccountResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateIraWithProfileArgs, 'profileAttributes'>
  >
  createLaterContribution?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateLaterContributionArgs, 'accountId' | 'amount'>
  >
  laterTotalLiquidation?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationLaterTotalLiquidationArgs, 'investmentAccountId'>
  >
  laterCreateIndividualBeneficiary?: Resolver<
    Maybe<ResolversTypes['LaterIndividualBeneficiaryResponse']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationLaterCreateIndividualBeneficiaryArgs,
      'accountId' | 'firstName' | 'lastName' | 'birthDate'
    >
  >
  updateContactInfo?: Resolver<
    Maybe<ResolversTypes['User']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateContactInfoArgs, 'input'>
  >
  updateEmail?: Resolver<
    Maybe<ResolversTypes['User']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateEmailArgs, 'email'>
  >
  updateEmployment?: Resolver<
    Maybe<ResolversTypes['User']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateEmploymentArgs, 'input'>
  >
  updateInvestorQuestions?: Resolver<
    Maybe<ResolversTypes['User']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateInvestorQuestionsArgs, 'input'>
  >
  updatePersonalInfo?: Resolver<
    Maybe<ResolversTypes['User']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdatePersonalInfoArgs, 'input'>
  >
  updateUserInfo?: Resolver<
    Maybe<ResolversTypes['UpdateUserInfoResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateUserInfoArgs, 'input'>
  >
  updateSecurityQuestion?: Resolver<
    Maybe<ResolversTypes['User']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSecurityQuestionArgs, 'input'>
  >
  completeRegistration?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  createBeneficiary?: Resolver<
    ResolversTypes['CreateBeneficiaryResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateBeneficiaryArgs, 'input'>
  >
  deactivateAccount?: Resolver<
    Maybe<ResolversTypes['Account']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeactivateAccountArgs, 'accountId'>
  >
  deactivateBeneficiary?: Resolver<
    ResolversTypes['DeactivateBeneficiaryResult'],
    ParentType,
    ContextType,
    RequireFields<MutationDeactivateBeneficiaryArgs, 'id'>
  >
  setBeneficiarySsn?: Resolver<
    ResolversTypes['SetBeneficiarySsnResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSetBeneficiarySsnArgs, 'id' | 'ssn'>
  >
  updateAddress?: Resolver<
    Maybe<ResolversTypes['Address']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAddressArgs, 'addressType' | 'input'>
  >
  updateBeneficiaryInfo?: Resolver<
    ResolversTypes['UpdateBeneficiaryInfoResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateBeneficiaryInfoArgs, 'id' | 'input'>
  >
  updateProfile?: Resolver<
    Maybe<ResolversTypes['Profile']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateProfileArgs, 'input'>
  >
  updateSignature?: Resolver<
    Maybe<ResolversTypes['Signature']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSignatureArgs, 'signatureType' | 'svgFile'>
  >
  activateBankCard?: Resolver<
    Maybe<ResolversTypes['ActivateBankCardPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationActivateBankCardArgs, 'input'>
  >
  createBankAccount?: Resolver<
    Maybe<ResolversTypes['CreateBankAccountPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateBankAccountArgs, 'input'>
  >
  lockBankCard?: Resolver<
    Maybe<ResolversTypes['LockBankCardPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLockBankCardArgs, 'input'>
  >
  orderBankCard?: Resolver<
    Maybe<ResolversTypes['OrderBankCardResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationOrderBankCardArgs, 'input'>
  >
  unlockBankCard?: Resolver<Maybe<ResolversTypes['UnlockBankCardPayload']>, ParentType, ContextType>
  updateBankCardPin?: Resolver<
    Maybe<ResolversTypes['UpdateBankCardPinPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateBankCardPinArgs, 'input'>
  >
  reportBankCardLostStolen?: Resolver<
    Maybe<ResolversTypes['ReportBankCardLostStolenPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationReportBankCardLostStolenArgs, 'input'>
  >
  deleteExpiredBankCardOrder?: Resolver<
    Maybe<ResolversTypes['DeleteExpiredBankCardOrderResult']>,
    ParentType,
    ContextType
  >
  closeBankAccount?: Resolver<
    ResolversTypes['CloseBankAccountResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCloseBankAccountArgs, 'input'>
  >
  reissueBankCard?: Resolver<
    Maybe<ResolversTypes['ReissueBankCardResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationReissueBankCardArgs, 'input'>
  >
  submitSpendTransactionsDispute?: Resolver<
    ResolversTypes['SpendTransactionsDisputeResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSubmitSpendTransactionsDisputeArgs, 'input'>
  >
  createSavingsAccount?: Resolver<
    ResolversTypes['CreateSavingsAccountResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateSavingsAccountArgs, 'input'>
  >
  updateBankAccountGoal?: Resolver<
    ResolversTypes['UpdateBankAccountGoalResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateBankAccountGoalArgs, 'input'>
  >
  assignLinkedSubaccount?: Resolver<
    Maybe<ResolversTypes['LinkedSubaccount']>,
    ParentType,
    ContextType,
    RequireFields<MutationAssignLinkedSubaccountArgs, 'linkedSubaccountId' | 'input'>
  >
  createPlaidLinkedAccount?: Resolver<
    Maybe<ResolversTypes['LinkedAccount']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePlaidLinkedAccountArgs, 'publicToken' | 'input'>
  >
  generateLinkSession?: Resolver<
    ResolversTypes['LinkSessionResult'],
    ParentType,
    ContextType,
    RequireFields<MutationGenerateLinkSessionArgs, 'input'>
  >
  registerLinkSession?: Resolver<
    Maybe<ResolversTypes['RegisterLinkSessionResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationRegisterLinkSessionArgs, 'input'>
  >
  setLinkingError?: Resolver<
    Maybe<ResolversTypes['LinkedAccount']>,
    ParentType,
    ContextType,
    RequireFields<MutationSetLinkingErrorArgs, 'linkedAccountId' | 'linkingErrorCode'>
  >
  unlinkLinkedAccount?: Resolver<
    Maybe<ResolversTypes['LinkedAccount']>,
    ParentType,
    ContextType,
    RequireFields<MutationUnlinkLinkedAccountArgs, 'linkedAccountId'>
  >
  updateLinkedAccount?: Resolver<
    Maybe<ResolversTypes['LinkedAccount']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateLinkedAccountArgs, 'linkedAccountId' | 'input'>
  >
  roundUpProfile?: Resolver<
    Maybe<ResolversTypes['RoundUpProfile']>,
    ParentType,
    ContextType,
    RequireFields<MutationRoundUpProfileArgs, 'input'>
  >
  setManualRoundUps?: Resolver<
    Array<ResolversTypes['RoundUp']>,
    ParentType,
    ContextType,
    RequireFields<MutationSetManualRoundUpsArgs, 'roundUpIds'>
  >
  updateRoundUpAccount?: Resolver<
    Maybe<ResolversTypes['RoundUpAccount']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateRoundUpAccountArgs, 'enabled' | 'linkedSubaccountId'>
  >
  initiateTransfer?: Resolver<
    Maybe<ResolversTypes['InitiateTransferPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationInitiateTransferArgs, 'input'>
  >
  cancelTransfer?: Resolver<
    Maybe<ResolversTypes['CancelTransferPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCancelTransferArgs, 'id' | 'accountId'>
  >
  startCheckDeposit?: Resolver<
    Maybe<ResolversTypes['StartCheckDepositPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationStartCheckDepositArgs, 'input'>
  >
  uploadCheck?: Resolver<
    Maybe<ResolversTypes['UploadCheckPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUploadCheckArgs, 'input'>
  >
  completeCheckDeposit?: Resolver<
    Maybe<ResolversTypes['CompleteCheckDepositPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCompleteCheckDepositArgs, 'input'>
  >
  createSupportTicket?: Resolver<
    Maybe<ResolversTypes['SupportTicket']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSupportTicketArgs, 'input'>
  >
  createSupportTicketOrException?: Resolver<
    Maybe<ResolversTypes['SupportTicketResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSupportTicketOrExceptionArgs, 'input'>
  >
  createAuthenticatedSupportTicket?: Resolver<
    Maybe<ResolversTypes['SupportTicket']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAuthenticatedSupportTicketArgs, 'input'>
  >
  createSupportTicketWithCustomFields?: Resolver<
    Maybe<ResolversTypes['SupportTicketWithCustomFieldsResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSupportTicketWithCustomFieldsArgs, 'input'>
  >
  createSuspendedUserSupportTicket?: Resolver<
    Maybe<ResolversTypes['SupportTicketWithCustomFieldsResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSuspendedUserSupportTicketArgs, 'input'>
  >
  createDirectDepositLinkInfo?: Resolver<
    ResolversTypes['CreateDirectDepositLinkInfoSwitch'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateDirectDepositLinkInfoArgs, 'input'>
  >
  startAcornsPdfSwitch?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationStartAcornsPdfSwitchArgs, 'input'>
  >
  startOnlineSwitch?: Resolver<
    ResolversTypes['StartOnlineSwitchPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationStartOnlineSwitchArgs, 'input'>
  >
  startSubmittableSwitch?: Resolver<
    Maybe<ResolversTypes['StartSubmittableSwitchPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationStartSubmittableSwitchArgs, 'input'>
  >
  updateSuitability?: Resolver<
    Maybe<ResolversTypes['suitability_UpdateSuitabilityResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSuitabilityArgs, 'suitabilityInput'>
  >
  cancelCheckPayment?: Resolver<
    Maybe<ResolversTypes['CancelCheckPaymentResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationCancelCheckPaymentArgs, 'id'>
  >
  sendCheckPayment?: Resolver<
    Maybe<ResolversTypes['SendCheckPaymentResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationSendCheckPaymentArgs, 'input'>
  >
  acceptDocument?: Resolver<
    ResolversTypes['AcceptDocumentResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationAcceptDocumentArgs, 'input'>
  >
  addSecurityToPortfolio?: Resolver<
    ResolversTypes['AddSecurityToPortfolioResult'],
    ParentType,
    ContextType,
    RequireFields<MutationAddSecurityToPortfolioArgs, 'input'>
  >
  addSelfDirectedPortfolio?: Resolver<
    ResolversTypes['AddSelfDirectedPortfolioResult'],
    ParentType,
    ContextType,
    RequireFields<MutationAddSelfDirectedPortfolioArgs, 'input'>
  >
  cancelInvestment?: Resolver<
    ResolversTypes['CancelInvestmentResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCancelInvestmentArgs, 'input'>
  >
  cancelInvestmentAccountClosureRequest?: Resolver<
    ResolversTypes['CancelInvestmentAccountClosureRequestResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCancelInvestmentAccountClosureRequestArgs, 'input'>
  >
  closeInvestmentAccount?: Resolver<
    ResolversTypes['CloseInvestmentAccountResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCloseInvestmentAccountArgs, 'input'>
  >
  closeUserAccount?: Resolver<ResolversTypes['CloseUserAccountResult'], ParentType, ContextType>
  createProspectUser?: Resolver<
    ResolversTypes['CreateProspectUserResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateProspectUserArgs, 'input'>
  >
  createUploadUrl?: Resolver<
    ResolversTypes['CreateUploadUrlResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateUploadUrlArgs, 'input'>
  >
  enableQuarterlyRecaps?: Resolver<
    ResolversTypes['EnableQuarterlyRecapsResult'],
    ParentType,
    ContextType,
    RequireFields<MutationEnableQuarterlyRecapsArgs, 'input'>
  >
  legacyUploadDocument?: Resolver<
    ResolversTypes['LegacyUploadDocumentResult'],
    ParentType,
    ContextType,
    RequireFields<MutationLegacyUploadDocumentArgs, 'input'>
  >
  linkManualFundingSource?: Resolver<
    ResolversTypes['LinkManualFundingSourceResult'],
    ParentType,
    ContextType,
    RequireFields<MutationLinkManualFundingSourceArgs, 'input'>
  >
  openCoreInvestmentAccount?: Resolver<
    ResolversTypes['OpenCoreInvestmentAccountResult'],
    ParentType,
    ContextType,
    RequireFields<MutationOpenCoreInvestmentAccountArgs, 'input'>
  >
  openEarlyAccount?: Resolver<
    ResolversTypes['OpenEarlyAccountResult'],
    ParentType,
    ContextType,
    RequireFields<MutationOpenEarlyAccountArgs, 'input'>
  >
  partnerLinkManualFundingSource?: Resolver<
    ResolversTypes['PartnerLinkFundingSourceResult'],
    ParentType,
    ContextType,
    RequireFields<MutationPartnerLinkManualFundingSourceArgs, 'input'>
  >
  recordInvestmentAccountRecapView?: Resolver<
    ResolversTypes['RecordInvestmentAccountRecapViewResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRecordInvestmentAccountRecapViewArgs, 'input'>
  >
  regenerateInvestmentAccountRecapPublicToken?: Resolver<
    ResolversTypes['RegenerateInvestmentAccountRecapPublicTokenResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRegenerateInvestmentAccountRecapPublicTokenArgs, 'input'>
  >
  removeSecurityFromPortfolio?: Resolver<
    ResolversTypes['RemoveSecurityFromPortfolioResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRemoveSecurityFromPortfolioArgs, 'input'>
  >
  removeSelfDirectedPortfolio?: Resolver<
    ResolversTypes['RemoveSelfDirectedPortfolioResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRemoveSelfDirectedPortfolioArgs, 'input'>
  >
  reopenUserAccount?: Resolver<ResolversTypes['ReopenUserAccountResult'], ParentType, ContextType>
  requestEarlyAccountClosure?: Resolver<
    Array<ResolversTypes['RequestEarlyAccountClosureResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationRequestEarlyAccountClosureArgs, 'input'>
  >
  requestInvestmentAccountReopen?: Resolver<
    ResolversTypes['RequestInvestmentAccountReopenResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRequestInvestmentAccountReopenArgs, 'input'>
  >
  saveUploadUrl?: Resolver<
    ResolversTypes['LegacyUploadDocumentResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSaveUploadUrlArgs, 'input'>
  >
  setInvestmentAccountRecapPublicAccess?: Resolver<
    ResolversTypes['SetInvestmentAccountRecapPublicAccessResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSetInvestmentAccountRecapPublicAccessArgs, 'input'>
  >
  suspendUserDeposits?: Resolver<ResolversTypes['Void'], ParentType, ContextType>
  unauthenticatedCreateUploadUrl?: Resolver<
    ResolversTypes['CreateUploadUrlResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUnauthenticatedCreateUploadUrlArgs, 'input'>
  >
  unauthenticatedSaveUploadUrl?: Resolver<
    ResolversTypes['UnauthenticatedSaveUploadUrlResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUnauthenticatedSaveUploadUrlArgs, 'input'>
  >
  unsuspendUserDeposits?: Resolver<ResolversTypes['Void'], ParentType, ContextType>
  updateAccountPortfolio?: Resolver<
    ResolversTypes['UpdateAccountPortfolioResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAccountPortfolioArgs, 'input'>
  >
  updatePortfolioSecurities?: Resolver<
    ResolversTypes['UpdatePortfolioSecuritiesResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdatePortfolioSecuritiesArgs, 'input'>
  >
  updateRegistration?: Resolver<
    ResolversTypes['Result'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateRegistrationArgs, 'input'>
  >
  validateUserSuspendedUploadToken?: Resolver<
    ResolversTypes['ValidateUserSuspendedUploadTokenResult'],
    ParentType,
    ContextType,
    RequireFields<MutationValidateUserSuspendedUploadTokenArgs, 'input'>
  >
  initiateLaterProgramAccountContribution?: Resolver<
    Maybe<ResolversTypes['LaterProgramAccountContributionResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationInitiateLaterProgramAccountContributionArgs, 'input'>
  >
  laterWithdrawal?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationLaterWithdrawalArgs,
      'amount' | 'federalTaxes' | 'investmentAccountId' | 'stateTaxes' | 'taxYear'
    >
  >
  taxWithholdingAmounts?: Resolver<
    Maybe<ResolversTypes['TaxWithholdingAmounts']>,
    ParentType,
    ContextType,
    RequireFields<MutationTaxWithholdingAmountsArgs, 'investmentId' | 'totalSharesAmount'>
  >
  verifyLaterAccountOrError?: Resolver<
    ResolversTypes['LaterAccountInfoOrError'],
    ParentType,
    ContextType,
    RequireFields<MutationVerifyLaterAccountOrErrorArgs, 'investmentAccountId'>
  >
  scheduleRecurringTransfer?: Resolver<
    Maybe<ResolversTypes['ScheduleRecurringTransferResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationScheduleRecurringTransferArgs, 'input'>
  >
  cancelRecurringTransfer?: Resolver<
    Maybe<ResolversTypes['CancelRecurringTransferResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationCancelRecurringTransferArgs, 'id'>
  >
  protectApplyLifeQuote?: Resolver<
    Maybe<ResolversTypes['LifeQuoteResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationProtectApplyLifeQuoteArgs, 'quoteInput'>
  >
  protectCreateLifeQuote?: Resolver<
    Maybe<ResolversTypes['LifeQuoteResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationProtectCreateLifeQuoteArgs, 'input'>
  >
  protectUpdateCoverage?: Resolver<
    Maybe<ResolversTypes['UpdateCoverageResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationProtectUpdateCoverageArgs, 'coverageResponse'>
  >
  protectUpdateRecommendedLifeCoverage?: Resolver<
    Maybe<ResolversTypes['UpdateRecommendedCoverageResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationProtectUpdateRecommendedLifeCoverageArgs, 'calculatorInput'>
  >
  protectUpdateResponses?: Resolver<
    Maybe<ResolversTypes['ProtectHome']>,
    ParentType,
    ContextType,
    RequireFields<MutationProtectUpdateResponsesArgs, 'questionResponses'>
  >
  feedEvent?: Resolver<
    Maybe<ResolversTypes['ActionFeedEventResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationFeedEventArgs, 'feedEvent'>
  >
  addFavoritePartnerOffers?: Resolver<
    ResolversTypes['FavoritePartnerOfferGroup'],
    ParentType,
    ContextType,
    RequireFields<MutationAddFavoritePartnerOffersArgs, 'input'>
  >
  removeFavoritePartnerOffers?: Resolver<
    ResolversTypes['FavoritePartnerOfferGroup'],
    ParentType,
    ContextType,
    RequireFields<MutationRemoveFavoritePartnerOffersArgs, 'input'>
  >
  setFavoritePartnerOffers?: Resolver<
    ResolversTypes['FavoritePartnerOfferGroup'],
    ParentType,
    ContextType,
    RequireFields<MutationSetFavoritePartnerOffersArgs, 'input'>
  >
  createJobAlert?: Resolver<
    Maybe<ResolversTypes['CreateJobAlertResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateJobAlertArgs, 'alertCriteria'>
  >
  removeJobAlert?: Resolver<
    Maybe<ResolversTypes['RemoveJobAlertResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationRemoveJobAlertArgs, 'id'>
  >
  addMilestonesToGroup?: Resolver<
    ResolversTypes['AddMilestoneToMilestoneGroupDefinitionResult'],
    ParentType,
    ContextType,
    RequireFields<MutationAddMilestonesToGroupArgs, 'addMilestonesToGroupInput'>
  >
  createMilestoneGroupDefinition?: Resolver<
    ResolversTypes['CreateMilestoneGroupDefinitionResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateMilestoneGroupDefinitionArgs, 'createGroupDefinitionInput'>
  >
  removeMilestonesFromGroup?: Resolver<
    ResolversTypes['RemoveMilestoneFromMilestoneGroupDefinitionResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRemoveMilestonesFromGroupArgs, 'removeMilestonesFromGroupInput'>
  >
  addActionToMilestoneGroupAchievementActionRule?: Resolver<
    ResolversTypes['AddActionToMilestoneGroupAchievementActionRuleResult'],
    ParentType,
    ContextType,
    RequireFields<
      MutationAddActionToMilestoneGroupAchievementActionRuleArgs,
      'addActionToRuleInput'
    >
  >
  createMilestoneGroupAchievementActionRule?: Resolver<
    ResolversTypes['CreateMilestoneGroupAchievementActionRuleResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateMilestoneGroupAchievementActionRuleArgs, 'createRuleInput'>
  >
  removeActionFromMilestoneGroupAchievementActionRule?: Resolver<
    ResolversTypes['RemoveActionFromMilestoneGroupAchievementActionRuleResult'],
    ParentType,
    ContextType,
    RequireFields<
      MutationRemoveActionFromMilestoneGroupAchievementActionRuleArgs,
      'removeActionFromRuleInput'
    >
  >
  addMilestonesToMilestoneHubDefinition?: Resolver<
    ResolversTypes['AddMilestonesToMilestoneHubDefinitionResult'],
    ParentType,
    ContextType,
    RequireFields<MutationAddMilestonesToMilestoneHubDefinitionArgs, 'addActionToRuleInput'>
  >
  createMilestoneHubDefinition?: Resolver<
    ResolversTypes['CreateMilestoneHubDefinitionResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateMilestoneHubDefinitionArgs, 'createMilestoneHubDefinitionInput'>
  >
  removeMilestonesFromMilestoneHubDefinition?: Resolver<
    ResolversTypes['RemoveMilestonesFromMilestoneHubDefinitionResult'],
    ParentType,
    ContextType,
    RequireFields<
      MutationRemoveMilestonesFromMilestoneHubDefinitionArgs,
      'removeActionFromRuleInput'
    >
  >
  dismissMessage?: Resolver<
    ResolversTypes['UpdateMessageResult'],
    ParentType,
    ContextType,
    RequireFields<MutationDismissMessageArgs, 'input'>
  >
  hideMessageByExternalId?: Resolver<
    ResolversTypes['UpdateMessageResult'],
    ParentType,
    ContextType,
    RequireFields<MutationHideMessageByExternalIdArgs, 'input'>
  >
  markAllAsRead?: Resolver<ResolversTypes['MarkAllAsReadResult'], ParentType, ContextType>
  readMessage?: Resolver<
    ResolversTypes['UpdateMessageResult'],
    ParentType,
    ContextType,
    RequireFields<MutationReadMessageArgs, 'input'>
  >
  markLearnContentAsHelpful?: Resolver<
    ResolversTypes['MarkLearnContentAsHelpfulResult'],
    ParentType,
    ContextType,
    RequireFields<MutationMarkLearnContentAsHelpfulArgs, 'input'>
  >
  unmarkLearnContentAsHelpful?: Resolver<
    ResolversTypes['UnmarkLearnContentAsHelpfulResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUnmarkLearnContentAsHelpfulArgs, 'input'>
  >
  markLearnContentAsViewed?: Resolver<
    ResolversTypes['MarkLearnContentAsViewedResult'],
    ParentType,
    ContextType,
    RequireFields<MutationMarkLearnContentAsViewedArgs, 'input'>
  >
  updateLearnContentProgress?: Resolver<
    ResolversTypes['UpdateLearnProgressResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateLearnContentProgressArgs, 'input'>
  >
  answerLearnQuizQuestion?: Resolver<
    ResolversTypes['AnswerLearnQuizQuestionResult'],
    ParentType,
    ContextType,
    RequireFields<MutationAnswerLearnQuizQuestionArgs, 'input'>
  >
  updateElapsedTimeForLearnQuiz?: Resolver<
    ResolversTypes['UpdateElapsedTimeForLearnQuizResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateElapsedTimeForLearnQuizArgs, 'input'>
  >
  respondToLearnPoll?: Resolver<
    ResolversTypes['RespondToLearnPollResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRespondToLearnPollArgs, 'input'>
  >
  addSearchTermToLearnSearchHistory?: Resolver<
    ResolversTypes['AddSearchTermToLearnSearchHistoryResult'],
    ParentType,
    ContextType,
    RequireFields<MutationAddSearchTermToLearnSearchHistoryArgs, 'input'>
  >
  uploadDocuments?: Resolver<
    Array<ResolversTypes['FileOrException']>,
    ParentType,
    ContextType,
    RequireFields<MutationUploadDocumentsArgs, 'input'>
  >
  uploadUnsolicitedDocuments?: Resolver<
    Array<ResolversTypes['FileOrException']>,
    ParentType,
    ContextType,
    RequireFields<MutationUploadUnsolicitedDocumentsArgs, 'input'>
  >
  createDocumentUpload?: Resolver<
    ResolversTypes['CreateDocumentUpload'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateDocumentUploadArgs, 'input'>
  >
  initiateSMSChallenge?: Resolver<
    ResolversTypes['InitiateSMSChallengeResult'],
    ParentType,
    ContextType,
    RequireFields<MutationInitiateSmsChallengeArgs, 'input'>
  >
  initiateEmailChallenge?: Resolver<
    ResolversTypes['InitiateEmailChallengeResult'],
    ParentType,
    ContextType,
    RequireFields<MutationInitiateEmailChallengeArgs, 'input'>
  >
  reinitiateChallenge?: Resolver<
    ResolversTypes['ReinitiateSMSChallengeResult'],
    ParentType,
    ContextType,
    RequireFields<MutationReinitiateChallengeArgs, 'input'>
  >
  registerPhoneAuthenticator?: Resolver<
    ResolversTypes['RegisterPhoneAuthenticatorResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRegisterPhoneAuthenticatorArgs, 'input' | 'challengeAnswerInput'>
  >
  registerEmailAuthenticator?: Resolver<
    ResolversTypes['RegisterEmailAuthenticatorResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRegisterEmailAuthenticatorArgs, 'input' | 'challengeAnswerInput'>
  >
  authenticate?: Resolver<
    ResolversTypes['AuthenticateResult'],
    ParentType,
    ContextType,
    RequireFields<MutationAuthenticateArgs, 'input'>
  >
  setDefaultAuthenticator?: Resolver<
    ResolversTypes['SetDefaultAuthenticatorResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSetDefaultAuthenticatorArgs, 'input'>
  >
  refreshAuthToken?: Resolver<
    ResolversTypes['RefreshAuthTokenResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRefreshAuthTokenArgs, 'input'>
  >
  registerCredentials?: Resolver<
    ResolversTypes['RegisterCredentialsResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRegisterCredentialsArgs, 'input'>
  >
  createUser?: Resolver<
    Maybe<ResolversTypes['Session']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateUserArgs, 'input'>
  >
  passwordResetRequest?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationPasswordResetRequestArgs, 'input'>
  >
  verifyDevice?: Resolver<
    ResolversTypes['VerifyDeviceResult'],
    ParentType,
    ContextType,
    RequireFields<MutationVerifyDeviceArgs, 'input'>
  >
  blockDevice?: Resolver<
    ResolversTypes['BlockDeviceResult'],
    ParentType,
    ContextType,
    RequireFields<MutationBlockDeviceArgs, 'input'>
  >
  unblockDevice?: Resolver<
    ResolversTypes['UnblockDeviceResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUnblockDeviceArgs, 'input'>
  >
  setAuthenticationPIN?: Resolver<
    ResolversTypes['SetAuthenticationPINResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSetAuthenticationPinArgs, 'input'>
  >
  verifyPasswords?: Resolver<
    ResolversTypes['VerifyPasswordsResult'],
    ParentType,
    ContextType,
    RequireFields<MutationVerifyPasswordsArgs, 'input'>
  >
  updateCredentials?: Resolver<
    ResolversTypes['UpdateCredentialsResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCredentialsArgs, 'input'>
  >
  updateSecurityQuestionAndAnswer?: Resolver<
    ResolversTypes['UpdateSecurityQuestionAndAnswerResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSecurityQuestionAndAnswerArgs, 'input'>
  >
  resetPasswordByToken?: Resolver<
    ResolversTypes['ResetPasswordByTokenResult'],
    ParentType,
    ContextType,
    RequireFields<MutationResetPasswordByTokenArgs, 'input'>
  >
  resetPasswordWithToken?: Resolver<
    ResolversTypes['ResetPasswordWithTokenResult'],
    ParentType,
    ContextType,
    RequireFields<MutationResetPasswordWithTokenArgs, 'input'>
  >
  changePassword?: Resolver<
    Maybe<ResolversTypes['Void']>,
    ParentType,
    ContextType,
    RequireFields<MutationChangePasswordArgs, 'oldPassword' | 'newPassword'>
  >
  changePasswordAuth?: Resolver<
    ResolversTypes['ChangePasswordResult'],
    ParentType,
    ContextType,
    RequireFields<MutationChangePasswordAuthArgs, 'input'>
  >
  upgradeAuthentication?: Resolver<
    ResolversTypes['UpgradeAuthenticationResult'],
    ParentType,
    ContextType
  >
  logout?: Resolver<ResolversTypes['LogoutResult'], ParentType, ContextType>
  applyPromotion?: Resolver<
    ResolversTypes['ApplyPromotionResult'],
    ParentType,
    ContextType,
    RequireFields<MutationApplyPromotionArgs, 'input'>
  >
  deactivateTierSubscription?: Resolver<
    ResolversTypes['DeactivateTierSubscriptionResult'],
    ParentType,
    ContextType,
    RequireFields<MutationDeactivateTierSubscriptionArgs, 'input'>
  >
  requestSubscriptionMigrationWaiver?: Resolver<
    ResolversTypes['RequestSubscriptionMigrationWaiverResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRequestSubscriptionMigrationWaiverArgs, 'input'>
  >
  subscribeToTier?: Resolver<
    ResolversTypes['SubscribeToTierResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSubscribeToTierArgs, 'input'>
  >
  subscribeUserToTier?: Resolver<
    ResolversTypes['SubscribeUserToTierResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSubscribeUserToTierArgs, 'input'>
  >
  subscribeUserToTierByOpenAccounts?: Resolver<
    ResolversTypes['TierSubscription'],
    ParentType,
    ContextType
  >
  subscribeUserToTierByProductKey?: Resolver<
    ResolversTypes['TierSubscription'],
    ParentType,
    ContextType,
    RequireFields<MutationSubscribeUserToTierByProductKeyArgs, never>
  >
  unsubscribeUserFromTier?: Resolver<
    ResolversTypes['UnsubscribeUserFromTierResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUnsubscribeUserFromTierArgs, never>
  >
  splitDepositSettings?: Resolver<
    ResolversTypes['SplitDepositSettingsMutation'],
    ParentType,
    ContextType,
    RequireFields<MutationSplitDepositSettingsArgs, 'id'>
  >
  splitDeposit?: Resolver<
    ResolversTypes['SplitDepositMutation'],
    ParentType,
    ContextType,
    RequireFields<MutationSplitDepositArgs, 'id'>
  >
  configureSplitDepositDirectDepositIntentSetting?: Resolver<
    Maybe<ResolversTypes['ConfigureSplitDepositDirectDepositIntentSettingResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationConfigureSplitDepositDirectDepositIntentSettingArgs, 'input'>
  >
  configureSplitDepositDirectDepositSetting?: Resolver<
    Maybe<ResolversTypes['ConfigureSplitDepositDirectDepositSettingResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationConfigureSplitDepositDirectDepositSettingArgs, 'input'>
  >
  changeOutsideContributionAmount?: Resolver<
    ResolversTypes['ChangeOutsideContributionAmountResult'],
    ParentType,
    ContextType,
    RequireFields<MutationChangeOutsideContributionAmountArgs, 'input'>
  >
  createOutsideContribution?: Resolver<
    ResolversTypes['CreateOutsideContributionResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateOutsideContributionArgs, 'input'>
  >
  createOutsideContributionCheckoutCart?: Resolver<
    ResolversTypes['CreateOutsideContributionCheckoutCartResult'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateOutsideContributionCheckoutCartArgs, 'input'>
  >
  authenticateForFeeNegotiation?: Resolver<
    ResolversTypes['AuthenticateForFeeNegotiationResult'],
    ParentType,
    ContextType,
    RequireFields<MutationAuthenticateForFeeNegotiationArgs, 'input'>
  >
  authenticateForFeeNegotiationChallengeMethod?: Resolver<
    ResolversTypes['AuthenticateNegotiationStatusResult'],
    ParentType,
    ContextType,
    RequireFields<MutationAuthenticateForFeeNegotiationChallengeMethodArgs, 'input'>
  >
  authenticateForFeeNegotiationChallenge?: Resolver<
    ResolversTypes['AuthenticateNegotiationStatusResult'],
    ParentType,
    ContextType,
    RequireFields<MutationAuthenticateForFeeNegotiationChallengeArgs, 'input'>
  >
  submitBankFeeNegotiation?: Resolver<
    ResolversTypes['SubmitBankFeeNegotiationResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSubmitBankFeeNegotiationArgs, 'input'>
  >
  syncBankFeeTransactions?: Resolver<
    ResolversTypes['SyncBankFeeTransactionsResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSyncBankFeeTransactionsArgs, 'input'>
  >
  submitForBillNegotiation?: Resolver<
    ResolversTypes['BillNegotiationSubmitResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSubmitForBillNegotiationArgs, 'input'>
  >
  submitUserReportedBankFeeRefund?: Resolver<
    ResolversTypes['SubmitUserReportedBankFeeRefundResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSubmitUserReportedBankFeeRefundArgs, 'input'>
  >
  setNegotiationStatus?: Resolver<
    ResolversTypes['SetNegotiationStatusResult'],
    ParentType,
    ContextType,
    RequireFields<MutationSetNegotiationStatusArgs, 'input'>
  >
  setUserPartnerStatus?: Resolver<
    ResolversTypes['UserPartnerStatusResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationSetUserPartnerStatusArgs, 'input'>
  >
  registerProspect?: Resolver<
    ResolversTypes['RegisterProspectResult'],
    ParentType,
    ContextType,
    RequireFields<MutationRegisterProspectArgs, 'input'>
  >
  updateAttribution?: Resolver<
    ResolversTypes['UpdateAttributionResult'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAttributionArgs, 'input'>
  >
  stub?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<MutationStubArgs, 'id'>
  >
}

export type NegativeSecurityPercentErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NegativeSecurityPercentError'] = ResolversParentTypes['NegativeSecurityPercentError']
> = {
  securityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NegotiationServiceConnectionFailureResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NegotiationServiceConnectionFailure'] = ResolversParentTypes['NegotiationServiceConnectionFailure']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NextBillingDateResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NextBillingDate'] = ResolversParentTypes['NextBillingDate']
> = {
  next_billing_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NextTransferDateResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NextTransferDateResult'] = ResolversParentTypes['NextTransferDateResult']
> = {
  __resolveType: TypeResolveFn<
    'RecurringTransferDate' | 'MalformedRecurringTransferException',
    ParentType,
    ContextType
  >
}

export type NoBeneficiaryFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NoBeneficiaryFoundException'] = ResolversParentTypes['NoBeneficiaryFoundException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NoFundingSourceUserAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NoFundingSourceUserAlert'] = ResolversParentTypes['NoFundingSourceUserAlert']
> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NonBasicAccountOpenExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NonBasicAccountOpenException'] = ResolversParentTypes['NonBasicAccountOpenException']
> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NoProspectRecordResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NoProspectRecord'] = ResolversParentTypes['NoProspectRecord']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NotificationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']
> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  subcategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NotificationMessageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NotificationMessage'] = ResolversParentTypes['NotificationMessage']
> = {
  body?: Resolver<ResolversTypes['MessageTextAsset'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  deepLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  icon?: Resolver<Maybe<ResolversTypes['MessageVisualAsset']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  isDismissed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  messageCategory?: Resolver<ResolversTypes['MessageCategory'], ParentType, ContextType>
  messageType?: Resolver<ResolversTypes['MessageType'], ParentType, ContextType>
  readAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['MessageTextAsset'], ParentType, ContextType>
  trackingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NotificationsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Notifications'] = ResolversParentTypes['Notifications']
> = {
  emails?: Resolver<Maybe<Array<Maybe<ResolversTypes['Notification']>>>, ParentType, ContextType>
  pushes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Notification']>>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OccupationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Occupation'] = ResolversParentTypes['Occupation']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OfferResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Offer'] = ResolversParentTypes['Offer']
> = {
  availableIn?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  availableTo?: Resolver<ResolversTypes['OfferAvailability'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  expiresAfter?: Resolver<Maybe<ResolversTypes['OfferExpiration']>, ParentType, ContextType>
  expiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  offering?: Resolver<ResolversTypes['Offering'], ParentType, ContextType>
  price?: Resolver<ResolversTypes['OfferPrice'], ParentType, ContextType>
  termsUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['OfferType'], ParentType, ContextType>
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OfferExpirationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OfferExpiration'] = ResolversParentTypes['OfferExpiration']
> = {
  period?: Resolver<ResolversTypes['OfferExpirationPeriod'], ParentType, ContextType>
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OfferingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Offering'] = ResolversParentTypes['Offering']
> = {
  __resolveType: TypeResolveFn<'Product' | 'Tier', ParentType, ContextType>
}

export type OfferLocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OfferLocation'] = ResolversParentTypes['OfferLocation']
> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OfferPriceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OfferPrice'] = ResolversParentTypes['OfferPrice']
> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['OfferPriceType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OmnibusShareTransferIdResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OmnibusShareTransferId'] = ResolversParentTypes['OmnibusShareTransferId']
> = {
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OnboardingTipItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OnboardingTipItem'] = ResolversParentTypes['OnboardingTipItem']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  headline?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['OnboardingTipType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OnboardingTipsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OnboardingTips'] = ResolversParentTypes['OnboardingTips']
> = {
  items?: Resolver<Array<ResolversTypes['OnboardingTipItem']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OnlineSwitchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OnlineSwitch'] = ResolversParentTypes['OnlineSwitch']
> = {
  source?: Resolver<ResolversTypes['SwitchSource'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  vendorTargetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OpenAccountsExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OpenAccountsException'] = ResolversParentTypes['OpenAccountsException']
> = {
  openAccountTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OpenCoreInvestmentAccountResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OpenCoreInvestmentAccountResult'] = ResolversParentTypes['OpenCoreInvestmentAccountResult']
> = {
  __resolveType: TypeResolveFn<
    | 'CoreAccountAlreadyExistsException'
    | 'InvalidPortfolioIdException'
    | 'InvestmentAccount'
    | 'InvestmentAccountCreationException'
    | 'UserClosedException'
    | 'UserNotFoundException',
    ParentType,
    ContextType
  >
}

export type OpenEarlyAccountResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OpenEarlyAccountResult'] = ResolversParentTypes['OpenEarlyAccountResult']
> = {
  __resolveType: TypeResolveFn<
    | 'BeneficiaryAccountExistsException'
    | 'CoreAccountClosedException'
    | 'InternalErrorException'
    | 'InvalidStateException'
    | 'InvalidSubscriptionTierException'
    | 'InvalidTerminationAgeException'
    | 'InvestmentAccount'
    | 'MaxAccountsCreatedException'
    | 'MissingBeneficiarySsnException'
    | 'NoBeneficiaryFoundException'
    | 'UserClosedException'
    | 'UserNotFoundException'
    | 'UserNotVerifiedException',
    ParentType,
    ContextType
  >
}

export type OrderBankCardResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OrderBankCardResult'] = ResolversParentTypes['OrderBankCardResult']
> = {
  __resolveType: TypeResolveFn<'BankCardOrder', ParentType, ContextType>
}

export type OutsideContributionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OutsideContribution'] = ResolversParentTypes['OutsideContribution']
> = {
  accountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  checkoutCart?: Resolver<
    ResolversTypes['OutsideContributionCheckoutCart'],
    ParentType,
    ContextType
  >
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  investmentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  noteAuthor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  paymentMethodId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['ContributionState'], ParentType, ContextType>
  transferRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OutsideContributionCheckoutCartResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OutsideContributionCheckoutCart'] = ResolversParentTypes['OutsideContributionCheckoutCart']
> = {
  code?: Resolver<ResolversTypes['OutsideContributionCode'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  feeAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  investmentAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  paymentIntentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['CheckoutCartStatus'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OutsideContributionCodeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OutsideContributionCode'] = ResolversParentTypes['OutsideContributionCode']
> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  recipientFirstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  recipientId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  signupBonusUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OutsideContributionProspectResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OutsideContributionProspect'] = ResolversParentTypes['OutsideContributionProspect']
> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OwnerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Owner'] = ResolversParentTypes['Owner']
> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  greyLogoImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  colorBackgroundLogoImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  imageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  monochromeImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  twitterHandle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']
> = {
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PartnerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Partner'] = ResolversParentTypes['Partner']
> = {
  accountToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  authorization?: Resolver<
    Maybe<ResolversTypes['PartnerAuthorizationData']>,
    ParentType,
    ContextType
  >
  clientCredentialsToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  clientId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  existingAccountRedirectUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  externalId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  logoTypeUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  plaidInstitutionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  routingNumbers?: Resolver<
    Maybe<Array<ResolversTypes['PartnerRoutingNumber']>>,
    ParentType,
    ContextType
  >
  user?: Resolver<ResolversTypes['PartnerUserPayload'], ParentType, ContextType>
  website?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PartnerAuthorizationDataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PartnerAuthorizationData'] = ResolversParentTypes['PartnerAuthorizationData']
> = {
  provider?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  uid?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  accessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  refreshToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  expiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PartnerChoicesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PartnerChoices'] = ResolversParentTypes['PartnerChoices']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  icon?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PartnerDetailsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PartnerDetailsResponse'] = ResolversParentTypes['PartnerDetailsResponse']
> = {
  partnerLogoUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  partnerName?: Resolver<ResolversTypes['BenefitsPartner'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PartnerDocumentUrlResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PartnerDocumentUrlResponse'] = ResolversParentTypes['PartnerDocumentUrlResponse']
> = {
  documentUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PartnerLinkFundingSourceResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PartnerLinkFundingSourceResult'] = ResolversParentTypes['PartnerLinkFundingSourceResult']
> = {
  __resolveType: TypeResolveFn<
    | 'CurrentBankStatementNotProvided'
    | 'FundingSourceAccount'
    | 'FundingSourceAlreadyExists'
    | 'FundingSourceCredentialsExceedLinkLimit'
    | 'InvalidAccountNumber'
    | 'InvalidAccountToken'
    | 'InvalidManualLink'
    | 'InvalidRoutingNumber'
    | 'PreviousFundingSourcePending'
    | 'RdvVerificationRequired',
    ParentType,
    ContextType
  >
}

export type PartnerOfferGroupResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PartnerOfferGroup'] = ResolversParentTypes['PartnerOfferGroup']
> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  carouselType?: Resolver<ResolversTypes['CarouselType'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  offers?: Resolver<Array<ResolversTypes['PartnerOfferGroupItem']>, ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PartnerOfferGroupItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PartnerOfferGroupItem'] = ResolversParentTypes['PartnerOfferGroupItem']
> = {
  __resolveType: TypeResolveFn<
    'JobOffer' | 'PromoOffer' | 'JobSearchOffer' | 'EarnOffer',
    ParentType,
    ContextType
  >
}

export type PartnerRoutingNumberResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PartnerRoutingNumber'] = ResolversParentTypes['PartnerRoutingNumber']
> = {
  routingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PartnerUrlResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PartnerUrlResponse'] = ResolversParentTypes['PartnerUrlResponse']
> = {
  partnerUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['AcornsPartnerStatus'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PartnerUserPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PartnerUserPayload'] = ResolversParentTypes['PartnerUserPayload']
> = {
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  dob?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  ssn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  usCitizen?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PasswordResetFormResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PasswordResetForm'] = ResolversParentTypes['PasswordResetForm']
> = {
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  fields?: Resolver<
    Array<Maybe<ResolversTypes['PasswordResetFormFields']>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PasswordResetFormFieldsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PasswordResetFormFields'] = ResolversParentTypes['PasswordResetFormFields']
> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PastAnnotatedItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastAnnotatedItem'] = ResolversParentTypes['PastAnnotatedItem']
> = {
  __resolveType: TypeResolveFn<'EarlyGiftItem', ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  noteAuthor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
}

export type PastCoreCombinedItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastCoreCombinedItem'] = ResolversParentTypes['PastCoreCombinedItem']
> = {
  __resolveType: TypeResolveFn<'CoreInvestmentItem' | 'CoreRoundUpsItem', ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  isCombinedInvestment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
}

export type PastCoreItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastCoreItem'] = ResolversParentTypes['PastCoreItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PastCoreSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastCoreSummary'] = ResolversParentTypes['PastCoreSummary']
> = {
  investments?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  netReturns?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  dividends?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  foundMoneyRewards?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  referralRewards?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  withdrawals?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PastCoreTradedItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastCoreTradedItem'] = ResolversParentTypes['PastCoreTradedItem']
> = {
  __resolveType: TypeResolveFn<
    | 'CoreAdjustmentItem'
    | 'CoreDividendsItem'
    | 'CoreEmployeeCreditItem'
    | 'CoreFeeInvestmentItem'
    | 'CoreFoundMoneyRewardItem'
    | 'CoreGiftCardCreditRedemptionItem'
    | 'CoreInvestmentItem'
    | 'CoreLocalFoundMoneyItem'
    | 'CorePartnerRewardItem'
    | 'CoreRebalanceItem'
    | 'CoreReferralRewardItem'
    | 'CoreRoundUpsItem'
    | 'CoreWithdrawalItem'
    | 'EarlyDividendsItem'
    | 'EarlyFeeInvestmentItem'
    | 'EarlyGiftItem'
    | 'EarlyInvestmentItem'
    | 'EarlyWithdrawalItem'
    | 'LaterDividendsItem'
    | 'LaterFeeInvestmentItem'
    | 'LaterInvestmentItem'
    | 'LaterRebalanceItem'
    | 'LaterWithdrawalItem',
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
}

export type PastEarlyItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastEarlyItem'] = ResolversParentTypes['PastEarlyItem']
> = {
  __resolveType: TypeResolveFn<
    | 'EarlyDividendsItem'
    | 'EarlyFeeInvestmentItem'
    | 'EarlyGiftItem'
    | 'EarlyInvestmentItem'
    | 'EarlyWithdrawalItem',
    ParentType,
    ContextType
  >
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
}

export type PastEarlySummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastEarlySummary'] = ResolversParentTypes['PastEarlySummary']
> = {
  contributions?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  netReturns?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  dividends?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  withdrawals?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PastItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastItem'] = ResolversParentTypes['PastItem']
> = {
  __resolveType: TypeResolveFn<
    | 'CoreACHSubscriptionFeeItem'
    | 'CoreAdjustmentItem'
    | 'CoreCashForwardItem'
    | 'CoreCollectionItem'
    | 'CoreDividendsItem'
    | 'CoreEmployeeCreditItem'
    | 'CoreFeeInvestmentItem'
    | 'CoreFoundMoneyRewardItem'
    | 'CoreGiftCardCreditRedemptionItem'
    | 'CoreHoldingsTransferInItem'
    | 'CoreInvestmentItem'
    | 'CoreLocalFoundMoneyItem'
    | 'CorePartnerRewardItem'
    | 'CoreRebalanceItem'
    | 'CoreReferralRewardItem'
    | 'CoreRoundUpsItem'
    | 'CoreWithdrawalItem'
    | 'EarlyDividendsItem'
    | 'EarlyFeeInvestmentItem'
    | 'EarlyGiftItem'
    | 'EarlyInvestmentItem'
    | 'EarlyWithdrawalItem'
    | 'LaterDividendsItem'
    | 'LaterFeeInvestmentItem'
    | 'LaterInvestmentItem'
    | 'LaterRebalanceItem'
    | 'LaterWithdrawalItem'
    | 'PastCoreItem'
    | 'PastSpendItem'
    | 'SpendATMReimbursementItem'
    | 'SpendATMWithdrawalItem'
    | 'SpendBillPayItem'
    | 'SpendCheckDepositItem'
    | 'SpendCheckPaymentItem'
    | 'SpendDigitalWalletItem'
    | 'SpendDirectDepositItem'
    | 'SpendECheckItem'
    | 'SpendPurchaseItem'
    | 'SpendRealTimeRoundUpItem'
    | 'SpendTransferInItem'
    | 'SpendTransferOutItem',
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
}

export type PastItemConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastItemConnection'] = ResolversParentTypes['PastItemConnection']
> = {
  edges?: Resolver<Array<ResolversTypes['PastItemEdge']>, ParentType, ContextType>
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PastItemEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastItemEdge'] = ResolversParentTypes['PastItemEdge']
> = {
  node?: Resolver<Maybe<ResolversTypes['PastItem']>, ParentType, ContextType>
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PastLaterSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastLaterSummary'] = ResolversParentTypes['PastLaterSummary']
> = {
  contributions?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  currentYearContributions?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  dividends?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  netReturns?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  priorYearContributions?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  withdrawals?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PastSpendItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastSpendItem'] = ResolversParentTypes['PastSpendItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PastSpendSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastSpendSummary'] = ResolversParentTypes['PastSpendSummary']
> = {
  foundMoneyPlus?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  debits?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  deposits?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  debitsLast30Days?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  depositsLast30Days?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  availableBalance?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  instantRoundUps?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PastUserTransferItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PastUserTransferItem'] = ResolversParentTypes['PastUserTransferItem']
> = {
  __resolveType: TypeResolveFn<
    | 'CoreInvestmentItem'
    | 'CoreRoundUpsItem'
    | 'CoreWithdrawalItem'
    | 'EarlyInvestmentItem'
    | 'EarlyWithdrawalItem'
    | 'LaterInvestmentItem'
    | 'LaterWithdrawalItem'
    | 'SpendTransferInItem'
    | 'SpendTransferOutItem',
    ParentType,
    ContextType
  >
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
}

export type PdfDownloadUrlPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PdfDownloadUrlPayload'] = ResolversParentTypes['PdfDownloadUrlPayload']
> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PdfFormLinksResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PdfFormLinks'] = ResolversParentTypes['PdfFormLinks']
> = {
  formUrls?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PerformanceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Performance'] = ResolversParentTypes['Performance']
> = {
  accountValues?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['AccountValue']>>>,
    ParentType,
    ContextType
  >
  marketChange?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  marketChangePercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  marketChangePercentWithoutFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  marketChangeWithoutFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  previousCloseAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  totalInvested?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  totalInvestedWithPending?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PhoneResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Phone'] = ResolversParentTypes['Phone']
> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PhoneAuthenticatorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PhoneAuthenticator'] = ResolversParentTypes['PhoneAuthenticator']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  lastUsedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  phoneNumber?: Resolver<ResolversTypes['PhoneNumber'], ParentType, ContextType>
  deviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface PhoneNumberScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['PhoneNumber'], any> {
  name: 'PhoneNumber'
}

export type PhoneNumberOptedOutExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PhoneNumberOptedOutException'] = ResolversParentTypes['PhoneNumberOptedOutException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PoBoxAddressErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['POBoxAddressError'] = ResolversParentTypes['POBoxAddressError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PortfolioResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Portfolio'] = ResolversParentTypes['Portfolio']
> = {
  accountAllocation?: Resolver<ResolversTypes['PortfolioAllocation'], ParentType, ContextType>
  cashOwed?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  currentAllocationPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  currentBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  currentBalanceWithPending?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  customizationLevel?: Resolver<
    Maybe<ResolversTypes['PortfolioCustomizationLevel']>,
    ParentType,
    ContextType
  >
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  etfs?: Resolver<Maybe<Array<ResolversTypes['ETF']>>, ParentType, ContextType>
  holdings?: Resolver<Maybe<Array<ResolversTypes['PortfolioHolding']>>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  minimumManagedAllocationPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  nameKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  pendingBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  portfolioSecurities?: Resolver<
    Maybe<Array<ResolversTypes['PortfolioSecurity']>>,
    ParentType,
    ContextType
  >
  portfolioSecurityAllocations?: Resolver<
    Maybe<Array<ResolversTypes['PortfolioSecurityAllocation']>>,
    ParentType,
    ContextType
  >
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  projection?: Resolver<Maybe<ResolversTypes['PortfolioProjection']>, ParentType, ContextType>
  riskLevel?: Resolver<ResolversTypes['PortfolioRiskLevel'], ParentType, ContextType>
  theme?: Resolver<ResolversTypes['PortfolioTheme'], ParentType, ContextType>
  yearToDateReturn?: Resolver<Maybe<ResolversTypes['MarketReturn']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PortfolioAllocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioAllocation'] = ResolversParentTypes['PortfolioAllocation']
> = {
  allocationPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  portfolioId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PortfolioAlreadyRemovedErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioAlreadyRemovedError'] = ResolversParentTypes['PortfolioAlreadyRemovedError']
> = {
  portfolioRemovedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PortfolioHoldingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioHolding'] = ResolversParentTypes['PortfolioHolding']
> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PortfolioNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioNotFoundException'] = ResolversParentTypes['PortfolioNotFoundException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PortfolioNotSupportedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioNotSupportedException'] = ResolversParentTypes['PortfolioNotSupportedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PortfolioProjectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioProjection'] = ResolversParentTypes['PortfolioProjection']
> = {
  averageGrowthRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  highestGrowthRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  lowestGrowthRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PortfolioRemovalInProgressErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioRemovalInProgressError'] = ResolversParentTypes['PortfolioRemovalInProgressError']
> = {
  clientMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PortfolioSecurityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioSecurity'] = ResolversParentTypes['PortfolioSecurity']
> = {
  currentAllocationPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  marketValue?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  targetAllocationPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  todaysReturn?: Resolver<ResolversTypes['MarketReturn'], ParentType, ContextType>
  totalReturn?: Resolver<ResolversTypes['MarketReturn'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PortfolioSecurityAllocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioSecurityAllocation'] = ResolversParentTypes['PortfolioSecurityAllocation']
> = {
  allocationPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  investmentCategories?: Resolver<ResolversTypes['InvestmentCategory'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  removableFromBasePortfolio?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  security?: Resolver<Maybe<ResolversTypes['Security']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PortfolioSecurityLimitReachedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioSecurityLimitReached'] = ResolversParentTypes['PortfolioSecurityLimitReached']
> = {
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PortfolioUpdateFailedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioUpdateFailedException'] = ResolversParentTypes['PortfolioUpdateFailedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface PositiveFloatScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['PositiveFloat'], any> {
  name: 'PositiveFloat'
}

export type PremiumResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Premium'] = ResolversParentTypes['Premium']
> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  term?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PremiumsResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PremiumsResult'] = ResolversParentTypes['PremiumsResult']
> = {
  quoteData?: Resolver<ResolversTypes['QuoteResult'], ParentType, ContextType>
  quoteStatus?: Resolver<ResolversTypes['QuoteStatus'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PresentableProductResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PresentableProduct'] = ResolversParentTypes['PresentableProduct']
> = {
  descriptionKeys?: Resolver<Array<ResolversTypes['StringKey']>, ParentType, ContextType>
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PreviousFundingSourcePendingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PreviousFundingSourcePending'] = ResolversParentTypes['PreviousFundingSourcePending']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProductResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Product'] = ResolversParentTypes['Product']
> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  descriptionKeys?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  key?: Resolver<ResolversTypes['ProductKey'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProfileResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Profile'] = ResolversParentTypes['Profile']
> = {
  annualIncome?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  combinedAnnualIncome?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  employees?: Resolver<Maybe<ResolversTypes['Employees']>, ParentType, ContextType>
  employmentStatus?: Resolver<Maybe<ResolversTypes['EmploymentStatus']>, ParentType, ContextType>
  filingType?: Resolver<Maybe<ResolversTypes['FilingType']>, ParentType, ContextType>
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  fundsAvailability?: Resolver<Maybe<ResolversTypes['FundsAvailability']>, ParentType, ContextType>
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  maritalStatus?: Resolver<Maybe<ResolversTypes['MaritalStatus']>, ParentType, ContextType>
  retirementPlanAccess?: Resolver<
    Maybe<ResolversTypes['RetirementPlanAccess']>,
    ParentType,
    ContextType
  >
  selfEmployedIncome?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  signatures?: Resolver<Array<Maybe<ResolversTypes['Signature']>>, ParentType, ContextType>
  ssnLastFour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  transfersPaused?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PromoOfferResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PromoOffer'] = ResolversParentTypes['PromoOffer']
> = {
  backgroundImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  desktopBackgroundImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  partnerUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PromotionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Promotion'] = ResolversParentTypes['Promotion']
> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  duration?: Resolver<Maybe<ResolversTypes['PromotionDuration']>, ParentType, ContextType>
  expiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  incentives?: Resolver<Maybe<Array<ResolversTypes['Incentive']>>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  offering?: Resolver<ResolversTypes['Offering'], ParentType, ContextType>
  presentInContexts?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  termsUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PromotionConsumedErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PromotionConsumedError'] = ResolversParentTypes['PromotionConsumedError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PromotionDurationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PromotionDuration'] = ResolversParentTypes['PromotionDuration']
> = {
  period?: Resolver<ResolversTypes['PromotionDurationPeriod'], ParentType, ContextType>
  periodCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PromotionExpiredErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PromotionExpiredError'] = ResolversParentTypes['PromotionExpiredError']
> = {
  expiredAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PromotionNotFoundErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PromotionNotFoundError'] = ResolversParentTypes['PromotionNotFoundError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProspectResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Prospect'] = ResolversParentTypes['Prospect']
> = {
  __resolveType: TypeResolveFn<
    'GrowProspect' | 'LaterWaitlistProspect' | 'OutsideContributionProspect',
    ParentType,
    ContextType
  >
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
}

export type ProtectContextResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ProtectContext'] = ResolversParentTypes['ProtectContext']
> = {
  style?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  widgetType?: Resolver<ResolversTypes['WidgetReferenceType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProtectHomeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ProtectHome'] = ResolversParentTypes['ProtectHome']
> = {
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  widgets?: Resolver<Array<ResolversTypes['ProtectHomeWidget']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProtectHomeWidgetResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ProtectHomeWidget'] = ResolversParentTypes['ProtectHomeWidget']
> = {
  __resolveType: TypeResolveFn<
    'Education' | 'ExploreCarousel' | 'HomeIcons' | 'InsuranceSection',
    ParentType,
    ContextType
  >
}

export type ProtectLanderResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ProtectLander'] = ResolversParentTypes['ProtectLander']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  lastCheckinAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  tipTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  tutorialTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProtectLearningCenterResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ProtectLearningCenter'] = ResolversParentTypes['ProtectLearningCenter']
> = {
  articles?: Resolver<Array<ResolversTypes['Article']>, ParentType, ContextType>
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  eyebrow?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProviderResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Provider'] = ResolversParentTypes['Provider']
> = {
  cta?: Resolver<Maybe<ResolversTypes['Cta']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  isSelected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProviderSearchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ProviderSearch'] = ResolversParentTypes['ProviderSearch']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  insuranceType?: Resolver<ResolversTypes['InsuranceType'], ParentType, ContextType>
  providers?: Resolver<Array<ResolversTypes['Provider']>, ParentType, ContextType>
  searchImage?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  searchTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  subtitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  unknownProvider?: Resolver<ResolversTypes['UnknownProvider'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type QueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']
> = {
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  actionFeed?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['ActionCard']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryActionFeedArgs, never>
  >
  fundingSourceInfo?: Resolver<Maybe<ResolversTypes['FundingSourceInfo']>, ParentType, ContextType>
  activity?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Activity']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryActivityArgs, never>
  >
  acceptanceDocuments?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['AcceptanceDocument']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryAcceptanceDocumentsArgs, never>
  >
  allAcceptanceDocuments?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['AcceptanceDocument']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAcceptanceDocumentsArgs, never>
  >
  acceptanceDocument?: Resolver<
    Maybe<ResolversTypes['AcceptanceDocument']>,
    ParentType,
    ContextType,
    RequireFields<QueryAcceptanceDocumentArgs, 'type'>
  >
  recurringInvestmentSettings?: Resolver<
    Maybe<ResolversTypes['RecurringInvestmentSettings']>,
    ParentType,
    ContextType,
    RequireFields<QueryRecurringInvestmentSettingsArgs, never>
  >
  allInvestmentAccounts?: Resolver<
    Maybe<Array<ResolversTypes['InvestmentAccount']>>,
    ParentType,
    ContextType
  >
  market?: Resolver<Maybe<ResolversTypes['Market']>, ParentType, ContextType>
  performance?: Resolver<
    Maybe<ResolversTypes['Performance']>,
    ParentType,
    ContextType,
    RequireFields<QueryPerformanceArgs, 'start' | 'days'>
  >
  settings?: Resolver<Maybe<ResolversTypes['Settings']>, ParentType, ContextType>
  notifications?: Resolver<Maybe<ResolversTypes['Notifications']>, ParentType, ContextType>
  statements?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Statement']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryStatementsArgs, 'type'>
  >
  toggle?: Resolver<
    Maybe<ResolversTypes['Toggle']>,
    ParentType,
    ContextType,
    RequireFields<QueryToggleArgs, 'projectId' | 'toggleId'>
  >
  partner?: Resolver<
    Maybe<ResolversTypes['Partner']>,
    ParentType,
    ContextType,
    RequireFields<QueryPartnerArgs, 'oauthToken' | 'payloadToken'>
  >
  allSuitabilityQuestions?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SuitabilityQuestion']>>>,
    ParentType,
    ContextType
  >
  allSecurityQuestions?: Resolver<
    Maybe<Array<ResolversTypes['SecurityQuestion']>>,
    ParentType,
    ContextType
  >
  allCloseAccountReasons?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['CloseAccountReason']>>>,
    ParentType,
    ContextType
  >
  accountStrength?: Resolver<
    Maybe<ResolversTypes['AccountStrengthResult']>,
    ParentType,
    ContextType,
    RequireFields<QueryAccountStrengthArgs, never>
  >
  userStatus?: Resolver<Maybe<ResolversTypes['UserStatus']>, ParentType, ContextType>
  extensionOwners?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['ExtensionOwner']>>>,
    ParentType,
    ContextType
  >
  extensionCampaignStore?: Resolver<
    Maybe<ResolversTypes['ExtensionCampaignStore']>,
    ParentType,
    ContextType,
    RequireFields<QueryExtensionCampaignStoreArgs, 'id' | 'campaignId'>
  >
  extensionCampaignStores?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['ExtensionCampaignStore']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryExtensionCampaignStoresArgs, never>
  >
  extensionRewardsSummary?: Resolver<
    ResolversTypes['ExtensionRewardsSummary'],
    ParentType,
    ContextType
  >
  extensionTransactions?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['ExtensionTransaction']>>>,
    ParentType,
    ContextType
  >
  foundMoneyOffer?: Resolver<
    Maybe<ResolversTypes['FoundMoneyOffer']>,
    ParentType,
    ContextType,
    RequireFields<QueryFoundMoneyOfferArgs, 'id'>
  >
  foundMoneyOffers?: Resolver<
    Maybe<Array<ResolversTypes['FoundMoneyOffer']>>,
    ParentType,
    ContextType,
    RequireFields<QueryFoundMoneyOffersArgs, never>
  >
  foundMoneyCampaigns?: Resolver<
    Maybe<Array<ResolversTypes['FoundMoneyCampaign']>>,
    ParentType,
    ContextType,
    RequireFields<QueryFoundMoneyCampaignsArgs, never>
  >
  foundMoneyRewards?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['FoundMoneyReward']>>>,
    ParentType,
    ContextType
  >
  foundMoneySummary?: Resolver<Maybe<ResolversTypes['FoundMoneySummary']>, ParentType, ContextType>
  foundMoneyOfferCategories?: Resolver<
    Maybe<Array<ResolversTypes['FoundMoneyOfferCategory']>>,
    ParentType,
    ContextType
  >
  laterAccounts?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['LaterAccount']>>>,
    ParentType,
    ContextType
  >
  laterBeneficiaries?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['LaterIndividualBeneficiary']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryLaterBeneficiariesArgs, 'investmentAccountId'>
  >
  laterHistory?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['LaterHistoryItem']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryLaterHistoryArgs, 'accountId'>
  >
  laterPortfolioPerformance?: Resolver<
    Maybe<ResolversTypes['LaterPortfolioPerformance']>,
    ParentType,
    ContextType,
    RequireFields<QueryLaterPortfolioPerformanceArgs, 'accountId'>
  >
  laterDeposits?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['LaterDeposit']>>>,
    ParentType,
    ContextType
  >
  rolloverAccounts?: Resolver<Maybe<ResolversTypes['RolloverAccounts']>, ParentType, ContextType>
  custodianCompanies?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['CustodianCompany']>>>,
    ParentType,
    ContextType
  >
  withholdingDefaults?: Resolver<
    Maybe<ResolversTypes['WithholdingDefaults']>,
    ParentType,
    ContextType,
    RequireFields<QueryWithholdingDefaultsArgs, 'investmentAccountId' | 'withdrawalAmount'>
  >
  laterContributionHistory?: Resolver<
    Maybe<Array<ResolversTypes['ContributionHistoryItem']>>,
    ParentType,
    ContextType,
    RequireFields<QueryLaterContributionHistoryArgs, 'investmentAccountId'>
  >
  eligibility?: Resolver<
    Maybe<ResolversTypes['Eligibility']>,
    ParentType,
    ContextType,
    RequireFields<QueryEligibilityArgs, 'eligibilityScope'>
  >
  remoteStrings?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  accounts?: Resolver<
    Array<Maybe<ResolversTypes['Account']>>,
    ParentType,
    ContextType,
    RequireFields<QueryAccountsArgs, never>
  >
  addresses?: Resolver<
    Array<Maybe<ResolversTypes['Address']>>,
    ParentType,
    ContextType,
    RequireFields<QueryAddressesArgs, never>
  >
  alertHubBeneficiaryAlerts?: Resolver<
    Maybe<Array<ResolversTypes['AlertHubBeneficiaryAlert']>>,
    ParentType,
    ContextType
  >
  beneficiaries?: Resolver<Maybe<Array<ResolversTypes['Beneficiary']>>, ParentType, ContextType>
  beneficiary?: Resolver<
    Maybe<ResolversTypes['Beneficiary']>,
    ParentType,
    ContextType,
    RequireFields<QueryBeneficiaryArgs, 'id'>
  >
  beneficiaryAlerts?: Resolver<Maybe<Array<ResolversTypes['Alert']>>, ParentType, ContextType>
  occupations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Occupation']>>>, ParentType, ContextType>
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>
  signatures?: Resolver<
    Array<Maybe<ResolversTypes['Signature']>>,
    ParentType,
    ContextType,
    RequireFields<QuerySignaturesArgs, never>
  >
  MightyOakCardWaiver?: Resolver<ResolversTypes['MightyOakWaiverResult'], ParentType, ContextType>
  billingCycle?: Resolver<
    Maybe<ResolversTypes['BillingCycle']>,
    ParentType,
    ContextType,
    RequireFields<QueryBillingCycleArgs, never>
  >
  billingCycles?: Resolver<
    Maybe<Array<ResolversTypes['BillingCycle']>>,
    ParentType,
    ContextType,
    RequireFields<QueryBillingCyclesArgs, never>
  >
  fee?: Resolver<
    Maybe<ResolversTypes['Fee']>,
    ParentType,
    ContextType,
    RequireFields<QueryFeeArgs, 'id'>
  >
  fees?: Resolver<
    Maybe<Array<ResolversTypes['Fee']>>,
    ParentType,
    ContextType,
    RequireFields<QueryFeesArgs, never>
  >
  nextBillingDate?: Resolver<Maybe<ResolversTypes['NextBillingDate']>, ParentType, ContextType>
  addressDeliverability?: Resolver<
    Maybe<ResolversTypes['AddressDeliverabilityResult']>,
    ParentType,
    ContextType,
    RequireFields<QueryAddressDeliverabilityArgs, 'input'>
  >
  allBankAccounts?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['BankAccount']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryAllBankAccountsArgs, 'input'>
  >
  allBankCards?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['BankCard']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryAllBankCardsArgs, never>
  >
  bankMetadata?: Resolver<Maybe<ResolversTypes['BankMetadata']>, ParentType, ContextType>
  bankCardOrder?: Resolver<Maybe<ResolversTypes['BankCardOrder']>, ParentType, ContextType>
  bankTransaction?: Resolver<
    Maybe<ResolversTypes['BankTransaction']>,
    ParentType,
    ContextType,
    RequireFields<QueryBankTransactionArgs, 'id'>
  >
  allBankDocuments?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['BankDocument']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryAllBankDocumentsArgs, 'input'>
  >
  allBankStatements?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['BankStatement']>>>,
    ParentType,
    ContextType
  >
  spendAlerts?: Resolver<Maybe<Array<Maybe<ResolversTypes['SpendAlert']>>>, ParentType, ContextType>
  allBankTransactions?: Resolver<
    Maybe<ResolversTypes['BankTransactionConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryAllBankTransactionsArgs, never>
  >
  spendAtms?: Resolver<
    Maybe<ResolversTypes['SpendAtmsResult']>,
    ParentType,
    ContextType,
    RequireFields<QuerySpendAtmsArgs, 'input'>
  >
  spendAccount?: Resolver<Maybe<ResolversTypes['SpendAccount']>, ParentType, ContextType>
  bankCardReissue?: Resolver<Maybe<ResolversTypes['BankCardReissue']>, ParentType, ContextType>
  bankAccountClosureReasons?: Resolver<
    Array<ResolversTypes['BankAccountClosureReason']>,
    ParentType,
    ContextType
  >
  savingsAccountEligibilityByUserId?: Resolver<
    Maybe<ResolversTypes['SavingsAccountEligibility']>,
    ParentType,
    ContextType,
    RequireFields<QuerySavingsAccountEligibilityByUserIdArgs, 'type'>
  >
  bankAccountDisclosures?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['BankAccountDisclosure']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryBankAccountDisclosuresArgs, 'input'>
  >
  bankingEmploymentStatuses?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  financialInstitution?: Resolver<
    Maybe<ResolversTypes['FinancialInstitution']>,
    ParentType,
    ContextType,
    RequireFields<QueryFinancialInstitutionArgs, 'externalId' | 'linkable'>
  >
  financialInstitutions?: Resolver<
    ResolversTypes['FinancialInstitutionTypePagination'],
    ParentType,
    ContextType,
    RequireFields<
      QueryFinancialInstitutionsArgs,
      'includeBlacklisted' | 'supportsAuth' | 'supportsFunding' | 'includeDirectBank' | 'pageInput'
    >
  >
  linkedAccount?: Resolver<
    Maybe<ResolversTypes['LinkedAccount']>,
    ParentType,
    ContextType,
    RequireFields<QueryLinkedAccountArgs, 'linkedAccountId'>
  >
  linkedAccountAlerts?: Resolver<
    Maybe<Array<ResolversTypes['LinkedAccountAlertsResponse']>>,
    ParentType,
    ContextType
  >
  linkedAccountWebhooks?: Resolver<ResolversTypes['Webhooks'], ParentType, ContextType>
  linkedAccounts?: Resolver<
    Array<ResolversTypes['LinkedAccount']>,
    ParentType,
    ContextType,
    RequireFields<QueryLinkedAccountsArgs, 'externalSources'>
  >
  linkedSubaccount?: Resolver<
    Maybe<ResolversTypes['LinkedSubaccount']>,
    ParentType,
    ContextType,
    RequireFields<QueryLinkedSubaccountArgs, 'linkedSubaccountId'>
  >
  linkedSubaccounts?: Resolver<
    Array<ResolversTypes['LinkedSubaccount']>,
    ParentType,
    ContextType,
    RequireFields<QueryLinkedSubaccountsArgs, never>
  >
  roundUpAccount?: Resolver<
    Maybe<ResolversTypes['RoundUpAccount']>,
    ParentType,
    ContextType,
    RequireFields<QueryRoundUpAccountArgs, 'linkedSubaccountId'>
  >
  roundUpAccounts?: Resolver<Array<ResolversTypes['RoundUpAccount']>, ParentType, ContextType>
  roundUpProfile?: Resolver<Maybe<ResolversTypes['RoundUpProfile']>, ParentType, ContextType>
  roundUps?: Resolver<
    ResolversTypes['RoundUpTypePagination'],
    ParentType,
    ContextType,
    RequireFields<QueryRoundUpsArgs, 'state' | 'pageInput'>
  >
  allPastCoreItems?: Resolver<
    Maybe<ResolversTypes['PastItemConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryAllPastCoreItemsArgs, never>
  >
  allPastLaterItems?: Resolver<
    Maybe<ResolversTypes['PastItemConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryAllPastLaterItemsArgs, never>
  >
  allPastSpendItems?: Resolver<
    Maybe<ResolversTypes['PastItemConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryAllPastSpendItemsArgs, never>
  >
  allPastEarlyItems?: Resolver<
    Maybe<ResolversTypes['PastItemConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryAllPastEarlyItemsArgs, 'beneficiaryAccountId'>
  >
  pastCoreSummary?: Resolver<Maybe<ResolversTypes['PastCoreSummary']>, ParentType, ContextType>
  pastEarlySummary?: Resolver<
    Maybe<ResolversTypes['PastEarlySummary']>,
    ParentType,
    ContextType,
    RequireFields<QueryPastEarlySummaryArgs, 'beneficiaryAccountId'>
  >
  pastSpendSummary?: Resolver<Maybe<ResolversTypes['PastSpendSummary']>, ParentType, ContextType>
  allPastCoreItemChildren?: Resolver<
    Maybe<Array<ResolversTypes['PastItem']>>,
    ParentType,
    ContextType,
    RequireFields<QueryAllPastCoreItemChildrenArgs, 'pastItemId'>
  >
  pastSpendTransactionItem?: Resolver<
    Maybe<ResolversTypes['PastItem']>,
    ParentType,
    ContextType,
    RequireFields<QueryPastSpendTransactionItemArgs, 'transactionId'>
  >
  allPastPendingItems?: Resolver<Maybe<Array<ResolversTypes['PastItem']>>, ParentType, ContextType>
  allTransferableFrom?: Resolver<
    Maybe<Array<ResolversTypes['TransferableFrom']>>,
    ParentType,
    ContextType
  >
  allTransferableTo?: Resolver<
    Maybe<Array<ResolversTypes['TransferableTo']>>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTransferableToArgs, 'input'>
  >
  estimatedTransferDates?: Resolver<
    Maybe<ResolversTypes['EstimatedTransferDatesPayload']>,
    ParentType,
    ContextType,
    RequireFields<QueryEstimatedTransferDatesArgs, 'input'>
  >
  allReturnedCheckDeposits?: Resolver<
    Maybe<Array<ResolversTypes['ReturnedCheckDeposit']>>,
    ParentType,
    ContextType
  >
  evaluateCheckDeposit?: Resolver<
    Maybe<ResolversTypes['EvaluateCheckDepositPayload']>,
    ParentType,
    ContextType,
    RequireFields<QueryEvaluateCheckDepositArgs, 'input'>
  >
  allContactCategories?: Resolver<
    Maybe<Array<ResolversTypes['ContactCategory']>>,
    ParentType,
    ContextType
  >
  allSupportArticles?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SupportArticle']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryAllSupportArticlesArgs, never>
  >
  allSupportCategories?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SupportCategory']>>>,
    ParentType,
    ContextType
  >
  allSupportSections?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SupportSection']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryAllSupportSectionsArgs, never>
  >
  allSupportTicketForms?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SupportTicketForm']>>>,
    ParentType,
    ContextType
  >
  supportChatEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  supportSchedule?: Resolver<
    Maybe<ResolversTypes['ScheduleResult']>,
    ParentType,
    ContextType,
    RequireFields<QuerySupportScheduleArgs, 'input'>
  >
  contactFormAlert?: Resolver<Maybe<ResolversTypes['ContactFormAlert']>, ParentType, ContextType>
  supportMostCommonFaq?: Resolver<
    Maybe<Array<ResolversTypes['ContactFaq']>>,
    ParentType,
    ContextType
  >
  helpFormContent?: Resolver<
    Maybe<ResolversTypes['HelpFormContent']>,
    ParentType,
    ContextType,
    RequireFields<QueryHelpFormContentArgs, 'form'>
  >
  supportArticle?: Resolver<
    Maybe<ResolversTypes['SupportArticle']>,
    ParentType,
    ContextType,
    RequireFields<QuerySupportArticleArgs, 'id'>
  >
  supportSection?: Resolver<
    Maybe<ResolversTypes['SupportSection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySupportSectionArgs, 'sectionId'>
  >
  supportCategory?: Resolver<
    Maybe<ResolversTypes['SupportCategory']>,
    ParentType,
    ContextType,
    RequireFields<QuerySupportCategoryArgs, 'categoryId'>
  >
  supportArticlesBySectionId?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SupportArticle']>>>,
    ParentType,
    ContextType,
    RequireFields<QuerySupportArticlesBySectionIdArgs, 'sectionId'>
  >
  instantSearchSupportArticles?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SearchSupportArticleResult']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryInstantSearchSupportArticlesArgs, 'query' | 'isPrivate'>
  >
  supportTicketForm?: Resolver<
    Maybe<ResolversTypes['SupportTicketForm']>,
    ParentType,
    ContextType,
    RequireFields<QuerySupportTicketFormArgs, 'id'>
  >
  supportTicketFormField?: Resolver<
    Maybe<ResolversTypes['SupportTicketFormField']>,
    ParentType,
    ContextType,
    RequireFields<QuerySupportTicketFormFieldArgs, 'id'>
  >
  searchSupportArticles?: Resolver<
    Maybe<ResolversTypes['SearchSupportResult']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchSupportArticlesArgs, 'query' | 'isPrivate'>
  >
  supportSectionsByCategoryId?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SupportSection']>>>,
    ParentType,
    ContextType,
    RequireFields<QuerySupportSectionsByCategoryIdArgs, 'categoryId'>
  >
  userWinbackScore?: Resolver<
    Maybe<ResolversTypes['userWinbackScoreRes']>,
    ParentType,
    ContextType,
    RequireFields<QueryUserWinbackScoreArgs, 'userId'>
  >
  allCardTrackingStatuses?: Resolver<
    Maybe<Array<ResolversTypes['CardDeliveryStatus']>>,
    ParentType,
    ContextType,
    RequireFields<QueryAllCardTrackingStatusesArgs, never>
  >
  directDepositState?: Resolver<
    ResolversTypes['DirectDepositStatePayload'],
    ParentType,
    ContextType
  >
  generateUpdatedPdf?: Resolver<
    Maybe<ResolversTypes['GenerateUpdatedPdfPayload']>,
    ParentType,
    ContextType,
    RequireFields<QueryGenerateUpdatedPdfArgs, 'input'>
  >
  parameterizedPdf?: Resolver<
    Maybe<ResolversTypes['GenerateUpdatedPdfPayload']>,
    ParentType,
    ContextType,
    RequireFields<QueryParameterizedPdfArgs, 'input'>
  >
  pdfDownloadUrl?: Resolver<
    Maybe<ResolversTypes['PdfDownloadUrlPayload']>,
    ParentType,
    ContextType,
    RequireFields<QueryPdfDownloadUrlArgs, 'input'>
  >
  searchEmployers?: Resolver<
    Maybe<ResolversTypes['SearchEmployersPayload']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchEmployersArgs, 'input'>
  >
  topEmployers?: Resolver<ResolversTypes['TopEmployerPayload'], ParentType, ContextType>
  recommendedPortfolio?: Resolver<
    Maybe<ResolversTypes['suitability_Portfolio']>,
    ParentType,
    ContextType
  >
  suitabilityResponses?: Resolver<
    Maybe<Array<ResolversTypes['suitability_SuitabilityResponse']>>,
    ParentType,
    ContextType
  >
  suitabilityServiceEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  allCheckPayments?: Resolver<
    Maybe<ResolversTypes['AllCheckPaymentsResult']>,
    ParentType,
    ContextType,
    RequireFields<QueryAllCheckPaymentsArgs, 'pageInput'>
  >
  estimatedCheckPaymentDates?: Resolver<
    Maybe<ResolversTypes['EstimatedCheckPaymentDates']>,
    ParentType,
    ContextType
  >
  verifyCheckPaymentRecipientAddress?: Resolver<
    Maybe<ResolversTypes['VerifyCheckPaymentRecipientAddressResult']>,
    ParentType,
    ContextType,
    RequireFields<QueryVerifyCheckPaymentRecipientAddressArgs, 'input'>
  >
  closureReasonsByInvestmentAccountType?: Resolver<
    Array<ResolversTypes['InvestmentAccountClosureReason']>,
    ParentType,
    ContextType,
    RequireFields<QueryClosureReasonsByInvestmentAccountTypeArgs, never>
  >
  combinedPerformanceByUserId?: Resolver<
    ResolversTypes['CombinedPerformance'],
    ParentType,
    ContextType,
    RequireFields<QueryCombinedPerformanceByUserIdArgs, never>
  >
  cryptoEtf?: Resolver<Maybe<ResolversTypes['ETF']>, ParentType, ContextType>
  earlyAccountClosureReasons?: Resolver<
    Array<ResolversTypes['InvestmentAccountClosureReason']>,
    ParentType,
    ContextType
  >
  earlyAccountStateRegulation?: Resolver<
    ResolversTypes['EarlyAccountStateRegulationResult'],
    ParentType,
    ContextType,
    RequireFields<QueryEarlyAccountStateRegulationArgs, never>
  >
  earlyAccountTransferInfo?: Resolver<
    Maybe<ResolversTypes['EarlyAccountTransferInfo']>,
    ParentType,
    ContextType,
    RequireFields<QueryEarlyAccountTransferInfoArgs, 'investmentAccountId'>
  >
  etf?: Resolver<
    Maybe<ResolversTypes['ETF']>,
    ParentType,
    ContextType,
    RequireFields<QueryEtfArgs, 'symbol'>
  >
  fundingSourceAccounts?: Resolver<
    Maybe<Array<ResolversTypes['FundingSourceAccount']>>,
    ParentType,
    ContextType
  >
  investment?: Resolver<
    Maybe<ResolversTypes['Investment']>,
    ParentType,
    ContextType,
    RequireFields<QueryInvestmentArgs, 'id'>
  >
  investmentAccount?: Resolver<
    Maybe<ResolversTypes['InvestmentAccount']>,
    ParentType,
    ContextType,
    RequireFields<QueryInvestmentAccountArgs, 'id'>
  >
  investmentAccountByBeneficiaryId?: Resolver<
    Maybe<ResolversTypes['InvestmentAccount']>,
    ParentType,
    ContextType,
    RequireFields<QueryInvestmentAccountByBeneficiaryIdArgs, 'beneficiaryId'>
  >
  investmentAccountRecap?: Resolver<
    Maybe<ResolversTypes['InvestmentAccountRecap']>,
    ParentType,
    ContextType,
    RequireFields<QueryInvestmentAccountRecapArgs, 'id'>
  >
  investmentAccountRecapByPublicToken?: Resolver<
    Maybe<ResolversTypes['InvestmentAccountRecap']>,
    ParentType,
    ContextType,
    RequireFields<QueryInvestmentAccountRecapByPublicTokenArgs, 'publicToken'>
  >
  investmentAccountsByUserId?: Resolver<
    Array<ResolversTypes['InvestmentAccount']>,
    ParentType,
    ContextType,
    RequireFields<QueryInvestmentAccountsByUserIdArgs, never>
  >
  invitationForUser?: Resolver<Maybe<ResolversTypes['Referral']>, ParentType, ContextType>
  portfolios?: Resolver<
    Array<ResolversTypes['Portfolio']>,
    ParentType,
    ContextType,
    RequireFields<QueryPortfoliosArgs, never>
  >
  referralForUser?: Resolver<Maybe<ResolversTypes['Referral']>, ParentType, ContextType>
  registration?: Resolver<ResolversTypes['Result'], ParentType, ContextType>
  userAlerts?: Resolver<Maybe<Array<ResolversTypes['UserAlertsResponse']>>, ParentType, ContextType>
  laterAlerts?: Resolver<Maybe<Array<ResolversTypes['Alert']>>, ParentType, ContextType>
  laterContributionAbility?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['ContributionAbility']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryLaterContributionAbilityArgs, never>
  >
  laterUserContributionAbility?: Resolver<
    Maybe<ResolversTypes['LaterContributionAbilityResult']>,
    ParentType,
    ContextType
  >
  pastLaterSummary?: Resolver<
    Maybe<ResolversTypes['PastLaterSummary']>,
    ParentType,
    ContextType,
    RequireFields<QueryPastLaterSummaryArgs, never>
  >
  withholdingEstimates?: Resolver<
    Maybe<ResolversTypes['WithholdingEstimates']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryWithholdingEstimatesArgs,
      | 'federalWithholdingPercentage'
      | 'investmentAccountId'
      | 'stateWithholdingPercentage'
      | 'withdrawalAmount'
    >
  >
  yearLaterReport?: Resolver<
    ResolversTypes['YearLaterReport'],
    ParentType,
    ContextType,
    RequireFields<QueryYearLaterReportArgs, 'year'>
  >
  recurringTransfers?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['RecurringTransfer']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryRecurringTransfersArgs, never>
  >
  nextTransferDate?: Resolver<
    Maybe<ResolversTypes['NextTransferDateResult']>,
    ParentType,
    ContextType,
    RequireFields<QueryNextTransferDateArgs, 'recurrenceRule'>
  >
  protectContext?: Resolver<Maybe<ResolversTypes['ProtectContext']>, ParentType, ContextType>
  protectCoverageShop?: Resolver<Maybe<ResolversTypes['CoverageShop']>, ParentType, ContextType>
  protectHome?: Resolver<Maybe<ResolversTypes['ProtectHome']>, ParentType, ContextType>
  protectInsuranceHome?: Resolver<
    Maybe<ResolversTypes['InsuranceHome']>,
    ParentType,
    ContextType,
    RequireFields<QueryProtectInsuranceHomeArgs, 'insuranceType'>
  >
  protectLander?: Resolver<Maybe<ResolversTypes['ProtectLander']>, ParentType, ContextType>
  protectLearningCenter?: Resolver<
    Maybe<ResolversTypes['ProtectLearningCenter']>,
    ParentType,
    ContextType
  >
  protectLifeCalculatorSurvey?: Resolver<
    Maybe<ResolversTypes['LifeCalculatorSurvey']>,
    ParentType,
    ContextType
  >
  protectLifeQuotePremiums?: Resolver<
    Maybe<ResolversTypes['PremiumsResult']>,
    ParentType,
    ContextType,
    RequireFields<QueryProtectLifeQuotePremiumsArgs, 'parameters'>
  >
  protectLifeQuoteSurvey?: Resolver<
    Maybe<ResolversTypes['LifeQuoteSurvey']>,
    ParentType,
    ContextType,
    RequireFields<QueryProtectLifeQuoteSurveyArgs, 'providerName'>
  >
  protectOnboardingQuestions?: Resolver<
    Maybe<Array<ResolversTypes['Question']>>,
    ParentType,
    ContextType
  >
  protectProviders?: Resolver<
    Maybe<ResolversTypes['ProviderSearch']>,
    ParentType,
    ContextType,
    RequireFields<QueryProtectProvidersArgs, 'insuranceType'>
  >
  protectRecommendations?: Resolver<
    Maybe<ResolversTypes['Recommendations']>,
    ParentType,
    ContextType
  >
  protectRecommendedLifeCoverage?: Resolver<
    Maybe<ResolversTypes['RecommendedLifeCoverage']>,
    ParentType,
    ContextType
  >
  activitySummary?: Resolver<
    Maybe<ResolversTypes['ActivitySummaryResponse']>,
    ParentType,
    ContextType,
    RequireFields<QueryActivitySummaryArgs, never>
  >
  finishSetup?: Resolver<
    Maybe<ResolversTypes['FinishSetup']>,
    ParentType,
    ContextType,
    RequireFields<QueryFinishSetupArgs, 'feedContext' | 'accountId'>
  >
  onboardingTips?: Resolver<
    Maybe<ResolversTypes['OnboardingTips']>,
    ParentType,
    ContextType,
    RequireFields<QueryOnboardingTipsArgs, 'feedContext'>
  >
  personalizedFoundMoney?: Resolver<
    Maybe<Array<ResolversTypes['FoundMoneyCampaignV2']>>,
    ParentType,
    ContextType
  >
  personalizedFoundMoneyV2?: Resolver<
    Maybe<Array<ResolversTypes['FoundMoneyCampaignV2']>>,
    ParentType,
    ContextType
  >
  activeEarnOffers?: Resolver<
    ResolversTypes['EarnOfferQueryPage'],
    ParentType,
    ContextType,
    RequireFields<QueryActiveEarnOffersArgs, never>
  >
  earnOfferByCampaignOfferId?: Resolver<
    Maybe<ResolversTypes['EarnOffer']>,
    ParentType,
    ContextType,
    RequireFields<QueryEarnOfferByCampaignOfferIdArgs, 'campaignOfferId' | 'origin' | 'sessionId'>
  >
  favoriteEarnOffers?: Resolver<
    ResolversTypes['FavoritePartnerOfferGroup'],
    ParentType,
    ContextType
  >
  searchActiveEarnOffers?: Resolver<
    ResolversTypes['EarnOfferQueryPage'],
    ParentType,
    ContextType,
    RequireFields<QuerySearchActiveEarnOffersArgs, 'searchTerm'>
  >
  partnerOfferGroup?: Resolver<
    Maybe<ResolversTypes['PartnerOfferGroup']>,
    ParentType,
    ContextType,
    RequireFields<QueryPartnerOfferGroupArgs, 'id'>
  >
  partnerOfferGroupsByType?: Resolver<
    Maybe<Array<ResolversTypes['PartnerOfferGroup']>>,
    ParentType,
    ContextType,
    RequireFields<QueryPartnerOfferGroupsByTypeArgs, 'partnerOfferGroupsTypeInput'>
  >
  jobAlerts?: Resolver<Maybe<Array<ResolversTypes['JobAlert']>>, ParentType, ContextType>
  jobSearch?: Resolver<
    Maybe<Array<ResolversTypes['jobs_Offer']>>,
    ParentType,
    ContextType,
    RequireFields<QueryJobSearchArgs, 'searchCriteria'>
  >
  jobSearchV2?: Resolver<
    Maybe<ResolversTypes['jobs_OfferConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryJobSearchV2Args, 'searchCriteria' | 'pagination'>
  >
  jobSearchPage?: Resolver<Maybe<ResolversTypes['JobSearchPage']>, ParentType, ContextType>
  jobEducationContent?: Resolver<Maybe<ResolversTypes['jobs_Education']>, ParentType, ContextType>
  milestoneRules?: Resolver<Maybe<Array<ResolversTypes['MilestoneRule']>>, ParentType, ContextType>
  milestone?: Resolver<
    Maybe<ResolversTypes['Milestone']>,
    ParentType,
    ContextType,
    RequireFields<QueryMilestoneArgs, 'id'>
  >
  milestonesByTheme?: Resolver<
    Maybe<ResolversTypes['MilestoneThemeGroup']>,
    ParentType,
    ContextType,
    RequireFields<QueryMilestonesByThemeArgs, 'theme'>
  >
  milestoneHub?: Resolver<Maybe<ResolversTypes['MilestoneHub']>, ParentType, ContextType>
  milestoneHubDefinition?: Resolver<
    Maybe<ResolversTypes['MilestoneHubDefinition']>,
    ParentType,
    ContextType,
    RequireFields<QueryMilestoneHubDefinitionArgs, 'id'>
  >
  milestoneHubDefinitions?: Resolver<
    Array<ResolversTypes['MilestoneHubDefinition']>,
    ParentType,
    ContextType
  >
  featuredMilestones?: Resolver<ResolversTypes['FeaturedMilestones'], ParentType, ContextType>
  featuredMilestones_v2?: Resolver<
    Maybe<ResolversTypes['FeaturedMilestonesV2']>,
    ParentType,
    ContextType
  >
  milestoneDefinition?: Resolver<
    Maybe<ResolversTypes['MilestoneDefinition']>,
    ParentType,
    ContextType,
    RequireFields<QueryMilestoneDefinitionArgs, 'id'>
  >
  milestoneDefinitions?: Resolver<
    Maybe<Array<ResolversTypes['MilestoneDefinition']>>,
    ParentType,
    ContextType
  >
  milestoneGroupDefinition?: Resolver<
    Maybe<ResolversTypes['MilestoneGroupDefinition']>,
    ParentType,
    ContextType,
    RequireFields<QueryMilestoneGroupDefinitionArgs, 'groupID'>
  >
  milestoneGroupDefinitions?: Resolver<
    Maybe<Array<ResolversTypes['MilestoneGroupDefinition']>>,
    ParentType,
    ContextType
  >
  milestoneChallengePointsRuleByMilestoneIdByChallengeId?: Resolver<
    Maybe<ResolversTypes['MilestoneChallengePointsRule']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryMilestoneChallengePointsRuleByMilestoneIdByChallengeIdArgs,
      'milestoneID' | 'challengeID'
    >
  >
  milestoneChallengePointsRulesByMilestoneId?: Resolver<
    Maybe<Array<ResolversTypes['MilestoneChallengePointsRule']>>,
    ParentType,
    ContextType,
    RequireFields<QueryMilestoneChallengePointsRulesByMilestoneIdArgs, 'milestoneID'>
  >
  milestoneChallenge?: Resolver<
    Maybe<ResolversTypes['MilestoneChallenge']>,
    ParentType,
    ContextType,
    RequireFields<QueryMilestoneChallengeArgs, 'id'>
  >
  promoMilestoneChallengeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  milestoneEligibilityByScopes?: Resolver<
    Maybe<Array<ResolversTypes['MilestoneEligibility']>>,
    ParentType,
    ContextType,
    RequireFields<QueryMilestoneEligibilityByScopesArgs, 'scopes'>
  >
  milestoneHubEligible?: Resolver<
    Maybe<ResolversTypes['Eligibility']>,
    ParentType,
    ContextType,
    RequireFields<QueryMilestoneHubEligibleArgs, 'registrationCompletedAt'>
  >
  milestoneAchievementActionRule?: Resolver<
    Maybe<ResolversTypes['MilestoneAchievementActionRule']>,
    ParentType,
    ContextType,
    RequireFields<QueryMilestoneAchievementActionRuleArgs, 'milestoneID'>
  >
  milestoneAchievementActionRules?: Resolver<
    Array<ResolversTypes['MilestoneAchievementActionRule']>,
    ParentType,
    ContextType
  >
  milestoneGroupAchievementActionRule?: Resolver<
    Maybe<ResolversTypes['MilestoneGroupAchievementActionRule']>,
    ParentType,
    ContextType,
    RequireFields<QueryMilestoneGroupAchievementActionRuleArgs, 'milestoneGroupID'>
  >
  milestoneGroupAchievementActionRules?: Resolver<
    Maybe<Array<ResolversTypes['MilestoneGroupAchievementActionRule']>>,
    ParentType,
    ContextType
  >
  accountPointsRuleByMilestoneId?: Resolver<
    Maybe<ResolversTypes['AccountPointsRule']>,
    ParentType,
    ContextType,
    RequireFields<QueryAccountPointsRuleByMilestoneIdArgs, 'milestoneID'>
  >
  accountPointsRules?: Resolver<
    Maybe<Array<ResolversTypes['AccountPointsRule']>>,
    ParentType,
    ContextType
  >
  milestoneAccountLevelDefinitions?: Resolver<
    Maybe<Array<ResolversTypes['MilestoneAccountLevelDefinition']>>,
    ParentType,
    ContextType
  >
  milestoneAchievementActionTypes?: Resolver<
    Array<ResolversTypes['MilestoneAchievementActionType']>,
    ParentType,
    ContextType
  >
  allMessages?: Resolver<
    Maybe<Array<ResolversTypes['Message']>>,
    ParentType,
    ContextType,
    RequireFields<QueryAllMessagesArgs, never>
  >
  messages?: Resolver<
    Maybe<ResolversTypes['MessageConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryMessagesArgs, never>
  >
  learnContentCategories?: Resolver<
    Maybe<Array<ResolversTypes['LearnContentCategory']>>,
    ParentType,
    ContextType
  >
  featuredLearnContentPersonalizedByUserId?: Resolver<
    Maybe<Array<ResolversTypes['FeaturedLearnContentPreview']>>,
    ParentType,
    ContextType
  >
  trendingLearnContentByTierId?: Resolver<
    Maybe<Array<ResolversTypes['TrendingLearnContentPreview']>>,
    ParentType,
    ContextType,
    RequireFields<QueryTrendingLearnContentByTierIdArgs, 'tierId'>
  >
  trendingLearnContentByTopicId?: Resolver<
    Maybe<Array<ResolversTypes['TrendingLearnContentPreview']>>,
    ParentType,
    ContextType,
    RequireFields<QueryTrendingLearnContentByTopicIdArgs, 'topicId'>
  >
  trendingLearnContentPersonalizedByUserId?: Resolver<
    Maybe<Array<ResolversTypes['TrendingLearnContentPreview']>>,
    ParentType,
    ContextType
  >
  learnMedia?: Resolver<
    Maybe<ResolversTypes['LearnMedia']>,
    ParentType,
    ContextType,
    RequireFields<QueryLearnMediaArgs, 'id'>
  >
  learnNextStepActionsByMediaId?: Resolver<
    Maybe<Array<ResolversTypes['LearnNextStepAction']>>,
    ParentType,
    ContextType,
    RequireFields<QueryLearnNextStepActionsByMediaIdArgs, 'mediaId'>
  >
  relatedLearnContentByMediaId?: Resolver<
    Maybe<Array<ResolversTypes['LearnContentPreview']>>,
    ParentType,
    ContextType,
    RequireFields<QueryRelatedLearnContentByMediaIdArgs, 'mediaId'>
  >
  course?: Resolver<
    Maybe<ResolversTypes['Course']>,
    ParentType,
    ContextType,
    RequireFields<QueryCourseArgs, 'id'>
  >
  coursesByTierId?: Resolver<
    Maybe<Array<ResolversTypes['CoursePreview']>>,
    ParentType,
    ContextType,
    RequireFields<QueryCoursesByTierIdArgs, 'tierId'>
  >
  coursesByTopicId?: Resolver<
    Maybe<Array<ResolversTypes['CoursePreview']>>,
    ParentType,
    ContextType,
    RequireFields<QueryCoursesByTopicIdArgs, 'topicId'>
  >
  coursesByTopicId_v2?: Resolver<
    Maybe<Array<ResolversTypes['LearnCoursePreview']>>,
    ParentType,
    ContextType,
    RequireFields<QueryCoursesByTopicId_V2Args, 'topicId'>
  >
  coursesPersonalizedByUserId?: Resolver<
    Maybe<Array<ResolversTypes['CoursePreview']>>,
    ParentType,
    ContextType
  >
  learnNextStepActionsByCourseId?: Resolver<
    Maybe<Array<ResolversTypes['LearnNextStepAction']>>,
    ParentType,
    ContextType,
    RequireFields<QueryLearnNextStepActionsByCourseIdArgs, 'courseId'>
  >
  relatedCoursePreviewsByCourseId?: Resolver<
    Maybe<Array<ResolversTypes['CoursePreview']>>,
    ParentType,
    ContextType,
    RequireFields<QueryRelatedCoursePreviewsByCourseIdArgs, 'courseId'>
  >
  relatedCoursePreviewsByCourseId_v2?: Resolver<
    Maybe<Array<ResolversTypes['LearnCoursePreview']>>,
    ParentType,
    ContextType,
    RequireFields<QueryRelatedCoursePreviewsByCourseId_V2Args, 'courseId'>
  >
  relatedQuizByCourseId?: Resolver<
    Maybe<ResolversTypes['Quiz']>,
    ParentType,
    ContextType,
    RequireFields<QueryRelatedQuizByCourseIdArgs, 'courseId'>
  >
  completedQuizByQuizId?: Resolver<
    Maybe<ResolversTypes['CompletedQuiz']>,
    ParentType,
    ContextType,
    RequireFields<QueryCompletedQuizByQuizIdArgs, 'quizId'>
  >
  learnQuestionInsightsByQuizId?: Resolver<
    Maybe<Array<ResolversTypes['LearnQuestionInsight']>>,
    ParentType,
    ContextType,
    RequireFields<QueryLearnQuestionInsightsByQuizIdArgs, 'quizId'>
  >
  quiz?: Resolver<
    Maybe<ResolversTypes['Quiz']>,
    ParentType,
    ContextType,
    RequireFields<QueryQuizArgs, 'id'>
  >
  relatedQuizzesByCourseId?: Resolver<
    Maybe<Array<ResolversTypes['QuizPreview']>>,
    ParentType,
    ContextType,
    RequireFields<QueryRelatedQuizzesByCourseIdArgs, 'courseId'>
  >
  learnArticle?: Resolver<
    Maybe<ResolversTypes['LearnArticle']>,
    ParentType,
    ContextType,
    RequireFields<QueryLearnArticleArgs, 'id'>
  >
  relatedCourseByArticleId?: Resolver<
    Maybe<ResolversTypes['Course']>,
    ParentType,
    ContextType,
    RequireFields<QueryRelatedCourseByArticleIdArgs, 'articleId'>
  >
  relatedLearnContentByArticleId?: Resolver<
    Maybe<Array<ResolversTypes['LearnContentPreview']>>,
    ParentType,
    ContextType,
    RequireFields<QueryRelatedLearnContentByArticleIdArgs, 'articleId'>
  >
  learnContentBySearchTerm?: Resolver<
    Maybe<ResolversTypes['ContentPreviewConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryLearnContentBySearchTermArgs, 'term' | 'pagination'>
  >
  learnContentByTierId?: Resolver<
    Maybe<ResolversTypes['ContentPreviewConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryLearnContentByTierIdArgs, 'filter' | 'pagination'>
  >
  learnContentByTopicId?: Resolver<
    Maybe<ResolversTypes['ContentPreviewConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryLearnContentByTopicIdArgs, 'filter' | 'pagination'>
  >
  learnContentRecommendationsBySearchTerm?: Resolver<
    Maybe<Array<ResolversTypes['LearnContentPreview']>>,
    ParentType,
    ContextType,
    RequireFields<QueryLearnContentRecommendationsBySearchTermArgs, 'term'>
  >
  learnContentSearchHistoryByUserId?: Resolver<
    Maybe<ResolversTypes['SearchHistory']>,
    ParentType,
    ContextType
  >
  documentRequest?: Resolver<
    Maybe<ResolversTypes['DocumentRequest']>,
    ParentType,
    ContextType,
    RequireFields<QueryDocumentRequestArgs, 'input'>
  >
  documentRequests?: Resolver<
    Maybe<ResolversTypes['DocumentRequestsConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryDocumentRequestsArgs, 'input'>
  >
  registeredAuthenticators?: Resolver<
    Maybe<Array<ResolversTypes['Authenticator']>>,
    ParentType,
    ContextType
  >
  authProfile?: Resolver<Maybe<ResolversTypes['AuthProfile']>, ParentType, ContextType>
  authAlerts?: Resolver<Maybe<Array<ResolversTypes['AuthAlert']>>, ParentType, ContextType>
  passwordResetFormFieldsByToken?: Resolver<
    Maybe<ResolversTypes['PasswordResetForm']>,
    ParentType,
    ContextType,
    RequireFields<QueryPasswordResetFormFieldsByTokenArgs, 'resetToken'>
  >
  emailAddressValidation?: Resolver<
    ResolversTypes['EmailAddressValidation'],
    ParentType,
    ContextType,
    RequireFields<QueryEmailAddressValidationArgs, 'email'>
  >
  validatePasswordResetToken?: Resolver<
    ResolversTypes['ValidatePasswordResetTokenResult'],
    ParentType,
    ContextType,
    RequireFields<QueryValidatePasswordResetTokenArgs, 'resetToken'>
  >
  offer?: Resolver<
    Maybe<ResolversTypes['Offer']>,
    ParentType,
    ContextType,
    RequireFields<QueryOfferArgs, 'id'>
  >
  product?: Resolver<
    Maybe<ResolversTypes['Product']>,
    ParentType,
    ContextType,
    RequireFields<QueryProductArgs, 'id'>
  >
  productByKey?: Resolver<
    Maybe<ResolversTypes['Product']>,
    ParentType,
    ContextType,
    RequireFields<QueryProductByKeyArgs, 'productKey'>
  >
  products?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType>
  promotion?: Resolver<
    Maybe<ResolversTypes['Promotion']>,
    ParentType,
    ContextType,
    RequireFields<QueryPromotionArgs, 'id'>
  >
  promotionsByUserId?: Resolver<
    Maybe<Array<ResolversTypes['Promotion']>>,
    ParentType,
    ContextType,
    RequireFields<QueryPromotionsByUserIdArgs, 'limit'>
  >
  subscriptionMigration?: Resolver<
    Maybe<ResolversTypes['SubscriptionMigration']>,
    ParentType,
    ContextType,
    RequireFields<QuerySubscriptionMigrationArgs, 'id'>
  >
  subscriptionMigrationWaiver?: Resolver<
    Maybe<ResolversTypes['SubscriptionMigrationWaiver']>,
    ParentType,
    ContextType,
    RequireFields<QuerySubscriptionMigrationWaiverArgs, 'id'>
  >
  subscriptionMigrationWaiversByUserId?: Resolver<
    Maybe<Array<ResolversTypes['SubscriptionMigrationWaiver']>>,
    ParentType,
    ContextType
  >
  tier?: Resolver<
    Maybe<ResolversTypes['Tier']>,
    ParentType,
    ContextType,
    RequireFields<QueryTierArgs, 'id'>
  >
  tierGroup?: Resolver<
    Maybe<ResolversTypes['TierGroup']>,
    ParentType,
    ContextType,
    RequireFields<QueryTierGroupArgs, never>
  >
  tierGroupForUser?: Resolver<Maybe<ResolversTypes['TierGroup']>, ParentType, ContextType>
  tierOptionByOpenAccounts?: Resolver<Maybe<ResolversTypes['TierOption']>, ParentType, ContextType>
  tierOptionByProductKey?: Resolver<
    Maybe<ResolversTypes['TierOption']>,
    ParentType,
    ContextType,
    RequireFields<QueryTierOptionByProductKeyArgs, 'productKey'>
  >
  tierOptionByTierPriceId?: Resolver<
    Maybe<ResolversTypes['TierOptionByTierPriceIdResult']>,
    ParentType,
    ContextType,
    RequireFields<QueryTierOptionByTierPriceIdArgs, 'tierPriceId'>
  >
  tierSubscription?: Resolver<
    Maybe<ResolversTypes['TierSubscription']>,
    ParentType,
    ContextType,
    RequireFields<QueryTierSubscriptionArgs, 'id'>
  >
  tierSubscriptionByUserId?: Resolver<
    Maybe<ResolversTypes['TierSubscription']>,
    ParentType,
    ContextType
  >
  tierSubscriptionForUser?: Resolver<
    Maybe<ResolversTypes['TierSubscriptionForUser']>,
    ParentType,
    ContextType
  >
  tierSubscriptionHistoryByUserId?: Resolver<
    Maybe<ResolversTypes['TierSubscriptionConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryTierSubscriptionHistoryByUserIdArgs, 'limit' | 'reverse'>
  >
  splitDepositSettings?: Resolver<
    Maybe<ResolversTypes['SplitDepositSettings']>,
    ParentType,
    ContextType,
    RequireFields<QuerySplitDepositSettingsArgs, 'id'>
  >
  splitDepositSettingsByUserId?: Resolver<
    Maybe<Array<ResolversTypes['SplitDepositSettings']>>,
    ParentType,
    ContextType,
    RequireFields<QuerySplitDepositSettingsByUserIdArgs, never>
  >
  smartDepositMetadata?: Resolver<
    Maybe<ResolversTypes['SmartDepositMetadataResult']>,
    ParentType,
    ContextType,
    RequireFields<QuerySmartDepositMetadataArgs, 'smartDepositMetadataInput'>
  >
  outsideContributionCode?: Resolver<
    Maybe<ResolversTypes['OutsideContributionCode']>,
    ParentType,
    ContextType,
    RequireFields<QueryOutsideContributionCodeArgs, 'id'>
  >
  outsideContributionCodeByCode?: Resolver<
    Maybe<ResolversTypes['OutsideContributionCode']>,
    ParentType,
    ContextType,
    RequireFields<QueryOutsideContributionCodeByCodeArgs, 'code'>
  >
  outsideContributionCodeByInvestmentAccountId?: Resolver<
    Maybe<ResolversTypes['OutsideContributionCode']>,
    ParentType,
    ContextType,
    RequireFields<QueryOutsideContributionCodeByInvestmentAccountIdArgs, 'investmentAccountId'>
  >
  earnCTADataByUserId?: Resolver<
    Maybe<Array<ResolversTypes['EarnCTARecord']>>,
    ParentType,
    ContextType,
    RequireFields<QueryEarnCtaDataByUserIdArgs, 'id'>
  >
  bankFeeNegotiationsByUserId?: Resolver<
    Maybe<ResolversTypes['FeeNegotiationOutput']>,
    ParentType,
    ContextType
  >
  listUtilityServices?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['ServiceNode']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryListUtilityServicesArgs, never>
  >
  bankFeeNegotiationResultsByUserId?: Resolver<
    Maybe<ResolversTypes['BankFeeNegotiationResults']>,
    ParentType,
    ContextType
  >
  billNegotiationsByUserId?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['BillNegotiation']>>>,
    ParentType,
    ContextType
  >
  bankFeeNegotiationAlerts?: Resolver<
    Maybe<Array<ResolversTypes['BankFeeNegotiationAlert']>>,
    ParentType,
    ContextType
  >
  bankFeesByUserId?: Resolver<
    Maybe<Array<ResolversTypes['BankFee']>>,
    ParentType,
    ContextType,
    RequireFields<QueryBankFeesByUserIdArgs, 'first' | 'offset' | 'statusFilter'>
  >
  bankFeeSummaryByUserId?: Resolver<
    Maybe<ResolversTypes['BankFeeSummary']>,
    ParentType,
    ContextType
  >
  authenticateForFeeNegotiationStatusByLinkedAccountId?: Resolver<
    Maybe<ResolversTypes['AuthenticateForFeeNegotiationStatus']>,
    ParentType,
    ContextType,
    RequireFields<QueryAuthenticateForFeeNegotiationStatusByLinkedAccountIdArgs, 'linkedAccountId'>
  >
  mailInDocumentsByUserId?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['MailInDocument']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryMailInDocumentsByUserIdArgs, 'mailInDocumentTypeFilter'>
  >
  sampleMailInDocument?: Resolver<
    Maybe<ResolversTypes['SampleMailInDocument']>,
    ParentType,
    ContextType,
    RequireFields<QuerySampleMailInDocumentArgs, 'typeFilter'>
  >
  getPartnerUrl?: Resolver<
    ResolversTypes['PartnerUrlResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryGetPartnerUrlArgs, 'input'>
  >
  getPartnerDocumentByUserId?: Resolver<
    ResolversTypes['PartnerDocumentUrlResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryGetPartnerDocumentByUserIdArgs, 'input'>
  >
  getPartnerDetails?: Resolver<
    ResolversTypes['PartnerDetailsResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryGetPartnerDetailsArgs, 'input'>
  >
  advocate?: Resolver<Maybe<ResolversTypes['Advocate']>, ParentType, ContextType>
  friend?: Resolver<
    Maybe<ResolversTypes['Friend']>,
    ParentType,
    ContextType,
    RequireFields<QueryFriendArgs, never>
  >
  registrationFunnel?: Resolver<
    Maybe<ResolversTypes['RegistrationFunnel']>,
    ParentType,
    ContextType,
    RequireFields<QueryRegistrationFunnelArgs, 'filter'>
  >
  securityBySymbol?: Resolver<
    Maybe<ResolversTypes['Security']>,
    ParentType,
    ContextType,
    RequireFields<QuerySecurityBySymbolArgs, 'input'>
  >
  securitiesBySymbols?: Resolver<
    Maybe<ResolversTypes['SecuritiesBySymbolsResponse']>,
    ParentType,
    ContextType,
    RequireFields<QuerySecuritiesBySymbolsArgs, 'input'>
  >
  securityPerformanceBySymbol?: Resolver<
    Maybe<ResolversTypes['SecurityPerformance']>,
    ParentType,
    ContextType,
    RequireFields<QuerySecurityPerformanceBySymbolArgs, 'input'>
  >
  securityPerformancesBySymbol?: Resolver<
    Maybe<Array<ResolversTypes['SecurityPerformance']>>,
    ParentType,
    ContextType,
    RequireFields<QuerySecurityPerformancesBySymbolArgs, 'input'>
  >
  searchSecurities?: Resolver<
    Maybe<ResolversTypes['SearchSecuritiesResponse']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchSecuritiesArgs, 'input'>
  >
  securitiesBySector?: Resolver<
    Maybe<ResolversTypes['SecuritiesBySectorResponse']>,
    ParentType,
    ContextType,
    RequireFields<QuerySecuritiesBySectorArgs, 'input'>
  >
  cohortEligibility?: Resolver<
    Array<ResolversTypes['CohortEligibility']>,
    ParentType,
    ContextType,
    RequireFields<QueryCohortEligibilityArgs, 'scopes'>
  >
}

export type QuestionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Question'] = ResolversParentTypes['Question']
> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  defaultAnswer?: Resolver<Maybe<ResolversTypes['Answer']>, ParentType, ContextType>
  eyebrow?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  headline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  possibleAnswers?: Resolver<Maybe<Array<ResolversTypes['Answer']>>, ParentType, ContextType>
  tip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  type?: Resolver<ResolversTypes['OnboardingStepType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type QuestionAnswerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['QuestionAnswer'] = ResolversParentTypes['QuestionAnswer']
> = {
  name?: Resolver<ResolversTypes['QuestionAnswerName'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type QuizResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Quiz'] = ResolversParentTypes['Quiz']
> = {
  authors?: Resolver<Array<ResolversTypes['LearnAuthor']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<Maybe<ResolversTypes['LearnVisualAsset']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  metadata?: Resolver<ResolversTypes['LearnMetadata'], ParentType, ContextType>
  questions?: Resolver<Array<ResolversTypes['LearnQuestion']>, ParentType, ContextType>
  theme?: Resolver<ResolversTypes['QuizTheme'], ParentType, ContextType>
  tier?: Resolver<ResolversTypes['LearnTier'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  topics?: Resolver<Array<ResolversTypes['LearnTopic']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type QuizPreviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['QuizPreview'] = ResolversParentTypes['QuizPreview']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  progress?: Resolver<Maybe<ResolversTypes['LearnProgress']>, ParentType, ContextType>
  quizTheme?: Resolver<ResolversTypes['QuizTheme'], ParentType, ContextType>
  tierName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type QuizPreviewLockedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['QuizPreviewLocked'] = ResolversParentTypes['QuizPreviewLocked']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type QuizThemeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['QuizTheme'] = ResolversParentTypes['QuizTheme']
> = {
  __resolveType: TypeResolveFn<'LearnThemeLiteral', ParentType, ContextType>
}

export type QuoteResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['QuoteResult'] = ResolversParentTypes['QuoteResult']
> = {
  __resolveType: TypeResolveFn<
    'IneligibilityLander' | 'LifeQuoteResultSliders',
    ParentType,
    ContextType
  >
}

export type QuoteSliderResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['QuoteSlider'] = ResolversParentTypes['QuoteSlider']
> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  defaultValue?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  headline?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  maxLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  minLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  possibleValues?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>
  questionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  tip?: Resolver<Maybe<ResolversTypes['Tip']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RawLinkSessionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RawLinkSession'] = ResolversParentTypes['RawLinkSession']
> = {
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RdvRequiredUserAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RdvRequiredUserAlert'] = ResolversParentTypes['RdvRequiredUserAlert']
> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RdvVerificationRequiredResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RdvVerificationRequired'] = ResolversParentTypes['RdvVerificationRequired']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecaptchaExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecaptchaException'] = ResolversParentTypes['RecaptchaException']
> = {
  errorCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecommendationsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Recommendations'] = ResolversParentTypes['Recommendations']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  widgets?: Resolver<Array<ResolversTypes['RecommendationWidget']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecommendationWidgetResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecommendationWidget'] = ResolversParentTypes['RecommendationWidget']
> = {
  __resolveType: TypeResolveFn<'BriefInsuranceSection', ParentType, ContextType>
}

export type RecommendedLifeCoverageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecommendedLifeCoverage'] = ResolversParentTypes['RecommendedLifeCoverage']
> = {
  about?: Resolver<ResolversTypes['AboutSection'], ParentType, ContextType>
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  disclaimer?: Resolver<ResolversTypes['Disclaimer'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  widgets?: Resolver<
    Array<ResolversTypes['RecommendedLifeCoverageWidget']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecommendedLifeCoverageWidgetResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecommendedLifeCoverageWidget'] = ResolversParentTypes['RecommendedLifeCoverageWidget']
> = {
  __resolveType: TypeResolveFn<
    'CollapsedLifeRecommendation' | 'ExpandedLifeRecommendation' | 'InsuranceCarousel',
    ParentType,
    ContextType
  >
}

export type RecordAlreadyExistsErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecordAlreadyExistsError'] = ResolversParentTypes['RecordAlreadyExistsError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecordDoesNotExistErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecordDoesNotExistError'] = ResolversParentTypes['RecordDoesNotExistError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecordInvestmentAccountRecapViewResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecordInvestmentAccountRecapViewResult'] = ResolversParentTypes['RecordInvestmentAccountRecapViewResult']
> = {
  __resolveType: TypeResolveFn<
    'InvestmentAccountRecap' | 'InvestmentAccountRecapNotFoundException',
    ParentType,
    ContextType
  >
}

export type RecurrenceRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecurrenceRule'] = ResolversParentTypes['RecurrenceRule']
> = {
  frequency?: Resolver<ResolversTypes['RecurrenceFrequency'], ParentType, ContextType>
  byWeekDay?: Resolver<Maybe<Array<ResolversTypes['DayOfWeek']>>, ParentType, ContextType>
  byMonthDay?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>
  interval?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecurringInvestmentPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecurringInvestmentPayload'] = ResolversParentTypes['RecurringInvestmentPayload']
> = {
  recurringInvestmentSettings?: Resolver<
    ResolversTypes['RecurringInvestmentSettings'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecurringInvestmentSettingsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecurringInvestmentSettings'] = ResolversParentTypes['RecurringInvestmentSettings']
> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  day?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  frequency?: Resolver<Maybe<ResolversTypes['InvestmentFrequency']>, ParentType, ContextType>
  nextInvestmentAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecurringTransferResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecurringTransfer'] = ResolversParentTypes['RecurringTransfer']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  recurrenceRule?: Resolver<ResolversTypes['RecurrenceRule'], ParentType, ContextType>
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  transferEvent?: Resolver<ResolversTypes['RecurringTransferEvent'], ParentType, ContextType>
  nextTransferDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecurringTransferAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecurringTransferAccount'] = ResolversParentTypes['RecurringTransferAccount']
> = {
  type?: Resolver<ResolversTypes['RecurringTransferAccountType'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecurringTransferDateResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecurringTransferDate'] = ResolversParentTypes['RecurringTransferDate']
> = {
  nextTransferDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecurringTransferEventResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecurringTransferEvent'] = ResolversParentTypes['RecurringTransferEvent']
> = {
  targetAccount?: Resolver<ResolversTypes['RecurringTransferAccount'], ParentType, ContextType>
  fundingSource?: Resolver<
    ResolversTypes['RecurringTransferFundingSource'],
    ParentType,
    ContextType
  >
  direction?: Resolver<ResolversTypes['RecurringTransferDirection'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecurringTransferFundingSourceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecurringTransferFundingSource'] = ResolversParentTypes['RecurringTransferFundingSource']
> = {
  type?: Resolver<ResolversTypes['RecurringTransferFundingSourceType'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RecurringTransferPathExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RecurringTransferPathException'] = ResolversParentTypes['RecurringTransferPathException']
> = {
  path?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  exception?: Resolver<
    ResolversTypes['RecurringTransferPathExceptionCase'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReferralResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Referral'] = ResolversParentTypes['Referral']
> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  referreeRewardAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  referrerRewardAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReferralCampaignResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReferralCampaign'] = ResolversParentTypes['ReferralCampaign']
> = {
  friendUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  friendEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  advocateUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  advocateEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  events?: Resolver<Maybe<Array<ResolversTypes['ReferralEvent']>>, ParentType, ContextType>
  friendRewards?: Resolver<Maybe<Array<ResolversTypes['ReferralReward']>>, ParentType, ContextType>
  advocateRewards?: Resolver<
    Maybe<Array<ResolversTypes['ReferralReward']>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReferralEventResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReferralEvent'] = ResolversParentTypes['ReferralEvent']
> = {
  referralEventId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  referralEventType?: Resolver<ResolversTypes['ReferralEventType'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['ReferralEventStatus'], ParentType, ContextType>
  dateCompleted?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReferralHistoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReferralHistory'] = ResolversParentTypes['ReferralHistory']
> = {
  numPendingReferrals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  numCompletedReferrals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  totalReferralRewardsEarned?: Resolver<
    Maybe<ResolversTypes['CurrencyAmount']>,
    ParentType,
    ContextType
  >
  friendSummary?: Resolver<Maybe<Array<ResolversTypes['FriendSummary']>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReferralRewardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReferralReward'] = ResolversParentTypes['ReferralReward']
> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  valueType?: Resolver<Maybe<ResolversTypes['ReferralValueType']>, ParentType, ContextType>
  rewardStatus?: Resolver<Maybe<ResolversTypes['ReferralRewardStatus']>, ParentType, ContextType>
  rewardFulfilledAtDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReferralRewardSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReferralRewardSummary'] = ResolversParentTypes['ReferralRewardSummary']
> = {
  status?: Resolver<ResolversTypes['ReferralRewardStatus'], ParentType, ContextType>
  advocateUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RefreshAuthTokenRateLimitedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RefreshAuthTokenRateLimitedException'] = ResolversParentTypes['RefreshAuthTokenRateLimitedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RefreshAuthTokenResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RefreshAuthTokenResult'] = ResolversParentTypes['RefreshAuthTokenResult']
> = {
  __resolveType: TypeResolveFn<
    | 'AuthSession'
    | 'TokenExpiredException'
    | 'InvalidPinException'
    | 'RefreshAuthTokenRateLimitedException'
    | 'UserSuspendedException',
    ParentType,
    ContextType
  >
}

export type RefreshTokenNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RefreshTokenNotFoundException'] = ResolversParentTypes['RefreshTokenNotFoundException']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RegenerateInvestmentAccountRecapPublicTokenResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RegenerateInvestmentAccountRecapPublicTokenResult'] = ResolversParentTypes['RegenerateInvestmentAccountRecapPublicTokenResult']
> = {
  __resolveType: TypeResolveFn<
    'InvestmentAccountRecap' | 'InvestmentAccountRecapNotFoundException',
    ParentType,
    ContextType
  >
}

export type RegisterCredentialsResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RegisterCredentialsResult'] = ResolversParentTypes['RegisterCredentialsResult']
> = {
  __resolveType: TypeResolveFn<
    | 'AuthSession'
    | 'EmailTakenException'
    | 'InvalidPasswordException'
    | 'MissingRequiredAgreementsException',
    ParentType,
    ContextType
  >
}

export type RegisterEmailAuthenticatorResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RegisterEmailAuthenticatorResult'] = ResolversParentTypes['RegisterEmailAuthenticatorResult']
> = {
  __resolveType: TypeResolveFn<
    | 'EmailAuthenticator'
    | 'AuthChallengeAnswerIncorrectException'
    | 'AuthChallengeAnswerAttemptsExhaustedException'
    | 'AuthChallengeExpiredException'
    | 'AuthenticatorTypeAlreadyRegisteredException'
    | 'ExistingEmailVerifiedException',
    ParentType,
    ContextType
  >
}

export type RegisterLinkSessionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RegisterLinkSessionResult'] = ResolversParentTypes['RegisterLinkSessionResult']
> = {
  __resolveType: TypeResolveFn<'AsyncLinkSessionResult' | 'LinkedAccount', ParentType, ContextType>
}

export type RegisterPhoneAuthenticatorResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RegisterPhoneAuthenticatorResult'] = ResolversParentTypes['RegisterPhoneAuthenticatorResult']
> = {
  __resolveType: TypeResolveFn<
    | 'PhoneAuthenticator'
    | 'AuthChallengeAnswerIncorrectException'
    | 'AuthChallengeAnswerAttemptsExhaustedException'
    | 'AuthChallengeExpiredException'
    | 'InvalidPhoneNumberException'
    | 'AuthenticatorTypeAlreadyRegisteredException',
    ParentType,
    ContextType
  >
}

export type RegisterProspectResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RegisterProspectResult'] = ResolversParentTypes['RegisterProspectResult']
> = {
  __resolveType: TypeResolveFn<
    | 'InvalidConversionIdentifierException'
    | 'InvalidSourceAttributesException'
    | 'RegistrationFunnel',
    ParentType,
    ContextType
  >
}

export type RegistrationFunnelResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RegistrationFunnel'] = ResolversParentTypes['RegistrationFunnel']
> = {
  flow?: Resolver<Array<ResolversTypes['RegistrationPage']>, ParentType, ContextType>
  metadata?: Resolver<ResolversTypes['FunnelMetadata'], ParentType, ContextType>
  sourceAttributes?: Resolver<ResolversTypes['SourceAttributes'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RegistrationPageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RegistrationPage'] = ResolversParentTypes['RegistrationPage']
> = {
  actions?: Resolver<Array<ResolversTypes['RegistrationPageAction']>, ParentType, ContextType>
  isBackEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['PageName'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RegistrationPageActionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RegistrationPageAction'] = ResolversParentTypes['RegistrationPageAction']
> = {
  nextPage?: Resolver<ResolversTypes['PageName'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['ActionType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReinitiateSmsChallengeResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReinitiateSMSChallengeResult'] = ResolversParentTypes['ReinitiateSMSChallengeResult']
> = {
  __resolveType: TypeResolveFn<
    'SMSAuthChallenge' | 'EmailAuthChallenge' | 'AuthChallengeExpiredException',
    ParentType,
    ContextType
  >
}

export type ReissueBankCardEligibilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReissueBankCardEligibility'] = ResolversParentTypes['ReissueBankCardEligibility']
> = {
  __resolveType: TypeResolveFn<
    'ReissueBankCardEligible' | 'ReissueBankCardIneligible',
    ParentType,
    ContextType
  >
}

export type ReissueBankCardEligibleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReissueBankCardEligible'] = ResolversParentTypes['ReissueBankCardEligible']
> = {
  originalCardCreatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReissueBankCardExistsErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReissueBankCardExistsError'] = ResolversParentTypes['ReissueBankCardExistsError']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReissueBankCardIneligibleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReissueBankCardIneligible'] = ResolversParentTypes['ReissueBankCardIneligible']
> = {
  issues?: Resolver<
    Array<Maybe<ResolversTypes['ReissueBankCardIneligibleIssue']>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReissueBankCardResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReissueBankCardResult'] = ResolversParentTypes['ReissueBankCardResult']
> = {
  __resolveType: TypeResolveFn<
    'BankCardRequest' | 'ReissueBankCardExistsError',
    ParentType,
    ContextType
  >
}

export type RelinkLinkedAccountAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RelinkLinkedAccountAlert'] = ResolversParentTypes['RelinkLinkedAccountAlert']
> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RemoveActionFromMilestoneAchievementActionRuleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RemoveActionFromMilestoneAchievementActionRuleResult'] = ResolversParentTypes['RemoveActionFromMilestoneAchievementActionRuleResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneAchievementActionRule' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type RemoveActionFromMilestoneGroupAchievementActionRuleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RemoveActionFromMilestoneGroupAchievementActionRuleResult'] = ResolversParentTypes['RemoveActionFromMilestoneGroupAchievementActionRuleResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneGroupAchievementActionRule' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type RemovedJobAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RemovedJobAlert'] = ResolversParentTypes['RemovedJobAlert']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RemoveJobAlertResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RemoveJobAlertResult'] = ResolversParentTypes['RemoveJobAlertResult']
> = {
  __resolveType: TypeResolveFn<'RemovedJobAlert', ParentType, ContextType>
}

export type RemoveMilestoneFromMilestoneGroupDefinitionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RemoveMilestoneFromMilestoneGroupDefinitionResult'] = ResolversParentTypes['RemoveMilestoneFromMilestoneGroupDefinitionResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneGroupDefinition' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type RemoveMilestonesFromMilestoneHubDefinitionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RemoveMilestonesFromMilestoneHubDefinitionResult'] = ResolversParentTypes['RemoveMilestonesFromMilestoneHubDefinitionResult']
> = {
  __resolveType: TypeResolveFn<
    'RecordDoesNotExistError' | 'MilestoneHubDefinition',
    ParentType,
    ContextType
  >
}

export type RemoveSecurityFromPortfolioResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RemoveSecurityFromPortfolioResult'] = ResolversParentTypes['RemoveSecurityFromPortfolioResult']
> = {
  __resolveType: TypeResolveFn<
    | 'InvestmentAccountNotFoundException'
    | 'InvestmentAccountNotSupportedException'
    | 'Portfolio'
    | 'PortfolioNotFoundException'
    | 'PortfolioNotSupportedException'
    | 'SecurityNotSupportedException',
    ParentType,
    ContextType
  >
}

export type RemoveSelfDirectedPortfolioResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RemoveSelfDirectedPortfolioResult'] = ResolversParentTypes['RemoveSelfDirectedPortfolioResult']
> = {
  __resolveType: TypeResolveFn<
    | 'AccountNotFoundException'
    | 'InvestmentAccount'
    | 'InvestmentAccountAlreadyClosed'
    | 'InvestmentAccountClosureInProgress'
    | 'PortfolioAlreadyRemovedError'
    | 'PortfolioNotFoundException'
    | 'PortfolioRemovalInProgressError',
    ParentType,
    ContextType
  >
}

export type ReopenUserAccountResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReopenUserAccountResult'] = ResolversParentTypes['ReopenUserAccountResult']
> = {
  __resolveType: TypeResolveFn<
    | 'UserNotFoundException'
    | 'UserReopenLockedException'
    | 'UserReopenSuspendedException'
    | 'User_v2',
    ParentType,
    ContextType
  >
}

export type ReportBankCardLostStolenPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReportBankCardLostStolenPayload'] = ResolversParentTypes['ReportBankCardLostStolenPayload']
> = {
  bankCard?: Resolver<Maybe<ResolversTypes['BankCard']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RequestEarlyAccountClosureResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RequestEarlyAccountClosureResult'] = ResolversParentTypes['RequestEarlyAccountClosureResult']
> = {
  __resolveType: TypeResolveFn<
    | 'AccountAlreadyClosedException'
    | 'ClosureRequestExistsException'
    | 'FundingSourceRequiresRdvException'
    | 'InternalErrorException'
    | 'InvalidAccountTypeException'
    | 'InvestmentAccount'
    | 'InvestmentAccountNeedsTransferException'
    | 'MissingFundingSourceException',
    ParentType,
    ContextType
  >
}

export type RequestInvestmentAccountReopenResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RequestInvestmentAccountReopenResult'] = ResolversParentTypes['RequestInvestmentAccountReopenResult']
> = {
  __resolveType: TypeResolveFn<
    | 'ExistingRequestPendingReview'
    | 'ExistingRequestPendingUserAction'
    | 'InvalidSubscriptionTierException'
    | 'InvestmentAccountNotClosedException'
    | 'InvestmentAccountNotFoundException'
    | 'InvestmentAccountReopenRequest',
    ParentType,
    ContextType
  >
}

export type RequestSubscriptionMigrationWaiverResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RequestSubscriptionMigrationWaiverResult'] = ResolversParentTypes['RequestSubscriptionMigrationWaiverResult']
> = {
  __resolveType: TypeResolveFn<
    | 'InvalidTierForMigrationError'
    | 'SubscriptionMigrationInvalidError'
    | 'SubscriptionMigrationWaiver',
    ParentType,
    ContextType
  >
}

export type ResetPasswordByTokenExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ResetPasswordByTokenException'] = ResolversParentTypes['ResetPasswordByTokenException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ResetPasswordByTokenResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ResetPasswordByTokenResult'] = ResolversParentTypes['ResetPasswordByTokenResult']
> = {
  __resolveType: TypeResolveFn<
    | 'ResetPasswordByTokenSuccess'
    | 'ResetPasswordByTokenException'
    | 'InvalidPasswordException'
    | 'UserCredentialsNotFoundException'
    | 'IncorrectSecurityAnswerException'
    | 'IncorrectSsnException',
    ParentType,
    ContextType
  >
}

export type ResetPasswordByTokenSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ResetPasswordByTokenSuccess'] = ResolversParentTypes['ResetPasswordByTokenSuccess']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ResetPasswordWithTokenResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ResetPasswordWithTokenResult'] = ResolversParentTypes['ResetPasswordWithTokenResult']
> = {
  __resolveType: TypeResolveFn<
    | 'ResetPasswordWithTokenSuccess'
    | 'InvalidPasswordResetTokenException'
    | 'UserCredentialsNotFoundException'
    | 'InvalidPasswordResetException',
    ParentType,
    ContextType
  >
}

export type ResetPasswordWithTokenSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ResetPasswordWithTokenSuccess'] = ResolversParentTypes['ResetPasswordWithTokenSuccess']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ResourceNotFoundErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ResourceNotFoundError'] = ResolversParentTypes['ResourceNotFoundError']
> = {
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RespondToLearnPollResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RespondToLearnPollResult'] = ResolversParentTypes['RespondToLearnPollResult']
> = {
  __resolveType: TypeResolveFn<
    'LearnPollResponse' | 'InvalidOptionException' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type RestoreLoginAccessResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RestoreLoginAccessResult'] = ResolversParentTypes['RestoreLoginAccessResult']
> = {
  __resolveType: TypeResolveFn<
    'AuthProfile' | 'AuthProfileNotFoundException',
    ParentType,
    ContextType
  >
}

export type ResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Result'] = ResolversParentTypes['Result']
> = {
  funnel?: Resolver<ResolversTypes['Funnel'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReturnedCheckDepositResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReturnedCheckDeposit'] = ResolversParentTypes['ReturnedCheckDeposit']
> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  rejectedDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  frontCheckImageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  backCheckImageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RevokeLoginAccessResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RevokeLoginAccessResult'] = ResolversParentTypes['RevokeLoginAccessResult']
> = {
  __resolveType: TypeResolveFn<
    'AuthProfile' | 'UserCredentialsNotFoundException',
    ParentType,
    ContextType
  >
}

export type RevokePasswordResetTokenResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RevokePasswordResetTokenResult'] = ResolversParentTypes['RevokePasswordResetTokenResult']
> = {
  __resolveType: TypeResolveFn<
    'RevokePasswordResetTokenSuccess' | 'InvalidPasswordResetTokenException',
    ParentType,
    ContextType
  >
}

export type RevokePasswordResetTokenSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RevokePasswordResetTokenSuccess'] = ResolversParentTypes['RevokePasswordResetTokenSuccess']
> = {
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RewardSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RewardSummary'] = ResolversParentTypes['RewardSummary']
> = {
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RolloverAccountsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RolloverAccounts'] = ResolversParentTypes['RolloverAccounts']
> = {
  accounts?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['RolloverAccountType']>>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RolloverAccountTypeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RolloverAccountType'] = ResolversParentTypes['RolloverAccountType']
> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  code?: Resolver<ResolversTypes['RolloverAccountCode'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RoundUpResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RoundUp'] = ResolversParentTypes['RoundUp']
> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  change?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  instant?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  investmentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  investmentNonce?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  linkedSubaccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  manual?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  multiplier?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  roundUpAccount?: Resolver<ResolversTypes['RoundUpAccount'], ParentType, ContextType>
  roundUpProfile?: Resolver<ResolversTypes['RoundUpProfile'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['RoundUpState'], ParentType, ContextType>
  targetAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  transactionDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  transactionDisplayDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  transactionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RoundUpAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RoundUpAccount'] = ResolversParentTypes['RoundUpAccount']
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  linkedSubaccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  roundUpProfile?: Resolver<ResolversTypes['RoundUpProfile'], ParentType, ContextType>
  roundUps?: Resolver<Array<ResolversTypes['RoundUp']>, ParentType, ContextType>
  startDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RoundUpProfileResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RoundUpProfile'] = ResolversParentTypes['RoundUpProfile']
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  multiplier?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  realTimeRoundUpEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  roundUpAccounts?: Resolver<Array<ResolversTypes['RoundUpAccount']>, ParentType, ContextType>
  roundUpCount?: Resolver<
    ResolversTypes['Int'],
    ParentType,
    ContextType,
    RequireFields<RoundUpProfileRoundUpCountArgs, 'state'>
  >
  roundUpTotal?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType,
    RequireFields<RoundUpProfileRoundUpTotalArgs, 'state'>
  >
  roundUps?: Resolver<Array<ResolversTypes['RoundUp']>, ParentType, ContextType>
  roundUpsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  showRoundUpsProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  targetAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  wholeDollarAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RoundUpTypeEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RoundUpTypeEdge'] = ResolversParentTypes['RoundUpTypeEdge']
> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  node?: Resolver<ResolversTypes['RoundUp'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RoundUpTypePaginationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RoundUpTypePagination'] = ResolversParentTypes['RoundUpTypePagination']
> = {
  edges?: Resolver<Array<ResolversTypes['RoundUpTypeEdge']>, ParentType, ContextType>
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface RoutingNumberScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['RoutingNumber'], any> {
  name: 'RoutingNumber'
}

export type SamePasswordsExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SamePasswordsException'] = ResolversParentTypes['SamePasswordsException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SampleMailInDocumentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SampleMailInDocument'] = ResolversParentTypes['SampleMailInDocument']
> = {
  mailType?: Resolver<ResolversTypes['MailInDocumentType'], ParentType, ContextType>
  letterUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SavingsAccountEligibilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SavingsAccountEligibility'] = ResolversParentTypes['SavingsAccountEligibility']
> = {
  isEligibleForOpen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  notEligibleReasons?: Resolver<
    Array<ResolversTypes['SavingsAccountEligibilityRequirement']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ScheduleRecurringTransferResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ScheduleRecurringTransferResult'] = ResolversParentTypes['ScheduleRecurringTransferResult']
> = {
  __resolveType: TypeResolveFn<
    'RecurringTransfer' | 'MalformedRecurringTransferException',
    ParentType,
    ContextType
  >
}

export type ScheduleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ScheduleResult'] = ResolversParentTypes['ScheduleResult']
> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SearchEmployersPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SearchEmployersPayload'] = ResolversParentTypes['SearchEmployersPayload']
> = {
  results?: Resolver<Maybe<Array<ResolversTypes['Employer']>>, ParentType, ContextType>
  trackingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SearchHistoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SearchHistory'] = ResolversParentTypes['SearchHistory']
> = {
  popularSearches?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  recentSearches?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SearchSecuritiesPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SearchSecuritiesPageInfo'] = ResolversParentTypes['SearchSecuritiesPageInfo']
> = {
  totalMatches?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  prevPageCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  nextPageCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SearchSecuritiesResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SearchSecuritiesResponse'] = ResolversParentTypes['SearchSecuritiesResponse']
> = {
  securities?: Resolver<Array<ResolversTypes['Security']>, ParentType, ContextType>
  pageInfo?: Resolver<Maybe<ResolversTypes['SearchSecuritiesPageInfo']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SearchSupportArticleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SearchSupportArticleResult'] = ResolversParentTypes['SearchSupportArticleResult']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  author?: Resolver<ResolversTypes['SupportAuthor'], ParentType, ContextType>
  draft?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  promoted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  section?: Resolver<ResolversTypes['SupportSection'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  outdated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  editedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  snippet?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  resultType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SearchSupportResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SearchSupportResult'] = ResolversParentTypes['SearchSupportResult']
> = {
  relevantSearchCategories?: Resolver<
    Array<Maybe<ResolversTypes['SupportCategory']>>,
    ParentType,
    ContextType
  >
  relevantSearchArticles?: Resolver<
    Array<Maybe<ResolversTypes['SearchSupportArticleResult']>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SecretSquirrelExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SecretSquirrelException'] = ResolversParentTypes['SecretSquirrelException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SecuritiesBySectorPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SecuritiesBySectorPageInfo'] = ResolversParentTypes['SecuritiesBySectorPageInfo']
> = {
  totalMatches?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  prevPageCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  nextPageCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SecuritiesBySectorResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SecuritiesBySectorResponse'] = ResolversParentTypes['SecuritiesBySectorResponse']
> = {
  securities?: Resolver<Array<ResolversTypes['Security']>, ParentType, ContextType>
  pageInfo?: Resolver<Maybe<ResolversTypes['SecuritiesBySectorPageInfo']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SecuritiesBySymbolsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SecuritiesBySymbolsResponse'] = ResolversParentTypes['SecuritiesBySymbolsResponse']
> = {
  securities?: Resolver<Array<ResolversTypes['Security']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SecurityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Security'] = ResolversParentTypes['Security']
> = {
  __resolveType: TypeResolveFn<'Fund' | 'Stock', ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  symbol?: Resolver<ResolversTypes['TickerSymbol'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['SecurityType'], ParentType, ContextType>
  week52High?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  week52Low?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  currentPrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  lastClosePrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  openPrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  shortName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  longName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  volume?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>
  marketCap?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>
  profile?: Resolver<ResolversTypes['SecurityProfile'], ParentType, ContextType>
  securityProfile?: Resolver<ResolversTypes['SecurityProfile'], ParentType, ContextType>
  headlines?: Resolver<Array<ResolversTypes['SecurityHeadline']>, ParentType, ContextType>
  securityHeadlines?: Resolver<Array<ResolversTypes['SecurityHeadline']>, ParentType, ContextType>
  lastUpdatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  earliestPriceDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
}

export type SecurityGainResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SecurityGain'] = ResolversParentTypes['SecurityGain']
> = {
  percent?: Resolver<Maybe<ResolversTypes['BigDecimal']>, ParentType, ContextType>
  marketValue?: Resolver<Maybe<ResolversTypes['BigCurrencyAmount']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SecurityHeadlineResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SecurityHeadline'] = ResolversParentTypes['SecurityHeadline']
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  headline?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  storyUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SecurityNotSupportedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SecurityNotSupportedException'] = ResolversParentTypes['SecurityNotSupportedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SecurityPerformanceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SecurityPerformance'] = ResolversParentTypes['SecurityPerformance']
> = {
  symbol?: Resolver<ResolversTypes['TickerSymbol'], ParentType, ContextType>
  gain?: Resolver<ResolversTypes['SecurityGain'], ParentType, ContextType>
  prices?: Resolver<Maybe<Array<ResolversTypes['SecurityPrice']>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SecurityPriceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SecurityPrice'] = ResolversParentTypes['SecurityPrice']
> = {
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  marketValue?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  unadjustedMarketValue?: Resolver<
    Maybe<ResolversTypes['BigCurrencyAmount']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SecurityProfileResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SecurityProfile'] = ResolversParentTypes['SecurityProfile']
> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  tradingSectors?: Resolver<Array<ResolversTypes['TradingSector']>, ParentType, ContextType>
  logoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  defaultLogoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SecurityQuestionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SecurityQuestion'] = ResolversParentTypes['SecurityQuestion']
> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SelfDirectedPortfolioResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SelfDirectedPortfolio'] = ResolversParentTypes['SelfDirectedPortfolio']
> = {
  accountAllocation?: Resolver<ResolversTypes['PortfolioAllocation'], ParentType, ContextType>
  cashOwed?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  currentAllocationPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  currentBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  currentBalanceWithPending?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  customizationLevel?: Resolver<
    Maybe<ResolversTypes['PortfolioCustomizationLevel']>,
    ParentType,
    ContextType
  >
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  pendingBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  portfolioSecurities?: Resolver<
    Maybe<Array<ResolversTypes['PortfolioSecurity']>>,
    ParentType,
    ContextType
  >
  portfolioSecurityAllocations?: Resolver<
    Maybe<Array<ResolversTypes['PortfolioSecurityAllocation']>>,
    ParentType,
    ContextType
  >
  requirements?: Resolver<ResolversTypes['AccountRequirements'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['SelfDirectedPortfolioStatus'], ParentType, ContextType>
  yearToDateReturn?: Resolver<Maybe<ResolversTypes['MarketReturn']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SendCheckPaymentResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SendCheckPaymentResult'] = ResolversParentTypes['SendCheckPaymentResult']
> = {
  __resolveType: TypeResolveFn<
    'CheckPayment' | 'AuthorizationError' | 'DuplicateActionError' | 'InvalidAddressError',
    ParentType,
    ContextType
  >
}

export type ServiceNodeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ServiceNode'] = ResolversParentTypes['ServiceNode']
> = {
  serviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  serviceName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  logoUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SessionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Session'] = ResolversParentTypes['Session']
> = {
  uuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  token?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  refreshToken?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  redirectUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SetAuthenticationPinResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SetAuthenticationPINResult'] = ResolversParentTypes['SetAuthenticationPINResult']
> = {
  __resolveType: TypeResolveFn<
    'SetAuthenticationPINSuccess' | 'InvalidPinException' | 'UserCredentialsNotFoundException',
    ParentType,
    ContextType
  >
}

export type SetAuthenticationPinSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SetAuthenticationPINSuccess'] = ResolversParentTypes['SetAuthenticationPINSuccess']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SetBeneficiarySsnResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SetBeneficiarySsnResult'] = ResolversParentTypes['SetBeneficiarySsnResult']
> = {
  __resolveType: TypeResolveFn<
    | 'Beneficiary'
    | 'BeneficiaryNotFoundException'
    | 'InternalErrorException'
    | 'InvalidSsnException'
    | 'SecretSquirrelException'
    | 'SsnAlreadyInUseException'
    | 'SsnMatchesCustodianException'
    | 'SsnUpdateForbiddenException',
    ParentType,
    ContextType
  >
}

export type SetDefaultAuthenticatorResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SetDefaultAuthenticatorResult'] = ResolversParentTypes['SetDefaultAuthenticatorResult']
> = {
  __resolveType: TypeResolveFn<
    | 'PhoneAuthenticator'
    | 'EmailAuthenticator'
    | 'AuthenticatorNotFoundException'
    | 'AuthenticatorAlreadyDefaultException',
    ParentType,
    ContextType
  >
}

export type SetInvestmentAccountRecapPublicAccessResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SetInvestmentAccountRecapPublicAccessResult'] = ResolversParentTypes['SetInvestmentAccountRecapPublicAccessResult']
> = {
  __resolveType: TypeResolveFn<
    'InvestmentAccountRecap' | 'InvestmentAccountRecapNotFoundException',
    ParentType,
    ContextType
  >
}

export type SetNegotiationStatusResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SetNegotiationStatusResult'] = ResolversParentTypes['SetNegotiationStatusResult']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SettingsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Settings'] = ResolversParentTypes['Settings']
> = {
  automaticRoundup?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  allowDebitCard?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  threshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  dollarRoundupAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  roundupMultiplier?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  depositsSuspended?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  notifications?: Resolver<ResolversTypes['Notifications'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SetUpTipResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SetUpTip'] = ResolversParentTypes['SetUpTip']
> = {
  backgroundImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  ctaDetails?: Resolver<ResolversTypes['ActionFeedCta'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['ProductSetupTipType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface ShortScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Short'], any> {
  name: 'Short'
}

export type SignatureResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Signature'] = ResolversParentTypes['Signature']
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  profile?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>
  signatureType?: Resolver<ResolversTypes['SignatureType'], ParentType, ContextType>
  svgFile?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SmartDepositMetadataResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SmartDepositMetadataResult'] = ResolversParentTypes['SmartDepositMetadataResult']
> = {
  recommendedAllocations?: Resolver<
    Array<ResolversTypes['SplitDepositAllocation']>,
    ParentType,
    ContextType
  >
  targetAccounts?: Resolver<
    Array<ResolversTypes['SplitDepositTargetAccount']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SmsAuthChallengeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SMSAuthChallenge'] = ResolversParentTypes['SMSAuthChallenge']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  maskedPhoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  alternateAuthenticators?: Resolver<
    Array<ResolversTypes['AuthenticatorInfo']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SocialCopiesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SocialCopies'] = ResolversParentTypes['SocialCopies']
> = {
  campaignTaxonomy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  copy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  targetMedium?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SourceAttributesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SourceAttributes'] = ResolversParentTypes['SourceAttributes']
> = {
  affiliateCampaignID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  buttonSourceToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  carrier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  clickID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  sourceID?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendAccount'] = ResolversParentTypes['SpendAccount']
> = {
  status?: Resolver<ResolversTypes['SpendAccountStatus'], ParentType, ContextType>
  isReopenable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  isEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  lockReason?: Resolver<Maybe<ResolversTypes['BankAccountLockReason']>, ParentType, ContextType>
  bankCardOrder?: Resolver<Maybe<ResolversTypes['BankCardOrder']>, ParentType, ContextType>
  isDirectDepositIncentiveEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  bankType?: Resolver<Maybe<ResolversTypes['BankType']>, ParentType, ContextType>
  accountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendAlert'] = ResolversParentTypes['SpendAlert']
> = {
  __resolveType: TypeResolveFn<
    'SystemCardLockedSpendAlert' | 'UserCardLockedSpendAlert',
    ParentType,
    ContextType
  >
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
}

export type SpendAtmResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendAtm'] = ResolversParentTypes['SpendAtm']
> = {
  address?: Resolver<ResolversTypes['SpendAtmAddress'], ParentType, ContextType>
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  atmName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendAtmAddressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendAtmAddress'] = ResolversParentTypes['SpendAtmAddress']
> = {
  latitude?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  longitude?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  addressLine?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  cityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  stateCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendAtmReimbursementItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendATMReimbursementItem'] = ResolversParentTypes['SpendATMReimbursementItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendAtmsPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendAtmsPayload'] = ResolversParentTypes['SpendAtmsPayload']
> = {
  atms?: Resolver<Maybe<Array<Maybe<ResolversTypes['SpendAtm']>>>, ParentType, ContextType>
  executedSearchRadius?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendAtmsResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendAtmsResult'] = ResolversParentTypes['SpendAtmsResult']
> = {
  __resolveType: TypeResolveFn<
    'SpendAtmsPayload' | 'SpendAtmVendorUnavailableError',
    ParentType,
    ContextType
  >
}

export type SpendAtmVendorUnavailableErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendAtmVendorUnavailableError'] = ResolversParentTypes['SpendAtmVendorUnavailableError']
> = {
  requestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendAtmWithdrawalItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendATMWithdrawalItem'] = ResolversParentTypes['SpendATMWithdrawalItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendBillPayItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendBillPayItem'] = ResolversParentTypes['SpendBillPayItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendCheckDepositItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendCheckDepositItem'] = ResolversParentTypes['SpendCheckDepositItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendCheckPaymentItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendCheckPaymentItem'] = ResolversParentTypes['SpendCheckPaymentItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendDigitalWalletItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendDigitalWalletItem'] = ResolversParentTypes['SpendDigitalWalletItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendDirectDepositItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendDirectDepositItem'] = ResolversParentTypes['SpendDirectDepositItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendDisputesResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendDisputesResponse'] = ResolversParentTypes['SpendDisputesResponse']
> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  creationDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  disputeDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  questions?: Resolver<
    Array<ResolversTypes['SpendTransactionsDisputeQuestions']>,
    ParentType,
    ContextType
  >
  transactions?: Resolver<
    Array<ResolversTypes['SpendTransactionsResponse']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendECheckItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendECheckItem'] = ResolversParentTypes['SpendECheckItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendItem'] = ResolversParentTypes['SpendItem']
> = {
  __resolveType: TypeResolveFn<
    | 'PastSpendItem'
    | 'SpendATMReimbursementItem'
    | 'SpendATMWithdrawalItem'
    | 'SpendBillPayItem'
    | 'SpendCheckDepositItem'
    | 'SpendCheckPaymentItem'
    | 'SpendDigitalWalletItem'
    | 'SpendDirectDepositItem'
    | 'SpendECheckItem'
    | 'SpendPurchaseItem'
    | 'SpendRealTimeRoundUpItem'
    | 'SpendTransferInItem'
    | 'SpendTransferOutItem',
    ParentType,
    ContextType
  >
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
}

export type SpendPurchaseItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendPurchaseItem'] = ResolversParentTypes['SpendPurchaseItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendRealTimeRoundUpItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendRealTimeRoundUpItem'] = ResolversParentTypes['SpendRealTimeRoundUpItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  initialAmount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  multiplier?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendTransactionsDisputeCustomersResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendTransactionsDisputeCustomersResponse'] = ResolversParentTypes['SpendTransactionsDisputeCustomersResponse']
> = {
  customerNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  applicationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  productCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  disputes?: Resolver<Array<ResolversTypes['SpendDisputesResponse']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendTransactionsDisputeQuestionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendTransactionsDisputeQuestions'] = ResolversParentTypes['SpendTransactionsDisputeQuestions']
> = {
  question?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  answer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendTransactionsDisputeResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendTransactionsDisputeResponse'] = ResolversParentTypes['SpendTransactionsDisputeResponse']
> = {
  customers?: Resolver<
    ResolversTypes['SpendTransactionsDisputeCustomersResponse'],
    ParentType,
    ContextType
  >
  bankType?: Resolver<ResolversTypes['BankType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendTransactionsDisputeResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendTransactionsDisputeResult'] = ResolversParentTypes['SpendTransactionsDisputeResult']
> = {
  __resolveType: TypeResolveFn<'SpendTransactionsDisputeResponse', ParentType, ContextType>
}

export type SpendTransactionsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendTransactionsResponse'] = ResolversParentTypes['SpendTransactionsResponse']
> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  postingDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  disputedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  transactionCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  coreTransactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendTransferInItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendTransferInItem'] = ResolversParentTypes['SpendTransferInItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpendTransferOutItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SpendTransferOutItem'] = ResolversParentTypes['SpendTransferOutItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SplitDepositResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDeposit'] = ResolversParentTypes['SplitDeposit']
> = {
  allocations?: Resolver<Array<ResolversTypes['SplitDepositAllocation']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  distributedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  expectedNextDepositAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  expectedNextDepositAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isCancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isCanceled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isUsingRecommendedAllocations?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  savingsRatePercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  settingsId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  splitDistribution?: Resolver<ResolversTypes['DistributionAmounts'], ParentType, ContextType>
  transactionAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  willDistributeAutomaticallyAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SplitDepositAllocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositAllocation'] = ResolversParentTypes['SplitDepositAllocation']
> = {
  __resolveType: TypeResolveFn<
    'SplitDepositDirectDepositAllocation' | 'SplitDepositRecurrenceAllocation',
    ParentType,
    ContextType
  >
  allocationPercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  targetAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  targetAccountType?: Resolver<
    ResolversTypes['SplitDepositTargetAccountType'],
    ParentType,
    ContextType
  >
}

export type SplitDepositDailyRecurrenceRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositDailyRecurrenceRule'] = ResolversParentTypes['SplitDepositDailyRecurrenceRule']
> = {
  frequency?: Resolver<ResolversTypes['SplitDepositRecurrenceFrequency'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SplitDepositDirectDepositAllocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositDirectDepositAllocation'] = ResolversParentTypes['SplitDepositDirectDepositAllocation']
> = {
  allocationPercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  normalizedAmount?: Resolver<
    Maybe<ResolversTypes['FormattedMonetaryAmount']>,
    ParentType,
    ContextType
  >
  normalizedDailyAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  targetAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  targetAccountType?: Resolver<
    ResolversTypes['SplitDepositTargetAccountType'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SplitDepositDirectDepositIntentSettingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositDirectDepositIntentSetting'] = ResolversParentTypes['SplitDepositDirectDepositIntentSetting']
> = {
  allocations?: Resolver<
    Array<ResolversTypes['SplitDepositDirectDepositAllocation']>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  distributionType?: Resolver<ResolversTypes['DistributionType'], ParentType, ContextType>
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  employerHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  estimatedPaycheckAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isUsingRecommendedAllocations?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  onboarded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  savingsRatePercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  deposits?: Resolver<
    Maybe<Array<ResolversTypes['SplitDeposit']>>,
    ParentType,
    ContextType,
    RequireFields<SplitDepositDirectDepositIntentSettingDepositsArgs, never>
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SplitDepositDirectDepositSettingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositDirectDepositSetting'] = ResolversParentTypes['SplitDepositDirectDepositSetting']
> = {
  allocations?: Resolver<
    Array<ResolversTypes['SplitDepositDirectDepositAllocation']>,
    ParentType,
    ContextType
  >
  awaitingConfiguration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  distributionType?: Resolver<ResolversTypes['DistributionType'], ParentType, ContextType>
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  employerHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isUsingRecommendedAllocations?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  monthlyTotals?: Resolver<Array<ResolversTypes['MonthlyTotal']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  normalizedAmount?: Resolver<
    Maybe<ResolversTypes['FormattedMonetaryAmount']>,
    ParentType,
    ContextType
  >
  onboarded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  savingsRatePercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  deposits?: Resolver<
    Maybe<Array<ResolversTypes['SplitDeposit']>>,
    ParentType,
    ContextType,
    RequireFields<SplitDepositDirectDepositSettingDepositsArgs, never>
  >
  totalAmounts?: Resolver<Maybe<ResolversTypes['TotalAmounts']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SplitDepositMonthlyRecurrenceRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositMonthlyRecurrenceRule'] = ResolversParentTypes['SplitDepositMonthlyRecurrenceRule']
> = {
  byMonthDay?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>
  frequency?: Resolver<ResolversTypes['SplitDepositRecurrenceFrequency'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SplitDepositMutationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositMutation'] = ResolversParentTypes['SplitDepositMutation']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  execute?: Resolver<ResolversTypes['SplitDeposit'], ParentType, ContextType>
  cancel?: Resolver<ResolversTypes['SplitDeposit'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SplitDepositRecurrenceAllocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositRecurrenceAllocation'] = ResolversParentTypes['SplitDepositRecurrenceAllocation']
> = {
  allocationPercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  legacyRecurrenceAmount?: Resolver<
    Maybe<ResolversTypes['FormattedMonetaryAmount']>,
    ParentType,
    ContextType
  >
  legacyRecurrenceRule?: Resolver<
    Maybe<ResolversTypes['SplitDepositRecurrenceRule']>,
    ParentType,
    ContextType
  >
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  targetAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  targetAccountType?: Resolver<
    ResolversTypes['SplitDepositTargetAccountType'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SplitDepositRecurrenceRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositRecurrenceRule'] = ResolversParentTypes['SplitDepositRecurrenceRule']
> = {
  __resolveType: TypeResolveFn<
    | 'SplitDepositDailyRecurrenceRule'
    | 'SplitDepositMonthlyRecurrenceRule'
    | 'SplitDepositWeeklyRecurrenceRule',
    ParentType,
    ContextType
  >
  frequency?: Resolver<ResolversTypes['SplitDepositRecurrenceFrequency'], ParentType, ContextType>
}

export type SplitDepositRecurrenceSettingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositRecurrenceSetting'] = ResolversParentTypes['SplitDepositRecurrenceSetting']
> = {
  allocations?: Resolver<
    Array<ResolversTypes['SplitDepositRecurrenceAllocation']>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  distributionType?: Resolver<ResolversTypes['DistributionType'], ParentType, ContextType>
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  employerHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  monthlyTotals?: Resolver<Array<ResolversTypes['MonthlyTotal']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  normalizedAmount?: Resolver<
    Maybe<ResolversTypes['FormattedMonetaryAmount']>,
    ParentType,
    ContextType
  >
  onboarded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  savingsRatePercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  deposits?: Resolver<
    Maybe<Array<ResolversTypes['SplitDeposit']>>,
    ParentType,
    ContextType,
    RequireFields<SplitDepositRecurrenceSettingDepositsArgs, never>
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SplitDepositSettingsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositSettings'] = ResolversParentTypes['SplitDepositSettings']
> = {
  __resolveType: TypeResolveFn<
    | 'SplitDepositDirectDepositIntentSetting'
    | 'SplitDepositDirectDepositSetting'
    | 'SplitDepositRecurrenceSetting',
    ParentType,
    ContextType
  >
  allocations?: Resolver<Array<ResolversTypes['SplitDepositAllocation']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  distributionType?: Resolver<ResolversTypes['DistributionType'], ParentType, ContextType>
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  employerHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  onboarded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  savingsRatePercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  deposits?: Resolver<
    Maybe<Array<ResolversTypes['SplitDeposit']>>,
    ParentType,
    ContextType,
    RequireFields<SplitDepositSettingsDepositsArgs, never>
  >
}

export type SplitDepositSettingsMutationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositSettingsMutation'] = ResolversParentTypes['SplitDepositSettingsMutation']
> = {
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  employerHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  configure?: Resolver<
    ResolversTypes['SplitDepositSettings'],
    ParentType,
    ContextType,
    RequireFields<SplitDepositSettingsMutationConfigureArgs, 'input'>
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SplitDepositTargetAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositTargetAccount'] = ResolversParentTypes['SplitDepositTargetAccount']
> = {
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  targetAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  targetAccountType?: Resolver<
    ResolversTypes['SplitDepositTargetAccountType'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SplitDepositWeeklyRecurrenceRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplitDepositWeeklyRecurrenceRule'] = ResolversParentTypes['SplitDepositWeeklyRecurrenceRule']
> = {
  byWeekDay?: Resolver<Array<ResolversTypes['DayOfWeek']>, ParentType, ContextType>
  frequency?: Resolver<ResolversTypes['SplitDepositRecurrenceFrequency'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SsnAlreadyInUseExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SsnAlreadyInUseException'] = ResolversParentTypes['SsnAlreadyInUseException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SsnDocumentRequestedUserAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SSNDocumentRequestedUserAlert'] = ResolversParentTypes['SSNDocumentRequestedUserAlert']
> = {
  requestedDocumentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SsnMatchesCustodianExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SsnMatchesCustodianException'] = ResolversParentTypes['SsnMatchesCustodianException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SsnUpdateForbiddenExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SsnUpdateForbiddenException'] = ResolversParentTypes['SsnUpdateForbiddenException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SsnUsedErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SSNUsedError'] = ResolversParentTypes['SSNUsedError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type StartCheckDepositPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['StartCheckDepositPayload'] = ResolversParentTypes['StartCheckDepositPayload']
> = {
  sessionToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type StartOnlineSwitchPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['StartOnlineSwitchPayload'] = ResolversParentTypes['StartOnlineSwitchPayload']
> = {
  userSwitch?: Resolver<ResolversTypes['UserSwitch'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type StartSubmittableSwitchPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['StartSubmittableSwitchPayload'] = ResolversParentTypes['StartSubmittableSwitchPayload']
> = {
  userSwitch?: Resolver<ResolversTypes['UserSwitch'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type StatementResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Statement'] = ResolversParentTypes['Statement']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  statementType?: Resolver<ResolversTypes['StatementType'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  uploaded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  archivableId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  archivableType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  s3Filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  link?: Resolver<Maybe<ResolversTypes['StatementLink']>, ParentType, ContextType>
  investmentAccountType?: Resolver<
    Maybe<ResolversTypes['InvestmentAccountType']>,
    ParentType,
    ContextType
  >
  formType?: Resolver<Maybe<ResolversTypes['FormType']>, ParentType, ContextType>
  portfolioType?: Resolver<ResolversTypes['StatementPortfolioType'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type StatementLinkResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['StatementLink'] = ResolversParentTypes['StatementLink']
> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  downloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type StockResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Stock'] = ResolversParentTypes['Stock']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  symbol?: Resolver<ResolversTypes['TickerSymbol'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['SecurityType'], ParentType, ContextType>
  week52High?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  week52Low?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  currentPrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  lastClosePrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  openPrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  shortName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  longName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  volume?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>
  marketCap?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>
  profile?: Resolver<ResolversTypes['SecurityProfile'], ParentType, ContextType>
  securityProfile?: Resolver<ResolversTypes['SecurityProfile'], ParentType, ContextType>
  headlines?: Resolver<Array<ResolversTypes['SecurityHeadline']>, ParentType, ContextType>
  securityHeadlines?: Resolver<Array<ResolversTypes['SecurityHeadline']>, ParentType, ContextType>
  lastUpdatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  earliestPriceDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface StringKeyScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['StringKey'], any> {
  name: 'StringKey'
}

export type StringKeyAssetResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['StringKeyAsset'] = ResolversParentTypes['StringKeyAsset']
> = {
  args?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  key?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SubcategoryMessageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SubcategoryMessage'] = ResolversParentTypes['SubcategoryMessage']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SubmissionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Submission'] = ResolversParentTypes['Submission']
> = {
  bank?: Resolver<ResolversTypes['BankName'], ParentType, ContextType>
  linkedAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['SubmissionStatus'], ParentType, ContextType>
  updated?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  feeSynopsis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SubmissionErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SubmissionError'] = ResolversParentTypes['SubmissionError']
> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SubmitBankFeeNegotiationResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SubmitBankFeeNegotiationResponse'] = ResolversParentTypes['SubmitBankFeeNegotiationResponse']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SubmitBankFeeNegotiationResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SubmitBankFeeNegotiationResult'] = ResolversParentTypes['SubmitBankFeeNegotiationResult']
> = {
  __resolveType: TypeResolveFn<
    'SubmitBankFeeNegotiationResponse' | 'LinkedAccountNotFound',
    ParentType,
    ContextType
  >
}

export type SubmittableSwitchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SubmittableSwitch'] = ResolversParentTypes['SubmittableSwitch']
> = {
  requiresEmployerMailingAddress?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  requiresNonSsnEmployeeId?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  requiresSsnLastFour?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  source?: Resolver<ResolversTypes['SwitchSource'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>
  vendorTargetId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SubmitUserReportedBankFeeRefundResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SubmitUserReportedBankFeeRefundResult'] = ResolversParentTypes['SubmitUserReportedBankFeeRefundResult']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SubscriberIneligibleErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SubscriberIneligibleError'] = ResolversParentTypes['SubscriberIneligibleError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SubscribeToTierResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SubscribeToTierResult'] = ResolversParentTypes['SubscribeToTierResult']
> = {
  __resolveType: TypeResolveFn<
    'InvalidTier' | 'InvalidTierPrice' | 'TierSubscription',
    ParentType,
    ContextType
  >
}

export type SubscribeUserToTierResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SubscribeUserToTierResult'] = ResolversParentTypes['SubscribeUserToTierResult']
> = {
  __resolveType: TypeResolveFn<
    'InvalidTierPriceId' | 'TierDowngradeActionRequired' | 'TierSubscription',
    ParentType,
    ContextType
  >
}

export type SubscriptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']
> = {
  onMessageCreated?: SubscriptionResolver<
    ResolversTypes['Message'],
    'onMessageCreated',
    ParentType,
    ContextType
  >
}

export type SubscriptionMigrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SubscriptionMigration'] = ResolversParentTypes['SubscriptionMigration']
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  effectiveAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  fromTier?: Resolver<ResolversTypes['Tier'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  toTier?: Resolver<ResolversTypes['Tier'], ParentType, ContextType>
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SubscriptionMigrationInvalidErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SubscriptionMigrationInvalidError'] = ResolversParentTypes['SubscriptionMigrationInvalidError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SubscriptionMigrationWaiverResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SubscriptionMigrationWaiver'] = ResolversParentTypes['SubscriptionMigrationWaiver']
> = {
  accepted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  migration?: Resolver<ResolversTypes['SubscriptionMigration'], ParentType, ContextType>
  reason?: Resolver<ResolversTypes['SubscriptionMigrationWaiverReason'], ParentType, ContextType>
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SuitabilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Suitability'] = ResolversParentTypes['Suitability']
> = {
  answer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  answerId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  pickerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  questionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Suitability_PortfolioResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['suitability_Portfolio'] = ResolversParentTypes['suitability_Portfolio']
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Suitability_SuitabilityAnswerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['suitability_SuitabilityAnswer'] = ResolversParentTypes['suitability_SuitabilityAnswer']
> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Suitability_SuitabilityQuestionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['suitability_SuitabilityQuestion'] = ResolversParentTypes['suitability_SuitabilityQuestion']
> = {
  defaultAnswer?: Resolver<
    Maybe<ResolversTypes['suitability_SuitabilityAnswer']>,
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  possibleAnswers?: Resolver<
    Array<ResolversTypes['suitability_SuitabilityAnswer']>,
    ParentType,
    ContextType
  >
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Suitability_SuitabilityResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['suitability_SuitabilityResponse'] = ResolversParentTypes['suitability_SuitabilityResponse']
> = {
  answer?: Resolver<Maybe<ResolversTypes['suitability_SuitabilityAnswer']>, ParentType, ContextType>
  question?: Resolver<ResolversTypes['suitability_SuitabilityQuestion'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Suitability_UpdateSuitabilityResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['suitability_UpdateSuitabilityResult'] = ResolversParentTypes['suitability_UpdateSuitabilityResult']
> = {
  recommendedPortfolio?: Resolver<
    Maybe<ResolversTypes['suitability_Portfolio']>,
    ParentType,
    ContextType
  >
  suitabilityResponses?: Resolver<
    Array<ResolversTypes['suitability_SuitabilityResponse']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SuitabilityAnswerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SuitabilityAnswer'] = ResolversParentTypes['SuitabilityAnswer']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  answer?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SuitabilityQuestionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SuitabilityQuestion'] = ResolversParentTypes['SuitabilityQuestion']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  pickerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  placeholder?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  answers?: Resolver<Array<Maybe<ResolversTypes['SuitabilityAnswer']>>, ParentType, ContextType>
  defaultAnswer?: Resolver<ResolversTypes['SuitabilityAnswer'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SummaryItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SummaryItem'] = ResolversParentTypes['SummaryItem']
> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SupportArticleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportArticle'] = ResolversParentTypes['SupportArticle']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  editedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  sectionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  author?: Resolver<ResolversTypes['SupportAuthor'], ParentType, ContextType>
  promoted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  section?: Resolver<ResolversTypes['SupportSection'], ParentType, ContextType>
  category?: Resolver<ResolversTypes['SupportCategory'], ParentType, ContextType>
  private?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SupportAuthorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportAuthor'] = ResolversParentTypes['SupportAuthor']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  photo?: Resolver<ResolversTypes['SupportAuthorPhoto'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SupportAuthorPhotoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportAuthorPhoto'] = ResolversParentTypes['SupportAuthorPhoto']
> = {
  contentUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SupportCategoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportCategory'] = ResolversParentTypes['SupportCategory']
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SupportSectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportSection'] = ResolversParentTypes['SupportSection']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  articles?: Resolver<Array<Maybe<ResolversTypes['SupportArticle']>>, ParentType, ContextType>
  category?: Resolver<ResolversTypes['SupportCategory'], ParentType, ContextType>
  categoryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SupportTicketResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportTicket'] = ResolversParentTypes['SupportTicket']
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SupportTicketFormResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportTicketForm'] = ResolversParentTypes['SupportTicketForm']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  ticketFields?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SupportTicketFormField']>>>,
    ParentType,
    ContextType
  >
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  isDefault?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SupportTicketFormFieldResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportTicketFormField'] = ResolversParentTypes['SupportTicketFormField']
> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  systemFieldOptions?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['CustomFieldOption']>>>,
    ParentType,
    ContextType
  >
  customFieldOptions?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['CustomFieldOption']>>>,
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SupportTicketResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportTicketResponse'] = ResolversParentTypes['SupportTicketResponse']
> = {
  __resolveType: TypeResolveFn<'SupportTicket' | 'RecaptchaException', ParentType, ContextType>
}

export type SupportTicketWithCustomFieldsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportTicketWithCustomFieldsResponse'] = ResolversParentTypes['SupportTicketWithCustomFieldsResponse']
> = {
  __resolveType: TypeResolveFn<'SupportTicket' | 'SubmissionError', ParentType, ContextType>
}

export type SupportUserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportUser'] = ResolversParentTypes['SupportUser']
> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SwitchInterfaceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SwitchInterface'] = ResolversParentTypes['SwitchInterface']
> = {
  __resolveType: TypeResolveFn<
    'AcornsPdfSwitch' | 'OnlineSwitch' | 'SubmittableSwitch',
    ParentType,
    ContextType
  >
  source?: Resolver<ResolversTypes['SwitchSource'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>
}

export type SwitchPayloadInterfaceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SwitchPayloadInterface'] = ResolversParentTypes['SwitchPayloadInterface']
> = {
  __resolveType: TypeResolveFn<
    'StartOnlineSwitchPayload' | 'StartSubmittableSwitchPayload',
    ParentType,
    ContextType
  >
  userSwitch?: Resolver<ResolversTypes['UserSwitch'], ParentType, ContextType>
}

export type SyncBankFeeTransactionsResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SyncBankFeeTransactionsResult'] = ResolversParentTypes['SyncBankFeeTransactionsResult']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SystemCardLockedSpendAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SystemCardLockedSpendAlert'] = ResolversParentTypes['SystemCardLockedSpendAlert']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TaxWithholdingAmountsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TaxWithholdingAmounts'] = ResolversParentTypes['TaxWithholdingAmounts']
> = {
  federalWithholdingAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  stateWithholdingAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TfaOptionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TfaOptions'] = ResolversParentTypes['TfaOptions']
> = {
  phone?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  email?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  question?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  notification?: Resolver<Maybe<Array<ResolversTypes['TfaNotification']>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface TickerSymbolScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['TickerSymbol'], any> {
  name: 'TickerSymbol'
}

export type TierResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Tier'] = ResolversParentTypes['Tier']
> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  assetPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  bundles?: Resolver<Maybe<Array<ResolversTypes['Bundle']>>, ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  excludedProducts?: Resolver<Array<ResolversTypes['TierProduct']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  includedProducts?: Resolver<Array<ResolversTypes['TierProduct']>, ParentType, ContextType>
  key?: Resolver<ResolversTypes['TierKey'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  products?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType>
  tierGroupId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  tierPrice?: Resolver<ResolversTypes['TierPrice'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierDowngradeActionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierDowngradeAction'] = ResolversParentTypes['TierDowngradeAction']
> = {
  key?: Resolver<ResolversTypes['TierDowngradeActionKey'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierDowngradeActionRequiredResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierDowngradeActionRequired'] = ResolversParentTypes['TierDowngradeActionRequired']
> = {
  actions?: Resolver<Array<ResolversTypes['TierDowngradeAction']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierGroupResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierGroup'] = ResolversParentTypes['TierGroup']
> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  preferredTierId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  tierOptions?: Resolver<Array<ResolversTypes['TierOption']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  winbackTierOption?: Resolver<Maybe<ResolversTypes['TierOption']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierOptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierOption'] = ResolversParentTypes['TierOption']
> = {
  preferredTierPrice?: Resolver<ResolversTypes['TierPrice'], ParentType, ContextType>
  tier?: Resolver<ResolversTypes['Tier'], ParentType, ContextType>
  tierPrices?: Resolver<Array<ResolversTypes['TierPrice']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierOptionByTierPriceIdResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierOptionByTierPriceIdResult'] = ResolversParentTypes['TierOptionByTierPriceIdResult']
> = {
  __resolveType: TypeResolveFn<'InvalidTierPriceId' | 'TierOption', ParentType, ContextType>
}

export type TierPriceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierPrice'] = ResolversParentTypes['TierPrice']
> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  billingFrequency?: Resolver<ResolversTypes['BillingFrequency'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  tierId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierProductResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierProduct'] = ResolversParentTypes['TierProduct']
> = {
  key?: Resolver<ResolversTypes['ProductKey'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierSubscriptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierSubscription'] = ResolversParentTypes['TierSubscription']
> = {
  activePromotion?: Resolver<Maybe<ResolversTypes['Promotion']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  createdBy?: Resolver<Maybe<ResolversTypes['TierSubscriptionCreatedBy']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  migration?: Resolver<Maybe<ResolversTypes['SubscriptionMigration']>, ParentType, ContextType>
  migrationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  offer?: Resolver<Maybe<ResolversTypes['Offer']>, ParentType, ContextType>
  offerExpiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  promotionAppliedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  promotionExpiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  status?: Resolver<ResolversTypes['TierSubscriptionStatus'], ParentType, ContextType>
  tier?: Resolver<ResolversTypes['Tier'], ParentType, ContextType>
  tierPrice?: Resolver<ResolversTypes['TierPrice'], ParentType, ContextType>
  transition?: Resolver<
    Maybe<ResolversTypes['TierSubscriptionTransition']>,
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierSubscriptionAlreadyDeactivatedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierSubscriptionAlreadyDeactivated'] = ResolversParentTypes['TierSubscriptionAlreadyDeactivated']
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierSubscriptionConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierSubscriptionConnection'] = ResolversParentTypes['TierSubscriptionConnection']
> = {
  edges?: Resolver<Array<ResolversTypes['TierSubscription']>, ParentType, ContextType>
  pageInfo?: Resolver<ResolversTypes['TierSubscriptionPageInfo'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierSubscriptionForUserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierSubscriptionForUser'] = ResolversParentTypes['TierSubscriptionForUser']
> = {
  __resolveType: TypeResolveFn<
    'TierSubscription' | 'TierSubscriptionNotFound' | 'TierSubscriptionUnsubscribed',
    ParentType,
    ContextType
  >
}

export type TierSubscriptionNotFoundResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierSubscriptionNotFound'] = ResolversParentTypes['TierSubscriptionNotFound']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierSubscriptionPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierSubscriptionPageInfo'] = ResolversParentTypes['TierSubscriptionPageInfo']
> = {
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  hasNext?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierSubscriptionTransitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierSubscriptionTransition'] = ResolversParentTypes['TierSubscriptionTransition']
> = {
  desiredTier?: Resolver<Maybe<ResolversTypes['Tier']>, ParentType, ContextType>
  desiredTierPrice?: Resolver<Maybe<ResolversTypes['TierPrice']>, ParentType, ContextType>
  initiatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  subscriptionDeactivationReason?: Resolver<
    Maybe<ResolversTypes['TierSubscriptionDeactivationReason']>,
    ParentType,
    ContextType
  >
  transitionAction?: Resolver<
    ResolversTypes['SubscriptionTransitionAction'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TierSubscriptionUnsubscribedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TierSubscriptionUnsubscribed'] = ResolversParentTypes['TierSubscriptionUnsubscribed']
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface TimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Time'], any> {
  name: 'Time'
}

export type TimestampsInterfaceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimestampsInterface'] = ResolversParentTypes['TimestampsInterface']
> = {
  __resolveType: TypeResolveFn<
    | 'InvestmentAccount'
    | 'RecurringInvestmentSettings'
    | 'Beneficiary'
    | 'Address'
    | 'Phone'
    | 'Account'
    | 'Profile'
    | 'Signature'
    | 'BillingCycle'
    | 'Credit'
    | 'Fee'
    | 'FeeExecution'
    | 'FinancialInstitution'
    | 'LinkedAccount'
    | 'LinkedSubaccount'
    | 'RoundUpAccount'
    | 'RoundUpProfile'
    | 'RoundUp'
    | 'FundingSourceAccount'
    | 'OutsideContributionCode'
    | 'InvestmentAccountReopenRequest'
    | 'InvestmentAccountReopenRequestAction'
    | 'InvestmentAccountReopenRequestNote'
    | 'UserInvestmentAccountReopenCheck'
    | 'OutsideContributionCheckoutCart'
    | 'OutsideContribution',
    ParentType,
    ContextType
  >
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
}

export type TipResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Tip'] = ResolversParentTypes['Tip']
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ToggleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Toggle'] = ResolversParentTypes['Toggle']
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  value?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  invalid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TokenExpiredExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TokenExpiredException'] = ResolversParentTypes['TokenExpiredException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TopEmployerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TopEmployer'] = ResolversParentTypes['TopEmployer']
> = {
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  employerSwitchType?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>
  logo?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  onlineSwitchUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TopEmployerPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TopEmployerPayload'] = ResolversParentTypes['TopEmployerPayload']
> = {
  topEmployersList?: Resolver<Array<ResolversTypes['TopEmployer']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TopHoldingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TopHolding'] = ResolversParentTypes['TopHolding']
> = {
  symbol?: Resolver<Maybe<ResolversTypes['TickerSymbol']>, ParentType, ContextType>
  securityName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  numberOfShares?: Resolver<Maybe<ResolversTypes['BigDecimal']>, ParentType, ContextType>
  sharePercentage?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>
  marketValue?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TotalAmountsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TotalAmounts'] = ResolversParentTypes['TotalAmounts']
> = {
  totalContributedAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  totalDepositedAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TransactionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TransactionResult'] = ResolversParentTypes['TransactionResult']
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TransferResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Transfer'] = ResolversParentTypes['Transfer']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['TransferState'], ParentType, ContextType>
  from?: Resolver<ResolversTypes['TransferableAccount'], ParentType, ContextType>
  to?: Resolver<ResolversTypes['TransferableAccount'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  canceledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TransferableAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TransferableAccount'] = ResolversParentTypes['TransferableAccount']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['TransferableAccountTypeEnum'], ParentType, ContextType>
  balance?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  accountNumberMasked?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  externalSource?: Resolver<Maybe<ResolversTypes['ExternalSource']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TransferableFromResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TransferableFrom'] = ResolversParentTypes['TransferableFrom']
> = {
  from?: Resolver<ResolversTypes['TransferableAccount'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TransferableToResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TransferableTo'] = ResolversParentTypes['TransferableTo']
> = {
  to?: Resolver<ResolversTypes['TransferableAccount'], ParentType, ContextType>
  min?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  max?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TransferInternalSharesResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TransferInternalSharesResult'] = ResolversParentTypes['TransferInternalSharesResult']
> = {
  __resolveType: TypeResolveFn<
    'OmnibusShareTransferId' | 'InternalShareTransferFailed',
    ParentType,
    ContextType
  >
}

export type TrendingLearnContentPreviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TrendingLearnContentPreview'] = ResolversParentTypes['TrendingLearnContentPreview']
> = {
  __resolveType: TypeResolveFn<
    | 'LearnArticlePreview'
    | 'LearnArticlePreviewLocked'
    | 'LearnMediaPreview'
    | 'LearnMediaPreviewLocked',
    ParentType,
    ContextType
  >
}

export type UnableToCancelCheckErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnableToCancelCheckError'] = ResolversParentTypes['UnableToCancelCheckError']
> = {
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UnauthenticatedSaveUploadUrlResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnauthenticatedSaveUploadUrlResult'] = ResolversParentTypes['UnauthenticatedSaveUploadUrlResult']
> = {
  __resolveType: TypeResolveFn<'DocumentUploads' | 'UploadSaveError', ParentType, ContextType>
}

export type UnauthorizedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnauthorizedException'] = ResolversParentTypes['UnauthorizedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UnblockDeviceResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnblockDeviceResult'] = ResolversParentTypes['UnblockDeviceResult']
> = {
  __resolveType: TypeResolveFn<'Device' | 'DeviceNotFoundException', ParentType, ContextType>
}

export type UnknownProviderResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnknownProvider'] = ResolversParentTypes['UnknownProvider']
> = {
  cta?: Resolver<ResolversTypes['Cta'], ParentType, ContextType>
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UnlockBankCardPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnlockBankCardPayload'] = ResolversParentTypes['UnlockBankCardPayload']
> = {
  bankCard?: Resolver<Maybe<ResolversTypes['BankCard']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UnmarkLearnContentAsHelpfulResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnmarkLearnContentAsHelpfulResult'] = ResolversParentTypes['UnmarkLearnContentAsHelpfulResult']
> = {
  __resolveType: TypeResolveFn<
    'UpdateLearnContentHelpfulnessResult' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type UnrecoverableLinkedAccountErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnrecoverableLinkedAccountError'] = ResolversParentTypes['UnrecoverableLinkedAccountError']
> = {
  linkedAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UnsubscribeUserFromTierResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnsubscribeUserFromTierResult'] = ResolversParentTypes['UnsubscribeUserFromTierResult']
> = {
  __resolveType: TypeResolveFn<
    'TierDowngradeActionRequired' | 'TierSubscriptionUnsubscribed',
    ParentType,
    ContextType
  >
}

export type UnverifiedBeneficiarySsnAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnverifiedBeneficiarySsnAlert'] = ResolversParentTypes['UnverifiedBeneficiarySsnAlert']
> = {
  beneficiary?: Resolver<ResolversTypes['Beneficiary'], ParentType, ContextType>
  beneficiaryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UnverifiedBeneficiarySsnAlertItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnverifiedBeneficiarySsnAlertItem'] = ResolversParentTypes['UnverifiedBeneficiarySsnAlertItem']
> = {
  beneficiary?: Resolver<ResolversTypes['Beneficiary'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateAccountPointsRuleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAccountPointsRuleResult'] = ResolversParentTypes['UpdateAccountPointsRuleResult']
> = {
  __resolveType: TypeResolveFn<
    'RecordAlreadyExistsError' | 'RecordDoesNotExistError' | 'AccountPointsRule',
    ParentType,
    ContextType
  >
}

export type UpdateAccountPortfolioResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAccountPortfolioResponse'] = ResolversParentTypes['UpdateAccountPortfolioResponse']
> = {
  __resolveType: TypeResolveFn<
    | 'InvalidActionOnAccount'
    | 'InvestmentAccount'
    | 'InvestmentAccountNotFoundException'
    | 'PortfolioNotFoundException'
    | 'PortfolioUpdateFailedException',
    ParentType,
    ContextType
  >
}

export type UpdateAttributionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAttributionResult'] = ResolversParentTypes['UpdateAttributionResult']
> = {
  __resolveType: TypeResolveFn<
    | 'InvalidConversionIdentifierException'
    | 'InvalidSourceAttributesException'
    | 'NoProspectRecord'
    | 'RegistrationFunnel',
    ParentType,
    ContextType
  >
}

export type UpdateAuthEmailResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAuthEmailResult'] = ResolversParentTypes['UpdateAuthEmailResult']
> = {
  __resolveType: TypeResolveFn<
    'AuthProfile' | 'ExistingEmailVerifiedException',
    ParentType,
    ContextType
  >
}

export type UpdateAuthPhoneNumberResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAuthPhoneNumberResult'] = ResolversParentTypes['UpdateAuthPhoneNumberResult']
> = {
  __resolveType: TypeResolveFn<
    'AuthProfile' | 'InvalidPhoneNumberException' | 'ExistingPhoneVerifiedException',
    ParentType,
    ContextType
  >
}

export type UpdateBankAccountGoalPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateBankAccountGoalPayload'] = ResolversParentTypes['UpdateBankAccountGoalPayload']
> = {
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateBankAccountGoalResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateBankAccountGoalResult'] = ResolversParentTypes['UpdateBankAccountGoalResult']
> = {
  __resolveType: TypeResolveFn<'UpdateBankAccountGoalPayload', ParentType, ContextType>
}

export type UpdateBankCardPinPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateBankCardPinPayload'] = ResolversParentTypes['UpdateBankCardPinPayload']
> = {
  bankCard?: Resolver<Maybe<ResolversTypes['BankCard']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateBeneficiaryInfoResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateBeneficiaryInfoResult'] = ResolversParentTypes['UpdateBeneficiaryInfoResult']
> = {
  __resolveType: TypeResolveFn<
    | 'Beneficiary'
    | 'BeneficiaryNotFoundException'
    | 'InternalErrorException'
    | 'InvalidAddressException'
    | 'InvalidEmailException'
    | 'InvalidPhoneException',
    ParentType,
    ContextType
  >
}

export type UpdateCoverageResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateCoverageResponse'] = ResolversParentTypes['UpdateCoverageResponse']
> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateCredentialsResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateCredentialsResult'] = ResolversParentTypes['UpdateCredentialsResult']
> = {
  __resolveType: TypeResolveFn<
    | 'Credentials'
    | 'EmailTakenException'
    | 'BlockedEmailDomainException'
    | 'UserCredentialsNotFoundException',
    ParentType,
    ContextType
  >
}

export type UpdateElapsedTimeForLearnQuizResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateElapsedTimeForLearnQuizResult'] = ResolversParentTypes['UpdateElapsedTimeForLearnQuizResult']
> = {
  __resolveType: TypeResolveFn<
    'LearnContentElapsedMillisecondsUpdatedResult' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type UpdateLearnContentHelpfulnessResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateLearnContentHelpfulnessResult'] = ResolversParentTypes['UpdateLearnContentHelpfulnessResult']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  isHelpful?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateLearnProgressResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateLearnProgressResult'] = ResolversParentTypes['UpdateLearnProgressResult']
> = {
  __resolveType: TypeResolveFn<
    'LearnProgressUpdatedResult' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type UpdateMessageFailedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateMessageFailed'] = ResolversParentTypes['UpdateMessageFailed']
> = {
  errorMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateMessageIgnoredResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateMessageIgnored'] = ResolversParentTypes['UpdateMessageIgnored']
> = {
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateMessageResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateMessageResult'] = ResolversParentTypes['UpdateMessageResult']
> = {
  __resolveType: TypeResolveFn<
    'AlertMessage' | 'NotificationMessage' | 'UpdateMessageIgnored',
    ParentType,
    ContextType
  >
}

export type UpdateMilestoneAccountLevelDefinitionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateMilestoneAccountLevelDefinitionResult'] = ResolversParentTypes['UpdateMilestoneAccountLevelDefinitionResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneAccountLevelDefinition' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type UpdateMilestoneChallengeDefinitionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateMilestoneChallengeDefinitionResult'] = ResolversParentTypes['UpdateMilestoneChallengeDefinitionResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneChallengeDefinition' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type UpdateMilestoneChallengePointsRuleResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateMilestoneChallengePointsRuleResult'] = ResolversParentTypes['UpdateMilestoneChallengePointsRuleResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneChallengePointsRule' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type UpdateMilestoneDefinitionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateMilestoneDefinitionResult'] = ResolversParentTypes['UpdateMilestoneDefinitionResult']
> = {
  __resolveType: TypeResolveFn<
    'MilestoneDefinition' | 'RecordDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type UpdatePortfolioSecuritiesResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdatePortfolioSecuritiesResult'] = ResolversParentTypes['UpdatePortfolioSecuritiesResult']
> = {
  __resolveType: TypeResolveFn<
    | 'CustomerAgreementRequiredException'
    | 'InvalidAllocationPercentError'
    | 'InvalidSecurityError'
    | 'InvalidSecurityForAllocationError'
    | 'InvestmentAccount'
    | 'LiquidationUnavailableError'
    | 'NegativeSecurityPercentError'
    | 'PortfolioSecurityLimitReached',
    ParentType,
    ContextType
  >
}

export type UpdateRecommendedCoverageResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateRecommendedCoverageResponse'] = ResolversParentTypes['UpdateRecommendedCoverageResponse']
> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateReferralRewardErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateReferralRewardError'] = ResolversParentTypes['UpdateReferralRewardError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateReferralRewardResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateReferralRewardResponse'] = ResolversParentTypes['UpdateReferralRewardResponse']
> = {
  __resolveType: TypeResolveFn<
    'ReferralRewardSummary' | 'UpdateReferralRewardError',
    ParentType,
    ContextType
  >
}

export type UpdateSecurityQuestionAndAnswerResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateSecurityQuestionAndAnswerResult'] = ResolversParentTypes['UpdateSecurityQuestionAndAnswerResult']
> = {
  __resolveType: TypeResolveFn<
    'UpdateSecurityQuestionAndAnswerSuccess' | 'InvalidSecurityQuestionException',
    ParentType,
    ContextType
  >
}

export type UpdateSecurityQuestionAndAnswerSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateSecurityQuestionAndAnswerSuccess'] = ResolversParentTypes['UpdateSecurityQuestionAndAnswerSuccess']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  questionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  questionText?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateUserInfoResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateUserInfoResult'] = ResolversParentTypes['UpdateUserInfoResult']
> = {
  __resolveType: TypeResolveFn<
    'User' | 'SSNUsedError' | 'InvalidSSNError' | 'POBoxAddressError',
    ParentType,
    ContextType
  >
}

export type UpgradeAuthenticationResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpgradeAuthenticationResult'] = ResolversParentTypes['UpgradeAuthenticationResult']
> = {
  __resolveType: TypeResolveFn<
    'AuthSession' | 'AuthenticationAlreadyUpgradedException' | 'UserCredentialsNotFoundException',
    ParentType,
    ContextType
  >
}

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload'
}

export type UploadCheckPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UploadCheckPayload'] = ResolversParentTypes['UploadCheckPayload']
> = {
  sessionToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UploadDoesNotExistResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UploadDoesNotExist'] = ResolversParentTypes['UploadDoesNotExist']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UploadDoesNotExistErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UploadDoesNotExistError'] = ResolversParentTypes['UploadDoesNotExistError']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  uploadUuid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UploadFailedErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UploadFailedError'] = ResolversParentTypes['UploadFailedError']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UploadSaveErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UploadSaveError'] = ResolversParentTypes['UploadSaveError']
> = {
  uploadExceptions?: Resolver<
    Array<ResolversTypes['UploadSaveExceptions']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UploadSaveExceptionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UploadSaveExceptions'] = ResolversParentTypes['UploadSaveExceptions']
> = {
  __resolveType: TypeResolveFn<
    'FileDoesNotExistError' | 'UploadDoesNotExistError',
    ParentType,
    ContextType
  >
}

export type UploadUrlResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UploadUrl'] = ResolversParentTypes['UploadUrl']
> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  policy?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  uploadUuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  xAmzAlgorithm?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  xAmzCredential?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  xAmzDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  xAmzSecurityToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  xAmzSignature?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface UrlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['URL'], any> {
  name: 'URL'
}

export type UserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']
> = {
  uuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  dob?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  usCitizen?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  employer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  occupation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  pinCreated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  registrationComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  registrationCompletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  closedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  state?: Resolver<Maybe<ResolversTypes['USStateName']>, ParentType, ContextType>
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  fundingSource?: Resolver<Maybe<ResolversTypes['FundingSource']>, ParentType, ContextType>
  fundingSourceCanChange?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  fundingSourceChangeRequiresApproval?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  portfolio?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>
  uploads?: Resolver<Array<ResolversTypes['UserUpload']>, ParentType, ContextType>
  pendingBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  currentBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  allocationProfileId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  recommendedAllocationProfileId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  employedAffiliatedWithBrokerDealer?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  shareholderOrDirector?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  subjectToBackupWithholding?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  securityQuestion?: Resolver<ResolversTypes['SecurityQuestion'], ParentType, ContextType>
  suitability?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Suitability']>>>,
    ParentType,
    ContextType
  >
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  alerts?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserAlert']>>>, ParentType, ContextType>
  totals?: Resolver<ResolversTypes['UserTotals'], ParentType, ContextType>
  dailyChange?: Resolver<Maybe<ResolversTypes['UserDailyChange']>, ParentType, ContextType>
  roundUps?: Resolver<ResolversTypes['UserRoundUps'], ParentType, ContextType>
  maritalStatus?: Resolver<Maybe<ResolversTypes['MaritalStatusType']>, ParentType, ContextType>
  investmentAccounts?: Resolver<
    Maybe<Array<ResolversTypes['InvestmentAccount']>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type User_V2Resolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['User_v2'] = ResolversParentTypes['User_v2']
> = {
  closedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  uuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserAlert'] = ResolversParentTypes['UserAlert']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  metadata?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserAlertsItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserAlertsItem'] = ResolversParentTypes['UserAlertsItem']
> = {
  __resolveType: TypeResolveFn<
    | 'UserAlert'
    | 'MissingSsnBeneficiaryAlertItem'
    | 'UnverifiedBeneficiarySsnAlertItem'
    | 'LinkedAccountAlert'
    | 'RelinkLinkedAccountAlert'
    | 'AddressDocumentRequestedUserAlert'
    | 'BankDocumentRequestedUserAlert'
    | 'IdentityDocumentRequestedUserAlert'
    | 'InsufficientFundsUserAlert'
    | 'InvestmentsPausedUserAlert'
    | 'MiscDocumentRequestedUserAlert'
    | 'NoFundingSourceUserAlert'
    | 'RdvRequiredUserAlert'
    | 'SSNDocumentRequestedUserAlert'
    | 'W9DocumentRequestedUserAlert',
    ParentType,
    ContextType
  >
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
}

export type UserAlertsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserAlertsResponse'] = ResolversParentTypes['UserAlertsResponse']
> = {
  __resolveType: TypeResolveFn<
    | 'AddressDocumentRequestedUserAlert'
    | 'BankDocumentRequestedUserAlert'
    | 'IdentityDocumentRequestedUserAlert'
    | 'InsufficientFundsUserAlert'
    | 'InvestmentsPausedUserAlert'
    | 'MiscDocumentRequestedUserAlert'
    | 'NoFundingSourceUserAlert'
    | 'RdvRequiredUserAlert'
    | 'SSNDocumentRequestedUserAlert'
    | 'UserAlert'
    | 'W9DocumentRequestedUserAlert',
    ParentType,
    ContextType
  >
}

export type UserCardLockedSpendAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserCardLockedSpendAlert'] = ResolversParentTypes['UserCardLockedSpendAlert']
> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserClosedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserClosedException'] = ResolversParentTypes['UserClosedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserCredentialsNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserCredentialsNotFoundException'] = ResolversParentTypes['UserCredentialsNotFoundException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserDailyChangeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserDailyChange'] = ResolversParentTypes['UserDailyChange']
> = {
  accountChange?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  accountPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  change?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  marketChange?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  marketPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserInvestmentAccountReopenCheckResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserInvestmentAccountReopenCheck'] = ResolversParentTypes['UserInvestmentAccountReopenCheck']
> = {
  accountReopenRequestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  passed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  reopenCheckType?: Resolver<
    ResolversTypes['InvestmentAccountReopenCheck'],
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userUuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserLockedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserLockedException'] = ResolversParentTypes['UserLockedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserNotFoundResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserNotFound'] = ResolversParentTypes['UserNotFound']
> = {
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserNotFoundExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserNotFoundException'] = ResolversParentTypes['UserNotFoundException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserNotVerifiedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserNotVerifiedException'] = ResolversParentTypes['UserNotVerifiedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserPartnerStatusResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserPartnerStatusResponse'] = ResolversParentTypes['UserPartnerStatusResponse']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserReopenLockedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserReopenLockedException'] = ResolversParentTypes['UserReopenLockedException']
> = {
  lockedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserReopenSuspendedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserReopenSuspendedException'] = ResolversParentTypes['UserReopenSuspendedException']
> = {
  suspendedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  suspendedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserRoundUpsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserRoundUps'] = ResolversParentTypes['UserRoundUps']
> = {
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  waiting?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserStatus'] = ResolversParentTypes['UserStatus']
> = {
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  closed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  closedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  verifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  registrationComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  registrationCompleteAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserSuspendedExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserSuspendedException'] = ResolversParentTypes['UserSuspendedException']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  suspensionReasonValid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserSuspendedUploadTokenLengthErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserSuspendedUploadTokenLengthError'] = ResolversParentTypes['UserSuspendedUploadTokenLengthError']
> = {
  length?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserSuspendedUploadTokenValidationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserSuspendedUploadTokenValidation'] = ResolversParentTypes['UserSuspendedUploadTokenValidation']
> = {
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  tokenValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserSwitchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserSwitch'] = ResolversParentTypes['UserSwitch']
> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  isComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['SwitchStatus'], ParentType, ContextType>
  switchType?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  vendorSwitchId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserTotalsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserTotals'] = ResolversParentTypes['UserTotals']
> = {
  totalInvested?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  totalDeposits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  totalWithdrawn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  totalDividends?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  totalFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  totalReferrals?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  totalFoundMoney?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  totalGainLoss?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  totalOtherRewards?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  totalRoundUps?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserUploadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserUpload'] = ResolversParentTypes['UserUpload']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  documentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserWinbackErrorsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['userWinbackErrors'] = ResolversParentTypes['userWinbackErrors']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserWinbackScoreResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['userWinbackScore'] = ResolversParentTypes['userWinbackScore']
> = {
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  churnProbability?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  predictedRevenue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserWinbackScoreResResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['userWinbackScoreRes'] = ResolversParentTypes['userWinbackScoreRes']
> = {
  __resolveType: TypeResolveFn<'userWinbackScore' | 'userWinbackErrors', ParentType, ContextType>
}

export interface UsStateNameScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['USStateName'], any> {
  name: 'USStateName'
}

export interface UuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UUID'], any> {
  name: 'UUID'
}

export type ValidatePasswordResetTokenResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ValidatePasswordResetTokenResult'] = ResolversParentTypes['ValidatePasswordResetTokenResult']
> = {
  __resolveType: TypeResolveFn<
    'ValidatePasswordResetTokenSuccess' | 'InvalidPasswordResetTokenException',
    ParentType,
    ContextType
  >
}

export type ValidatePasswordResetTokenSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ValidatePasswordResetTokenSuccess'] = ResolversParentTypes['ValidatePasswordResetTokenSuccess']
> = {
  displaySsnField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ValidateUserSuspendedUploadTokenResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ValidateUserSuspendedUploadTokenResult'] = ResolversParentTypes['ValidateUserSuspendedUploadTokenResult']
> = {
  __resolveType: TypeResolveFn<
    'UserSuspendedUploadTokenLengthError' | 'UserSuspendedUploadTokenValidation',
    ParentType,
    ContextType
  >
}

export type VerifyCheckPaymentRecipientAddressResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['VerifyCheckPaymentRecipientAddressResult'] = ResolversParentTypes['VerifyCheckPaymentRecipientAddressResult']
> = {
  __resolveType: TypeResolveFn<
    'CheckPaymentRecipientAddressType' | 'InvalidAddressError' | 'AuthorizationError',
    ParentType,
    ContextType
  >
}

export type VerifyDeviceResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['VerifyDeviceResult'] = ResolversParentTypes['VerifyDeviceResult']
> = {
  __resolveType: TypeResolveFn<
    'SMSAuthChallenge' | 'EmailAuthChallenge' | 'DeviceNotFoundException',
    ParentType,
    ContextType
  >
}

export type VerifyPasswordsResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['VerifyPasswordsResult'] = ResolversParentTypes['VerifyPasswordsResult']
> = {
  __resolveType: TypeResolveFn<
    | 'VerifyPasswordsSuccess'
    | 'IncorrectOldPasswordException'
    | 'SamePasswordsException'
    | 'InvalidPasswordException'
    | 'UnauthorizedException',
    ParentType,
    ContextType
  >
}

export type VerifyPasswordsSuccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['VerifyPasswordsSuccess'] = ResolversParentTypes['VerifyPasswordsSuccess']
> = {
  isValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type VersionMismatchExceptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['VersionMismatchException'] = ResolversParentTypes['VersionMismatchException']
> = {
  latestVersion?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ViewedLearnContentResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ViewedLearnContentResult'] = ResolversParentTypes['ViewedLearnContentResult']
> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface VoidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Void'], any> {
  name: 'Void'
}

export type W9DocumentRequestedUserAlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['W9DocumentRequestedUserAlert'] = ResolversParentTypes['W9DocumentRequestedUserAlert']
> = {
  requestedDocumentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type WebhooksResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Webhooks'] = ResolversParentTypes['Webhooks']
> = {
  plaid?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type WebviewLinkSessionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WebviewLinkSession'] = ResolversParentTypes['WebviewLinkSession']
> = {
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type WithdrawalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Withdrawal'] = ResolversParentTypes['Withdrawal']
> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  presentableWithdrawalStatus?: Resolver<
    ResolversTypes['PresentableWithdrawalStatus'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type WithholdingDefaultsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WithholdingDefaults'] = ResolversParentTypes['WithholdingDefaults']
> = {
  federalWithholdingPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  stateWithholdingPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  showStateWithholdingField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  showFederalWithholdingField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type WithholdingEstimatesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WithholdingEstimates'] = ResolversParentTypes['WithholdingEstimates']
> = {
  estimatedCustomerAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  estimatedFederalWithholdingAmount?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >
  estimatedStateWithholdingAmount?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >
  estimatedTaxableEarnings?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>
  estimatedTotalWithholdingAmount?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type YearLaterReportResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['YearLaterReport'] = ResolversParentTypes['YearLaterReport']
> = {
  accountBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  accountCreationDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  accountPerformance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  accountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  firstDepositAmountForYear?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  firstDepositDateForYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  recurringContributionAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  recurringContributionFrequency?: Resolver<
    Maybe<ResolversTypes['InvestmentFrequency']>,
    ParentType,
    ContextType
  >
  totalDeposits?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalDepositsForYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalDividends?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalNetReturns?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalWithdrawals?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  userAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Resolvers<ContextType = any> = {
  AboutSection?: AboutSectionResolvers<ContextType>
  AbstractSwitch?: AbstractSwitchResolvers<ContextType>
  AcceptanceDocument?: AcceptanceDocumentResolvers<ContextType>
  AcceptDocumentResponse?: AcceptDocumentResponseResolvers<ContextType>
  AcceptedDocument?: AcceptedDocumentResolvers<ContextType>
  Account?: AccountResolvers<ContextType>
  AccountAchievement?: AccountAchievementResolvers<ContextType>
  AccountAlreadyClosedException?: AccountAlreadyClosedExceptionResolvers<ContextType>
  AccountClosedException?: AccountClosedExceptionResolvers<ContextType>
  AccountNotFoundException?: AccountNotFoundExceptionResolvers<ContextType>
  AccountNumber?: GraphQLScalarType
  AccountPoints?: AccountPointsResolvers<ContextType>
  AccountPointsRule?: AccountPointsRuleResolvers<ContextType>
  AccountRequirement?: AccountRequirementResolvers<ContextType>
  AccountRequirements?: AccountRequirementsResolvers<ContextType>
  AccountSetupMilestones?: AccountSetupMilestonesResolvers<ContextType>
  AccountStrengthResult?: AccountStrengthResultResolvers<ContextType>
  AccountValue?: AccountValueResolvers<ContextType>
  AcornsPdfSwitch?: AcornsPdfSwitchResolvers<ContextType>
  ActionCard?: ActionCardResolvers<ContextType>
  ActionCardButton?: ActionCardButtonResolvers<ContextType>
  ActionFeedCta?: ActionFeedCtaResolvers<ContextType>
  ActionFeedEventResponse?: ActionFeedEventResponseResolvers<ContextType>
  ActivateBankCardPayload?: ActivateBankCardPayloadResolvers<ContextType>
  Activity?: ActivityResolvers<ContextType>
  ActivitySummaryResponse?: ActivitySummaryResponseResolvers<ContextType>
  AddActionToMilestoneAchievementActionRuleResult?: AddActionToMilestoneAchievementActionRuleResultResolvers<
    ContextType
  >
  AddActionToMilestoneGroupAchievementActionRuleResult?: AddActionToMilestoneGroupAchievementActionRuleResultResolvers<
    ContextType
  >
  AddMilestonesToMilestoneHubDefinitionResult?: AddMilestonesToMilestoneHubDefinitionResultResolvers<
    ContextType
  >
  AddMilestoneToMilestoneGroupDefinitionResult?: AddMilestoneToMilestoneGroupDefinitionResultResolvers<
    ContextType
  >
  Address?: AddressResolvers<ContextType>
  AddressDeliverabilityAdditionalInfo?: AddressDeliverabilityAdditionalInfoResolvers<ContextType>
  AddressDeliverabilityCorrectedAddress?: AddressDeliverabilityCorrectedAddressResolvers<
    ContextType
  >
  AddressDeliverabilityResult?: AddressDeliverabilityResultResolvers<ContextType>
  AddressDeliverabilityUnavailableError?: AddressDeliverabilityUnavailableErrorResolvers<
    ContextType
  >
  AddressDeliverabilityVerificationError?: AddressDeliverabilityVerificationErrorResolvers<
    ContextType
  >
  AddressDeliverabilityVerified?: AddressDeliverabilityVerifiedResolvers<ContextType>
  AddressDocumentRequestedUserAlert?: AddressDocumentRequestedUserAlertResolvers<ContextType>
  AddSearchTermToLearnSearchHistoryResult?: AddSearchTermToLearnSearchHistoryResultResolvers<
    ContextType
  >
  AddSecurityToPortfolioResult?: AddSecurityToPortfolioResultResolvers<ContextType>
  AddSelfDirectedPortfolioResult?: AddSelfDirectedPortfolioResultResolvers<ContextType>
  Advocate?: AdvocateResolvers<ContextType>
  AdvocateFriendsStatuses?: AdvocateFriendsStatusesResolvers<ContextType>
  Alert?: AlertResolvers<ContextType>
  AlertHubBeneficiaryAlert?: AlertHubBeneficiaryAlertResolvers<ContextType>
  AlertMessage?: AlertMessageResolvers<ContextType>
  AllCheckPaymentsResult?: AllCheckPaymentsResultResolvers<ContextType>
  Amount?: GraphQLScalarType
  Answer?: AnswerResolvers<ContextType>
  AnswerLearnQuizQuestionResult?: AnswerLearnQuizQuestionResultResolvers<ContextType>
  ApplyPromotionResult?: ApplyPromotionResultResolvers<ContextType>
  Article?: ArticleResolvers<ContextType>
  AsyncLinkSessionResult?: AsyncLinkSessionResultResolvers<ContextType>
  AuthAlert?: AuthAlertResolvers<ContextType>
  AuthChallenge?: AuthChallengeResolvers<ContextType>
  AuthChallengeAnswerAttemptsExhaustedException?: AuthChallengeAnswerAttemptsExhaustedExceptionResolvers<
    ContextType
  >
  AuthChallengeAnswerIncorrectException?: AuthChallengeAnswerIncorrectExceptionResolvers<
    ContextType
  >
  AuthChallengeExpiredException?: AuthChallengeExpiredExceptionResolvers<ContextType>
  AuthenticateForFeeNegotiationResult?: AuthenticateForFeeNegotiationResultResolvers<ContextType>
  AuthenticateForFeeNegotiationStatus?: AuthenticateForFeeNegotiationStatusResolvers<ContextType>
  AuthenticateNegotiationStatusResult?: AuthenticateNegotiationStatusResultResolvers<ContextType>
  AuthenticateResult?: AuthenticateResultResolvers<ContextType>
  AuthenticationAlreadyUpgradedException?: AuthenticationAlreadyUpgradedExceptionResolvers<
    ContextType
  >
  Authenticator?: AuthenticatorResolvers<ContextType>
  AuthenticatorAlreadyDefaultException?: AuthenticatorAlreadyDefaultExceptionResolvers<ContextType>
  AuthenticatorInfo?: AuthenticatorInfoResolvers<ContextType>
  AuthenticatorNotFoundException?: AuthenticatorNotFoundExceptionResolvers<ContextType>
  AuthenticatorTypeAlreadyRegisteredException?: AuthenticatorTypeAlreadyRegisteredExceptionResolvers<
    ContextType
  >
  AuthenticatorUnavailableException?: AuthenticatorUnavailableExceptionResolvers<ContextType>
  AuthorizationError?: AuthorizationErrorResolvers<ContextType>
  AuthProfile?: AuthProfileResolvers<ContextType>
  AuthProfileAlreadyExistsException?: AuthProfileAlreadyExistsExceptionResolvers<ContextType>
  AuthProfileNotFoundException?: AuthProfileNotFoundExceptionResolvers<ContextType>
  AuthSession?: AuthSessionResolvers<ContextType>
  AuthTokenNotFoundException?: AuthTokenNotFoundExceptionResolvers<ContextType>
  AutomationError?: AutomationErrorResolvers<ContextType>
  BackendJobBatch?: BackendJobBatchResolvers<ContextType>
  BackendJobBatchSummary?: BackendJobBatchSummaryResolvers<ContextType>
  BackgroundImage?: BackgroundImageResolvers<ContextType>
  BankAccount?: BankAccountResolvers<ContextType>
  BankAccountDisclosure?: BankAccountDisclosureResolvers<ContextType>
  BankAccountGoal?: BankAccountGoalResolvers<ContextType>
  BankAccountGoals?: BankAccountGoalsResolvers<ContextType>
  BankAccountNotFoundError?: BankAccountNotFoundErrorResolvers<ContextType>
  BankAccountRequirement?: BankAccountRequirementResolvers<ContextType>
  BankAccountRequirements?: BankAccountRequirementsResolvers<ContextType>
  BankCard?: BankCardResolvers<ContextType>
  BankCardOrder?: BankCardOrderResolvers<ContextType>
  BankCardOrderAddressVerification?: BankCardOrderAddressVerificationResolvers<ContextType>
  BankCardOrderFundingSourceVerification?: BankCardOrderFundingSourceVerificationResolvers<
    ContextType
  >
  BankCardOrderIdentityVerification?: BankCardOrderIdentityVerificationResolvers<ContextType>
  BankCardOrderPrefundVerification?: BankCardOrderPrefundVerificationResolvers<ContextType>
  BankCardPin?: GraphQLScalarType
  BankCardReissue?: BankCardReissueResolvers<ContextType>
  BankCardRequest?: BankCardRequestResolvers<ContextType>
  BankCardRequestMailingAddress?: BankCardRequestMailingAddressResolvers<ContextType>
  BankConnection?: BankConnectionResolvers<ContextType>
  BankDocument?: BankDocumentResolvers<ContextType>
  BankDocumentRequestedUserAlert?: BankDocumentRequestedUserAlertResolvers<ContextType>
  BankFee?: BankFeeResolvers<ContextType>
  BankFeeConnection?: BankFeeConnectionResolvers<ContextType>
  BankFeeConnectionAlert?: BankFeeConnectionAlertResolvers<ContextType>
  BankFeeNegotiationAlert?: BankFeeNegotiationAlertResolvers<ContextType>
  BankFeeNegotiationResults?: BankFeeNegotiationResultsResolvers<ContextType>
  BankFeeSummary?: BankFeeSummaryResolvers<ContextType>
  BankMetadata?: BankMetadataResolvers<ContextType>
  BankMetadataTotals?: BankMetadataTotalsResolvers<ContextType>
  BankStatement?: BankStatementResolvers<ContextType>
  BankTransaction?: BankTransactionResolvers<ContextType>
  BankTransactionConnection?: BankTransactionConnectionResolvers<ContextType>
  BankTransactionEdge?: BankTransactionEdgeResolvers<ContextType>
  BasePortfolio?: BasePortfolioResolvers<ContextType>
  BatchAddTierSubscriptions?: BatchAddTierSubscriptionsResolvers<ContextType>
  BatchAddTierSubscriptionsResult?: BatchAddTierSubscriptionsResultResolvers<ContextType>
  Beneficiary?: BeneficiaryResolvers<ContextType>
  BeneficiaryAccountExistsException?: BeneficiaryAccountExistsExceptionResolvers<ContextType>
  BeneficiaryExceedsAgeLimitException?: BeneficiaryExceedsAgeLimitExceptionResolvers<ContextType>
  BeneficiaryNotFoundException?: BeneficiaryNotFoundExceptionResolvers<ContextType>
  BeneficiaryRequestedLaterAlert?: BeneficiaryRequestedLaterAlertResolvers<ContextType>
  BigCurrencyAmount?: BigCurrencyAmountResolvers<ContextType>
  BigDecimal?: GraphQLScalarType
  BillingCycle?: BillingCycleResolvers<ContextType>
  BillingProfileNotFoundException?: BillingProfileNotFoundExceptionResolvers<ContextType>
  BillNegotiation?: BillNegotiationResolvers<ContextType>
  BillNegotiationSubmitResult?: BillNegotiationSubmitResultResolvers<ContextType>
  BlockDeviceResult?: BlockDeviceResultResolvers<ContextType>
  BlockedEmailDomainException?: BlockedEmailDomainExceptionResolvers<ContextType>
  BriefInsuranceSection?: BriefInsuranceSectionResolvers<ContextType>
  Bundle?: BundleResolvers<ContextType>
  CancelCheckPaymentResult?: CancelCheckPaymentResultResolvers<ContextType>
  CancelInvestmentAccountClosureRequestResult?: CancelInvestmentAccountClosureRequestResultResolvers<
    ContextType
  >
  CancelInvestmentPayload?: CancelInvestmentPayloadResolvers<ContextType>
  CancelInvestmentResult?: CancelInvestmentResultResolvers<ContextType>
  CancelRecurringTransferResult?: CancelRecurringTransferResultResolvers<ContextType>
  CancelTransferPayload?: CancelTransferPayloadResolvers<ContextType>
  CardDeliveryStatus?: CardDeliveryStatusResolvers<ContextType>
  CardNumberMasked?: GraphQLScalarType
  CarouselOffer?: CarouselOfferResolvers<ContextType>
  ChallengePointsEarned?: ChallengePointsEarnedResolvers<ContextType>
  ChangeOutsideContributionAmountResult?: ChangeOutsideContributionAmountResultResolvers<
    ContextType
  >
  ChangePasswordResult?: ChangePasswordResultResolvers<ContextType>
  ChangePasswordSuccess?: ChangePasswordSuccessResolvers<ContextType>
  ChangeSecuritySymbolResult?: ChangeSecuritySymbolResultResolvers<ContextType>
  CheckPayment?: CheckPaymentResolvers<ContextType>
  CheckPaymentAddress?: CheckPaymentAddressResolvers<ContextType>
  CheckPaymentConnection?: CheckPaymentConnectionResolvers<ContextType>
  CheckPaymentEdge?: CheckPaymentEdgeResolvers<ContextType>
  CheckPaymentRecipient?: CheckPaymentRecipientResolvers<ContextType>
  CheckPaymentRecipientAddressType?: CheckPaymentRecipientAddressTypeResolvers<ContextType>
  CloseAccountReason?: CloseAccountReasonResolvers<ContextType>
  CloseBankAccountResult?: CloseBankAccountResultResolvers<ContextType>
  CloseInvestmentAccountResult?: CloseInvestmentAccountResultResolvers<ContextType>
  CloseUserAccountResult?: CloseUserAccountResultResolvers<ContextType>
  ClosureRequestDoesNotExistException?: ClosureRequestDoesNotExistExceptionResolvers<ContextType>
  ClosureRequestExistsException?: ClosureRequestExistsExceptionResolvers<ContextType>
  CohortEligibility?: CohortEligibilityResolvers<ContextType>
  CollapsedLifeRecommendation?: CollapsedLifeRecommendationResolvers<ContextType>
  CombinedPerformance?: CombinedPerformanceResolvers<ContextType>
  CompleteCheckDepositPayload?: CompleteCheckDepositPayloadResolvers<ContextType>
  CompletedQuiz?: CompletedQuizResolvers<ContextType>
  CondensedSocialCopies?: CondensedSocialCopiesResolvers<ContextType>
  ConfigureSplitDepositDirectDepositIntentGenericError?: ConfigureSplitDepositDirectDepositIntentGenericErrorResolvers<
    ContextType
  >
  ConfigureSplitDepositDirectDepositIntentPayload?: ConfigureSplitDepositDirectDepositIntentPayloadResolvers<
    ContextType
  >
  ConfigureSplitDepositDirectDepositIntentSettingResult?: ConfigureSplitDepositDirectDepositIntentSettingResultResolvers<
    ContextType
  >
  ConfigureSplitDepositDirectDepositSettingGenericError?: ConfigureSplitDepositDirectDepositSettingGenericErrorResolvers<
    ContextType
  >
  ConfigureSplitDepositDirectDepositSettingPayload?: ConfigureSplitDepositDirectDepositSettingPayloadResolvers<
    ContextType
  >
  ConfigureSplitDepositDirectDepositSettingResult?: ConfigureSplitDepositDirectDepositSettingResultResolvers<
    ContextType
  >
  ConnectACHAccountResult?: ConnectAchAccountResultResolvers<ContextType>
  ConnectACHAccountSucceeded?: ConnectAchAccountSucceededResolvers<ContextType>
  ContactCategory?: ContactCategoryResolvers<ContextType>
  ContactFaq?: ContactFaqResolvers<ContextType>
  ContactFormAlert?: ContactFormAlertResolvers<ContextType>
  ContactSubcategory?: ContactSubcategoryResolvers<ContextType>
  ContentPreviewConnection?: ContentPreviewConnectionResolvers<ContextType>
  ContentPreviewEdge?: ContentPreviewEdgeResolvers<ContextType>
  ContributionAbility?: ContributionAbilityResolvers<ContextType>
  ContributionAbilityByYear?: ContributionAbilityByYearResolvers<ContextType>
  ContributionActionRequiredError?: ContributionActionRequiredErrorResolvers<ContextType>
  ContributionAmountAboveThresholdError?: ContributionAmountAboveThresholdErrorResolvers<
    ContextType
  >
  ContributionAmountBelowThresholdError?: ContributionAmountBelowThresholdErrorResolvers<
    ContextType
  >
  ContributionCardDeclinedError?: ContributionCardDeclinedErrorResolvers<ContextType>
  ContributionHistoryItem?: ContributionHistoryItemResolvers<ContextType>
  ContributionInvalidOwnerEmailError?: ContributionInvalidOwnerEmailErrorResolvers<ContextType>
  CoreAccountAlreadyExistsException?: CoreAccountAlreadyExistsExceptionResolvers<ContextType>
  CoreAccountClosedException?: CoreAccountClosedExceptionResolvers<ContextType>
  CoreACHSubscriptionFeeItem?: CoreAchSubscriptionFeeItemResolvers<ContextType>
  CoreAdjustmentItem?: CoreAdjustmentItemResolvers<ContextType>
  CoreCashForwardItem?: CoreCashForwardItemResolvers<ContextType>
  CoreCollectionItem?: CoreCollectionItemResolvers<ContextType>
  CoreDividendsItem?: CoreDividendsItemResolvers<ContextType>
  CoreEmployeeCreditItem?: CoreEmployeeCreditItemResolvers<ContextType>
  CoreFeeInvestmentItem?: CoreFeeInvestmentItemResolvers<ContextType>
  CoreFoundMoneyRewardItem?: CoreFoundMoneyRewardItemResolvers<ContextType>
  CoreGiftCardCreditRedemptionItem?: CoreGiftCardCreditRedemptionItemResolvers<ContextType>
  CoreHoldingsTransferInItem?: CoreHoldingsTransferInItemResolvers<ContextType>
  CoreInvestmentItem?: CoreInvestmentItemResolvers<ContextType>
  CoreLocalFoundMoneyItem?: CoreLocalFoundMoneyItemResolvers<ContextType>
  CorePartnerRewardItem?: CorePartnerRewardItemResolvers<ContextType>
  CoreRebalanceItem?: CoreRebalanceItemResolvers<ContextType>
  CoreReferralRewardItem?: CoreReferralRewardItemResolvers<ContextType>
  CoreRoundUpsItem?: CoreRoundUpsItemResolvers<ContextType>
  CoreWithdrawalItem?: CoreWithdrawalItemResolvers<ContextType>
  Course?: CourseResolvers<ContextType>
  CoursePreview?: CoursePreviewResolvers<ContextType>
  CoursePreviewLocked?: CoursePreviewLockedResolvers<ContextType>
  CourseTheme?: CourseThemeResolvers<ContextType>
  CoverageAsk?: CoverageAskResolvers<ContextType>
  CoverageCalculator?: CoverageCalculatorResolvers<ContextType>
  CoverageGrow?: CoverageGrowResolvers<ContextType>
  CoverageKnown?: CoverageKnownResolvers<ContextType>
  CoverageShop?: CoverageShopResolvers<ContextType>
  CoverageShopWidget?: CoverageShopWidgetResolvers<ContextType>
  CoverageUnknown?: CoverageUnknownResolvers<ContextType>
  CreateAccountPointsRuleResult?: CreateAccountPointsRuleResultResolvers<ContextType>
  CreateAuthProfileResult?: CreateAuthProfileResultResolvers<ContextType>
  CreateBankAccountPayload?: CreateBankAccountPayloadResolvers<ContextType>
  CreateBeneficiaryResult?: CreateBeneficiaryResultResolvers<ContextType>
  CreateDirectDepositLinkInfoFailure?: CreateDirectDepositLinkInfoFailureResolvers<ContextType>
  CreateDirectDepositLinkInfoPayload?: CreateDirectDepositLinkInfoPayloadResolvers<ContextType>
  CreateDirectDepositLinkInfoSwitch?: CreateDirectDepositLinkInfoSwitchResolvers<ContextType>
  CreateDocumentUpload?: CreateDocumentUploadResolvers<ContextType>
  CreateInvestmentAccountResponse?: CreateInvestmentAccountResponseResolvers<ContextType>
  CreateJobAlertResult?: CreateJobAlertResultResolvers<ContextType>
  CreateMilestoneAccountLevelDefinitionResult?: CreateMilestoneAccountLevelDefinitionResultResolvers<
    ContextType
  >
  CreateMilestoneAchievementActionRuleResult?: CreateMilestoneAchievementActionRuleResultResolvers<
    ContextType
  >
  CreateMilestoneChallengeDefinitionResult?: CreateMilestoneChallengeDefinitionResultResolvers<
    ContextType
  >
  CreateMilestoneChallengePointsRuleResult?: CreateMilestoneChallengePointsRuleResultResolvers<
    ContextType
  >
  CreateMilestoneDefinitionResult?: CreateMilestoneDefinitionResultResolvers<ContextType>
  CreateMilestoneGroupAchievementActionRuleResult?: CreateMilestoneGroupAchievementActionRuleResultResolvers<
    ContextType
  >
  CreateMilestoneGroupDefinitionResult?: CreateMilestoneGroupDefinitionResultResolvers<ContextType>
  CreateMilestoneHubDefinitionResult?: CreateMilestoneHubDefinitionResultResolvers<ContextType>
  CreateMilestoneRuleResult?: CreateMilestoneRuleResultResolvers<ContextType>
  CreateOfferResult?: CreateOfferResultResolvers<ContextType>
  CreateOutsideContributionCheckoutCartResult?: CreateOutsideContributionCheckoutCartResultResolvers<
    ContextType
  >
  CreateOutsideContributionResult?: CreateOutsideContributionResultResolvers<ContextType>
  CreatePinwheelLinkToken?: CreatePinwheelLinkTokenResolvers<ContextType>
  CreateProspectUserResult?: CreateProspectUserResultResolvers<ContextType>
  CreateSavingsAccountPayload?: CreateSavingsAccountPayloadResolvers<ContextType>
  CreateSavingsAccountResult?: CreateSavingsAccountResultResolvers<ContextType>
  CreateSavingsAccountVerificationError?: CreateSavingsAccountVerificationErrorResolvers<
    ContextType
  >
  CreateSubscriptionMigrationResult?: CreateSubscriptionMigrationResultResolvers<ContextType>
  CreateUploadUrlResult?: CreateUploadUrlResultResolvers<ContextType>
  Credentials?: CredentialsResolvers<ContextType>
  Credit?: CreditResolvers<ContextType>
  Cta?: CtaResolvers<ContextType>
  CtaDetails?: CtaDetailsResolvers<ContextType>
  CurrencyAmount?: CurrencyAmountResolvers<ContextType>
  CurrencyMilestoneProgress?: CurrencyMilestoneProgressResolvers<ContextType>
  CurrentBankStatementNotProvided?: CurrentBankStatementNotProvidedResolvers<ContextType>
  CustodianCompany?: CustodianCompanyResolvers<ContextType>
  CustomerAgreementRequiredException?: CustomerAgreementRequiredExceptionResolvers<ContextType>
  CustomFieldOption?: CustomFieldOptionResolvers<ContextType>
  Date?: GraphQLScalarType
  DateTime?: GraphQLScalarType
  DeactivateBeneficiaryResult?: DeactivateBeneficiaryResultResolvers<ContextType>
  DeactivateSecurityFailed?: DeactivateSecurityFailedResolvers<ContextType>
  DeactivateSecurityResult?: DeactivateSecurityResultResolvers<ContextType>
  DeactivateTierSubscriptionResult?: DeactivateTierSubscriptionResultResolvers<ContextType>
  DeleteExpiredBankCardOrderCardTierNotFoundError?: DeleteExpiredBankCardOrderCardTierNotFoundErrorResolvers<
    ContextType
  >
  DeleteExpiredBankCardOrderNotExpiredError?: DeleteExpiredBankCardOrderNotExpiredErrorResolvers<
    ContextType
  >
  DeleteExpiredBankCardOrderNotFoundError?: DeleteExpiredBankCardOrderNotFoundErrorResolvers<
    ContextType
  >
  DeleteExpiredBankCardOrderResult?: DeleteExpiredBankCardOrderResultResolvers<ContextType>
  DepositRiskFactor?: DepositRiskFactorResolvers<ContextType>
  DeregisterAuthenticatorResult?: DeregisterAuthenticatorResultResolvers<ContextType>
  DesignLibraryIcon?: DesignLibraryIconResolvers<ContextType>
  Destination?: DestinationResolvers<ContextType>
  Device?: DeviceResolvers<ContextType>
  DeviceBlockedException?: DeviceBlockedExceptionResolvers<ContextType>
  DeviceNotFoundException?: DeviceNotFoundExceptionResolvers<ContextType>
  DirectDepositState?: DirectDepositStateResolvers<ContextType>
  DirectDepositStatePayload?: DirectDepositStatePayloadResolvers<ContextType>
  Disclaimer?: DisclaimerResolvers<ContextType>
  DiscreteMilestoneProgress?: DiscreteMilestoneProgressResolvers<ContextType>
  DistributionAmounts?: DistributionAmountsResolvers<ContextType>
  Dividend?: DividendResolvers<ContextType>
  Document?: DocumentResolvers<ContextType>
  DocumentNotFound?: DocumentNotFoundResolvers<ContextType>
  DocumentRequest?: DocumentRequestResolvers<ContextType>
  DocumentRequestEdge?: DocumentRequestEdgeResolvers<ContextType>
  DocumentRequestsConnection?: DocumentRequestsConnectionResolvers<ContextType>
  DocumentRequestsPageInfo?: DocumentRequestsPageInfoResolvers<ContextType>
  DocumentUploads?: DocumentUploadsResolvers<ContextType>
  DuplicateActionError?: DuplicateActionErrorResolvers<ContextType>
  EarlyAccountStateRegulation?: EarlyAccountStateRegulationResolvers<ContextType>
  EarlyAccountStateRegulationResult?: EarlyAccountStateRegulationResultResolvers<ContextType>
  EarlyAccountTransferInfo?: EarlyAccountTransferInfoResolvers<ContextType>
  EarlyDividendsItem?: EarlyDividendsItemResolvers<ContextType>
  EarlyFeeInvestmentItem?: EarlyFeeInvestmentItemResolvers<ContextType>
  EarlyGiftItem?: EarlyGiftItemResolvers<ContextType>
  EarlyInvestmentItem?: EarlyInvestmentItemResolvers<ContextType>
  EarlyWithdrawalItem?: EarlyWithdrawalItemResolvers<ContextType>
  EarnCTARecord?: EarnCtaRecordResolvers<ContextType>
  EarnOffer?: EarnOfferResolvers<ContextType>
  EarnOfferCtaDetails?: EarnOfferCtaDetailsResolvers<ContextType>
  EarnOfferQueryPage?: EarnOfferQueryPageResolvers<ContextType>
  EarnPageInfo?: EarnPageInfoResolvers<ContextType>
  EditSecurityQuestionResult?: EditSecurityQuestionResultResolvers<ContextType>
  Education?: EducationResolvers<ContextType>
  EducationSection?: EducationSectionResolvers<ContextType>
  EducationTip?: EducationTipResolvers<ContextType>
  Eligibility?: EligibilityResolvers<ContextType>
  Email?: GraphQLScalarType
  EmailAddress?: GraphQLScalarType
  EmailAddressValidation?: EmailAddressValidationResolvers<ContextType>
  EmailAuthChallenge?: EmailAuthChallengeResolvers<ContextType>
  EmailAuthenticator?: EmailAuthenticatorResolvers<ContextType>
  EmailTakenException?: EmailTakenExceptionResolvers<ContextType>
  Employer?: EmployerResolvers<ContextType>
  EnableQuarterlyRecapsResult?: EnableQuarterlyRecapsResultResolvers<ContextType>
  EstimatedCheckPaymentDates?: EstimatedCheckPaymentDatesResolvers<ContextType>
  EstimatedTransferDatesPayload?: EstimatedTransferDatesPayloadResolvers<ContextType>
  ETF?: EtfResolvers<ContextType>
  ETFGain?: EtfGainResolvers<ContextType>
  ETFPerformance?: EtfPerformanceResolvers<ContextType>
  ETFPrice?: EtfPriceResolvers<ContextType>
  EvaluateCheckDepositPayload?: EvaluateCheckDepositPayloadResolvers<ContextType>
  ExistingEmailVerifiedException?: ExistingEmailVerifiedExceptionResolvers<ContextType>
  ExistingPhoneVerifiedException?: ExistingPhoneVerifiedExceptionResolvers<ContextType>
  ExistingRequestPendingReview?: ExistingRequestPendingReviewResolvers<ContextType>
  ExistingRequestPendingUserAction?: ExistingRequestPendingUserActionResolvers<ContextType>
  ExpandedLifeRecommendation?: ExpandedLifeRecommendationResolvers<ContextType>
  ExperienceContent?: ExperienceContentResolvers<ContextType>
  ExploreCarousel?: ExploreCarouselResolvers<ContextType>
  ExtensionCampaign?: ExtensionCampaignResolvers<ContextType>
  ExtensionCampaignBackgroundImage?: ExtensionCampaignBackgroundImageResolvers<ContextType>
  ExtensionCampaignCtaDetails?: ExtensionCampaignCtaDetailsResolvers<ContextType>
  ExtensionCampaignStore?: ExtensionCampaignStoreResolvers<ContextType>
  ExtensionOwner?: ExtensionOwnerResolvers<ContextType>
  ExtensionRewardsSummary?: ExtensionRewardsSummaryResolvers<ContextType>
  ExtensionTransaction?: ExtensionTransactionResolvers<ContextType>
  FavoritePartnerOfferGroup?: FavoritePartnerOfferGroupResolvers<ContextType>
  FeaturedLearnContentPreview?: FeaturedLearnContentPreviewResolvers<ContextType>
  FeaturedMilestones?: FeaturedMilestonesResolvers<ContextType>
  FeaturedMilestonesV2?: FeaturedMilestonesV2Resolvers<ContextType>
  FeaturedOffer?: FeaturedOfferResolvers<ContextType>
  FeaturedOffers?: FeaturedOffersResolvers<ContextType>
  Fee?: FeeResolvers<ContextType>
  FeeExecution?: FeeExecutionResolvers<ContextType>
  FeeNegotiation?: FeeNegotiationResolvers<ContextType>
  FeeNegotiationOutput?: FeeNegotiationOutputResolvers<ContextType>
  FeeStatusSummary?: FeeStatusSummaryResolvers<ContextType>
  File?: FileResolvers<ContextType>
  FileDoesNotExistError?: FileDoesNotExistErrorResolvers<ContextType>
  FileDoesNotExistInS3?: FileDoesNotExistInS3Resolvers<ContextType>
  FileOrException?: FileOrExceptionResolvers<ContextType>
  FileSizeError?: FileSizeErrorResolvers<ContextType>
  FileTooLarge?: FileTooLargeResolvers<ContextType>
  FinancialInstitution?: FinancialInstitutionResolvers<ContextType>
  FinancialInstitutionTypeEdge?: FinancialInstitutionTypeEdgeResolvers<ContextType>
  FinancialInstitutionTypePagination?: FinancialInstitutionTypePaginationResolvers<ContextType>
  FinishSetup?: FinishSetupResolvers<ContextType>
  Footer?: FooterResolvers<ContextType>
  FormattedMonetaryAmount?: FormattedMonetaryAmountResolvers<ContextType>
  FoundMoneyCampaign?: FoundMoneyCampaignResolvers<ContextType>
  FoundMoneyCampaignOfferV2?: FoundMoneyCampaignOfferV2Resolvers<ContextType>
  FoundMoneyCampaignV2?: FoundMoneyCampaignV2Resolvers<ContextType>
  FoundMoneyOffer?: FoundMoneyOfferResolvers<ContextType>
  FoundMoneyOfferCategory?: FoundMoneyOfferCategoryResolvers<ContextType>
  FoundMoneyReward?: FoundMoneyRewardResolvers<ContextType>
  FoundMoneySummary?: FoundMoneySummaryResolvers<ContextType>
  Friend?: FriendResolvers<ContextType>
  FriendExperienceContent?: FriendExperienceContentResolvers<ContextType>
  FriendSummary?: FriendSummaryResolvers<ContextType>
  Fund?: FundResolvers<ContextType>
  FundingSource?: FundingSourceResolvers<ContextType>
  FundingSourceAccount?: FundingSourceAccountResolvers<ContextType>
  FundingSourceAlreadyExists?: FundingSourceAlreadyExistsResolvers<ContextType>
  FundingSourceCredentialsExceedLinkLimit?: FundingSourceCredentialsExceedLinkLimitResolvers<
    ContextType
  >
  FundingSourceInfo?: FundingSourceInfoResolvers<ContextType>
  FundingSourceRequiresRdvException?: FundingSourceRequiresRdvExceptionResolvers<ContextType>
  FunnelMetadata?: FunnelMetadataResolvers<ContextType>
  GenerateUpdatedPdfPayload?: GenerateUpdatedPdfPayloadResolvers<ContextType>
  GrowProspect?: GrowProspectResolvers<ContextType>
  Header?: HeaderResolvers<ContextType>
  HelpFormContent?: HelpFormContentResolvers<ContextType>
  Holding?: HoldingResolvers<ContextType>
  HomeIcon?: HomeIconResolvers<ContextType>
  HomeIcons?: HomeIconsResolvers<ContextType>
  IdentityDocumentRequestedUserAlert?: IdentityDocumentRequestedUserAlertResolvers<ContextType>
  Image?: ImageResolvers<ContextType>
  Incentive?: IncentiveResolvers<ContextType>
  IncorrectOldPasswordException?: IncorrectOldPasswordExceptionResolvers<ContextType>
  IncorrectSecurityAnswerException?: IncorrectSecurityAnswerExceptionResolvers<ContextType>
  IncorrectSsnException?: IncorrectSsnExceptionResolvers<ContextType>
  IneligibilityLander?: IneligibilityLanderResolvers<ContextType>
  InitiateEmailChallengeResult?: InitiateEmailChallengeResultResolvers<ContextType>
  InitiateSMSChallengeResult?: InitiateSmsChallengeResultResolvers<ContextType>
  InitiateTransferPayload?: InitiateTransferPayloadResolvers<ContextType>
  InstitutionNotSupportedError?: InstitutionNotSupportedErrorResolvers<ContextType>
  InsufficientFundsUserAlert?: InsufficientFundsUserAlertResolvers<ContextType>
  InsuranceCarousel?: InsuranceCarouselResolvers<ContextType>
  InsuranceHome?: InsuranceHomeResolvers<ContextType>
  InsuranceHomeWidget?: InsuranceHomeWidgetResolvers<ContextType>
  InsuranceSection?: InsuranceSectionResolvers<ContextType>
  InternalErrorException?: InternalErrorExceptionResolvers<ContextType>
  InternalShareTransferFailed?: InternalShareTransferFailedResolvers<ContextType>
  InvalidAccountNumber?: InvalidAccountNumberResolvers<ContextType>
  InvalidAccountToken?: InvalidAccountTokenResolvers<ContextType>
  InvalidAccountTypeException?: InvalidAccountTypeExceptionResolvers<ContextType>
  InvalidActionOnAccount?: InvalidActionOnAccountResolvers<ContextType>
  InvalidAddressError?: InvalidAddressErrorResolvers<ContextType>
  InvalidAddressException?: InvalidAddressExceptionResolvers<ContextType>
  InvalidAllocationPercentError?: InvalidAllocationPercentErrorResolvers<ContextType>
  InvalidConversionIdentifierException?: InvalidConversionIdentifierExceptionResolvers<ContextType>
  InvalidCredentialsException?: InvalidCredentialsExceptionResolvers<ContextType>
  InvalidDateOfBirthException?: InvalidDateOfBirthExceptionResolvers<ContextType>
  InvalidEmailException?: InvalidEmailExceptionResolvers<ContextType>
  InvalidFile?: InvalidFileResolvers<ContextType>
  InvalidFirstNameException?: InvalidFirstNameExceptionResolvers<ContextType>
  InvalidInvestmentAccountException?: InvalidInvestmentAccountExceptionResolvers<ContextType>
  InvalidLastNameException?: InvalidLastNameExceptionResolvers<ContextType>
  InvalidLaterInput?: InvalidLaterInputResolvers<ContextType>
  InvalidManualLink?: InvalidManualLinkResolvers<ContextType>
  InvalidOptionException?: InvalidOptionExceptionResolvers<ContextType>
  InvalidPasswordException?: InvalidPasswordExceptionResolvers<ContextType>
  InvalidPasswordResetException?: InvalidPasswordResetExceptionResolvers<ContextType>
  InvalidPasswordResetTokenException?: InvalidPasswordResetTokenExceptionResolvers<ContextType>
  InvalidPhoneException?: InvalidPhoneExceptionResolvers<ContextType>
  InvalidPhoneNumberException?: InvalidPhoneNumberExceptionResolvers<ContextType>
  InvalidPinException?: InvalidPinExceptionResolvers<ContextType>
  InvalidPortfolioIdException?: InvalidPortfolioIdExceptionResolvers<ContextType>
  InvalidRoutingNumber?: InvalidRoutingNumberResolvers<ContextType>
  InvalidSecurityError?: InvalidSecurityErrorResolvers<ContextType>
  InvalidSecurityForAllocationError?: InvalidSecurityForAllocationErrorResolvers<ContextType>
  InvalidSecurityForSymbolChangeError?: InvalidSecurityForSymbolChangeErrorResolvers<ContextType>
  InvalidSecurityQuestionException?: InvalidSecurityQuestionExceptionResolvers<ContextType>
  InvalidSourceAttributesException?: InvalidSourceAttributesExceptionResolvers<ContextType>
  InvalidSSNError?: InvalidSsnErrorResolvers<ContextType>
  InvalidSsnException?: InvalidSsnExceptionResolvers<ContextType>
  InvalidStateException?: InvalidStateExceptionResolvers<ContextType>
  InvalidSubscriptionTierException?: InvalidSubscriptionTierExceptionResolvers<ContextType>
  InvalidSymbolForSymbolChangeError?: InvalidSymbolForSymbolChangeErrorResolvers<ContextType>
  InvalidTerminationAgeException?: InvalidTerminationAgeExceptionResolvers<ContextType>
  InvalidTier?: InvalidTierResolvers<ContextType>
  InvalidTierForMigrationError?: InvalidTierForMigrationErrorResolvers<ContextType>
  InvalidTierPrice?: InvalidTierPriceResolvers<ContextType>
  InvalidTierPriceCombination?: InvalidTierPriceCombinationResolvers<ContextType>
  InvalidTierPriceId?: InvalidTierPriceIdResolvers<ContextType>
  Investment?: InvestmentResolvers<ContextType>
  InvestmentAccount?: InvestmentAccountResolvers<ContextType>
  InvestmentAccountAlreadyClosed?: InvestmentAccountAlreadyClosedResolvers<ContextType>
  InvestmentAccountClosureInProgress?: InvestmentAccountClosureInProgressResolvers<ContextType>
  InvestmentAccountCreationException?: InvestmentAccountCreationExceptionResolvers<ContextType>
  InvestmentAccountNeedsTransferException?: InvestmentAccountNeedsTransferExceptionResolvers<
    ContextType
  >
  InvestmentAccountNotClosedException?: InvestmentAccountNotClosedExceptionResolvers<ContextType>
  InvestmentAccountNotFoundException?: InvestmentAccountNotFoundExceptionResolvers<ContextType>
  InvestmentAccountNotSupportedException?: InvestmentAccountNotSupportedExceptionResolvers<
    ContextType
  >
  InvestmentAccountOutsideContribution?: InvestmentAccountOutsideContributionResolvers<ContextType>
  InvestmentAccountRecap?: InvestmentAccountRecapResolvers<ContextType>
  InvestmentAccountRecapNotFoundException?: InvestmentAccountRecapNotFoundExceptionResolvers<
    ContextType
  >
  InvestmentAccountReopenRequest?: InvestmentAccountReopenRequestResolvers<ContextType>
  InvestmentAccountReopenRequestAction?: InvestmentAccountReopenRequestActionResolvers<ContextType>
  InvestmentAccountReopenRequestNote?: InvestmentAccountReopenRequestNoteResolvers<ContextType>
  InvestmentAccountSummary?: InvestmentAccountSummaryResolvers<ContextType>
  InvestmentAccountTransferability?: InvestmentAccountTransferabilityResolvers<ContextType>
  InvestmentAllocation?: InvestmentAllocationResolvers<ContextType>
  InvestmentCategory?: InvestmentCategoryResolvers<ContextType>
  InvestmentNotFoundException?: InvestmentNotFoundExceptionResolvers<ContextType>
  InvestmentsPausedUserAlert?: InvestmentsPausedUserAlertResolvers<ContextType>
  InvestmentUncancellableException?: InvestmentUncancellableExceptionResolvers<ContextType>
  JobAlert?: JobAlertResolvers<ContextType>
  JobLocation?: JobLocationResolvers<ContextType>
  JobOffer?: JobOfferResolvers<ContextType>
  JobOfferSalary?: JobOfferSalaryResolvers<ContextType>
  jobs_Article?: Jobs_ArticleResolvers<ContextType>
  jobs_Education?: Jobs_EducationResolvers<ContextType>
  jobs_Offer?: Jobs_OfferResolvers<ContextType>
  jobs_OfferConnection?: Jobs_OfferConnectionResolvers<ContextType>
  jobs_OfferEdge?: Jobs_OfferEdgeResolvers<ContextType>
  jobs_OfferSalary?: Jobs_OfferSalaryResolvers<ContextType>
  JobSearchCriteria?: JobSearchCriteriaResolvers<ContextType>
  JobSearchFilter?: JobSearchFilterResolvers<ContextType>
  JobSearchOffer?: JobSearchOfferResolvers<ContextType>
  JobSearchPage?: JobSearchPageResolvers<ContextType>
  JSON?: GraphQLScalarType
  LadderLinkResponse?: LadderLinkResponseResolvers<ContextType>
  LadderQuote?: LadderQuoteResolvers<ContextType>
  LadderQuoteStatus?: LadderQuoteStatusResolvers<ContextType>
  LadderResponse?: LadderResponseResolvers<ContextType>
  LaterAccount?: LaterAccountResolvers<ContextType>
  LaterAccountAlreadyVerified?: LaterAccountAlreadyVerifiedResolvers<ContextType>
  LaterAccountIneligibleForVerification?: LaterAccountIneligibleForVerificationResolvers<
    ContextType
  >
  LaterAccountInfo?: LaterAccountInfoResolvers<ContextType>
  LaterAccountInfoOrError?: LaterAccountInfoOrErrorResolvers<ContextType>
  LaterAccountNotFound?: LaterAccountNotFoundResolvers<ContextType>
  LaterBeneficiary?: LaterBeneficiaryResolvers<ContextType>
  LaterContributionAbilityResult?: LaterContributionAbilityResultResolvers<ContextType>
  LaterContributionLimitMet?: LaterContributionLimitMetResolvers<ContextType>
  LaterDeposit?: LaterDepositResolvers<ContextType>
  LaterDividendsItem?: LaterDividendsItemResolvers<ContextType>
  LaterEntityBeneficiary?: LaterEntityBeneficiaryResolvers<ContextType>
  LaterFeeInvestmentItem?: LaterFeeInvestmentItemResolvers<ContextType>
  LaterFullContributionSuccess?: LaterFullContributionSuccessResolvers<ContextType>
  LaterHistoryItem?: LaterHistoryItemResolvers<ContextType>
  LaterIndividualBeneficiary?: LaterIndividualBeneficiaryResolvers<ContextType>
  LaterIndividualBeneficiaryResponse?: LaterIndividualBeneficiaryResponseResolvers<ContextType>
  LaterInvestmentItem?: LaterInvestmentItemResolvers<ContextType>
  LaterPartialContributionSuccess?: LaterPartialContributionSuccessResolvers<ContextType>
  LaterPortfolioPerformance?: LaterPortfolioPerformanceResolvers<ContextType>
  LaterProgramAccountContributionResult?: LaterProgramAccountContributionResultResolvers<
    ContextType
  >
  LaterRebalanceItem?: LaterRebalanceItemResolvers<ContextType>
  LaterTypedException?: LaterTypedExceptionResolvers<ContextType>
  LaterWaitlistProspect?: LaterWaitlistProspectResolvers<ContextType>
  LaterWithdrawal?: LaterWithdrawalResolvers<ContextType>
  LaterWithdrawalItem?: LaterWithdrawalItemResolvers<ContextType>
  LaterWithholdingValues?: LaterWithholdingValuesResolvers<ContextType>
  LearnAnswer?: LearnAnswerResolvers<ContextType>
  LearnArticle?: LearnArticleResolvers<ContextType>
  LearnArticlePreview?: LearnArticlePreviewResolvers<ContextType>
  LearnArticlePreviewLocked?: LearnArticlePreviewLockedResolvers<ContextType>
  LearnAuthor?: LearnAuthorResolvers<ContextType>
  LearnConnection?: LearnConnectionResolvers<ContextType>
  LearnContentCategory?: LearnContentCategoryResolvers<ContextType>
  LearnContentCommunityStats?: LearnContentCommunityStatsResolvers<ContextType>
  LearnContentDuration?: LearnContentDurationResolvers<ContextType>
  LearnContentElapsedMillisecondsUpdatedResult?: LearnContentElapsedMillisecondsUpdatedResultResolvers<
    ContextType
  >
  LearnContentInteractionState?: LearnContentInteractionStateResolvers<ContextType>
  LearnContentPreview?: LearnContentPreviewResolvers<ContextType>
  LearnContentStats?: LearnContentStatsResolvers<ContextType>
  LearnCoursePreview?: LearnCoursePreviewResolvers<ContextType>
  LearnEdge?: LearnEdgeResolvers<ContextType>
  LearnInsight?: LearnInsightResolvers<ContextType>
  LearnInteractionState?: LearnInteractionStateResolvers<ContextType>
  LearnMedia?: LearnMediaResolvers<ContextType>
  LearnMediaArticle?: LearnMediaArticleResolvers<ContextType>
  LearnMediaPreview?: LearnMediaPreviewResolvers<ContextType>
  LearnMediaPreviewLocked?: LearnMediaPreviewLockedResolvers<ContextType>
  LearnMediaReference?: LearnMediaReferenceResolvers<ContextType>
  LearnMediaTheme?: LearnMediaThemeResolvers<ContextType>
  LearnMetadata?: LearnMetadataResolvers<ContextType>
  LearnNextStepAction?: LearnNextStepActionResolvers<ContextType>
  LearnPageInfo?: LearnPageInfoResolvers<ContextType>
  LearnPoll?: LearnPollResolvers<ContextType>
  LearnPollOption?: LearnPollOptionResolvers<ContextType>
  LearnPollPreview?: LearnPollPreviewResolvers<ContextType>
  LearnPollPreviewLocked?: LearnPollPreviewLockedResolvers<ContextType>
  LearnPollResponse?: LearnPollResponseResolvers<ContextType>
  LearnProgress?: LearnProgressResolvers<ContextType>
  LearnProgressUpdatedResult?: LearnProgressUpdatedResultResolvers<ContextType>
  LearnQuestion?: LearnQuestionResolvers<ContextType>
  LearnQuestionInsight?: LearnQuestionInsightResolvers<ContextType>
  LearnQuizAnswerResult?: LearnQuizAnswerResultResolvers<ContextType>
  LearnSearchTermSavedResult?: LearnSearchTermSavedResultResolvers<ContextType>
  LearnTag?: LearnTagResolvers<ContextType>
  LearnThemeLiteral?: LearnThemeLiteralResolvers<ContextType>
  LearnTier?: LearnTierResolvers<ContextType>
  LearnTopic?: LearnTopicResolvers<ContextType>
  LearnVisualAsset?: LearnVisualAssetResolvers<ContextType>
  LegacyUploadDocument?: LegacyUploadDocumentResolvers<ContextType>
  LegacyUploadDocumentResult?: LegacyUploadDocumentResultResolvers<ContextType>
  Lesson?: LessonResolvers<ContextType>
  LessonPreview?: LessonPreviewResolvers<ContextType>
  LessonPreviewLocked?: LessonPreviewLockedResolvers<ContextType>
  LifeCalculatorQuestion?: LifeCalculatorQuestionResolvers<ContextType>
  LifeCalculatorSurvey?: LifeCalculatorSurveyResolvers<ContextType>
  LifeCoverageBreakdown?: LifeCoverageBreakdownResolvers<ContextType>
  LifeCoverageBreakdownCategory?: LifeCoverageBreakdownCategoryResolvers<ContextType>
  LifeQuoteQuestion?: LifeQuoteQuestionResolvers<ContextType>
  LifeQuoteResponse?: LifeQuoteResponseResolvers<ContextType>
  LifeQuoteResultSliders?: LifeQuoteResultSlidersResolvers<ContextType>
  LifeQuoteStep?: LifeQuoteStepResolvers<ContextType>
  LifeQuoteSurvey?: LifeQuoteSurveyResolvers<ContextType>
  LinkedAccount?: LinkedAccountResolvers<ContextType>
  LinkedAccountAlert?: LinkedAccountAlertResolvers<ContextType>
  LinkedAccountAlertsResponse?: LinkedAccountAlertsResponseResolvers<ContextType>
  LinkedAccountNotFound?: LinkedAccountNotFoundResolvers<ContextType>
  LinkedSubaccount?: LinkedSubaccountResolvers<ContextType>
  LinkManualFundingSourceResult?: LinkManualFundingSourceResultResolvers<ContextType>
  LinkSessionResult?: LinkSessionResultResolvers<ContextType>
  LiquidationUnavailableError?: LiquidationUnavailableErrorResolvers<ContextType>
  LOBThumbNails?: LobThumbNailsResolvers<ContextType>
  LockBankCardPayload?: LockBankCardPayloadResolvers<ContextType>
  LoginAccess?: LoginAccessResolvers<ContextType>
  LoginRateLimitedException?: LoginRateLimitedExceptionResolvers<ContextType>
  LogoutDeviceResult?: LogoutDeviceResultResolvers<ContextType>
  LogoutDeviceSuccess?: LogoutDeviceSuccessResolvers<ContextType>
  LogoutResult?: LogoutResultResolvers<ContextType>
  LogoutSuccess?: LogoutSuccessResolvers<ContextType>
  Long?: GraphQLScalarType
  MailInDocument?: MailInDocumentResolvers<ContextType>
  MakeInvestmentPayload?: MakeInvestmentPayloadResolvers<ContextType>
  MalformedRecurringTransferException?: MalformedRecurringTransferExceptionResolvers<ContextType>
  MarkAllAsReadResult?: MarkAllAsReadResultResolvers<ContextType>
  MarkAllAsReadSuccess?: MarkAllAsReadSuccessResolvers<ContextType>
  Market?: MarketResolvers<ContextType>
  MarketReturn?: MarketReturnResolvers<ContextType>
  MarkLearnContentAsHelpfulResult?: MarkLearnContentAsHelpfulResultResolvers<ContextType>
  MarkLearnContentAsViewedResult?: MarkLearnContentAsViewedResultResolvers<ContextType>
  MaxAccountsCreatedException?: MaxAccountsCreatedExceptionResolvers<ContextType>
  Message?: MessageResolvers<ContextType>
  MessageConnection?: MessageConnectionResolvers<ContextType>
  MessageEdge?: MessageEdgeResolvers<ContextType>
  MessagePageInfo?: MessagePageInfoResolvers<ContextType>
  MessageTextAsset?: MessageTextAssetResolvers<ContextType>
  MessageVisualAsset?: MessageVisualAssetResolvers<ContextType>
  MfaMissingAuthAlert?: MfaMissingAuthAlertResolvers<ContextType>
  MightyOakCardWaiver?: MightyOakCardWaiverResolvers<ContextType>
  MightyOakCardWaiverExpiredException?: MightyOakCardWaiverExpiredExceptionResolvers<ContextType>
  MightyOakCardWaiverNotFoundException?: MightyOakCardWaiverNotFoundExceptionResolvers<ContextType>
  MightyOakWaiverResult?: MightyOakWaiverResultResolvers<ContextType>
  Milestone?: MilestoneResolvers<ContextType>
  MilestoneAccountLevelDefinition?: MilestoneAccountLevelDefinitionResolvers<ContextType>
  MilestoneAchievementActionRule?: MilestoneAchievementActionRuleResolvers<ContextType>
  MilestoneChallenge?: MilestoneChallengeResolvers<ContextType>
  MilestoneChallengeDefinition?: MilestoneChallengeDefinitionResolvers<ContextType>
  MilestoneChallengePointsRule?: MilestoneChallengePointsRuleResolvers<ContextType>
  MilestoneDefinition?: MilestoneDefinitionResolvers<ContextType>
  MilestoneEligibility?: MilestoneEligibilityResolvers<ContextType>
  MilestoneGroup?: MilestoneGroupResolvers<ContextType>
  MilestoneGroupAchievementActionRule?: MilestoneGroupAchievementActionRuleResolvers<ContextType>
  MilestoneGroupDefinition?: MilestoneGroupDefinitionResolvers<ContextType>
  MilestoneHub?: MilestoneHubResolvers<ContextType>
  MilestoneHubAccount?: MilestoneHubAccountResolvers<ContextType>
  MilestoneHubDefinition?: MilestoneHubDefinitionResolvers<ContextType>
  MilestoneProgress?: MilestoneProgressResolvers<ContextType>
  MilestoneRule?: MilestoneRuleResolvers<ContextType>
  MilestoneRuleGroup?: MilestoneRuleGroupResolvers<ContextType>
  MilestoneRuleGroupContent?: MilestoneRuleGroupContentResolvers<ContextType>
  MilestoneThemeGroup?: MilestoneThemeGroupResolvers<ContextType>
  MilestoneThemeGroupContent?: MilestoneThemeGroupContentResolvers<ContextType>
  Milliseconds?: MillisecondsResolvers<ContextType>
  MiscDocumentRequestedUserAlert?: MiscDocumentRequestedUserAlertResolvers<ContextType>
  MissingBeneficiarySsnException?: MissingBeneficiarySsnExceptionResolvers<ContextType>
  MissingFundingSourceException?: MissingFundingSourceExceptionResolvers<ContextType>
  MissingRequiredAgreementsException?: MissingRequiredAgreementsExceptionResolvers<ContextType>
  MissingSsnBeneficiaryAlert?: MissingSsnBeneficiaryAlertResolvers<ContextType>
  MissingSsnBeneficiaryAlertItem?: MissingSsnBeneficiaryAlertItemResolvers<ContextType>
  Modal?: ModalResolvers<ContextType>
  MonetaryAmount?: MonetaryAmountResolvers<ContextType>
  MonetaryIncentive?: MonetaryIncentiveResolvers<ContextType>
  MonthlyTotal?: MonthlyTotalResolvers<ContextType>
  Mutation?: MutationResolvers<ContextType>
  NegativeSecurityPercentError?: NegativeSecurityPercentErrorResolvers<ContextType>
  NegotiationServiceConnectionFailure?: NegotiationServiceConnectionFailureResolvers<ContextType>
  NextBillingDate?: NextBillingDateResolvers<ContextType>
  NextTransferDateResult?: NextTransferDateResultResolvers<ContextType>
  NoBeneficiaryFoundException?: NoBeneficiaryFoundExceptionResolvers<ContextType>
  NoFundingSourceUserAlert?: NoFundingSourceUserAlertResolvers<ContextType>
  NonBasicAccountOpenException?: NonBasicAccountOpenExceptionResolvers<ContextType>
  NoProspectRecord?: NoProspectRecordResolvers<ContextType>
  Notification?: NotificationResolvers<ContextType>
  NotificationMessage?: NotificationMessageResolvers<ContextType>
  Notifications?: NotificationsResolvers<ContextType>
  Occupation?: OccupationResolvers<ContextType>
  Offer?: OfferResolvers<ContextType>
  OfferExpiration?: OfferExpirationResolvers<ContextType>
  Offering?: OfferingResolvers<ContextType>
  OfferLocation?: OfferLocationResolvers<ContextType>
  OfferPrice?: OfferPriceResolvers<ContextType>
  OmnibusShareTransferId?: OmnibusShareTransferIdResolvers<ContextType>
  OnboardingTipItem?: OnboardingTipItemResolvers<ContextType>
  OnboardingTips?: OnboardingTipsResolvers<ContextType>
  OnlineSwitch?: OnlineSwitchResolvers<ContextType>
  OpenAccountsException?: OpenAccountsExceptionResolvers<ContextType>
  OpenCoreInvestmentAccountResult?: OpenCoreInvestmentAccountResultResolvers<ContextType>
  OpenEarlyAccountResult?: OpenEarlyAccountResultResolvers<ContextType>
  OrderBankCardResult?: OrderBankCardResultResolvers<ContextType>
  OutsideContribution?: OutsideContributionResolvers<ContextType>
  OutsideContributionCheckoutCart?: OutsideContributionCheckoutCartResolvers<ContextType>
  OutsideContributionCode?: OutsideContributionCodeResolvers<ContextType>
  OutsideContributionProspect?: OutsideContributionProspectResolvers<ContextType>
  Owner?: OwnerResolvers<ContextType>
  PageInfo?: PageInfoResolvers<ContextType>
  Partner?: PartnerResolvers<ContextType>
  PartnerAuthorizationData?: PartnerAuthorizationDataResolvers<ContextType>
  PartnerChoices?: PartnerChoicesResolvers<ContextType>
  PartnerDetailsResponse?: PartnerDetailsResponseResolvers<ContextType>
  PartnerDocumentUrlResponse?: PartnerDocumentUrlResponseResolvers<ContextType>
  PartnerLinkFundingSourceResult?: PartnerLinkFundingSourceResultResolvers<ContextType>
  PartnerOfferGroup?: PartnerOfferGroupResolvers<ContextType>
  PartnerOfferGroupItem?: PartnerOfferGroupItemResolvers<ContextType>
  PartnerRoutingNumber?: PartnerRoutingNumberResolvers<ContextType>
  PartnerUrlResponse?: PartnerUrlResponseResolvers<ContextType>
  PartnerUserPayload?: PartnerUserPayloadResolvers<ContextType>
  PasswordResetForm?: PasswordResetFormResolvers<ContextType>
  PasswordResetFormFields?: PasswordResetFormFieldsResolvers<ContextType>
  PastAnnotatedItem?: PastAnnotatedItemResolvers<ContextType>
  PastCoreCombinedItem?: PastCoreCombinedItemResolvers<ContextType>
  PastCoreItem?: PastCoreItemResolvers<ContextType>
  PastCoreSummary?: PastCoreSummaryResolvers<ContextType>
  PastCoreTradedItem?: PastCoreTradedItemResolvers<ContextType>
  PastEarlyItem?: PastEarlyItemResolvers<ContextType>
  PastEarlySummary?: PastEarlySummaryResolvers<ContextType>
  PastItem?: PastItemResolvers<ContextType>
  PastItemConnection?: PastItemConnectionResolvers<ContextType>
  PastItemEdge?: PastItemEdgeResolvers<ContextType>
  PastLaterSummary?: PastLaterSummaryResolvers<ContextType>
  PastSpendItem?: PastSpendItemResolvers<ContextType>
  PastSpendSummary?: PastSpendSummaryResolvers<ContextType>
  PastUserTransferItem?: PastUserTransferItemResolvers<ContextType>
  PdfDownloadUrlPayload?: PdfDownloadUrlPayloadResolvers<ContextType>
  PdfFormLinks?: PdfFormLinksResolvers<ContextType>
  Performance?: PerformanceResolvers<ContextType>
  Phone?: PhoneResolvers<ContextType>
  PhoneAuthenticator?: PhoneAuthenticatorResolvers<ContextType>
  PhoneNumber?: GraphQLScalarType
  PhoneNumberOptedOutException?: PhoneNumberOptedOutExceptionResolvers<ContextType>
  POBoxAddressError?: PoBoxAddressErrorResolvers<ContextType>
  Portfolio?: PortfolioResolvers<ContextType>
  PortfolioAllocation?: PortfolioAllocationResolvers<ContextType>
  PortfolioAlreadyRemovedError?: PortfolioAlreadyRemovedErrorResolvers<ContextType>
  PortfolioHolding?: PortfolioHoldingResolvers<ContextType>
  PortfolioNotFoundException?: PortfolioNotFoundExceptionResolvers<ContextType>
  PortfolioNotSupportedException?: PortfolioNotSupportedExceptionResolvers<ContextType>
  PortfolioProjection?: PortfolioProjectionResolvers<ContextType>
  PortfolioRemovalInProgressError?: PortfolioRemovalInProgressErrorResolvers<ContextType>
  PortfolioSecurity?: PortfolioSecurityResolvers<ContextType>
  PortfolioSecurityAllocation?: PortfolioSecurityAllocationResolvers<ContextType>
  PortfolioSecurityLimitReached?: PortfolioSecurityLimitReachedResolvers<ContextType>
  PortfolioUpdateFailedException?: PortfolioUpdateFailedExceptionResolvers<ContextType>
  PositiveFloat?: GraphQLScalarType
  Premium?: PremiumResolvers<ContextType>
  PremiumsResult?: PremiumsResultResolvers<ContextType>
  PresentableProduct?: PresentableProductResolvers<ContextType>
  PreviousFundingSourcePending?: PreviousFundingSourcePendingResolvers<ContextType>
  Product?: ProductResolvers<ContextType>
  Profile?: ProfileResolvers<ContextType>
  PromoOffer?: PromoOfferResolvers<ContextType>
  Promotion?: PromotionResolvers<ContextType>
  PromotionConsumedError?: PromotionConsumedErrorResolvers<ContextType>
  PromotionDuration?: PromotionDurationResolvers<ContextType>
  PromotionExpiredError?: PromotionExpiredErrorResolvers<ContextType>
  PromotionNotFoundError?: PromotionNotFoundErrorResolvers<ContextType>
  Prospect?: ProspectResolvers<ContextType>
  ProtectContext?: ProtectContextResolvers<ContextType>
  ProtectHome?: ProtectHomeResolvers<ContextType>
  ProtectHomeWidget?: ProtectHomeWidgetResolvers<ContextType>
  ProtectLander?: ProtectLanderResolvers<ContextType>
  ProtectLearningCenter?: ProtectLearningCenterResolvers<ContextType>
  Provider?: ProviderResolvers<ContextType>
  ProviderSearch?: ProviderSearchResolvers<ContextType>
  Query?: QueryResolvers<ContextType>
  Question?: QuestionResolvers<ContextType>
  QuestionAnswer?: QuestionAnswerResolvers<ContextType>
  Quiz?: QuizResolvers<ContextType>
  QuizPreview?: QuizPreviewResolvers<ContextType>
  QuizPreviewLocked?: QuizPreviewLockedResolvers<ContextType>
  QuizTheme?: QuizThemeResolvers<ContextType>
  QuoteResult?: QuoteResultResolvers<ContextType>
  QuoteSlider?: QuoteSliderResolvers<ContextType>
  RawLinkSession?: RawLinkSessionResolvers<ContextType>
  RdvRequiredUserAlert?: RdvRequiredUserAlertResolvers<ContextType>
  RdvVerificationRequired?: RdvVerificationRequiredResolvers<ContextType>
  RecaptchaException?: RecaptchaExceptionResolvers<ContextType>
  Recommendations?: RecommendationsResolvers<ContextType>
  RecommendationWidget?: RecommendationWidgetResolvers<ContextType>
  RecommendedLifeCoverage?: RecommendedLifeCoverageResolvers<ContextType>
  RecommendedLifeCoverageWidget?: RecommendedLifeCoverageWidgetResolvers<ContextType>
  RecordAlreadyExistsError?: RecordAlreadyExistsErrorResolvers<ContextType>
  RecordDoesNotExistError?: RecordDoesNotExistErrorResolvers<ContextType>
  RecordInvestmentAccountRecapViewResult?: RecordInvestmentAccountRecapViewResultResolvers<
    ContextType
  >
  RecurrenceRule?: RecurrenceRuleResolvers<ContextType>
  RecurringInvestmentPayload?: RecurringInvestmentPayloadResolvers<ContextType>
  RecurringInvestmentSettings?: RecurringInvestmentSettingsResolvers<ContextType>
  RecurringTransfer?: RecurringTransferResolvers<ContextType>
  RecurringTransferAccount?: RecurringTransferAccountResolvers<ContextType>
  RecurringTransferDate?: RecurringTransferDateResolvers<ContextType>
  RecurringTransferEvent?: RecurringTransferEventResolvers<ContextType>
  RecurringTransferFundingSource?: RecurringTransferFundingSourceResolvers<ContextType>
  RecurringTransferPathException?: RecurringTransferPathExceptionResolvers<ContextType>
  Referral?: ReferralResolvers<ContextType>
  ReferralCampaign?: ReferralCampaignResolvers<ContextType>
  ReferralEvent?: ReferralEventResolvers<ContextType>
  ReferralHistory?: ReferralHistoryResolvers<ContextType>
  ReferralReward?: ReferralRewardResolvers<ContextType>
  ReferralRewardSummary?: ReferralRewardSummaryResolvers<ContextType>
  RefreshAuthTokenRateLimitedException?: RefreshAuthTokenRateLimitedExceptionResolvers<ContextType>
  RefreshAuthTokenResult?: RefreshAuthTokenResultResolvers<ContextType>
  RefreshTokenNotFoundException?: RefreshTokenNotFoundExceptionResolvers<ContextType>
  RegenerateInvestmentAccountRecapPublicTokenResult?: RegenerateInvestmentAccountRecapPublicTokenResultResolvers<
    ContextType
  >
  RegisterCredentialsResult?: RegisterCredentialsResultResolvers<ContextType>
  RegisterEmailAuthenticatorResult?: RegisterEmailAuthenticatorResultResolvers<ContextType>
  RegisterLinkSessionResult?: RegisterLinkSessionResultResolvers<ContextType>
  RegisterPhoneAuthenticatorResult?: RegisterPhoneAuthenticatorResultResolvers<ContextType>
  RegisterProspectResult?: RegisterProspectResultResolvers<ContextType>
  RegistrationFunnel?: RegistrationFunnelResolvers<ContextType>
  RegistrationPage?: RegistrationPageResolvers<ContextType>
  RegistrationPageAction?: RegistrationPageActionResolvers<ContextType>
  ReinitiateSMSChallengeResult?: ReinitiateSmsChallengeResultResolvers<ContextType>
  ReissueBankCardEligibility?: ReissueBankCardEligibilityResolvers<ContextType>
  ReissueBankCardEligible?: ReissueBankCardEligibleResolvers<ContextType>
  ReissueBankCardExistsError?: ReissueBankCardExistsErrorResolvers<ContextType>
  ReissueBankCardIneligible?: ReissueBankCardIneligibleResolvers<ContextType>
  ReissueBankCardResult?: ReissueBankCardResultResolvers<ContextType>
  RelinkLinkedAccountAlert?: RelinkLinkedAccountAlertResolvers<ContextType>
  RemoveActionFromMilestoneAchievementActionRuleResult?: RemoveActionFromMilestoneAchievementActionRuleResultResolvers<
    ContextType
  >
  RemoveActionFromMilestoneGroupAchievementActionRuleResult?: RemoveActionFromMilestoneGroupAchievementActionRuleResultResolvers<
    ContextType
  >
  RemovedJobAlert?: RemovedJobAlertResolvers<ContextType>
  RemoveJobAlertResult?: RemoveJobAlertResultResolvers<ContextType>
  RemoveMilestoneFromMilestoneGroupDefinitionResult?: RemoveMilestoneFromMilestoneGroupDefinitionResultResolvers<
    ContextType
  >
  RemoveMilestonesFromMilestoneHubDefinitionResult?: RemoveMilestonesFromMilestoneHubDefinitionResultResolvers<
    ContextType
  >
  RemoveSecurityFromPortfolioResult?: RemoveSecurityFromPortfolioResultResolvers<ContextType>
  RemoveSelfDirectedPortfolioResult?: RemoveSelfDirectedPortfolioResultResolvers<ContextType>
  ReopenUserAccountResult?: ReopenUserAccountResultResolvers<ContextType>
  ReportBankCardLostStolenPayload?: ReportBankCardLostStolenPayloadResolvers<ContextType>
  RequestEarlyAccountClosureResult?: RequestEarlyAccountClosureResultResolvers<ContextType>
  RequestInvestmentAccountReopenResult?: RequestInvestmentAccountReopenResultResolvers<ContextType>
  RequestSubscriptionMigrationWaiverResult?: RequestSubscriptionMigrationWaiverResultResolvers<
    ContextType
  >
  ResetPasswordByTokenException?: ResetPasswordByTokenExceptionResolvers<ContextType>
  ResetPasswordByTokenResult?: ResetPasswordByTokenResultResolvers<ContextType>
  ResetPasswordByTokenSuccess?: ResetPasswordByTokenSuccessResolvers<ContextType>
  ResetPasswordWithTokenResult?: ResetPasswordWithTokenResultResolvers<ContextType>
  ResetPasswordWithTokenSuccess?: ResetPasswordWithTokenSuccessResolvers<ContextType>
  ResourceNotFoundError?: ResourceNotFoundErrorResolvers<ContextType>
  RespondToLearnPollResult?: RespondToLearnPollResultResolvers<ContextType>
  RestoreLoginAccessResult?: RestoreLoginAccessResultResolvers<ContextType>
  Result?: ResultResolvers<ContextType>
  ReturnedCheckDeposit?: ReturnedCheckDepositResolvers<ContextType>
  RevokeLoginAccessResult?: RevokeLoginAccessResultResolvers<ContextType>
  RevokePasswordResetTokenResult?: RevokePasswordResetTokenResultResolvers<ContextType>
  RevokePasswordResetTokenSuccess?: RevokePasswordResetTokenSuccessResolvers<ContextType>
  RewardSummary?: RewardSummaryResolvers<ContextType>
  RolloverAccounts?: RolloverAccountsResolvers<ContextType>
  RolloverAccountType?: RolloverAccountTypeResolvers<ContextType>
  RoundUp?: RoundUpResolvers<ContextType>
  RoundUpAccount?: RoundUpAccountResolvers<ContextType>
  RoundUpProfile?: RoundUpProfileResolvers<ContextType>
  RoundUpTypeEdge?: RoundUpTypeEdgeResolvers<ContextType>
  RoundUpTypePagination?: RoundUpTypePaginationResolvers<ContextType>
  RoutingNumber?: GraphQLScalarType
  SamePasswordsException?: SamePasswordsExceptionResolvers<ContextType>
  SampleMailInDocument?: SampleMailInDocumentResolvers<ContextType>
  SavingsAccountEligibility?: SavingsAccountEligibilityResolvers<ContextType>
  ScheduleRecurringTransferResult?: ScheduleRecurringTransferResultResolvers<ContextType>
  ScheduleResult?: ScheduleResultResolvers<ContextType>
  SearchEmployersPayload?: SearchEmployersPayloadResolvers<ContextType>
  SearchHistory?: SearchHistoryResolvers<ContextType>
  SearchSecuritiesPageInfo?: SearchSecuritiesPageInfoResolvers<ContextType>
  SearchSecuritiesResponse?: SearchSecuritiesResponseResolvers<ContextType>
  SearchSupportArticleResult?: SearchSupportArticleResultResolvers<ContextType>
  SearchSupportResult?: SearchSupportResultResolvers<ContextType>
  SecretSquirrelException?: SecretSquirrelExceptionResolvers<ContextType>
  SecuritiesBySectorPageInfo?: SecuritiesBySectorPageInfoResolvers<ContextType>
  SecuritiesBySectorResponse?: SecuritiesBySectorResponseResolvers<ContextType>
  SecuritiesBySymbolsResponse?: SecuritiesBySymbolsResponseResolvers<ContextType>
  Security?: SecurityResolvers<ContextType>
  SecurityGain?: SecurityGainResolvers<ContextType>
  SecurityHeadline?: SecurityHeadlineResolvers<ContextType>
  SecurityNotSupportedException?: SecurityNotSupportedExceptionResolvers<ContextType>
  SecurityPerformance?: SecurityPerformanceResolvers<ContextType>
  SecurityPrice?: SecurityPriceResolvers<ContextType>
  SecurityProfile?: SecurityProfileResolvers<ContextType>
  SecurityQuestion?: SecurityQuestionResolvers<ContextType>
  SelfDirectedPortfolio?: SelfDirectedPortfolioResolvers<ContextType>
  SendCheckPaymentResult?: SendCheckPaymentResultResolvers<ContextType>
  ServiceNode?: ServiceNodeResolvers<ContextType>
  Session?: SessionResolvers<ContextType>
  SetAuthenticationPINResult?: SetAuthenticationPinResultResolvers<ContextType>
  SetAuthenticationPINSuccess?: SetAuthenticationPinSuccessResolvers<ContextType>
  SetBeneficiarySsnResult?: SetBeneficiarySsnResultResolvers<ContextType>
  SetDefaultAuthenticatorResult?: SetDefaultAuthenticatorResultResolvers<ContextType>
  SetInvestmentAccountRecapPublicAccessResult?: SetInvestmentAccountRecapPublicAccessResultResolvers<
    ContextType
  >
  SetNegotiationStatusResult?: SetNegotiationStatusResultResolvers<ContextType>
  Settings?: SettingsResolvers<ContextType>
  SetUpTip?: SetUpTipResolvers<ContextType>
  Short?: GraphQLScalarType
  Signature?: SignatureResolvers<ContextType>
  SmartDepositMetadataResult?: SmartDepositMetadataResultResolvers<ContextType>
  SMSAuthChallenge?: SmsAuthChallengeResolvers<ContextType>
  SocialCopies?: SocialCopiesResolvers<ContextType>
  SourceAttributes?: SourceAttributesResolvers<ContextType>
  SpendAccount?: SpendAccountResolvers<ContextType>
  SpendAlert?: SpendAlertResolvers<ContextType>
  SpendAtm?: SpendAtmResolvers<ContextType>
  SpendAtmAddress?: SpendAtmAddressResolvers<ContextType>
  SpendATMReimbursementItem?: SpendAtmReimbursementItemResolvers<ContextType>
  SpendAtmsPayload?: SpendAtmsPayloadResolvers<ContextType>
  SpendAtmsResult?: SpendAtmsResultResolvers<ContextType>
  SpendAtmVendorUnavailableError?: SpendAtmVendorUnavailableErrorResolvers<ContextType>
  SpendATMWithdrawalItem?: SpendAtmWithdrawalItemResolvers<ContextType>
  SpendBillPayItem?: SpendBillPayItemResolvers<ContextType>
  SpendCheckDepositItem?: SpendCheckDepositItemResolvers<ContextType>
  SpendCheckPaymentItem?: SpendCheckPaymentItemResolvers<ContextType>
  SpendDigitalWalletItem?: SpendDigitalWalletItemResolvers<ContextType>
  SpendDirectDepositItem?: SpendDirectDepositItemResolvers<ContextType>
  SpendDisputesResponse?: SpendDisputesResponseResolvers<ContextType>
  SpendECheckItem?: SpendECheckItemResolvers<ContextType>
  SpendItem?: SpendItemResolvers<ContextType>
  SpendPurchaseItem?: SpendPurchaseItemResolvers<ContextType>
  SpendRealTimeRoundUpItem?: SpendRealTimeRoundUpItemResolvers<ContextType>
  SpendTransactionsDisputeCustomersResponse?: SpendTransactionsDisputeCustomersResponseResolvers<
    ContextType
  >
  SpendTransactionsDisputeQuestions?: SpendTransactionsDisputeQuestionsResolvers<ContextType>
  SpendTransactionsDisputeResponse?: SpendTransactionsDisputeResponseResolvers<ContextType>
  SpendTransactionsDisputeResult?: SpendTransactionsDisputeResultResolvers<ContextType>
  SpendTransactionsResponse?: SpendTransactionsResponseResolvers<ContextType>
  SpendTransferInItem?: SpendTransferInItemResolvers<ContextType>
  SpendTransferOutItem?: SpendTransferOutItemResolvers<ContextType>
  SplitDeposit?: SplitDepositResolvers<ContextType>
  SplitDepositAllocation?: SplitDepositAllocationResolvers<ContextType>
  SplitDepositDailyRecurrenceRule?: SplitDepositDailyRecurrenceRuleResolvers<ContextType>
  SplitDepositDirectDepositAllocation?: SplitDepositDirectDepositAllocationResolvers<ContextType>
  SplitDepositDirectDepositIntentSetting?: SplitDepositDirectDepositIntentSettingResolvers<
    ContextType
  >
  SplitDepositDirectDepositSetting?: SplitDepositDirectDepositSettingResolvers<ContextType>
  SplitDepositMonthlyRecurrenceRule?: SplitDepositMonthlyRecurrenceRuleResolvers<ContextType>
  SplitDepositMutation?: SplitDepositMutationResolvers<ContextType>
  SplitDepositRecurrenceAllocation?: SplitDepositRecurrenceAllocationResolvers<ContextType>
  SplitDepositRecurrenceRule?: SplitDepositRecurrenceRuleResolvers<ContextType>
  SplitDepositRecurrenceSetting?: SplitDepositRecurrenceSettingResolvers<ContextType>
  SplitDepositSettings?: SplitDepositSettingsResolvers<ContextType>
  SplitDepositSettingsMutation?: SplitDepositSettingsMutationResolvers<ContextType>
  SplitDepositTargetAccount?: SplitDepositTargetAccountResolvers<ContextType>
  SplitDepositWeeklyRecurrenceRule?: SplitDepositWeeklyRecurrenceRuleResolvers<ContextType>
  SsnAlreadyInUseException?: SsnAlreadyInUseExceptionResolvers<ContextType>
  SSNDocumentRequestedUserAlert?: SsnDocumentRequestedUserAlertResolvers<ContextType>
  SsnMatchesCustodianException?: SsnMatchesCustodianExceptionResolvers<ContextType>
  SsnUpdateForbiddenException?: SsnUpdateForbiddenExceptionResolvers<ContextType>
  SSNUsedError?: SsnUsedErrorResolvers<ContextType>
  StartCheckDepositPayload?: StartCheckDepositPayloadResolvers<ContextType>
  StartOnlineSwitchPayload?: StartOnlineSwitchPayloadResolvers<ContextType>
  StartSubmittableSwitchPayload?: StartSubmittableSwitchPayloadResolvers<ContextType>
  Statement?: StatementResolvers<ContextType>
  StatementLink?: StatementLinkResolvers<ContextType>
  Stock?: StockResolvers<ContextType>
  StringKey?: GraphQLScalarType
  StringKeyAsset?: StringKeyAssetResolvers<ContextType>
  SubcategoryMessage?: SubcategoryMessageResolvers<ContextType>
  Submission?: SubmissionResolvers<ContextType>
  SubmissionError?: SubmissionErrorResolvers<ContextType>
  SubmitBankFeeNegotiationResponse?: SubmitBankFeeNegotiationResponseResolvers<ContextType>
  SubmitBankFeeNegotiationResult?: SubmitBankFeeNegotiationResultResolvers<ContextType>
  SubmittableSwitch?: SubmittableSwitchResolvers<ContextType>
  SubmitUserReportedBankFeeRefundResult?: SubmitUserReportedBankFeeRefundResultResolvers<
    ContextType
  >
  SubscriberIneligibleError?: SubscriberIneligibleErrorResolvers<ContextType>
  SubscribeToTierResult?: SubscribeToTierResultResolvers<ContextType>
  SubscribeUserToTierResult?: SubscribeUserToTierResultResolvers<ContextType>
  Subscription?: SubscriptionResolvers<ContextType>
  SubscriptionMigration?: SubscriptionMigrationResolvers<ContextType>
  SubscriptionMigrationInvalidError?: SubscriptionMigrationInvalidErrorResolvers<ContextType>
  SubscriptionMigrationWaiver?: SubscriptionMigrationWaiverResolvers<ContextType>
  Suitability?: SuitabilityResolvers<ContextType>
  suitability_Portfolio?: Suitability_PortfolioResolvers<ContextType>
  suitability_SuitabilityAnswer?: Suitability_SuitabilityAnswerResolvers<ContextType>
  suitability_SuitabilityQuestion?: Suitability_SuitabilityQuestionResolvers<ContextType>
  suitability_SuitabilityResponse?: Suitability_SuitabilityResponseResolvers<ContextType>
  suitability_UpdateSuitabilityResult?: Suitability_UpdateSuitabilityResultResolvers<ContextType>
  SuitabilityAnswer?: SuitabilityAnswerResolvers<ContextType>
  SuitabilityQuestion?: SuitabilityQuestionResolvers<ContextType>
  SummaryItem?: SummaryItemResolvers<ContextType>
  SupportArticle?: SupportArticleResolvers<ContextType>
  SupportAuthor?: SupportAuthorResolvers<ContextType>
  SupportAuthorPhoto?: SupportAuthorPhotoResolvers<ContextType>
  SupportCategory?: SupportCategoryResolvers<ContextType>
  SupportSection?: SupportSectionResolvers<ContextType>
  SupportTicket?: SupportTicketResolvers<ContextType>
  SupportTicketForm?: SupportTicketFormResolvers<ContextType>
  SupportTicketFormField?: SupportTicketFormFieldResolvers<ContextType>
  SupportTicketResponse?: SupportTicketResponseResolvers<ContextType>
  SupportTicketWithCustomFieldsResponse?: SupportTicketWithCustomFieldsResponseResolvers<
    ContextType
  >
  SupportUser?: SupportUserResolvers<ContextType>
  SwitchInterface?: SwitchInterfaceResolvers<ContextType>
  SwitchPayloadInterface?: SwitchPayloadInterfaceResolvers<ContextType>
  SyncBankFeeTransactionsResult?: SyncBankFeeTransactionsResultResolvers<ContextType>
  SystemCardLockedSpendAlert?: SystemCardLockedSpendAlertResolvers<ContextType>
  TaxWithholdingAmounts?: TaxWithholdingAmountsResolvers<ContextType>
  TfaOptions?: TfaOptionsResolvers<ContextType>
  TickerSymbol?: GraphQLScalarType
  Tier?: TierResolvers<ContextType>
  TierDowngradeAction?: TierDowngradeActionResolvers<ContextType>
  TierDowngradeActionRequired?: TierDowngradeActionRequiredResolvers<ContextType>
  TierGroup?: TierGroupResolvers<ContextType>
  TierOption?: TierOptionResolvers<ContextType>
  TierOptionByTierPriceIdResult?: TierOptionByTierPriceIdResultResolvers<ContextType>
  TierPrice?: TierPriceResolvers<ContextType>
  TierProduct?: TierProductResolvers<ContextType>
  TierSubscription?: TierSubscriptionResolvers<ContextType>
  TierSubscriptionAlreadyDeactivated?: TierSubscriptionAlreadyDeactivatedResolvers<ContextType>
  TierSubscriptionConnection?: TierSubscriptionConnectionResolvers<ContextType>
  TierSubscriptionForUser?: TierSubscriptionForUserResolvers<ContextType>
  TierSubscriptionNotFound?: TierSubscriptionNotFoundResolvers<ContextType>
  TierSubscriptionPageInfo?: TierSubscriptionPageInfoResolvers<ContextType>
  TierSubscriptionTransition?: TierSubscriptionTransitionResolvers<ContextType>
  TierSubscriptionUnsubscribed?: TierSubscriptionUnsubscribedResolvers<ContextType>
  Time?: GraphQLScalarType
  TimestampsInterface?: TimestampsInterfaceResolvers<ContextType>
  Tip?: TipResolvers<ContextType>
  Toggle?: ToggleResolvers<ContextType>
  TokenExpiredException?: TokenExpiredExceptionResolvers<ContextType>
  TopEmployer?: TopEmployerResolvers<ContextType>
  TopEmployerPayload?: TopEmployerPayloadResolvers<ContextType>
  TopHolding?: TopHoldingResolvers<ContextType>
  TotalAmounts?: TotalAmountsResolvers<ContextType>
  TransactionResult?: TransactionResultResolvers<ContextType>
  Transfer?: TransferResolvers<ContextType>
  TransferableAccount?: TransferableAccountResolvers<ContextType>
  TransferableFrom?: TransferableFromResolvers<ContextType>
  TransferableTo?: TransferableToResolvers<ContextType>
  TransferInternalSharesResult?: TransferInternalSharesResultResolvers<ContextType>
  TrendingLearnContentPreview?: TrendingLearnContentPreviewResolvers<ContextType>
  UnableToCancelCheckError?: UnableToCancelCheckErrorResolvers<ContextType>
  UnauthenticatedSaveUploadUrlResult?: UnauthenticatedSaveUploadUrlResultResolvers<ContextType>
  UnauthorizedException?: UnauthorizedExceptionResolvers<ContextType>
  UnblockDeviceResult?: UnblockDeviceResultResolvers<ContextType>
  UnknownProvider?: UnknownProviderResolvers<ContextType>
  UnlockBankCardPayload?: UnlockBankCardPayloadResolvers<ContextType>
  UnmarkLearnContentAsHelpfulResult?: UnmarkLearnContentAsHelpfulResultResolvers<ContextType>
  UnrecoverableLinkedAccountError?: UnrecoverableLinkedAccountErrorResolvers<ContextType>
  UnsubscribeUserFromTierResult?: UnsubscribeUserFromTierResultResolvers<ContextType>
  UnverifiedBeneficiarySsnAlert?: UnverifiedBeneficiarySsnAlertResolvers<ContextType>
  UnverifiedBeneficiarySsnAlertItem?: UnverifiedBeneficiarySsnAlertItemResolvers<ContextType>
  UpdateAccountPointsRuleResult?: UpdateAccountPointsRuleResultResolvers<ContextType>
  UpdateAccountPortfolioResponse?: UpdateAccountPortfolioResponseResolvers<ContextType>
  UpdateAttributionResult?: UpdateAttributionResultResolvers<ContextType>
  UpdateAuthEmailResult?: UpdateAuthEmailResultResolvers<ContextType>
  UpdateAuthPhoneNumberResult?: UpdateAuthPhoneNumberResultResolvers<ContextType>
  UpdateBankAccountGoalPayload?: UpdateBankAccountGoalPayloadResolvers<ContextType>
  UpdateBankAccountGoalResult?: UpdateBankAccountGoalResultResolvers<ContextType>
  UpdateBankCardPinPayload?: UpdateBankCardPinPayloadResolvers<ContextType>
  UpdateBeneficiaryInfoResult?: UpdateBeneficiaryInfoResultResolvers<ContextType>
  UpdateCoverageResponse?: UpdateCoverageResponseResolvers<ContextType>
  UpdateCredentialsResult?: UpdateCredentialsResultResolvers<ContextType>
  UpdateElapsedTimeForLearnQuizResult?: UpdateElapsedTimeForLearnQuizResultResolvers<ContextType>
  UpdateLearnContentHelpfulnessResult?: UpdateLearnContentHelpfulnessResultResolvers<ContextType>
  UpdateLearnProgressResult?: UpdateLearnProgressResultResolvers<ContextType>
  UpdateMessageFailed?: UpdateMessageFailedResolvers<ContextType>
  UpdateMessageIgnored?: UpdateMessageIgnoredResolvers<ContextType>
  UpdateMessageResult?: UpdateMessageResultResolvers<ContextType>
  UpdateMilestoneAccountLevelDefinitionResult?: UpdateMilestoneAccountLevelDefinitionResultResolvers<
    ContextType
  >
  UpdateMilestoneChallengeDefinitionResult?: UpdateMilestoneChallengeDefinitionResultResolvers<
    ContextType
  >
  UpdateMilestoneChallengePointsRuleResult?: UpdateMilestoneChallengePointsRuleResultResolvers<
    ContextType
  >
  UpdateMilestoneDefinitionResult?: UpdateMilestoneDefinitionResultResolvers<ContextType>
  UpdatePortfolioSecuritiesResult?: UpdatePortfolioSecuritiesResultResolvers<ContextType>
  UpdateRecommendedCoverageResponse?: UpdateRecommendedCoverageResponseResolvers<ContextType>
  UpdateReferralRewardError?: UpdateReferralRewardErrorResolvers<ContextType>
  UpdateReferralRewardResponse?: UpdateReferralRewardResponseResolvers<ContextType>
  UpdateSecurityQuestionAndAnswerResult?: UpdateSecurityQuestionAndAnswerResultResolvers<
    ContextType
  >
  UpdateSecurityQuestionAndAnswerSuccess?: UpdateSecurityQuestionAndAnswerSuccessResolvers<
    ContextType
  >
  UpdateUserInfoResult?: UpdateUserInfoResultResolvers<ContextType>
  UpgradeAuthenticationResult?: UpgradeAuthenticationResultResolvers<ContextType>
  Upload?: GraphQLScalarType
  UploadCheckPayload?: UploadCheckPayloadResolvers<ContextType>
  UploadDoesNotExist?: UploadDoesNotExistResolvers<ContextType>
  UploadDoesNotExistError?: UploadDoesNotExistErrorResolvers<ContextType>
  UploadFailedError?: UploadFailedErrorResolvers<ContextType>
  UploadSaveError?: UploadSaveErrorResolvers<ContextType>
  UploadSaveExceptions?: UploadSaveExceptionsResolvers<ContextType>
  UploadUrl?: UploadUrlResolvers<ContextType>
  URL?: GraphQLScalarType
  User?: UserResolvers<ContextType>
  User_v2?: User_V2Resolvers<ContextType>
  UserAlert?: UserAlertResolvers<ContextType>
  UserAlertsItem?: UserAlertsItemResolvers<ContextType>
  UserAlertsResponse?: UserAlertsResponseResolvers<ContextType>
  UserCardLockedSpendAlert?: UserCardLockedSpendAlertResolvers<ContextType>
  UserClosedException?: UserClosedExceptionResolvers<ContextType>
  UserCredentialsNotFoundException?: UserCredentialsNotFoundExceptionResolvers<ContextType>
  UserDailyChange?: UserDailyChangeResolvers<ContextType>
  UserInvestmentAccountReopenCheck?: UserInvestmentAccountReopenCheckResolvers<ContextType>
  UserLockedException?: UserLockedExceptionResolvers<ContextType>
  UserNotFound?: UserNotFoundResolvers<ContextType>
  UserNotFoundException?: UserNotFoundExceptionResolvers<ContextType>
  UserNotVerifiedException?: UserNotVerifiedExceptionResolvers<ContextType>
  UserPartnerStatusResponse?: UserPartnerStatusResponseResolvers<ContextType>
  UserReopenLockedException?: UserReopenLockedExceptionResolvers<ContextType>
  UserReopenSuspendedException?: UserReopenSuspendedExceptionResolvers<ContextType>
  UserRoundUps?: UserRoundUpsResolvers<ContextType>
  UserStatus?: UserStatusResolvers<ContextType>
  UserSuspendedException?: UserSuspendedExceptionResolvers<ContextType>
  UserSuspendedUploadTokenLengthError?: UserSuspendedUploadTokenLengthErrorResolvers<ContextType>
  UserSuspendedUploadTokenValidation?: UserSuspendedUploadTokenValidationResolvers<ContextType>
  UserSwitch?: UserSwitchResolvers<ContextType>
  UserTotals?: UserTotalsResolvers<ContextType>
  UserUpload?: UserUploadResolvers<ContextType>
  userWinbackErrors?: UserWinbackErrorsResolvers<ContextType>
  userWinbackScore?: UserWinbackScoreResolvers<ContextType>
  userWinbackScoreRes?: UserWinbackScoreResResolvers<ContextType>
  USStateName?: GraphQLScalarType
  UUID?: GraphQLScalarType
  ValidatePasswordResetTokenResult?: ValidatePasswordResetTokenResultResolvers<ContextType>
  ValidatePasswordResetTokenSuccess?: ValidatePasswordResetTokenSuccessResolvers<ContextType>
  ValidateUserSuspendedUploadTokenResult?: ValidateUserSuspendedUploadTokenResultResolvers<
    ContextType
  >
  VerifyCheckPaymentRecipientAddressResult?: VerifyCheckPaymentRecipientAddressResultResolvers<
    ContextType
  >
  VerifyDeviceResult?: VerifyDeviceResultResolvers<ContextType>
  VerifyPasswordsResult?: VerifyPasswordsResultResolvers<ContextType>
  VerifyPasswordsSuccess?: VerifyPasswordsSuccessResolvers<ContextType>
  VersionMismatchException?: VersionMismatchExceptionResolvers<ContextType>
  ViewedLearnContentResult?: ViewedLearnContentResultResolvers<ContextType>
  Void?: GraphQLScalarType
  W9DocumentRequestedUserAlert?: W9DocumentRequestedUserAlertResolvers<ContextType>
  Webhooks?: WebhooksResolvers<ContextType>
  WebviewLinkSession?: WebviewLinkSessionResolvers<ContextType>
  Withdrawal?: WithdrawalResolvers<ContextType>
  WithholdingDefaults?: WithholdingDefaultsResolvers<ContextType>
  WithholdingEstimates?: WithholdingEstimatesResolvers<ContextType>
  YearLaterReport?: YearLaterReportResolvers<ContextType>
}

/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
 */
export type IResolvers<ContextType = any> = Resolvers<ContextType>
